export default {
	//Cached at: 0.018
	data: {
		density: 0.002,
		imageWidth: 100,
		imageHeight: 69,
		allPixelData: {
			'0': 221,
			'1': 220,
			'2': 218,
			'3': 255,
			'4': 219,
			'5': 218,
			'6': 216,
			'7': 255,
			'8': 220,
			'9': 219,
			'10': 217,
			'11': 255,
			'12': 221,
			'13': 221,
			'14': 219,
			'15': 255,
			'16': 225,
			'17': 224,
			'18': 222,
			'19': 255,
			'20': 223,
			'21': 222,
			'22': 220,
			'23': 255,
			'24': 224,
			'25': 223,
			'26': 221,
			'27': 255,
			'28': 226,
			'29': 225,
			'30': 223,
			'31': 255,
			'32': 226,
			'33': 225,
			'34': 223,
			'35': 255,
			'36': 227,
			'37': 226,
			'38': 224,
			'39': 255,
			'40': 227,
			'41': 226,
			'42': 224,
			'43': 255,
			'44': 227,
			'45': 227,
			'46': 225,
			'47': 255,
			'48': 225,
			'49': 224,
			'50': 222,
			'51': 255,
			'52': 224,
			'53': 223,
			'54': 221,
			'55': 255,
			'56': 229,
			'57': 228,
			'58': 227,
			'59': 255,
			'60': 233,
			'61': 232,
			'62': 230,
			'63': 255,
			'64': 229,
			'65': 229,
			'66': 227,
			'67': 255,
			'68': 229,
			'69': 229,
			'70': 227,
			'71': 255,
			'72': 230,
			'73': 229,
			'74': 228,
			'75': 255,
			'76': 231,
			'77': 230,
			'78': 228,
			'79': 255,
			'80': 231,
			'81': 231,
			'82': 229,
			'83': 255,
			'84': 232,
			'85': 232,
			'86': 230,
			'87': 255,
			'88': 232,
			'89': 232,
			'90': 230,
			'91': 255,
			'92': 232,
			'93': 232,
			'94': 230,
			'95': 255,
			'96': 231,
			'97': 231,
			'98': 229,
			'99': 255,
			'100': 231,
			'101': 231,
			'102': 228,
			'103': 255,
			'104': 235,
			'105': 234,
			'106': 234,
			'107': 255,
			'108': 235,
			'109': 235,
			'110': 234,
			'111': 255,
			'112': 232,
			'113': 232,
			'114': 230,
			'115': 255,
			'116': 228,
			'117': 227,
			'118': 225,
			'119': 255,
			'120': 230,
			'121': 230,
			'122': 228,
			'123': 255,
			'124': 235,
			'125': 235,
			'126': 233,
			'127': 255,
			'128': 232,
			'129': 233,
			'130': 231,
			'131': 255,
			'132': 234,
			'133': 233,
			'134': 231,
			'135': 255,
			'136': 235,
			'137': 234,
			'138': 232,
			'139': 255,
			'140': 234,
			'141': 233,
			'142': 231,
			'143': 255,
			'144': 231,
			'145': 229,
			'146': 227,
			'147': 255,
			'148': 230,
			'149': 229,
			'150': 227,
			'151': 255,
			'152': 232,
			'153': 233,
			'154': 230,
			'155': 255,
			'156': 234,
			'157': 233,
			'158': 231,
			'159': 255,
			'160': 234,
			'161': 233,
			'162': 231,
			'163': 255,
			'164': 233,
			'165': 233,
			'166': 231,
			'167': 255,
			'168': 235,
			'169': 234,
			'170': 232,
			'171': 255,
			'172': 231,
			'173': 231,
			'174': 229,
			'175': 255,
			'176': 231,
			'177': 230,
			'178': 228,
			'179': 255,
			'180': 227,
			'181': 226,
			'182': 224,
			'183': 255,
			'184': 230,
			'185': 229,
			'186': 227,
			'187': 255,
			'188': 228,
			'189': 227,
			'190': 225,
			'191': 255,
			'192': 226,
			'193': 225,
			'194': 223,
			'195': 255,
			'196': 225,
			'197': 224,
			'198': 222,
			'199': 255,
			'200': 227,
			'201': 226,
			'202': 224,
			'203': 255,
			'204': 228,
			'205': 227,
			'206': 226,
			'207': 255,
			'208': 231,
			'209': 231,
			'210': 229,
			'211': 255,
			'212': 230,
			'213': 230,
			'214': 228,
			'215': 255,
			'216': 232,
			'217': 231,
			'218': 229,
			'219': 255,
			'220': 232,
			'221': 232,
			'222': 230,
			'223': 255,
			'224': 234,
			'225': 233,
			'226': 231,
			'227': 255,
			'228': 233,
			'229': 233,
			'230': 231,
			'231': 255,
			'232': 231,
			'233': 231,
			'234': 229,
			'235': 255,
			'236': 234,
			'237': 233,
			'238': 232,
			'239': 255,
			'240': 233,
			'241': 232,
			'242': 230,
			'243': 255,
			'244': 230,
			'245': 229,
			'246': 227,
			'247': 255,
			'248': 225,
			'249': 224,
			'250': 222,
			'251': 255,
			'252': 230,
			'253': 230,
			'254': 228,
			'255': 255,
			'256': 230,
			'257': 230,
			'258': 228,
			'259': 255,
			'260': 229,
			'261': 228,
			'262': 227,
			'263': 255,
			'264': 228,
			'265': 227,
			'266': 226,
			'267': 255,
			'268': 229,
			'269': 228,
			'270': 227,
			'271': 255,
			'272': 227,
			'273': 227,
			'274': 225,
			'275': 255,
			'276': 227,
			'277': 226,
			'278': 224,
			'279': 255,
			'280': 226,
			'281': 225,
			'282': 223,
			'283': 255,
			'284': 224,
			'285': 223,
			'286': 221,
			'287': 255,
			'288': 219,
			'289': 218,
			'290': 216,
			'291': 255,
			'292': 221,
			'293': 221,
			'294': 218,
			'295': 255,
			'296': 208,
			'297': 205,
			'298': 204,
			'299': 255,
			'300': 209,
			'301': 207,
			'302': 206,
			'303': 255,
			'304': 221,
			'305': 220,
			'306': 218,
			'307': 255,
			'308': 221,
			'309': 220,
			'310': 218,
			'311': 255,
			'312': 213,
			'313': 212,
			'314': 210,
			'315': 255,
			'316': 210,
			'317': 209,
			'318': 208,
			'319': 255,
			'320': 211,
			'321': 208,
			'322': 208,
			'323': 255,
			'324': 208,
			'325': 207,
			'326': 205,
			'327': 255,
			'328': 206,
			'329': 205,
			'330': 203,
			'331': 255,
			'332': 206,
			'333': 203,
			'334': 201,
			'335': 255,
			'336': 203,
			'337': 202,
			'338': 200,
			'339': 255,
			'340': 202,
			'341': 200,
			'342': 198,
			'343': 255,
			'344': 201,
			'345': 196,
			'346': 195,
			'347': 255,
			'348': 196,
			'349': 192,
			'350': 191,
			'351': 255,
			'352': 193,
			'353': 190,
			'354': 189,
			'355': 255,
			'356': 193,
			'357': 190,
			'358': 189,
			'359': 255,
			'360': 186,
			'361': 182,
			'362': 181,
			'363': 255,
			'364': 179,
			'365': 175,
			'366': 174,
			'367': 255,
			'368': 183,
			'369': 179,
			'370': 178,
			'371': 255,
			'372': 180,
			'373': 176,
			'374': 175,
			'375': 255,
			'376': 185,
			'377': 181,
			'378': 180,
			'379': 255,
			'380': 184,
			'381': 180,
			'382': 179,
			'383': 255,
			'384': 179,
			'385': 175,
			'386': 175,
			'387': 255,
			'388': 180,
			'389': 176,
			'390': 173,
			'391': 255,
			'392': 160,
			'393': 155,
			'394': 153,
			'395': 255,
			'396': 171,
			'397': 166,
			'398': 166,
			'399': 255,
			'400': 217,
			'401': 217,
			'402': 215,
			'403': 255,
			'404': 218,
			'405': 217,
			'406': 215,
			'407': 255,
			'408': 220,
			'409': 218,
			'410': 217,
			'411': 255,
			'412': 222,
			'413': 219,
			'414': 217,
			'415': 255,
			'416': 222,
			'417': 221,
			'418': 219,
			'419': 255,
			'420': 223,
			'421': 222,
			'422': 220,
			'423': 255,
			'424': 225,
			'425': 224,
			'426': 222,
			'427': 255,
			'428': 225,
			'429': 224,
			'430': 222,
			'431': 255,
			'432': 225,
			'433': 224,
			'434': 222,
			'435': 255,
			'436': 226,
			'437': 225,
			'438': 224,
			'439': 255,
			'440': 226,
			'441': 226,
			'442': 224,
			'443': 255,
			'444': 226,
			'445': 225,
			'446': 223,
			'447': 255,
			'448': 225,
			'449': 224,
			'450': 222,
			'451': 255,
			'452': 226,
			'453': 225,
			'454': 223,
			'455': 255,
			'456': 229,
			'457': 228,
			'458': 226,
			'459': 255,
			'460': 232,
			'461': 232,
			'462': 230,
			'463': 255,
			'464': 229,
			'465': 229,
			'466': 227,
			'467': 255,
			'468': 227,
			'469': 228,
			'470': 225,
			'471': 255,
			'472': 230,
			'473': 228,
			'474': 228,
			'475': 255,
			'476': 230,
			'477': 229,
			'478': 228,
			'479': 255,
			'480': 230,
			'481': 230,
			'482': 227,
			'483': 255,
			'484': 232,
			'485': 232,
			'486': 230,
			'487': 255,
			'488': 232,
			'489': 231,
			'490': 229,
			'491': 255,
			'492': 232,
			'493': 232,
			'494': 229,
			'495': 255,
			'496': 233,
			'497': 233,
			'498': 230,
			'499': 255,
			'500': 232,
			'501': 232,
			'502': 230,
			'503': 255,
			'504': 232,
			'505': 231,
			'506': 231,
			'507': 255,
			'508': 234,
			'509': 234,
			'510': 233,
			'511': 255,
			'512': 234,
			'513': 235,
			'514': 233,
			'515': 255,
			'516': 230,
			'517': 230,
			'518': 228,
			'519': 255,
			'520': 226,
			'521': 226,
			'522': 223,
			'523': 255,
			'524': 236,
			'525': 236,
			'526': 236,
			'527': 255,
			'528': 234,
			'529': 234,
			'530': 233,
			'531': 255,
			'532': 232,
			'533': 232,
			'534': 229,
			'535': 255,
			'536': 232,
			'537': 231,
			'538': 229,
			'539': 255,
			'540': 233,
			'541': 233,
			'542': 231,
			'543': 255,
			'544': 234,
			'545': 233,
			'546': 232,
			'547': 255,
			'548': 233,
			'549': 233,
			'550': 232,
			'551': 255,
			'552': 232,
			'553': 232,
			'554': 231,
			'555': 255,
			'556': 232,
			'557': 232,
			'558': 230,
			'559': 255,
			'560': 233,
			'561': 233,
			'562': 231,
			'563': 255,
			'564': 233,
			'565': 233,
			'566': 231,
			'567': 255,
			'568': 232,
			'569': 231,
			'570': 229,
			'571': 255,
			'572': 232,
			'573': 232,
			'574': 230,
			'575': 255,
			'576': 231,
			'577': 231,
			'578': 229,
			'579': 255,
			'580': 229,
			'581': 228,
			'582': 226,
			'583': 255,
			'584': 231,
			'585': 230,
			'586': 228,
			'587': 255,
			'588': 221,
			'589': 219,
			'590': 217,
			'591': 255,
			'592': 226,
			'593': 225,
			'594': 223,
			'595': 255,
			'596': 229,
			'597': 229,
			'598': 227,
			'599': 255,
			'600': 221,
			'601': 220,
			'602': 218,
			'603': 255,
			'604': 229,
			'605': 229,
			'606': 226,
			'607': 255,
			'608': 234,
			'609': 234,
			'610': 232,
			'611': 255,
			'612': 232,
			'613': 231,
			'614': 229,
			'615': 255,
			'616': 232,
			'617': 232,
			'618': 230,
			'619': 255,
			'620': 231,
			'621': 231,
			'622': 229,
			'623': 255,
			'624': 233,
			'625': 233,
			'626': 231,
			'627': 255,
			'628': 233,
			'629': 233,
			'630': 231,
			'631': 255,
			'632': 233,
			'633': 232,
			'634': 230,
			'635': 255,
			'636': 233,
			'637': 233,
			'638': 232,
			'639': 255,
			'640': 232,
			'641': 232,
			'642': 230,
			'643': 255,
			'644': 235,
			'645': 234,
			'646': 233,
			'647': 255,
			'648': 233,
			'649': 232,
			'650': 231,
			'651': 255,
			'652': 229,
			'653': 228,
			'654': 226,
			'655': 255,
			'656': 228,
			'657': 228,
			'658': 226,
			'659': 255,
			'660': 228,
			'661': 227,
			'662': 225,
			'663': 255,
			'664': 229,
			'665': 228,
			'666': 226,
			'667': 255,
			'668': 229,
			'669': 228,
			'670': 226,
			'671': 255,
			'672': 225,
			'673': 224,
			'674': 222,
			'675': 255,
			'676': 227,
			'677': 226,
			'678': 224,
			'679': 255,
			'680': 225,
			'681': 224,
			'682': 222,
			'683': 255,
			'684': 223,
			'685': 222,
			'686': 220,
			'687': 255,
			'688': 219,
			'689': 218,
			'690': 216,
			'691': 255,
			'692': 219,
			'693': 218,
			'694': 216,
			'695': 255,
			'696': 210,
			'697': 208,
			'698': 206,
			'699': 255,
			'700': 207,
			'701': 205,
			'702': 203,
			'703': 255,
			'704': 214,
			'705': 213,
			'706': 211,
			'707': 255,
			'708': 218,
			'709': 217,
			'710': 215,
			'711': 255,
			'712': 213,
			'713': 213,
			'714': 211,
			'715': 255,
			'716': 207,
			'717': 207,
			'718': 205,
			'719': 255,
			'720': 208,
			'721': 206,
			'722': 205,
			'723': 255,
			'724': 207,
			'725': 203,
			'726': 202,
			'727': 255,
			'728': 203,
			'729': 203,
			'730': 201,
			'731': 255,
			'732': 203,
			'733': 201,
			'734': 199,
			'735': 255,
			'736': 201,
			'737': 199,
			'738': 197,
			'739': 255,
			'740': 200,
			'741': 198,
			'742': 196,
			'743': 255,
			'744': 199,
			'745': 194,
			'746': 193,
			'747': 255,
			'748': 196,
			'749': 192,
			'750': 191,
			'751': 255,
			'752': 193,
			'753': 189,
			'754': 188,
			'755': 255,
			'756': 193,
			'757': 189,
			'758': 188,
			'759': 255,
			'760': 183,
			'761': 179,
			'762': 178,
			'763': 255,
			'764': 175,
			'765': 170,
			'766': 170,
			'767': 255,
			'768': 181,
			'769': 176,
			'770': 176,
			'771': 255,
			'772': 173,
			'773': 169,
			'774': 168,
			'775': 255,
			'776': 175,
			'777': 171,
			'778': 169,
			'779': 255,
			'780': 181,
			'781': 177,
			'782': 176,
			'783': 255,
			'784': 176,
			'785': 172,
			'786': 172,
			'787': 255,
			'788': 181,
			'789': 177,
			'790': 175,
			'791': 255,
			'792': 155,
			'793': 150,
			'794': 148,
			'795': 255,
			'796': 138,
			'797': 132,
			'798': 132,
			'799': 255,
			'800': 222,
			'801': 221,
			'802': 219,
			'803': 255,
			'804': 221,
			'805': 219,
			'806': 217,
			'807': 255,
			'808': 221,
			'809': 219,
			'810': 217,
			'811': 255,
			'812': 223,
			'813': 220,
			'814': 218,
			'815': 255,
			'816': 222,
			'817': 221,
			'818': 219,
			'819': 255,
			'820': 223,
			'821': 222,
			'822': 220,
			'823': 255,
			'824': 226,
			'825': 225,
			'826': 223,
			'827': 255,
			'828': 226,
			'829': 225,
			'830': 223,
			'831': 255,
			'832': 227,
			'833': 225,
			'834': 223,
			'835': 255,
			'836': 227,
			'837': 226,
			'838': 225,
			'839': 255,
			'840': 227,
			'841': 226,
			'842': 225,
			'843': 255,
			'844': 227,
			'845': 226,
			'846': 224,
			'847': 255,
			'848': 227,
			'849': 226,
			'850': 224,
			'851': 255,
			'852': 229,
			'853': 228,
			'854': 226,
			'855': 255,
			'856': 227,
			'857': 226,
			'858': 224,
			'859': 255,
			'860': 226,
			'861': 225,
			'862': 223,
			'863': 255,
			'864': 232,
			'865': 232,
			'866': 230,
			'867': 255,
			'868': 230,
			'869': 230,
			'870': 228,
			'871': 255,
			'872': 230,
			'873': 230,
			'874': 227,
			'875': 255,
			'876': 230,
			'877': 230,
			'878': 228,
			'879': 255,
			'880': 230,
			'881': 231,
			'882': 229,
			'883': 255,
			'884': 233,
			'885': 233,
			'886': 231,
			'887': 255,
			'888': 233,
			'889': 233,
			'890': 230,
			'891': 255,
			'892': 233,
			'893': 234,
			'894': 232,
			'895': 255,
			'896': 234,
			'897': 234,
			'898': 234,
			'899': 255,
			'900': 234,
			'901': 234,
			'902': 235,
			'903': 255,
			'904': 234,
			'905': 235,
			'906': 234,
			'907': 255,
			'908': 234,
			'909': 234,
			'910': 234,
			'911': 255,
			'912': 234,
			'913': 234,
			'914': 233,
			'915': 255,
			'916': 229,
			'917': 228,
			'918': 227,
			'919': 255,
			'920': 228,
			'921': 227,
			'922': 225,
			'923': 255,
			'924': 239,
			'925': 239,
			'926': 238,
			'927': 255,
			'928': 236,
			'929': 236,
			'930': 236,
			'931': 255,
			'932': 234,
			'933': 234,
			'934': 233,
			'935': 255,
			'936': 234,
			'937': 234,
			'938': 234,
			'939': 255,
			'940': 233,
			'941': 233,
			'942': 231,
			'943': 255,
			'944': 233,
			'945': 233,
			'946': 232,
			'947': 255,
			'948': 233,
			'949': 233,
			'950': 234,
			'951': 255,
			'952': 232,
			'953': 232,
			'954': 231,
			'955': 255,
			'956': 233,
			'957': 233,
			'958': 231,
			'959': 255,
			'960': 232,
			'961': 232,
			'962': 230,
			'963': 255,
			'964': 234,
			'965': 233,
			'966': 232,
			'967': 255,
			'968': 233,
			'969': 232,
			'970': 232,
			'971': 255,
			'972': 233,
			'973': 233,
			'974': 231,
			'975': 255,
			'976': 233,
			'977': 233,
			'978': 231,
			'979': 255,
			'980': 231,
			'981': 230,
			'982': 228,
			'983': 255,
			'984': 230,
			'985': 229,
			'986': 227,
			'987': 255,
			'988': 220,
			'989': 219,
			'990': 217,
			'991': 255,
			'992': 227,
			'993': 226,
			'994': 224,
			'995': 255,
			'996': 227,
			'997': 226,
			'998': 224,
			'999': 255,
			'1000': 228,
			'1001': 227,
			'1002': 225,
			'1003': 255,
			'1004': 234,
			'1005': 234,
			'1006': 233,
			'1007': 255,
			'1008': 234,
			'1009': 234,
			'1010': 234,
			'1011': 255,
			'1012': 233,
			'1013': 233,
			'1014': 232,
			'1015': 255,
			'1016': 233,
			'1017': 233,
			'1018': 231,
			'1019': 255,
			'1020': 232,
			'1021': 232,
			'1022': 230,
			'1023': 255,
			'1024': 233,
			'1025': 232,
			'1026': 231,
			'1027': 255,
			'1028': 233,
			'1029': 233,
			'1030': 232,
			'1031': 255,
			'1032': 234,
			'1033': 234,
			'1034': 235,
			'1035': 255,
			'1036': 235,
			'1037': 235,
			'1038': 235,
			'1039': 255,
			'1040': 231,
			'1041': 231,
			'1042': 228,
			'1043': 255,
			'1044': 236,
			'1045': 236,
			'1046': 235,
			'1047': 255,
			'1048': 237,
			'1049': 237,
			'1050': 237,
			'1051': 255,
			'1052': 232,
			'1053': 231,
			'1054': 230,
			'1055': 255,
			'1056': 230,
			'1057': 230,
			'1058': 228,
			'1059': 255,
			'1060': 229,
			'1061': 229,
			'1062': 227,
			'1063': 255,
			'1064': 232,
			'1065': 231,
			'1066': 229,
			'1067': 255,
			'1068': 230,
			'1069': 229,
			'1070': 227,
			'1071': 255,
			'1072': 228,
			'1073': 227,
			'1074': 225,
			'1075': 255,
			'1076': 227,
			'1077': 227,
			'1078': 225,
			'1079': 255,
			'1080': 226,
			'1081': 225,
			'1082': 223,
			'1083': 255,
			'1084': 224,
			'1085': 223,
			'1086': 221,
			'1087': 255,
			'1088': 220,
			'1089': 219,
			'1090': 217,
			'1091': 255,
			'1092': 218,
			'1093': 217,
			'1094': 215,
			'1095': 255,
			'1096': 214,
			'1097': 212,
			'1098': 210,
			'1099': 255,
			'1100': 210,
			'1101': 207,
			'1102': 206,
			'1103': 255,
			'1104': 216,
			'1105': 216,
			'1106': 214,
			'1107': 255,
			'1108': 218,
			'1109': 217,
			'1110': 215,
			'1111': 255,
			'1112': 213,
			'1113': 211,
			'1114': 209,
			'1115': 255,
			'1116': 212,
			'1117': 209,
			'1118': 208,
			'1119': 255,
			'1120': 209,
			'1121': 207,
			'1122': 206,
			'1123': 255,
			'1124': 210,
			'1125': 205,
			'1126': 204,
			'1127': 255,
			'1128': 208,
			'1129': 204,
			'1130': 203,
			'1131': 255,
			'1132': 205,
			'1133': 202,
			'1134': 200,
			'1135': 255,
			'1136': 202,
			'1137': 199,
			'1138': 198,
			'1139': 255,
			'1140': 203,
			'1141': 199,
			'1142': 198,
			'1143': 255,
			'1144': 199,
			'1145': 195,
			'1146': 194,
			'1147': 255,
			'1148': 196,
			'1149': 192,
			'1150': 191,
			'1151': 255,
			'1152': 194,
			'1153': 190,
			'1154': 189,
			'1155': 255,
			'1156': 195,
			'1157': 191,
			'1158': 190,
			'1159': 255,
			'1160': 187,
			'1161': 183,
			'1162': 182,
			'1163': 255,
			'1164': 173,
			'1165': 170,
			'1166': 169,
			'1167': 255,
			'1168': 172,
			'1169': 169,
			'1170': 168,
			'1171': 255,
			'1172': 168,
			'1173': 164,
			'1174': 162,
			'1175': 255,
			'1176': 177,
			'1177': 173,
			'1178': 172,
			'1179': 255,
			'1180': 179,
			'1181': 175,
			'1182': 175,
			'1183': 255,
			'1184': 177,
			'1185': 173,
			'1186': 172,
			'1187': 255,
			'1188': 176,
			'1189': 172,
			'1190': 171,
			'1191': 255,
			'1192': 163,
			'1193': 160,
			'1194': 158,
			'1195': 255,
			'1196': 134,
			'1197': 128,
			'1198': 128,
			'1199': 255,
			'1200': 221,
			'1201': 219,
			'1202': 217,
			'1203': 255,
			'1204': 224,
			'1205': 222,
			'1206': 220,
			'1207': 255,
			'1208': 222,
			'1209': 222,
			'1210': 219,
			'1211': 255,
			'1212': 222,
			'1213': 222,
			'1214': 220,
			'1215': 255,
			'1216': 224,
			'1217': 223,
			'1218': 221,
			'1219': 255,
			'1220': 224,
			'1221': 223,
			'1222': 221,
			'1223': 255,
			'1224': 226,
			'1225': 225,
			'1226': 223,
			'1227': 255,
			'1228': 226,
			'1229': 224,
			'1230': 224,
			'1231': 255,
			'1232': 226,
			'1233': 225,
			'1234': 223,
			'1235': 255,
			'1236': 228,
			'1237': 227,
			'1238': 225,
			'1239': 255,
			'1240': 228,
			'1241': 227,
			'1242': 225,
			'1243': 255,
			'1244': 227,
			'1245': 226,
			'1246': 224,
			'1247': 255,
			'1248': 229,
			'1249': 228,
			'1250': 226,
			'1251': 255,
			'1252': 228,
			'1253': 227,
			'1254': 225,
			'1255': 255,
			'1256': 226,
			'1257': 225,
			'1258': 223,
			'1259': 255,
			'1260': 228,
			'1261': 228,
			'1262': 226,
			'1263': 255,
			'1264': 233,
			'1265': 233,
			'1266': 231,
			'1267': 255,
			'1268': 232,
			'1269': 232,
			'1270': 230,
			'1271': 255,
			'1272': 232,
			'1273': 232,
			'1274': 230,
			'1275': 255,
			'1276': 233,
			'1277': 233,
			'1278': 231,
			'1279': 255,
			'1280': 232,
			'1281': 231,
			'1282': 229,
			'1283': 255,
			'1284': 233,
			'1285': 232,
			'1286': 231,
			'1287': 255,
			'1288': 234,
			'1289': 234,
			'1290': 234,
			'1291': 255,
			'1292': 234,
			'1293': 234,
			'1294': 234,
			'1295': 255,
			'1296': 235,
			'1297': 235,
			'1298': 236,
			'1299': 255,
			'1300': 235,
			'1301': 235,
			'1302': 235,
			'1303': 255,
			'1304': 236,
			'1305': 235,
			'1306': 235,
			'1307': 255,
			'1308': 237,
			'1309': 237,
			'1310': 237,
			'1311': 255,
			'1312': 233,
			'1313': 233,
			'1314': 232,
			'1315': 255,
			'1316': 227,
			'1317': 225,
			'1318': 223,
			'1319': 255,
			'1320': 229,
			'1321': 228,
			'1322': 226,
			'1323': 255,
			'1324': 241,
			'1325': 241,
			'1326': 240,
			'1327': 255,
			'1328': 238,
			'1329': 238,
			'1330': 238,
			'1331': 255,
			'1332': 235,
			'1333': 235,
			'1334': 235,
			'1335': 255,
			'1336': 235,
			'1337': 235,
			'1338': 234,
			'1339': 255,
			'1340': 234,
			'1341': 233,
			'1342': 231,
			'1343': 255,
			'1344': 236,
			'1345': 236,
			'1346': 236,
			'1347': 255,
			'1348': 237,
			'1349': 237,
			'1350': 238,
			'1351': 255,
			'1352': 234,
			'1353': 234,
			'1354': 233,
			'1355': 255,
			'1356': 234,
			'1357': 234,
			'1358': 233,
			'1359': 255,
			'1360': 235,
			'1361': 236,
			'1362': 236,
			'1363': 255,
			'1364': 235,
			'1365': 234,
			'1366': 234,
			'1367': 255,
			'1368': 234,
			'1369': 233,
			'1370': 233,
			'1371': 255,
			'1372': 234,
			'1373': 234,
			'1374': 234,
			'1375': 255,
			'1376': 234,
			'1377': 234,
			'1378': 233,
			'1379': 255,
			'1380': 230,
			'1381': 229,
			'1382': 227,
			'1383': 255,
			'1384': 231,
			'1385': 230,
			'1386': 228,
			'1387': 255,
			'1388': 212,
			'1389': 211,
			'1390': 209,
			'1391': 255,
			'1392': 216,
			'1393': 215,
			'1394': 213,
			'1395': 255,
			'1396': 237,
			'1397': 236,
			'1398': 234,
			'1399': 255,
			'1400': 234,
			'1401': 234,
			'1402': 232,
			'1403': 255,
			'1404': 234,
			'1405': 234,
			'1406': 233,
			'1407': 255,
			'1408': 238,
			'1409': 237,
			'1410': 237,
			'1411': 255,
			'1412': 236,
			'1413': 237,
			'1414': 236,
			'1415': 255,
			'1416': 237,
			'1417': 237,
			'1418': 236,
			'1419': 255,
			'1420': 234,
			'1421': 235,
			'1422': 234,
			'1423': 255,
			'1424': 233,
			'1425': 234,
			'1426': 233,
			'1427': 255,
			'1428': 235,
			'1429': 235,
			'1430': 235,
			'1431': 255,
			'1432': 239,
			'1433': 239,
			'1434': 239,
			'1435': 255,
			'1436': 237,
			'1437': 237,
			'1438': 236,
			'1439': 255,
			'1440': 231,
			'1441': 231,
			'1442': 229,
			'1443': 255,
			'1444': 241,
			'1445': 240,
			'1446': 240,
			'1447': 255,
			'1448': 241,
			'1449': 241,
			'1450': 241,
			'1451': 255,
			'1452': 232,
			'1453': 232,
			'1454': 231,
			'1455': 255,
			'1456': 231,
			'1457': 231,
			'1458': 229,
			'1459': 255,
			'1460': 230,
			'1461': 229,
			'1462': 227,
			'1463': 255,
			'1464': 232,
			'1465': 232,
			'1466': 230,
			'1467': 255,
			'1468': 228,
			'1469': 228,
			'1470': 226,
			'1471': 255,
			'1472': 230,
			'1473': 229,
			'1474': 227,
			'1475': 255,
			'1476': 229,
			'1477': 228,
			'1478': 226,
			'1479': 255,
			'1480': 228,
			'1481': 226,
			'1482': 224,
			'1483': 255,
			'1484': 227,
			'1485': 226,
			'1486': 224,
			'1487': 255,
			'1488': 222,
			'1489': 221,
			'1490': 219,
			'1491': 255,
			'1492': 219,
			'1493': 219,
			'1494': 217,
			'1495': 255,
			'1496': 212,
			'1497': 208,
			'1498': 207,
			'1499': 255,
			'1500': 214,
			'1501': 211,
			'1502': 210,
			'1503': 255,
			'1504': 220,
			'1505': 219,
			'1506': 217,
			'1507': 255,
			'1508': 221,
			'1509': 220,
			'1510': 218,
			'1511': 255,
			'1512': 214,
			'1513': 212,
			'1514': 210,
			'1515': 255,
			'1516': 212,
			'1517': 210,
			'1518': 208,
			'1519': 255,
			'1520': 209,
			'1521': 208,
			'1522': 206,
			'1523': 255,
			'1524': 209,
			'1525': 207,
			'1526': 206,
			'1527': 255,
			'1528': 210,
			'1529': 206,
			'1530': 205,
			'1531': 255,
			'1532': 206,
			'1533': 201,
			'1534': 200,
			'1535': 255,
			'1536': 203,
			'1537': 199,
			'1538': 198,
			'1539': 255,
			'1540': 203,
			'1541': 199,
			'1542': 198,
			'1543': 255,
			'1544': 199,
			'1545': 195,
			'1546': 194,
			'1547': 255,
			'1548': 196,
			'1549': 192,
			'1550': 191,
			'1551': 255,
			'1552': 193,
			'1553': 189,
			'1554': 188,
			'1555': 255,
			'1556': 194,
			'1557': 190,
			'1558': 189,
			'1559': 255,
			'1560': 188,
			'1561': 184,
			'1562': 183,
			'1563': 255,
			'1564': 172,
			'1565': 170,
			'1566': 169,
			'1567': 255,
			'1568': 174,
			'1569': 172,
			'1570': 171,
			'1571': 255,
			'1572': 178,
			'1573': 174,
			'1574': 173,
			'1575': 255,
			'1576': 185,
			'1577': 181,
			'1578': 180,
			'1579': 255,
			'1580': 180,
			'1581': 176,
			'1582': 174,
			'1583': 255,
			'1584': 178,
			'1585': 174,
			'1586': 173,
			'1587': 255,
			'1588': 172,
			'1589': 167,
			'1590': 167,
			'1591': 255,
			'1592': 173,
			'1593': 169,
			'1594': 168,
			'1595': 255,
			'1596': 181,
			'1597': 177,
			'1598': 177,
			'1599': 255,
			'1600': 216,
			'1601': 215,
			'1602': 213,
			'1603': 255,
			'1604': 221,
			'1605': 221,
			'1606': 218,
			'1607': 255,
			'1608': 223,
			'1609': 222,
			'1610': 220,
			'1611': 255,
			'1612': 225,
			'1613': 224,
			'1614': 222,
			'1615': 255,
			'1616': 226,
			'1617': 225,
			'1618': 223,
			'1619': 255,
			'1620': 226,
			'1621': 225,
			'1622': 223,
			'1623': 255,
			'1624': 226,
			'1625': 225,
			'1626': 223,
			'1627': 255,
			'1628': 227,
			'1629': 226,
			'1630': 224,
			'1631': 255,
			'1632': 226,
			'1633': 226,
			'1634': 224,
			'1635': 255,
			'1636': 227,
			'1637': 227,
			'1638': 225,
			'1639': 255,
			'1640': 227,
			'1641': 226,
			'1642': 225,
			'1643': 255,
			'1644': 229,
			'1645': 228,
			'1646': 226,
			'1647': 255,
			'1648': 230,
			'1649': 229,
			'1650': 227,
			'1651': 255,
			'1652': 230,
			'1653': 229,
			'1654': 228,
			'1655': 255,
			'1656': 230,
			'1657': 230,
			'1658': 228,
			'1659': 255,
			'1660': 235,
			'1661': 234,
			'1662': 232,
			'1663': 255,
			'1664': 232,
			'1665': 233,
			'1666': 231,
			'1667': 255,
			'1668': 232,
			'1669': 232,
			'1670': 232,
			'1671': 255,
			'1672': 233,
			'1673': 233,
			'1674': 231,
			'1675': 255,
			'1676': 235,
			'1677': 235,
			'1678': 233,
			'1679': 255,
			'1680': 235,
			'1681': 235,
			'1682': 233,
			'1683': 255,
			'1684': 234,
			'1685': 234,
			'1686': 233,
			'1687': 255,
			'1688': 235,
			'1689': 235,
			'1690': 234,
			'1691': 255,
			'1692': 235,
			'1693': 235,
			'1694': 234,
			'1695': 255,
			'1696': 235,
			'1697': 235,
			'1698': 234,
			'1699': 255,
			'1700': 236,
			'1701': 237,
			'1702': 237,
			'1703': 255,
			'1704': 237,
			'1705': 237,
			'1706': 237,
			'1707': 255,
			'1708': 237,
			'1709': 237,
			'1710': 236,
			'1711': 255,
			'1712': 233,
			'1713': 233,
			'1714': 233,
			'1715': 255,
			'1716': 228,
			'1717': 228,
			'1718': 226,
			'1719': 255,
			'1720': 228,
			'1721': 226,
			'1722': 226,
			'1723': 255,
			'1724': 236,
			'1725': 235,
			'1726': 235,
			'1727': 255,
			'1728': 243,
			'1729': 242,
			'1730': 241,
			'1731': 255,
			'1732': 240,
			'1733': 240,
			'1734': 240,
			'1735': 255,
			'1736': 232,
			'1737': 231,
			'1738': 230,
			'1739': 255,
			'1740': 223,
			'1741': 222,
			'1742': 218,
			'1743': 255,
			'1744': 234,
			'1745': 234,
			'1746': 233,
			'1747': 255,
			'1748': 238,
			'1749': 238,
			'1750': 237,
			'1751': 255,
			'1752': 238,
			'1753': 238,
			'1754': 238,
			'1755': 255,
			'1756': 233,
			'1757': 233,
			'1758': 232,
			'1759': 255,
			'1760': 233,
			'1761': 233,
			'1762': 233,
			'1763': 255,
			'1764': 237,
			'1765': 237,
			'1766': 236,
			'1767': 255,
			'1768': 234,
			'1769': 234,
			'1770': 233,
			'1771': 255,
			'1772': 233,
			'1773': 233,
			'1774': 233,
			'1775': 255,
			'1776': 231,
			'1777': 230,
			'1778': 229,
			'1779': 255,
			'1780': 225,
			'1781': 224,
			'1782': 222,
			'1783': 255,
			'1784': 226,
			'1785': 225,
			'1786': 223,
			'1787': 255,
			'1788': 220,
			'1789': 219,
			'1790': 217,
			'1791': 255,
			'1792': 219,
			'1793': 218,
			'1794': 216,
			'1795': 255,
			'1796': 229,
			'1797': 229,
			'1798': 227,
			'1799': 255,
			'1800': 237,
			'1801': 237,
			'1802': 235,
			'1803': 255,
			'1804': 245,
			'1805': 246,
			'1806': 244,
			'1807': 255,
			'1808': 249,
			'1809': 249,
			'1810': 246,
			'1811': 255,
			'1812': 249,
			'1813': 249,
			'1814': 248,
			'1815': 255,
			'1816': 244,
			'1817': 244,
			'1818': 243,
			'1819': 255,
			'1820': 243,
			'1821': 243,
			'1822': 242,
			'1823': 255,
			'1824': 240,
			'1825': 240,
			'1826': 239,
			'1827': 255,
			'1828': 234,
			'1829': 234,
			'1830': 233,
			'1831': 255,
			'1832': 229,
			'1833': 228,
			'1834': 227,
			'1835': 255,
			'1836': 224,
			'1837': 223,
			'1838': 221,
			'1839': 255,
			'1840': 233,
			'1841': 232,
			'1842': 230,
			'1843': 255,
			'1844': 223,
			'1845': 222,
			'1846': 220,
			'1847': 255,
			'1848': 219,
			'1849': 217,
			'1850': 216,
			'1851': 255,
			'1852': 239,
			'1853': 239,
			'1854': 238,
			'1855': 255,
			'1856': 232,
			'1857': 231,
			'1858': 229,
			'1859': 255,
			'1860': 232,
			'1861': 231,
			'1862': 229,
			'1863': 255,
			'1864': 235,
			'1865': 235,
			'1866': 233,
			'1867': 255,
			'1868': 228,
			'1869': 228,
			'1870': 226,
			'1871': 255,
			'1872': 228,
			'1873': 227,
			'1874': 225,
			'1875': 255,
			'1876': 231,
			'1877': 230,
			'1878': 228,
			'1879': 255,
			'1880': 228,
			'1881': 227,
			'1882': 225,
			'1883': 255,
			'1884': 226,
			'1885': 225,
			'1886': 223,
			'1887': 255,
			'1888': 226,
			'1889': 225,
			'1890': 223,
			'1891': 255,
			'1892': 223,
			'1893': 222,
			'1894': 220,
			'1895': 255,
			'1896': 214,
			'1897': 213,
			'1898': 211,
			'1899': 255,
			'1900': 211,
			'1901': 210,
			'1902': 208,
			'1903': 255,
			'1904': 208,
			'1905': 205,
			'1906': 204,
			'1907': 255,
			'1908': 211,
			'1909': 210,
			'1910': 208,
			'1911': 255,
			'1912': 213,
			'1913': 213,
			'1914': 211,
			'1915': 255,
			'1916': 211,
			'1917': 211,
			'1918': 209,
			'1919': 255,
			'1920': 212,
			'1921': 211,
			'1922': 209,
			'1923': 255,
			'1924': 210,
			'1925': 206,
			'1926': 205,
			'1927': 255,
			'1928': 207,
			'1929': 204,
			'1930': 203,
			'1931': 255,
			'1932': 205,
			'1933': 201,
			'1934': 200,
			'1935': 255,
			'1936': 203,
			'1937': 199,
			'1938': 198,
			'1939': 255,
			'1940': 201,
			'1941': 197,
			'1942': 196,
			'1943': 255,
			'1944': 200,
			'1945': 196,
			'1946': 195,
			'1947': 255,
			'1948': 198,
			'1949': 194,
			'1950': 193,
			'1951': 255,
			'1952': 197,
			'1953': 193,
			'1954': 192,
			'1955': 255,
			'1956': 195,
			'1957': 190,
			'1958': 190,
			'1959': 255,
			'1960': 188,
			'1961': 184,
			'1962': 183,
			'1963': 255,
			'1964': 171,
			'1965': 167,
			'1966': 167,
			'1967': 255,
			'1968': 167,
			'1969': 162,
			'1970': 162,
			'1971': 255,
			'1972': 180,
			'1973': 176,
			'1974': 175,
			'1975': 255,
			'1976': 182,
			'1977': 178,
			'1978': 177,
			'1979': 255,
			'1980': 182,
			'1981': 178,
			'1982': 177,
			'1983': 255,
			'1984': 180,
			'1985': 176,
			'1986': 175,
			'1987': 255,
			'1988': 178,
			'1989': 175,
			'1990': 173,
			'1991': 255,
			'1992': 170,
			'1993': 166,
			'1994': 165,
			'1995': 255,
			'1996': 177,
			'1997': 173,
			'1998': 171,
			'1999': 255,
			'2000': 223,
			'2001': 222,
			'2002': 220,
			'2003': 255,
			'2004': 220,
			'2005': 219,
			'2006': 217,
			'2007': 255,
			'2008': 221,
			'2009': 220,
			'2010': 218,
			'2011': 255,
			'2012': 224,
			'2013': 223,
			'2014': 221,
			'2015': 255,
			'2016': 226,
			'2017': 225,
			'2018': 223,
			'2019': 255,
			'2020': 228,
			'2021': 227,
			'2022': 225,
			'2023': 255,
			'2024': 228,
			'2025': 227,
			'2026': 225,
			'2027': 255,
			'2028': 227,
			'2029': 226,
			'2030': 224,
			'2031': 255,
			'2032': 229,
			'2033': 229,
			'2034': 227,
			'2035': 255,
			'2036': 230,
			'2037': 230,
			'2038': 228,
			'2039': 255,
			'2040': 228,
			'2041': 227,
			'2042': 225,
			'2043': 255,
			'2044': 230,
			'2045': 229,
			'2046': 227,
			'2047': 255,
			'2048': 229,
			'2049': 228,
			'2050': 228,
			'2051': 255,
			'2052': 230,
			'2053': 229,
			'2054': 229,
			'2055': 255,
			'2056': 233,
			'2057': 233,
			'2058': 230,
			'2059': 255,
			'2060': 237,
			'2061': 237,
			'2062': 236,
			'2063': 255,
			'2064': 236,
			'2065': 236,
			'2066': 235,
			'2067': 255,
			'2068': 233,
			'2069': 233,
			'2070': 232,
			'2071': 255,
			'2072': 235,
			'2073': 235,
			'2074': 235,
			'2075': 255,
			'2076': 231,
			'2077': 231,
			'2078': 230,
			'2079': 255,
			'2080': 235,
			'2081': 235,
			'2082': 234,
			'2083': 255,
			'2084': 237,
			'2085': 237,
			'2086': 236,
			'2087': 255,
			'2088': 235,
			'2089': 235,
			'2090': 233,
			'2091': 255,
			'2092': 235,
			'2093': 235,
			'2094': 235,
			'2095': 255,
			'2096': 236,
			'2097': 236,
			'2098': 235,
			'2099': 255,
			'2100': 235,
			'2101': 235,
			'2102': 234,
			'2103': 255,
			'2104': 237,
			'2105': 237,
			'2106': 237,
			'2107': 255,
			'2108': 237,
			'2109': 236,
			'2110': 236,
			'2111': 255,
			'2112': 233,
			'2113': 232,
			'2114': 231,
			'2115': 255,
			'2116': 235,
			'2117': 234,
			'2118': 233,
			'2119': 255,
			'2120': 225,
			'2121': 224,
			'2122': 222,
			'2123': 255,
			'2124': 222,
			'2125': 221,
			'2126': 220,
			'2127': 255,
			'2128': 245,
			'2129': 244,
			'2130': 243,
			'2131': 255,
			'2132': 242,
			'2133': 241,
			'2134': 240,
			'2135': 255,
			'2136': 233,
			'2137': 232,
			'2138': 231,
			'2139': 255,
			'2140': 224,
			'2141': 223,
			'2142': 221,
			'2143': 255,
			'2144': 230,
			'2145': 229,
			'2146': 227,
			'2147': 255,
			'2148': 234,
			'2149': 234,
			'2150': 232,
			'2151': 255,
			'2152': 237,
			'2153': 237,
			'2154': 236,
			'2155': 255,
			'2156': 235,
			'2157': 235,
			'2158': 234,
			'2159': 255,
			'2160': 228,
			'2161': 228,
			'2162': 227,
			'2163': 255,
			'2164': 237,
			'2165': 237,
			'2166': 237,
			'2167': 255,
			'2168': 236,
			'2169': 236,
			'2170': 235,
			'2171': 255,
			'2172': 235,
			'2173': 236,
			'2174': 235,
			'2175': 255,
			'2176': 229,
			'2177': 229,
			'2178': 227,
			'2179': 255,
			'2180': 219,
			'2181': 218,
			'2182': 216,
			'2183': 255,
			'2184': 221,
			'2185': 220,
			'2186': 218,
			'2187': 255,
			'2188': 233,
			'2189': 232,
			'2190': 230,
			'2191': 255,
			'2192': 244,
			'2193': 244,
			'2194': 242,
			'2195': 255,
			'2196': 225,
			'2197': 225,
			'2198': 223,
			'2199': 255,
			'2200': 225,
			'2201': 225,
			'2202': 223,
			'2203': 255,
			'2204': 197,
			'2205': 194,
			'2206': 193,
			'2207': 255,
			'2208': 199,
			'2209': 197,
			'2210': 196,
			'2211': 255,
			'2212': 209,
			'2213': 207,
			'2214': 206,
			'2215': 255,
			'2216': 208,
			'2217': 206,
			'2218': 204,
			'2219': 255,
			'2220': 230,
			'2221': 229,
			'2222': 227,
			'2223': 255,
			'2224': 243,
			'2225': 243,
			'2226': 240,
			'2227': 255,
			'2228': 244,
			'2229': 246,
			'2230': 243,
			'2231': 255,
			'2232': 220,
			'2233': 218,
			'2234': 216,
			'2235': 255,
			'2236': 219,
			'2237': 218,
			'2238': 216,
			'2239': 255,
			'2240': 237,
			'2241': 237,
			'2242': 234,
			'2243': 255,
			'2244': 224,
			'2245': 224,
			'2246': 223,
			'2247': 255,
			'2248': 215,
			'2249': 213,
			'2250': 212,
			'2251': 255,
			'2252': 232,
			'2253': 231,
			'2254': 229,
			'2255': 255,
			'2256': 225,
			'2257': 224,
			'2258': 222,
			'2259': 255,
			'2260': 228,
			'2261': 227,
			'2262': 225,
			'2263': 255,
			'2264': 228,
			'2265': 227,
			'2266': 225,
			'2267': 255,
			'2268': 223,
			'2269': 222,
			'2270': 220,
			'2271': 255,
			'2272': 221,
			'2273': 220,
			'2274': 218,
			'2275': 255,
			'2276': 226,
			'2277': 226,
			'2278': 224,
			'2279': 255,
			'2280': 225,
			'2281': 225,
			'2282': 223,
			'2283': 255,
			'2284': 223,
			'2285': 222,
			'2286': 220,
			'2287': 255,
			'2288': 224,
			'2289': 223,
			'2290': 221,
			'2291': 255,
			'2292': 219,
			'2293': 218,
			'2294': 216,
			'2295': 255,
			'2296': 217,
			'2297': 216,
			'2298': 214,
			'2299': 255,
			'2300': 217,
			'2301': 216,
			'2302': 214,
			'2303': 255,
			'2304': 212,
			'2305': 211,
			'2306': 209,
			'2307': 255,
			'2308': 213,
			'2309': 211,
			'2310': 209,
			'2311': 255,
			'2312': 213,
			'2313': 212,
			'2314': 210,
			'2315': 255,
			'2316': 212,
			'2317': 211,
			'2318': 209,
			'2319': 255,
			'2320': 214,
			'2321': 212,
			'2322': 210,
			'2323': 255,
			'2324': 210,
			'2325': 208,
			'2326': 206,
			'2327': 255,
			'2328': 204,
			'2329': 201,
			'2330': 200,
			'2331': 255,
			'2332': 204,
			'2333': 201,
			'2334': 199,
			'2335': 255,
			'2336': 203,
			'2337': 199,
			'2338': 198,
			'2339': 255,
			'2340': 204,
			'2341': 200,
			'2342': 199,
			'2343': 255,
			'2344': 200,
			'2345': 196,
			'2346': 195,
			'2347': 255,
			'2348': 201,
			'2349': 197,
			'2350': 196,
			'2351': 255,
			'2352': 198,
			'2353': 194,
			'2354': 193,
			'2355': 255,
			'2356': 196,
			'2357': 191,
			'2358': 190,
			'2359': 255,
			'2360': 181,
			'2361': 178,
			'2362': 176,
			'2363': 255,
			'2364': 173,
			'2365': 168,
			'2366': 167,
			'2367': 255,
			'2368': 175,
			'2369': 171,
			'2370': 170,
			'2371': 255,
			'2372': 184,
			'2373': 180,
			'2374': 179,
			'2375': 255,
			'2376': 181,
			'2377': 177,
			'2378': 176,
			'2379': 255,
			'2380': 178,
			'2381': 174,
			'2382': 173,
			'2383': 255,
			'2384': 177,
			'2385': 174,
			'2386': 172,
			'2387': 255,
			'2388': 176,
			'2389': 173,
			'2390': 172,
			'2391': 255,
			'2392': 174,
			'2393': 169,
			'2394': 168,
			'2395': 255,
			'2396': 173,
			'2397': 170,
			'2398': 168,
			'2399': 255,
			'2400': 227,
			'2401': 227,
			'2402': 225,
			'2403': 255,
			'2404': 228,
			'2405': 227,
			'2406': 225,
			'2407': 255,
			'2408': 226,
			'2409': 226,
			'2410': 224,
			'2411': 255,
			'2412': 226,
			'2413': 225,
			'2414': 223,
			'2415': 255,
			'2416': 226,
			'2417': 225,
			'2418': 223,
			'2419': 255,
			'2420': 230,
			'2421': 229,
			'2422': 227,
			'2423': 255,
			'2424': 230,
			'2425': 229,
			'2426': 227,
			'2427': 255,
			'2428': 229,
			'2429': 228,
			'2430': 226,
			'2431': 255,
			'2432': 231,
			'2433': 230,
			'2434': 228,
			'2435': 255,
			'2436': 232,
			'2437': 232,
			'2438': 230,
			'2439': 255,
			'2440': 232,
			'2441': 231,
			'2442': 229,
			'2443': 255,
			'2444': 232,
			'2445': 231,
			'2446': 229,
			'2447': 255,
			'2448': 232,
			'2449': 230,
			'2450': 230,
			'2451': 255,
			'2452': 232,
			'2453': 230,
			'2454': 230,
			'2455': 255,
			'2456': 233,
			'2457': 233,
			'2458': 230,
			'2459': 255,
			'2460': 235,
			'2461': 236,
			'2462': 235,
			'2463': 255,
			'2464': 238,
			'2465': 238,
			'2466': 238,
			'2467': 255,
			'2468': 235,
			'2469': 235,
			'2470': 234,
			'2471': 255,
			'2472': 234,
			'2473': 234,
			'2474': 233,
			'2475': 255,
			'2476': 231,
			'2477': 231,
			'2478': 230,
			'2479': 255,
			'2480': 234,
			'2481': 234,
			'2482': 235,
			'2483': 255,
			'2484': 237,
			'2485': 238,
			'2486': 238,
			'2487': 255,
			'2488': 236,
			'2489': 236,
			'2490': 236,
			'2491': 255,
			'2492': 236,
			'2493': 236,
			'2494': 236,
			'2495': 255,
			'2496': 236,
			'2497': 236,
			'2498': 236,
			'2499': 255,
			'2500': 235,
			'2501': 235,
			'2502': 234,
			'2503': 255,
			'2504': 235,
			'2505': 235,
			'2506': 235,
			'2507': 255,
			'2508': 234,
			'2509': 234,
			'2510': 234,
			'2511': 255,
			'2512': 233,
			'2513': 233,
			'2514': 232,
			'2515': 255,
			'2516': 234,
			'2517': 234,
			'2518': 232,
			'2519': 255,
			'2520': 232,
			'2521': 231,
			'2522': 230,
			'2523': 255,
			'2524': 235,
			'2525': 235,
			'2526': 235,
			'2527': 255,
			'2528': 243,
			'2529': 242,
			'2530': 241,
			'2531': 255,
			'2532': 242,
			'2533': 241,
			'2534': 242,
			'2535': 255,
			'2536': 239,
			'2537': 239,
			'2538': 237,
			'2539': 255,
			'2540': 236,
			'2541': 236,
			'2542': 235,
			'2543': 255,
			'2544': 231,
			'2545': 231,
			'2546': 230,
			'2547': 255,
			'2548': 236,
			'2549': 236,
			'2550': 236,
			'2551': 255,
			'2552': 241,
			'2553': 241,
			'2554': 240,
			'2555': 255,
			'2556': 240,
			'2557': 240,
			'2558': 241,
			'2559': 255,
			'2560': 238,
			'2561': 238,
			'2562': 238,
			'2563': 255,
			'2564': 237,
			'2565': 237,
			'2566': 237,
			'2567': 255,
			'2568': 238,
			'2569': 238,
			'2570': 238,
			'2571': 255,
			'2572': 238,
			'2573': 237,
			'2574': 238,
			'2575': 255,
			'2576': 237,
			'2577': 237,
			'2578': 236,
			'2579': 255,
			'2580': 229,
			'2581': 228,
			'2582': 226,
			'2583': 255,
			'2584': 231,
			'2585': 231,
			'2586': 229,
			'2587': 255,
			'2588': 238,
			'2589': 239,
			'2590': 237,
			'2591': 255,
			'2592': 208,
			'2593': 206,
			'2594': 205,
			'2595': 255,
			'2596': 156,
			'2597': 149,
			'2598': 150,
			'2599': 255,
			'2600': 132,
			'2601': 125,
			'2602': 125,
			'2603': 255,
			'2604': 88,
			'2605': 77,
			'2606': 77,
			'2607': 255,
			'2608': 56,
			'2609': 46,
			'2610': 46,
			'2611': 255,
			'2612': 67,
			'2613': 57,
			'2614': 57,
			'2615': 255,
			'2616': 107,
			'2617': 99,
			'2618': 98,
			'2619': 255,
			'2620': 101,
			'2621': 92,
			'2622': 91,
			'2623': 255,
			'2624': 140,
			'2625': 132,
			'2626': 133,
			'2627': 255,
			'2628': 176,
			'2629': 172,
			'2630': 171,
			'2631': 255,
			'2632': 198,
			'2633': 196,
			'2634': 194,
			'2635': 255,
			'2636': 253,
			'2637': 253,
			'2638': 250,
			'2639': 255,
			'2640': 252,
			'2641': 252,
			'2642': 250,
			'2643': 255,
			'2644': 238,
			'2645': 238,
			'2646': 236,
			'2647': 255,
			'2648': 234,
			'2649': 233,
			'2650': 231,
			'2651': 255,
			'2652': 227,
			'2653': 227,
			'2654': 224,
			'2655': 255,
			'2656': 218,
			'2657': 218,
			'2658': 216,
			'2659': 255,
			'2660': 219,
			'2661': 218,
			'2662': 216,
			'2663': 255,
			'2664': 225,
			'2665': 224,
			'2666': 222,
			'2667': 255,
			'2668': 227,
			'2669': 226,
			'2670': 224,
			'2671': 255,
			'2672': 222,
			'2673': 221,
			'2674': 219,
			'2675': 255,
			'2676': 220,
			'2677': 219,
			'2678': 217,
			'2679': 255,
			'2680': 224,
			'2681': 223,
			'2682': 221,
			'2683': 255,
			'2684': 224,
			'2685': 223,
			'2686': 221,
			'2687': 255,
			'2688': 223,
			'2689': 222,
			'2690': 220,
			'2691': 255,
			'2692': 223,
			'2693': 222,
			'2694': 220,
			'2695': 255,
			'2696': 221,
			'2697': 220,
			'2698': 218,
			'2699': 255,
			'2700': 221,
			'2701': 220,
			'2702': 218,
			'2703': 255,
			'2704': 220,
			'2705': 220,
			'2706': 218,
			'2707': 255,
			'2708': 217,
			'2709': 216,
			'2710': 214,
			'2711': 255,
			'2712': 215,
			'2713': 213,
			'2714': 211,
			'2715': 255,
			'2716': 214,
			'2717': 213,
			'2718': 211,
			'2719': 255,
			'2720': 215,
			'2721': 211,
			'2722': 210,
			'2723': 255,
			'2724': 213,
			'2725': 212,
			'2726': 210,
			'2727': 255,
			'2728': 208,
			'2729': 205,
			'2730': 204,
			'2731': 255,
			'2732': 204,
			'2733': 201,
			'2734': 200,
			'2735': 255,
			'2736': 201,
			'2737': 198,
			'2738': 196,
			'2739': 255,
			'2740': 203,
			'2741': 199,
			'2742': 198,
			'2743': 255,
			'2744': 197,
			'2745': 193,
			'2746': 192,
			'2747': 255,
			'2748': 192,
			'2749': 188,
			'2750': 187,
			'2751': 255,
			'2752': 190,
			'2753': 186,
			'2754': 185,
			'2755': 255,
			'2756': 188,
			'2757': 184,
			'2758': 183,
			'2759': 255,
			'2760': 171,
			'2761': 167,
			'2762': 166,
			'2763': 255,
			'2764': 174,
			'2765': 170,
			'2766': 168,
			'2767': 255,
			'2768': 186,
			'2769': 182,
			'2770': 181,
			'2771': 255,
			'2772': 183,
			'2773': 179,
			'2774': 178,
			'2775': 255,
			'2776': 180,
			'2777': 176,
			'2778': 175,
			'2779': 255,
			'2780': 176,
			'2781': 172,
			'2782': 171,
			'2783': 255,
			'2784': 174,
			'2785': 170,
			'2786': 169,
			'2787': 255,
			'2788': 176,
			'2789': 172,
			'2790': 171,
			'2791': 255,
			'2792': 172,
			'2793': 168,
			'2794': 167,
			'2795': 255,
			'2796': 172,
			'2797': 169,
			'2798': 168,
			'2799': 255,
			'2800': 215,
			'2801': 214,
			'2802': 212,
			'2803': 255,
			'2804': 207,
			'2805': 205,
			'2806': 204,
			'2807': 255,
			'2808': 214,
			'2809': 213,
			'2810': 211,
			'2811': 255,
			'2812': 220,
			'2813': 219,
			'2814': 217,
			'2815': 255,
			'2816': 220,
			'2817': 219,
			'2818': 217,
			'2819': 255,
			'2820': 220,
			'2821': 219,
			'2822': 217,
			'2823': 255,
			'2824': 219,
			'2825': 218,
			'2826': 216,
			'2827': 255,
			'2828': 220,
			'2829': 219,
			'2830': 217,
			'2831': 255,
			'2832': 223,
			'2833': 222,
			'2834': 220,
			'2835': 255,
			'2836': 226,
			'2837': 226,
			'2838': 224,
			'2839': 255,
			'2840': 227,
			'2841': 226,
			'2842': 224,
			'2843': 255,
			'2844': 226,
			'2845': 225,
			'2846': 223,
			'2847': 255,
			'2848': 229,
			'2849': 228,
			'2850': 225,
			'2851': 255,
			'2852': 227,
			'2853': 227,
			'2854': 224,
			'2855': 255,
			'2856': 217,
			'2857': 217,
			'2858': 214,
			'2859': 255,
			'2860': 225,
			'2861': 224,
			'2862': 222,
			'2863': 255,
			'2864': 234,
			'2865': 234,
			'2866': 234,
			'2867': 255,
			'2868': 235,
			'2869': 235,
			'2870': 234,
			'2871': 255,
			'2872': 236,
			'2873': 236,
			'2874': 235,
			'2875': 255,
			'2876': 234,
			'2877': 234,
			'2878': 234,
			'2879': 255,
			'2880': 236,
			'2881': 236,
			'2882': 236,
			'2883': 255,
			'2884': 239,
			'2885': 239,
			'2886': 239,
			'2887': 255,
			'2888': 239,
			'2889': 239,
			'2890': 240,
			'2891': 255,
			'2892': 240,
			'2893': 240,
			'2894': 240,
			'2895': 255,
			'2896': 237,
			'2897': 237,
			'2898': 238,
			'2899': 255,
			'2900': 238,
			'2901': 238,
			'2902': 239,
			'2903': 255,
			'2904': 237,
			'2905': 237,
			'2906': 236,
			'2907': 255,
			'2908': 236,
			'2909': 236,
			'2910': 233,
			'2911': 255,
			'2912': 236,
			'2913': 236,
			'2914': 236,
			'2915': 255,
			'2916': 235,
			'2917': 235,
			'2918': 235,
			'2919': 255,
			'2920': 234,
			'2921': 234,
			'2922': 234,
			'2923': 255,
			'2924': 237,
			'2925': 237,
			'2926': 237,
			'2927': 255,
			'2928': 241,
			'2929': 241,
			'2930': 239,
			'2931': 255,
			'2932': 243,
			'2933': 243,
			'2934': 244,
			'2935': 255,
			'2936': 243,
			'2937': 242,
			'2938': 241,
			'2939': 255,
			'2940': 236,
			'2941': 236,
			'2942': 235,
			'2943': 255,
			'2944': 231,
			'2945': 231,
			'2946': 231,
			'2947': 255,
			'2948': 234,
			'2949': 234,
			'2950': 234,
			'2951': 255,
			'2952': 238,
			'2953': 238,
			'2954': 238,
			'2955': 255,
			'2956': 238,
			'2957': 238,
			'2958': 237,
			'2959': 255,
			'2960': 236,
			'2961': 236,
			'2962': 235,
			'2963': 255,
			'2964': 236,
			'2965': 236,
			'2966': 236,
			'2967': 255,
			'2968': 236,
			'2969': 236,
			'2970': 235,
			'2971': 255,
			'2972': 234,
			'2973': 234,
			'2974': 234,
			'2975': 255,
			'2976': 245,
			'2977': 245,
			'2978': 244,
			'2979': 255,
			'2980': 243,
			'2981': 243,
			'2982': 241,
			'2983': 255,
			'2984': 211,
			'2985': 209,
			'2986': 208,
			'2987': 255,
			'2988': 162,
			'2989': 155,
			'2990': 155,
			'2991': 255,
			'2992': 84,
			'2993': 74,
			'2994': 74,
			'2995': 255,
			'2996': 70,
			'2997': 59,
			'2998': 59,
			'2999': 255,
			'3000': 77,
			'3001': 65,
			'3002': 65,
			'3003': 255,
			'3004': 57,
			'3005': 47,
			'3006': 46,
			'3007': 255,
			'3008': 41,
			'3009': 30,
			'3010': 29,
			'3011': 255,
			'3012': 66,
			'3013': 55,
			'3014': 55,
			'3015': 255,
			'3016': 76,
			'3017': 66,
			'3018': 65,
			'3019': 255,
			'3020': 61,
			'3021': 51,
			'3022': 50,
			'3023': 255,
			'3024': 68,
			'3025': 57,
			'3026': 58,
			'3027': 255,
			'3028': 54,
			'3029': 42,
			'3030': 43,
			'3031': 255,
			'3032': 82,
			'3033': 73,
			'3034': 73,
			'3035': 255,
			'3036': 158,
			'3037': 152,
			'3038': 151,
			'3039': 255,
			'3040': 226,
			'3041': 225,
			'3042': 222,
			'3043': 255,
			'3044': 242,
			'3045': 242,
			'3046': 240,
			'3047': 255,
			'3048': 250,
			'3049': 250,
			'3050': 248,
			'3051': 255,
			'3052': 241,
			'3053': 241,
			'3054': 239,
			'3055': 255,
			'3056': 228,
			'3057': 227,
			'3058': 225,
			'3059': 255,
			'3060': 223,
			'3061': 222,
			'3062': 220,
			'3063': 255,
			'3064': 228,
			'3065': 227,
			'3066': 225,
			'3067': 255,
			'3068': 229,
			'3069': 228,
			'3070': 226,
			'3071': 255,
			'3072': 225,
			'3073': 224,
			'3074': 222,
			'3075': 255,
			'3076': 225,
			'3077': 224,
			'3078': 222,
			'3079': 255,
			'3080': 223,
			'3081': 222,
			'3082': 220,
			'3083': 255,
			'3084': 222,
			'3085': 222,
			'3086': 220,
			'3087': 255,
			'3088': 208,
			'3089': 206,
			'3090': 205,
			'3091': 255,
			'3092': 205,
			'3093': 203,
			'3094': 201,
			'3095': 255,
			'3096': 218,
			'3097': 216,
			'3098': 215,
			'3099': 255,
			'3100': 216,
			'3101': 215,
			'3102': 213,
			'3103': 255,
			'3104': 215,
			'3105': 213,
			'3106': 212,
			'3107': 255,
			'3108': 213,
			'3109': 212,
			'3110': 210,
			'3111': 255,
			'3112': 211,
			'3113': 209,
			'3114': 207,
			'3115': 255,
			'3116': 210,
			'3117': 208,
			'3118': 206,
			'3119': 255,
			'3120': 212,
			'3121': 208,
			'3122': 207,
			'3123': 255,
			'3124': 212,
			'3125': 209,
			'3126': 207,
			'3127': 255,
			'3128': 209,
			'3129': 207,
			'3130': 205,
			'3131': 255,
			'3132': 207,
			'3133': 203,
			'3134': 202,
			'3135': 255,
			'3136': 205,
			'3137': 201,
			'3138': 200,
			'3139': 255,
			'3140': 202,
			'3141': 198,
			'3142': 197,
			'3143': 255,
			'3144': 202,
			'3145': 198,
			'3146': 197,
			'3147': 255,
			'3148': 196,
			'3149': 192,
			'3150': 191,
			'3151': 255,
			'3152': 192,
			'3153': 188,
			'3154': 187,
			'3155': 255,
			'3156': 191,
			'3157': 187,
			'3158': 186,
			'3159': 255,
			'3160': 190,
			'3161': 187,
			'3162': 186,
			'3163': 255,
			'3164': 181,
			'3165': 177,
			'3166': 176,
			'3167': 255,
			'3168': 184,
			'3169': 180,
			'3170': 179,
			'3171': 255,
			'3172': 181,
			'3173': 177,
			'3174': 176,
			'3175': 255,
			'3176': 179,
			'3177': 175,
			'3178': 174,
			'3179': 255,
			'3180': 180,
			'3181': 176,
			'3182': 175,
			'3183': 255,
			'3184': 176,
			'3185': 172,
			'3186': 171,
			'3187': 255,
			'3188': 179,
			'3189': 175,
			'3190': 173,
			'3191': 255,
			'3192': 175,
			'3193': 171,
			'3194': 170,
			'3195': 255,
			'3196': 175,
			'3197': 171,
			'3198': 169,
			'3199': 255,
			'3200': 208,
			'3201': 207,
			'3202': 205,
			'3203': 255,
			'3204': 207,
			'3205': 206,
			'3206': 204,
			'3207': 255,
			'3208': 197,
			'3209': 193,
			'3210': 192,
			'3211': 255,
			'3212': 207,
			'3213': 205,
			'3214': 203,
			'3215': 255,
			'3216': 215,
			'3217': 215,
			'3218': 212,
			'3219': 255,
			'3220': 217,
			'3221': 216,
			'3222': 214,
			'3223': 255,
			'3224': 215,
			'3225': 213,
			'3226': 211,
			'3227': 255,
			'3228': 214,
			'3229': 213,
			'3230': 211,
			'3231': 255,
			'3232': 217,
			'3233': 216,
			'3234': 214,
			'3235': 255,
			'3236': 217,
			'3237': 216,
			'3238': 214,
			'3239': 255,
			'3240': 219,
			'3241': 218,
			'3242': 216,
			'3243': 255,
			'3244': 221,
			'3245': 219,
			'3246': 217,
			'3247': 255,
			'3248': 222,
			'3249': 221,
			'3250': 219,
			'3251': 255,
			'3252': 229,
			'3253': 228,
			'3254': 226,
			'3255': 255,
			'3256': 221,
			'3257': 219,
			'3258': 217,
			'3259': 255,
			'3260': 220,
			'3261': 219,
			'3262': 217,
			'3263': 255,
			'3264': 226,
			'3265': 225,
			'3266': 224,
			'3267': 255,
			'3268': 227,
			'3269': 226,
			'3270': 224,
			'3271': 255,
			'3272': 228,
			'3273': 227,
			'3274': 225,
			'3275': 255,
			'3276': 230,
			'3277': 229,
			'3278': 227,
			'3279': 255,
			'3280': 232,
			'3281': 231,
			'3282': 229,
			'3283': 255,
			'3284': 232,
			'3285': 232,
			'3286': 230,
			'3287': 255,
			'3288': 233,
			'3289': 233,
			'3290': 232,
			'3291': 255,
			'3292': 234,
			'3293': 234,
			'3294': 234,
			'3295': 255,
			'3296': 235,
			'3297': 235,
			'3298': 235,
			'3299': 255,
			'3300': 236,
			'3301': 236,
			'3302': 236,
			'3303': 255,
			'3304': 235,
			'3305': 235,
			'3306': 234,
			'3307': 255,
			'3308': 233,
			'3309': 233,
			'3310': 231,
			'3311': 255,
			'3312': 233,
			'3313': 233,
			'3314': 231,
			'3315': 255,
			'3316': 233,
			'3317': 234,
			'3318': 232,
			'3319': 255,
			'3320': 231,
			'3321': 231,
			'3322': 229,
			'3323': 255,
			'3324': 231,
			'3325': 231,
			'3326': 228,
			'3327': 255,
			'3328': 229,
			'3329': 229,
			'3330': 227,
			'3331': 255,
			'3332': 236,
			'3333': 236,
			'3334': 234,
			'3335': 255,
			'3336': 240,
			'3337': 239,
			'3338': 239,
			'3339': 255,
			'3340': 238,
			'3341': 238,
			'3342': 238,
			'3343': 255,
			'3344': 237,
			'3345': 237,
			'3346': 235,
			'3347': 255,
			'3348': 235,
			'3349': 235,
			'3350': 233,
			'3351': 255,
			'3352': 236,
			'3353': 236,
			'3354': 235,
			'3355': 255,
			'3356': 237,
			'3357': 237,
			'3358': 237,
			'3359': 255,
			'3360': 235,
			'3361': 235,
			'3362': 235,
			'3363': 255,
			'3364': 235,
			'3365': 235,
			'3366': 235,
			'3367': 255,
			'3368': 236,
			'3369': 236,
			'3370': 236,
			'3371': 255,
			'3372': 246,
			'3373': 247,
			'3374': 246,
			'3375': 255,
			'3376': 223,
			'3377': 222,
			'3378': 221,
			'3379': 255,
			'3380': 174,
			'3381': 170,
			'3382': 170,
			'3383': 255,
			'3384': 113,
			'3385': 103,
			'3386': 104,
			'3387': 255,
			'3388': 59,
			'3389': 47,
			'3390': 47,
			'3391': 255,
			'3392': 37,
			'3393': 26,
			'3394': 25,
			'3395': 255,
			'3396': 83,
			'3397': 73,
			'3398': 72,
			'3399': 255,
			'3400': 93,
			'3401': 83,
			'3402': 82,
			'3403': 255,
			'3404': 33,
			'3405': 24,
			'3406': 23,
			'3407': 255,
			'3408': 48,
			'3409': 38,
			'3410': 37,
			'3411': 255,
			'3412': 70,
			'3413': 59,
			'3414': 58,
			'3415': 255,
			'3416': 73,
			'3417': 62,
			'3418': 62,
			'3419': 255,
			'3420': 48,
			'3421': 39,
			'3422': 38,
			'3423': 255,
			'3424': 31,
			'3425': 23,
			'3426': 22,
			'3427': 255,
			'3428': 36,
			'3429': 27,
			'3430': 27,
			'3431': 255,
			'3432': 38,
			'3433': 28,
			'3434': 27,
			'3435': 255,
			'3436': 33,
			'3437': 22,
			'3438': 21,
			'3439': 255,
			'3440': 63,
			'3441': 53,
			'3442': 52,
			'3443': 255,
			'3444': 190,
			'3445': 187,
			'3446': 186,
			'3447': 255,
			'3448': 230,
			'3449': 229,
			'3450': 227,
			'3451': 255,
			'3452': 234,
			'3453': 233,
			'3454': 231,
			'3455': 255,
			'3456': 237,
			'3457': 236,
			'3458': 234,
			'3459': 255,
			'3460': 229,
			'3461': 228,
			'3462': 226,
			'3463': 255,
			'3464': 222,
			'3465': 221,
			'3466': 218,
			'3467': 255,
			'3468': 218,
			'3469': 217,
			'3470': 215,
			'3471': 255,
			'3472': 218,
			'3473': 217,
			'3474': 215,
			'3475': 255,
			'3476': 220,
			'3477': 219,
			'3478': 217,
			'3479': 255,
			'3480': 220,
			'3481': 219,
			'3482': 217,
			'3483': 255,
			'3484': 219,
			'3485': 218,
			'3486': 216,
			'3487': 255,
			'3488': 211,
			'3489': 210,
			'3490': 208,
			'3491': 255,
			'3492': 206,
			'3493': 204,
			'3494': 202,
			'3495': 255,
			'3496': 206,
			'3497': 203,
			'3498': 201,
			'3499': 255,
			'3500': 210,
			'3501': 207,
			'3502': 205,
			'3503': 255,
			'3504': 211,
			'3505': 207,
			'3506': 206,
			'3507': 255,
			'3508': 205,
			'3509': 203,
			'3510': 201,
			'3511': 255,
			'3512': 204,
			'3513': 201,
			'3514': 200,
			'3515': 255,
			'3516': 204,
			'3517': 200,
			'3518': 199,
			'3519': 255,
			'3520': 202,
			'3521': 199,
			'3522': 198,
			'3523': 255,
			'3524': 202,
			'3525': 199,
			'3526': 198,
			'3527': 255,
			'3528': 202,
			'3529': 199,
			'3530': 197,
			'3531': 255,
			'3532': 201,
			'3533': 197,
			'3534': 196,
			'3535': 255,
			'3536': 200,
			'3537': 197,
			'3538': 196,
			'3539': 255,
			'3540': 200,
			'3541': 195,
			'3542': 195,
			'3543': 255,
			'3544': 187,
			'3545': 182,
			'3546': 182,
			'3547': 255,
			'3548': 182,
			'3549': 178,
			'3550': 177,
			'3551': 255,
			'3552': 190,
			'3553': 186,
			'3554': 185,
			'3555': 255,
			'3556': 189,
			'3557': 185,
			'3558': 184,
			'3559': 255,
			'3560': 187,
			'3561': 183,
			'3562': 182,
			'3563': 255,
			'3564': 183,
			'3565': 179,
			'3566': 178,
			'3567': 255,
			'3568': 182,
			'3569': 178,
			'3570': 177,
			'3571': 255,
			'3572': 181,
			'3573': 177,
			'3574': 176,
			'3575': 255,
			'3576': 180,
			'3577': 176,
			'3578': 175,
			'3579': 255,
			'3580': 175,
			'3581': 171,
			'3582': 170,
			'3583': 255,
			'3584': 173,
			'3585': 169,
			'3586': 168,
			'3587': 255,
			'3588': 172,
			'3589': 168,
			'3590': 166,
			'3591': 255,
			'3592': 170,
			'3593': 166,
			'3594': 164,
			'3595': 255,
			'3596': 169,
			'3597': 165,
			'3598': 164,
			'3599': 255,
			'3600': 219,
			'3601': 217,
			'3602': 215,
			'3603': 255,
			'3604': 229,
			'3605': 228,
			'3606': 226,
			'3607': 255,
			'3608': 222,
			'3609': 221,
			'3610': 218,
			'3611': 255,
			'3612': 221,
			'3613': 220,
			'3614': 218,
			'3615': 255,
			'3616': 224,
			'3617': 223,
			'3618': 220,
			'3619': 255,
			'3620': 227,
			'3621': 227,
			'3622': 225,
			'3623': 255,
			'3624': 227,
			'3625': 227,
			'3626': 225,
			'3627': 255,
			'3628': 226,
			'3629': 225,
			'3630': 223,
			'3631': 255,
			'3632': 228,
			'3633': 227,
			'3634': 225,
			'3635': 255,
			'3636': 226,
			'3637': 225,
			'3638': 223,
			'3639': 255,
			'3640': 226,
			'3641': 225,
			'3642': 223,
			'3643': 255,
			'3644': 228,
			'3645': 227,
			'3646': 225,
			'3647': 255,
			'3648': 229,
			'3649': 228,
			'3650': 226,
			'3651': 255,
			'3652': 229,
			'3653': 228,
			'3654': 226,
			'3655': 255,
			'3656': 230,
			'3657': 230,
			'3658': 228,
			'3659': 255,
			'3660': 231,
			'3661': 230,
			'3662': 228,
			'3663': 255,
			'3664': 229,
			'3665': 228,
			'3666': 226,
			'3667': 255,
			'3668': 225,
			'3669': 224,
			'3670': 222,
			'3671': 255,
			'3672': 225,
			'3673': 224,
			'3674': 222,
			'3675': 255,
			'3676': 228,
			'3677': 227,
			'3678': 224,
			'3679': 255,
			'3680': 230,
			'3681': 231,
			'3682': 228,
			'3683': 255,
			'3684': 229,
			'3685': 229,
			'3686': 226,
			'3687': 255,
			'3688': 230,
			'3689': 230,
			'3690': 229,
			'3691': 255,
			'3692': 229,
			'3693': 229,
			'3694': 227,
			'3695': 255,
			'3696': 230,
			'3697': 230,
			'3698': 227,
			'3699': 255,
			'3700': 232,
			'3701': 233,
			'3702': 230,
			'3703': 255,
			'3704': 232,
			'3705': 232,
			'3706': 230,
			'3707': 255,
			'3708': 232,
			'3709': 232,
			'3710': 230,
			'3711': 255,
			'3712': 226,
			'3713': 225,
			'3714': 223,
			'3715': 255,
			'3716': 223,
			'3717': 221,
			'3718': 219,
			'3719': 255,
			'3720': 229,
			'3721': 229,
			'3722': 227,
			'3723': 255,
			'3724': 229,
			'3725': 229,
			'3726': 228,
			'3727': 255,
			'3728': 233,
			'3729': 233,
			'3730': 231,
			'3731': 255,
			'3732': 232,
			'3733': 233,
			'3734': 231,
			'3735': 255,
			'3736': 238,
			'3737': 239,
			'3738': 237,
			'3739': 255,
			'3740': 240,
			'3741': 240,
			'3742': 240,
			'3743': 255,
			'3744': 240,
			'3745': 240,
			'3746': 238,
			'3747': 255,
			'3748': 239,
			'3749': 239,
			'3750': 238,
			'3751': 255,
			'3752': 239,
			'3753': 239,
			'3754': 238,
			'3755': 255,
			'3756': 239,
			'3757': 239,
			'3758': 239,
			'3759': 255,
			'3760': 238,
			'3761': 238,
			'3762': 238,
			'3763': 255,
			'3764': 238,
			'3765': 239,
			'3766': 239,
			'3767': 255,
			'3768': 255,
			'3769': 255,
			'3770': 255,
			'3771': 255,
			'3772': 237,
			'3773': 237,
			'3774': 235,
			'3775': 255,
			'3776': 145,
			'3777': 137,
			'3778': 137,
			'3779': 255,
			'3780': 100,
			'3781': 89,
			'3782': 90,
			'3783': 255,
			'3784': 52,
			'3785': 41,
			'3786': 41,
			'3787': 255,
			'3788': 48,
			'3789': 38,
			'3790': 36,
			'3791': 255,
			'3792': 33,
			'3793': 24,
			'3794': 22,
			'3795': 255,
			'3796': 86,
			'3797': 76,
			'3798': 76,
			'3799': 255,
			'3800': 89,
			'3801': 79,
			'3802': 78,
			'3803': 255,
			'3804': 33,
			'3805': 25,
			'3806': 24,
			'3807': 255,
			'3808': 46,
			'3809': 36,
			'3810': 35,
			'3811': 255,
			'3812': 63,
			'3813': 53,
			'3814': 52,
			'3815': 255,
			'3816': 64,
			'3817': 54,
			'3818': 54,
			'3819': 255,
			'3820': 34,
			'3821': 26,
			'3822': 24,
			'3823': 255,
			'3824': 31,
			'3825': 22,
			'3826': 20,
			'3827': 255,
			'3828': 26,
			'3829': 17,
			'3830': 18,
			'3831': 255,
			'3832': 37,
			'3833': 29,
			'3834': 29,
			'3835': 255,
			'3836': 60,
			'3837': 50,
			'3838': 50,
			'3839': 255,
			'3840': 43,
			'3841': 31,
			'3842': 31,
			'3843': 255,
			'3844': 39,
			'3845': 29,
			'3846': 30,
			'3847': 255,
			'3848': 64,
			'3849': 56,
			'3850': 56,
			'3851': 255,
			'3852': 201,
			'3853': 199,
			'3854': 197,
			'3855': 255,
			'3856': 255,
			'3857': 255,
			'3858': 255,
			'3859': 255,
			'3860': 239,
			'3861': 240,
			'3862': 240,
			'3863': 255,
			'3864': 229,
			'3865': 229,
			'3866': 227,
			'3867': 255,
			'3868': 221,
			'3869': 220,
			'3870': 218,
			'3871': 255,
			'3872': 223,
			'3873': 221,
			'3874': 219,
			'3875': 255,
			'3876': 228,
			'3877': 227,
			'3878': 225,
			'3879': 255,
			'3880': 225,
			'3881': 224,
			'3882': 222,
			'3883': 255,
			'3884': 225,
			'3885': 224,
			'3886': 222,
			'3887': 255,
			'3888': 229,
			'3889': 228,
			'3890': 226,
			'3891': 255,
			'3892': 228,
			'3893': 227,
			'3894': 225,
			'3895': 255,
			'3896': 218,
			'3897': 216,
			'3898': 214,
			'3899': 255,
			'3900': 216,
			'3901': 214,
			'3902': 212,
			'3903': 255,
			'3904': 220,
			'3905': 219,
			'3906': 217,
			'3907': 255,
			'3908': 217,
			'3909': 216,
			'3910': 214,
			'3911': 255,
			'3912': 212,
			'3913': 211,
			'3914': 209,
			'3915': 255,
			'3916': 211,
			'3917': 209,
			'3918': 208,
			'3919': 255,
			'3920': 210,
			'3921': 208,
			'3922': 206,
			'3923': 255,
			'3924': 207,
			'3925': 205,
			'3926': 203,
			'3927': 255,
			'3928': 204,
			'3929': 199,
			'3930': 199,
			'3931': 255,
			'3932': 204,
			'3933': 201,
			'3934': 200,
			'3935': 255,
			'3936': 199,
			'3937': 196,
			'3938': 195,
			'3939': 255,
			'3940': 198,
			'3941': 195,
			'3942': 193,
			'3943': 255,
			'3944': 187,
			'3945': 183,
			'3946': 182,
			'3947': 255,
			'3948': 177,
			'3949': 173,
			'3950': 172,
			'3951': 255,
			'3952': 185,
			'3953': 181,
			'3954': 180,
			'3955': 255,
			'3956': 181,
			'3957': 177,
			'3958': 176,
			'3959': 255,
			'3960': 180,
			'3961': 176,
			'3962': 175,
			'3963': 255,
			'3964': 177,
			'3965': 173,
			'3966': 172,
			'3967': 255,
			'3968': 176,
			'3969': 172,
			'3970': 171,
			'3971': 255,
			'3972': 179,
			'3973': 175,
			'3974': 174,
			'3975': 255,
			'3976': 177,
			'3977': 173,
			'3978': 172,
			'3979': 255,
			'3980': 170,
			'3981': 166,
			'3982': 165,
			'3983': 255,
			'3984': 174,
			'3985': 170,
			'3986': 169,
			'3987': 255,
			'3988': 170,
			'3989': 166,
			'3990': 164,
			'3991': 255,
			'3992': 173,
			'3993': 169,
			'3994': 167,
			'3995': 255,
			'3996': 168,
			'3997': 164,
			'3998': 164,
			'3999': 255,
			'4000': 227,
			'4001': 227,
			'4002': 225,
			'4003': 255,
			'4004': 225,
			'4005': 224,
			'4006': 222,
			'4007': 255,
			'4008': 228,
			'4009': 227,
			'4010': 225,
			'4011': 255,
			'4012': 228,
			'4013': 227,
			'4014': 225,
			'4015': 255,
			'4016': 225,
			'4017': 225,
			'4018': 224,
			'4019': 255,
			'4020': 227,
			'4021': 226,
			'4022': 226,
			'4023': 255,
			'4024': 228,
			'4025': 228,
			'4026': 227,
			'4027': 255,
			'4028': 229,
			'4029': 227,
			'4030': 226,
			'4031': 255,
			'4032': 229,
			'4033': 228,
			'4034': 225,
			'4035': 255,
			'4036': 230,
			'4037': 229,
			'4038': 227,
			'4039': 255,
			'4040': 229,
			'4041': 229,
			'4042': 227,
			'4043': 255,
			'4044': 229,
			'4045': 229,
			'4046': 227,
			'4047': 255,
			'4048': 230,
			'4049': 230,
			'4050': 228,
			'4051': 255,
			'4052': 231,
			'4053': 231,
			'4054': 229,
			'4055': 255,
			'4056': 231,
			'4057': 230,
			'4058': 228,
			'4059': 255,
			'4060': 232,
			'4061': 232,
			'4062': 230,
			'4063': 255,
			'4064': 233,
			'4065': 234,
			'4066': 232,
			'4067': 255,
			'4068': 232,
			'4069': 233,
			'4070': 230,
			'4071': 255,
			'4072': 233,
			'4073': 232,
			'4074': 230,
			'4075': 255,
			'4076': 233,
			'4077': 233,
			'4078': 232,
			'4079': 255,
			'4080': 234,
			'4081': 234,
			'4082': 234,
			'4083': 255,
			'4084': 234,
			'4085': 234,
			'4086': 234,
			'4087': 255,
			'4088': 235,
			'4089': 234,
			'4090': 234,
			'4091': 255,
			'4092': 235,
			'4093': 235,
			'4094': 234,
			'4095': 255,
			'4096': 233,
			'4097': 233,
			'4098': 232,
			'4099': 255,
			'4100': 234,
			'4101': 234,
			'4102': 234,
			'4103': 255,
			'4104': 236,
			'4105': 235,
			'4106': 234,
			'4107': 255,
			'4108': 237,
			'4109': 237,
			'4110': 236,
			'4111': 255,
			'4112': 227,
			'4113': 226,
			'4114': 225,
			'4115': 255,
			'4116': 221,
			'4117': 219,
			'4118': 216,
			'4119': 255,
			'4120': 227,
			'4121': 226,
			'4122': 224,
			'4123': 255,
			'4124': 228,
			'4125': 228,
			'4126': 227,
			'4127': 255,
			'4128': 239,
			'4129': 239,
			'4130': 240,
			'4131': 255,
			'4132': 234,
			'4133': 234,
			'4134': 234,
			'4135': 255,
			'4136': 235,
			'4137': 235,
			'4138': 234,
			'4139': 255,
			'4140': 237,
			'4141': 237,
			'4142': 237,
			'4143': 255,
			'4144': 237,
			'4145': 237,
			'4146': 238,
			'4147': 255,
			'4148': 235,
			'4149': 235,
			'4150': 234,
			'4151': 255,
			'4152': 235,
			'4153': 234,
			'4154': 232,
			'4155': 255,
			'4156': 236,
			'4157': 235,
			'4158': 235,
			'4159': 255,
			'4160': 237,
			'4161': 236,
			'4162': 235,
			'4163': 255,
			'4164': 255,
			'4165': 255,
			'4166': 255,
			'4167': 255,
			'4168': 222,
			'4169': 221,
			'4170': 220,
			'4171': 255,
			'4172': 158,
			'4173': 151,
			'4174': 151,
			'4175': 255,
			'4176': 81,
			'4177': 70,
			'4178': 72,
			'4179': 255,
			'4180': 54,
			'4181': 43,
			'4182': 41,
			'4183': 255,
			'4184': 63,
			'4185': 53,
			'4186': 52,
			'4187': 255,
			'4188': 77,
			'4189': 68,
			'4190': 67,
			'4191': 255,
			'4192': 56,
			'4193': 47,
			'4194': 46,
			'4195': 255,
			'4196': 39,
			'4197': 30,
			'4198': 28,
			'4199': 255,
			'4200': 43,
			'4201': 33,
			'4202': 31,
			'4203': 255,
			'4204': 33,
			'4205': 24,
			'4206': 23,
			'4207': 255,
			'4208': 54,
			'4209': 45,
			'4210': 43,
			'4211': 255,
			'4212': 88,
			'4213': 77,
			'4214': 76,
			'4215': 255,
			'4216': 65,
			'4217': 55,
			'4218': 56,
			'4219': 255,
			'4220': 45,
			'4221': 35,
			'4222': 34,
			'4223': 255,
			'4224': 45,
			'4225': 35,
			'4226': 34,
			'4227': 255,
			'4228': 53,
			'4229': 44,
			'4230': 44,
			'4231': 255,
			'4232': 51,
			'4233': 44,
			'4234': 43,
			'4235': 255,
			'4236': 37,
			'4237': 28,
			'4238': 28,
			'4239': 255,
			'4240': 51,
			'4241': 41,
			'4242': 40,
			'4243': 255,
			'4244': 41,
			'4245': 31,
			'4246': 30,
			'4247': 255,
			'4248': 5,
			'4249': 0,
			'4250': 0,
			'4251': 255,
			'4252': 67,
			'4253': 59,
			'4254': 58,
			'4255': 255,
			'4256': 231,
			'4257': 230,
			'4258': 229,
			'4259': 255,
			'4260': 249,
			'4261': 250,
			'4262': 250,
			'4263': 255,
			'4264': 235,
			'4265': 235,
			'4266': 235,
			'4267': 255,
			'4268': 229,
			'4269': 229,
			'4270': 226,
			'4271': 255,
			'4272': 221,
			'4273': 219,
			'4274': 217,
			'4275': 255,
			'4276': 214,
			'4277': 213,
			'4278': 211,
			'4279': 255,
			'4280': 226,
			'4281': 225,
			'4282': 223,
			'4283': 255,
			'4284': 227,
			'4285': 226,
			'4286': 224,
			'4287': 255,
			'4288': 227,
			'4289': 226,
			'4290': 224,
			'4291': 255,
			'4292': 226,
			'4293': 225,
			'4294': 223,
			'4295': 255,
			'4296': 224,
			'4297': 222,
			'4298': 221,
			'4299': 255,
			'4300': 220,
			'4301': 218,
			'4302': 216,
			'4303': 255,
			'4304': 219,
			'4305': 218,
			'4306': 216,
			'4307': 255,
			'4308': 218,
			'4309': 217,
			'4310': 215,
			'4311': 255,
			'4312': 215,
			'4313': 215,
			'4314': 212,
			'4315': 255,
			'4316': 214,
			'4317': 213,
			'4318': 211,
			'4319': 255,
			'4320': 216,
			'4321': 213,
			'4322': 212,
			'4323': 255,
			'4324': 212,
			'4325': 209,
			'4326': 207,
			'4327': 255,
			'4328': 209,
			'4329': 205,
			'4330': 204,
			'4331': 255,
			'4332': 208,
			'4333': 205,
			'4334': 203,
			'4335': 255,
			'4336': 204,
			'4337': 203,
			'4338': 201,
			'4339': 255,
			'4340': 201,
			'4341': 198,
			'4342': 196,
			'4343': 255,
			'4344': 204,
			'4345': 201,
			'4346': 199,
			'4347': 255,
			'4348': 204,
			'4349': 200,
			'4350': 199,
			'4351': 255,
			'4352': 195,
			'4353': 191,
			'4354': 190,
			'4355': 255,
			'4356': 189,
			'4357': 185,
			'4358': 184,
			'4359': 255,
			'4360': 183,
			'4361': 179,
			'4362': 178,
			'4363': 255,
			'4364': 186,
			'4365': 183,
			'4366': 182,
			'4367': 255,
			'4368': 175,
			'4369': 172,
			'4370': 171,
			'4371': 255,
			'4372': 155,
			'4373': 150,
			'4374': 150,
			'4375': 255,
			'4376': 157,
			'4377': 152,
			'4378': 152,
			'4379': 255,
			'4380': 182,
			'4381': 179,
			'4382': 178,
			'4383': 255,
			'4384': 178,
			'4385': 174,
			'4386': 173,
			'4387': 255,
			'4388': 173,
			'4389': 169,
			'4390': 167,
			'4391': 255,
			'4392': 174,
			'4393': 170,
			'4394': 168,
			'4395': 255,
			'4396': 175,
			'4397': 171,
			'4398': 170,
			'4399': 255,
			'4400': 226,
			'4401': 225,
			'4402': 223,
			'4403': 255,
			'4404': 227,
			'4405': 226,
			'4406': 224,
			'4407': 255,
			'4408': 228,
			'4409': 227,
			'4410': 225,
			'4411': 255,
			'4412': 229,
			'4413': 228,
			'4414': 226,
			'4415': 255,
			'4416': 228,
			'4417': 227,
			'4418': 227,
			'4419': 255,
			'4420': 229,
			'4421': 227,
			'4422': 226,
			'4423': 255,
			'4424': 228,
			'4425': 226,
			'4426': 225,
			'4427': 255,
			'4428': 228,
			'4429': 227,
			'4430': 226,
			'4431': 255,
			'4432': 229,
			'4433': 228,
			'4434': 226,
			'4435': 255,
			'4436': 228,
			'4437': 229,
			'4438': 228,
			'4439': 255,
			'4440': 229,
			'4441': 229,
			'4442': 228,
			'4443': 255,
			'4444': 232,
			'4445': 231,
			'4446': 229,
			'4447': 255,
			'4448': 232,
			'4449': 232,
			'4450': 230,
			'4451': 255,
			'4452': 233,
			'4453': 232,
			'4454': 230,
			'4455': 255,
			'4456': 234,
			'4457': 232,
			'4458': 230,
			'4459': 255,
			'4460': 233,
			'4461': 232,
			'4462': 231,
			'4463': 255,
			'4464': 233,
			'4465': 234,
			'4466': 234,
			'4467': 255,
			'4468': 235,
			'4469': 235,
			'4470': 234,
			'4471': 255,
			'4472': 235,
			'4473': 235,
			'4474': 234,
			'4475': 255,
			'4476': 236,
			'4477': 236,
			'4478': 235,
			'4479': 255,
			'4480': 235,
			'4481': 235,
			'4482': 234,
			'4483': 255,
			'4484': 236,
			'4485': 236,
			'4486': 236,
			'4487': 255,
			'4488': 236,
			'4489': 236,
			'4490': 235,
			'4491': 255,
			'4492': 236,
			'4493': 236,
			'4494': 236,
			'4495': 255,
			'4496': 236,
			'4497': 236,
			'4498': 236,
			'4499': 255,
			'4500': 236,
			'4501': 236,
			'4502': 236,
			'4503': 255,
			'4504': 237,
			'4505': 237,
			'4506': 238,
			'4507': 255,
			'4508': 237,
			'4509': 238,
			'4510': 237,
			'4511': 255,
			'4512': 236,
			'4513': 236,
			'4514': 236,
			'4515': 255,
			'4516': 233,
			'4517': 232,
			'4518': 230,
			'4519': 255,
			'4520': 230,
			'4521': 229,
			'4522': 227,
			'4523': 255,
			'4524': 232,
			'4525': 231,
			'4526': 229,
			'4527': 255,
			'4528': 238,
			'4529': 238,
			'4530': 238,
			'4531': 255,
			'4532': 239,
			'4533': 240,
			'4534': 239,
			'4535': 255,
			'4536': 238,
			'4537': 238,
			'4538': 237,
			'4539': 255,
			'4540': 236,
			'4541': 236,
			'4542': 236,
			'4543': 255,
			'4544': 238,
			'4545': 238,
			'4546': 238,
			'4547': 255,
			'4548': 236,
			'4549': 237,
			'4550': 237,
			'4551': 255,
			'4552': 236,
			'4553': 234,
			'4554': 234,
			'4555': 255,
			'4556': 239,
			'4557': 238,
			'4558': 238,
			'4559': 255,
			'4560': 255,
			'4561': 255,
			'4562': 255,
			'4563': 255,
			'4564': 207,
			'4565': 205,
			'4566': 202,
			'4567': 255,
			'4568': 106,
			'4569': 96,
			'4570': 97,
			'4571': 255,
			'4572': 71,
			'4573': 60,
			'4574': 61,
			'4575': 255,
			'4576': 37,
			'4577': 27,
			'4578': 27,
			'4579': 255,
			'4580': 33,
			'4581': 23,
			'4582': 21,
			'4583': 255,
			'4584': 69,
			'4585': 59,
			'4586': 59,
			'4587': 255,
			'4588': 87,
			'4589': 76,
			'4590': 76,
			'4591': 255,
			'4592': 55,
			'4593': 45,
			'4594': 44,
			'4595': 255,
			'4596': 34,
			'4597': 24,
			'4598': 23,
			'4599': 255,
			'4600': 46,
			'4601': 34,
			'4602': 34,
			'4603': 255,
			'4604': 60,
			'4605': 49,
			'4606': 49,
			'4607': 255,
			'4608': 92,
			'4609': 83,
			'4610': 83,
			'4611': 255,
			'4612': 136,
			'4613': 127,
			'4614': 127,
			'4615': 255,
			'4616': 71,
			'4617': 61,
			'4618': 62,
			'4619': 255,
			'4620': 36,
			'4621': 25,
			'4622': 25,
			'4623': 255,
			'4624': 37,
			'4625': 28,
			'4626': 28,
			'4627': 255,
			'4628': 46,
			'4629': 37,
			'4630': 36,
			'4631': 255,
			'4632': 65,
			'4633': 56,
			'4634': 54,
			'4635': 255,
			'4636': 67,
			'4637': 58,
			'4638': 57,
			'4639': 255,
			'4640': 54,
			'4641': 44,
			'4642': 44,
			'4643': 255,
			'4644': 43,
			'4645': 34,
			'4646': 33,
			'4647': 255,
			'4648': 36,
			'4649': 26,
			'4650': 25,
			'4651': 255,
			'4652': 27,
			'4653': 16,
			'4654': 16,
			'4655': 255,
			'4656': 74,
			'4657': 66,
			'4658': 64,
			'4659': 255,
			'4660': 229,
			'4661': 228,
			'4662': 228,
			'4663': 255,
			'4664': 254,
			'4665': 255,
			'4666': 255,
			'4667': 255,
			'4668': 233,
			'4669': 233,
			'4670': 230,
			'4671': 255,
			'4672': 227,
			'4673': 226,
			'4674': 224,
			'4675': 255,
			'4676': 205,
			'4677': 204,
			'4678': 202,
			'4679': 255,
			'4680': 219,
			'4681': 218,
			'4682': 216,
			'4683': 255,
			'4684': 228,
			'4685': 227,
			'4686': 225,
			'4687': 255,
			'4688': 226,
			'4689': 225,
			'4690': 223,
			'4691': 255,
			'4692': 225,
			'4693': 224,
			'4694': 222,
			'4695': 255,
			'4696': 222,
			'4697': 221,
			'4698': 219,
			'4699': 255,
			'4700': 219,
			'4701': 218,
			'4702': 217,
			'4703': 255,
			'4704': 219,
			'4705': 218,
			'4706': 216,
			'4707': 255,
			'4708': 217,
			'4709': 216,
			'4710': 214,
			'4711': 255,
			'4712': 216,
			'4713': 215,
			'4714': 213,
			'4715': 255,
			'4716': 213,
			'4717': 213,
			'4718': 211,
			'4719': 255,
			'4720': 213,
			'4721': 212,
			'4722': 210,
			'4723': 255,
			'4724': 212,
			'4725': 209,
			'4726': 208,
			'4727': 255,
			'4728': 209,
			'4729': 207,
			'4730': 205,
			'4731': 255,
			'4732': 204,
			'4733': 202,
			'4734': 201,
			'4735': 255,
			'4736': 205,
			'4737': 201,
			'4738': 200,
			'4739': 255,
			'4740': 204,
			'4741': 199,
			'4742': 198,
			'4743': 255,
			'4744': 200,
			'4745': 196,
			'4746': 195,
			'4747': 255,
			'4748': 198,
			'4749': 194,
			'4750': 193,
			'4751': 255,
			'4752': 197,
			'4753': 193,
			'4754': 192,
			'4755': 255,
			'4756': 195,
			'4757': 191,
			'4758': 190,
			'4759': 255,
			'4760': 192,
			'4761': 188,
			'4762': 187,
			'4763': 255,
			'4764': 192,
			'4765': 188,
			'4766': 187,
			'4767': 255,
			'4768': 182,
			'4769': 179,
			'4770': 177,
			'4771': 255,
			'4772': 166,
			'4773': 162,
			'4774': 161,
			'4775': 255,
			'4776': 160,
			'4777': 156,
			'4778': 156,
			'4779': 255,
			'4780': 181,
			'4781': 177,
			'4782': 176,
			'4783': 255,
			'4784': 176,
			'4785': 171,
			'4786': 170,
			'4787': 255,
			'4788': 176,
			'4789': 173,
			'4790': 172,
			'4791': 255,
			'4792': 173,
			'4793': 169,
			'4794': 167,
			'4795': 255,
			'4796': 175,
			'4797': 171,
			'4798': 167,
			'4799': 255,
			'4800': 225,
			'4801': 224,
			'4802': 222,
			'4803': 255,
			'4804': 225,
			'4805': 223,
			'4806': 222,
			'4807': 255,
			'4808': 227,
			'4809': 226,
			'4810': 225,
			'4811': 255,
			'4812': 229,
			'4813': 229,
			'4814': 226,
			'4815': 255,
			'4816': 230,
			'4817': 229,
			'4818': 227,
			'4819': 255,
			'4820': 229,
			'4821': 229,
			'4822': 226,
			'4823': 255,
			'4824': 228,
			'4825': 228,
			'4826': 225,
			'4827': 255,
			'4828': 230,
			'4829': 229,
			'4830': 227,
			'4831': 255,
			'4832': 230,
			'4833': 230,
			'4834': 228,
			'4835': 255,
			'4836': 229,
			'4837': 229,
			'4838': 229,
			'4839': 255,
			'4840': 230,
			'4841': 229,
			'4842': 228,
			'4843': 255,
			'4844': 233,
			'4845': 232,
			'4846': 229,
			'4847': 255,
			'4848': 234,
			'4849': 233,
			'4850': 231,
			'4851': 255,
			'4852': 234,
			'4853': 233,
			'4854': 231,
			'4855': 255,
			'4856': 233,
			'4857': 232,
			'4858': 230,
			'4859': 255,
			'4860': 233,
			'4861': 232,
			'4862': 230,
			'4863': 255,
			'4864': 233,
			'4865': 234,
			'4866': 233,
			'4867': 255,
			'4868': 235,
			'4869': 234,
			'4870': 235,
			'4871': 255,
			'4872': 235,
			'4873': 234,
			'4874': 235,
			'4875': 255,
			'4876': 236,
			'4877': 236,
			'4878': 235,
			'4879': 255,
			'4880': 235,
			'4881': 235,
			'4882': 233,
			'4883': 255,
			'4884': 236,
			'4885': 236,
			'4886': 235,
			'4887': 255,
			'4888': 237,
			'4889': 237,
			'4890': 237,
			'4891': 255,
			'4892': 236,
			'4893': 236,
			'4894': 237,
			'4895': 255,
			'4896': 236,
			'4897': 236,
			'4898': 235,
			'4899': 255,
			'4900': 236,
			'4901': 236,
			'4902': 235,
			'4903': 255,
			'4904': 236,
			'4905': 236,
			'4906': 237,
			'4907': 255,
			'4908': 236,
			'4909': 236,
			'4910': 234,
			'4911': 255,
			'4912': 238,
			'4913': 236,
			'4914': 237,
			'4915': 255,
			'4916': 235,
			'4917': 235,
			'4918': 234,
			'4919': 255,
			'4920': 229,
			'4921': 229,
			'4922': 227,
			'4923': 255,
			'4924': 233,
			'4925': 232,
			'4926': 230,
			'4927': 255,
			'4928': 239,
			'4929': 238,
			'4930': 238,
			'4931': 255,
			'4932': 239,
			'4933': 239,
			'4934': 238,
			'4935': 255,
			'4936': 240,
			'4937': 240,
			'4938': 239,
			'4939': 255,
			'4940': 237,
			'4941': 237,
			'4942': 236,
			'4943': 255,
			'4944': 236,
			'4945': 235,
			'4946': 234,
			'4947': 255,
			'4948': 238,
			'4949': 239,
			'4950': 237,
			'4951': 255,
			'4952': 239,
			'4953': 239,
			'4954': 239,
			'4955': 255,
			'4956': 255,
			'4957': 255,
			'4958': 255,
			'4959': 255,
			'4960': 207,
			'4961': 205,
			'4962': 204,
			'4963': 255,
			'4964': 47,
			'4965': 37,
			'4966': 37,
			'4967': 255,
			'4968': 29,
			'4969': 18,
			'4970': 18,
			'4971': 255,
			'4972': 43,
			'4973': 34,
			'4974': 32,
			'4975': 255,
			'4976': 42,
			'4977': 33,
			'4978': 31,
			'4979': 255,
			'4980': 64,
			'4981': 54,
			'4982': 54,
			'4983': 255,
			'4984': 93,
			'4985': 83,
			'4986': 82,
			'4987': 255,
			'4988': 125,
			'4989': 116,
			'4990': 117,
			'4991': 255,
			'4992': 124,
			'4993': 116,
			'4994': 117,
			'4995': 255,
			'4996': 129,
			'4997': 121,
			'4998': 121,
			'4999': 255,
			'5000': 141,
			'5001': 134,
			'5002': 134,
			'5003': 255,
			'5004': 147,
			'5005': 140,
			'5006': 140,
			'5007': 255,
			'5008': 161,
			'5009': 155,
			'5010': 155,
			'5011': 255,
			'5012': 159,
			'5013': 152,
			'5014': 153,
			'5015': 255,
			'5016': 118,
			'5017': 108,
			'5018': 109,
			'5019': 255,
			'5020': 92,
			'5021': 82,
			'5022': 82,
			'5023': 255,
			'5024': 70,
			'5025': 60,
			'5026': 60,
			'5027': 255,
			'5028': 42,
			'5029': 32,
			'5030': 31,
			'5031': 255,
			'5032': 22,
			'5033': 13,
			'5034': 12,
			'5035': 255,
			'5036': 51,
			'5037': 41,
			'5038': 41,
			'5039': 255,
			'5040': 83,
			'5041': 73,
			'5042': 73,
			'5043': 255,
			'5044': 66,
			'5045': 56,
			'5046': 55,
			'5047': 255,
			'5048': 55,
			'5049': 45,
			'5050': 45,
			'5051': 255,
			'5052': 47,
			'5053': 38,
			'5054': 37,
			'5055': 255,
			'5056': 20,
			'5057': 9,
			'5058': 7,
			'5059': 255,
			'5060': 141,
			'5061': 135,
			'5062': 134,
			'5063': 255,
			'5064': 246,
			'5065': 246,
			'5066': 244,
			'5067': 255,
			'5068': 238,
			'5069': 239,
			'5070': 236,
			'5071': 255,
			'5072': 234,
			'5073': 233,
			'5074': 232,
			'5075': 255,
			'5076': 226,
			'5077': 226,
			'5078': 225,
			'5079': 255,
			'5080': 219,
			'5081': 218,
			'5082': 216,
			'5083': 255,
			'5084': 227,
			'5085': 226,
			'5086': 224,
			'5087': 255,
			'5088': 226,
			'5089': 225,
			'5090': 223,
			'5091': 255,
			'5092': 225,
			'5093': 224,
			'5094': 222,
			'5095': 255,
			'5096': 221,
			'5097': 220,
			'5098': 218,
			'5099': 255,
			'5100': 220,
			'5101': 217,
			'5102': 216,
			'5103': 255,
			'5104': 219,
			'5105': 218,
			'5106': 216,
			'5107': 255,
			'5108': 217,
			'5109': 216,
			'5110': 214,
			'5111': 255,
			'5112': 214,
			'5113': 213,
			'5114': 211,
			'5115': 255,
			'5116': 214,
			'5117': 213,
			'5118': 211,
			'5119': 255,
			'5120': 212,
			'5121': 210,
			'5122': 208,
			'5123': 255,
			'5124': 209,
			'5125': 209,
			'5126': 207,
			'5127': 255,
			'5128': 209,
			'5129': 207,
			'5130': 205,
			'5131': 255,
			'5132': 206,
			'5133': 204,
			'5134': 202,
			'5135': 255,
			'5136': 204,
			'5137': 201,
			'5138': 200,
			'5139': 255,
			'5140': 202,
			'5141': 198,
			'5142': 197,
			'5143': 255,
			'5144': 198,
			'5145': 194,
			'5146': 193,
			'5147': 255,
			'5148': 197,
			'5149': 193,
			'5150': 192,
			'5151': 255,
			'5152': 196,
			'5153': 192,
			'5154': 191,
			'5155': 255,
			'5156': 193,
			'5157': 189,
			'5158': 188,
			'5159': 255,
			'5160': 190,
			'5161': 186,
			'5162': 185,
			'5163': 255,
			'5164': 185,
			'5165': 181,
			'5166': 180,
			'5167': 255,
			'5168': 183,
			'5169': 178,
			'5170': 177,
			'5171': 255,
			'5172': 184,
			'5173': 180,
			'5174': 179,
			'5175': 255,
			'5176': 176,
			'5177': 172,
			'5178': 171,
			'5179': 255,
			'5180': 171,
			'5181': 168,
			'5182': 166,
			'5183': 255,
			'5184': 175,
			'5185': 172,
			'5186': 169,
			'5187': 255,
			'5188': 178,
			'5189': 173,
			'5190': 173,
			'5191': 255,
			'5192': 174,
			'5193': 170,
			'5194': 168,
			'5195': 255,
			'5196': 174,
			'5197': 171,
			'5198': 168,
			'5199': 255,
			'5200': 227,
			'5201': 226,
			'5202': 224,
			'5203': 255,
			'5204': 224,
			'5205': 223,
			'5206': 221,
			'5207': 255,
			'5208': 226,
			'5209': 226,
			'5210': 224,
			'5211': 255,
			'5212': 228,
			'5213': 227,
			'5214': 226,
			'5215': 255,
			'5216': 229,
			'5217': 229,
			'5218': 226,
			'5219': 255,
			'5220': 230,
			'5221': 229,
			'5222': 228,
			'5223': 255,
			'5224': 230,
			'5225': 230,
			'5226': 229,
			'5227': 255,
			'5228': 231,
			'5229': 231,
			'5230': 229,
			'5231': 255,
			'5232': 232,
			'5233': 232,
			'5234': 230,
			'5235': 255,
			'5236': 231,
			'5237': 230,
			'5238': 228,
			'5239': 255,
			'5240': 232,
			'5241': 232,
			'5242': 230,
			'5243': 255,
			'5244': 232,
			'5245': 231,
			'5246': 229,
			'5247': 255,
			'5248': 230,
			'5249': 229,
			'5250': 227,
			'5251': 255,
			'5252': 233,
			'5253': 233,
			'5254': 231,
			'5255': 255,
			'5256': 233,
			'5257': 233,
			'5258': 231,
			'5259': 255,
			'5260': 233,
			'5261': 233,
			'5262': 232,
			'5263': 255,
			'5264': 235,
			'5265': 234,
			'5266': 235,
			'5267': 255,
			'5268': 235,
			'5269': 234,
			'5270': 235,
			'5271': 255,
			'5272': 236,
			'5273': 235,
			'5274': 235,
			'5275': 255,
			'5276': 236,
			'5277': 236,
			'5278': 236,
			'5279': 255,
			'5280': 236,
			'5281': 236,
			'5282': 235,
			'5283': 255,
			'5284': 236,
			'5285': 236,
			'5286': 236,
			'5287': 255,
			'5288': 236,
			'5289': 236,
			'5290': 236,
			'5291': 255,
			'5292': 237,
			'5293': 237,
			'5294': 237,
			'5295': 255,
			'5296': 238,
			'5297': 238,
			'5298': 238,
			'5299': 255,
			'5300': 235,
			'5301': 235,
			'5302': 234,
			'5303': 255,
			'5304': 235,
			'5305': 236,
			'5306': 234,
			'5307': 255,
			'5308': 237,
			'5309': 237,
			'5310': 238,
			'5311': 255,
			'5312': 239,
			'5313': 238,
			'5314': 237,
			'5315': 255,
			'5316': 233,
			'5317': 233,
			'5318': 232,
			'5319': 255,
			'5320': 233,
			'5321': 233,
			'5322': 232,
			'5323': 255,
			'5324': 233,
			'5325': 233,
			'5326': 230,
			'5327': 255,
			'5328': 232,
			'5329': 232,
			'5330': 230,
			'5331': 255,
			'5332': 237,
			'5333': 236,
			'5334': 237,
			'5335': 255,
			'5336': 239,
			'5337': 240,
			'5338': 238,
			'5339': 255,
			'5340': 239,
			'5341': 239,
			'5342': 238,
			'5343': 255,
			'5344': 236,
			'5345': 236,
			'5346': 236,
			'5347': 255,
			'5348': 236,
			'5349': 236,
			'5350': 234,
			'5351': 255,
			'5352': 250,
			'5353': 251,
			'5354': 250,
			'5355': 255,
			'5356': 255,
			'5357': 255,
			'5358': 255,
			'5359': 255,
			'5360': 93,
			'5361': 83,
			'5362': 82,
			'5363': 255,
			'5364': 19,
			'5365': 8,
			'5366': 8,
			'5367': 255,
			'5368': 39,
			'5369': 31,
			'5370': 30,
			'5371': 255,
			'5372': 36,
			'5373': 26,
			'5374': 25,
			'5375': 255,
			'5376': 87,
			'5377': 77,
			'5378': 78,
			'5379': 255,
			'5380': 161,
			'5381': 155,
			'5382': 155,
			'5383': 255,
			'5384': 182,
			'5385': 176,
			'5386': 176,
			'5387': 255,
			'5388': 190,
			'5389': 185,
			'5390': 185,
			'5391': 255,
			'5392': 203,
			'5393': 200,
			'5394': 199,
			'5395': 255,
			'5396': 210,
			'5397': 206,
			'5398': 205,
			'5399': 255,
			'5400': 205,
			'5401': 202,
			'5402': 201,
			'5403': 255,
			'5404': 194,
			'5405': 191,
			'5406': 190,
			'5407': 255,
			'5408': 183,
			'5409': 180,
			'5410': 178,
			'5411': 255,
			'5412': 178,
			'5413': 174,
			'5414': 173,
			'5415': 255,
			'5416': 166,
			'5417': 159,
			'5418': 159,
			'5419': 255,
			'5420': 142,
			'5421': 133,
			'5422': 134,
			'5423': 255,
			'5424': 113,
			'5425': 102,
			'5426': 104,
			'5427': 255,
			'5428': 95,
			'5429': 85,
			'5430': 85,
			'5431': 255,
			'5432': 83,
			'5433': 73,
			'5434': 73,
			'5435': 255,
			'5436': 63,
			'5437': 53,
			'5438': 52,
			'5439': 255,
			'5440': 40,
			'5441': 30,
			'5442': 32,
			'5443': 255,
			'5444': 43,
			'5445': 34,
			'5446': 34,
			'5447': 255,
			'5448': 58,
			'5449': 48,
			'5450': 46,
			'5451': 255,
			'5452': 68,
			'5453': 58,
			'5454': 57,
			'5455': 255,
			'5456': 24,
			'5457': 14,
			'5458': 13,
			'5459': 255,
			'5460': 51,
			'5461': 42,
			'5462': 40,
			'5463': 255,
			'5464': 230,
			'5465': 229,
			'5466': 227,
			'5467': 255,
			'5468': 247,
			'5469': 247,
			'5470': 244,
			'5471': 255,
			'5472': 232,
			'5473': 231,
			'5474': 229,
			'5475': 255,
			'5476': 233,
			'5477': 233,
			'5478': 231,
			'5479': 255,
			'5480': 230,
			'5481': 229,
			'5482': 227,
			'5483': 255,
			'5484': 227,
			'5485': 226,
			'5486': 224,
			'5487': 255,
			'5488': 225,
			'5489': 224,
			'5490': 222,
			'5491': 255,
			'5492': 225,
			'5493': 224,
			'5494': 222,
			'5495': 255,
			'5496': 223,
			'5497': 222,
			'5498': 220,
			'5499': 255,
			'5500': 222,
			'5501': 220,
			'5502': 218,
			'5503': 255,
			'5504': 219,
			'5505': 218,
			'5506': 216,
			'5507': 255,
			'5508': 217,
			'5509': 216,
			'5510': 214,
			'5511': 255,
			'5512': 214,
			'5513': 213,
			'5514': 211,
			'5515': 255,
			'5516': 215,
			'5517': 213,
			'5518': 211,
			'5519': 255,
			'5520': 211,
			'5521': 207,
			'5522': 206,
			'5523': 255,
			'5524': 206,
			'5525': 204,
			'5526': 202,
			'5527': 255,
			'5528': 206,
			'5529': 202,
			'5530': 201,
			'5531': 255,
			'5532': 205,
			'5533': 201,
			'5534': 200,
			'5535': 255,
			'5536': 201,
			'5537': 198,
			'5538': 196,
			'5539': 255,
			'5540': 198,
			'5541': 194,
			'5542': 193,
			'5543': 255,
			'5544': 196,
			'5545': 192,
			'5546': 191,
			'5547': 255,
			'5548': 197,
			'5549': 193,
			'5550': 192,
			'5551': 255,
			'5552': 195,
			'5553': 191,
			'5554': 190,
			'5555': 255,
			'5556': 192,
			'5557': 188,
			'5558': 187,
			'5559': 255,
			'5560': 190,
			'5561': 186,
			'5562': 185,
			'5563': 255,
			'5564': 186,
			'5565': 182,
			'5566': 181,
			'5567': 255,
			'5568': 181,
			'5569': 177,
			'5570': 176,
			'5571': 255,
			'5572': 179,
			'5573': 175,
			'5574': 174,
			'5575': 255,
			'5576': 174,
			'5577': 170,
			'5578': 167,
			'5579': 255,
			'5580': 173,
			'5581': 171,
			'5582': 169,
			'5583': 255,
			'5584': 177,
			'5585': 173,
			'5586': 172,
			'5587': 255,
			'5588': 176,
			'5589': 172,
			'5590': 171,
			'5591': 255,
			'5592': 172,
			'5593': 168,
			'5594': 165,
			'5595': 255,
			'5596': 174,
			'5597': 171,
			'5598': 169,
			'5599': 255,
			'5600': 227,
			'5601': 226,
			'5602': 224,
			'5603': 255,
			'5604': 226,
			'5605': 225,
			'5606': 223,
			'5607': 255,
			'5608': 225,
			'5609': 225,
			'5610': 225,
			'5611': 255,
			'5612': 226,
			'5613': 226,
			'5614': 226,
			'5615': 255,
			'5616': 229,
			'5617': 228,
			'5618': 225,
			'5619': 255,
			'5620': 229,
			'5621': 229,
			'5622': 227,
			'5623': 255,
			'5624': 230,
			'5625': 229,
			'5626': 228,
			'5627': 255,
			'5628': 231,
			'5629': 230,
			'5630': 228,
			'5631': 255,
			'5632': 231,
			'5633': 231,
			'5634': 229,
			'5635': 255,
			'5636': 232,
			'5637': 231,
			'5638': 229,
			'5639': 255,
			'5640': 233,
			'5641': 233,
			'5642': 231,
			'5643': 255,
			'5644': 232,
			'5645': 232,
			'5646': 230,
			'5647': 255,
			'5648': 229,
			'5649': 229,
			'5650': 227,
			'5651': 255,
			'5652': 232,
			'5653': 231,
			'5654': 229,
			'5655': 255,
			'5656': 234,
			'5657': 233,
			'5658': 231,
			'5659': 255,
			'5660': 234,
			'5661': 234,
			'5662': 234,
			'5663': 255,
			'5664': 235,
			'5665': 234,
			'5666': 235,
			'5667': 255,
			'5668': 236,
			'5669': 236,
			'5670': 236,
			'5671': 255,
			'5672': 235,
			'5673': 236,
			'5674': 235,
			'5675': 255,
			'5676': 237,
			'5677': 237,
			'5678': 237,
			'5679': 255,
			'5680': 238,
			'5681': 238,
			'5682': 238,
			'5683': 255,
			'5684': 236,
			'5685': 236,
			'5686': 236,
			'5687': 255,
			'5688': 236,
			'5689': 236,
			'5690': 236,
			'5691': 255,
			'5692': 237,
			'5693': 237,
			'5694': 237,
			'5695': 255,
			'5696': 237,
			'5697': 237,
			'5698': 238,
			'5699': 255,
			'5700': 237,
			'5701': 237,
			'5702': 236,
			'5703': 255,
			'5704': 236,
			'5705': 236,
			'5706': 236,
			'5707': 255,
			'5708': 238,
			'5709': 238,
			'5710': 238,
			'5711': 255,
			'5712': 239,
			'5713': 239,
			'5714': 236,
			'5715': 255,
			'5716': 234,
			'5717': 235,
			'5718': 233,
			'5719': 255,
			'5720': 237,
			'5721': 238,
			'5722': 238,
			'5723': 255,
			'5724': 232,
			'5725': 232,
			'5726': 231,
			'5727': 255,
			'5728': 229,
			'5729': 229,
			'5730': 226,
			'5731': 255,
			'5732': 239,
			'5733': 239,
			'5734': 238,
			'5735': 255,
			'5736': 237,
			'5737': 237,
			'5738': 236,
			'5739': 255,
			'5740': 237,
			'5741': 237,
			'5742': 235,
			'5743': 255,
			'5744': 238,
			'5745': 238,
			'5746': 238,
			'5747': 255,
			'5748': 241,
			'5749': 241,
			'5750': 242,
			'5751': 255,
			'5752': 255,
			'5753': 255,
			'5754': 255,
			'5755': 255,
			'5756': 158,
			'5757': 153,
			'5758': 150,
			'5759': 255,
			'5760': 44,
			'5761': 32,
			'5762': 32,
			'5763': 255,
			'5764': 50,
			'5765': 41,
			'5766': 39,
			'5767': 255,
			'5768': 43,
			'5769': 33,
			'5770': 32,
			'5771': 255,
			'5772': 38,
			'5773': 26,
			'5774': 26,
			'5775': 255,
			'5776': 160,
			'5777': 154,
			'5778': 154,
			'5779': 255,
			'5780': 227,
			'5781': 226,
			'5782': 224,
			'5783': 255,
			'5784': 220,
			'5785': 218,
			'5786': 217,
			'5787': 255,
			'5788': 216,
			'5789': 214,
			'5790': 213,
			'5791': 255,
			'5792': 214,
			'5793': 210,
			'5794': 209,
			'5795': 255,
			'5796': 207,
			'5797': 204,
			'5798': 203,
			'5799': 255,
			'5800': 200,
			'5801': 196,
			'5802': 195,
			'5803': 255,
			'5804': 193,
			'5805': 189,
			'5806': 188,
			'5807': 255,
			'5808': 188,
			'5809': 184,
			'5810': 183,
			'5811': 255,
			'5812': 189,
			'5813': 185,
			'5814': 184,
			'5815': 255,
			'5816': 186,
			'5817': 183,
			'5818': 181,
			'5819': 255,
			'5820': 174,
			'5821': 170,
			'5822': 169,
			'5823': 255,
			'5824': 150,
			'5825': 144,
			'5826': 145,
			'5827': 255,
			'5828': 130,
			'5829': 121,
			'5830': 123,
			'5831': 255,
			'5832': 131,
			'5833': 121,
			'5834': 123,
			'5835': 255,
			'5836': 114,
			'5837': 104,
			'5838': 105,
			'5839': 255,
			'5840': 65,
			'5841': 55,
			'5842': 55,
			'5843': 255,
			'5844': 31,
			'5845': 22,
			'5846': 21,
			'5847': 255,
			'5848': 24,
			'5849': 15,
			'5850': 15,
			'5851': 255,
			'5852': 46,
			'5853': 37,
			'5854': 36,
			'5855': 255,
			'5856': 43,
			'5857': 33,
			'5858': 33,
			'5859': 255,
			'5860': 25,
			'5861': 17,
			'5862': 14,
			'5863': 255,
			'5864': 188,
			'5865': 185,
			'5866': 183,
			'5867': 255,
			'5868': 255,
			'5869': 255,
			'5870': 255,
			'5871': 255,
			'5872': 229,
			'5873': 228,
			'5874': 225,
			'5875': 255,
			'5876': 228,
			'5877': 228,
			'5878': 226,
			'5879': 255,
			'5880': 230,
			'5881': 229,
			'5882': 227,
			'5883': 255,
			'5884': 228,
			'5885': 227,
			'5886': 225,
			'5887': 255,
			'5888': 224,
			'5889': 223,
			'5890': 221,
			'5891': 255,
			'5892': 223,
			'5893': 222,
			'5894': 220,
			'5895': 255,
			'5896': 221,
			'5897': 220,
			'5898': 218,
			'5899': 255,
			'5900': 220,
			'5901': 219,
			'5902': 217,
			'5903': 255,
			'5904': 218,
			'5905': 217,
			'5906': 215,
			'5907': 255,
			'5908': 217,
			'5909': 216,
			'5910': 214,
			'5911': 255,
			'5912': 215,
			'5913': 215,
			'5914': 213,
			'5915': 255,
			'5916': 212,
			'5917': 211,
			'5918': 210,
			'5919': 255,
			'5920': 212,
			'5921': 209,
			'5922': 207,
			'5923': 255,
			'5924': 205,
			'5925': 202,
			'5926': 200,
			'5927': 255,
			'5928': 200,
			'5929': 197,
			'5930': 196,
			'5931': 255,
			'5932': 200,
			'5933': 197,
			'5934': 196,
			'5935': 255,
			'5936': 197,
			'5937': 192,
			'5938': 192,
			'5939': 255,
			'5940': 197,
			'5941': 193,
			'5942': 192,
			'5943': 255,
			'5944': 198,
			'5945': 194,
			'5946': 193,
			'5947': 255,
			'5948': 197,
			'5949': 193,
			'5950': 192,
			'5951': 255,
			'5952': 196,
			'5953': 192,
			'5954': 191,
			'5955': 255,
			'5956': 193,
			'5957': 189,
			'5958': 188,
			'5959': 255,
			'5960': 190,
			'5961': 186,
			'5962': 185,
			'5963': 255,
			'5964': 186,
			'5965': 182,
			'5966': 181,
			'5967': 255,
			'5968': 181,
			'5969': 177,
			'5970': 176,
			'5971': 255,
			'5972': 178,
			'5973': 174,
			'5974': 173,
			'5975': 255,
			'5976': 175,
			'5977': 172,
			'5978': 171,
			'5979': 255,
			'5980': 177,
			'5981': 174,
			'5982': 173,
			'5983': 255,
			'5984': 178,
			'5985': 173,
			'5986': 173,
			'5987': 255,
			'5988': 175,
			'5989': 171,
			'5990': 169,
			'5991': 255,
			'5992': 171,
			'5993': 167,
			'5994': 164,
			'5995': 255,
			'5996': 172,
			'5997': 169,
			'5998': 168,
			'5999': 255,
			'6000': 226,
			'6001': 225,
			'6002': 223,
			'6003': 255,
			'6004': 228,
			'6005': 227,
			'6006': 225,
			'6007': 255,
			'6008': 228,
			'6009': 227,
			'6010': 226,
			'6011': 255,
			'6012': 227,
			'6013': 227,
			'6014': 225,
			'6015': 255,
			'6016': 227,
			'6017': 227,
			'6018': 225,
			'6019': 255,
			'6020': 229,
			'6021': 228,
			'6022': 226,
			'6023': 255,
			'6024': 230,
			'6025': 229,
			'6026': 227,
			'6027': 255,
			'6028': 231,
			'6029': 231,
			'6030': 229,
			'6031': 255,
			'6032': 232,
			'6033': 231,
			'6034': 229,
			'6035': 255,
			'6036': 231,
			'6037': 232,
			'6038': 230,
			'6039': 255,
			'6040': 232,
			'6041': 231,
			'6042': 229,
			'6043': 255,
			'6044': 233,
			'6045': 233,
			'6046': 231,
			'6047': 255,
			'6048': 234,
			'6049': 234,
			'6050': 232,
			'6051': 255,
			'6052': 232,
			'6053': 232,
			'6054': 230,
			'6055': 255,
			'6056': 233,
			'6057': 233,
			'6058': 232,
			'6059': 255,
			'6060': 234,
			'6061': 234,
			'6062': 233,
			'6063': 255,
			'6064': 234,
			'6065': 234,
			'6066': 233,
			'6067': 255,
			'6068': 235,
			'6069': 235,
			'6070': 234,
			'6071': 255,
			'6072': 235,
			'6073': 235,
			'6074': 235,
			'6075': 255,
			'6076': 237,
			'6077': 237,
			'6078': 236,
			'6079': 255,
			'6080': 237,
			'6081': 237,
			'6082': 237,
			'6083': 255,
			'6084': 236,
			'6085': 236,
			'6086': 236,
			'6087': 255,
			'6088': 237,
			'6089': 237,
			'6090': 237,
			'6091': 255,
			'6092': 237,
			'6093': 237,
			'6094': 237,
			'6095': 255,
			'6096': 237,
			'6097': 237,
			'6098': 237,
			'6099': 255,
			'6100': 238,
			'6101': 238,
			'6102': 238,
			'6103': 255,
			'6104': 236,
			'6105': 237,
			'6106': 237,
			'6107': 255,
			'6108': 236,
			'6109': 236,
			'6110': 236,
			'6111': 255,
			'6112': 240,
			'6113': 240,
			'6114': 238,
			'6115': 255,
			'6116': 237,
			'6117': 237,
			'6118': 237,
			'6119': 255,
			'6120': 240,
			'6121': 240,
			'6122': 241,
			'6123': 255,
			'6124': 231,
			'6125': 231,
			'6126': 230,
			'6127': 255,
			'6128': 229,
			'6129': 228,
			'6130': 226,
			'6131': 255,
			'6132': 242,
			'6133': 242,
			'6134': 241,
			'6135': 255,
			'6136': 238,
			'6137': 237,
			'6138': 235,
			'6139': 255,
			'6140': 237,
			'6141': 237,
			'6142': 236,
			'6143': 255,
			'6144': 239,
			'6145': 239,
			'6146': 239,
			'6147': 255,
			'6148': 252,
			'6149': 252,
			'6150': 252,
			'6151': 255,
			'6152': 211,
			'6153': 210,
			'6154': 209,
			'6155': 255,
			'6156': 76,
			'6157': 66,
			'6158': 67,
			'6159': 255,
			'6160': 35,
			'6161': 24,
			'6162': 24,
			'6163': 255,
			'6164': 57,
			'6165': 47,
			'6166': 46,
			'6167': 255,
			'6168': 38,
			'6169': 27,
			'6170': 27,
			'6171': 255,
			'6172': 94,
			'6173': 85,
			'6174': 85,
			'6175': 255,
			'6176': 225,
			'6177': 223,
			'6178': 221,
			'6179': 255,
			'6180': 230,
			'6181': 229,
			'6182': 227,
			'6183': 255,
			'6184': 224,
			'6185': 223,
			'6186': 221,
			'6187': 255,
			'6188': 216,
			'6189': 215,
			'6190': 213,
			'6191': 255,
			'6192': 210,
			'6193': 207,
			'6194': 206,
			'6195': 255,
			'6196': 207,
			'6197': 202,
			'6198': 201,
			'6199': 255,
			'6200': 203,
			'6201': 198,
			'6202': 198,
			'6203': 255,
			'6204': 198,
			'6205': 194,
			'6206': 193,
			'6207': 255,
			'6208': 193,
			'6209': 189,
			'6210': 188,
			'6211': 255,
			'6212': 192,
			'6213': 188,
			'6214': 187,
			'6215': 255,
			'6216': 192,
			'6217': 188,
			'6218': 187,
			'6219': 255,
			'6220': 194,
			'6221': 190,
			'6222': 189,
			'6223': 255,
			'6224': 191,
			'6225': 189,
			'6226': 187,
			'6227': 255,
			'6228': 176,
			'6229': 171,
			'6230': 171,
			'6231': 255,
			'6232': 155,
			'6233': 145,
			'6234': 147,
			'6235': 255,
			'6236': 140,
			'6237': 131,
			'6238': 132,
			'6239': 255,
			'6240': 124,
			'6241': 114,
			'6242': 115,
			'6243': 255,
			'6244': 92,
			'6245': 82,
			'6246': 81,
			'6247': 255,
			'6248': 55,
			'6249': 44,
			'6250': 46,
			'6251': 255,
			'6252': 38,
			'6253': 29,
			'6254': 30,
			'6255': 255,
			'6256': 48,
			'6257': 39,
			'6258': 38,
			'6259': 255,
			'6260': 12,
			'6261': 2,
			'6262': 1,
			'6263': 255,
			'6264': 113,
			'6265': 106,
			'6266': 104,
			'6267': 255,
			'6268': 255,
			'6269': 255,
			'6270': 255,
			'6271': 255,
			'6272': 231,
			'6273': 231,
			'6274': 229,
			'6275': 255,
			'6276': 217,
			'6277': 215,
			'6278': 213,
			'6279': 255,
			'6280': 229,
			'6281': 228,
			'6282': 226,
			'6283': 255,
			'6284': 233,
			'6285': 232,
			'6286': 230,
			'6287': 255,
			'6288': 229,
			'6289': 228,
			'6290': 226,
			'6291': 255,
			'6292': 222,
			'6293': 221,
			'6294': 219,
			'6295': 255,
			'6296': 218,
			'6297': 217,
			'6298': 215,
			'6299': 255,
			'6300': 218,
			'6301': 217,
			'6302': 215,
			'6303': 255,
			'6304': 217,
			'6305': 216,
			'6306': 214,
			'6307': 255,
			'6308': 216,
			'6309': 215,
			'6310': 213,
			'6311': 255,
			'6312': 214,
			'6313': 214,
			'6314': 211,
			'6315': 255,
			'6316': 213,
			'6317': 210,
			'6318': 209,
			'6319': 255,
			'6320': 210,
			'6321': 207,
			'6322': 206,
			'6323': 255,
			'6324': 205,
			'6325': 202,
			'6326': 201,
			'6327': 255,
			'6328': 204,
			'6329': 200,
			'6330': 199,
			'6331': 255,
			'6332': 201,
			'6333': 199,
			'6334': 197,
			'6335': 255,
			'6336': 198,
			'6337': 195,
			'6338': 193,
			'6339': 255,
			'6340': 198,
			'6341': 194,
			'6342': 193,
			'6343': 255,
			'6344': 199,
			'6345': 195,
			'6346': 194,
			'6347': 255,
			'6348': 196,
			'6349': 192,
			'6350': 191,
			'6351': 255,
			'6352': 193,
			'6353': 189,
			'6354': 188,
			'6355': 255,
			'6356': 191,
			'6357': 187,
			'6358': 186,
			'6359': 255,
			'6360': 189,
			'6361': 185,
			'6362': 184,
			'6363': 255,
			'6364': 187,
			'6365': 183,
			'6366': 182,
			'6367': 255,
			'6368': 181,
			'6369': 177,
			'6370': 176,
			'6371': 255,
			'6372': 176,
			'6373': 172,
			'6374': 171,
			'6375': 255,
			'6376': 175,
			'6377': 171,
			'6378': 170,
			'6379': 255,
			'6380': 178,
			'6381': 175,
			'6382': 174,
			'6383': 255,
			'6384': 177,
			'6385': 175,
			'6386': 174,
			'6387': 255,
			'6388': 175,
			'6389': 171,
			'6390': 169,
			'6391': 255,
			'6392': 170,
			'6393': 166,
			'6394': 164,
			'6395': 255,
			'6396': 169,
			'6397': 165,
			'6398': 164,
			'6399': 255,
			'6400': 224,
			'6401': 223,
			'6402': 221,
			'6403': 255,
			'6404': 226,
			'6405': 224,
			'6406': 223,
			'6407': 255,
			'6408': 227,
			'6409': 226,
			'6410': 224,
			'6411': 255,
			'6412': 225,
			'6413': 224,
			'6414': 222,
			'6415': 255,
			'6416': 228,
			'6417': 227,
			'6418': 225,
			'6419': 255,
			'6420': 227,
			'6421': 226,
			'6422': 224,
			'6423': 255,
			'6424': 230,
			'6425': 229,
			'6426': 227,
			'6427': 255,
			'6428': 229,
			'6429': 228,
			'6430': 226,
			'6431': 255,
			'6432': 230,
			'6433': 229,
			'6434': 227,
			'6435': 255,
			'6436': 230,
			'6437': 229,
			'6438': 227,
			'6439': 255,
			'6440': 232,
			'6441': 231,
			'6442': 229,
			'6443': 255,
			'6444': 233,
			'6445': 233,
			'6446': 230,
			'6447': 255,
			'6448': 233,
			'6449': 233,
			'6450': 232,
			'6451': 255,
			'6452': 235,
			'6453': 235,
			'6454': 235,
			'6455': 255,
			'6456': 233,
			'6457': 233,
			'6458': 231,
			'6459': 255,
			'6460': 234,
			'6461': 234,
			'6462': 233,
			'6463': 255,
			'6464': 234,
			'6465': 233,
			'6466': 231,
			'6467': 255,
			'6468': 235,
			'6469': 235,
			'6470': 234,
			'6471': 255,
			'6472': 234,
			'6473': 234,
			'6474': 234,
			'6475': 255,
			'6476': 236,
			'6477': 236,
			'6478': 235,
			'6479': 255,
			'6480': 236,
			'6481': 236,
			'6482': 236,
			'6483': 255,
			'6484': 236,
			'6485': 236,
			'6486': 236,
			'6487': 255,
			'6488': 237,
			'6489': 237,
			'6490': 237,
			'6491': 255,
			'6492': 237,
			'6493': 237,
			'6494': 237,
			'6495': 255,
			'6496': 239,
			'6497': 239,
			'6498': 238,
			'6499': 255,
			'6500': 238,
			'6501': 238,
			'6502': 238,
			'6503': 255,
			'6504': 237,
			'6505': 237,
			'6506': 237,
			'6507': 255,
			'6508': 236,
			'6509': 236,
			'6510': 235,
			'6511': 255,
			'6512': 239,
			'6513': 238,
			'6514': 238,
			'6515': 255,
			'6516': 235,
			'6517': 235,
			'6518': 234,
			'6519': 255,
			'6520': 236,
			'6521': 236,
			'6522': 235,
			'6523': 255,
			'6524': 231,
			'6525': 231,
			'6526': 229,
			'6527': 255,
			'6528': 232,
			'6529': 232,
			'6530': 230,
			'6531': 255,
			'6532': 240,
			'6533': 239,
			'6534': 239,
			'6535': 255,
			'6536': 241,
			'6537': 240,
			'6538': 240,
			'6539': 255,
			'6540': 239,
			'6541': 239,
			'6542': 239,
			'6543': 255,
			'6544': 240,
			'6545': 240,
			'6546': 240,
			'6547': 255,
			'6548': 254,
			'6549': 254,
			'6550': 253,
			'6551': 255,
			'6552': 161,
			'6553': 158,
			'6554': 156,
			'6555': 255,
			'6556': 59,
			'6557': 49,
			'6558': 49,
			'6559': 255,
			'6560': 65,
			'6561': 54,
			'6562': 53,
			'6563': 255,
			'6564': 64,
			'6565': 54,
			'6566': 54,
			'6567': 255,
			'6568': 48,
			'6569': 37,
			'6570': 37,
			'6571': 255,
			'6572': 159,
			'6573': 154,
			'6574': 153,
			'6575': 255,
			'6576': 241,
			'6577': 241,
			'6578': 240,
			'6579': 255,
			'6580': 229,
			'6581': 228,
			'6582': 226,
			'6583': 255,
			'6584': 222,
			'6585': 221,
			'6586': 219,
			'6587': 255,
			'6588': 216,
			'6589': 215,
			'6590': 213,
			'6591': 255,
			'6592': 214,
			'6593': 213,
			'6594': 211,
			'6595': 255,
			'6596': 208,
			'6597': 205,
			'6598': 204,
			'6599': 255,
			'6600': 205,
			'6601': 201,
			'6602': 200,
			'6603': 255,
			'6604': 203,
			'6605': 198,
			'6606': 197,
			'6607': 255,
			'6608': 196,
			'6609': 192,
			'6610': 191,
			'6611': 255,
			'6612': 193,
			'6613': 189,
			'6614': 188,
			'6615': 255,
			'6616': 195,
			'6617': 191,
			'6618': 190,
			'6619': 255,
			'6620': 196,
			'6621': 192,
			'6622': 191,
			'6623': 255,
			'6624': 200,
			'6625': 196,
			'6626': 195,
			'6627': 255,
			'6628': 198,
			'6629': 195,
			'6630': 194,
			'6631': 255,
			'6632': 182,
			'6633': 178,
			'6634': 177,
			'6635': 255,
			'6636': 154,
			'6637': 148,
			'6638': 148,
			'6639': 255,
			'6640': 152,
			'6641': 143,
			'6642': 144,
			'6643': 255,
			'6644': 165,
			'6645': 159,
			'6646': 158,
			'6647': 255,
			'6648': 131,
			'6649': 122,
			'6650': 123,
			'6651': 255,
			'6652': 53,
			'6653': 42,
			'6654': 42,
			'6655': 255,
			'6656': 31,
			'6657': 22,
			'6658': 19,
			'6659': 255,
			'6660': 32,
			'6661': 23,
			'6662': 24,
			'6663': 255,
			'6664': 17,
			'6665': 6,
			'6666': 6,
			'6667': 255,
			'6668': 154,
			'6669': 149,
			'6670': 147,
			'6671': 255,
			'6672': 237,
			'6673': 236,
			'6674': 234,
			'6675': 255,
			'6676': 207,
			'6677': 204,
			'6678': 203,
			'6679': 255,
			'6680': 227,
			'6681': 226,
			'6682': 224,
			'6683': 255,
			'6684': 229,
			'6685': 228,
			'6686': 226,
			'6687': 255,
			'6688': 234,
			'6689': 233,
			'6690': 231,
			'6691': 255,
			'6692': 229,
			'6693': 228,
			'6694': 226,
			'6695': 255,
			'6696': 216,
			'6697': 215,
			'6698': 213,
			'6699': 255,
			'6700': 215,
			'6701': 214,
			'6702': 212,
			'6703': 255,
			'6704': 217,
			'6705': 217,
			'6706': 215,
			'6707': 255,
			'6708': 216,
			'6709': 216,
			'6710': 214,
			'6711': 255,
			'6712': 215,
			'6713': 213,
			'6714': 211,
			'6715': 255,
			'6716': 215,
			'6717': 211,
			'6718': 210,
			'6719': 255,
			'6720': 209,
			'6721': 206,
			'6722': 205,
			'6723': 255,
			'6724': 206,
			'6725': 202,
			'6726': 201,
			'6727': 255,
			'6728': 209,
			'6729': 203,
			'6730': 203,
			'6731': 255,
			'6732': 205,
			'6733': 203,
			'6734': 202,
			'6735': 255,
			'6736': 203,
			'6737': 200,
			'6738': 198,
			'6739': 255,
			'6740': 204,
			'6741': 200,
			'6742': 199,
			'6743': 255,
			'6744': 202,
			'6745': 198,
			'6746': 197,
			'6747': 255,
			'6748': 195,
			'6749': 191,
			'6750': 190,
			'6751': 255,
			'6752': 193,
			'6753': 189,
			'6754': 188,
			'6755': 255,
			'6756': 191,
			'6757': 187,
			'6758': 186,
			'6759': 255,
			'6760': 187,
			'6761': 183,
			'6762': 182,
			'6763': 255,
			'6764': 186,
			'6765': 182,
			'6766': 181,
			'6767': 255,
			'6768': 185,
			'6769': 181,
			'6770': 180,
			'6771': 255,
			'6772': 175,
			'6773': 171,
			'6774': 170,
			'6775': 255,
			'6776': 174,
			'6777': 170,
			'6778': 168,
			'6779': 255,
			'6780': 178,
			'6781': 174,
			'6782': 174,
			'6783': 255,
			'6784': 178,
			'6785': 175,
			'6786': 173,
			'6787': 255,
			'6788': 175,
			'6789': 171,
			'6790': 168,
			'6791': 255,
			'6792': 169,
			'6793': 165,
			'6794': 163,
			'6795': 255,
			'6796': 169,
			'6797': 165,
			'6798': 164,
			'6799': 255,
			'6800': 223,
			'6801': 222,
			'6802': 220,
			'6803': 255,
			'6804': 227,
			'6805': 226,
			'6806': 224,
			'6807': 255,
			'6808': 228,
			'6809': 227,
			'6810': 225,
			'6811': 255,
			'6812': 226,
			'6813': 226,
			'6814': 224,
			'6815': 255,
			'6816': 228,
			'6817': 228,
			'6818': 226,
			'6819': 255,
			'6820': 226,
			'6821': 225,
			'6822': 223,
			'6823': 255,
			'6824': 231,
			'6825': 229,
			'6826': 227,
			'6827': 255,
			'6828': 228,
			'6829': 227,
			'6830': 225,
			'6831': 255,
			'6832': 230,
			'6833': 229,
			'6834': 227,
			'6835': 255,
			'6836': 228,
			'6837': 227,
			'6838': 225,
			'6839': 255,
			'6840': 230,
			'6841': 230,
			'6842': 228,
			'6843': 255,
			'6844': 233,
			'6845': 232,
			'6846': 230,
			'6847': 255,
			'6848': 234,
			'6849': 233,
			'6850': 231,
			'6851': 255,
			'6852': 236,
			'6853': 236,
			'6854': 236,
			'6855': 255,
			'6856': 235,
			'6857': 235,
			'6858': 234,
			'6859': 255,
			'6860': 232,
			'6861': 232,
			'6862': 230,
			'6863': 255,
			'6864': 237,
			'6865': 237,
			'6866': 236,
			'6867': 255,
			'6868': 238,
			'6869': 239,
			'6870': 238,
			'6871': 255,
			'6872': 235,
			'6873': 235,
			'6874': 233,
			'6875': 255,
			'6876': 234,
			'6877': 234,
			'6878': 233,
			'6879': 255,
			'6880': 237,
			'6881': 237,
			'6882': 237,
			'6883': 255,
			'6884': 237,
			'6885': 237,
			'6886': 237,
			'6887': 255,
			'6888': 238,
			'6889': 238,
			'6890': 238,
			'6891': 255,
			'6892': 237,
			'6893': 237,
			'6894': 236,
			'6895': 255,
			'6896': 236,
			'6897': 237,
			'6898': 236,
			'6899': 255,
			'6900': 239,
			'6901': 239,
			'6902': 239,
			'6903': 255,
			'6904': 238,
			'6905': 238,
			'6906': 238,
			'6907': 255,
			'6908': 239,
			'6909': 238,
			'6910': 238,
			'6911': 255,
			'6912': 236,
			'6913': 236,
			'6914': 236,
			'6915': 255,
			'6916': 233,
			'6917': 233,
			'6918': 232,
			'6919': 255,
			'6920': 234,
			'6921': 234,
			'6922': 233,
			'6923': 255,
			'6924': 236,
			'6925': 236,
			'6926': 235,
			'6927': 255,
			'6928': 234,
			'6929': 234,
			'6930': 232,
			'6931': 255,
			'6932': 236,
			'6933': 236,
			'6934': 236,
			'6935': 255,
			'6936': 237,
			'6937': 238,
			'6938': 238,
			'6939': 255,
			'6940': 235,
			'6941': 235,
			'6942': 235,
			'6943': 255,
			'6944': 240,
			'6945': 241,
			'6946': 240,
			'6947': 255,
			'6948': 255,
			'6949': 255,
			'6950': 255,
			'6951': 255,
			'6952': 137,
			'6953': 133,
			'6954': 132,
			'6955': 255,
			'6956': 45,
			'6957': 34,
			'6958': 33,
			'6959': 255,
			'6960': 78,
			'6961': 68,
			'6962': 67,
			'6963': 255,
			'6964': 52,
			'6965': 41,
			'6966': 40,
			'6967': 255,
			'6968': 88,
			'6969': 79,
			'6970': 78,
			'6971': 255,
			'6972': 208,
			'6973': 205,
			'6974': 203,
			'6975': 255,
			'6976': 228,
			'6977': 228,
			'6978': 226,
			'6979': 255,
			'6980': 229,
			'6981': 228,
			'6982': 226,
			'6983': 255,
			'6984': 223,
			'6985': 222,
			'6986': 220,
			'6987': 255,
			'6988': 221,
			'6989': 220,
			'6990': 218,
			'6991': 255,
			'6992': 220,
			'6993': 219,
			'6994': 217,
			'6995': 255,
			'6996': 213,
			'6997': 213,
			'6998': 211,
			'6999': 255,
			'7000': 208,
			'7001': 207,
			'7002': 205,
			'7003': 255,
			'7004': 204,
			'7005': 200,
			'7006': 199,
			'7007': 255,
			'7008': 200,
			'7009': 195,
			'7010': 194,
			'7011': 255,
			'7012': 197,
			'7013': 193,
			'7014': 192,
			'7015': 255,
			'7016': 195,
			'7017': 191,
			'7018': 190,
			'7019': 255,
			'7020': 197,
			'7021': 193,
			'7022': 192,
			'7023': 255,
			'7024': 199,
			'7025': 195,
			'7026': 194,
			'7027': 255,
			'7028': 198,
			'7029': 194,
			'7030': 193,
			'7031': 255,
			'7032': 195,
			'7033': 192,
			'7034': 190,
			'7035': 255,
			'7036': 190,
			'7037': 186,
			'7038': 185,
			'7039': 255,
			'7040': 184,
			'7041': 181,
			'7042': 179,
			'7043': 255,
			'7044': 191,
			'7045': 189,
			'7046': 187,
			'7047': 255,
			'7048': 172,
			'7049': 167,
			'7050': 167,
			'7051': 255,
			'7052': 106,
			'7053': 95,
			'7054': 96,
			'7055': 255,
			'7056': 44,
			'7057': 34,
			'7058': 33,
			'7059': 255,
			'7060': 33,
			'7061': 24,
			'7062': 23,
			'7063': 255,
			'7064': 9,
			'7065': 0,
			'7066': 0,
			'7067': 255,
			'7068': 71,
			'7069': 63,
			'7070': 62,
			'7071': 255,
			'7072': 213,
			'7073': 211,
			'7074': 210,
			'7075': 255,
			'7076': 221,
			'7077': 220,
			'7078': 218,
			'7079': 255,
			'7080': 218,
			'7081': 217,
			'7082': 215,
			'7083': 255,
			'7084': 215,
			'7085': 213,
			'7086': 211,
			'7087': 255,
			'7088': 224,
			'7089': 223,
			'7090': 221,
			'7091': 255,
			'7092': 229,
			'7093': 228,
			'7094': 226,
			'7095': 255,
			'7096': 220,
			'7097': 219,
			'7098': 217,
			'7099': 255,
			'7100': 213,
			'7101': 212,
			'7102': 210,
			'7103': 255,
			'7104': 212,
			'7105': 210,
			'7106': 208,
			'7107': 255,
			'7108': 212,
			'7109': 211,
			'7110': 209,
			'7111': 255,
			'7112': 214,
			'7113': 211,
			'7114': 210,
			'7115': 255,
			'7116': 213,
			'7117': 210,
			'7118': 209,
			'7119': 255,
			'7120': 208,
			'7121': 204,
			'7122': 203,
			'7123': 255,
			'7124': 208,
			'7125': 205,
			'7126': 203,
			'7127': 255,
			'7128': 209,
			'7129': 206,
			'7130': 205,
			'7131': 255,
			'7132': 204,
			'7133': 202,
			'7134': 200,
			'7135': 255,
			'7136': 204,
			'7137': 201,
			'7138': 200,
			'7139': 255,
			'7140': 202,
			'7141': 198,
			'7142': 197,
			'7143': 255,
			'7144': 194,
			'7145': 190,
			'7146': 189,
			'7147': 255,
			'7148': 196,
			'7149': 192,
			'7150': 191,
			'7151': 255,
			'7152': 189,
			'7153': 185,
			'7154': 184,
			'7155': 255,
			'7156': 188,
			'7157': 184,
			'7158': 183,
			'7159': 255,
			'7160': 187,
			'7161': 183,
			'7162': 182,
			'7163': 255,
			'7164': 185,
			'7165': 181,
			'7166': 180,
			'7167': 255,
			'7168': 178,
			'7169': 174,
			'7170': 173,
			'7171': 255,
			'7172': 175,
			'7173': 171,
			'7174': 170,
			'7175': 255,
			'7176': 175,
			'7177': 171,
			'7178': 171,
			'7179': 255,
			'7180': 174,
			'7181': 170,
			'7182': 168,
			'7183': 255,
			'7184': 175,
			'7185': 171,
			'7186': 169,
			'7187': 255,
			'7188': 170,
			'7189': 166,
			'7190': 164,
			'7191': 255,
			'7192': 167,
			'7193': 163,
			'7194': 163,
			'7195': 255,
			'7196': 171,
			'7197': 168,
			'7198': 167,
			'7199': 255,
			'7200': 210,
			'7201': 209,
			'7202': 208,
			'7203': 255,
			'7204': 218,
			'7205': 217,
			'7206': 215,
			'7207': 255,
			'7208': 226,
			'7209': 225,
			'7210': 223,
			'7211': 255,
			'7212': 225,
			'7213': 225,
			'7214': 223,
			'7215': 255,
			'7216': 224,
			'7217': 224,
			'7218': 222,
			'7219': 255,
			'7220': 226,
			'7221': 225,
			'7222': 223,
			'7223': 255,
			'7224': 224,
			'7225': 223,
			'7226': 221,
			'7227': 255,
			'7228': 228,
			'7229': 227,
			'7230': 225,
			'7231': 255,
			'7232': 231,
			'7233': 231,
			'7234': 229,
			'7235': 255,
			'7236': 230,
			'7237': 230,
			'7238': 228,
			'7239': 255,
			'7240': 232,
			'7241': 231,
			'7242': 229,
			'7243': 255,
			'7244': 232,
			'7245': 232,
			'7246': 230,
			'7247': 255,
			'7248': 233,
			'7249': 233,
			'7250': 231,
			'7251': 255,
			'7252': 234,
			'7253': 234,
			'7254': 232,
			'7255': 255,
			'7256': 235,
			'7257': 235,
			'7258': 234,
			'7259': 255,
			'7260': 230,
			'7261': 230,
			'7262': 228,
			'7263': 255,
			'7264': 234,
			'7265': 234,
			'7266': 233,
			'7267': 255,
			'7268': 238,
			'7269': 238,
			'7270': 238,
			'7271': 255,
			'7272': 238,
			'7273': 238,
			'7274': 237,
			'7275': 255,
			'7276': 238,
			'7277': 238,
			'7278': 237,
			'7279': 255,
			'7280': 238,
			'7281': 238,
			'7282': 238,
			'7283': 255,
			'7284': 237,
			'7285': 237,
			'7286': 237,
			'7287': 255,
			'7288': 238,
			'7289': 238,
			'7290': 238,
			'7291': 255,
			'7292': 237,
			'7293': 237,
			'7294': 237,
			'7295': 255,
			'7296': 235,
			'7297': 235,
			'7298': 235,
			'7299': 255,
			'7300': 236,
			'7301': 236,
			'7302': 237,
			'7303': 255,
			'7304': 239,
			'7305': 239,
			'7306': 240,
			'7307': 255,
			'7308': 242,
			'7309': 240,
			'7310': 240,
			'7311': 255,
			'7312': 237,
			'7313': 237,
			'7314': 237,
			'7315': 255,
			'7316': 237,
			'7317': 237,
			'7318': 237,
			'7319': 255,
			'7320': 236,
			'7321': 235,
			'7322': 234,
			'7323': 255,
			'7324': 239,
			'7325': 238,
			'7326': 238,
			'7327': 255,
			'7328': 241,
			'7329': 240,
			'7330': 240,
			'7331': 255,
			'7332': 240,
			'7333': 240,
			'7334': 241,
			'7335': 255,
			'7336': 233,
			'7337': 233,
			'7338': 232,
			'7339': 255,
			'7340': 230,
			'7341': 230,
			'7342': 228,
			'7343': 255,
			'7344': 252,
			'7345': 252,
			'7346': 252,
			'7347': 255,
			'7348': 236,
			'7349': 236,
			'7350': 235,
			'7351': 255,
			'7352': 105,
			'7353': 96,
			'7354': 97,
			'7355': 255,
			'7356': 54,
			'7357': 43,
			'7358': 43,
			'7359': 255,
			'7360': 86,
			'7361': 76,
			'7362': 76,
			'7363': 255,
			'7364': 78,
			'7365': 67,
			'7366': 67,
			'7367': 255,
			'7368': 140,
			'7369': 133,
			'7370': 133,
			'7371': 255,
			'7372': 216,
			'7373': 215,
			'7374': 213,
			'7375': 255,
			'7376': 221,
			'7377': 220,
			'7378': 217,
			'7379': 255,
			'7380': 231,
			'7381': 230,
			'7382': 228,
			'7383': 255,
			'7384': 227,
			'7385': 226,
			'7386': 224,
			'7387': 255,
			'7388': 223,
			'7389': 222,
			'7390': 220,
			'7391': 255,
			'7392': 221,
			'7393': 220,
			'7394': 218,
			'7395': 255,
			'7396': 218,
			'7397': 216,
			'7398': 214,
			'7399': 255,
			'7400': 212,
			'7401': 209,
			'7402': 208,
			'7403': 255,
			'7404': 204,
			'7405': 200,
			'7406': 199,
			'7407': 255,
			'7408': 198,
			'7409': 194,
			'7410': 193,
			'7411': 255,
			'7412': 196,
			'7413': 192,
			'7414': 191,
			'7415': 255,
			'7416': 193,
			'7417': 189,
			'7418': 188,
			'7419': 255,
			'7420': 194,
			'7421': 190,
			'7422': 189,
			'7423': 255,
			'7424': 195,
			'7425': 191,
			'7426': 190,
			'7427': 255,
			'7428': 194,
			'7429': 190,
			'7430': 189,
			'7431': 255,
			'7432': 197,
			'7433': 193,
			'7434': 192,
			'7435': 255,
			'7436': 192,
			'7437': 188,
			'7438': 187,
			'7439': 255,
			'7440': 184,
			'7441': 180,
			'7442': 179,
			'7443': 255,
			'7444': 187,
			'7445': 184,
			'7446': 183,
			'7447': 255,
			'7448': 184,
			'7449': 180,
			'7450': 179,
			'7451': 255,
			'7452': 177,
			'7453': 171,
			'7454': 171,
			'7455': 255,
			'7456': 81,
			'7457': 71,
			'7458': 72,
			'7459': 255,
			'7460': 32,
			'7461': 21,
			'7462': 20,
			'7463': 255,
			'7464': 30,
			'7465': 19,
			'7466': 18,
			'7467': 255,
			'7468': 111,
			'7469': 105,
			'7470': 103,
			'7471': 255,
			'7472': 242,
			'7473': 241,
			'7474': 240,
			'7475': 255,
			'7476': 227,
			'7477': 226,
			'7478': 224,
			'7479': 255,
			'7480': 220,
			'7481': 219,
			'7482': 217,
			'7483': 255,
			'7484': 217,
			'7485': 216,
			'7486': 214,
			'7487': 255,
			'7488': 212,
			'7489': 211,
			'7490': 209,
			'7491': 255,
			'7492': 215,
			'7493': 213,
			'7494': 211,
			'7495': 255,
			'7496': 222,
			'7497': 221,
			'7498': 219,
			'7499': 255,
			'7500': 217,
			'7501': 216,
			'7502': 214,
			'7503': 255,
			'7504': 212,
			'7505': 211,
			'7506': 209,
			'7507': 255,
			'7508': 209,
			'7509': 206,
			'7510': 205,
			'7511': 255,
			'7512': 206,
			'7513': 204,
			'7514': 202,
			'7515': 255,
			'7516': 206,
			'7517': 204,
			'7518': 202,
			'7519': 255,
			'7520': 207,
			'7521': 205,
			'7522': 203,
			'7523': 255,
			'7524': 209,
			'7525': 206,
			'7526': 205,
			'7527': 255,
			'7528': 206,
			'7529': 206,
			'7530': 203,
			'7531': 255,
			'7532': 203,
			'7533': 200,
			'7534': 198,
			'7535': 255,
			'7536': 202,
			'7537': 198,
			'7538': 197,
			'7539': 255,
			'7540': 196,
			'7541': 192,
			'7542': 191,
			'7543': 255,
			'7544': 196,
			'7545': 192,
			'7546': 191,
			'7547': 255,
			'7548': 193,
			'7549': 189,
			'7550': 188,
			'7551': 255,
			'7552': 183,
			'7553': 179,
			'7554': 178,
			'7555': 255,
			'7556': 187,
			'7557': 183,
			'7558': 182,
			'7559': 255,
			'7560': 188,
			'7561': 184,
			'7562': 183,
			'7563': 255,
			'7564': 182,
			'7565': 178,
			'7566': 177,
			'7567': 255,
			'7568': 178,
			'7569': 174,
			'7570': 173,
			'7571': 255,
			'7572': 180,
			'7573': 176,
			'7574': 175,
			'7575': 255,
			'7576': 178,
			'7577': 174,
			'7578': 174,
			'7579': 255,
			'7580': 177,
			'7581': 173,
			'7582': 170,
			'7583': 255,
			'7584': 171,
			'7585': 167,
			'7586': 164,
			'7587': 255,
			'7588': 167,
			'7589': 163,
			'7590': 162,
			'7591': 255,
			'7592': 163,
			'7593': 160,
			'7594': 159,
			'7595': 255,
			'7596': 163,
			'7597': 158,
			'7598': 158,
			'7599': 255,
			'7600': 218,
			'7601': 217,
			'7602': 215,
			'7603': 255,
			'7604': 212,
			'7605': 211,
			'7606': 209,
			'7607': 255,
			'7608': 217,
			'7609': 216,
			'7610': 214,
			'7611': 255,
			'7612': 225,
			'7613': 224,
			'7614': 222,
			'7615': 255,
			'7616': 221,
			'7617': 220,
			'7618': 218,
			'7619': 255,
			'7620': 223,
			'7621': 222,
			'7622': 220,
			'7623': 255,
			'7624': 220,
			'7625': 219,
			'7626': 217,
			'7627': 255,
			'7628': 217,
			'7629': 216,
			'7630': 214,
			'7631': 255,
			'7632': 223,
			'7633': 222,
			'7634': 220,
			'7635': 255,
			'7636': 225,
			'7637': 223,
			'7638': 221,
			'7639': 255,
			'7640': 223,
			'7641': 222,
			'7642': 220,
			'7643': 255,
			'7644': 221,
			'7645': 220,
			'7646': 218,
			'7647': 255,
			'7648': 222,
			'7649': 222,
			'7650': 220,
			'7651': 255,
			'7652': 228,
			'7653': 227,
			'7654': 225,
			'7655': 255,
			'7656': 231,
			'7657': 230,
			'7658': 227,
			'7659': 255,
			'7660': 231,
			'7661': 231,
			'7662': 228,
			'7663': 255,
			'7664': 231,
			'7665': 231,
			'7666': 229,
			'7667': 255,
			'7668': 236,
			'7669': 236,
			'7670': 235,
			'7671': 255,
			'7672': 235,
			'7673': 235,
			'7674': 234,
			'7675': 255,
			'7676': 235,
			'7677': 235,
			'7678': 235,
			'7679': 255,
			'7680': 236,
			'7681': 236,
			'7682': 236,
			'7683': 255,
			'7684': 235,
			'7685': 235,
			'7686': 233,
			'7687': 255,
			'7688': 234,
			'7689': 234,
			'7690': 234,
			'7691': 255,
			'7692': 239,
			'7693': 239,
			'7694': 239,
			'7695': 255,
			'7696': 236,
			'7697': 236,
			'7698': 236,
			'7699': 255,
			'7700': 229,
			'7701': 229,
			'7702': 228,
			'7703': 255,
			'7704': 234,
			'7705': 234,
			'7706': 233,
			'7707': 255,
			'7708': 238,
			'7709': 237,
			'7710': 236,
			'7711': 255,
			'7712': 234,
			'7713': 234,
			'7714': 234,
			'7715': 255,
			'7716': 234,
			'7717': 234,
			'7718': 233,
			'7719': 255,
			'7720': 230,
			'7721': 230,
			'7722': 228,
			'7723': 255,
			'7724': 227,
			'7725': 226,
			'7726': 224,
			'7727': 255,
			'7728': 233,
			'7729': 232,
			'7730': 231,
			'7731': 255,
			'7732': 234,
			'7733': 234,
			'7734': 232,
			'7735': 255,
			'7736': 234,
			'7737': 233,
			'7738': 231,
			'7739': 255,
			'7740': 229,
			'7741': 228,
			'7742': 226,
			'7743': 255,
			'7744': 251,
			'7745': 251,
			'7746': 250,
			'7747': 255,
			'7748': 183,
			'7749': 179,
			'7750': 178,
			'7751': 255,
			'7752': 50,
			'7753': 38,
			'7754': 39,
			'7755': 255,
			'7756': 49,
			'7757': 39,
			'7758': 39,
			'7759': 255,
			'7760': 94,
			'7761': 83,
			'7762': 84,
			'7763': 255,
			'7764': 138,
			'7765': 129,
			'7766': 130,
			'7767': 255,
			'7768': 171,
			'7769': 166,
			'7770': 166,
			'7771': 255,
			'7772': 209,
			'7773': 209,
			'7774': 206,
			'7775': 255,
			'7776': 224,
			'7777': 223,
			'7778': 221,
			'7779': 255,
			'7780': 231,
			'7781': 231,
			'7782': 229,
			'7783': 255,
			'7784': 229,
			'7785': 228,
			'7786': 226,
			'7787': 255,
			'7788': 220,
			'7789': 219,
			'7790': 217,
			'7791': 255,
			'7792': 218,
			'7793': 217,
			'7794': 215,
			'7795': 255,
			'7796': 213,
			'7797': 210,
			'7798': 209,
			'7799': 255,
			'7800': 208,
			'7801': 203,
			'7802': 203,
			'7803': 255,
			'7804': 203,
			'7805': 199,
			'7806': 198,
			'7807': 255,
			'7808': 196,
			'7809': 192,
			'7810': 191,
			'7811': 255,
			'7812': 192,
			'7813': 188,
			'7814': 187,
			'7815': 255,
			'7816': 189,
			'7817': 185,
			'7818': 184,
			'7819': 255,
			'7820': 191,
			'7821': 187,
			'7822': 186,
			'7823': 255,
			'7824': 193,
			'7825': 189,
			'7826': 188,
			'7827': 255,
			'7828': 189,
			'7829': 185,
			'7830': 184,
			'7831': 255,
			'7832': 187,
			'7833': 183,
			'7834': 182,
			'7835': 255,
			'7836': 184,
			'7837': 180,
			'7838': 179,
			'7839': 255,
			'7840': 181,
			'7841': 177,
			'7842': 176,
			'7843': 255,
			'7844': 184,
			'7845': 180,
			'7846': 179,
			'7847': 255,
			'7848': 188,
			'7849': 185,
			'7850': 184,
			'7851': 255,
			'7852': 192,
			'7853': 189,
			'7854': 188,
			'7855': 255,
			'7856': 125,
			'7857': 116,
			'7858': 117,
			'7859': 255,
			'7860': 57,
			'7861': 46,
			'7862': 45,
			'7863': 255,
			'7864': 44,
			'7865': 32,
			'7866': 31,
			'7867': 255,
			'7868': 96,
			'7869': 88,
			'7870': 88,
			'7871': 255,
			'7872': 236,
			'7873': 236,
			'7874': 234,
			'7875': 255,
			'7876': 233,
			'7877': 232,
			'7878': 230,
			'7879': 255,
			'7880': 224,
			'7881': 223,
			'7882': 221,
			'7883': 255,
			'7884': 224,
			'7885': 223,
			'7886': 221,
			'7887': 255,
			'7888': 219,
			'7889': 218,
			'7890': 216,
			'7891': 255,
			'7892': 216,
			'7893': 215,
			'7894': 213,
			'7895': 255,
			'7896': 218,
			'7897': 217,
			'7898': 215,
			'7899': 255,
			'7900': 217,
			'7901': 216,
			'7902': 214,
			'7903': 255,
			'7904': 217,
			'7905': 216,
			'7906': 214,
			'7907': 255,
			'7908': 215,
			'7909': 212,
			'7910': 211,
			'7911': 255,
			'7912': 212,
			'7913': 210,
			'7914': 208,
			'7915': 255,
			'7916': 209,
			'7917': 208,
			'7918': 206,
			'7919': 255,
			'7920': 207,
			'7921': 206,
			'7922': 204,
			'7923': 255,
			'7924': 209,
			'7925': 207,
			'7926': 206,
			'7927': 255,
			'7928': 209,
			'7929': 205,
			'7930': 204,
			'7931': 255,
			'7932': 208,
			'7933': 204,
			'7934': 203,
			'7935': 255,
			'7936': 205,
			'7937': 200,
			'7938': 199,
			'7939': 255,
			'7940': 199,
			'7941': 194,
			'7942': 194,
			'7943': 255,
			'7944': 194,
			'7945': 190,
			'7946': 189,
			'7947': 255,
			'7948': 184,
			'7949': 180,
			'7950': 179,
			'7951': 255,
			'7952': 187,
			'7953': 183,
			'7954': 182,
			'7955': 255,
			'7956': 193,
			'7957': 189,
			'7958': 188,
			'7959': 255,
			'7960': 188,
			'7961': 184,
			'7962': 183,
			'7963': 255,
			'7964': 181,
			'7965': 177,
			'7966': 176,
			'7967': 255,
			'7968': 180,
			'7969': 177,
			'7970': 176,
			'7971': 255,
			'7972': 178,
			'7973': 176,
			'7974': 175,
			'7975': 255,
			'7976': 178,
			'7977': 175,
			'7978': 174,
			'7979': 255,
			'7980': 178,
			'7981': 174,
			'7982': 173,
			'7983': 255,
			'7984': 173,
			'7985': 169,
			'7986': 167,
			'7987': 255,
			'7988': 171,
			'7989': 167,
			'7990': 165,
			'7991': 255,
			'7992': 166,
			'7993': 164,
			'7994': 162,
			'7995': 255,
			'7996': 167,
			'7997': 163,
			'7998': 162,
			'7999': 255,
			'8000': 227,
			'8001': 227,
			'8002': 225,
			'8003': 255,
			'8004': 220,
			'8005': 219,
			'8006': 217,
			'8007': 255,
			'8008': 211,
			'8009': 209,
			'8010': 207,
			'8011': 255,
			'8012': 226,
			'8013': 225,
			'8014': 223,
			'8015': 255,
			'8016': 227,
			'8017': 227,
			'8018': 226,
			'8019': 255,
			'8020': 228,
			'8021': 227,
			'8022': 225,
			'8023': 255,
			'8024': 231,
			'8025': 230,
			'8026': 227,
			'8027': 255,
			'8028': 222,
			'8029': 221,
			'8030': 219,
			'8031': 255,
			'8032': 223,
			'8033': 222,
			'8034': 220,
			'8035': 255,
			'8036': 228,
			'8037': 226,
			'8038': 225,
			'8039': 255,
			'8040': 225,
			'8041': 225,
			'8042': 223,
			'8043': 255,
			'8044': 228,
			'8045': 228,
			'8046': 225,
			'8047': 255,
			'8048': 206,
			'8049': 203,
			'8050': 202,
			'8051': 255,
			'8052': 216,
			'8053': 215,
			'8054': 213,
			'8055': 255,
			'8056': 229,
			'8057': 228,
			'8058': 226,
			'8059': 255,
			'8060': 226,
			'8061': 225,
			'8062': 223,
			'8063': 255,
			'8064': 224,
			'8065': 223,
			'8066': 221,
			'8067': 255,
			'8068': 227,
			'8069': 226,
			'8070': 224,
			'8071': 255,
			'8072': 234,
			'8073': 234,
			'8074': 232,
			'8075': 255,
			'8076': 234,
			'8077': 234,
			'8078': 232,
			'8079': 255,
			'8080': 234,
			'8081': 234,
			'8082': 231,
			'8083': 255,
			'8084': 234,
			'8085': 234,
			'8086': 232,
			'8087': 255,
			'8088': 236,
			'8089': 237,
			'8090': 236,
			'8091': 255,
			'8092': 229,
			'8093': 228,
			'8094': 227,
			'8095': 255,
			'8096': 227,
			'8097': 227,
			'8098': 224,
			'8099': 255,
			'8100': 237,
			'8101': 238,
			'8102': 235,
			'8103': 255,
			'8104': 231,
			'8105': 231,
			'8106': 229,
			'8107': 255,
			'8108': 232,
			'8109': 232,
			'8110': 230,
			'8111': 255,
			'8112': 237,
			'8113': 237,
			'8114': 235,
			'8115': 255,
			'8116': 232,
			'8117': 231,
			'8118': 231,
			'8119': 255,
			'8120': 231,
			'8121': 231,
			'8122': 230,
			'8123': 255,
			'8124': 232,
			'8125': 231,
			'8126': 229,
			'8127': 255,
			'8128': 227,
			'8129': 227,
			'8130': 225,
			'8131': 255,
			'8132': 223,
			'8133': 222,
			'8134': 220,
			'8135': 255,
			'8136': 229,
			'8137': 229,
			'8138': 226,
			'8139': 255,
			'8140': 234,
			'8141': 233,
			'8142': 231,
			'8143': 255,
			'8144': 244,
			'8145': 245,
			'8146': 242,
			'8147': 255,
			'8148': 164,
			'8149': 159,
			'8150': 158,
			'8151': 255,
			'8152': 46,
			'8153': 34,
			'8154': 35,
			'8155': 255,
			'8156': 55,
			'8157': 44,
			'8158': 44,
			'8159': 255,
			'8160': 105,
			'8161': 95,
			'8162': 96,
			'8163': 255,
			'8164': 174,
			'8165': 169,
			'8166': 169,
			'8167': 255,
			'8168': 191,
			'8169': 188,
			'8170': 187,
			'8171': 255,
			'8172': 221,
			'8173': 219,
			'8174': 217,
			'8175': 255,
			'8176': 230,
			'8177': 230,
			'8178': 228,
			'8179': 255,
			'8180': 231,
			'8181': 230,
			'8182': 228,
			'8183': 255,
			'8184': 229,
			'8185': 228,
			'8186': 226,
			'8187': 255,
			'8188': 220,
			'8189': 219,
			'8190': 218,
			'8191': 255,
			'8192': 215,
			'8193': 214,
			'8194': 212,
			'8195': 255,
			'8196': 206,
			'8197': 203,
			'8198': 202,
			'8199': 255,
			'8200': 198,
			'8201': 194,
			'8202': 192,
			'8203': 255,
			'8204': 192,
			'8205': 188,
			'8206': 187,
			'8207': 255,
			'8208': 189,
			'8209': 185,
			'8210': 184,
			'8211': 255,
			'8212': 187,
			'8213': 183,
			'8214': 182,
			'8215': 255,
			'8216': 185,
			'8217': 181,
			'8218': 180,
			'8219': 255,
			'8220': 188,
			'8221': 184,
			'8222': 183,
			'8223': 255,
			'8224': 191,
			'8225': 187,
			'8226': 186,
			'8227': 255,
			'8228': 188,
			'8229': 184,
			'8230': 183,
			'8231': 255,
			'8232': 181,
			'8233': 177,
			'8234': 176,
			'8235': 255,
			'8236': 178,
			'8237': 174,
			'8238': 173,
			'8239': 255,
			'8240': 182,
			'8241': 178,
			'8242': 177,
			'8243': 255,
			'8244': 185,
			'8245': 181,
			'8246': 180,
			'8247': 255,
			'8248': 186,
			'8249': 182,
			'8250': 181,
			'8251': 255,
			'8252': 190,
			'8253': 186,
			'8254': 186,
			'8255': 255,
			'8256': 150,
			'8257': 143,
			'8258': 143,
			'8259': 255,
			'8260': 85,
			'8261': 75,
			'8262': 74,
			'8263': 255,
			'8264': 45,
			'8265': 34,
			'8266': 34,
			'8267': 255,
			'8268': 71,
			'8269': 62,
			'8270': 61,
			'8271': 255,
			'8272': 216,
			'8273': 214,
			'8274': 212,
			'8275': 255,
			'8276': 233,
			'8277': 233,
			'8278': 231,
			'8279': 255,
			'8280': 219,
			'8281': 218,
			'8282': 216,
			'8283': 255,
			'8284': 217,
			'8285': 217,
			'8286': 214,
			'8287': 255,
			'8288': 218,
			'8289': 217,
			'8290': 215,
			'8291': 255,
			'8292': 217,
			'8293': 216,
			'8294': 214,
			'8295': 255,
			'8296': 214,
			'8297': 213,
			'8298': 211,
			'8299': 255,
			'8300': 214,
			'8301': 213,
			'8302': 211,
			'8303': 255,
			'8304': 213,
			'8305': 211,
			'8306': 209,
			'8307': 255,
			'8308': 212,
			'8309': 210,
			'8310': 208,
			'8311': 255,
			'8312': 213,
			'8313': 209,
			'8314': 208,
			'8315': 255,
			'8316': 209,
			'8317': 207,
			'8318': 205,
			'8319': 255,
			'8320': 211,
			'8321': 209,
			'8322': 207,
			'8323': 255,
			'8324': 210,
			'8325': 207,
			'8326': 206,
			'8327': 255,
			'8328': 206,
			'8329': 201,
			'8330': 200,
			'8331': 255,
			'8332': 200,
			'8333': 195,
			'8334': 195,
			'8335': 255,
			'8336': 197,
			'8337': 193,
			'8338': 192,
			'8339': 255,
			'8340': 200,
			'8341': 196,
			'8342': 195,
			'8343': 255,
			'8344': 199,
			'8345': 195,
			'8346': 194,
			'8347': 255,
			'8348': 190,
			'8349': 187,
			'8350': 185,
			'8351': 255,
			'8352': 186,
			'8353': 182,
			'8354': 181,
			'8355': 255,
			'8356': 182,
			'8357': 178,
			'8358': 177,
			'8359': 255,
			'8360': 186,
			'8361': 182,
			'8362': 181,
			'8363': 255,
			'8364': 183,
			'8365': 179,
			'8366': 178,
			'8367': 255,
			'8368': 175,
			'8369': 171,
			'8370': 170,
			'8371': 255,
			'8372': 174,
			'8373': 171,
			'8374': 170,
			'8375': 255,
			'8376': 175,
			'8377': 172,
			'8378': 170,
			'8379': 255,
			'8380': 172,
			'8381': 168,
			'8382': 167,
			'8383': 255,
			'8384': 172,
			'8385': 169,
			'8386': 166,
			'8387': 255,
			'8388': 166,
			'8389': 162,
			'8390': 162,
			'8391': 255,
			'8392': 160,
			'8393': 155,
			'8394': 155,
			'8395': 255,
			'8396': 164,
			'8397': 159,
			'8398': 159,
			'8399': 255,
			'8400': 226,
			'8401': 225,
			'8402': 223,
			'8403': 255,
			'8404': 226,
			'8405': 225,
			'8406': 223,
			'8407': 255,
			'8408': 223,
			'8409': 222,
			'8410': 220,
			'8411': 255,
			'8412': 226,
			'8413': 225,
			'8414': 223,
			'8415': 255,
			'8416': 226,
			'8417': 226,
			'8418': 225,
			'8419': 255,
			'8420': 228,
			'8421': 227,
			'8422': 225,
			'8423': 255,
			'8424': 229,
			'8425': 227,
			'8426': 228,
			'8427': 255,
			'8428': 229,
			'8429': 228,
			'8430': 226,
			'8431': 255,
			'8432': 229,
			'8433': 228,
			'8434': 225,
			'8435': 255,
			'8436': 232,
			'8437': 231,
			'8438': 230,
			'8439': 255,
			'8440': 232,
			'8441': 231,
			'8442': 229,
			'8443': 255,
			'8444': 242,
			'8445': 242,
			'8446': 240,
			'8447': 255,
			'8448': 204,
			'8449': 201,
			'8450': 200,
			'8451': 255,
			'8452': 207,
			'8453': 204,
			'8454': 202,
			'8455': 255,
			'8456': 234,
			'8457': 233,
			'8458': 231,
			'8459': 255,
			'8460': 231,
			'8461': 231,
			'8462': 228,
			'8463': 255,
			'8464': 226,
			'8465': 226,
			'8466': 224,
			'8467': 255,
			'8468': 221,
			'8469': 220,
			'8470': 218,
			'8471': 255,
			'8472': 237,
			'8473': 237,
			'8474': 236,
			'8475': 255,
			'8476': 238,
			'8477': 239,
			'8478': 239,
			'8479': 255,
			'8480': 237,
			'8481': 237,
			'8482': 236,
			'8483': 255,
			'8484': 237,
			'8485': 237,
			'8486': 238,
			'8487': 255,
			'8488': 241,
			'8489': 241,
			'8490': 241,
			'8491': 255,
			'8492': 229,
			'8493': 227,
			'8494': 227,
			'8495': 255,
			'8496': 222,
			'8497': 221,
			'8498': 218,
			'8499': 255,
			'8500': 243,
			'8501': 243,
			'8502': 243,
			'8503': 255,
			'8504': 239,
			'8505': 239,
			'8506': 238,
			'8507': 255,
			'8508': 235,
			'8509': 235,
			'8510': 233,
			'8511': 255,
			'8512': 240,
			'8513': 239,
			'8514': 238,
			'8515': 255,
			'8516': 240,
			'8517': 240,
			'8518': 240,
			'8519': 255,
			'8520': 239,
			'8521': 239,
			'8522': 239,
			'8523': 255,
			'8524': 240,
			'8525': 240,
			'8526': 240,
			'8527': 255,
			'8528': 240,
			'8529': 240,
			'8530': 240,
			'8531': 255,
			'8532': 237,
			'8533': 237,
			'8534': 237,
			'8535': 255,
			'8536': 235,
			'8537': 235,
			'8538': 234,
			'8539': 255,
			'8540': 238,
			'8541': 238,
			'8542': 238,
			'8543': 255,
			'8544': 255,
			'8545': 255,
			'8546': 255,
			'8547': 255,
			'8548': 188,
			'8549': 184,
			'8550': 184,
			'8551': 255,
			'8552': 62,
			'8553': 52,
			'8554': 52,
			'8555': 255,
			'8556': 74,
			'8557': 63,
			'8558': 63,
			'8559': 255,
			'8560': 116,
			'8561': 107,
			'8562': 108,
			'8563': 255,
			'8564': 187,
			'8565': 184,
			'8566': 183,
			'8567': 255,
			'8568': 206,
			'8569': 204,
			'8570': 202,
			'8571': 255,
			'8572': 227,
			'8573': 227,
			'8574': 224,
			'8575': 255,
			'8576': 234,
			'8577': 234,
			'8578': 232,
			'8579': 255,
			'8580': 230,
			'8581': 230,
			'8582': 228,
			'8583': 255,
			'8584': 228,
			'8585': 227,
			'8586': 225,
			'8587': 255,
			'8588': 222,
			'8589': 222,
			'8590': 219,
			'8591': 255,
			'8592': 217,
			'8593': 216,
			'8594': 213,
			'8595': 255,
			'8596': 208,
			'8597': 205,
			'8598': 204,
			'8599': 255,
			'8600': 198,
			'8601': 193,
			'8602': 192,
			'8603': 255,
			'8604': 187,
			'8605': 183,
			'8606': 182,
			'8607': 255,
			'8608': 186,
			'8609': 182,
			'8610': 181,
			'8611': 255,
			'8612': 186,
			'8613': 182,
			'8614': 181,
			'8615': 255,
			'8616': 184,
			'8617': 180,
			'8618': 179,
			'8619': 255,
			'8620': 187,
			'8621': 183,
			'8622': 182,
			'8623': 255,
			'8624': 191,
			'8625': 187,
			'8626': 186,
			'8627': 255,
			'8628': 193,
			'8629': 189,
			'8630': 188,
			'8631': 255,
			'8632': 187,
			'8633': 183,
			'8634': 182,
			'8635': 255,
			'8636': 182,
			'8637': 178,
			'8638': 177,
			'8639': 255,
			'8640': 184,
			'8641': 180,
			'8642': 179,
			'8643': 255,
			'8644': 182,
			'8645': 178,
			'8646': 177,
			'8647': 255,
			'8648': 184,
			'8649': 180,
			'8650': 179,
			'8651': 255,
			'8652': 187,
			'8653': 183,
			'8654': 182,
			'8655': 255,
			'8656': 136,
			'8657': 127,
			'8658': 128,
			'8659': 255,
			'8660': 71,
			'8661': 60,
			'8662': 59,
			'8663': 255,
			'8664': 57,
			'8665': 46,
			'8666': 46,
			'8667': 255,
			'8668': 88,
			'8669': 79,
			'8670': 79,
			'8671': 255,
			'8672': 214,
			'8673': 212,
			'8674': 211,
			'8675': 255,
			'8676': 231,
			'8677': 230,
			'8678': 228,
			'8679': 255,
			'8680': 219,
			'8681': 218,
			'8682': 216,
			'8683': 255,
			'8684': 219,
			'8685': 217,
			'8686': 215,
			'8687': 255,
			'8688': 218,
			'8689': 216,
			'8690': 214,
			'8691': 255,
			'8692': 216,
			'8693': 215,
			'8694': 213,
			'8695': 255,
			'8696': 215,
			'8697': 214,
			'8698': 212,
			'8699': 255,
			'8700': 216,
			'8701': 215,
			'8702': 213,
			'8703': 255,
			'8704': 214,
			'8705': 213,
			'8706': 211,
			'8707': 255,
			'8708': 209,
			'8709': 208,
			'8710': 206,
			'8711': 255,
			'8712': 211,
			'8713': 209,
			'8714': 207,
			'8715': 255,
			'8716': 203,
			'8717': 200,
			'8718': 198,
			'8719': 255,
			'8720': 185,
			'8721': 181,
			'8722': 180,
			'8723': 255,
			'8724': 207,
			'8725': 204,
			'8726': 202,
			'8727': 255,
			'8728': 204,
			'8729': 200,
			'8730': 199,
			'8731': 255,
			'8732': 185,
			'8733': 180,
			'8734': 179,
			'8735': 255,
			'8736': 187,
			'8737': 183,
			'8738': 182,
			'8739': 255,
			'8740': 190,
			'8741': 186,
			'8742': 185,
			'8743': 255,
			'8744': 182,
			'8745': 177,
			'8746': 176,
			'8747': 255,
			'8748': 190,
			'8749': 185,
			'8750': 185,
			'8751': 255,
			'8752': 187,
			'8753': 184,
			'8754': 182,
			'8755': 255,
			'8756': 176,
			'8757': 172,
			'8758': 171,
			'8759': 255,
			'8760': 185,
			'8761': 181,
			'8762': 180,
			'8763': 255,
			'8764': 184,
			'8765': 180,
			'8766': 179,
			'8767': 255,
			'8768': 178,
			'8769': 174,
			'8770': 173,
			'8771': 255,
			'8772': 172,
			'8773': 168,
			'8774': 167,
			'8775': 255,
			'8776': 172,
			'8777': 168,
			'8778': 167,
			'8779': 255,
			'8780': 170,
			'8781': 166,
			'8782': 165,
			'8783': 255,
			'8784': 169,
			'8785': 165,
			'8786': 164,
			'8787': 255,
			'8788': 167,
			'8789': 163,
			'8790': 161,
			'8791': 255,
			'8792': 160,
			'8793': 155,
			'8794': 154,
			'8795': 255,
			'8796': 163,
			'8797': 156,
			'8798': 156,
			'8799': 255,
			'8800': 226,
			'8801': 225,
			'8802': 223,
			'8803': 255,
			'8804': 224,
			'8805': 223,
			'8806': 220,
			'8807': 255,
			'8808': 228,
			'8809': 227,
			'8810': 226,
			'8811': 255,
			'8812': 227,
			'8813': 225,
			'8814': 225,
			'8815': 255,
			'8816': 225,
			'8817': 226,
			'8818': 223,
			'8819': 255,
			'8820': 226,
			'8821': 226,
			'8822': 224,
			'8823': 255,
			'8824': 227,
			'8825': 225,
			'8826': 225,
			'8827': 255,
			'8828': 227,
			'8829': 226,
			'8830': 224,
			'8831': 255,
			'8832': 229,
			'8833': 228,
			'8834': 227,
			'8835': 255,
			'8836': 229,
			'8837': 230,
			'8838': 228,
			'8839': 255,
			'8840': 229,
			'8841': 228,
			'8842': 226,
			'8843': 255,
			'8844': 235,
			'8845': 234,
			'8846': 232,
			'8847': 255,
			'8848': 218,
			'8849': 216,
			'8850': 214,
			'8851': 255,
			'8852': 210,
			'8853': 208,
			'8854': 206,
			'8855': 255,
			'8856': 236,
			'8857': 235,
			'8858': 234,
			'8859': 255,
			'8860': 236,
			'8861': 236,
			'8862': 236,
			'8863': 255,
			'8864': 232,
			'8865': 232,
			'8866': 230,
			'8867': 255,
			'8868': 229,
			'8869': 228,
			'8870': 226,
			'8871': 255,
			'8872': 236,
			'8873': 236,
			'8874': 235,
			'8875': 255,
			'8876': 239,
			'8877': 239,
			'8878': 239,
			'8879': 255,
			'8880': 238,
			'8881': 238,
			'8882': 239,
			'8883': 255,
			'8884': 238,
			'8885': 238,
			'8886': 237,
			'8887': 255,
			'8888': 239,
			'8889': 238,
			'8890': 237,
			'8891': 255,
			'8892': 238,
			'8893': 238,
			'8894': 237,
			'8895': 255,
			'8896': 235,
			'8897': 235,
			'8898': 235,
			'8899': 255,
			'8900': 238,
			'8901': 237,
			'8902': 237,
			'8903': 255,
			'8904': 240,
			'8905': 240,
			'8906': 240,
			'8907': 255,
			'8908': 238,
			'8909': 238,
			'8910': 238,
			'8911': 255,
			'8912': 239,
			'8913': 238,
			'8914': 238,
			'8915': 255,
			'8916': 239,
			'8917': 239,
			'8918': 239,
			'8919': 255,
			'8920': 238,
			'8921': 238,
			'8922': 238,
			'8923': 255,
			'8924': 238,
			'8925': 238,
			'8926': 238,
			'8927': 255,
			'8928': 238,
			'8929': 238,
			'8930': 238,
			'8931': 255,
			'8932': 238,
			'8933': 238,
			'8934': 239,
			'8935': 255,
			'8936': 237,
			'8937': 237,
			'8938': 238,
			'8939': 255,
			'8940': 237,
			'8941': 237,
			'8942': 238,
			'8943': 255,
			'8944': 254,
			'8945': 255,
			'8946': 255,
			'8947': 255,
			'8948': 213,
			'8949': 212,
			'8950': 210,
			'8951': 255,
			'8952': 86,
			'8953': 76,
			'8954': 75,
			'8955': 255,
			'8956': 89,
			'8957': 78,
			'8958': 79,
			'8959': 255,
			'8960': 137,
			'8961': 131,
			'8962': 132,
			'8963': 255,
			'8964': 202,
			'8965': 200,
			'8966': 199,
			'8967': 255,
			'8968': 219,
			'8969': 218,
			'8970': 216,
			'8971': 255,
			'8972': 237,
			'8973': 236,
			'8974': 235,
			'8975': 255,
			'8976': 236,
			'8977': 236,
			'8978': 234,
			'8979': 255,
			'8980': 233,
			'8981': 234,
			'8982': 231,
			'8983': 255,
			'8984': 216,
			'8985': 214,
			'8986': 212,
			'8987': 255,
			'8988': 201,
			'8989': 198,
			'8990': 196,
			'8991': 255,
			'8992': 209,
			'8993': 207,
			'8994': 205,
			'8995': 255,
			'8996': 215,
			'8997': 213,
			'8998': 212,
			'8999': 255,
			'9000': 200,
			'9001': 197,
			'9002': 196,
			'9003': 255,
			'9004': 186,
			'9005': 182,
			'9006': 181,
			'9007': 255,
			'9008': 184,
			'9009': 180,
			'9010': 179,
			'9011': 255,
			'9012': 186,
			'9013': 182,
			'9014': 181,
			'9015': 255,
			'9016': 185,
			'9017': 181,
			'9018': 180,
			'9019': 255,
			'9020': 187,
			'9021': 183,
			'9022': 182,
			'9023': 255,
			'9024': 191,
			'9025': 187,
			'9026': 186,
			'9027': 255,
			'9028': 199,
			'9029': 195,
			'9030': 194,
			'9031': 255,
			'9032': 195,
			'9033': 191,
			'9034': 190,
			'9035': 255,
			'9036': 186,
			'9037': 182,
			'9038': 181,
			'9039': 255,
			'9040': 186,
			'9041': 182,
			'9042': 181,
			'9043': 255,
			'9044': 181,
			'9045': 178,
			'9046': 176,
			'9047': 255,
			'9048': 181,
			'9049': 177,
			'9050': 176,
			'9051': 255,
			'9052': 186,
			'9053': 183,
			'9054': 183,
			'9055': 255,
			'9056': 122,
			'9057': 113,
			'9058': 114,
			'9059': 255,
			'9060': 56,
			'9061': 45,
			'9062': 44,
			'9063': 255,
			'9064': 53,
			'9065': 42,
			'9066': 41,
			'9067': 255,
			'9068': 82,
			'9069': 72,
			'9070': 72,
			'9071': 255,
			'9072': 221,
			'9073': 220,
			'9074': 218,
			'9075': 255,
			'9076': 233,
			'9077': 233,
			'9078': 231,
			'9079': 255,
			'9080': 222,
			'9081': 221,
			'9082': 219,
			'9083': 255,
			'9084': 222,
			'9085': 220,
			'9086': 218,
			'9087': 255,
			'9088': 221,
			'9089': 220,
			'9090': 218,
			'9091': 255,
			'9092': 220,
			'9093': 219,
			'9094': 217,
			'9095': 255,
			'9096': 218,
			'9097': 217,
			'9098': 215,
			'9099': 255,
			'9100': 216,
			'9101': 215,
			'9102': 213,
			'9103': 255,
			'9104': 216,
			'9105': 215,
			'9106': 213,
			'9107': 255,
			'9108': 214,
			'9109': 213,
			'9110': 211,
			'9111': 255,
			'9112': 216,
			'9113': 213,
			'9114': 212,
			'9115': 255,
			'9116': 215,
			'9117': 211,
			'9118': 210,
			'9119': 255,
			'9120': 167,
			'9121': 161,
			'9122': 161,
			'9123': 255,
			'9124': 181,
			'9125': 177,
			'9126': 176,
			'9127': 255,
			'9128': 215,
			'9129': 214,
			'9130': 212,
			'9131': 255,
			'9132': 200,
			'9133': 197,
			'9134': 196,
			'9135': 255,
			'9136': 203,
			'9137': 198,
			'9138': 197,
			'9139': 255,
			'9140': 195,
			'9141': 191,
			'9142': 190,
			'9143': 255,
			'9144': 189,
			'9145': 185,
			'9146': 184,
			'9147': 255,
			'9148': 197,
			'9149': 193,
			'9150': 192,
			'9151': 255,
			'9152': 195,
			'9153': 191,
			'9154': 190,
			'9155': 255,
			'9156': 193,
			'9157': 189,
			'9158': 188,
			'9159': 255,
			'9160': 188,
			'9161': 184,
			'9162': 183,
			'9163': 255,
			'9164': 187,
			'9165': 183,
			'9166': 182,
			'9167': 255,
			'9168': 184,
			'9169': 180,
			'9170': 179,
			'9171': 255,
			'9172': 181,
			'9173': 177,
			'9174': 176,
			'9175': 255,
			'9176': 179,
			'9177': 175,
			'9178': 174,
			'9179': 255,
			'9180': 176,
			'9181': 172,
			'9182': 171,
			'9183': 255,
			'9184': 174,
			'9185': 170,
			'9186': 168,
			'9187': 255,
			'9188': 171,
			'9189': 167,
			'9190': 164,
			'9191': 255,
			'9192': 169,
			'9193': 165,
			'9194': 163,
			'9195': 255,
			'9196': 171,
			'9197': 168,
			'9198': 165,
			'9199': 255,
			'9200': 219,
			'9201': 218,
			'9202': 216,
			'9203': 255,
			'9204': 222,
			'9205': 221,
			'9206': 218,
			'9207': 255,
			'9208': 225,
			'9209': 224,
			'9210': 223,
			'9211': 255,
			'9212': 227,
			'9213': 226,
			'9214': 227,
			'9215': 255,
			'9216': 228,
			'9217': 228,
			'9218': 226,
			'9219': 255,
			'9220': 224,
			'9221': 223,
			'9222': 221,
			'9223': 255,
			'9224': 226,
			'9225': 225,
			'9226': 222,
			'9227': 255,
			'9228': 229,
			'9229': 228,
			'9230': 226,
			'9231': 255,
			'9232': 228,
			'9233': 228,
			'9234': 227,
			'9235': 255,
			'9236': 228,
			'9237': 228,
			'9238': 228,
			'9239': 255,
			'9240': 229,
			'9241': 229,
			'9242': 226,
			'9243': 255,
			'9244': 229,
			'9245': 229,
			'9246': 227,
			'9247': 255,
			'9248': 236,
			'9249': 236,
			'9250': 234,
			'9251': 255,
			'9252': 221,
			'9253': 220,
			'9254': 217,
			'9255': 255,
			'9256': 223,
			'9257': 222,
			'9258': 221,
			'9259': 255,
			'9260': 241,
			'9261': 241,
			'9262': 241,
			'9263': 255,
			'9264': 227,
			'9265': 226,
			'9266': 224,
			'9267': 255,
			'9268': 224,
			'9269': 223,
			'9270': 220,
			'9271': 255,
			'9272': 237,
			'9273': 237,
			'9274': 236,
			'9275': 255,
			'9276': 233,
			'9277': 233,
			'9278': 232,
			'9279': 255,
			'9280': 236,
			'9281': 236,
			'9282': 235,
			'9283': 255,
			'9284': 240,
			'9285': 240,
			'9286': 237,
			'9287': 255,
			'9288': 239,
			'9289': 239,
			'9290': 238,
			'9291': 255,
			'9292': 240,
			'9293': 239,
			'9294': 240,
			'9295': 255,
			'9296': 237,
			'9297': 237,
			'9298': 238,
			'9299': 255,
			'9300': 236,
			'9301': 236,
			'9302': 234,
			'9303': 255,
			'9304': 239,
			'9305': 239,
			'9306': 239,
			'9307': 255,
			'9308': 238,
			'9309': 238,
			'9310': 239,
			'9311': 255,
			'9312': 238,
			'9313': 238,
			'9314': 238,
			'9315': 255,
			'9316': 237,
			'9317': 237,
			'9318': 238,
			'9319': 255,
			'9320': 238,
			'9321': 238,
			'9322': 238,
			'9323': 255,
			'9324': 239,
			'9325': 239,
			'9326': 237,
			'9327': 255,
			'9328': 239,
			'9329': 238,
			'9330': 238,
			'9331': 255,
			'9332': 238,
			'9333': 238,
			'9334': 238,
			'9335': 255,
			'9336': 237,
			'9337': 237,
			'9338': 237,
			'9339': 255,
			'9340': 237,
			'9341': 237,
			'9342': 237,
			'9343': 255,
			'9344': 248,
			'9345': 248,
			'9346': 249,
			'9347': 255,
			'9348': 224,
			'9349': 223,
			'9350': 223,
			'9351': 255,
			'9352': 119,
			'9353': 110,
			'9354': 109,
			'9355': 255,
			'9356': 125,
			'9357': 116,
			'9358': 117,
			'9359': 255,
			'9360': 170,
			'9361': 165,
			'9362': 164,
			'9363': 255,
			'9364': 211,
			'9365': 209,
			'9366': 208,
			'9367': 255,
			'9368': 228,
			'9369': 228,
			'9370': 225,
			'9371': 255,
			'9372': 239,
			'9373': 239,
			'9374': 238,
			'9375': 255,
			'9376': 236,
			'9377': 237,
			'9378': 235,
			'9379': 255,
			'9380': 214,
			'9381': 212,
			'9382': 210,
			'9383': 255,
			'9384': 176,
			'9385': 170,
			'9386': 170,
			'9387': 255,
			'9388': 159,
			'9389': 153,
			'9390': 153,
			'9391': 255,
			'9392': 152,
			'9393': 145,
			'9394': 146,
			'9395': 255,
			'9396': 150,
			'9397': 143,
			'9398': 143,
			'9399': 255,
			'9400': 156,
			'9401': 151,
			'9402': 151,
			'9403': 255,
			'9404': 170,
			'9405': 166,
			'9406': 165,
			'9407': 255,
			'9408': 179,
			'9409': 175,
			'9410': 174,
			'9411': 255,
			'9412': 187,
			'9413': 183,
			'9414': 182,
			'9415': 255,
			'9416': 188,
			'9417': 184,
			'9418': 183,
			'9419': 255,
			'9420': 185,
			'9421': 181,
			'9422': 180,
			'9423': 255,
			'9424': 184,
			'9425': 180,
			'9426': 179,
			'9427': 255,
			'9428': 177,
			'9429': 173,
			'9430': 172,
			'9431': 255,
			'9432': 181,
			'9433': 176,
			'9434': 176,
			'9435': 255,
			'9436': 186,
			'9437': 181,
			'9438': 181,
			'9439': 255,
			'9440': 180,
			'9441': 176,
			'9442': 175,
			'9443': 255,
			'9444': 182,
			'9445': 179,
			'9446': 178,
			'9447': 255,
			'9448': 184,
			'9449': 182,
			'9450': 180,
			'9451': 255,
			'9452': 182,
			'9453': 178,
			'9454': 177,
			'9455': 255,
			'9456': 116,
			'9457': 107,
			'9458': 107,
			'9459': 255,
			'9460': 61,
			'9461': 50,
			'9462': 49,
			'9463': 255,
			'9464': 51,
			'9465': 40,
			'9466': 39,
			'9467': 255,
			'9468': 77,
			'9469': 68,
			'9470': 66,
			'9471': 255,
			'9472': 224,
			'9473': 223,
			'9474': 221,
			'9475': 255,
			'9476': 234,
			'9477': 233,
			'9478': 231,
			'9479': 255,
			'9480': 222,
			'9481': 221,
			'9482': 219,
			'9483': 255,
			'9484': 221,
			'9485': 220,
			'9486': 218,
			'9487': 255,
			'9488': 220,
			'9489': 219,
			'9490': 217,
			'9491': 255,
			'9492': 219,
			'9493': 218,
			'9494': 216,
			'9495': 255,
			'9496': 217,
			'9497': 216,
			'9498': 214,
			'9499': 255,
			'9500': 216,
			'9501': 215,
			'9502': 213,
			'9503': 255,
			'9504': 214,
			'9505': 214,
			'9506': 212,
			'9507': 255,
			'9508': 215,
			'9509': 213,
			'9510': 211,
			'9511': 255,
			'9512': 212,
			'9513': 207,
			'9514': 206,
			'9515': 255,
			'9516': 211,
			'9517': 208,
			'9518': 207,
			'9519': 255,
			'9520': 200,
			'9521': 196,
			'9522': 195,
			'9523': 255,
			'9524': 182,
			'9525': 178,
			'9526': 177,
			'9527': 255,
			'9528': 211,
			'9529': 211,
			'9530': 209,
			'9531': 255,
			'9532': 206,
			'9533': 203,
			'9534': 202,
			'9535': 255,
			'9536': 201,
			'9537': 198,
			'9538': 196,
			'9539': 255,
			'9540': 199,
			'9541': 195,
			'9542': 194,
			'9543': 255,
			'9544': 200,
			'9545': 197,
			'9546': 196,
			'9547': 255,
			'9548': 197,
			'9549': 193,
			'9550': 192,
			'9551': 255,
			'9552': 194,
			'9553': 189,
			'9554': 188,
			'9555': 255,
			'9556': 191,
			'9557': 187,
			'9558': 186,
			'9559': 255,
			'9560': 188,
			'9561': 184,
			'9562': 183,
			'9563': 255,
			'9564': 185,
			'9565': 181,
			'9566': 180,
			'9567': 255,
			'9568': 184,
			'9569': 180,
			'9570': 179,
			'9571': 255,
			'9572': 184,
			'9573': 180,
			'9574': 179,
			'9575': 255,
			'9576': 178,
			'9577': 175,
			'9578': 173,
			'9579': 255,
			'9580': 176,
			'9581': 172,
			'9582': 171,
			'9583': 255,
			'9584': 173,
			'9585': 169,
			'9586': 168,
			'9587': 255,
			'9588': 171,
			'9589': 167,
			'9590': 164,
			'9591': 255,
			'9592': 169,
			'9593': 165,
			'9594': 164,
			'9595': 255,
			'9596': 169,
			'9597': 164,
			'9598': 162,
			'9599': 255,
			'9600': 216,
			'9601': 215,
			'9602': 213,
			'9603': 255,
			'9604': 222,
			'9605': 221,
			'9606': 219,
			'9607': 255,
			'9608': 226,
			'9609': 225,
			'9610': 223,
			'9611': 255,
			'9612': 225,
			'9613': 224,
			'9614': 223,
			'9615': 255,
			'9616': 228,
			'9617': 227,
			'9618': 225,
			'9619': 255,
			'9620': 225,
			'9621': 225,
			'9622': 223,
			'9623': 255,
			'9624': 227,
			'9625': 227,
			'9626': 224,
			'9627': 255,
			'9628': 229,
			'9629': 227,
			'9630': 225,
			'9631': 255,
			'9632': 229,
			'9633': 228,
			'9634': 226,
			'9635': 255,
			'9636': 229,
			'9637': 229,
			'9638': 227,
			'9639': 255,
			'9640': 231,
			'9641': 231,
			'9642': 228,
			'9643': 255,
			'9644': 231,
			'9645': 231,
			'9646': 229,
			'9647': 255,
			'9648': 233,
			'9649': 232,
			'9650': 230,
			'9651': 255,
			'9652': 228,
			'9653': 227,
			'9654': 225,
			'9655': 255,
			'9656': 224,
			'9657': 224,
			'9658': 221,
			'9659': 255,
			'9660': 240,
			'9661': 240,
			'9662': 238,
			'9663': 255,
			'9664': 223,
			'9665': 222,
			'9666': 220,
			'9667': 255,
			'9668': 217,
			'9669': 216,
			'9670': 214,
			'9671': 255,
			'9672': 236,
			'9673': 236,
			'9674': 235,
			'9675': 255,
			'9676': 232,
			'9677': 231,
			'9678': 230,
			'9679': 255,
			'9680': 236,
			'9681': 236,
			'9682': 236,
			'9683': 255,
			'9684': 240,
			'9685': 239,
			'9686': 238,
			'9687': 255,
			'9688': 239,
			'9689': 239,
			'9690': 238,
			'9691': 255,
			'9692': 240,
			'9693': 240,
			'9694': 240,
			'9695': 255,
			'9696': 238,
			'9697': 238,
			'9698': 237,
			'9699': 255,
			'9700': 235,
			'9701': 235,
			'9702': 235,
			'9703': 255,
			'9704': 234,
			'9705': 234,
			'9706': 233,
			'9707': 255,
			'9708': 238,
			'9709': 238,
			'9710': 237,
			'9711': 255,
			'9712': 237,
			'9713': 237,
			'9714': 237,
			'9715': 255,
			'9716': 237,
			'9717': 237,
			'9718': 236,
			'9719': 255,
			'9720': 240,
			'9721': 240,
			'9722': 240,
			'9723': 255,
			'9724': 240,
			'9725': 239,
			'9726': 238,
			'9727': 255,
			'9728': 238,
			'9729': 238,
			'9730': 237,
			'9731': 255,
			'9732': 237,
			'9733': 237,
			'9734': 237,
			'9735': 255,
			'9736': 237,
			'9737': 237,
			'9738': 237,
			'9739': 255,
			'9740': 237,
			'9741': 237,
			'9742': 237,
			'9743': 255,
			'9744': 243,
			'9745': 243,
			'9746': 244,
			'9747': 255,
			'9748': 231,
			'9749': 230,
			'9750': 230,
			'9751': 255,
			'9752': 153,
			'9753': 147,
			'9754': 147,
			'9755': 255,
			'9756': 154,
			'9757': 150,
			'9758': 149,
			'9759': 255,
			'9760': 173,
			'9761': 169,
			'9762': 168,
			'9763': 255,
			'9764': 213,
			'9765': 210,
			'9766': 209,
			'9767': 255,
			'9768': 235,
			'9769': 235,
			'9770': 233,
			'9771': 255,
			'9772': 236,
			'9773': 236,
			'9774': 234,
			'9775': 255,
			'9776': 225,
			'9777': 224,
			'9778': 222,
			'9779': 255,
			'9780': 201,
			'9781': 198,
			'9782': 197,
			'9783': 255,
			'9784': 197,
			'9785': 194,
			'9786': 193,
			'9787': 255,
			'9788': 185,
			'9789': 181,
			'9790': 180,
			'9791': 255,
			'9792': 161,
			'9793': 155,
			'9794': 155,
			'9795': 255,
			'9796': 134,
			'9797': 125,
			'9798': 126,
			'9799': 255,
			'9800': 157,
			'9801': 151,
			'9802': 151,
			'9803': 255,
			'9804': 186,
			'9805': 183,
			'9806': 181,
			'9807': 255,
			'9808': 186,
			'9809': 181,
			'9810': 180,
			'9811': 255,
			'9812': 199,
			'9813': 195,
			'9814': 194,
			'9815': 255,
			'9816': 190,
			'9817': 186,
			'9818': 185,
			'9819': 255,
			'9820': 185,
			'9821': 182,
			'9822': 181,
			'9823': 255,
			'9824': 179,
			'9825': 175,
			'9826': 174,
			'9827': 255,
			'9828': 147,
			'9829': 140,
			'9830': 141,
			'9831': 255,
			'9832': 115,
			'9833': 105,
			'9834': 107,
			'9835': 255,
			'9836': 97,
			'9837': 87,
			'9838': 89,
			'9839': 255,
			'9840': 118,
			'9841': 109,
			'9842': 110,
			'9843': 255,
			'9844': 153,
			'9845': 147,
			'9846': 148,
			'9847': 255,
			'9848': 179,
			'9849': 175,
			'9850': 173,
			'9851': 255,
			'9852': 187,
			'9853': 184,
			'9854': 182,
			'9855': 255,
			'9856': 120,
			'9857': 113,
			'9858': 113,
			'9859': 255,
			'9860': 57,
			'9861': 47,
			'9862': 46,
			'9863': 255,
			'9864': 33,
			'9865': 22,
			'9866': 21,
			'9867': 255,
			'9868': 125,
			'9869': 119,
			'9870': 117,
			'9871': 255,
			'9872': 244,
			'9873': 245,
			'9874': 242,
			'9875': 255,
			'9876': 226,
			'9877': 225,
			'9878': 223,
			'9879': 255,
			'9880': 222,
			'9881': 221,
			'9882': 219,
			'9883': 255,
			'9884': 222,
			'9885': 221,
			'9886': 219,
			'9887': 255,
			'9888': 219,
			'9889': 219,
			'9890': 217,
			'9891': 255,
			'9892': 218,
			'9893': 217,
			'9894': 215,
			'9895': 255,
			'9896': 217,
			'9897': 216,
			'9898': 214,
			'9899': 255,
			'9900': 216,
			'9901': 215,
			'9902': 213,
			'9903': 255,
			'9904': 213,
			'9905': 213,
			'9906': 211,
			'9907': 255,
			'9908': 214,
			'9909': 211,
			'9910': 210,
			'9911': 255,
			'9912': 212,
			'9913': 207,
			'9914': 207,
			'9915': 255,
			'9916': 205,
			'9917': 203,
			'9918': 201,
			'9919': 255,
			'9920': 207,
			'9921': 203,
			'9922': 202,
			'9923': 255,
			'9924': 204,
			'9925': 200,
			'9926': 199,
			'9927': 255,
			'9928': 212,
			'9929': 211,
			'9930': 209,
			'9931': 255,
			'9932': 205,
			'9933': 203,
			'9934': 201,
			'9935': 255,
			'9936': 200,
			'9937': 196,
			'9938': 195,
			'9939': 255,
			'9940': 199,
			'9941': 195,
			'9942': 194,
			'9943': 255,
			'9944': 195,
			'9945': 192,
			'9946': 191,
			'9947': 255,
			'9948': 194,
			'9949': 191,
			'9950': 190,
			'9951': 255,
			'9952': 194,
			'9953': 190,
			'9954': 189,
			'9955': 255,
			'9956': 191,
			'9957': 187,
			'9958': 186,
			'9959': 255,
			'9960': 186,
			'9961': 182,
			'9962': 181,
			'9963': 255,
			'9964': 185,
			'9965': 181,
			'9966': 180,
			'9967': 255,
			'9968': 184,
			'9969': 180,
			'9970': 179,
			'9971': 255,
			'9972': 181,
			'9973': 177,
			'9974': 176,
			'9975': 255,
			'9976': 177,
			'9977': 175,
			'9978': 173,
			'9979': 255,
			'9980': 177,
			'9981': 174,
			'9982': 173,
			'9983': 255,
			'9984': 173,
			'9985': 169,
			'9986': 167,
			'9987': 255,
			'9988': 171,
			'9989': 167,
			'9990': 164,
			'9991': 255,
			'9992': 168,
			'9993': 164,
			'9994': 163,
			'9995': 255,
			'9996': 169,
			'9997': 165,
			'9998': 164,
			'9999': 255,
			'10000': 227,
			'10001': 227,
			'10002': 225,
			'10003': 255,
			'10004': 224,
			'10005': 223,
			'10006': 221,
			'10007': 255,
			'10008': 225,
			'10009': 224,
			'10010': 222,
			'10011': 255,
			'10012': 225,
			'10013': 225,
			'10014': 224,
			'10015': 255,
			'10016': 225,
			'10017': 225,
			'10018': 223,
			'10019': 255,
			'10020': 226,
			'10021': 226,
			'10022': 225,
			'10023': 255,
			'10024': 228,
			'10025': 227,
			'10026': 226,
			'10027': 255,
			'10028': 228,
			'10029': 226,
			'10030': 225,
			'10031': 255,
			'10032': 229,
			'10033': 228,
			'10034': 226,
			'10035': 255,
			'10036': 231,
			'10037': 231,
			'10038': 228,
			'10039': 255,
			'10040': 230,
			'10041': 230,
			'10042': 229,
			'10043': 255,
			'10044': 231,
			'10045': 230,
			'10046': 228,
			'10047': 255,
			'10048': 232,
			'10049': 231,
			'10050': 229,
			'10051': 255,
			'10052': 230,
			'10053': 230,
			'10054': 228,
			'10055': 255,
			'10056': 231,
			'10057': 231,
			'10058': 229,
			'10059': 255,
			'10060': 237,
			'10061': 236,
			'10062': 234,
			'10063': 255,
			'10064': 224,
			'10065': 223,
			'10066': 221,
			'10067': 255,
			'10068': 222,
			'10069': 221,
			'10070': 219,
			'10071': 255,
			'10072': 233,
			'10073': 232,
			'10074': 230,
			'10075': 255,
			'10076': 238,
			'10077': 238,
			'10078': 238,
			'10079': 255,
			'10080': 240,
			'10081': 240,
			'10082': 240,
			'10083': 255,
			'10084': 238,
			'10085': 238,
			'10086': 235,
			'10087': 255,
			'10088': 239,
			'10089': 238,
			'10090': 237,
			'10091': 255,
			'10092': 240,
			'10093': 240,
			'10094': 239,
			'10095': 255,
			'10096': 241,
			'10097': 241,
			'10098': 240,
			'10099': 255,
			'10100': 234,
			'10101': 233,
			'10102': 233,
			'10103': 255,
			'10104': 226,
			'10105': 225,
			'10106': 224,
			'10107': 255,
			'10108': 239,
			'10109': 239,
			'10110': 238,
			'10111': 255,
			'10112': 237,
			'10113': 238,
			'10114': 238,
			'10115': 255,
			'10116': 235,
			'10117': 235,
			'10118': 234,
			'10119': 255,
			'10120': 235,
			'10121': 234,
			'10122': 233,
			'10123': 255,
			'10124': 240,
			'10125': 239,
			'10126': 239,
			'10127': 255,
			'10128': 238,
			'10129': 238,
			'10130': 238,
			'10131': 255,
			'10132': 236,
			'10133': 236,
			'10134': 236,
			'10135': 255,
			'10136': 237,
			'10137': 237,
			'10138': 236,
			'10139': 255,
			'10140': 237,
			'10141': 237,
			'10142': 237,
			'10143': 255,
			'10144': 244,
			'10145': 245,
			'10146': 244,
			'10147': 255,
			'10148': 227,
			'10149': 226,
			'10150': 226,
			'10151': 255,
			'10152': 156,
			'10153': 152,
			'10154': 151,
			'10155': 255,
			'10156': 171,
			'10157': 167,
			'10158': 166,
			'10159': 255,
			'10160': 168,
			'10161': 164,
			'10162': 163,
			'10163': 255,
			'10164': 203,
			'10165': 200,
			'10166': 198,
			'10167': 255,
			'10168': 241,
			'10169': 241,
			'10170': 240,
			'10171': 255,
			'10172': 232,
			'10173': 232,
			'10174': 229,
			'10175': 255,
			'10176': 223,
			'10177': 221,
			'10178': 220,
			'10179': 255,
			'10180': 237,
			'10181': 237,
			'10182': 235,
			'10183': 255,
			'10184': 248,
			'10185': 249,
			'10186': 246,
			'10187': 255,
			'10188': 228,
			'10189': 227,
			'10190': 225,
			'10191': 255,
			'10192': 207,
			'10193': 204,
			'10194': 203,
			'10195': 255,
			'10196': 178,
			'10197': 175,
			'10198': 174,
			'10199': 255,
			'10200': 195,
			'10201': 192,
			'10202': 191,
			'10203': 255,
			'10204': 218,
			'10205': 215,
			'10206': 213,
			'10207': 255,
			'10208': 214,
			'10209': 211,
			'10210': 209,
			'10211': 255,
			'10212': 211,
			'10213': 208,
			'10214': 207,
			'10215': 255,
			'10216': 188,
			'10217': 184,
			'10218': 183,
			'10219': 255,
			'10220': 177,
			'10221': 174,
			'10222': 173,
			'10223': 255,
			'10224': 165,
			'10225': 159,
			'10226': 159,
			'10227': 255,
			'10228': 144,
			'10229': 133,
			'10230': 135,
			'10231': 255,
			'10232': 124,
			'10233': 116,
			'10234': 116,
			'10235': 255,
			'10236': 113,
			'10237': 104,
			'10238': 104,
			'10239': 255,
			'10240': 119,
			'10241': 110,
			'10242': 111,
			'10243': 255,
			'10244': 114,
			'10245': 103,
			'10246': 105,
			'10247': 255,
			'10248': 131,
			'10249': 122,
			'10250': 123,
			'10251': 255,
			'10252': 188,
			'10253': 185,
			'10254': 183,
			'10255': 255,
			'10256': 130,
			'10257': 123,
			'10258': 123,
			'10259': 255,
			'10260': 42,
			'10261': 31,
			'10262': 30,
			'10263': 255,
			'10264': 36,
			'10265': 25,
			'10266': 24,
			'10267': 255,
			'10268': 182,
			'10269': 178,
			'10270': 177,
			'10271': 255,
			'10272': 249,
			'10273': 249,
			'10274': 247,
			'10275': 255,
			'10276': 223,
			'10277': 222,
			'10278': 220,
			'10279': 255,
			'10280': 222,
			'10281': 221,
			'10282': 219,
			'10283': 255,
			'10284': 221,
			'10285': 219,
			'10286': 218,
			'10287': 255,
			'10288': 221,
			'10289': 219,
			'10290': 218,
			'10291': 255,
			'10292': 219,
			'10293': 218,
			'10294': 215,
			'10295': 255,
			'10296': 216,
			'10297': 215,
			'10298': 213,
			'10299': 255,
			'10300': 215,
			'10301': 215,
			'10302': 213,
			'10303': 255,
			'10304': 214,
			'10305': 212,
			'10306': 210,
			'10307': 255,
			'10308': 214,
			'10309': 210,
			'10310': 209,
			'10311': 255,
			'10312': 212,
			'10313': 208,
			'10314': 207,
			'10315': 255,
			'10316': 208,
			'10317': 204,
			'10318': 203,
			'10319': 255,
			'10320': 206,
			'10321': 203,
			'10322': 202,
			'10323': 255,
			'10324': 209,
			'10325': 204,
			'10326': 204,
			'10327': 255,
			'10328': 212,
			'10329': 210,
			'10330': 208,
			'10331': 255,
			'10332': 203,
			'10333': 202,
			'10334': 200,
			'10335': 255,
			'10336': 199,
			'10337': 195,
			'10338': 194,
			'10339': 255,
			'10340': 198,
			'10341': 194,
			'10342': 193,
			'10343': 255,
			'10344': 197,
			'10345': 193,
			'10346': 192,
			'10347': 255,
			'10348': 195,
			'10349': 191,
			'10350': 190,
			'10351': 255,
			'10352': 192,
			'10353': 188,
			'10354': 187,
			'10355': 255,
			'10356': 188,
			'10357': 184,
			'10358': 183,
			'10359': 255,
			'10360': 185,
			'10361': 181,
			'10362': 180,
			'10363': 255,
			'10364': 186,
			'10365': 182,
			'10366': 181,
			'10367': 255,
			'10368': 184,
			'10369': 180,
			'10370': 179,
			'10371': 255,
			'10372': 180,
			'10373': 176,
			'10374': 175,
			'10375': 255,
			'10376': 178,
			'10377': 174,
			'10378': 174,
			'10379': 255,
			'10380': 176,
			'10381': 172,
			'10382': 171,
			'10383': 255,
			'10384': 174,
			'10385': 170,
			'10386': 168,
			'10387': 255,
			'10388': 171,
			'10389': 167,
			'10390': 165,
			'10391': 255,
			'10392': 166,
			'10393': 162,
			'10394': 162,
			'10395': 255,
			'10396': 169,
			'10397': 165,
			'10398': 164,
			'10399': 255,
			'10400': 224,
			'10401': 223,
			'10402': 221,
			'10403': 255,
			'10404': 222,
			'10405': 221,
			'10406': 219,
			'10407': 255,
			'10408': 224,
			'10409': 224,
			'10410': 222,
			'10411': 255,
			'10412': 226,
			'10413': 226,
			'10414': 225,
			'10415': 255,
			'10416': 227,
			'10417': 227,
			'10418': 225,
			'10419': 255,
			'10420': 227,
			'10421': 226,
			'10422': 225,
			'10423': 255,
			'10424': 227,
			'10425': 226,
			'10426': 226,
			'10427': 255,
			'10428': 229,
			'10429': 228,
			'10430': 226,
			'10431': 255,
			'10432': 228,
			'10433': 227,
			'10434': 225,
			'10435': 255,
			'10436': 230,
			'10437': 230,
			'10438': 227,
			'10439': 255,
			'10440': 231,
			'10441': 231,
			'10442': 230,
			'10443': 255,
			'10444': 226,
			'10445': 225,
			'10446': 224,
			'10447': 255,
			'10448': 230,
			'10449': 230,
			'10450': 227,
			'10451': 255,
			'10452': 232,
			'10453': 232,
			'10454': 230,
			'10455': 255,
			'10456': 233,
			'10457': 232,
			'10458': 230,
			'10459': 255,
			'10460': 235,
			'10461': 235,
			'10462': 234,
			'10463': 255,
			'10464': 220,
			'10465': 219,
			'10466': 218,
			'10467': 255,
			'10468': 225,
			'10469': 224,
			'10470': 222,
			'10471': 255,
			'10472': 231,
			'10473': 229,
			'10474': 227,
			'10475': 255,
			'10476': 234,
			'10477': 233,
			'10478': 232,
			'10479': 255,
			'10480': 240,
			'10481': 240,
			'10482': 239,
			'10483': 255,
			'10484': 238,
			'10485': 238,
			'10486': 237,
			'10487': 255,
			'10488': 238,
			'10489': 238,
			'10490': 237,
			'10491': 255,
			'10492': 241,
			'10493': 240,
			'10494': 238,
			'10495': 255,
			'10496': 243,
			'10497': 243,
			'10498': 244,
			'10499': 255,
			'10500': 227,
			'10501': 227,
			'10502': 226,
			'10503': 255,
			'10504': 221,
			'10505': 220,
			'10506': 219,
			'10507': 255,
			'10508': 242,
			'10509': 242,
			'10510': 242,
			'10511': 255,
			'10512': 238,
			'10513': 238,
			'10514': 238,
			'10515': 255,
			'10516': 238,
			'10517': 236,
			'10518': 237,
			'10519': 255,
			'10520': 232,
			'10521': 231,
			'10522': 229,
			'10523': 255,
			'10524': 238,
			'10525': 238,
			'10526': 237,
			'10527': 255,
			'10528': 238,
			'10529': 238,
			'10530': 239,
			'10531': 255,
			'10532': 235,
			'10533': 234,
			'10534': 233,
			'10535': 255,
			'10536': 237,
			'10537': 235,
			'10538': 235,
			'10539': 255,
			'10540': 238,
			'10541': 238,
			'10542': 239,
			'10543': 255,
			'10544': 242,
			'10545': 242,
			'10546': 241,
			'10547': 255,
			'10548': 227,
			'10549': 226,
			'10550': 224,
			'10551': 255,
			'10552': 184,
			'10553': 182,
			'10554': 180,
			'10555': 255,
			'10556': 181,
			'10557': 176,
			'10558': 175,
			'10559': 255,
			'10560': 168,
			'10561': 163,
			'10562': 162,
			'10563': 255,
			'10564': 207,
			'10565': 204,
			'10566': 203,
			'10567': 255,
			'10568': 244,
			'10569': 244,
			'10570': 244,
			'10571': 255,
			'10572': 231,
			'10573': 231,
			'10574': 230,
			'10575': 255,
			'10576': 240,
			'10577': 240,
			'10578': 238,
			'10579': 255,
			'10580': 236,
			'10581': 236,
			'10582': 235,
			'10583': 255,
			'10584': 211,
			'10585': 209,
			'10586': 207,
			'10587': 255,
			'10588': 155,
			'10589': 151,
			'10590': 150,
			'10591': 255,
			'10592': 60,
			'10593': 51,
			'10594': 51,
			'10595': 255,
			'10596': 79,
			'10597': 70,
			'10598': 69,
			'10599': 255,
			'10600': 117,
			'10601': 109,
			'10602': 109,
			'10603': 255,
			'10604': 188,
			'10605': 184,
			'10606': 183,
			'10607': 255,
			'10608': 239,
			'10609': 239,
			'10610': 237,
			'10611': 255,
			'10612': 224,
			'10613': 222,
			'10614': 220,
			'10615': 255,
			'10616': 177,
			'10617': 172,
			'10618': 171,
			'10619': 255,
			'10620': 130,
			'10621': 121,
			'10622': 122,
			'10623': 255,
			'10624': 114,
			'10625': 105,
			'10626': 106,
			'10627': 255,
			'10628': 117,
			'10629': 108,
			'10630': 108,
			'10631': 255,
			'10632': 152,
			'10633': 144,
			'10634': 145,
			'10635': 255,
			'10636': 184,
			'10637': 179,
			'10638': 179,
			'10639': 255,
			'10640': 178,
			'10641': 173,
			'10642': 173,
			'10643': 255,
			'10644': 158,
			'10645': 151,
			'10646': 151,
			'10647': 255,
			'10648': 121,
			'10649': 112,
			'10650': 113,
			'10651': 255,
			'10652': 177,
			'10653': 172,
			'10654': 171,
			'10655': 255,
			'10656': 143,
			'10657': 138,
			'10658': 137,
			'10659': 255,
			'10660': 34,
			'10661': 23,
			'10662': 22,
			'10663': 255,
			'10664': 53,
			'10665': 42,
			'10666': 43,
			'10667': 255,
			'10668': 206,
			'10669': 204,
			'10670': 203,
			'10671': 255,
			'10672': 241,
			'10673': 241,
			'10674': 239,
			'10675': 255,
			'10676': 224,
			'10677': 223,
			'10678': 221,
			'10679': 255,
			'10680': 221,
			'10681': 220,
			'10682': 218,
			'10683': 255,
			'10684': 221,
			'10685': 220,
			'10686': 218,
			'10687': 255,
			'10688': 222,
			'10689': 219,
			'10690': 218,
			'10691': 255,
			'10692': 218,
			'10693': 217,
			'10694': 215,
			'10695': 255,
			'10696': 216,
			'10697': 215,
			'10698': 213,
			'10699': 255,
			'10700': 215,
			'10701': 215,
			'10702': 213,
			'10703': 255,
			'10704': 214,
			'10705': 213,
			'10706': 211,
			'10707': 255,
			'10708': 214,
			'10709': 209,
			'10710': 209,
			'10711': 255,
			'10712': 210,
			'10713': 205,
			'10714': 205,
			'10715': 255,
			'10716': 209,
			'10717': 207,
			'10718': 206,
			'10719': 255,
			'10720': 204,
			'10721': 201,
			'10722': 200,
			'10723': 255,
			'10724': 200,
			'10725': 195,
			'10726': 195,
			'10727': 255,
			'10728': 210,
			'10729': 207,
			'10730': 206,
			'10731': 255,
			'10732': 202,
			'10733': 199,
			'10734': 198,
			'10735': 255,
			'10736': 197,
			'10737': 193,
			'10738': 192,
			'10739': 255,
			'10740': 196,
			'10741': 192,
			'10742': 191,
			'10743': 255,
			'10744': 194,
			'10745': 190,
			'10746': 189,
			'10747': 255,
			'10748': 193,
			'10749': 189,
			'10750': 188,
			'10751': 255,
			'10752': 189,
			'10753': 185,
			'10754': 184,
			'10755': 255,
			'10756': 187,
			'10757': 183,
			'10758': 182,
			'10759': 255,
			'10760': 187,
			'10761': 183,
			'10762': 182,
			'10763': 255,
			'10764': 186,
			'10765': 182,
			'10766': 181,
			'10767': 255,
			'10768': 183,
			'10769': 179,
			'10770': 178,
			'10771': 255,
			'10772': 181,
			'10773': 177,
			'10774': 176,
			'10775': 255,
			'10776': 177,
			'10777': 173,
			'10778': 172,
			'10779': 255,
			'10780': 175,
			'10781': 170,
			'10782': 169,
			'10783': 255,
			'10784': 174,
			'10785': 170,
			'10786': 168,
			'10787': 255,
			'10788': 171,
			'10789': 167,
			'10790': 165,
			'10791': 255,
			'10792': 167,
			'10793': 163,
			'10794': 162,
			'10795': 255,
			'10796': 168,
			'10797': 164,
			'10798': 163,
			'10799': 255,
			'10800': 224,
			'10801': 223,
			'10802': 221,
			'10803': 255,
			'10804': 223,
			'10805': 222,
			'10806': 220,
			'10807': 255,
			'10808': 225,
			'10809': 224,
			'10810': 222,
			'10811': 255,
			'10812': 227,
			'10813': 226,
			'10814': 224,
			'10815': 255,
			'10816': 228,
			'10817': 227,
			'10818': 225,
			'10819': 255,
			'10820': 228,
			'10821': 227,
			'10822': 225,
			'10823': 255,
			'10824': 228,
			'10825': 227,
			'10826': 225,
			'10827': 255,
			'10828': 228,
			'10829': 228,
			'10830': 226,
			'10831': 255,
			'10832': 228,
			'10833': 227,
			'10834': 225,
			'10835': 255,
			'10836': 228,
			'10837': 228,
			'10838': 227,
			'10839': 255,
			'10840': 231,
			'10841': 231,
			'10842': 230,
			'10843': 255,
			'10844': 225,
			'10845': 224,
			'10846': 222,
			'10847': 255,
			'10848': 229,
			'10849': 228,
			'10850': 226,
			'10851': 255,
			'10852': 232,
			'10853': 232,
			'10854': 230,
			'10855': 255,
			'10856': 234,
			'10857': 233,
			'10858': 231,
			'10859': 255,
			'10860': 235,
			'10861': 234,
			'10862': 233,
			'10863': 255,
			'10864': 226,
			'10865': 224,
			'10866': 222,
			'10867': 255,
			'10868': 232,
			'10869': 231,
			'10870': 230,
			'10871': 255,
			'10872': 239,
			'10873': 238,
			'10874': 237,
			'10875': 255,
			'10876': 212,
			'10877': 211,
			'10878': 208,
			'10879': 255,
			'10880': 224,
			'10881': 224,
			'10882': 221,
			'10883': 255,
			'10884': 242,
			'10885': 242,
			'10886': 242,
			'10887': 255,
			'10888': 238,
			'10889': 239,
			'10890': 239,
			'10891': 255,
			'10892': 240,
			'10893': 240,
			'10894': 237,
			'10895': 255,
			'10896': 243,
			'10897': 242,
			'10898': 241,
			'10899': 255,
			'10900': 230,
			'10901': 229,
			'10902': 229,
			'10903': 255,
			'10904': 228,
			'10905': 227,
			'10906': 226,
			'10907': 255,
			'10908': 242,
			'10909': 242,
			'10910': 242,
			'10911': 255,
			'10912': 240,
			'10913': 239,
			'10914': 238,
			'10915': 255,
			'10916': 238,
			'10917': 238,
			'10918': 238,
			'10919': 255,
			'10920': 237,
			'10921': 237,
			'10922': 237,
			'10923': 255,
			'10924': 239,
			'10925': 239,
			'10926': 238,
			'10927': 255,
			'10928': 239,
			'10929': 238,
			'10930': 237,
			'10931': 255,
			'10932': 231,
			'10933': 230,
			'10934': 229,
			'10935': 255,
			'10936': 236,
			'10937': 235,
			'10938': 234,
			'10939': 255,
			'10940': 244,
			'10941': 245,
			'10942': 245,
			'10943': 255,
			'10944': 223,
			'10945': 222,
			'10946': 221,
			'10947': 255,
			'10948': 199,
			'10949': 197,
			'10950': 195,
			'10951': 255,
			'10952': 247,
			'10953': 248,
			'10954': 245,
			'10955': 255,
			'10956': 209,
			'10957': 208,
			'10958': 206,
			'10959': 255,
			'10960': 178,
			'10961': 173,
			'10962': 172,
			'10963': 255,
			'10964': 225,
			'10965': 224,
			'10966': 223,
			'10967': 255,
			'10968': 241,
			'10969': 241,
			'10970': 242,
			'10971': 255,
			'10972': 234,
			'10973': 234,
			'10974': 233,
			'10975': 255,
			'10976': 232,
			'10977': 232,
			'10978': 230,
			'10979': 255,
			'10980': 221,
			'10981': 219,
			'10982': 217,
			'10983': 255,
			'10984': 192,
			'10985': 188,
			'10986': 187,
			'10987': 255,
			'10988': 153,
			'10989': 147,
			'10990': 147,
			'10991': 255,
			'10992': 56,
			'10993': 45,
			'10994': 46,
			'10995': 255,
			'10996': 91,
			'10997': 81,
			'10998': 81,
			'10999': 255,
			'11000': 82,
			'11001': 70,
			'11002': 71,
			'11003': 255,
			'11004': 123,
			'11005': 115,
			'11006': 115,
			'11007': 255,
			'11008': 232,
			'11009': 234,
			'11010': 231,
			'11011': 255,
			'11012': 227,
			'11013': 226,
			'11014': 224,
			'11015': 255,
			'11016': 174,
			'11017': 169,
			'11018': 169,
			'11019': 255,
			'11020': 132,
			'11021': 123,
			'11022': 124,
			'11023': 255,
			'11024': 83,
			'11025': 72,
			'11026': 71,
			'11027': 255,
			'11028': 67,
			'11029': 58,
			'11030': 57,
			'11031': 255,
			'11032': 41,
			'11033': 32,
			'11034': 33,
			'11035': 255,
			'11036': 63,
			'11037': 53,
			'11038': 53,
			'11039': 255,
			'11040': 112,
			'11041': 103,
			'11042': 103,
			'11043': 255,
			'11044': 148,
			'11045': 141,
			'11046': 141,
			'11047': 255,
			'11048': 168,
			'11049': 163,
			'11050': 163,
			'11051': 255,
			'11052': 185,
			'11053': 183,
			'11054': 182,
			'11055': 255,
			'11056': 149,
			'11057': 145,
			'11058': 144,
			'11059': 255,
			'11060': 29,
			'11061': 17,
			'11062': 16,
			'11063': 255,
			'11064': 74,
			'11065': 66,
			'11066': 65,
			'11067': 255,
			'11068': 229,
			'11069': 228,
			'11070': 227,
			'11071': 255,
			'11072': 233,
			'11073': 232,
			'11074': 230,
			'11075': 255,
			'11076': 223,
			'11077': 222,
			'11078': 220,
			'11079': 255,
			'11080': 222,
			'11081': 221,
			'11082': 219,
			'11083': 255,
			'11084': 222,
			'11085': 221,
			'11086': 219,
			'11087': 255,
			'11088': 220,
			'11089': 219,
			'11090': 217,
			'11091': 255,
			'11092': 218,
			'11093': 217,
			'11094': 215,
			'11095': 255,
			'11096': 217,
			'11097': 216,
			'11098': 214,
			'11099': 255,
			'11100': 215,
			'11101': 214,
			'11102': 212,
			'11103': 255,
			'11104': 215,
			'11105': 211,
			'11106': 210,
			'11107': 255,
			'11108': 212,
			'11109': 209,
			'11110': 207,
			'11111': 255,
			'11112': 210,
			'11113': 208,
			'11114': 206,
			'11115': 255,
			'11116': 209,
			'11117': 205,
			'11118': 204,
			'11119': 255,
			'11120': 205,
			'11121': 201,
			'11122': 200,
			'11123': 255,
			'11124': 197,
			'11125': 194,
			'11126': 193,
			'11127': 255,
			'11128': 203,
			'11129': 199,
			'11130': 198,
			'11131': 255,
			'11132': 202,
			'11133': 198,
			'11134': 197,
			'11135': 255,
			'11136': 197,
			'11137': 193,
			'11138': 192,
			'11139': 255,
			'11140': 197,
			'11141': 193,
			'11142': 192,
			'11143': 255,
			'11144': 194,
			'11145': 190,
			'11146': 189,
			'11147': 255,
			'11148': 192,
			'11149': 188,
			'11150': 187,
			'11151': 255,
			'11152': 190,
			'11153': 186,
			'11154': 185,
			'11155': 255,
			'11156': 189,
			'11157': 185,
			'11158': 184,
			'11159': 255,
			'11160': 186,
			'11161': 182,
			'11162': 181,
			'11163': 255,
			'11164': 184,
			'11165': 180,
			'11166': 179,
			'11167': 255,
			'11168': 182,
			'11169': 178,
			'11170': 177,
			'11171': 255,
			'11172': 178,
			'11173': 174,
			'11174': 173,
			'11175': 255,
			'11176': 176,
			'11177': 172,
			'11178': 171,
			'11179': 255,
			'11180': 175,
			'11181': 171,
			'11182': 170,
			'11183': 255,
			'11184': 172,
			'11185': 168,
			'11186': 165,
			'11187': 255,
			'11188': 168,
			'11189': 164,
			'11190': 163,
			'11191': 255,
			'11192': 166,
			'11193': 162,
			'11194': 160,
			'11195': 255,
			'11196': 169,
			'11197': 164,
			'11198': 162,
			'11199': 255,
			'11200': 223,
			'11201': 222,
			'11202': 220,
			'11203': 255,
			'11204': 222,
			'11205': 221,
			'11206': 219,
			'11207': 255,
			'11208': 225,
			'11209': 224,
			'11210': 222,
			'11211': 255,
			'11212': 224,
			'11213': 223,
			'11214': 221,
			'11215': 255,
			'11216': 225,
			'11217': 224,
			'11218': 221,
			'11219': 255,
			'11220': 225,
			'11221': 224,
			'11222': 222,
			'11223': 255,
			'11224': 228,
			'11225': 227,
			'11226': 225,
			'11227': 255,
			'11228': 229,
			'11229': 229,
			'11230': 227,
			'11231': 255,
			'11232': 228,
			'11233': 227,
			'11234': 225,
			'11235': 255,
			'11236': 230,
			'11237': 229,
			'11238': 228,
			'11239': 255,
			'11240': 230,
			'11241': 230,
			'11242': 228,
			'11243': 255,
			'11244': 228,
			'11245': 227,
			'11246': 225,
			'11247': 255,
			'11248': 232,
			'11249': 232,
			'11250': 230,
			'11251': 255,
			'11252': 231,
			'11253': 230,
			'11254': 228,
			'11255': 255,
			'11256': 234,
			'11257': 233,
			'11258': 231,
			'11259': 255,
			'11260': 228,
			'11261': 228,
			'11262': 226,
			'11263': 255,
			'11264': 232,
			'11265': 232,
			'11266': 229,
			'11267': 255,
			'11268': 237,
			'11269': 237,
			'11270': 236,
			'11271': 255,
			'11272': 241,
			'11273': 242,
			'11274': 241,
			'11275': 255,
			'11276': 223,
			'11277': 223,
			'11278': 221,
			'11279': 255,
			'11280': 217,
			'11281': 216,
			'11282': 213,
			'11283': 255,
			'11284': 239,
			'11285': 239,
			'11286': 237,
			'11287': 255,
			'11288': 241,
			'11289': 241,
			'11290': 241,
			'11291': 255,
			'11292': 241,
			'11293': 239,
			'11294': 239,
			'11295': 255,
			'11296': 240,
			'11297': 239,
			'11298': 238,
			'11299': 255,
			'11300': 235,
			'11301': 235,
			'11302': 233,
			'11303': 255,
			'11304': 237,
			'11305': 237,
			'11306': 234,
			'11307': 255,
			'11308': 240,
			'11309': 239,
			'11310': 239,
			'11311': 255,
			'11312': 240,
			'11313': 240,
			'11314': 239,
			'11315': 255,
			'11316': 239,
			'11317': 239,
			'11318': 237,
			'11319': 255,
			'11320': 238,
			'11321': 239,
			'11322': 239,
			'11323': 255,
			'11324': 240,
			'11325': 240,
			'11326': 237,
			'11327': 255,
			'11328': 240,
			'11329': 240,
			'11330': 238,
			'11331': 255,
			'11332': 234,
			'11333': 233,
			'11334': 232,
			'11335': 255,
			'11336': 237,
			'11337': 236,
			'11338': 236,
			'11339': 255,
			'11340': 247,
			'11341': 248,
			'11342': 248,
			'11343': 255,
			'11344': 215,
			'11345': 214,
			'11346': 212,
			'11347': 255,
			'11348': 183,
			'11349': 180,
			'11350': 178,
			'11351': 255,
			'11352': 242,
			'11353': 242,
			'11354': 240,
			'11355': 255,
			'11356': 233,
			'11357': 232,
			'11358': 230,
			'11359': 255,
			'11360': 192,
			'11361': 189,
			'11362': 187,
			'11363': 255,
			'11364': 231,
			'11365': 231,
			'11366': 229,
			'11367': 255,
			'11368': 239,
			'11369': 239,
			'11370': 239,
			'11371': 255,
			'11372': 232,
			'11373': 231,
			'11374': 230,
			'11375': 255,
			'11376': 218,
			'11377': 217,
			'11378': 215,
			'11379': 255,
			'11380': 218,
			'11381': 216,
			'11382': 214,
			'11383': 255,
			'11384': 228,
			'11385': 227,
			'11386': 225,
			'11387': 255,
			'11388': 222,
			'11389': 221,
			'11390': 219,
			'11391': 255,
			'11392': 201,
			'11393': 198,
			'11394': 198,
			'11395': 255,
			'11396': 165,
			'11397': 159,
			'11398': 160,
			'11399': 255,
			'11400': 142,
			'11401': 133,
			'11402': 134,
			'11403': 255,
			'11404': 155,
			'11405': 149,
			'11406': 148,
			'11407': 255,
			'11408': 213,
			'11409': 212,
			'11410': 210,
			'11411': 255,
			'11412': 212,
			'11413': 210,
			'11414': 208,
			'11415': 255,
			'11416': 177,
			'11417': 173,
			'11418': 172,
			'11419': 255,
			'11420': 155,
			'11421': 147,
			'11422': 148,
			'11423': 255,
			'11424': 96,
			'11425': 85,
			'11426': 86,
			'11427': 255,
			'11428': 91,
			'11429': 80,
			'11430': 79,
			'11431': 255,
			'11432': 68,
			'11433': 59,
			'11434': 59,
			'11435': 255,
			'11436': 65,
			'11437': 55,
			'11438': 55,
			'11439': 255,
			'11440': 93,
			'11441': 82,
			'11442': 81,
			'11443': 255,
			'11444': 93,
			'11445': 82,
			'11446': 82,
			'11447': 255,
			'11448': 161,
			'11449': 156,
			'11450': 156,
			'11451': 255,
			'11452': 196,
			'11453': 194,
			'11454': 193,
			'11455': 255,
			'11456': 149,
			'11457': 144,
			'11458': 144,
			'11459': 255,
			'11460': 38,
			'11461': 26,
			'11462': 27,
			'11463': 255,
			'11464': 124,
			'11465': 117,
			'11466': 117,
			'11467': 255,
			'11468': 237,
			'11469': 237,
			'11470': 235,
			'11471': 255,
			'11472': 230,
			'11473': 229,
			'11474': 227,
			'11475': 255,
			'11476': 221,
			'11477': 220,
			'11478': 218,
			'11479': 255,
			'11480': 221,
			'11481': 220,
			'11482': 218,
			'11483': 255,
			'11484': 224,
			'11485': 223,
			'11486': 221,
			'11487': 255,
			'11488': 223,
			'11489': 222,
			'11490': 220,
			'11491': 255,
			'11492': 216,
			'11493': 216,
			'11494': 214,
			'11495': 255,
			'11496': 214,
			'11497': 213,
			'11498': 211,
			'11499': 255,
			'11500': 215,
			'11501': 213,
			'11502': 212,
			'11503': 255,
			'11504': 220,
			'11505': 217,
			'11506': 215,
			'11507': 255,
			'11508': 221,
			'11509': 219,
			'11510': 217,
			'11511': 255,
			'11512': 212,
			'11513': 210,
			'11514': 208,
			'11515': 255,
			'11516': 199,
			'11517': 194,
			'11518': 194,
			'11519': 255,
			'11520': 204,
			'11521': 203,
			'11522': 201,
			'11523': 255,
			'11524': 205,
			'11525': 201,
			'11526': 200,
			'11527': 255,
			'11528': 191,
			'11529': 187,
			'11530': 186,
			'11531': 255,
			'11532': 191,
			'11533': 187,
			'11534': 186,
			'11535': 255,
			'11536': 200,
			'11537': 196,
			'11538': 195,
			'11539': 255,
			'11540': 203,
			'11541': 199,
			'11542': 198,
			'11543': 255,
			'11544': 197,
			'11545': 193,
			'11546': 192,
			'11547': 255,
			'11548': 195,
			'11549': 191,
			'11550': 190,
			'11551': 255,
			'11552': 192,
			'11553': 188,
			'11554': 187,
			'11555': 255,
			'11556': 189,
			'11557': 185,
			'11558': 184,
			'11559': 255,
			'11560': 187,
			'11561': 183,
			'11562': 182,
			'11563': 255,
			'11564': 185,
			'11565': 181,
			'11566': 180,
			'11567': 255,
			'11568': 182,
			'11569': 178,
			'11570': 177,
			'11571': 255,
			'11572': 181,
			'11573': 176,
			'11574': 176,
			'11575': 255,
			'11576': 179,
			'11577': 174,
			'11578': 173,
			'11579': 255,
			'11580': 177,
			'11581': 173,
			'11582': 172,
			'11583': 255,
			'11584': 173,
			'11585': 169,
			'11586': 167,
			'11587': 255,
			'11588': 170,
			'11589': 166,
			'11590': 165,
			'11591': 255,
			'11592': 168,
			'11593': 163,
			'11594': 162,
			'11595': 255,
			'11596': 168,
			'11597': 164,
			'11598': 162,
			'11599': 255,
			'11600': 226,
			'11601': 225,
			'11602': 223,
			'11603': 255,
			'11604': 221,
			'11605': 220,
			'11606': 218,
			'11607': 255,
			'11608': 221,
			'11609': 221,
			'11610': 219,
			'11611': 255,
			'11612': 221,
			'11613': 220,
			'11614': 218,
			'11615': 255,
			'11616': 223,
			'11617': 223,
			'11618': 222,
			'11619': 255,
			'11620': 225,
			'11621': 224,
			'11622': 222,
			'11623': 255,
			'11624': 227,
			'11625': 226,
			'11626': 224,
			'11627': 255,
			'11628': 230,
			'11629': 229,
			'11630': 227,
			'11631': 255,
			'11632': 229,
			'11633': 228,
			'11634': 226,
			'11635': 255,
			'11636': 232,
			'11637': 231,
			'11638': 229,
			'11639': 255,
			'11640': 231,
			'11641': 231,
			'11642': 229,
			'11643': 255,
			'11644': 229,
			'11645': 228,
			'11646': 226,
			'11647': 255,
			'11648': 233,
			'11649': 232,
			'11650': 230,
			'11651': 255,
			'11652': 231,
			'11653': 231,
			'11654': 229,
			'11655': 255,
			'11656': 231,
			'11657': 230,
			'11658': 228,
			'11659': 255,
			'11660': 231,
			'11661': 230,
			'11662': 228,
			'11663': 255,
			'11664': 236,
			'11665': 236,
			'11666': 235,
			'11667': 255,
			'11668': 237,
			'11669': 236,
			'11670': 237,
			'11671': 255,
			'11672': 235,
			'11673': 235,
			'11674': 234,
			'11675': 255,
			'11676': 241,
			'11677': 241,
			'11678': 241,
			'11679': 255,
			'11680': 230,
			'11681': 229,
			'11682': 228,
			'11683': 255,
			'11684': 232,
			'11685': 232,
			'11686': 230,
			'11687': 255,
			'11688': 239,
			'11689': 239,
			'11690': 238,
			'11691': 255,
			'11692': 240,
			'11693': 239,
			'11694': 240,
			'11695': 255,
			'11696': 240,
			'11697': 239,
			'11698': 240,
			'11699': 255,
			'11700': 231,
			'11701': 230,
			'11702': 229,
			'11703': 255,
			'11704': 234,
			'11705': 234,
			'11706': 231,
			'11707': 255,
			'11708': 237,
			'11709': 237,
			'11710': 236,
			'11711': 255,
			'11712': 238,
			'11713': 237,
			'11714': 237,
			'11715': 255,
			'11716': 240,
			'11717': 239,
			'11718': 239,
			'11719': 255,
			'11720': 240,
			'11721': 239,
			'11722': 238,
			'11723': 255,
			'11724': 240,
			'11725': 239,
			'11726': 238,
			'11727': 255,
			'11728': 239,
			'11729': 239,
			'11730': 239,
			'11731': 255,
			'11732': 239,
			'11733': 239,
			'11734': 238,
			'11735': 255,
			'11736': 238,
			'11737': 238,
			'11738': 239,
			'11739': 255,
			'11740': 240,
			'11741': 241,
			'11742': 240,
			'11743': 255,
			'11744': 229,
			'11745': 229,
			'11746': 228,
			'11747': 255,
			'11748': 190,
			'11749': 187,
			'11750': 185,
			'11751': 255,
			'11752': 238,
			'11753': 238,
			'11754': 236,
			'11755': 255,
			'11756': 213,
			'11757': 211,
			'11758': 210,
			'11759': 255,
			'11760': 197,
			'11761': 194,
			'11762': 193,
			'11763': 255,
			'11764': 241,
			'11765': 242,
			'11766': 241,
			'11767': 255,
			'11768': 236,
			'11769': 236,
			'11770': 235,
			'11771': 255,
			'11772': 231,
			'11773': 230,
			'11774': 228,
			'11775': 255,
			'11776': 230,
			'11777': 229,
			'11778': 227,
			'11779': 255,
			'11780': 216,
			'11781': 215,
			'11782': 212,
			'11783': 255,
			'11784': 190,
			'11785': 187,
			'11786': 186,
			'11787': 255,
			'11788': 183,
			'11789': 179,
			'11790': 178,
			'11791': 255,
			'11792': 185,
			'11793': 182,
			'11794': 180,
			'11795': 255,
			'11796': 173,
			'11797': 169,
			'11798': 168,
			'11799': 255,
			'11800': 180,
			'11801': 177,
			'11802': 175,
			'11803': 255,
			'11804': 208,
			'11805': 203,
			'11806': 202,
			'11807': 255,
			'11808': 221,
			'11809': 219,
			'11810': 217,
			'11811': 255,
			'11812': 204,
			'11813': 202,
			'11814': 200,
			'11815': 255,
			'11816': 175,
			'11817': 171,
			'11818': 170,
			'11819': 255,
			'11820': 160,
			'11821': 153,
			'11822': 153,
			'11823': 255,
			'11824': 132,
			'11825': 123,
			'11826': 124,
			'11827': 255,
			'11828': 101,
			'11829': 91,
			'11830': 91,
			'11831': 255,
			'11832': 131,
			'11833': 121,
			'11834': 123,
			'11835': 255,
			'11836': 148,
			'11837': 139,
			'11838': 140,
			'11839': 255,
			'11840': 146,
			'11841': 136,
			'11842': 137,
			'11843': 255,
			'11844': 147,
			'11845': 140,
			'11846': 140,
			'11847': 255,
			'11848': 166,
			'11849': 162,
			'11850': 160,
			'11851': 255,
			'11852': 196,
			'11853': 193,
			'11854': 191,
			'11855': 255,
			'11856': 132,
			'11857': 126,
			'11858': 126,
			'11859': 255,
			'11860': 59,
			'11861': 48,
			'11862': 49,
			'11863': 255,
			'11864': 132,
			'11865': 125,
			'11866': 124,
			'11867': 255,
			'11868': 220,
			'11869': 218,
			'11870': 217,
			'11871': 255,
			'11872': 233,
			'11873': 233,
			'11874': 231,
			'11875': 255,
			'11876': 223,
			'11877': 222,
			'11878': 220,
			'11879': 255,
			'11880': 220,
			'11881': 219,
			'11882': 217,
			'11883': 255,
			'11884': 226,
			'11885': 225,
			'11886': 223,
			'11887': 255,
			'11888': 222,
			'11889': 220,
			'11890': 219,
			'11891': 255,
			'11892': 209,
			'11893': 206,
			'11894': 204,
			'11895': 255,
			'11896': 213,
			'11897': 209,
			'11898': 208,
			'11899': 255,
			'11900': 207,
			'11901': 203,
			'11902': 202,
			'11903': 255,
			'11904': 198,
			'11905': 196,
			'11906': 195,
			'11907': 255,
			'11908': 186,
			'11909': 181,
			'11910': 180,
			'11911': 255,
			'11912': 169,
			'11913': 164,
			'11914': 163,
			'11915': 255,
			'11916': 184,
			'11917': 180,
			'11918': 180,
			'11919': 255,
			'11920': 208,
			'11921': 206,
			'11922': 204,
			'11923': 255,
			'11924': 203,
			'11925': 199,
			'11926': 198,
			'11927': 255,
			'11928': 193,
			'11929': 189,
			'11930': 188,
			'11931': 255,
			'11932': 191,
			'11933': 187,
			'11934': 186,
			'11935': 255,
			'11936': 195,
			'11937': 191,
			'11938': 190,
			'11939': 255,
			'11940': 184,
			'11941': 180,
			'11942': 179,
			'11943': 255,
			'11944': 191,
			'11945': 187,
			'11946': 186,
			'11947': 255,
			'11948': 191,
			'11949': 187,
			'11950': 186,
			'11951': 255,
			'11952': 187,
			'11953': 183,
			'11954': 182,
			'11955': 255,
			'11956': 188,
			'11957': 184,
			'11958': 183,
			'11959': 255,
			'11960': 189,
			'11961': 185,
			'11962': 184,
			'11963': 255,
			'11964': 190,
			'11965': 186,
			'11966': 185,
			'11967': 255,
			'11968': 189,
			'11969': 185,
			'11970': 184,
			'11971': 255,
			'11972': 185,
			'11973': 182,
			'11974': 180,
			'11975': 255,
			'11976': 180,
			'11977': 177,
			'11978': 176,
			'11979': 255,
			'11980': 179,
			'11981': 176,
			'11982': 175,
			'11983': 255,
			'11984': 177,
			'11985': 174,
			'11986': 171,
			'11987': 255,
			'11988': 174,
			'11989': 170,
			'11990': 169,
			'11991': 255,
			'11992': 171,
			'11993': 167,
			'11994': 167,
			'11995': 255,
			'11996': 174,
			'11997': 171,
			'11998': 169,
			'11999': 255,
			'12000': 231,
			'12001': 230,
			'12002': 228,
			'12003': 255,
			'12004': 232,
			'12005': 231,
			'12006': 229,
			'12007': 255,
			'12008': 215,
			'12009': 213,
			'12010': 211,
			'12011': 255,
			'12012': 215,
			'12013': 214,
			'12014': 212,
			'12015': 255,
			'12016': 229,
			'12017': 229,
			'12018': 228,
			'12019': 255,
			'12020': 230,
			'12021': 229,
			'12022': 227,
			'12023': 255,
			'12024': 230,
			'12025': 229,
			'12026': 227,
			'12027': 255,
			'12028': 230,
			'12029': 229,
			'12030': 226,
			'12031': 255,
			'12032': 228,
			'12033': 228,
			'12034': 226,
			'12035': 255,
			'12036': 229,
			'12037': 228,
			'12038': 226,
			'12039': 255,
			'12040': 234,
			'12041': 233,
			'12042': 231,
			'12043': 255,
			'12044': 234,
			'12045': 233,
			'12046': 231,
			'12047': 255,
			'12048': 227,
			'12049': 226,
			'12050': 224,
			'12051': 255,
			'12052': 230,
			'12053': 230,
			'12054': 228,
			'12055': 255,
			'12056': 229,
			'12057': 229,
			'12058': 227,
			'12059': 255,
			'12060': 229,
			'12061': 227,
			'12062': 226,
			'12063': 255,
			'12064': 234,
			'12065': 233,
			'12066': 232,
			'12067': 255,
			'12068': 236,
			'12069': 235,
			'12070': 235,
			'12071': 255,
			'12072': 234,
			'12073': 234,
			'12074': 233,
			'12075': 255,
			'12076': 237,
			'12077': 237,
			'12078': 236,
			'12079': 255,
			'12080': 239,
			'12081': 239,
			'12082': 240,
			'12083': 255,
			'12084': 238,
			'12085': 238,
			'12086': 238,
			'12087': 255,
			'12088': 238,
			'12089': 238,
			'12090': 238,
			'12091': 255,
			'12092': 238,
			'12093': 238,
			'12094': 239,
			'12095': 255,
			'12096': 238,
			'12097': 238,
			'12098': 238,
			'12099': 255,
			'12100': 235,
			'12101': 235,
			'12102': 234,
			'12103': 255,
			'12104': 236,
			'12105': 235,
			'12106': 234,
			'12107': 255,
			'12108': 236,
			'12109': 235,
			'12110': 234,
			'12111': 255,
			'12112': 238,
			'12113': 238,
			'12114': 238,
			'12115': 255,
			'12116': 240,
			'12117': 240,
			'12118': 241,
			'12119': 255,
			'12120': 240,
			'12121': 239,
			'12122': 240,
			'12123': 255,
			'12124': 240,
			'12125': 240,
			'12126': 240,
			'12127': 255,
			'12128': 235,
			'12129': 235,
			'12130': 233,
			'12131': 255,
			'12132': 234,
			'12133': 234,
			'12134': 233,
			'12135': 255,
			'12136': 238,
			'12137': 238,
			'12138': 239,
			'12139': 255,
			'12140': 234,
			'12141': 234,
			'12142': 234,
			'12143': 255,
			'12144': 242,
			'12145': 242,
			'12146': 241,
			'12147': 255,
			'12148': 216,
			'12149': 215,
			'12150': 213,
			'12151': 255,
			'12152': 199,
			'12153': 196,
			'12154': 194,
			'12155': 255,
			'12156': 187,
			'12157': 183,
			'12158': 182,
			'12159': 255,
			'12160': 228,
			'12161': 227,
			'12162': 225,
			'12163': 255,
			'12164': 239,
			'12165': 239,
			'12166': 237,
			'12167': 255,
			'12168': 234,
			'12169': 234,
			'12170': 233,
			'12171': 255,
			'12172': 231,
			'12173': 231,
			'12174': 229,
			'12175': 255,
			'12176': 227,
			'12177': 226,
			'12178': 224,
			'12179': 255,
			'12180': 221,
			'12181': 220,
			'12182': 218,
			'12183': 255,
			'12184': 201,
			'12185': 196,
			'12186': 195,
			'12187': 255,
			'12188': 175,
			'12189': 170,
			'12190': 170,
			'12191': 255,
			'12192': 165,
			'12193': 161,
			'12194': 159,
			'12195': 255,
			'12196': 169,
			'12197': 164,
			'12198': 162,
			'12199': 255,
			'12200': 197,
			'12201': 194,
			'12202': 193,
			'12203': 255,
			'12204': 221,
			'12205': 218,
			'12206': 217,
			'12207': 255,
			'12208': 226,
			'12209': 226,
			'12210': 224,
			'12211': 255,
			'12212': 204,
			'12213': 203,
			'12214': 201,
			'12215': 255,
			'12216': 173,
			'12217': 169,
			'12218': 168,
			'12219': 255,
			'12220': 158,
			'12221': 154,
			'12222': 153,
			'12223': 255,
			'12224': 165,
			'12225': 160,
			'12226': 160,
			'12227': 255,
			'12228': 149,
			'12229': 143,
			'12230': 143,
			'12231': 255,
			'12232': 136,
			'12233': 128,
			'12234': 128,
			'12235': 255,
			'12236': 144,
			'12237': 136,
			'12238': 136,
			'12239': 255,
			'12240': 158,
			'12241': 152,
			'12242': 152,
			'12243': 255,
			'12244': 174,
			'12245': 170,
			'12246': 169,
			'12247': 255,
			'12248': 174,
			'12249': 170,
			'12250': 168,
			'12251': 255,
			'12252': 192,
			'12253': 188,
			'12254': 187,
			'12255': 255,
			'12256': 123,
			'12257': 116,
			'12258': 116,
			'12259': 255,
			'12260': 78,
			'12261': 67,
			'12262': 67,
			'12263': 255,
			'12264': 139,
			'12265': 132,
			'12266': 131,
			'12267': 255,
			'12268': 223,
			'12269': 223,
			'12270': 221,
			'12271': 255,
			'12272': 223,
			'12273': 222,
			'12274': 220,
			'12275': 255,
			'12276': 223,
			'12277': 222,
			'12278': 220,
			'12279': 255,
			'12280': 223,
			'12281': 222,
			'12282': 220,
			'12283': 255,
			'12284': 222,
			'12285': 221,
			'12286': 219,
			'12287': 255,
			'12288': 217,
			'12289': 216,
			'12290': 214,
			'12291': 255,
			'12292': 208,
			'12293': 205,
			'12294': 204,
			'12295': 255,
			'12296': 210,
			'12297': 206,
			'12298': 205,
			'12299': 255,
			'12300': 195,
			'12301': 193,
			'12302': 191,
			'12303': 255,
			'12304': 173,
			'12305': 168,
			'12306': 167,
			'12307': 255,
			'12308': 167,
			'12309': 162,
			'12310': 162,
			'12311': 255,
			'12312': 184,
			'12313': 179,
			'12314': 178,
			'12315': 255,
			'12316': 197,
			'12317': 194,
			'12318': 192,
			'12319': 255,
			'12320': 200,
			'12321': 195,
			'12322': 194,
			'12323': 255,
			'12324': 196,
			'12325': 192,
			'12326': 191,
			'12327': 255,
			'12328': 194,
			'12329': 190,
			'12330': 189,
			'12331': 255,
			'12332': 201,
			'12333': 196,
			'12334': 195,
			'12335': 255,
			'12336': 195,
			'12337': 191,
			'12338': 190,
			'12339': 255,
			'12340': 182,
			'12341': 178,
			'12342': 177,
			'12343': 255,
			'12344': 182,
			'12345': 178,
			'12346': 177,
			'12347': 255,
			'12348': 174,
			'12349': 170,
			'12350': 169,
			'12351': 255,
			'12352': 171,
			'12353': 167,
			'12354': 166,
			'12355': 255,
			'12356': 177,
			'12357': 173,
			'12358': 172,
			'12359': 255,
			'12360': 174,
			'12361': 170,
			'12362': 169,
			'12363': 255,
			'12364': 166,
			'12365': 161,
			'12366': 160,
			'12367': 255,
			'12368': 164,
			'12369': 158,
			'12370': 158,
			'12371': 255,
			'12372': 167,
			'12373': 163,
			'12374': 161,
			'12375': 255,
			'12376': 166,
			'12377': 162,
			'12378': 162,
			'12379': 255,
			'12380': 165,
			'12381': 160,
			'12382': 159,
			'12383': 255,
			'12384': 162,
			'12385': 156,
			'12386': 155,
			'12387': 255,
			'12388': 162,
			'12389': 157,
			'12390': 157,
			'12391': 255,
			'12392': 156,
			'12393': 150,
			'12394': 150,
			'12395': 255,
			'12396': 153,
			'12397': 148,
			'12398': 147,
			'12399': 255,
			'12400': 219,
			'12401': 218,
			'12402': 217,
			'12403': 255,
			'12404': 230,
			'12405': 229,
			'12406': 227,
			'12407': 255,
			'12408': 216,
			'12409': 214,
			'12410': 212,
			'12411': 255,
			'12412': 208,
			'12413': 206,
			'12414': 204,
			'12415': 255,
			'12416': 218,
			'12417': 217,
			'12418': 215,
			'12419': 255,
			'12420': 216,
			'12421': 215,
			'12422': 213,
			'12423': 255,
			'12424': 215,
			'12425': 214,
			'12426': 212,
			'12427': 255,
			'12428': 215,
			'12429': 215,
			'12430': 212,
			'12431': 255,
			'12432': 217,
			'12433': 215,
			'12434': 213,
			'12435': 255,
			'12436': 214,
			'12437': 212,
			'12438': 210,
			'12439': 255,
			'12440': 220,
			'12441': 219,
			'12442': 217,
			'12443': 255,
			'12444': 231,
			'12445': 230,
			'12446': 228,
			'12447': 255,
			'12448': 216,
			'12449': 215,
			'12450': 213,
			'12451': 255,
			'12452': 213,
			'12453': 212,
			'12454': 210,
			'12455': 255,
			'12456': 225,
			'12457': 223,
			'12458': 221,
			'12459': 255,
			'12460': 215,
			'12461': 214,
			'12462': 212,
			'12463': 255,
			'12464': 212,
			'12465': 211,
			'12466': 208,
			'12467': 255,
			'12468': 224,
			'12469': 223,
			'12470': 220,
			'12471': 255,
			'12472': 230,
			'12473': 230,
			'12474': 227,
			'12475': 255,
			'12476': 226,
			'12477': 225,
			'12478': 223,
			'12479': 255,
			'12480': 225,
			'12481': 225,
			'12482': 223,
			'12483': 255,
			'12484': 228,
			'12485': 227,
			'12486': 226,
			'12487': 255,
			'12488': 232,
			'12489': 232,
			'12490': 231,
			'12491': 255,
			'12492': 230,
			'12493': 229,
			'12494': 228,
			'12495': 255,
			'12496': 224,
			'12497': 223,
			'12498': 221,
			'12499': 255,
			'12500': 229,
			'12501': 228,
			'12502': 226,
			'12503': 255,
			'12504': 226,
			'12505': 225,
			'12506': 223,
			'12507': 255,
			'12508': 225,
			'12509': 225,
			'12510': 223,
			'12511': 255,
			'12512': 230,
			'12513': 229,
			'12514': 227,
			'12515': 255,
			'12516': 231,
			'12517': 230,
			'12518': 228,
			'12519': 255,
			'12520': 231,
			'12521': 231,
			'12522': 229,
			'12523': 255,
			'12524': 233,
			'12525': 233,
			'12526': 232,
			'12527': 255,
			'12528': 232,
			'12529': 232,
			'12530': 230,
			'12531': 255,
			'12532': 235,
			'12533': 235,
			'12534': 234,
			'12535': 255,
			'12536': 235,
			'12537': 235,
			'12538': 235,
			'12539': 255,
			'12540': 234,
			'12541': 234,
			'12542': 235,
			'12543': 255,
			'12544': 233,
			'12545': 232,
			'12546': 231,
			'12547': 255,
			'12548': 232,
			'12549': 232,
			'12550': 229,
			'12551': 255,
			'12552': 154,
			'12553': 149,
			'12554': 148,
			'12555': 255,
			'12556': 179,
			'12557': 173,
			'12558': 173,
			'12559': 255,
			'12560': 246,
			'12561': 247,
			'12562': 245,
			'12563': 255,
			'12564': 230,
			'12565': 229,
			'12566': 227,
			'12567': 255,
			'12568': 234,
			'12569': 234,
			'12570': 232,
			'12571': 255,
			'12572': 229,
			'12573': 228,
			'12574': 226,
			'12575': 255,
			'12576': 220,
			'12577': 219,
			'12578': 217,
			'12579': 255,
			'12580': 214,
			'12581': 212,
			'12582': 210,
			'12583': 255,
			'12584': 201,
			'12585': 197,
			'12586': 196,
			'12587': 255,
			'12588': 187,
			'12589': 183,
			'12590': 182,
			'12591': 255,
			'12592': 178,
			'12593': 174,
			'12594': 173,
			'12595': 255,
			'12596': 179,
			'12597': 174,
			'12598': 173,
			'12599': 255,
			'12600': 206,
			'12601': 203,
			'12602': 202,
			'12603': 255,
			'12604': 225,
			'12605': 226,
			'12606': 223,
			'12607': 255,
			'12608': 220,
			'12609': 220,
			'12610': 217,
			'12611': 255,
			'12612': 200,
			'12613': 196,
			'12614': 195,
			'12615': 255,
			'12616': 172,
			'12617': 168,
			'12618': 167,
			'12619': 255,
			'12620': 163,
			'12621': 159,
			'12622': 157,
			'12623': 255,
			'12624': 166,
			'12625': 163,
			'12626': 162,
			'12627': 255,
			'12628': 180,
			'12629': 177,
			'12630': 176,
			'12631': 255,
			'12632': 177,
			'12633': 173,
			'12634': 172,
			'12635': 255,
			'12636': 174,
			'12637': 170,
			'12638': 169,
			'12639': 255,
			'12640': 179,
			'12641': 176,
			'12642': 176,
			'12643': 255,
			'12644': 173,
			'12645': 169,
			'12646': 168,
			'12647': 255,
			'12648': 170,
			'12649': 166,
			'12650': 163,
			'12651': 255,
			'12652': 184,
			'12653': 181,
			'12654': 179,
			'12655': 255,
			'12656': 130,
			'12657': 123,
			'12658': 123,
			'12659': 255,
			'12660': 126,
			'12661': 116,
			'12662': 118,
			'12663': 255,
			'12664': 192,
			'12665': 189,
			'12666': 188,
			'12667': 255,
			'12668': 226,
			'12669': 226,
			'12670': 223,
			'12671': 255,
			'12672': 218,
			'12673': 217,
			'12674': 215,
			'12675': 255,
			'12676': 221,
			'12677': 220,
			'12678': 218,
			'12679': 255,
			'12680': 214,
			'12681': 213,
			'12682': 211,
			'12683': 255,
			'12684': 210,
			'12685': 209,
			'12686': 207,
			'12687': 255,
			'12688': 215,
			'12689': 215,
			'12690': 213,
			'12691': 255,
			'12692': 208,
			'12693': 206,
			'12694': 205,
			'12695': 255,
			'12696': 205,
			'12697': 202,
			'12698': 201,
			'12699': 255,
			'12700': 210,
			'12701': 207,
			'12702': 206,
			'12703': 255,
			'12704': 204,
			'12705': 200,
			'12706': 199,
			'12707': 255,
			'12708': 199,
			'12709': 195,
			'12710': 194,
			'12711': 255,
			'12712': 199,
			'12713': 195,
			'12714': 194,
			'12715': 255,
			'12716': 185,
			'12717': 181,
			'12718': 180,
			'12719': 255,
			'12720': 179,
			'12721': 174,
			'12722': 173,
			'12723': 255,
			'12724': 193,
			'12725': 189,
			'12726': 188,
			'12727': 255,
			'12728': 188,
			'12729': 184,
			'12730': 183,
			'12731': 255,
			'12732': 190,
			'12733': 186,
			'12734': 185,
			'12735': 255,
			'12736': 187,
			'12737': 183,
			'12738': 182,
			'12739': 255,
			'12740': 188,
			'12741': 184,
			'12742': 183,
			'12743': 255,
			'12744': 185,
			'12745': 181,
			'12746': 180,
			'12747': 255,
			'12748': 181,
			'12749': 177,
			'12750': 176,
			'12751': 255,
			'12752': 180,
			'12753': 177,
			'12754': 176,
			'12755': 255,
			'12756': 178,
			'12757': 174,
			'12758': 173,
			'12759': 255,
			'12760': 171,
			'12761': 168,
			'12762': 167,
			'12763': 255,
			'12764': 164,
			'12765': 159,
			'12766': 159,
			'12767': 255,
			'12768': 161,
			'12769': 157,
			'12770': 156,
			'12771': 255,
			'12772': 162,
			'12773': 156,
			'12774': 155,
			'12775': 255,
			'12776': 162,
			'12777': 157,
			'12778': 157,
			'12779': 255,
			'12780': 160,
			'12781': 155,
			'12782': 154,
			'12783': 255,
			'12784': 153,
			'12785': 146,
			'12786': 146,
			'12787': 255,
			'12788': 154,
			'12789': 146,
			'12790': 147,
			'12791': 255,
			'12792': 145,
			'12793': 138,
			'12794': 138,
			'12795': 255,
			'12796': 141,
			'12797': 134,
			'12798': 134,
			'12799': 255,
			'12800': 190,
			'12801': 187,
			'12802': 186,
			'12803': 255,
			'12804': 196,
			'12805': 194,
			'12806': 192,
			'12807': 255,
			'12808': 229,
			'12809': 228,
			'12810': 226,
			'12811': 255,
			'12812': 220,
			'12813': 219,
			'12814': 217,
			'12815': 255,
			'12816': 219,
			'12817': 218,
			'12818': 216,
			'12819': 255,
			'12820': 222,
			'12821': 221,
			'12822': 219,
			'12823': 255,
			'12824': 221,
			'12825': 220,
			'12826': 218,
			'12827': 255,
			'12828': 222,
			'12829': 221,
			'12830': 219,
			'12831': 255,
			'12832': 223,
			'12833': 222,
			'12834': 220,
			'12835': 255,
			'12836': 224,
			'12837': 222,
			'12838': 220,
			'12839': 255,
			'12840': 222,
			'12841': 222,
			'12842': 219,
			'12843': 255,
			'12844': 226,
			'12845': 225,
			'12846': 223,
			'12847': 255,
			'12848': 228,
			'12849': 227,
			'12850': 225,
			'12851': 255,
			'12852': 225,
			'12853': 223,
			'12854': 222,
			'12855': 255,
			'12856': 228,
			'12857': 227,
			'12858': 225,
			'12859': 255,
			'12860': 226,
			'12861': 225,
			'12862': 223,
			'12863': 255,
			'12864': 220,
			'12865': 219,
			'12866': 217,
			'12867': 255,
			'12868': 224,
			'12869': 223,
			'12870': 221,
			'12871': 255,
			'12872': 230,
			'12873': 229,
			'12874': 227,
			'12875': 255,
			'12876': 228,
			'12877': 227,
			'12878': 225,
			'12879': 255,
			'12880': 227,
			'12881': 227,
			'12882': 224,
			'12883': 255,
			'12884': 227,
			'12885': 226,
			'12886': 224,
			'12887': 255,
			'12888': 233,
			'12889': 232,
			'12890': 230,
			'12891': 255,
			'12892': 235,
			'12893': 234,
			'12894': 232,
			'12895': 255,
			'12896': 226,
			'12897': 225,
			'12898': 223,
			'12899': 255,
			'12900': 228,
			'12901': 227,
			'12902': 226,
			'12903': 255,
			'12904': 217,
			'12905': 216,
			'12906': 214,
			'12907': 255,
			'12908': 225,
			'12909': 223,
			'12910': 221,
			'12911': 255,
			'12912': 228,
			'12913': 227,
			'12914': 226,
			'12915': 255,
			'12916': 222,
			'12917': 221,
			'12918': 219,
			'12919': 255,
			'12920': 217,
			'12921': 215,
			'12922': 213,
			'12923': 255,
			'12924': 217,
			'12925': 216,
			'12926': 214,
			'12927': 255,
			'12928': 228,
			'12929': 227,
			'12930': 225,
			'12931': 255,
			'12932': 232,
			'12933': 232,
			'12934': 230,
			'12935': 255,
			'12936': 228,
			'12937': 227,
			'12938': 225,
			'12939': 255,
			'12940': 232,
			'12941': 231,
			'12942': 229,
			'12943': 255,
			'12944': 230,
			'12945': 230,
			'12946': 228,
			'12947': 255,
			'12948': 222,
			'12949': 221,
			'12950': 218,
			'12951': 255,
			'12952': 200,
			'12953': 198,
			'12954': 197,
			'12955': 255,
			'12956': 192,
			'12957': 188,
			'12958': 187,
			'12959': 255,
			'12960': 211,
			'12961': 209,
			'12962': 207,
			'12963': 255,
			'12964': 227,
			'12965': 226,
			'12966': 224,
			'12967': 255,
			'12968': 235,
			'12969': 234,
			'12970': 232,
			'12971': 255,
			'12972': 231,
			'12973': 229,
			'12974': 227,
			'12975': 255,
			'12976': 224,
			'12977': 223,
			'12978': 221,
			'12979': 255,
			'12980': 216,
			'12981': 213,
			'12982': 212,
			'12983': 255,
			'12984': 204,
			'12985': 199,
			'12986': 198,
			'12987': 255,
			'12988': 196,
			'12989': 192,
			'12990': 191,
			'12991': 255,
			'12992': 181,
			'12993': 177,
			'12994': 176,
			'12995': 255,
			'12996': 182,
			'12997': 178,
			'12998': 177,
			'12999': 255,
			'13000': 205,
			'13001': 201,
			'13002': 200,
			'13003': 255,
			'13004': 208,
			'13005': 206,
			'13006': 204,
			'13007': 255,
			'13008': 209,
			'13009': 207,
			'13010': 205,
			'13011': 255,
			'13012': 197,
			'13013': 193,
			'13014': 192,
			'13015': 255,
			'13016': 175,
			'13017': 171,
			'13018': 170,
			'13019': 255,
			'13020': 167,
			'13021': 162,
			'13022': 162,
			'13023': 255,
			'13024': 155,
			'13025': 149,
			'13026': 149,
			'13027': 255,
			'13028': 157,
			'13029': 152,
			'13030': 152,
			'13031': 255,
			'13032': 182,
			'13033': 178,
			'13034': 177,
			'13035': 255,
			'13036': 183,
			'13037': 180,
			'13038': 179,
			'13039': 255,
			'13040': 181,
			'13041': 177,
			'13042': 176,
			'13043': 255,
			'13044': 176,
			'13045': 172,
			'13046': 170,
			'13047': 255,
			'13048': 171,
			'13049': 166,
			'13050': 163,
			'13051': 255,
			'13052': 178,
			'13053': 176,
			'13054': 173,
			'13055': 255,
			'13056': 153,
			'13057': 148,
			'13058': 148,
			'13059': 255,
			'13060': 146,
			'13061': 137,
			'13062': 138,
			'13063': 255,
			'13064': 217,
			'13065': 217,
			'13066': 215,
			'13067': 255,
			'13068': 226,
			'13069': 225,
			'13070': 223,
			'13071': 255,
			'13072': 222,
			'13073': 221,
			'13074': 219,
			'13075': 255,
			'13076': 220,
			'13077': 219,
			'13078': 217,
			'13079': 255,
			'13080': 215,
			'13081': 214,
			'13082': 212,
			'13083': 255,
			'13084': 214,
			'13085': 213,
			'13086': 211,
			'13087': 255,
			'13088': 216,
			'13089': 215,
			'13090': 213,
			'13091': 255,
			'13092': 213,
			'13093': 212,
			'13094': 210,
			'13095': 255,
			'13096': 212,
			'13097': 211,
			'13098': 210,
			'13099': 255,
			'13100': 212,
			'13101': 208,
			'13102': 207,
			'13103': 255,
			'13104': 210,
			'13105': 205,
			'13106': 204,
			'13107': 255,
			'13108': 206,
			'13109': 202,
			'13110': 201,
			'13111': 255,
			'13112': 202,
			'13113': 198,
			'13114': 197,
			'13115': 255,
			'13116': 204,
			'13117': 200,
			'13118': 199,
			'13119': 255,
			'13120': 199,
			'13121': 196,
			'13122': 195,
			'13123': 255,
			'13124': 197,
			'13125': 193,
			'13126': 192,
			'13127': 255,
			'13128': 189,
			'13129': 186,
			'13130': 184,
			'13131': 255,
			'13132': 191,
			'13133': 187,
			'13134': 186,
			'13135': 255,
			'13136': 185,
			'13137': 181,
			'13138': 180,
			'13139': 255,
			'13140': 180,
			'13141': 176,
			'13142': 175,
			'13143': 255,
			'13144': 186,
			'13145': 182,
			'13146': 181,
			'13147': 255,
			'13148': 183,
			'13149': 179,
			'13150': 178,
			'13151': 255,
			'13152': 183,
			'13153': 179,
			'13154': 178,
			'13155': 255,
			'13156': 182,
			'13157': 178,
			'13158': 177,
			'13159': 255,
			'13160': 182,
			'13161': 178,
			'13162': 177,
			'13163': 255,
			'13164': 176,
			'13165': 172,
			'13166': 171,
			'13167': 255,
			'13168': 171,
			'13169': 167,
			'13170': 166,
			'13171': 255,
			'13172': 167,
			'13173': 163,
			'13174': 162,
			'13175': 255,
			'13176': 164,
			'13177': 160,
			'13178': 159,
			'13179': 255,
			'13180': 163,
			'13181': 159,
			'13182': 158,
			'13183': 255,
			'13184': 161,
			'13185': 157,
			'13186': 156,
			'13187': 255,
			'13188': 159,
			'13189': 153,
			'13190': 153,
			'13191': 255,
			'13192': 158,
			'13193': 152,
			'13194': 153,
			'13195': 255,
			'13196': 160,
			'13197': 153,
			'13198': 154,
			'13199': 255,
			'13200': 205,
			'13201': 200,
			'13202': 199,
			'13203': 255,
			'13204': 210,
			'13205': 208,
			'13206': 207,
			'13207': 255,
			'13208': 226,
			'13209': 225,
			'13210': 223,
			'13211': 255,
			'13212': 223,
			'13213': 223,
			'13214': 221,
			'13215': 255,
			'13216': 224,
			'13217': 223,
			'13218': 221,
			'13219': 255,
			'13220': 226,
			'13221': 225,
			'13222': 223,
			'13223': 255,
			'13224': 227,
			'13225': 226,
			'13226': 224,
			'13227': 255,
			'13228': 228,
			'13229': 227,
			'13230': 225,
			'13231': 255,
			'13232': 226,
			'13233': 226,
			'13234': 224,
			'13235': 255,
			'13236': 228,
			'13237': 228,
			'13238': 227,
			'13239': 255,
			'13240': 230,
			'13241': 228,
			'13242': 227,
			'13243': 255,
			'13244': 228,
			'13245': 227,
			'13246': 225,
			'13247': 255,
			'13248': 230,
			'13249': 229,
			'13250': 227,
			'13251': 255,
			'13252': 232,
			'13253': 231,
			'13254': 229,
			'13255': 255,
			'13256': 230,
			'13257': 229,
			'13258': 228,
			'13259': 255,
			'13260': 231,
			'13261': 229,
			'13262': 228,
			'13263': 255,
			'13264': 232,
			'13265': 232,
			'13266': 230,
			'13267': 255,
			'13268': 233,
			'13269': 233,
			'13270': 231,
			'13271': 255,
			'13272': 233,
			'13273': 232,
			'13274': 230,
			'13275': 255,
			'13276': 234,
			'13277': 232,
			'13278': 230,
			'13279': 255,
			'13280': 233,
			'13281': 233,
			'13282': 231,
			'13283': 255,
			'13284': 240,
			'13285': 241,
			'13286': 239,
			'13287': 255,
			'13288': 232,
			'13289': 232,
			'13290': 230,
			'13291': 255,
			'13292': 228,
			'13293': 227,
			'13294': 226,
			'13295': 255,
			'13296': 235,
			'13297': 235,
			'13298': 233,
			'13299': 255,
			'13300': 236,
			'13301': 236,
			'13302': 235,
			'13303': 255,
			'13304': 231,
			'13305': 231,
			'13306': 230,
			'13307': 255,
			'13308': 235,
			'13309': 235,
			'13310': 235,
			'13311': 255,
			'13312': 237,
			'13313': 237,
			'13314': 237,
			'13315': 255,
			'13316': 235,
			'13317': 235,
			'13318': 234,
			'13319': 255,
			'13320': 228,
			'13321': 227,
			'13322': 225,
			'13323': 255,
			'13324': 217,
			'13325': 216,
			'13326': 213,
			'13327': 255,
			'13328': 232,
			'13329': 231,
			'13330': 229,
			'13331': 255,
			'13332': 231,
			'13333': 231,
			'13334': 229,
			'13335': 255,
			'13336': 233,
			'13337': 234,
			'13338': 233,
			'13339': 255,
			'13340': 235,
			'13341': 235,
			'13342': 234,
			'13343': 255,
			'13344': 236,
			'13345': 236,
			'13346': 235,
			'13347': 255,
			'13348': 230,
			'13349': 230,
			'13350': 229,
			'13351': 255,
			'13352': 244,
			'13353': 244,
			'13354': 242,
			'13355': 255,
			'13356': 217,
			'13357': 215,
			'13358': 214,
			'13359': 255,
			'13360': 176,
			'13361': 172,
			'13362': 171,
			'13363': 255,
			'13364': 216,
			'13365': 214,
			'13366': 213,
			'13367': 255,
			'13368': 236,
			'13369': 235,
			'13370': 233,
			'13371': 255,
			'13372': 232,
			'13373': 231,
			'13374': 229,
			'13375': 255,
			'13376': 228,
			'13377': 228,
			'13378': 226,
			'13379': 255,
			'13380': 219,
			'13381': 217,
			'13382': 216,
			'13383': 255,
			'13384': 210,
			'13385': 207,
			'13386': 205,
			'13387': 255,
			'13388': 182,
			'13389': 179,
			'13390': 177,
			'13391': 255,
			'13392': 161,
			'13393': 155,
			'13394': 155,
			'13395': 255,
			'13396': 205,
			'13397': 202,
			'13398': 201,
			'13399': 255,
			'13400': 233,
			'13401': 231,
			'13402': 230,
			'13403': 255,
			'13404': 216,
			'13405': 213,
			'13406': 212,
			'13407': 255,
			'13408': 208,
			'13409': 204,
			'13410': 203,
			'13411': 255,
			'13412': 192,
			'13413': 188,
			'13414': 187,
			'13415': 255,
			'13416': 181,
			'13417': 176,
			'13418': 175,
			'13419': 255,
			'13420': 178,
			'13421': 175,
			'13422': 174,
			'13423': 255,
			'13424': 179,
			'13425': 176,
			'13426': 174,
			'13427': 255,
			'13428': 121,
			'13429': 113,
			'13430': 113,
			'13431': 255,
			'13432': 135,
			'13433': 126,
			'13434': 126,
			'13435': 255,
			'13436': 178,
			'13437': 174,
			'13438': 174,
			'13439': 255,
			'13440': 173,
			'13441': 169,
			'13442': 167,
			'13443': 255,
			'13444': 170,
			'13445': 166,
			'13446': 164,
			'13447': 255,
			'13448': 169,
			'13449': 165,
			'13450': 164,
			'13451': 255,
			'13452': 170,
			'13453': 166,
			'13454': 165,
			'13455': 255,
			'13456': 157,
			'13457': 149,
			'13458': 150,
			'13459': 255,
			'13460': 165,
			'13461': 158,
			'13462': 158,
			'13463': 255,
			'13464': 227,
			'13465': 226,
			'13466': 224,
			'13467': 255,
			'13468': 223,
			'13469': 222,
			'13470': 220,
			'13471': 255,
			'13472': 220,
			'13473': 219,
			'13474': 217,
			'13475': 255,
			'13476': 218,
			'13477': 217,
			'13478': 215,
			'13479': 255,
			'13480': 219,
			'13481': 218,
			'13482': 216,
			'13483': 255,
			'13484': 218,
			'13485': 217,
			'13486': 215,
			'13487': 255,
			'13488': 217,
			'13489': 215,
			'13490': 213,
			'13491': 255,
			'13492': 215,
			'13493': 215,
			'13494': 212,
			'13495': 255,
			'13496': 214,
			'13497': 212,
			'13498': 211,
			'13499': 255,
			'13500': 213,
			'13501': 208,
			'13502': 207,
			'13503': 255,
			'13504': 210,
			'13505': 208,
			'13506': 206,
			'13507': 255,
			'13508': 209,
			'13509': 207,
			'13510': 206,
			'13511': 255,
			'13512': 210,
			'13513': 206,
			'13514': 205,
			'13515': 255,
			'13516': 211,
			'13517': 208,
			'13518': 207,
			'13519': 255,
			'13520': 209,
			'13521': 206,
			'13522': 205,
			'13523': 255,
			'13524': 204,
			'13525': 201,
			'13526': 200,
			'13527': 255,
			'13528': 204,
			'13529': 202,
			'13530': 200,
			'13531': 255,
			'13532': 202,
			'13533': 198,
			'13534': 197,
			'13535': 255,
			'13536': 199,
			'13537': 195,
			'13538': 194,
			'13539': 255,
			'13540': 196,
			'13541': 192,
			'13542': 191,
			'13543': 255,
			'13544': 193,
			'13545': 189,
			'13546': 188,
			'13547': 255,
			'13548': 192,
			'13549': 188,
			'13550': 187,
			'13551': 255,
			'13552': 192,
			'13553': 188,
			'13554': 187,
			'13555': 255,
			'13556': 186,
			'13557': 182,
			'13558': 181,
			'13559': 255,
			'13560': 185,
			'13561': 181,
			'13562': 180,
			'13563': 255,
			'13564': 184,
			'13565': 180,
			'13566': 179,
			'13567': 255,
			'13568': 178,
			'13569': 175,
			'13570': 174,
			'13571': 255,
			'13572': 176,
			'13573': 174,
			'13574': 172,
			'13575': 255,
			'13576': 170,
			'13577': 166,
			'13578': 165,
			'13579': 255,
			'13580': 162,
			'13581': 157,
			'13582': 156,
			'13583': 255,
			'13584': 162,
			'13585': 157,
			'13586': 156,
			'13587': 255,
			'13588': 161,
			'13589': 157,
			'13590': 157,
			'13591': 255,
			'13592': 163,
			'13593': 157,
			'13594': 157,
			'13595': 255,
			'13596': 165,
			'13597': 159,
			'13598': 159,
			'13599': 255,
			'13600': 210,
			'13601': 208,
			'13602': 207,
			'13603': 255,
			'13604': 222,
			'13605': 222,
			'13606': 220,
			'13607': 255,
			'13608': 224,
			'13609': 224,
			'13610': 222,
			'13611': 255,
			'13612': 221,
			'13613': 221,
			'13614': 219,
			'13615': 255,
			'13616': 221,
			'13617': 221,
			'13618': 219,
			'13619': 255,
			'13620': 224,
			'13621': 223,
			'13622': 221,
			'13623': 255,
			'13624': 225,
			'13625': 224,
			'13626': 222,
			'13627': 255,
			'13628': 226,
			'13629': 225,
			'13630': 223,
			'13631': 255,
			'13632': 226,
			'13633': 225,
			'13634': 224,
			'13635': 255,
			'13636': 226,
			'13637': 225,
			'13638': 227,
			'13639': 255,
			'13640': 228,
			'13641': 226,
			'13642': 227,
			'13643': 255,
			'13644': 228,
			'13645': 227,
			'13646': 225,
			'13647': 255,
			'13648': 228,
			'13649': 227,
			'13650': 224,
			'13651': 255,
			'13652': 228,
			'13653': 227,
			'13654': 225,
			'13655': 255,
			'13656': 229,
			'13657': 229,
			'13658': 227,
			'13659': 255,
			'13660': 230,
			'13661': 229,
			'13662': 230,
			'13663': 255,
			'13664': 231,
			'13665': 230,
			'13666': 228,
			'13667': 255,
			'13668': 231,
			'13669': 230,
			'13670': 228,
			'13671': 255,
			'13672': 231,
			'13673': 231,
			'13674': 229,
			'13675': 255,
			'13676': 234,
			'13677': 233,
			'13678': 231,
			'13679': 255,
			'13680': 231,
			'13681': 230,
			'13682': 229,
			'13683': 255,
			'13684': 230,
			'13685': 229,
			'13686': 227,
			'13687': 255,
			'13688': 214,
			'13689': 213,
			'13690': 211,
			'13691': 255,
			'13692': 216,
			'13693': 214,
			'13694': 212,
			'13695': 255,
			'13696': 217,
			'13697': 215,
			'13698': 213,
			'13699': 255,
			'13700': 225,
			'13701': 225,
			'13702': 223,
			'13703': 255,
			'13704': 236,
			'13705': 237,
			'13706': 235,
			'13707': 255,
			'13708': 234,
			'13709': 235,
			'13710': 234,
			'13711': 255,
			'13712': 232,
			'13713': 232,
			'13714': 230,
			'13715': 255,
			'13716': 234,
			'13717': 234,
			'13718': 232,
			'13719': 255,
			'13720': 233,
			'13721': 233,
			'13722': 231,
			'13723': 255,
			'13724': 223,
			'13725': 222,
			'13726': 220,
			'13727': 255,
			'13728': 233,
			'13729': 233,
			'13730': 231,
			'13731': 255,
			'13732': 232,
			'13733': 232,
			'13734': 230,
			'13735': 255,
			'13736': 232,
			'13737': 232,
			'13738': 230,
			'13739': 255,
			'13740': 235,
			'13741': 235,
			'13742': 235,
			'13743': 255,
			'13744': 234,
			'13745': 234,
			'13746': 233,
			'13747': 255,
			'13748': 236,
			'13749': 236,
			'13750': 237,
			'13751': 255,
			'13752': 246,
			'13753': 247,
			'13754': 246,
			'13755': 255,
			'13756': 205,
			'13757': 203,
			'13758': 201,
			'13759': 255,
			'13760': 153,
			'13761': 146,
			'13762': 146,
			'13763': 255,
			'13764': 205,
			'13765': 202,
			'13766': 200,
			'13767': 255,
			'13768': 233,
			'13769': 233,
			'13770': 230,
			'13771': 255,
			'13772': 234,
			'13773': 233,
			'13774': 231,
			'13775': 255,
			'13776': 232,
			'13777': 232,
			'13778': 230,
			'13779': 255,
			'13780': 223,
			'13781': 222,
			'13782': 220,
			'13783': 255,
			'13784': 194,
			'13785': 190,
			'13786': 189,
			'13787': 255,
			'13788': 146,
			'13789': 139,
			'13790': 139,
			'13791': 255,
			'13792': 167,
			'13793': 161,
			'13794': 161,
			'13795': 255,
			'13796': 195,
			'13797': 192,
			'13798': 191,
			'13799': 255,
			'13800': 208,
			'13801': 207,
			'13802': 205,
			'13803': 255,
			'13804': 243,
			'13805': 243,
			'13806': 240,
			'13807': 255,
			'13808': 250,
			'13809': 251,
			'13810': 249,
			'13811': 255,
			'13812': 211,
			'13813': 209,
			'13814': 208,
			'13815': 255,
			'13816': 188,
			'13817': 185,
			'13818': 184,
			'13819': 255,
			'13820': 161,
			'13821': 157,
			'13822': 156,
			'13823': 255,
			'13824': 163,
			'13825': 157,
			'13826': 157,
			'13827': 255,
			'13828': 133,
			'13829': 125,
			'13830': 125,
			'13831': 255,
			'13832': 87,
			'13833': 76,
			'13834': 76,
			'13835': 255,
			'13836': 148,
			'13837': 139,
			'13838': 140,
			'13839': 255,
			'13840': 168,
			'13841': 165,
			'13842': 164,
			'13843': 255,
			'13844': 161,
			'13845': 158,
			'13846': 157,
			'13847': 255,
			'13848': 169,
			'13849': 166,
			'13850': 165,
			'13851': 255,
			'13852': 160,
			'13853': 154,
			'13854': 154,
			'13855': 255,
			'13856': 129,
			'13857': 119,
			'13858': 121,
			'13859': 255,
			'13860': 184,
			'13861': 180,
			'13862': 180,
			'13863': 255,
			'13864': 231,
			'13865': 230,
			'13866': 228,
			'13867': 255,
			'13868': 219,
			'13869': 218,
			'13870': 216,
			'13871': 255,
			'13872': 217,
			'13873': 216,
			'13874': 214,
			'13875': 255,
			'13876': 218,
			'13877': 217,
			'13878': 215,
			'13879': 255,
			'13880': 217,
			'13881': 216,
			'13882': 214,
			'13883': 255,
			'13884': 216,
			'13885': 214,
			'13886': 212,
			'13887': 255,
			'13888': 214,
			'13889': 213,
			'13890': 211,
			'13891': 255,
			'13892': 213,
			'13893': 211,
			'13894': 209,
			'13895': 255,
			'13896': 214,
			'13897': 209,
			'13898': 209,
			'13899': 255,
			'13900': 212,
			'13901': 209,
			'13902': 208,
			'13903': 255,
			'13904': 209,
			'13905': 209,
			'13906': 206,
			'13907': 255,
			'13908': 209,
			'13909': 205,
			'13910': 204,
			'13911': 255,
			'13912': 207,
			'13913': 204,
			'13914': 203,
			'13915': 255,
			'13916': 204,
			'13917': 202,
			'13918': 201,
			'13919': 255,
			'13920': 204,
			'13921': 199,
			'13922': 198,
			'13923': 255,
			'13924': 202,
			'13925': 200,
			'13926': 198,
			'13927': 255,
			'13928': 200,
			'13929': 198,
			'13930': 196,
			'13931': 255,
			'13932': 198,
			'13933': 194,
			'13934': 193,
			'13935': 255,
			'13936': 197,
			'13937': 193,
			'13938': 192,
			'13939': 255,
			'13940': 195,
			'13941': 191,
			'13942': 190,
			'13943': 255,
			'13944': 193,
			'13945': 189,
			'13946': 188,
			'13947': 255,
			'13948': 192,
			'13949': 188,
			'13950': 187,
			'13951': 255,
			'13952': 190,
			'13953': 186,
			'13954': 185,
			'13955': 255,
			'13956': 186,
			'13957': 182,
			'13958': 181,
			'13959': 255,
			'13960': 183,
			'13961': 179,
			'13962': 178,
			'13963': 255,
			'13964': 181,
			'13965': 177,
			'13966': 176,
			'13967': 255,
			'13968': 179,
			'13969': 175,
			'13970': 174,
			'13971': 255,
			'13972': 180,
			'13973': 178,
			'13974': 176,
			'13975': 255,
			'13976': 171,
			'13977': 167,
			'13978': 166,
			'13979': 255,
			'13980': 155,
			'13981': 150,
			'13982': 150,
			'13983': 255,
			'13984': 156,
			'13985': 151,
			'13986': 151,
			'13987': 255,
			'13988': 165,
			'13989': 161,
			'13990': 159,
			'13991': 255,
			'13992': 165,
			'13993': 160,
			'13994': 158,
			'13995': 255,
			'13996': 167,
			'13997': 164,
			'13998': 163,
			'13999': 255,
			'14000': 207,
			'14001': 206,
			'14002': 204,
			'14003': 255,
			'14004': 215,
			'14005': 214,
			'14006': 212,
			'14007': 255,
			'14008': 226,
			'14009': 224,
			'14010': 223,
			'14011': 255,
			'14012': 222,
			'14013': 221,
			'14014': 219,
			'14015': 255,
			'14016': 222,
			'14017': 221,
			'14018': 219,
			'14019': 255,
			'14020': 223,
			'14021': 222,
			'14022': 220,
			'14023': 255,
			'14024': 225,
			'14025': 223,
			'14026': 221,
			'14027': 255,
			'14028': 224,
			'14029': 224,
			'14030': 222,
			'14031': 255,
			'14032': 226,
			'14033': 226,
			'14034': 224,
			'14035': 255,
			'14036': 227,
			'14037': 226,
			'14038': 224,
			'14039': 255,
			'14040': 227,
			'14041': 225,
			'14042': 226,
			'14043': 255,
			'14044': 228,
			'14045': 228,
			'14046': 227,
			'14047': 255,
			'14048': 227,
			'14049': 227,
			'14050': 225,
			'14051': 255,
			'14052': 227,
			'14053': 226,
			'14054': 224,
			'14055': 255,
			'14056': 228,
			'14057': 227,
			'14058': 224,
			'14059': 255,
			'14060': 230,
			'14061': 230,
			'14062': 228,
			'14063': 255,
			'14064': 230,
			'14065': 229,
			'14066': 227,
			'14067': 255,
			'14068': 231,
			'14069': 231,
			'14070': 229,
			'14071': 255,
			'14072': 231,
			'14073': 230,
			'14074': 228,
			'14075': 255,
			'14076': 231,
			'14077': 231,
			'14078': 229,
			'14079': 255,
			'14080': 242,
			'14081': 242,
			'14082': 242,
			'14083': 255,
			'14084': 213,
			'14085': 211,
			'14086': 211,
			'14087': 255,
			'14088': 191,
			'14089': 189,
			'14090': 187,
			'14091': 255,
			'14092': 218,
			'14093': 218,
			'14094': 216,
			'14095': 255,
			'14096': 207,
			'14097': 205,
			'14098': 203,
			'14099': 255,
			'14100': 222,
			'14101': 222,
			'14102': 220,
			'14103': 255,
			'14104': 229,
			'14105': 229,
			'14106': 226,
			'14107': 255,
			'14108': 230,
			'14109': 230,
			'14110': 228,
			'14111': 255,
			'14112': 230,
			'14113': 230,
			'14114': 228,
			'14115': 255,
			'14116': 232,
			'14117': 231,
			'14118': 229,
			'14119': 255,
			'14120': 234,
			'14121': 234,
			'14122': 232,
			'14123': 255,
			'14124': 222,
			'14125': 221,
			'14126': 219,
			'14127': 255,
			'14128': 222,
			'14129': 221,
			'14130': 220,
			'14131': 255,
			'14132': 230,
			'14133': 230,
			'14134': 228,
			'14135': 255,
			'14136': 230,
			'14137': 230,
			'14138': 228,
			'14139': 255,
			'14140': 232,
			'14141': 232,
			'14142': 230,
			'14143': 255,
			'14144': 233,
			'14145': 233,
			'14146': 231,
			'14147': 255,
			'14148': 235,
			'14149': 234,
			'14150': 233,
			'14151': 255,
			'14152': 245,
			'14153': 245,
			'14154': 243,
			'14155': 255,
			'14156': 200,
			'14157': 198,
			'14158': 196,
			'14159': 255,
			'14160': 141,
			'14161': 133,
			'14162': 133,
			'14163': 255,
			'14164': 192,
			'14165': 188,
			'14166': 187,
			'14167': 255,
			'14168': 219,
			'14169': 218,
			'14170': 215,
			'14171': 255,
			'14172': 226,
			'14173': 225,
			'14174': 223,
			'14175': 255,
			'14176': 235,
			'14177': 234,
			'14178': 232,
			'14179': 255,
			'14180': 203,
			'14181': 200,
			'14182': 199,
			'14183': 255,
			'14184': 126,
			'14185': 117,
			'14186': 118,
			'14187': 255,
			'14188': 89,
			'14189': 78,
			'14190': 79,
			'14191': 255,
			'14192': 112,
			'14193': 104,
			'14194': 103,
			'14195': 255,
			'14196': 97,
			'14197': 87,
			'14198': 88,
			'14199': 255,
			'14200': 87,
			'14201': 79,
			'14202': 79,
			'14203': 255,
			'14204': 133,
			'14205': 125,
			'14206': 125,
			'14207': 255,
			'14208': 209,
			'14209': 206,
			'14210': 205,
			'14211': 255,
			'14212': 232,
			'14213': 230,
			'14214': 229,
			'14215': 255,
			'14216': 144,
			'14217': 139,
			'14218': 139,
			'14219': 255,
			'14220': 61,
			'14221': 51,
			'14222': 52,
			'14223': 255,
			'14224': 59,
			'14225': 48,
			'14226': 48,
			'14227': 255,
			'14228': 110,
			'14229': 101,
			'14230': 101,
			'14231': 255,
			'14232': 89,
			'14233': 81,
			'14234': 79,
			'14235': 255,
			'14236': 110,
			'14237': 100,
			'14238': 101,
			'14239': 255,
			'14240': 163,
			'14241': 155,
			'14242': 157,
			'14243': 255,
			'14244': 162,
			'14245': 156,
			'14246': 156,
			'14247': 255,
			'14248': 167,
			'14249': 162,
			'14250': 161,
			'14251': 255,
			'14252': 138,
			'14253': 130,
			'14254': 130,
			'14255': 255,
			'14256': 114,
			'14257': 105,
			'14258': 106,
			'14259': 255,
			'14260': 207,
			'14261': 205,
			'14262': 204,
			'14263': 255,
			'14264': 227,
			'14265': 228,
			'14266': 225,
			'14267': 255,
			'14268': 216,
			'14269': 215,
			'14270': 213,
			'14271': 255,
			'14272': 217,
			'14273': 216,
			'14274': 214,
			'14275': 255,
			'14276': 217,
			'14277': 216,
			'14278': 214,
			'14279': 255,
			'14280': 215,
			'14281': 215,
			'14282': 213,
			'14283': 255,
			'14284': 214,
			'14285': 214,
			'14286': 212,
			'14287': 255,
			'14288': 213,
			'14289': 213,
			'14290': 210,
			'14291': 255,
			'14292': 214,
			'14293': 211,
			'14294': 209,
			'14295': 255,
			'14296': 212,
			'14297': 209,
			'14298': 207,
			'14299': 255,
			'14300': 208,
			'14301': 208,
			'14302': 206,
			'14303': 255,
			'14304': 209,
			'14305': 206,
			'14306': 205,
			'14307': 255,
			'14308': 208,
			'14309': 205,
			'14310': 204,
			'14311': 255,
			'14312': 203,
			'14313': 202,
			'14314': 200,
			'14315': 255,
			'14316': 205,
			'14317': 200,
			'14318': 200,
			'14319': 255,
			'14320': 204,
			'14321': 200,
			'14322': 199,
			'14323': 255,
			'14324': 200,
			'14325': 198,
			'14326': 197,
			'14327': 255,
			'14328': 198,
			'14329': 194,
			'14330': 193,
			'14331': 255,
			'14332': 197,
			'14333': 193,
			'14334': 192,
			'14335': 255,
			'14336': 194,
			'14337': 190,
			'14338': 189,
			'14339': 255,
			'14340': 190,
			'14341': 186,
			'14342': 185,
			'14343': 255,
			'14344': 191,
			'14345': 187,
			'14346': 186,
			'14347': 255,
			'14348': 190,
			'14349': 186,
			'14350': 185,
			'14351': 255,
			'14352': 188,
			'14353': 184,
			'14354': 183,
			'14355': 255,
			'14356': 187,
			'14357': 183,
			'14358': 182,
			'14359': 255,
			'14360': 183,
			'14361': 179,
			'14362': 178,
			'14363': 255,
			'14364': 179,
			'14365': 176,
			'14366': 175,
			'14367': 255,
			'14368': 178,
			'14369': 174,
			'14370': 173,
			'14371': 255,
			'14372': 179,
			'14373': 175,
			'14374': 174,
			'14375': 255,
			'14376': 170,
			'14377': 166,
			'14378': 165,
			'14379': 255,
			'14380': 162,
			'14381': 158,
			'14382': 157,
			'14383': 255,
			'14384': 164,
			'14385': 160,
			'14386': 159,
			'14387': 255,
			'14388': 163,
			'14389': 159,
			'14390': 158,
			'14391': 255,
			'14392': 162,
			'14393': 158,
			'14394': 156,
			'14395': 255,
			'14396': 163,
			'14397': 160,
			'14398': 159,
			'14399': 255,
			'14400': 214,
			'14401': 213,
			'14402': 211,
			'14403': 255,
			'14404': 222,
			'14405': 221,
			'14406': 219,
			'14407': 255,
			'14408': 221,
			'14409': 218,
			'14410': 216,
			'14411': 255,
			'14412': 222,
			'14413': 218,
			'14414': 216,
			'14415': 255,
			'14416': 221,
			'14417': 220,
			'14418': 218,
			'14419': 255,
			'14420': 222,
			'14421': 221,
			'14422': 219,
			'14423': 255,
			'14424': 224,
			'14425': 223,
			'14426': 221,
			'14427': 255,
			'14428': 224,
			'14429': 223,
			'14430': 221,
			'14431': 255,
			'14432': 222,
			'14433': 222,
			'14434': 220,
			'14435': 255,
			'14436': 223,
			'14437': 222,
			'14438': 219,
			'14439': 255,
			'14440': 224,
			'14441': 223,
			'14442': 221,
			'14443': 255,
			'14444': 224,
			'14445': 224,
			'14446': 222,
			'14447': 255,
			'14448': 227,
			'14449': 226,
			'14450': 224,
			'14451': 255,
			'14452': 228,
			'14453': 227,
			'14454': 225,
			'14455': 255,
			'14456': 227,
			'14457': 226,
			'14458': 225,
			'14459': 255,
			'14460': 229,
			'14461': 228,
			'14462': 226,
			'14463': 255,
			'14464': 229,
			'14465': 229,
			'14466': 227,
			'14467': 255,
			'14468': 230,
			'14469': 229,
			'14470': 227,
			'14471': 255,
			'14472': 230,
			'14473': 230,
			'14474': 228,
			'14475': 255,
			'14476': 228,
			'14477': 228,
			'14478': 226,
			'14479': 255,
			'14480': 244,
			'14481': 245,
			'14482': 244,
			'14483': 255,
			'14484': 218,
			'14485': 217,
			'14486': 217,
			'14487': 255,
			'14488': 189,
			'14489': 186,
			'14490': 185,
			'14491': 255,
			'14492': 231,
			'14493': 230,
			'14494': 228,
			'14495': 255,
			'14496': 232,
			'14497': 231,
			'14498': 229,
			'14499': 255,
			'14500': 232,
			'14501': 231,
			'14502': 229,
			'14503': 255,
			'14504': 228,
			'14505': 228,
			'14506': 226,
			'14507': 255,
			'14508': 228,
			'14509': 227,
			'14510': 225,
			'14511': 255,
			'14512': 228,
			'14513': 227,
			'14514': 225,
			'14515': 255,
			'14516': 228,
			'14517': 227,
			'14518': 225,
			'14519': 255,
			'14520': 237,
			'14521': 236,
			'14522': 234,
			'14523': 255,
			'14524': 217,
			'14525': 216,
			'14526': 214,
			'14527': 255,
			'14528': 214,
			'14529': 212,
			'14530': 211,
			'14531': 255,
			'14532': 226,
			'14533': 225,
			'14534': 223,
			'14535': 255,
			'14536': 228,
			'14537': 228,
			'14538': 227,
			'14539': 255,
			'14540': 229,
			'14541': 228,
			'14542': 226,
			'14543': 255,
			'14544': 230,
			'14545': 230,
			'14546': 227,
			'14547': 255,
			'14548': 231,
			'14549': 231,
			'14550': 228,
			'14551': 255,
			'14552': 243,
			'14553': 244,
			'14554': 242,
			'14555': 255,
			'14556': 200,
			'14557': 197,
			'14558': 196,
			'14559': 255,
			'14560': 144,
			'14561': 138,
			'14562': 137,
			'14563': 255,
			'14564': 191,
			'14565': 187,
			'14566': 187,
			'14567': 255,
			'14568': 198,
			'14569': 194,
			'14570': 193,
			'14571': 255,
			'14572': 206,
			'14573': 203,
			'14574': 202,
			'14575': 255,
			'14576': 211,
			'14577': 210,
			'14578': 208,
			'14579': 255,
			'14580': 131,
			'14581': 123,
			'14582': 124,
			'14583': 255,
			'14584': 61,
			'14585': 50,
			'14586': 50,
			'14587': 255,
			'14588': 68,
			'14589': 57,
			'14590': 57,
			'14591': 255,
			'14592': 88,
			'14593': 77,
			'14594': 77,
			'14595': 255,
			'14596': 68,
			'14597': 57,
			'14598': 58,
			'14599': 255,
			'14600': 39,
			'14601': 27,
			'14602': 26,
			'14603': 255,
			'14604': 39,
			'14605': 27,
			'14606': 26,
			'14607': 255,
			'14608': 56,
			'14609': 46,
			'14610': 44,
			'14611': 255,
			'14612': 82,
			'14613': 72,
			'14614': 71,
			'14615': 255,
			'14616': 66,
			'14617': 55,
			'14618': 55,
			'14619': 255,
			'14620': 44,
			'14621': 33,
			'14622': 31,
			'14623': 255,
			'14624': 40,
			'14625': 30,
			'14626': 28,
			'14627': 255,
			'14628': 63,
			'14629': 53,
			'14630': 51,
			'14631': 255,
			'14632': 74,
			'14633': 64,
			'14634': 63,
			'14635': 255,
			'14636': 77,
			'14637': 67,
			'14638': 66,
			'14639': 255,
			'14640': 141,
			'14641': 132,
			'14642': 133,
			'14643': 255,
			'14644': 162,
			'14645': 152,
			'14646': 154,
			'14647': 255,
			'14648': 156,
			'14649': 147,
			'14650': 149,
			'14651': 255,
			'14652': 105,
			'14653': 95,
			'14654': 96,
			'14655': 255,
			'14656': 99,
			'14657': 90,
			'14658': 90,
			'14659': 255,
			'14660': 220,
			'14661': 218,
			'14662': 216,
			'14663': 255,
			'14664': 222,
			'14665': 222,
			'14666': 220,
			'14667': 255,
			'14668': 214,
			'14669': 214,
			'14670': 211,
			'14671': 255,
			'14672': 216,
			'14673': 215,
			'14674': 213,
			'14675': 255,
			'14676': 214,
			'14677': 214,
			'14678': 212,
			'14679': 255,
			'14680': 214,
			'14681': 212,
			'14682': 211,
			'14683': 255,
			'14684': 215,
			'14685': 213,
			'14686': 211,
			'14687': 255,
			'14688': 214,
			'14689': 211,
			'14690': 210,
			'14691': 255,
			'14692': 210,
			'14693': 208,
			'14694': 206,
			'14695': 255,
			'14696': 208,
			'14697': 207,
			'14698': 205,
			'14699': 255,
			'14700': 208,
			'14701': 206,
			'14702': 205,
			'14703': 255,
			'14704': 210,
			'14705': 205,
			'14706': 204,
			'14707': 255,
			'14708': 206,
			'14709': 203,
			'14710': 202,
			'14711': 255,
			'14712': 203,
			'14713': 201,
			'14714': 199,
			'14715': 255,
			'14716': 202,
			'14717': 198,
			'14718': 197,
			'14719': 255,
			'14720': 201,
			'14721': 198,
			'14722': 196,
			'14723': 255,
			'14724': 201,
			'14725': 197,
			'14726': 196,
			'14727': 255,
			'14728': 197,
			'14729': 193,
			'14730': 192,
			'14731': 255,
			'14732': 196,
			'14733': 192,
			'14734': 191,
			'14735': 255,
			'14736': 193,
			'14737': 189,
			'14738': 188,
			'14739': 255,
			'14740': 188,
			'14741': 184,
			'14742': 183,
			'14743': 255,
			'14744': 189,
			'14745': 185,
			'14746': 184,
			'14747': 255,
			'14748': 188,
			'14749': 184,
			'14750': 183,
			'14751': 255,
			'14752': 186,
			'14753': 182,
			'14754': 181,
			'14755': 255,
			'14756': 185,
			'14757': 181,
			'14758': 180,
			'14759': 255,
			'14760': 182,
			'14761': 178,
			'14762': 177,
			'14763': 255,
			'14764': 179,
			'14765': 175,
			'14766': 175,
			'14767': 255,
			'14768': 177,
			'14769': 174,
			'14770': 172,
			'14771': 255,
			'14772': 175,
			'14773': 171,
			'14774': 168,
			'14775': 255,
			'14776': 170,
			'14777': 166,
			'14778': 164,
			'14779': 255,
			'14780': 164,
			'14781': 161,
			'14782': 160,
			'14783': 255,
			'14784': 161,
			'14785': 157,
			'14786': 156,
			'14787': 255,
			'14788': 162,
			'14789': 158,
			'14790': 157,
			'14791': 255,
			'14792': 161,
			'14793': 157,
			'14794': 157,
			'14795': 255,
			'14796': 164,
			'14797': 159,
			'14798': 158,
			'14799': 255,
			'14800': 213,
			'14801': 212,
			'14802': 209,
			'14803': 255,
			'14804': 221,
			'14805': 221,
			'14806': 219,
			'14807': 255,
			'14808': 218,
			'14809': 218,
			'14810': 216,
			'14811': 255,
			'14812': 220,
			'14813': 218,
			'14814': 216,
			'14815': 255,
			'14816': 221,
			'14817': 219,
			'14818': 217,
			'14819': 255,
			'14820': 222,
			'14821': 219,
			'14822': 217,
			'14823': 255,
			'14824': 223,
			'14825': 222,
			'14826': 221,
			'14827': 255,
			'14828': 226,
			'14829': 225,
			'14830': 224,
			'14831': 255,
			'14832': 219,
			'14833': 218,
			'14834': 216,
			'14835': 255,
			'14836': 215,
			'14837': 214,
			'14838': 212,
			'14839': 255,
			'14840': 222,
			'14841': 221,
			'14842': 219,
			'14843': 255,
			'14844': 222,
			'14845': 221,
			'14846': 219,
			'14847': 255,
			'14848': 227,
			'14849': 225,
			'14850': 224,
			'14851': 255,
			'14852': 227,
			'14853': 227,
			'14854': 227,
			'14855': 255,
			'14856': 226,
			'14857': 225,
			'14858': 226,
			'14859': 255,
			'14860': 227,
			'14861': 226,
			'14862': 225,
			'14863': 255,
			'14864': 228,
			'14865': 227,
			'14866': 225,
			'14867': 255,
			'14868': 230,
			'14869': 228,
			'14870': 226,
			'14871': 255,
			'14872': 230,
			'14873': 230,
			'14874': 228,
			'14875': 255,
			'14876': 229,
			'14877': 228,
			'14878': 226,
			'14879': 255,
			'14880': 235,
			'14881': 234,
			'14882': 233,
			'14883': 255,
			'14884': 223,
			'14885': 221,
			'14886': 220,
			'14887': 255,
			'14888': 212,
			'14889': 210,
			'14890': 208,
			'14891': 255,
			'14892': 229,
			'14893': 229,
			'14894': 227,
			'14895': 255,
			'14896': 229,
			'14897': 228,
			'14898': 226,
			'14899': 255,
			'14900': 229,
			'14901': 228,
			'14902': 226,
			'14903': 255,
			'14904': 228,
			'14905': 227,
			'14906': 225,
			'14907': 255,
			'14908': 228,
			'14909': 227,
			'14910': 225,
			'14911': 255,
			'14912': 227,
			'14913': 226,
			'14914': 224,
			'14915': 255,
			'14916': 225,
			'14917': 224,
			'14918': 222,
			'14919': 255,
			'14920': 231,
			'14921': 230,
			'14922': 228,
			'14923': 255,
			'14924': 220,
			'14925': 220,
			'14926': 217,
			'14927': 255,
			'14928': 208,
			'14929': 207,
			'14930': 205,
			'14931': 255,
			'14932': 225,
			'14933': 224,
			'14934': 222,
			'14935': 255,
			'14936': 225,
			'14937': 224,
			'14938': 222,
			'14939': 255,
			'14940': 220,
			'14941': 219,
			'14942': 217,
			'14943': 255,
			'14944': 231,
			'14945': 230,
			'14946': 228,
			'14947': 255,
			'14948': 228,
			'14949': 228,
			'14950': 225,
			'14951': 255,
			'14952': 238,
			'14953': 239,
			'14954': 238,
			'14955': 255,
			'14956': 201,
			'14957': 199,
			'14958': 198,
			'14959': 255,
			'14960': 164,
			'14961': 159,
			'14962': 158,
			'14963': 255,
			'14964': 203,
			'14965': 199,
			'14966': 198,
			'14967': 255,
			'14968': 186,
			'14969': 182,
			'14970': 181,
			'14971': 255,
			'14972': 187,
			'14973': 184,
			'14974': 182,
			'14975': 255,
			'14976': 182,
			'14977': 177,
			'14978': 176,
			'14979': 255,
			'14980': 84,
			'14981': 74,
			'14982': 74,
			'14983': 255,
			'14984': 66,
			'14985': 55,
			'14986': 54,
			'14987': 255,
			'14988': 99,
			'14989': 90,
			'14990': 90,
			'14991': 255,
			'14992': 144,
			'14993': 138,
			'14994': 138,
			'14995': 255,
			'14996': 157,
			'14997': 152,
			'14998': 150,
			'14999': 255,
			'15000': 123,
			'15001': 116,
			'15002': 115,
			'15003': 255,
			'15004': 82,
			'15005': 73,
			'15006': 72,
			'15007': 255,
			'15008': 30,
			'15009': 20,
			'15010': 20,
			'15011': 255,
			'15012': 42,
			'15013': 31,
			'15014': 30,
			'15015': 255,
			'15016': 70,
			'15017': 59,
			'15018': 59,
			'15019': 255,
			'15020': 75,
			'15021': 66,
			'15022': 66,
			'15023': 255,
			'15024': 78,
			'15025': 67,
			'15026': 67,
			'15027': 255,
			'15028': 75,
			'15029': 65,
			'15030': 64,
			'15031': 255,
			'15032': 62,
			'15033': 52,
			'15034': 51,
			'15035': 255,
			'15036': 54,
			'15037': 44,
			'15038': 42,
			'15039': 255,
			'15040': 95,
			'15041': 86,
			'15042': 84,
			'15043': 255,
			'15044': 141,
			'15045': 133,
			'15046': 132,
			'15047': 255,
			'15048': 133,
			'15049': 124,
			'15050': 125,
			'15051': 255,
			'15052': 79,
			'15053': 68,
			'15054': 69,
			'15055': 255,
			'15056': 112,
			'15057': 104,
			'15058': 104,
			'15059': 255,
			'15060': 226,
			'15061': 226,
			'15062': 224,
			'15063': 255,
			'15064': 216,
			'15065': 214,
			'15066': 213,
			'15067': 255,
			'15068': 213,
			'15069': 210,
			'15070': 209,
			'15071': 255,
			'15072': 212,
			'15073': 211,
			'15074': 209,
			'15075': 255,
			'15076': 213,
			'15077': 212,
			'15078': 210,
			'15079': 255,
			'15080': 214,
			'15081': 210,
			'15082': 209,
			'15083': 255,
			'15084': 213,
			'15085': 209,
			'15086': 208,
			'15087': 255,
			'15088': 211,
			'15089': 208,
			'15090': 207,
			'15091': 255,
			'15092': 208,
			'15093': 205,
			'15094': 204,
			'15095': 255,
			'15096': 208,
			'15097': 203,
			'15098': 203,
			'15099': 255,
			'15100': 206,
			'15101': 202,
			'15102': 201,
			'15103': 255,
			'15104': 205,
			'15105': 202,
			'15106': 201,
			'15107': 255,
			'15108': 203,
			'15109': 199,
			'15110': 199,
			'15111': 255,
			'15112': 202,
			'15113': 199,
			'15114': 198,
			'15115': 255,
			'15116': 198,
			'15117': 195,
			'15118': 194,
			'15119': 255,
			'15120': 197,
			'15121': 193,
			'15122': 192,
			'15123': 255,
			'15124': 197,
			'15125': 193,
			'15126': 192,
			'15127': 255,
			'15128': 195,
			'15129': 191,
			'15130': 190,
			'15131': 255,
			'15132': 192,
			'15133': 188,
			'15134': 187,
			'15135': 255,
			'15136': 192,
			'15137': 188,
			'15138': 187,
			'15139': 255,
			'15140': 190,
			'15141': 186,
			'15142': 185,
			'15143': 255,
			'15144': 187,
			'15145': 183,
			'15146': 182,
			'15147': 255,
			'15148': 185,
			'15149': 181,
			'15150': 180,
			'15151': 255,
			'15152': 182,
			'15153': 178,
			'15154': 177,
			'15155': 255,
			'15156': 181,
			'15157': 177,
			'15158': 176,
			'15159': 255,
			'15160': 180,
			'15161': 175,
			'15162': 175,
			'15163': 255,
			'15164': 178,
			'15165': 174,
			'15166': 173,
			'15167': 255,
			'15168': 174,
			'15169': 171,
			'15170': 169,
			'15171': 255,
			'15172': 169,
			'15173': 165,
			'15174': 163,
			'15175': 255,
			'15176': 161,
			'15177': 156,
			'15178': 156,
			'15179': 255,
			'15180': 161,
			'15181': 157,
			'15182': 156,
			'15183': 255,
			'15184': 158,
			'15185': 154,
			'15186': 153,
			'15187': 255,
			'15188': 161,
			'15189': 157,
			'15190': 156,
			'15191': 255,
			'15192': 161,
			'15193': 157,
			'15194': 156,
			'15195': 255,
			'15196': 163,
			'15197': 157,
			'15198': 157,
			'15199': 255,
			'15200': 215,
			'15201': 212,
			'15202': 211,
			'15203': 255,
			'15204': 219,
			'15205': 218,
			'15206': 216,
			'15207': 255,
			'15208': 220,
			'15209': 220,
			'15210': 217,
			'15211': 255,
			'15212': 220,
			'15213': 219,
			'15214': 217,
			'15215': 255,
			'15216': 221,
			'15217': 218,
			'15218': 216,
			'15219': 255,
			'15220': 222,
			'15221': 219,
			'15222': 217,
			'15223': 255,
			'15224': 222,
			'15225': 221,
			'15226': 220,
			'15227': 255,
			'15228': 223,
			'15229': 222,
			'15230': 221,
			'15231': 255,
			'15232': 223,
			'15233': 222,
			'15234': 219,
			'15235': 255,
			'15236': 220,
			'15237': 219,
			'15238': 217,
			'15239': 255,
			'15240': 225,
			'15241': 224,
			'15242': 222,
			'15243': 255,
			'15244': 226,
			'15245': 225,
			'15246': 223,
			'15247': 255,
			'15248': 226,
			'15249': 225,
			'15250': 223,
			'15251': 255,
			'15252': 227,
			'15253': 226,
			'15254': 225,
			'15255': 255,
			'15256': 226,
			'15257': 226,
			'15258': 224,
			'15259': 255,
			'15260': 226,
			'15261': 226,
			'15262': 224,
			'15263': 255,
			'15264': 227,
			'15265': 226,
			'15266': 224,
			'15267': 255,
			'15268': 229,
			'15269': 227,
			'15270': 225,
			'15271': 255,
			'15272': 228,
			'15273': 227,
			'15274': 225,
			'15275': 255,
			'15276': 226,
			'15277': 225,
			'15278': 223,
			'15279': 255,
			'15280': 228,
			'15281': 227,
			'15282': 224,
			'15283': 255,
			'15284': 230,
			'15285': 228,
			'15286': 227,
			'15287': 255,
			'15288': 228,
			'15289': 228,
			'15290': 227,
			'15291': 255,
			'15292': 226,
			'15293': 226,
			'15294': 224,
			'15295': 255,
			'15296': 228,
			'15297': 227,
			'15298': 225,
			'15299': 255,
			'15300': 226,
			'15301': 225,
			'15302': 223,
			'15303': 255,
			'15304': 225,
			'15305': 224,
			'15306': 222,
			'15307': 255,
			'15308': 229,
			'15309': 228,
			'15310': 226,
			'15311': 255,
			'15312': 233,
			'15313': 232,
			'15314': 230,
			'15315': 255,
			'15316': 216,
			'15317': 215,
			'15318': 213,
			'15319': 255,
			'15320': 205,
			'15321': 202,
			'15322': 201,
			'15323': 255,
			'15324': 226,
			'15325': 224,
			'15326': 223,
			'15327': 255,
			'15328': 218,
			'15329': 217,
			'15330': 215,
			'15331': 255,
			'15332': 224,
			'15333': 223,
			'15334': 221,
			'15335': 255,
			'15336': 222,
			'15337': 221,
			'15338': 219,
			'15339': 255,
			'15340': 223,
			'15341': 222,
			'15342': 220,
			'15343': 255,
			'15344': 227,
			'15345': 226,
			'15346': 225,
			'15347': 255,
			'15348': 223,
			'15349': 223,
			'15350': 221,
			'15351': 255,
			'15352': 231,
			'15353': 230,
			'15354': 228,
			'15355': 255,
			'15356': 218,
			'15357': 216,
			'15358': 214,
			'15359': 255,
			'15360': 170,
			'15361': 167,
			'15362': 165,
			'15363': 255,
			'15364': 199,
			'15365': 195,
			'15366': 194,
			'15367': 255,
			'15368': 189,
			'15369': 185,
			'15370': 184,
			'15371': 255,
			'15372': 172,
			'15373': 168,
			'15374': 167,
			'15375': 255,
			'15376': 187,
			'15377': 183,
			'15378': 182,
			'15379': 255,
			'15380': 93,
			'15381': 83,
			'15382': 83,
			'15383': 255,
			'15384': 56,
			'15385': 44,
			'15386': 43,
			'15387': 255,
			'15388': 65,
			'15389': 55,
			'15390': 54,
			'15391': 255,
			'15392': 38,
			'15393': 28,
			'15394': 29,
			'15395': 255,
			'15396': 170,
			'15397': 166,
			'15398': 165,
			'15399': 255,
			'15400': 249,
			'15401': 250,
			'15402': 248,
			'15403': 255,
			'15404': 217,
			'15405': 214,
			'15406': 213,
			'15407': 255,
			'15408': 174,
			'15409': 169,
			'15410': 169,
			'15411': 255,
			'15412': 150,
			'15413': 143,
			'15414': 143,
			'15415': 255,
			'15416': 131,
			'15417': 122,
			'15418': 123,
			'15419': 255,
			'15420': 127,
			'15421': 118,
			'15422': 119,
			'15423': 255,
			'15424': 93,
			'15425': 84,
			'15426': 83,
			'15427': 255,
			'15428': 70,
			'15429': 61,
			'15430': 61,
			'15431': 255,
			'15432': 64,
			'15433': 54,
			'15434': 52,
			'15435': 255,
			'15436': 45,
			'15437': 35,
			'15438': 34,
			'15439': 255,
			'15440': 74,
			'15441': 64,
			'15442': 63,
			'15443': 255,
			'15444': 106,
			'15445': 97,
			'15446': 95,
			'15447': 255,
			'15448': 94,
			'15449': 85,
			'15450': 84,
			'15451': 255,
			'15452': 53,
			'15453': 41,
			'15454': 41,
			'15455': 255,
			'15456': 120,
			'15457': 113,
			'15458': 113,
			'15459': 255,
			'15460': 231,
			'15461': 231,
			'15462': 229,
			'15463': 255,
			'15464': 213,
			'15465': 210,
			'15466': 209,
			'15467': 255,
			'15468': 209,
			'15469': 207,
			'15470': 206,
			'15471': 255,
			'15472': 209,
			'15473': 208,
			'15474': 206,
			'15475': 255,
			'15476': 211,
			'15477': 209,
			'15478': 208,
			'15479': 255,
			'15480': 210,
			'15481': 207,
			'15482': 205,
			'15483': 255,
			'15484': 209,
			'15485': 207,
			'15486': 205,
			'15487': 255,
			'15488': 207,
			'15489': 205,
			'15490': 203,
			'15491': 255,
			'15492': 206,
			'15493': 201,
			'15494': 200,
			'15495': 255,
			'15496': 203,
			'15497': 200,
			'15498': 199,
			'15499': 255,
			'15500': 203,
			'15501': 199,
			'15502': 198,
			'15503': 255,
			'15504': 202,
			'15505': 198,
			'15506': 197,
			'15507': 255,
			'15508': 200,
			'15509': 196,
			'15510': 195,
			'15511': 255,
			'15512': 199,
			'15513': 195,
			'15514': 194,
			'15515': 255,
			'15516': 197,
			'15517': 193,
			'15518': 192,
			'15519': 255,
			'15520': 195,
			'15521': 190,
			'15522': 189,
			'15523': 255,
			'15524': 194,
			'15525': 190,
			'15526': 189,
			'15527': 255,
			'15528': 192,
			'15529': 188,
			'15530': 187,
			'15531': 255,
			'15532': 189,
			'15533': 185,
			'15534': 184,
			'15535': 255,
			'15536': 187,
			'15537': 183,
			'15538': 182,
			'15539': 255,
			'15540': 186,
			'15541': 182,
			'15542': 181,
			'15543': 255,
			'15544': 184,
			'15545': 180,
			'15546': 179,
			'15547': 255,
			'15548': 181,
			'15549': 177,
			'15550': 176,
			'15551': 255,
			'15552': 179,
			'15553': 175,
			'15554': 174,
			'15555': 255,
			'15556': 179,
			'15557': 175,
			'15558': 174,
			'15559': 255,
			'15560': 177,
			'15561': 173,
			'15562': 172,
			'15563': 255,
			'15564': 175,
			'15565': 171,
			'15566': 170,
			'15567': 255,
			'15568': 172,
			'15569': 168,
			'15570': 166,
			'15571': 255,
			'15572': 166,
			'15573': 162,
			'15574': 162,
			'15575': 255,
			'15576': 160,
			'15577': 155,
			'15578': 154,
			'15579': 255,
			'15580': 161,
			'15581': 156,
			'15582': 156,
			'15583': 255,
			'15584': 158,
			'15585': 153,
			'15586': 152,
			'15587': 255,
			'15588': 159,
			'15589': 155,
			'15590': 154,
			'15591': 255,
			'15592': 160,
			'15593': 156,
			'15594': 154,
			'15595': 255,
			'15596': 163,
			'15597': 156,
			'15598': 156,
			'15599': 255,
			'15600': 213,
			'15601': 211,
			'15602': 209,
			'15603': 255,
			'15604': 212,
			'15605': 209,
			'15606': 208,
			'15607': 255,
			'15608': 219,
			'15609': 219,
			'15610': 216,
			'15611': 255,
			'15612': 220,
			'15613': 219,
			'15614': 217,
			'15615': 255,
			'15616': 219,
			'15617': 218,
			'15618': 216,
			'15619': 255,
			'15620': 218,
			'15621': 218,
			'15622': 216,
			'15623': 255,
			'15624': 221,
			'15625': 220,
			'15626': 218,
			'15627': 255,
			'15628': 222,
			'15629': 221,
			'15630': 218,
			'15631': 255,
			'15632': 222,
			'15633': 221,
			'15634': 219,
			'15635': 255,
			'15636': 223,
			'15637': 222,
			'15638': 220,
			'15639': 255,
			'15640': 222,
			'15641': 222,
			'15642': 219,
			'15643': 255,
			'15644': 223,
			'15645': 222,
			'15646': 220,
			'15647': 255,
			'15648': 225,
			'15649': 224,
			'15650': 222,
			'15651': 255,
			'15652': 225,
			'15653': 224,
			'15654': 222,
			'15655': 255,
			'15656': 226,
			'15657': 225,
			'15658': 223,
			'15659': 255,
			'15660': 227,
			'15661': 227,
			'15662': 224,
			'15663': 255,
			'15664': 225,
			'15665': 224,
			'15666': 222,
			'15667': 255,
			'15668': 224,
			'15669': 223,
			'15670': 221,
			'15671': 255,
			'15672': 226,
			'15673': 225,
			'15674': 223,
			'15675': 255,
			'15676': 224,
			'15677': 223,
			'15678': 221,
			'15679': 255,
			'15680': 225,
			'15681': 224,
			'15682': 221,
			'15683': 255,
			'15684': 226,
			'15685': 225,
			'15686': 224,
			'15687': 255,
			'15688': 226,
			'15689': 225,
			'15690': 223,
			'15691': 255,
			'15692': 226,
			'15693': 225,
			'15694': 223,
			'15695': 255,
			'15696': 227,
			'15697': 226,
			'15698': 224,
			'15699': 255,
			'15700': 227,
			'15701': 226,
			'15702': 224,
			'15703': 255,
			'15704': 224,
			'15705': 223,
			'15706': 221,
			'15707': 255,
			'15708': 227,
			'15709': 226,
			'15710': 224,
			'15711': 255,
			'15712': 229,
			'15713': 228,
			'15714': 226,
			'15715': 255,
			'15716': 230,
			'15717': 229,
			'15718': 227,
			'15719': 255,
			'15720': 208,
			'15721': 204,
			'15722': 203,
			'15723': 255,
			'15724': 211,
			'15725': 209,
			'15726': 207,
			'15727': 255,
			'15728': 228,
			'15729': 227,
			'15730': 225,
			'15731': 255,
			'15732': 220,
			'15733': 219,
			'15734': 217,
			'15735': 255,
			'15736': 215,
			'15737': 214,
			'15738': 212,
			'15739': 255,
			'15740': 222,
			'15741': 221,
			'15742': 219,
			'15743': 255,
			'15744': 220,
			'15745': 219,
			'15746': 217,
			'15747': 255,
			'15748': 220,
			'15749': 218,
			'15750': 216,
			'15751': 255,
			'15752': 228,
			'15753': 226,
			'15754': 224,
			'15755': 255,
			'15756': 227,
			'15757': 227,
			'15758': 224,
			'15759': 255,
			'15760': 168,
			'15761': 164,
			'15762': 163,
			'15763': 255,
			'15764': 182,
			'15765': 178,
			'15766': 177,
			'15767': 255,
			'15768': 196,
			'15769': 193,
			'15770': 192,
			'15771': 255,
			'15772': 160,
			'15773': 156,
			'15774': 155,
			'15775': 255,
			'15776': 168,
			'15777': 163,
			'15778': 163,
			'15779': 255,
			'15780': 90,
			'15781': 81,
			'15782': 80,
			'15783': 255,
			'15784': 87,
			'15785': 77,
			'15786': 77,
			'15787': 255,
			'15788': 153,
			'15789': 146,
			'15790': 147,
			'15791': 255,
			'15792': 128,
			'15793': 122,
			'15794': 122,
			'15795': 255,
			'15796': 110,
			'15797': 101,
			'15798': 102,
			'15799': 255,
			'15800': 131,
			'15801': 123,
			'15802': 124,
			'15803': 255,
			'15804': 168,
			'15805': 163,
			'15806': 162,
			'15807': 255,
			'15808': 172,
			'15809': 167,
			'15810': 167,
			'15811': 255,
			'15812': 155,
			'15813': 149,
			'15814': 149,
			'15815': 255,
			'15816': 128,
			'15817': 120,
			'15818': 121,
			'15819': 255,
			'15820': 93,
			'15821': 83,
			'15822': 83,
			'15823': 255,
			'15824': 50,
			'15825': 42,
			'15826': 40,
			'15827': 255,
			'15828': 46,
			'15829': 37,
			'15830': 37,
			'15831': 255,
			'15832': 65,
			'15833': 54,
			'15834': 54,
			'15835': 255,
			'15836': 52,
			'15837': 42,
			'15838': 40,
			'15839': 255,
			'15840': 70,
			'15841': 60,
			'15842': 60,
			'15843': 255,
			'15844': 80,
			'15845': 70,
			'15846': 69,
			'15847': 255,
			'15848': 66,
			'15849': 55,
			'15850': 54,
			'15851': 255,
			'15852': 41,
			'15853': 30,
			'15854': 29,
			'15855': 255,
			'15856': 147,
			'15857': 141,
			'15858': 140,
			'15859': 255,
			'15860': 231,
			'15861': 231,
			'15862': 228,
			'15863': 255,
			'15864': 211,
			'15865': 209,
			'15866': 207,
			'15867': 255,
			'15868': 209,
			'15869': 208,
			'15870': 206,
			'15871': 255,
			'15872': 208,
			'15873': 207,
			'15874': 205,
			'15875': 255,
			'15876': 207,
			'15877': 206,
			'15878': 204,
			'15879': 255,
			'15880': 208,
			'15881': 208,
			'15882': 205,
			'15883': 255,
			'15884': 207,
			'15885': 205,
			'15886': 203,
			'15887': 255,
			'15888': 204,
			'15889': 201,
			'15890': 199,
			'15891': 255,
			'15892': 205,
			'15893': 201,
			'15894': 200,
			'15895': 255,
			'15896': 204,
			'15897': 203,
			'15898': 201,
			'15899': 255,
			'15900': 203,
			'15901': 201,
			'15902': 199,
			'15903': 255,
			'15904': 203,
			'15905': 199,
			'15906': 198,
			'15907': 255,
			'15908': 200,
			'15909': 196,
			'15910': 195,
			'15911': 255,
			'15912': 199,
			'15913': 195,
			'15914': 194,
			'15915': 255,
			'15916': 197,
			'15917': 193,
			'15918': 192,
			'15919': 255,
			'15920': 195,
			'15921': 191,
			'15922': 190,
			'15923': 255,
			'15924': 194,
			'15925': 190,
			'15926': 189,
			'15927': 255,
			'15928': 191,
			'15929': 187,
			'15930': 186,
			'15931': 255,
			'15932': 189,
			'15933': 185,
			'15934': 184,
			'15935': 255,
			'15936': 187,
			'15937': 183,
			'15938': 182,
			'15939': 255,
			'15940': 187,
			'15941': 183,
			'15942': 182,
			'15943': 255,
			'15944': 185,
			'15945': 181,
			'15946': 180,
			'15947': 255,
			'15948': 181,
			'15949': 177,
			'15950': 176,
			'15951': 255,
			'15952': 181,
			'15953': 177,
			'15954': 176,
			'15955': 255,
			'15956': 179,
			'15957': 175,
			'15958': 174,
			'15959': 255,
			'15960': 176,
			'15961': 172,
			'15962': 171,
			'15963': 255,
			'15964': 175,
			'15965': 171,
			'15966': 170,
			'15967': 255,
			'15968': 171,
			'15969': 167,
			'15970': 166,
			'15971': 255,
			'15972': 172,
			'15973': 168,
			'15974': 167,
			'15975': 255,
			'15976': 165,
			'15977': 162,
			'15978': 161,
			'15979': 255,
			'15980': 155,
			'15981': 148,
			'15982': 148,
			'15983': 255,
			'15984': 158,
			'15985': 151,
			'15986': 152,
			'15987': 255,
			'15988': 160,
			'15989': 157,
			'15990': 156,
			'15991': 255,
			'15992': 159,
			'15993': 154,
			'15994': 153,
			'15995': 255,
			'15996': 163,
			'15997': 157,
			'15998': 156,
			'15999': 255,
			'16000': 213,
			'16001': 211,
			'16002': 209,
			'16003': 255,
			'16004': 211,
			'16005': 207,
			'16006': 206,
			'16007': 255,
			'16008': 216,
			'16009': 215,
			'16010': 213,
			'16011': 255,
			'16012': 216,
			'16013': 215,
			'16014': 213,
			'16015': 255,
			'16016': 219,
			'16017': 218,
			'16018': 216,
			'16019': 255,
			'16020': 217,
			'16021': 216,
			'16022': 214,
			'16023': 255,
			'16024': 218,
			'16025': 218,
			'16026': 215,
			'16027': 255,
			'16028': 220,
			'16029': 219,
			'16030': 217,
			'16031': 255,
			'16032': 220,
			'16033': 219,
			'16034': 217,
			'16035': 255,
			'16036': 221,
			'16037': 220,
			'16038': 218,
			'16039': 255,
			'16040': 221,
			'16041': 220,
			'16042': 218,
			'16043': 255,
			'16044': 222,
			'16045': 220,
			'16046': 218,
			'16047': 255,
			'16048': 223,
			'16049': 222,
			'16050': 220,
			'16051': 255,
			'16052': 224,
			'16053': 223,
			'16054': 221,
			'16055': 255,
			'16056': 224,
			'16057': 223,
			'16058': 221,
			'16059': 255,
			'16060': 226,
			'16061': 225,
			'16062': 223,
			'16063': 255,
			'16064': 221,
			'16065': 220,
			'16066': 218,
			'16067': 255,
			'16068': 220,
			'16069': 219,
			'16070': 217,
			'16071': 255,
			'16072': 221,
			'16073': 220,
			'16074': 218,
			'16075': 255,
			'16076': 224,
			'16077': 223,
			'16078': 221,
			'16079': 255,
			'16080': 224,
			'16081': 223,
			'16082': 221,
			'16083': 255,
			'16084': 221,
			'16085': 219,
			'16086': 217,
			'16087': 255,
			'16088': 223,
			'16089': 222,
			'16090': 219,
			'16091': 255,
			'16092': 223,
			'16093': 222,
			'16094': 220,
			'16095': 255,
			'16096': 224,
			'16097': 222,
			'16098': 220,
			'16099': 255,
			'16100': 226,
			'16101': 225,
			'16102': 223,
			'16103': 255,
			'16104': 227,
			'16105': 226,
			'16106': 224,
			'16107': 255,
			'16108': 226,
			'16109': 225,
			'16110': 223,
			'16111': 255,
			'16112': 223,
			'16113': 222,
			'16114': 220,
			'16115': 255,
			'16116': 222,
			'16117': 221,
			'16118': 219,
			'16119': 255,
			'16120': 225,
			'16121': 224,
			'16122': 222,
			'16123': 255,
			'16124': 222,
			'16125': 221,
			'16126': 219,
			'16127': 255,
			'16128': 223,
			'16129': 222,
			'16130': 220,
			'16131': 255,
			'16132': 214,
			'16133': 213,
			'16134': 211,
			'16135': 255,
			'16136': 222,
			'16137': 221,
			'16138': 219,
			'16139': 255,
			'16140': 221,
			'16141': 220,
			'16142': 218,
			'16143': 255,
			'16144': 217,
			'16145': 217,
			'16146': 214,
			'16147': 255,
			'16148': 217,
			'16149': 216,
			'16150': 214,
			'16151': 255,
			'16152': 222,
			'16153': 221,
			'16154': 219,
			'16155': 255,
			'16156': 232,
			'16157': 233,
			'16158': 231,
			'16159': 255,
			'16160': 168,
			'16161': 163,
			'16162': 163,
			'16163': 255,
			'16164': 162,
			'16165': 156,
			'16166': 156,
			'16167': 255,
			'16168': 205,
			'16169': 203,
			'16170': 201,
			'16171': 255,
			'16172': 166,
			'16173': 161,
			'16174': 160,
			'16175': 255,
			'16176': 146,
			'16177': 139,
			'16178': 140,
			'16179': 255,
			'16180': 82,
			'16181': 72,
			'16182': 73,
			'16183': 255,
			'16184': 116,
			'16185': 107,
			'16186': 107,
			'16187': 255,
			'16188': 194,
			'16189': 190,
			'16190': 190,
			'16191': 255,
			'16192': 236,
			'16193': 234,
			'16194': 233,
			'16195': 255,
			'16196': 204,
			'16197': 200,
			'16198': 199,
			'16199': 255,
			'16200': 133,
			'16201': 127,
			'16202': 127,
			'16203': 255,
			'16204': 109,
			'16205': 100,
			'16206': 101,
			'16207': 255,
			'16208': 111,
			'16209': 101,
			'16210': 102,
			'16211': 255,
			'16212': 123,
			'16213': 113,
			'16214': 115,
			'16215': 255,
			'16216': 124,
			'16217': 116,
			'16218': 117,
			'16219': 255,
			'16220': 116,
			'16221': 107,
			'16222': 108,
			'16223': 255,
			'16224': 148,
			'16225': 138,
			'16226': 139,
			'16227': 255,
			'16228': 140,
			'16229': 132,
			'16230': 132,
			'16231': 255,
			'16232': 76,
			'16233': 66,
			'16234': 66,
			'16235': 255,
			'16236': 56,
			'16237': 46,
			'16238': 45,
			'16239': 255,
			'16240': 70,
			'16241': 60,
			'16242': 59,
			'16243': 255,
			'16244': 63,
			'16245': 53,
			'16246': 53,
			'16247': 255,
			'16248': 52,
			'16249': 42,
			'16250': 41,
			'16251': 255,
			'16252': 58,
			'16253': 47,
			'16254': 47,
			'16255': 255,
			'16256': 187,
			'16257': 184,
			'16258': 183,
			'16259': 255,
			'16260': 221,
			'16261': 221,
			'16262': 218,
			'16263': 255,
			'16264': 209,
			'16265': 208,
			'16266': 205,
			'16267': 255,
			'16268': 212,
			'16269': 212,
			'16270': 209,
			'16271': 255,
			'16272': 209,
			'16273': 208,
			'16274': 206,
			'16275': 255,
			'16276': 207,
			'16277': 205,
			'16278': 204,
			'16279': 255,
			'16280': 209,
			'16281': 207,
			'16282': 205,
			'16283': 255,
			'16284': 210,
			'16285': 207,
			'16286': 206,
			'16287': 255,
			'16288': 206,
			'16289': 203,
			'16290': 201,
			'16291': 255,
			'16292': 206,
			'16293': 205,
			'16294': 203,
			'16295': 255,
			'16296': 207,
			'16297': 204,
			'16298': 203,
			'16299': 255,
			'16300': 204,
			'16301': 200,
			'16302': 198,
			'16303': 255,
			'16304': 202,
			'16305': 198,
			'16306': 197,
			'16307': 255,
			'16308': 200,
			'16309': 196,
			'16310': 195,
			'16311': 255,
			'16312': 200,
			'16313': 196,
			'16314': 195,
			'16315': 255,
			'16316': 197,
			'16317': 193,
			'16318': 192,
			'16319': 255,
			'16320': 195,
			'16321': 191,
			'16322': 190,
			'16323': 255,
			'16324': 194,
			'16325': 190,
			'16326': 189,
			'16327': 255,
			'16328': 191,
			'16329': 187,
			'16330': 186,
			'16331': 255,
			'16332': 190,
			'16333': 186,
			'16334': 185,
			'16335': 255,
			'16336': 187,
			'16337': 183,
			'16338': 182,
			'16339': 255,
			'16340': 186,
			'16341': 182,
			'16342': 181,
			'16343': 255,
			'16344': 186,
			'16345': 182,
			'16346': 181,
			'16347': 255,
			'16348': 183,
			'16349': 179,
			'16350': 178,
			'16351': 255,
			'16352': 179,
			'16353': 175,
			'16354': 174,
			'16355': 255,
			'16356': 178,
			'16357': 174,
			'16358': 174,
			'16359': 255,
			'16360': 176,
			'16361': 172,
			'16362': 171,
			'16363': 255,
			'16364': 174,
			'16365': 170,
			'16366': 169,
			'16367': 255,
			'16368': 172,
			'16369': 168,
			'16370': 167,
			'16371': 255,
			'16372': 170,
			'16373': 166,
			'16374': 165,
			'16375': 255,
			'16376': 161,
			'16377': 156,
			'16378': 155,
			'16379': 255,
			'16380': 152,
			'16381': 147,
			'16382': 147,
			'16383': 255,
			'16384': 158,
			'16385': 153,
			'16386': 153,
			'16387': 255,
			'16388': 163,
			'16389': 160,
			'16390': 159,
			'16391': 255,
			'16392': 159,
			'16393': 154,
			'16394': 154,
			'16395': 255,
			'16396': 161,
			'16397': 155,
			'16398': 155,
			'16399': 255,
			'16400': 217,
			'16401': 213,
			'16402': 212,
			'16403': 255,
			'16404': 216,
			'16405': 216,
			'16406': 214,
			'16407': 255,
			'16408': 215,
			'16409': 214,
			'16410': 212,
			'16411': 255,
			'16412': 216,
			'16413': 215,
			'16414': 213,
			'16415': 255,
			'16416': 217,
			'16417': 216,
			'16418': 214,
			'16419': 255,
			'16420': 217,
			'16421': 217,
			'16422': 215,
			'16423': 255,
			'16424': 217,
			'16425': 216,
			'16426': 215,
			'16427': 255,
			'16428': 218,
			'16429': 217,
			'16430': 215,
			'16431': 255,
			'16432': 219,
			'16433': 218,
			'16434': 216,
			'16435': 255,
			'16436': 220,
			'16437': 219,
			'16438': 217,
			'16439': 255,
			'16440': 223,
			'16441': 220,
			'16442': 219,
			'16443': 255,
			'16444': 222,
			'16445': 218,
			'16446': 217,
			'16447': 255,
			'16448': 222,
			'16449': 220,
			'16450': 218,
			'16451': 255,
			'16452': 222,
			'16453': 221,
			'16454': 219,
			'16455': 255,
			'16456': 222,
			'16457': 221,
			'16458': 219,
			'16459': 255,
			'16460': 221,
			'16461': 220,
			'16462': 218,
			'16463': 255,
			'16464': 220,
			'16465': 219,
			'16466': 217,
			'16467': 255,
			'16468': 220,
			'16469': 219,
			'16470': 217,
			'16471': 255,
			'16472': 219,
			'16473': 218,
			'16474': 216,
			'16475': 255,
			'16476': 221,
			'16477': 221,
			'16478': 219,
			'16479': 255,
			'16480': 222,
			'16481': 220,
			'16482': 219,
			'16483': 255,
			'16484': 221,
			'16485': 219,
			'16486': 217,
			'16487': 255,
			'16488': 221,
			'16489': 220,
			'16490': 218,
			'16491': 255,
			'16492': 221,
			'16493': 220,
			'16494': 218,
			'16495': 255,
			'16496': 219,
			'16497': 218,
			'16498': 216,
			'16499': 255,
			'16500': 224,
			'16501': 223,
			'16502': 221,
			'16503': 255,
			'16504': 224,
			'16505': 223,
			'16506': 221,
			'16507': 255,
			'16508': 221,
			'16509': 220,
			'16510': 218,
			'16511': 255,
			'16512': 220,
			'16513': 219,
			'16514': 217,
			'16515': 255,
			'16516': 217,
			'16517': 216,
			'16518': 214,
			'16519': 255,
			'16520': 216,
			'16521': 215,
			'16522': 213,
			'16523': 255,
			'16524': 210,
			'16525': 208,
			'16526': 206,
			'16527': 255,
			'16528': 229,
			'16529': 228,
			'16530': 226,
			'16531': 255,
			'16532': 213,
			'16533': 211,
			'16534': 209,
			'16535': 255,
			'16536': 220,
			'16537': 219,
			'16538': 217,
			'16539': 255,
			'16540': 220,
			'16541': 219,
			'16542': 217,
			'16543': 255,
			'16544': 218,
			'16545': 217,
			'16546': 215,
			'16547': 255,
			'16548': 214,
			'16549': 213,
			'16550': 211,
			'16551': 255,
			'16552': 214,
			'16553': 213,
			'16554': 211,
			'16555': 255,
			'16556': 229,
			'16557': 228,
			'16558': 226,
			'16559': 255,
			'16560': 181,
			'16561': 178,
			'16562': 177,
			'16563': 255,
			'16564': 152,
			'16565': 146,
			'16566': 146,
			'16567': 255,
			'16568': 179,
			'16569': 176,
			'16570': 175,
			'16571': 255,
			'16572': 172,
			'16573': 168,
			'16574': 167,
			'16575': 255,
			'16576': 135,
			'16577': 126,
			'16578': 127,
			'16579': 255,
			'16580': 83,
			'16581': 72,
			'16582': 72,
			'16583': 255,
			'16584': 115,
			'16585': 105,
			'16586': 105,
			'16587': 255,
			'16588': 179,
			'16589': 175,
			'16590': 174,
			'16591': 255,
			'16592': 201,
			'16593': 199,
			'16594': 198,
			'16595': 255,
			'16596': 205,
			'16597': 202,
			'16598': 201,
			'16599': 255,
			'16600': 193,
			'16601': 191,
			'16602': 189,
			'16603': 255,
			'16604': 157,
			'16605': 149,
			'16606': 149,
			'16607': 255,
			'16608': 148,
			'16609': 138,
			'16610': 140,
			'16611': 255,
			'16612': 135,
			'16613': 127,
			'16614': 128,
			'16615': 255,
			'16616': 144,
			'16617': 136,
			'16618': 137,
			'16619': 255,
			'16620': 163,
			'16621': 155,
			'16622': 156,
			'16623': 255,
			'16624': 154,
			'16625': 145,
			'16626': 147,
			'16627': 255,
			'16628': 135,
			'16629': 127,
			'16630': 127,
			'16631': 255,
			'16632': 79,
			'16633': 69,
			'16634': 68,
			'16635': 255,
			'16636': 63,
			'16637': 53,
			'16638': 52,
			'16639': 255,
			'16640': 64,
			'16641': 54,
			'16642': 52,
			'16643': 255,
			'16644': 58,
			'16645': 48,
			'16646': 48,
			'16647': 255,
			'16648': 41,
			'16649': 30,
			'16650': 30,
			'16651': 255,
			'16652': 108,
			'16653': 100,
			'16654': 100,
			'16655': 255,
			'16656': 223,
			'16657': 221,
			'16658': 220,
			'16659': 255,
			'16660': 212,
			'16661': 210,
			'16662': 209,
			'16663': 255,
			'16664': 208,
			'16665': 205,
			'16666': 204,
			'16667': 255,
			'16668': 208,
			'16669': 206,
			'16670': 204,
			'16671': 255,
			'16672': 208,
			'16673': 204,
			'16674': 203,
			'16675': 255,
			'16676': 207,
			'16677': 204,
			'16678': 202,
			'16679': 255,
			'16680': 207,
			'16681': 204,
			'16682': 203,
			'16683': 255,
			'16684': 204,
			'16685': 199,
			'16686': 199,
			'16687': 255,
			'16688': 199,
			'16689': 195,
			'16690': 194,
			'16691': 255,
			'16692': 203,
			'16693': 199,
			'16694': 198,
			'16695': 255,
			'16696': 203,
			'16697': 198,
			'16698': 197,
			'16699': 255,
			'16700': 200,
			'16701': 195,
			'16702': 195,
			'16703': 255,
			'16704': 200,
			'16705': 196,
			'16706': 195,
			'16707': 255,
			'16708': 199,
			'16709': 195,
			'16710': 194,
			'16711': 255,
			'16712': 196,
			'16713': 192,
			'16714': 191,
			'16715': 255,
			'16716': 194,
			'16717': 190,
			'16718': 189,
			'16719': 255,
			'16720': 194,
			'16721': 190,
			'16722': 189,
			'16723': 255,
			'16724': 192,
			'16725': 188,
			'16726': 187,
			'16727': 255,
			'16728': 189,
			'16729': 185,
			'16730': 184,
			'16731': 255,
			'16732': 188,
			'16733': 184,
			'16734': 183,
			'16735': 255,
			'16736': 187,
			'16737': 183,
			'16738': 182,
			'16739': 255,
			'16740': 183,
			'16741': 179,
			'16742': 178,
			'16743': 255,
			'16744': 174,
			'16745': 170,
			'16746': 169,
			'16747': 255,
			'16748': 172,
			'16749': 168,
			'16750': 167,
			'16751': 255,
			'16752': 177,
			'16753': 173,
			'16754': 172,
			'16755': 255,
			'16756': 176,
			'16757': 172,
			'16758': 171,
			'16759': 255,
			'16760': 174,
			'16761': 170,
			'16762': 167,
			'16763': 255,
			'16764': 174,
			'16765': 171,
			'16766': 167,
			'16767': 255,
			'16768': 170,
			'16769': 166,
			'16770': 165,
			'16771': 255,
			'16772': 161,
			'16773': 155,
			'16774': 155,
			'16775': 255,
			'16776': 156,
			'16777': 150,
			'16778': 150,
			'16779': 255,
			'16780': 158,
			'16781': 154,
			'16782': 153,
			'16783': 255,
			'16784': 157,
			'16785': 153,
			'16786': 152,
			'16787': 255,
			'16788': 156,
			'16789': 150,
			'16790': 150,
			'16791': 255,
			'16792': 157,
			'16793': 150,
			'16794': 150,
			'16795': 255,
			'16796': 161,
			'16797': 153,
			'16798': 154,
			'16799': 255,
			'16800': 217,
			'16801': 215,
			'16802': 213,
			'16803': 255,
			'16804': 216,
			'16805': 214,
			'16806': 213,
			'16807': 255,
			'16808': 216,
			'16809': 215,
			'16810': 213,
			'16811': 255,
			'16812': 219,
			'16813': 218,
			'16814': 216,
			'16815': 255,
			'16816': 219,
			'16817': 218,
			'16818': 216,
			'16819': 255,
			'16820': 220,
			'16821': 219,
			'16822': 217,
			'16823': 255,
			'16824': 219,
			'16825': 218,
			'16826': 217,
			'16827': 255,
			'16828': 218,
			'16829': 217,
			'16830': 216,
			'16831': 255,
			'16832': 220,
			'16833': 219,
			'16834': 217,
			'16835': 255,
			'16836': 221,
			'16837': 220,
			'16838': 218,
			'16839': 255,
			'16840': 223,
			'16841': 221,
			'16842': 220,
			'16843': 255,
			'16844': 224,
			'16845': 223,
			'16846': 221,
			'16847': 255,
			'16848': 225,
			'16849': 224,
			'16850': 222,
			'16851': 255,
			'16852': 225,
			'16853': 224,
			'16854': 222,
			'16855': 255,
			'16856': 227,
			'16857': 226,
			'16858': 225,
			'16859': 255,
			'16860': 224,
			'16861': 223,
			'16862': 221,
			'16863': 255,
			'16864': 224,
			'16865': 223,
			'16866': 221,
			'16867': 255,
			'16868': 219,
			'16869': 219,
			'16870': 217,
			'16871': 255,
			'16872': 221,
			'16873': 220,
			'16874': 218,
			'16875': 255,
			'16876': 224,
			'16877': 223,
			'16878': 221,
			'16879': 255,
			'16880': 221,
			'16881': 220,
			'16882': 218,
			'16883': 255,
			'16884': 222,
			'16885': 221,
			'16886': 219,
			'16887': 255,
			'16888': 224,
			'16889': 224,
			'16890': 221,
			'16891': 255,
			'16892': 226,
			'16893': 225,
			'16894': 223,
			'16895': 255,
			'16896': 223,
			'16897': 222,
			'16898': 220,
			'16899': 255,
			'16900': 224,
			'16901': 224,
			'16902': 222,
			'16903': 255,
			'16904': 226,
			'16905': 225,
			'16906': 223,
			'16907': 255,
			'16908': 222,
			'16909': 221,
			'16910': 219,
			'16911': 255,
			'16912': 224,
			'16913': 223,
			'16914': 221,
			'16915': 255,
			'16916': 230,
			'16917': 229,
			'16918': 227,
			'16919': 255,
			'16920': 216,
			'16921': 215,
			'16922': 213,
			'16923': 255,
			'16924': 213,
			'16925': 212,
			'16926': 210,
			'16927': 255,
			'16928': 229,
			'16929': 229,
			'16930': 227,
			'16931': 255,
			'16932': 217,
			'16933': 216,
			'16934': 214,
			'16935': 255,
			'16936': 226,
			'16937': 225,
			'16938': 223,
			'16939': 255,
			'16940': 231,
			'16941': 231,
			'16942': 229,
			'16943': 255,
			'16944': 226,
			'16945': 225,
			'16946': 223,
			'16947': 255,
			'16948': 218,
			'16949': 217,
			'16950': 215,
			'16951': 255,
			'16952': 217,
			'16953': 217,
			'16954': 215,
			'16955': 255,
			'16956': 232,
			'16957': 232,
			'16958': 230,
			'16959': 255,
			'16960': 199,
			'16961': 197,
			'16962': 195,
			'16963': 255,
			'16964': 114,
			'16965': 105,
			'16966': 106,
			'16967': 255,
			'16968': 136,
			'16969': 128,
			'16970': 129,
			'16971': 255,
			'16972': 171,
			'16973': 166,
			'16974': 166,
			'16975': 255,
			'16976': 128,
			'16977': 120,
			'16978': 120,
			'16979': 255,
			'16980': 93,
			'16981': 82,
			'16982': 83,
			'16983': 255,
			'16984': 125,
			'16985': 115,
			'16986': 117,
			'16987': 255,
			'16988': 158,
			'16989': 150,
			'16990': 150,
			'16991': 255,
			'16992': 176,
			'16993': 173,
			'16994': 171,
			'16995': 255,
			'16996': 175,
			'16997': 172,
			'16998': 170,
			'16999': 255,
			'17000': 144,
			'17001': 136,
			'17002': 137,
			'17003': 255,
			'17004': 123,
			'17005': 114,
			'17006': 115,
			'17007': 255,
			'17008': 122,
			'17009': 112,
			'17010': 114,
			'17011': 255,
			'17012': 115,
			'17013': 106,
			'17014': 107,
			'17015': 255,
			'17016': 119,
			'17017': 110,
			'17018': 111,
			'17019': 255,
			'17020': 136,
			'17021': 127,
			'17022': 128,
			'17023': 255,
			'17024': 132,
			'17025': 124,
			'17026': 125,
			'17027': 255,
			'17028': 109,
			'17029': 99,
			'17030': 100,
			'17031': 255,
			'17032': 63,
			'17033': 53,
			'17034': 53,
			'17035': 255,
			'17036': 68,
			'17037': 58,
			'17038': 57,
			'17039': 255,
			'17040': 55,
			'17041': 45,
			'17042': 44,
			'17043': 255,
			'17044': 52,
			'17045': 42,
			'17046': 42,
			'17047': 255,
			'17048': 20,
			'17049': 8,
			'17050': 8,
			'17051': 255,
			'17052': 158,
			'17053': 153,
			'17054': 152,
			'17055': 255,
			'17056': 239,
			'17057': 239,
			'17058': 237,
			'17059': 255,
			'17060': 207,
			'17061': 203,
			'17062': 202,
			'17063': 255,
			'17064': 195,
			'17065': 191,
			'17066': 190,
			'17067': 255,
			'17068': 200,
			'17069': 195,
			'17070': 194,
			'17071': 255,
			'17072': 201,
			'17073': 196,
			'17074': 195,
			'17075': 255,
			'17076': 202,
			'17077': 197,
			'17078': 196,
			'17079': 255,
			'17080': 200,
			'17081': 195,
			'17082': 194,
			'17083': 255,
			'17084': 190,
			'17085': 186,
			'17086': 185,
			'17087': 255,
			'17088': 194,
			'17089': 190,
			'17090': 189,
			'17091': 255,
			'17092': 198,
			'17093': 194,
			'17094': 193,
			'17095': 255,
			'17096': 195,
			'17097': 191,
			'17098': 190,
			'17099': 255,
			'17100': 192,
			'17101': 188,
			'17102': 187,
			'17103': 255,
			'17104': 193,
			'17105': 189,
			'17106': 188,
			'17107': 255,
			'17108': 189,
			'17109': 185,
			'17110': 184,
			'17111': 255,
			'17112': 188,
			'17113': 184,
			'17114': 183,
			'17115': 255,
			'17116': 188,
			'17117': 184,
			'17118': 183,
			'17119': 255,
			'17120': 188,
			'17121': 184,
			'17122': 183,
			'17123': 255,
			'17124': 186,
			'17125': 182,
			'17126': 181,
			'17127': 255,
			'17128': 185,
			'17129': 181,
			'17130': 180,
			'17131': 255,
			'17132': 183,
			'17133': 179,
			'17134': 178,
			'17135': 255,
			'17136': 181,
			'17137': 177,
			'17138': 176,
			'17139': 255,
			'17140': 174,
			'17141': 170,
			'17142': 169,
			'17143': 255,
			'17144': 171,
			'17145': 167,
			'17146': 166,
			'17147': 255,
			'17148': 171,
			'17149': 167,
			'17150': 164,
			'17151': 255,
			'17152': 175,
			'17153': 171,
			'17154': 168,
			'17155': 255,
			'17156': 167,
			'17157': 163,
			'17158': 161,
			'17159': 255,
			'17160': 167,
			'17161': 163,
			'17162': 161,
			'17163': 255,
			'17164': 169,
			'17165': 166,
			'17166': 164,
			'17167': 255,
			'17168': 160,
			'17169': 155,
			'17170': 155,
			'17171': 255,
			'17172': 157,
			'17173': 151,
			'17174': 151,
			'17175': 255,
			'17176': 159,
			'17177': 154,
			'17178': 153,
			'17179': 255,
			'17180': 159,
			'17181': 153,
			'17182': 153,
			'17183': 255,
			'17184': 153,
			'17185': 144,
			'17186': 144,
			'17187': 255,
			'17188': 146,
			'17189': 136,
			'17190': 137,
			'17191': 255,
			'17192': 151,
			'17193': 141,
			'17194': 143,
			'17195': 255,
			'17196': 156,
			'17197': 148,
			'17198': 149,
			'17199': 255,
			'17200': 197,
			'17201': 193,
			'17202': 192,
			'17203': 255,
			'17204': 203,
			'17205': 198,
			'17206': 197,
			'17207': 255,
			'17208': 209,
			'17209': 206,
			'17210': 205,
			'17211': 255,
			'17212': 203,
			'17213': 199,
			'17214': 198,
			'17215': 255,
			'17216': 199,
			'17217': 196,
			'17218': 195,
			'17219': 255,
			'17220': 199,
			'17221': 196,
			'17222': 195,
			'17223': 255,
			'17224': 203,
			'17225': 199,
			'17226': 198,
			'17227': 255,
			'17228': 204,
			'17229': 202,
			'17230': 200,
			'17231': 255,
			'17232': 202,
			'17233': 199,
			'17234': 198,
			'17235': 255,
			'17236': 205,
			'17237': 202,
			'17238': 201,
			'17239': 255,
			'17240': 204,
			'17241': 202,
			'17242': 200,
			'17243': 255,
			'17244': 204,
			'17245': 202,
			'17246': 200,
			'17247': 255,
			'17248': 202,
			'17249': 199,
			'17250': 198,
			'17251': 255,
			'17252': 201,
			'17253': 197,
			'17254': 196,
			'17255': 255,
			'17256': 194,
			'17257': 190,
			'17258': 189,
			'17259': 255,
			'17260': 193,
			'17261': 189,
			'17262': 188,
			'17263': 255,
			'17264': 209,
			'17265': 206,
			'17266': 205,
			'17267': 255,
			'17268': 218,
			'17269': 216,
			'17270': 215,
			'17271': 255,
			'17272': 220,
			'17273': 219,
			'17274': 217,
			'17275': 255,
			'17276': 224,
			'17277': 224,
			'17278': 221,
			'17279': 255,
			'17280': 221,
			'17281': 220,
			'17282': 218,
			'17283': 255,
			'17284': 222,
			'17285': 219,
			'17286': 217,
			'17287': 255,
			'17288': 219,
			'17289': 218,
			'17290': 216,
			'17291': 255,
			'17292': 216,
			'17293': 215,
			'17294': 213,
			'17295': 255,
			'17296': 217,
			'17297': 216,
			'17298': 214,
			'17299': 255,
			'17300': 216,
			'17301': 214,
			'17302': 213,
			'17303': 255,
			'17304': 216,
			'17305': 215,
			'17306': 213,
			'17307': 255,
			'17308': 213,
			'17309': 212,
			'17310': 210,
			'17311': 255,
			'17312': 212,
			'17313': 211,
			'17314': 209,
			'17315': 255,
			'17316': 217,
			'17317': 216,
			'17318': 214,
			'17319': 255,
			'17320': 220,
			'17321': 219,
			'17322': 217,
			'17323': 255,
			'17324': 212,
			'17325': 211,
			'17326': 209,
			'17327': 255,
			'17328': 203,
			'17329': 200,
			'17330': 199,
			'17331': 255,
			'17332': 210,
			'17333': 209,
			'17334': 207,
			'17335': 255,
			'17336': 219,
			'17337': 218,
			'17338': 216,
			'17339': 255,
			'17340': 215,
			'17341': 214,
			'17342': 212,
			'17343': 255,
			'17344': 211,
			'17345': 207,
			'17346': 206,
			'17347': 255,
			'17348': 205,
			'17349': 203,
			'17350': 201,
			'17351': 255,
			'17352': 199,
			'17353': 197,
			'17354': 196,
			'17355': 255,
			'17356': 211,
			'17357': 209,
			'17358': 207,
			'17359': 255,
			'17360': 228,
			'17361': 227,
			'17362': 225,
			'17363': 255,
			'17364': 146,
			'17365': 139,
			'17366': 138,
			'17367': 255,
			'17368': 86,
			'17369': 75,
			'17370': 76,
			'17371': 255,
			'17372': 160,
			'17373': 152,
			'17374': 153,
			'17375': 255,
			'17376': 148,
			'17377': 140,
			'17378': 140,
			'17379': 255,
			'17380': 95,
			'17381': 86,
			'17382': 86,
			'17383': 255,
			'17384': 118,
			'17385': 108,
			'17386': 110,
			'17387': 255,
			'17388': 142,
			'17389': 133,
			'17390': 134,
			'17391': 255,
			'17392': 144,
			'17393': 135,
			'17394': 135,
			'17395': 255,
			'17396': 143,
			'17397': 135,
			'17398': 135,
			'17399': 255,
			'17400': 105,
			'17401': 95,
			'17402': 96,
			'17403': 255,
			'17404': 81,
			'17405': 70,
			'17406': 70,
			'17407': 255,
			'17408': 77,
			'17409': 67,
			'17410': 66,
			'17411': 255,
			'17412': 99,
			'17413': 88,
			'17414': 89,
			'17415': 255,
			'17416': 107,
			'17417': 99,
			'17418': 98,
			'17419': 255,
			'17420': 115,
			'17421': 107,
			'17422': 107,
			'17423': 255,
			'17424': 114,
			'17425': 105,
			'17426': 105,
			'17427': 255,
			'17428': 79,
			'17429': 69,
			'17430': 68,
			'17431': 255,
			'17432': 54,
			'17433': 44,
			'17434': 44,
			'17435': 255,
			'17436': 57,
			'17437': 48,
			'17438': 47,
			'17439': 255,
			'17440': 44,
			'17441': 34,
			'17442': 33,
			'17443': 255,
			'17444': 25,
			'17445': 14,
			'17446': 13,
			'17447': 255,
			'17448': 83,
			'17449': 73,
			'17450': 73,
			'17451': 255,
			'17452': 213,
			'17453': 210,
			'17454': 209,
			'17455': 255,
			'17456': 209,
			'17457': 206,
			'17458': 205,
			'17459': 255,
			'17460': 181,
			'17461': 176,
			'17462': 175,
			'17463': 255,
			'17464': 188,
			'17465': 184,
			'17466': 183,
			'17467': 255,
			'17468': 198,
			'17469': 194,
			'17470': 193,
			'17471': 255,
			'17472': 199,
			'17473': 195,
			'17474': 194,
			'17475': 255,
			'17476': 201,
			'17477': 197,
			'17478': 196,
			'17479': 255,
			'17480': 199,
			'17481': 195,
			'17482': 194,
			'17483': 255,
			'17484': 194,
			'17485': 190,
			'17486': 189,
			'17487': 255,
			'17488': 194,
			'17489': 190,
			'17490': 189,
			'17491': 255,
			'17492': 195,
			'17493': 191,
			'17494': 190,
			'17495': 255,
			'17496': 195,
			'17497': 191,
			'17498': 190,
			'17499': 255,
			'17500': 194,
			'17501': 190,
			'17502': 189,
			'17503': 255,
			'17504': 192,
			'17505': 188,
			'17506': 187,
			'17507': 255,
			'17508': 187,
			'17509': 183,
			'17510': 182,
			'17511': 255,
			'17512': 186,
			'17513': 182,
			'17514': 181,
			'17515': 255,
			'17516': 183,
			'17517': 179,
			'17518': 178,
			'17519': 255,
			'17520': 181,
			'17521': 177,
			'17522': 176,
			'17523': 255,
			'17524': 179,
			'17525': 175,
			'17526': 174,
			'17527': 255,
			'17528': 179,
			'17529': 175,
			'17530': 174,
			'17531': 255,
			'17532': 180,
			'17533': 176,
			'17534': 175,
			'17535': 255,
			'17536': 175,
			'17537': 172,
			'17538': 171,
			'17539': 255,
			'17540': 175,
			'17541': 172,
			'17542': 171,
			'17543': 255,
			'17544': 177,
			'17545': 173,
			'17546': 172,
			'17547': 255,
			'17548': 174,
			'17549': 170,
			'17550': 167,
			'17551': 255,
			'17552': 170,
			'17553': 166,
			'17554': 163,
			'17555': 255,
			'17556': 164,
			'17557': 160,
			'17558': 160,
			'17559': 255,
			'17560': 166,
			'17561': 162,
			'17562': 161,
			'17563': 255,
			'17564': 163,
			'17565': 159,
			'17566': 159,
			'17567': 255,
			'17568': 160,
			'17569': 156,
			'17570': 155,
			'17571': 255,
			'17572': 162,
			'17573': 159,
			'17574': 158,
			'17575': 255,
			'17576': 158,
			'17577': 153,
			'17578': 153,
			'17579': 255,
			'17580': 156,
			'17581': 147,
			'17582': 148,
			'17583': 255,
			'17584': 156,
			'17585': 146,
			'17586': 148,
			'17587': 255,
			'17588': 153,
			'17589': 144,
			'17590': 145,
			'17591': 255,
			'17592': 153,
			'17593': 144,
			'17594': 145,
			'17595': 255,
			'17596': 154,
			'17597': 146,
			'17598': 147,
			'17599': 255,
			'17600': 190,
			'17601': 187,
			'17602': 186,
			'17603': 255,
			'17604': 196,
			'17605': 193,
			'17606': 191,
			'17607': 255,
			'17608': 209,
			'17609': 205,
			'17610': 204,
			'17611': 255,
			'17612': 206,
			'17613': 201,
			'17614': 201,
			'17615': 255,
			'17616': 205,
			'17617': 200,
			'17618': 200,
			'17619': 255,
			'17620': 198,
			'17621': 195,
			'17622': 194,
			'17623': 255,
			'17624': 204,
			'17625': 200,
			'17626': 199,
			'17627': 255,
			'17628': 209,
			'17629': 204,
			'17630': 203,
			'17631': 255,
			'17632': 203,
			'17633': 200,
			'17634': 198,
			'17635': 255,
			'17636': 192,
			'17637': 188,
			'17638': 187,
			'17639': 255,
			'17640': 204,
			'17641': 199,
			'17642': 198,
			'17643': 255,
			'17644': 204,
			'17645': 200,
			'17646': 199,
			'17647': 255,
			'17648': 199,
			'17649': 194,
			'17650': 193,
			'17651': 255,
			'17652': 198,
			'17653': 195,
			'17654': 194,
			'17655': 255,
			'17656': 172,
			'17657': 167,
			'17658': 166,
			'17659': 255,
			'17660': 155,
			'17661': 150,
			'17662': 149,
			'17663': 255,
			'17664': 159,
			'17665': 154,
			'17666': 154,
			'17667': 255,
			'17668': 191,
			'17669': 186,
			'17670': 185,
			'17671': 255,
			'17672': 203,
			'17673': 201,
			'17674': 199,
			'17675': 255,
			'17676': 206,
			'17677': 203,
			'17678': 202,
			'17679': 255,
			'17680': 210,
			'17681': 207,
			'17682': 206,
			'17683': 255,
			'17684': 210,
			'17685': 206,
			'17686': 205,
			'17687': 255,
			'17688': 206,
			'17689': 203,
			'17690': 201,
			'17691': 255,
			'17692': 201,
			'17693': 198,
			'17694': 197,
			'17695': 255,
			'17696': 206,
			'17697': 203,
			'17698': 202,
			'17699': 255,
			'17700': 203,
			'17701': 201,
			'17702': 199,
			'17703': 255,
			'17704': 199,
			'17705': 196,
			'17706': 195,
			'17707': 255,
			'17708': 192,
			'17709': 189,
			'17710': 188,
			'17711': 255,
			'17712': 197,
			'17713': 194,
			'17714': 192,
			'17715': 255,
			'17716': 190,
			'17717': 187,
			'17718': 186,
			'17719': 255,
			'17720': 189,
			'17721': 184,
			'17722': 184,
			'17723': 255,
			'17724': 187,
			'17725': 183,
			'17726': 182,
			'17727': 255,
			'17728': 192,
			'17729': 188,
			'17730': 187,
			'17731': 255,
			'17732': 202,
			'17733': 199,
			'17734': 197,
			'17735': 255,
			'17736': 196,
			'17737': 192,
			'17738': 191,
			'17739': 255,
			'17740': 197,
			'17741': 193,
			'17742': 193,
			'17743': 255,
			'17744': 197,
			'17745': 193,
			'17746': 192,
			'17747': 255,
			'17748': 197,
			'17749': 193,
			'17750': 192,
			'17751': 255,
			'17752': 194,
			'17753': 189,
			'17754': 188,
			'17755': 255,
			'17756': 191,
			'17757': 186,
			'17758': 186,
			'17759': 255,
			'17760': 216,
			'17761': 213,
			'17762': 212,
			'17763': 255,
			'17764': 228,
			'17765': 228,
			'17766': 225,
			'17767': 255,
			'17768': 118,
			'17769': 110,
			'17770': 110,
			'17771': 255,
			'17772': 125,
			'17773': 115,
			'17774': 116,
			'17775': 255,
			'17776': 148,
			'17777': 139,
			'17778': 140,
			'17779': 255,
			'17780': 97,
			'17781': 88,
			'17782': 89,
			'17783': 255,
			'17784': 117,
			'17785': 107,
			'17786': 109,
			'17787': 255,
			'17788': 148,
			'17789': 138,
			'17790': 140,
			'17791': 255,
			'17792': 118,
			'17793': 109,
			'17794': 110,
			'17795': 255,
			'17796': 99,
			'17797': 90,
			'17798': 89,
			'17799': 255,
			'17800': 80,
			'17801': 71,
			'17802': 69,
			'17803': 255,
			'17804': 52,
			'17805': 42,
			'17806': 41,
			'17807': 255,
			'17808': 39,
			'17809': 30,
			'17810': 29,
			'17811': 255,
			'17812': 52,
			'17813': 42,
			'17814': 41,
			'17815': 255,
			'17816': 69,
			'17817': 59,
			'17818': 58,
			'17819': 255,
			'17820': 86,
			'17821': 78,
			'17822': 76,
			'17823': 255,
			'17824': 99,
			'17825': 89,
			'17826': 87,
			'17827': 255,
			'17828': 62,
			'17829': 52,
			'17830': 51,
			'17831': 255,
			'17832': 55,
			'17833': 45,
			'17834': 45,
			'17835': 255,
			'17836': 55,
			'17837': 45,
			'17838': 44,
			'17839': 255,
			'17840': 22,
			'17841': 12,
			'17842': 11,
			'17843': 255,
			'17844': 45,
			'17845': 36,
			'17846': 35,
			'17847': 255,
			'17848': 209,
			'17849': 206,
			'17850': 205,
			'17851': 255,
			'17852': 233,
			'17853': 232,
			'17854': 230,
			'17855': 255,
			'17856': 198,
			'17857': 194,
			'17858': 193,
			'17859': 255,
			'17860': 195,
			'17861': 191,
			'17862': 190,
			'17863': 255,
			'17864': 203,
			'17865': 199,
			'17866': 198,
			'17867': 255,
			'17868': 205,
			'17869': 201,
			'17870': 200,
			'17871': 255,
			'17872': 204,
			'17873': 202,
			'17874': 200,
			'17875': 255,
			'17876': 204,
			'17877': 200,
			'17878': 199,
			'17879': 255,
			'17880': 202,
			'17881': 198,
			'17882': 197,
			'17883': 255,
			'17884': 203,
			'17885': 199,
			'17886': 198,
			'17887': 255,
			'17888': 200,
			'17889': 196,
			'17890': 195,
			'17891': 255,
			'17892': 201,
			'17893': 197,
			'17894': 196,
			'17895': 255,
			'17896': 200,
			'17897': 196,
			'17898': 195,
			'17899': 255,
			'17900': 198,
			'17901': 194,
			'17902': 193,
			'17903': 255,
			'17904': 196,
			'17905': 192,
			'17906': 191,
			'17907': 255,
			'17908': 195,
			'17909': 191,
			'17910': 190,
			'17911': 255,
			'17912': 183,
			'17913': 179,
			'17914': 178,
			'17915': 255,
			'17916': 176,
			'17917': 172,
			'17918': 171,
			'17919': 255,
			'17920': 178,
			'17921': 174,
			'17922': 173,
			'17923': 255,
			'17924': 182,
			'17925': 178,
			'17926': 177,
			'17927': 255,
			'17928': 181,
			'17929': 177,
			'17930': 176,
			'17931': 255,
			'17932': 179,
			'17933': 175,
			'17934': 174,
			'17935': 255,
			'17936': 178,
			'17937': 175,
			'17938': 174,
			'17939': 255,
			'17940': 177,
			'17941': 175,
			'17942': 174,
			'17943': 255,
			'17944': 176,
			'17945': 172,
			'17946': 171,
			'17947': 255,
			'17948': 174,
			'17949': 170,
			'17950': 167,
			'17951': 255,
			'17952': 169,
			'17953': 165,
			'17954': 163,
			'17955': 255,
			'17956': 166,
			'17957': 162,
			'17958': 162,
			'17959': 255,
			'17960': 164,
			'17961': 160,
			'17962': 159,
			'17963': 255,
			'17964': 160,
			'17965': 155,
			'17966': 154,
			'17967': 255,
			'17968': 157,
			'17969': 152,
			'17970': 151,
			'17971': 255,
			'17972': 154,
			'17973': 148,
			'17974': 148,
			'17975': 255,
			'17976': 155,
			'17977': 148,
			'17978': 148,
			'17979': 255,
			'17980': 152,
			'17981': 143,
			'17982': 144,
			'17983': 255,
			'17984': 149,
			'17985': 139,
			'17986': 140,
			'17987': 255,
			'17988': 148,
			'17989': 140,
			'17990': 140,
			'17991': 255,
			'17992': 146,
			'17993': 138,
			'17994': 139,
			'17995': 255,
			'17996': 149,
			'17997': 140,
			'17998': 141,
			'17999': 255,
			'18000': 208,
			'18001': 206,
			'18002': 204,
			'18003': 255,
			'18004': 209,
			'18005': 207,
			'18006': 205,
			'18007': 255,
			'18008': 209,
			'18009': 209,
			'18010': 207,
			'18011': 255,
			'18012': 213,
			'18013': 211,
			'18014': 209,
			'18015': 255,
			'18016': 215,
			'18017': 212,
			'18018': 211,
			'18019': 255,
			'18020': 212,
			'18021': 211,
			'18022': 208,
			'18023': 255,
			'18024': 217,
			'18025': 213,
			'18026': 212,
			'18027': 255,
			'18028': 218,
			'18029': 213,
			'18030': 212,
			'18031': 255,
			'18032': 215,
			'18033': 211,
			'18034': 210,
			'18035': 255,
			'18036': 193,
			'18037': 190,
			'18038': 188,
			'18039': 255,
			'18040': 211,
			'18041': 210,
			'18042': 208,
			'18043': 255,
			'18044': 204,
			'18045': 201,
			'18046': 200,
			'18047': 255,
			'18048': 213,
			'18049': 209,
			'18050': 208,
			'18051': 255,
			'18052': 226,
			'18053': 227,
			'18054': 224,
			'18055': 255,
			'18056': 203,
			'18057': 201,
			'18058': 199,
			'18059': 255,
			'18060': 179,
			'18061': 174,
			'18062': 173,
			'18063': 255,
			'18064': 185,
			'18065': 181,
			'18066': 180,
			'18067': 255,
			'18068': 201,
			'18069': 198,
			'18070': 197,
			'18071': 255,
			'18072': 210,
			'18073': 208,
			'18074': 206,
			'18075': 255,
			'18076': 207,
			'18077': 205,
			'18078': 203,
			'18079': 255,
			'18080': 210,
			'18081': 208,
			'18082': 206,
			'18083': 255,
			'18084': 211,
			'18085': 211,
			'18086': 209,
			'18087': 255,
			'18088': 212,
			'18089': 211,
			'18090': 209,
			'18091': 255,
			'18092': 204,
			'18093': 202,
			'18094': 200,
			'18095': 255,
			'18096': 210,
			'18097': 207,
			'18098': 205,
			'18099': 255,
			'18100': 218,
			'18101': 216,
			'18102': 215,
			'18103': 255,
			'18104': 212,
			'18105': 211,
			'18106': 209,
			'18107': 255,
			'18108': 213,
			'18109': 211,
			'18110': 209,
			'18111': 255,
			'18112': 219,
			'18113': 218,
			'18114': 216,
			'18115': 255,
			'18116': 212,
			'18117': 210,
			'18118': 208,
			'18119': 255,
			'18120': 198,
			'18121': 194,
			'18122': 193,
			'18123': 255,
			'18124': 201,
			'18125': 198,
			'18126': 197,
			'18127': 255,
			'18128': 216,
			'18129': 216,
			'18130': 214,
			'18131': 255,
			'18132': 218,
			'18133': 217,
			'18134': 214,
			'18135': 255,
			'18136': 203,
			'18137': 199,
			'18138': 198,
			'18139': 255,
			'18140': 207,
			'18141': 204,
			'18142': 203,
			'18143': 255,
			'18144': 214,
			'18145': 212,
			'18146': 210,
			'18147': 255,
			'18148': 211,
			'18149': 206,
			'18150': 206,
			'18151': 255,
			'18152': 215,
			'18153': 211,
			'18154': 210,
			'18155': 255,
			'18156': 204,
			'18157': 200,
			'18158': 199,
			'18159': 255,
			'18160': 207,
			'18161': 202,
			'18162': 202,
			'18163': 255,
			'18164': 239,
			'18165': 240,
			'18166': 238,
			'18167': 255,
			'18168': 203,
			'18169': 201,
			'18170': 200,
			'18171': 255,
			'18172': 119,
			'18173': 109,
			'18174': 110,
			'18175': 255,
			'18176': 130,
			'18177': 120,
			'18178': 122,
			'18179': 255,
			'18180': 110,
			'18181': 101,
			'18182': 101,
			'18183': 255,
			'18184': 93,
			'18185': 84,
			'18186': 83,
			'18187': 255,
			'18188': 135,
			'18189': 126,
			'18190': 127,
			'18191': 255,
			'18192': 134,
			'18193': 124,
			'18194': 126,
			'18195': 255,
			'18196': 103,
			'18197': 94,
			'18198': 94,
			'18199': 255,
			'18200': 81,
			'18201': 72,
			'18202': 70,
			'18203': 255,
			'18204': 64,
			'18205': 53,
			'18206': 52,
			'18207': 255,
			'18208': 53,
			'18209': 43,
			'18210': 43,
			'18211': 255,
			'18212': 52,
			'18213': 42,
			'18214': 41,
			'18215': 255,
			'18216': 71,
			'18217': 60,
			'18218': 59,
			'18219': 255,
			'18220': 76,
			'18221': 65,
			'18222': 64,
			'18223': 255,
			'18224': 68,
			'18225': 59,
			'18226': 57,
			'18227': 255,
			'18228': 52,
			'18229': 42,
			'18230': 41,
			'18231': 255,
			'18232': 56,
			'18233': 46,
			'18234': 45,
			'18235': 255,
			'18236': 39,
			'18237': 30,
			'18238': 29,
			'18239': 255,
			'18240': 23,
			'18241': 12,
			'18242': 12,
			'18243': 255,
			'18244': 148,
			'18245': 141,
			'18246': 141,
			'18247': 255,
			'18248': 233,
			'18249': 233,
			'18250': 231,
			'18251': 255,
			'18252': 204,
			'18253': 202,
			'18254': 200,
			'18255': 255,
			'18256': 206,
			'18257': 201,
			'18258': 201,
			'18259': 255,
			'18260': 208,
			'18261': 204,
			'18262': 203,
			'18263': 255,
			'18264': 208,
			'18265': 204,
			'18266': 203,
			'18267': 255,
			'18268': 205,
			'18269': 200,
			'18270': 200,
			'18271': 255,
			'18272': 203,
			'18273': 199,
			'18274': 198,
			'18275': 255,
			'18276': 204,
			'18277': 200,
			'18278': 199,
			'18279': 255,
			'18280': 203,
			'18281': 198,
			'18282': 197,
			'18283': 255,
			'18284': 201,
			'18285': 197,
			'18286': 196,
			'18287': 255,
			'18288': 201,
			'18289': 198,
			'18290': 197,
			'18291': 255,
			'18292': 202,
			'18293': 198,
			'18294': 197,
			'18295': 255,
			'18296': 197,
			'18297': 193,
			'18298': 192,
			'18299': 255,
			'18300': 195,
			'18301': 191,
			'18302': 190,
			'18303': 255,
			'18304': 194,
			'18305': 190,
			'18306': 189,
			'18307': 255,
			'18308': 196,
			'18309': 192,
			'18310': 191,
			'18311': 255,
			'18312': 175,
			'18313': 171,
			'18314': 170,
			'18315': 255,
			'18316': 171,
			'18317': 167,
			'18318': 166,
			'18319': 255,
			'18320': 189,
			'18321': 185,
			'18322': 184,
			'18323': 255,
			'18324': 187,
			'18325': 183,
			'18326': 182,
			'18327': 255,
			'18328': 185,
			'18329': 181,
			'18330': 180,
			'18331': 255,
			'18332': 184,
			'18333': 180,
			'18334': 179,
			'18335': 255,
			'18336': 183,
			'18337': 179,
			'18338': 178,
			'18339': 255,
			'18340': 179,
			'18341': 174,
			'18342': 173,
			'18343': 255,
			'18344': 178,
			'18345': 175,
			'18346': 174,
			'18347': 255,
			'18348': 179,
			'18349': 175,
			'18350': 174,
			'18351': 255,
			'18352': 174,
			'18353': 170,
			'18354': 169,
			'18355': 255,
			'18356': 173,
			'18357': 169,
			'18358': 166,
			'18359': 255,
			'18360': 167,
			'18361': 163,
			'18362': 162,
			'18363': 255,
			'18364': 161,
			'18365': 156,
			'18366': 156,
			'18367': 255,
			'18368': 158,
			'18369': 153,
			'18370': 152,
			'18371': 255,
			'18372': 155,
			'18373': 149,
			'18374': 149,
			'18375': 255,
			'18376': 159,
			'18377': 153,
			'18378': 153,
			'18379': 255,
			'18380': 155,
			'18381': 146,
			'18382': 147,
			'18383': 255,
			'18384': 150,
			'18385': 141,
			'18386': 142,
			'18387': 255,
			'18388': 153,
			'18389': 144,
			'18390': 145,
			'18391': 255,
			'18392': 150,
			'18393': 141,
			'18394': 142,
			'18395': 255,
			'18396': 152,
			'18397': 143,
			'18398': 144,
			'18399': 255,
			'18400': 209,
			'18401': 208,
			'18402': 206,
			'18403': 255,
			'18404': 210,
			'18405': 206,
			'18406': 205,
			'18407': 255,
			'18408': 207,
			'18409': 206,
			'18410': 204,
			'18411': 255,
			'18412': 206,
			'18413': 206,
			'18414': 204,
			'18415': 255,
			'18416': 207,
			'18417': 207,
			'18418': 204,
			'18419': 255,
			'18420': 210,
			'18421': 209,
			'18422': 207,
			'18423': 255,
			'18424': 213,
			'18425': 209,
			'18426': 208,
			'18427': 255,
			'18428': 212,
			'18429': 209,
			'18430': 208,
			'18431': 255,
			'18432': 210,
			'18433': 208,
			'18434': 206,
			'18435': 255,
			'18436': 211,
			'18437': 208,
			'18438': 207,
			'18439': 255,
			'18440': 217,
			'18441': 217,
			'18442': 215,
			'18443': 255,
			'18444': 195,
			'18445': 191,
			'18446': 190,
			'18447': 255,
			'18448': 203,
			'18449': 198,
			'18450': 197,
			'18451': 255,
			'18452': 222,
			'18453': 220,
			'18454': 218,
			'18455': 255,
			'18456': 202,
			'18457': 200,
			'18458': 198,
			'18459': 255,
			'18460': 166,
			'18461': 162,
			'18462': 161,
			'18463': 255,
			'18464': 215,
			'18465': 214,
			'18466': 212,
			'18467': 255,
			'18468': 225,
			'18469': 224,
			'18470': 222,
			'18471': 255,
			'18472': 215,
			'18473': 215,
			'18474': 213,
			'18475': 255,
			'18476': 220,
			'18477': 220,
			'18478': 217,
			'18479': 255,
			'18480': 214,
			'18481': 212,
			'18482': 210,
			'18483': 255,
			'18484': 206,
			'18485': 203,
			'18486': 201,
			'18487': 255,
			'18488': 222,
			'18489': 221,
			'18490': 218,
			'18491': 255,
			'18492': 211,
			'18493': 210,
			'18494': 208,
			'18495': 255,
			'18496': 192,
			'18497': 187,
			'18498': 186,
			'18499': 255,
			'18500': 206,
			'18501': 201,
			'18502': 200,
			'18503': 255,
			'18504': 213,
			'18505': 211,
			'18506': 210,
			'18507': 255,
			'18508': 220,
			'18509': 219,
			'18510': 217,
			'18511': 255,
			'18512': 220,
			'18513': 219,
			'18514': 217,
			'18515': 255,
			'18516': 217,
			'18517': 216,
			'18518': 214,
			'18519': 255,
			'18520': 214,
			'18521': 213,
			'18522': 211,
			'18523': 255,
			'18524': 218,
			'18525': 218,
			'18526': 216,
			'18527': 255,
			'18528': 216,
			'18529': 216,
			'18530': 213,
			'18531': 255,
			'18532': 211,
			'18533': 208,
			'18534': 207,
			'18535': 255,
			'18536': 203,
			'18537': 199,
			'18538': 198,
			'18539': 255,
			'18540': 207,
			'18541': 202,
			'18542': 201,
			'18543': 255,
			'18544': 211,
			'18545': 206,
			'18546': 205,
			'18547': 255,
			'18548': 209,
			'18549': 206,
			'18550': 205,
			'18551': 255,
			'18552': 209,
			'18553': 207,
			'18554': 206,
			'18555': 255,
			'18556': 215,
			'18557': 212,
			'18558': 210,
			'18559': 255,
			'18560': 213,
			'18561': 211,
			'18562': 209,
			'18563': 255,
			'18564': 226,
			'18565': 226,
			'18566': 223,
			'18567': 255,
			'18568': 241,
			'18569': 241,
			'18570': 239,
			'18571': 255,
			'18572': 175,
			'18573': 169,
			'18574': 169,
			'18575': 255,
			'18576': 119,
			'18577': 108,
			'18578': 110,
			'18579': 255,
			'18580': 124,
			'18581': 114,
			'18582': 115,
			'18583': 255,
			'18584': 109,
			'18585': 100,
			'18586': 99,
			'18587': 255,
			'18588': 99,
			'18589': 91,
			'18590': 91,
			'18591': 255,
			'18592': 133,
			'18593': 123,
			'18594': 125,
			'18595': 255,
			'18596': 113,
			'18597': 103,
			'18598': 105,
			'18599': 255,
			'18600': 90,
			'18601': 81,
			'18602': 82,
			'18603': 255,
			'18604': 73,
			'18605': 63,
			'18606': 62,
			'18607': 255,
			'18608': 81,
			'18609': 71,
			'18610': 69,
			'18611': 255,
			'18612': 85,
			'18613': 75,
			'18614': 74,
			'18615': 255,
			'18616': 65,
			'18617': 55,
			'18618': 54,
			'18619': 255,
			'18620': 63,
			'18621': 53,
			'18622': 52,
			'18623': 255,
			'18624': 58,
			'18625': 48,
			'18626': 47,
			'18627': 255,
			'18628': 57,
			'18629': 47,
			'18630': 46,
			'18631': 255,
			'18632': 49,
			'18633': 40,
			'18634': 38,
			'18635': 255,
			'18636': 18,
			'18637': 10,
			'18638': 8,
			'18639': 255,
			'18640': 95,
			'18641': 87,
			'18642': 88,
			'18643': 255,
			'18644': 202,
			'18645': 196,
			'18646': 196,
			'18647': 255,
			'18648': 213,
			'18649': 211,
			'18650': 209,
			'18651': 255,
			'18652': 202,
			'18653': 201,
			'18654': 199,
			'18655': 255,
			'18656': 206,
			'18657': 201,
			'18658': 200,
			'18659': 255,
			'18660': 203,
			'18661': 199,
			'18662': 198,
			'18663': 255,
			'18664': 202,
			'18665': 198,
			'18666': 197,
			'18667': 255,
			'18668': 202,
			'18669': 200,
			'18670': 198,
			'18671': 255,
			'18672': 202,
			'18673': 198,
			'18674': 197,
			'18675': 255,
			'18676': 201,
			'18677': 196,
			'18678': 195,
			'18679': 255,
			'18680': 199,
			'18681': 195,
			'18682': 194,
			'18683': 255,
			'18684': 198,
			'18685': 194,
			'18686': 193,
			'18687': 255,
			'18688': 197,
			'18689': 193,
			'18690': 192,
			'18691': 255,
			'18692': 196,
			'18693': 192,
			'18694': 191,
			'18695': 255,
			'18696': 194,
			'18697': 190,
			'18698': 189,
			'18699': 255,
			'18700': 194,
			'18701': 190,
			'18702': 189,
			'18703': 255,
			'18704': 192,
			'18705': 188,
			'18706': 187,
			'18707': 255,
			'18708': 191,
			'18709': 187,
			'18710': 186,
			'18711': 255,
			'18712': 183,
			'18713': 179,
			'18714': 178,
			'18715': 255,
			'18716': 180,
			'18717': 176,
			'18718': 175,
			'18719': 255,
			'18720': 187,
			'18721': 183,
			'18722': 182,
			'18723': 255,
			'18724': 184,
			'18725': 180,
			'18726': 179,
			'18727': 255,
			'18728': 184,
			'18729': 180,
			'18730': 179,
			'18731': 255,
			'18732': 183,
			'18733': 179,
			'18734': 178,
			'18735': 255,
			'18736': 181,
			'18737': 176,
			'18738': 175,
			'18739': 255,
			'18740': 179,
			'18741': 175,
			'18742': 174,
			'18743': 255,
			'18744': 177,
			'18745': 175,
			'18746': 173,
			'18747': 255,
			'18748': 175,
			'18749': 172,
			'18750': 170,
			'18751': 255,
			'18752': 175,
			'18753': 171,
			'18754': 168,
			'18755': 255,
			'18756': 173,
			'18757': 169,
			'18758': 166,
			'18759': 255,
			'18760': 170,
			'18761': 166,
			'18762': 163,
			'18763': 255,
			'18764': 165,
			'18765': 161,
			'18766': 161,
			'18767': 255,
			'18768': 164,
			'18769': 161,
			'18770': 160,
			'18771': 255,
			'18772': 163,
			'18773': 159,
			'18774': 158,
			'18775': 255,
			'18776': 159,
			'18777': 153,
			'18778': 153,
			'18779': 255,
			'18780': 158,
			'18781': 151,
			'18782': 151,
			'18783': 255,
			'18784': 158,
			'18785': 151,
			'18786': 151,
			'18787': 255,
			'18788': 155,
			'18789': 149,
			'18790': 149,
			'18791': 255,
			'18792': 155,
			'18793': 146,
			'18794': 147,
			'18795': 255,
			'18796': 158,
			'18797': 149,
			'18798': 151,
			'18799': 255,
			'18800': 207,
			'18801': 206,
			'18802': 204,
			'18803': 255,
			'18804': 206,
			'18805': 203,
			'18806': 202,
			'18807': 255,
			'18808': 208,
			'18809': 204,
			'18810': 204,
			'18811': 255,
			'18812': 207,
			'18813': 204,
			'18814': 203,
			'18815': 255,
			'18816': 206,
			'18817': 203,
			'18818': 202,
			'18819': 255,
			'18820': 207,
			'18821': 206,
			'18822': 204,
			'18823': 255,
			'18824': 209,
			'18825': 207,
			'18826': 206,
			'18827': 255,
			'18828': 209,
			'18829': 208,
			'18830': 206,
			'18831': 255,
			'18832': 208,
			'18833': 204,
			'18834': 203,
			'18835': 255,
			'18836': 209,
			'18837': 205,
			'18838': 204,
			'18839': 255,
			'18840': 213,
			'18841': 212,
			'18842': 211,
			'18843': 255,
			'18844': 207,
			'18845': 205,
			'18846': 203,
			'18847': 255,
			'18848': 207,
			'18849': 203,
			'18850': 202,
			'18851': 255,
			'18852': 214,
			'18853': 212,
			'18854': 210,
			'18855': 255,
			'18856': 203,
			'18857': 198,
			'18858': 198,
			'18859': 255,
			'18860': 164,
			'18861': 160,
			'18862': 159,
			'18863': 255,
			'18864': 206,
			'18865': 204,
			'18866': 202,
			'18867': 255,
			'18868': 221,
			'18869': 222,
			'18870': 219,
			'18871': 255,
			'18872': 212,
			'18873': 210,
			'18874': 208,
			'18875': 255,
			'18876': 214,
			'18877': 212,
			'18878': 210,
			'18879': 255,
			'18880': 225,
			'18881': 224,
			'18882': 222,
			'18883': 255,
			'18884': 196,
			'18885': 192,
			'18886': 191,
			'18887': 255,
			'18888': 207,
			'18889': 204,
			'18890': 203,
			'18891': 255,
			'18892': 224,
			'18893': 224,
			'18894': 221,
			'18895': 255,
			'18896': 211,
			'18897': 209,
			'18898': 208,
			'18899': 255,
			'18900': 202,
			'18901': 200,
			'18902': 198,
			'18903': 255,
			'18904': 213,
			'18905': 212,
			'18906': 210,
			'18907': 255,
			'18908': 217,
			'18909': 216,
			'18910': 214,
			'18911': 255,
			'18912': 216,
			'18913': 215,
			'18914': 213,
			'18915': 255,
			'18916': 215,
			'18917': 213,
			'18918': 211,
			'18919': 255,
			'18920': 213,
			'18921': 213,
			'18922': 211,
			'18923': 255,
			'18924': 214,
			'18925': 213,
			'18926': 211,
			'18927': 255,
			'18928': 216,
			'18929': 215,
			'18930': 213,
			'18931': 255,
			'18932': 210,
			'18933': 207,
			'18934': 206,
			'18935': 255,
			'18936': 198,
			'18937': 194,
			'18938': 193,
			'18939': 255,
			'18940': 206,
			'18941': 203,
			'18942': 202,
			'18943': 255,
			'18944': 206,
			'18945': 203,
			'18946': 202,
			'18947': 255,
			'18948': 221,
			'18949': 218,
			'18950': 217,
			'18951': 255,
			'18952': 228,
			'18953': 224,
			'18954': 223,
			'18955': 255,
			'18956': 166,
			'18957': 163,
			'18958': 162,
			'18959': 255,
			'18960': 176,
			'18961': 173,
			'18962': 172,
			'18963': 255,
			'18964': 236,
			'18965': 236,
			'18966': 234,
			'18967': 255,
			'18968': 227,
			'18969': 226,
			'18970': 224,
			'18971': 255,
			'18972': 222,
			'18973': 221,
			'18974': 219,
			'18975': 255,
			'18976': 175,
			'18977': 170,
			'18978': 169,
			'18979': 255,
			'18980': 132,
			'18981': 124,
			'18982': 125,
			'18983': 255,
			'18984': 121,
			'18985': 111,
			'18986': 113,
			'18987': 255,
			'18988': 102,
			'18989': 93,
			'18990': 94,
			'18991': 255,
			'18992': 95,
			'18993': 86,
			'18994': 86,
			'18995': 255,
			'18996': 107,
			'18997': 99,
			'18998': 99,
			'18999': 255,
			'19000': 102,
			'19001': 93,
			'19002': 93,
			'19003': 255,
			'19004': 91,
			'19005': 80,
			'19006': 79,
			'19007': 255,
			'19008': 81,
			'19009': 71,
			'19010': 69,
			'19011': 255,
			'19012': 85,
			'19013': 75,
			'19014': 75,
			'19015': 255,
			'19016': 77,
			'19017': 67,
			'19018': 67,
			'19019': 255,
			'19020': 60,
			'19021': 50,
			'19022': 49,
			'19023': 255,
			'19024': 66,
			'19025': 56,
			'19026': 55,
			'19027': 255,
			'19028': 57,
			'19029': 47,
			'19030': 46,
			'19031': 255,
			'19032': 31,
			'19033': 23,
			'19034': 21,
			'19035': 255,
			'19036': 73,
			'19037': 65,
			'19038': 63,
			'19039': 255,
			'19040': 143,
			'19041': 135,
			'19042': 136,
			'19043': 255,
			'19044': 186,
			'19045': 181,
			'19046': 180,
			'19047': 255,
			'19048': 209,
			'19049': 208,
			'19050': 206,
			'19051': 255,
			'19052': 201,
			'19053': 200,
			'19054': 198,
			'19055': 255,
			'19056': 201,
			'19057': 196,
			'19058': 196,
			'19059': 255,
			'19060': 200,
			'19061': 197,
			'19062': 196,
			'19063': 255,
			'19064': 201,
			'19065': 197,
			'19066': 196,
			'19067': 255,
			'19068': 201,
			'19069': 197,
			'19070': 196,
			'19071': 255,
			'19072': 201,
			'19073': 197,
			'19074': 196,
			'19075': 255,
			'19076': 198,
			'19077': 193,
			'19078': 192,
			'19079': 255,
			'19080': 197,
			'19081': 193,
			'19082': 192,
			'19083': 255,
			'19084': 197,
			'19085': 193,
			'19086': 192,
			'19087': 255,
			'19088': 196,
			'19089': 191,
			'19090': 190,
			'19091': 255,
			'19092': 193,
			'19093': 189,
			'19094': 188,
			'19095': 255,
			'19096': 190,
			'19097': 186,
			'19098': 185,
			'19099': 255,
			'19100': 191,
			'19101': 187,
			'19102': 186,
			'19103': 255,
			'19104': 190,
			'19105': 186,
			'19106': 185,
			'19107': 255,
			'19108': 189,
			'19109': 185,
			'19110': 184,
			'19111': 255,
			'19112': 184,
			'19113': 180,
			'19114': 179,
			'19115': 255,
			'19116': 180,
			'19117': 177,
			'19118': 176,
			'19119': 255,
			'19120': 183,
			'19121': 179,
			'19122': 178,
			'19123': 255,
			'19124': 182,
			'19125': 178,
			'19126': 177,
			'19127': 255,
			'19128': 182,
			'19129': 178,
			'19130': 177,
			'19131': 255,
			'19132': 178,
			'19133': 174,
			'19134': 173,
			'19135': 255,
			'19136': 177,
			'19137': 173,
			'19138': 173,
			'19139': 255,
			'19140': 176,
			'19141': 172,
			'19142': 171,
			'19143': 255,
			'19144': 174,
			'19145': 170,
			'19146': 168,
			'19147': 255,
			'19148': 171,
			'19149': 167,
			'19150': 164,
			'19151': 255,
			'19152': 171,
			'19153': 167,
			'19154': 165,
			'19155': 255,
			'19156': 168,
			'19157': 164,
			'19158': 163,
			'19159': 255,
			'19160': 166,
			'19161': 162,
			'19162': 161,
			'19163': 255,
			'19164': 164,
			'19165': 160,
			'19166': 159,
			'19167': 255,
			'19168': 161,
			'19169': 158,
			'19170': 156,
			'19171': 255,
			'19172': 160,
			'19173': 155,
			'19174': 154,
			'19175': 255,
			'19176': 157,
			'19177': 151,
			'19178': 151,
			'19179': 255,
			'19180': 156,
			'19181': 150,
			'19182': 151,
			'19183': 255,
			'19184': 156,
			'19185': 149,
			'19186': 149,
			'19187': 255,
			'19188': 154,
			'19189': 146,
			'19190': 146,
			'19191': 255,
			'19192': 149,
			'19193': 141,
			'19194': 142,
			'19195': 255,
			'19196': 151,
			'19197': 142,
			'19198': 143,
			'19199': 255,
			'19200': 206,
			'19201': 202,
			'19202': 201,
			'19203': 255,
			'19204': 205,
			'19205': 202,
			'19206': 200,
			'19207': 255,
			'19208': 205,
			'19209': 205,
			'19210': 203,
			'19211': 255,
			'19212': 205,
			'19213': 203,
			'19214': 202,
			'19215': 255,
			'19216': 206,
			'19217': 202,
			'19218': 201,
			'19219': 255,
			'19220': 207,
			'19221': 202,
			'19222': 201,
			'19223': 255,
			'19224': 207,
			'19225': 204,
			'19226': 203,
			'19227': 255,
			'19228': 207,
			'19229': 204,
			'19230': 202,
			'19231': 255,
			'19232': 208,
			'19233': 203,
			'19234': 202,
			'19235': 255,
			'19236': 207,
			'19237': 204,
			'19238': 202,
			'19239': 255,
			'19240': 208,
			'19241': 207,
			'19242': 205,
			'19243': 255,
			'19244': 206,
			'19245': 204,
			'19246': 202,
			'19247': 255,
			'19248': 206,
			'19249': 203,
			'19250': 202,
			'19251': 255,
			'19252': 213,
			'19253': 209,
			'19254': 208,
			'19255': 255,
			'19256': 202,
			'19257': 198,
			'19258': 197,
			'19259': 255,
			'19260': 171,
			'19261': 167,
			'19262': 166,
			'19263': 255,
			'19264': 203,
			'19265': 199,
			'19266': 198,
			'19267': 255,
			'19268': 218,
			'19269': 218,
			'19270': 215,
			'19271': 255,
			'19272': 215,
			'19273': 211,
			'19274': 210,
			'19275': 255,
			'19276': 211,
			'19277': 209,
			'19278': 207,
			'19279': 255,
			'19280': 225,
			'19281': 225,
			'19282': 222,
			'19283': 255,
			'19284': 186,
			'19285': 182,
			'19286': 181,
			'19287': 255,
			'19288': 187,
			'19289': 182,
			'19290': 182,
			'19291': 255,
			'19292': 215,
			'19293': 214,
			'19294': 212,
			'19295': 255,
			'19296': 212,
			'19297': 210,
			'19298': 208,
			'19299': 255,
			'19300': 211,
			'19301': 210,
			'19302': 208,
			'19303': 255,
			'19304': 212,
			'19305': 212,
			'19306': 210,
			'19307': 255,
			'19308': 213,
			'19309': 212,
			'19310': 210,
			'19311': 255,
			'19312': 214,
			'19313': 212,
			'19314': 210,
			'19315': 255,
			'19316': 213,
			'19317': 211,
			'19318': 209,
			'19319': 255,
			'19320': 214,
			'19321': 214,
			'19322': 212,
			'19323': 255,
			'19324': 213,
			'19325': 210,
			'19326': 209,
			'19327': 255,
			'19328': 212,
			'19329': 211,
			'19330': 209,
			'19331': 255,
			'19332': 212,
			'19333': 210,
			'19334': 208,
			'19335': 255,
			'19336': 200,
			'19337': 196,
			'19338': 195,
			'19339': 255,
			'19340': 209,
			'19341': 208,
			'19342': 206,
			'19343': 255,
			'19344': 242,
			'19345': 243,
			'19346': 241,
			'19347': 255,
			'19348': 202,
			'19349': 198,
			'19350': 198,
			'19351': 255,
			'19352': 43,
			'19353': 41,
			'19354': 41,
			'19355': 255,
			'19356': 27,
			'19357': 22,
			'19358': 22,
			'19359': 255,
			'19360': 193,
			'19361': 189,
			'19362': 188,
			'19363': 255,
			'19364': 243,
			'19365': 241,
			'19366': 239,
			'19367': 255,
			'19368': 219,
			'19369': 218,
			'19370': 216,
			'19371': 255,
			'19372': 219,
			'19373': 219,
			'19374': 217,
			'19375': 255,
			'19376': 226,
			'19377': 225,
			'19378': 223,
			'19379': 255,
			'19380': 189,
			'19381': 184,
			'19382': 183,
			'19383': 255,
			'19384': 128,
			'19385': 119,
			'19386': 120,
			'19387': 255,
			'19388': 111,
			'19389': 100,
			'19390': 102,
			'19391': 255,
			'19392': 112,
			'19393': 103,
			'19394': 104,
			'19395': 255,
			'19396': 110,
			'19397': 101,
			'19398': 101,
			'19399': 255,
			'19400': 103,
			'19401': 94,
			'19402': 93,
			'19403': 255,
			'19404': 86,
			'19405': 76,
			'19406': 74,
			'19407': 255,
			'19408': 71,
			'19409': 61,
			'19410': 60,
			'19411': 255,
			'19412': 64,
			'19413': 54,
			'19414': 54,
			'19415': 255,
			'19416': 79,
			'19417': 69,
			'19418': 69,
			'19419': 255,
			'19420': 67,
			'19421': 57,
			'19422': 56,
			'19423': 255,
			'19424': 50,
			'19425': 40,
			'19426': 39,
			'19427': 255,
			'19428': 41,
			'19429': 30,
			'19430': 29,
			'19431': 255,
			'19432': 93,
			'19433': 84,
			'19434': 84,
			'19435': 255,
			'19436': 143,
			'19437': 134,
			'19438': 135,
			'19439': 255,
			'19440': 143,
			'19441': 134,
			'19442': 135,
			'19443': 255,
			'19444': 166,
			'19445': 159,
			'19446': 159,
			'19447': 255,
			'19448': 207,
			'19449': 205,
			'19450': 204,
			'19451': 255,
			'19452': 221,
			'19453': 218,
			'19454': 216,
			'19455': 255,
			'19456': 201,
			'19457': 197,
			'19458': 196,
			'19459': 255,
			'19460': 197,
			'19461': 192,
			'19462': 191,
			'19463': 255,
			'19464': 197,
			'19465': 194,
			'19466': 193,
			'19467': 255,
			'19468': 196,
			'19469': 193,
			'19470': 191,
			'19471': 255,
			'19472': 197,
			'19473': 193,
			'19474': 192,
			'19475': 255,
			'19476': 194,
			'19477': 191,
			'19478': 190,
			'19479': 255,
			'19480': 193,
			'19481': 189,
			'19482': 188,
			'19483': 255,
			'19484': 191,
			'19485': 187,
			'19486': 186,
			'19487': 255,
			'19488': 190,
			'19489': 186,
			'19490': 185,
			'19491': 255,
			'19492': 189,
			'19493': 185,
			'19494': 184,
			'19495': 255,
			'19496': 188,
			'19497': 184,
			'19498': 183,
			'19499': 255,
			'19500': 187,
			'19501': 183,
			'19502': 182,
			'19503': 255,
			'19504': 187,
			'19505': 183,
			'19506': 182,
			'19507': 255,
			'19508': 187,
			'19509': 183,
			'19510': 182,
			'19511': 255,
			'19512': 183,
			'19513': 180,
			'19514': 179,
			'19515': 255,
			'19516': 168,
			'19517': 163,
			'19518': 162,
			'19519': 255,
			'19520': 172,
			'19521': 168,
			'19522': 167,
			'19523': 255,
			'19524': 180,
			'19525': 177,
			'19526': 175,
			'19527': 255,
			'19528': 178,
			'19529': 174,
			'19530': 173,
			'19531': 255,
			'19532': 177,
			'19533': 173,
			'19534': 172,
			'19535': 255,
			'19536': 176,
			'19537': 172,
			'19538': 170,
			'19539': 255,
			'19540': 173,
			'19541': 169,
			'19542': 166,
			'19543': 255,
			'19544': 172,
			'19545': 168,
			'19546': 166,
			'19547': 255,
			'19548': 167,
			'19549': 163,
			'19550': 162,
			'19551': 255,
			'19552': 166,
			'19553': 162,
			'19554': 162,
			'19555': 255,
			'19556': 163,
			'19557': 159,
			'19558': 158,
			'19559': 255,
			'19560': 163,
			'19561': 160,
			'19562': 159,
			'19563': 255,
			'19564': 161,
			'19565': 157,
			'19566': 156,
			'19567': 255,
			'19568': 158,
			'19569': 154,
			'19570': 153,
			'19571': 255,
			'19572': 158,
			'19573': 152,
			'19574': 152,
			'19575': 255,
			'19576': 155,
			'19577': 150,
			'19578': 150,
			'19579': 255,
			'19580': 153,
			'19581': 147,
			'19582': 147,
			'19583': 255,
			'19584': 150,
			'19585': 141,
			'19586': 142,
			'19587': 255,
			'19588': 149,
			'19589': 139,
			'19590': 140,
			'19591': 255,
			'19592': 146,
			'19593': 137,
			'19594': 138,
			'19595': 255,
			'19596': 149,
			'19597': 140,
			'19598': 140,
			'19599': 255,
			'19600': 205,
			'19601': 200,
			'19602': 199,
			'19603': 255,
			'19604': 203,
			'19605': 200,
			'19606': 199,
			'19607': 255,
			'19608': 202,
			'19609': 201,
			'19610': 199,
			'19611': 255,
			'19612': 204,
			'19613': 203,
			'19614': 201,
			'19615': 255,
			'19616': 206,
			'19617': 205,
			'19618': 203,
			'19619': 255,
			'19620': 203,
			'19621': 201,
			'19622': 199,
			'19623': 255,
			'19624': 203,
			'19625': 200,
			'19626': 198,
			'19627': 255,
			'19628': 205,
			'19629': 201,
			'19630': 200,
			'19631': 255,
			'19632': 206,
			'19633': 204,
			'19634': 202,
			'19635': 255,
			'19636': 204,
			'19637': 202,
			'19638': 200,
			'19639': 255,
			'19640': 205,
			'19641': 203,
			'19642': 201,
			'19643': 255,
			'19644': 208,
			'19645': 205,
			'19646': 204,
			'19647': 255,
			'19648': 206,
			'19649': 202,
			'19650': 201,
			'19651': 255,
			'19652': 204,
			'19653': 200,
			'19654': 199,
			'19655': 255,
			'19656': 197,
			'19657': 194,
			'19658': 193,
			'19659': 255,
			'19660': 167,
			'19661': 163,
			'19662': 162,
			'19663': 255,
			'19664': 205,
			'19665': 200,
			'19666': 200,
			'19667': 255,
			'19668': 215,
			'19669': 212,
			'19670': 211,
			'19671': 255,
			'19672': 211,
			'19673': 210,
			'19674': 208,
			'19675': 255,
			'19676': 215,
			'19677': 213,
			'19678': 212,
			'19679': 255,
			'19680': 209,
			'19681': 206,
			'19682': 205,
			'19683': 255,
			'19684': 196,
			'19685': 192,
			'19686': 191,
			'19687': 255,
			'19688': 197,
			'19689': 195,
			'19690': 194,
			'19691': 255,
			'19692': 211,
			'19693': 210,
			'19694': 208,
			'19695': 255,
			'19696': 209,
			'19697': 205,
			'19698': 204,
			'19699': 255,
			'19700': 211,
			'19701': 209,
			'19702': 207,
			'19703': 255,
			'19704': 210,
			'19705': 209,
			'19706': 207,
			'19707': 255,
			'19708': 215,
			'19709': 214,
			'19710': 212,
			'19711': 255,
			'19712': 211,
			'19713': 210,
			'19714': 208,
			'19715': 255,
			'19716': 210,
			'19717': 209,
			'19718': 207,
			'19719': 255,
			'19720': 215,
			'19721': 210,
			'19722': 210,
			'19723': 255,
			'19724': 211,
			'19725': 209,
			'19726': 207,
			'19727': 255,
			'19728': 206,
			'19729': 206,
			'19730': 204,
			'19731': 255,
			'19732': 217,
			'19733': 214,
			'19734': 213,
			'19735': 255,
			'19736': 234,
			'19737': 231,
			'19738': 230,
			'19739': 255,
			'19740': 219,
			'19741': 218,
			'19742': 216,
			'19743': 255,
			'19744': 190,
			'19745': 186,
			'19746': 185,
			'19747': 255,
			'19748': 55,
			'19749': 46,
			'19750': 45,
			'19751': 255,
			'19752': 18,
			'19753': 14,
			'19754': 14,
			'19755': 255,
			'19756': 187,
			'19757': 185,
			'19758': 184,
			'19759': 255,
			'19760': 245,
			'19761': 245,
			'19762': 243,
			'19763': 255,
			'19764': 219,
			'19765': 216,
			'19766': 215,
			'19767': 255,
			'19768': 219,
			'19769': 218,
			'19770': 216,
			'19771': 255,
			'19772': 217,
			'19773': 216,
			'19774': 214,
			'19775': 255,
			'19776': 217,
			'19777': 216,
			'19778': 214,
			'19779': 255,
			'19780': 226,
			'19781': 224,
			'19782': 222,
			'19783': 255,
			'19784': 207,
			'19785': 203,
			'19786': 202,
			'19787': 255,
			'19788': 164,
			'19789': 157,
			'19790': 157,
			'19791': 255,
			'19792': 147,
			'19793': 138,
			'19794': 140,
			'19795': 255,
			'19796': 136,
			'19797': 126,
			'19798': 127,
			'19799': 255,
			'19800': 108,
			'19801': 98,
			'19802': 99,
			'19803': 255,
			'19804': 85,
			'19805': 75,
			'19806': 75,
			'19807': 255,
			'19808': 85,
			'19809': 75,
			'19810': 73,
			'19811': 255,
			'19812': 76,
			'19813': 66,
			'19814': 65,
			'19815': 255,
			'19816': 72,
			'19817': 62,
			'19818': 61,
			'19819': 255,
			'19820': 62,
			'19821': 52,
			'19822': 50,
			'19823': 255,
			'19824': 42,
			'19825': 33,
			'19826': 31,
			'19827': 255,
			'19828': 101,
			'19829': 91,
			'19830': 92,
			'19831': 255,
			'19832': 141,
			'19833': 132,
			'19834': 133,
			'19835': 255,
			'19836': 136,
			'19837': 127,
			'19838': 128,
			'19839': 255,
			'19840': 149,
			'19841': 139,
			'19842': 141,
			'19843': 255,
			'19844': 160,
			'19845': 152,
			'19846': 152,
			'19847': 255,
			'19848': 125,
			'19849': 120,
			'19850': 119,
			'19851': 255,
			'19852': 124,
			'19853': 119,
			'19854': 119,
			'19855': 255,
			'19856': 211,
			'19857': 208,
			'19858': 207,
			'19859': 255,
			'19860': 220,
			'19861': 216,
			'19862': 215,
			'19863': 255,
			'19864': 204,
			'19865': 200,
			'19866': 199,
			'19867': 255,
			'19868': 192,
			'19869': 188,
			'19870': 187,
			'19871': 255,
			'19872': 190,
			'19873': 186,
			'19874': 185,
			'19875': 255,
			'19876': 190,
			'19877': 186,
			'19878': 185,
			'19879': 255,
			'19880': 188,
			'19881': 184,
			'19882': 183,
			'19883': 255,
			'19884': 185,
			'19885': 181,
			'19886': 180,
			'19887': 255,
			'19888': 184,
			'19889': 180,
			'19890': 179,
			'19891': 255,
			'19892': 184,
			'19893': 180,
			'19894': 179,
			'19895': 255,
			'19896': 184,
			'19897': 180,
			'19898': 179,
			'19899': 255,
			'19900': 183,
			'19901': 179,
			'19902': 178,
			'19903': 255,
			'19904': 184,
			'19905': 180,
			'19906': 179,
			'19907': 255,
			'19908': 183,
			'19909': 179,
			'19910': 178,
			'19911': 255,
			'19912': 177,
			'19913': 174,
			'19914': 172,
			'19915': 255,
			'19916': 159,
			'19917': 154,
			'19918': 153,
			'19919': 255,
			'19920': 170,
			'19921': 166,
			'19922': 165,
			'19923': 255,
			'19924': 180,
			'19925': 178,
			'19926': 177,
			'19927': 255,
			'19928': 178,
			'19929': 173,
			'19930': 172,
			'19931': 255,
			'19932': 176,
			'19933': 172,
			'19934': 169,
			'19935': 255,
			'19936': 175,
			'19937': 171,
			'19938': 167,
			'19939': 255,
			'19940': 171,
			'19941': 166,
			'19942': 164,
			'19943': 255,
			'19944': 166,
			'19945': 161,
			'19946': 161,
			'19947': 255,
			'19948': 167,
			'19949': 164,
			'19950': 163,
			'19951': 255,
			'19952': 165,
			'19953': 161,
			'19954': 160,
			'19955': 255,
			'19956': 163,
			'19957': 159,
			'19958': 158,
			'19959': 255,
			'19960': 160,
			'19961': 155,
			'19962': 154,
			'19963': 255,
			'19964': 159,
			'19965': 154,
			'19966': 154,
			'19967': 255,
			'19968': 158,
			'19969': 153,
			'19970': 153,
			'19971': 255,
			'19972': 155,
			'19973': 150,
			'19974': 150,
			'19975': 255,
			'19976': 154,
			'19977': 148,
			'19978': 148,
			'19979': 255,
			'19980': 153,
			'19981': 144,
			'19982': 144,
			'19983': 255,
			'19984': 150,
			'19985': 140,
			'19986': 141,
			'19987': 255,
			'19988': 149,
			'19989': 140,
			'19990': 141,
			'19991': 255,
			'19992': 146,
			'19993': 137,
			'19994': 138,
			'19995': 255,
			'19996': 149,
			'19997': 139,
			'19998': 139,
			'19999': 255,
			'20000': 204,
			'20001': 200,
			'20002': 199,
			'20003': 255,
			'20004': 202,
			'20005': 200,
			'20006': 198,
			'20007': 255,
			'20008': 200,
			'20009': 196,
			'20010': 195,
			'20011': 255,
			'20012': 200,
			'20013': 196,
			'20014': 195,
			'20015': 255,
			'20016': 206,
			'20017': 204,
			'20018': 203,
			'20019': 255,
			'20020': 201,
			'20021': 198,
			'20022': 197,
			'20023': 255,
			'20024': 202,
			'20025': 198,
			'20026': 197,
			'20027': 255,
			'20028': 203,
			'20029': 201,
			'20030': 200,
			'20031': 255,
			'20032': 203,
			'20033': 202,
			'20034': 200,
			'20035': 255,
			'20036': 203,
			'20037': 200,
			'20038': 199,
			'20039': 255,
			'20040': 203,
			'20041': 199,
			'20042': 198,
			'20043': 255,
			'20044': 206,
			'20045': 205,
			'20046': 203,
			'20047': 255,
			'20048': 199,
			'20049': 196,
			'20050': 195,
			'20051': 255,
			'20052': 204,
			'20053': 200,
			'20054': 199,
			'20055': 255,
			'20056': 195,
			'20057': 191,
			'20058': 190,
			'20059': 255,
			'20060': 158,
			'20061': 154,
			'20062': 153,
			'20063': 255,
			'20064': 207,
			'20065': 203,
			'20066': 202,
			'20067': 255,
			'20068': 214,
			'20069': 210,
			'20070': 209,
			'20071': 255,
			'20072': 208,
			'20073': 207,
			'20074': 205,
			'20075': 255,
			'20076': 212,
			'20077': 211,
			'20078': 209,
			'20079': 255,
			'20080': 206,
			'20081': 202,
			'20082': 201,
			'20083': 255,
			'20084': 208,
			'20085': 207,
			'20086': 204,
			'20087': 255,
			'20088': 213,
			'20089': 209,
			'20090': 208,
			'20091': 255,
			'20092': 209,
			'20093': 206,
			'20094': 204,
			'20095': 255,
			'20096': 208,
			'20097': 206,
			'20098': 204,
			'20099': 255,
			'20100': 209,
			'20101': 208,
			'20102': 206,
			'20103': 255,
			'20104': 206,
			'20105': 206,
			'20106': 204,
			'20107': 255,
			'20108': 214,
			'20109': 213,
			'20110': 211,
			'20111': 255,
			'20112': 211,
			'20113': 209,
			'20114': 207,
			'20115': 255,
			'20116': 209,
			'20117': 205,
			'20118': 204,
			'20119': 255,
			'20120': 212,
			'20121': 208,
			'20122': 207,
			'20123': 255,
			'20124': 221,
			'20125': 221,
			'20126': 219,
			'20127': 255,
			'20128': 247,
			'20129': 245,
			'20130': 244,
			'20131': 255,
			'20132': 227,
			'20133': 225,
			'20134': 224,
			'20135': 255,
			'20136': 156,
			'20137': 153,
			'20138': 151,
			'20139': 255,
			'20140': 80,
			'20141': 73,
			'20142': 71,
			'20143': 255,
			'20144': 44,
			'20145': 32,
			'20146': 32,
			'20147': 255,
			'20148': 29,
			'20149': 17,
			'20150': 18,
			'20151': 255,
			'20152': 186,
			'20153': 180,
			'20154': 179,
			'20155': 255,
			'20156': 252,
			'20157': 252,
			'20158': 249,
			'20159': 255,
			'20160': 214,
			'20161': 214,
			'20162': 212,
			'20163': 255,
			'20164': 219,
			'20165': 218,
			'20166': 216,
			'20167': 255,
			'20168': 219,
			'20169': 218,
			'20170': 216,
			'20171': 255,
			'20172': 216,
			'20173': 215,
			'20174': 213,
			'20175': 255,
			'20176': 215,
			'20177': 214,
			'20178': 212,
			'20179': 255,
			'20180': 212,
			'20181': 213,
			'20182': 210,
			'20183': 255,
			'20184': 218,
			'20185': 217,
			'20186': 215,
			'20187': 255,
			'20188': 229,
			'20189': 228,
			'20190': 226,
			'20191': 255,
			'20192': 211,
			'20193': 208,
			'20194': 207,
			'20195': 255,
			'20196': 181,
			'20197': 176,
			'20198': 175,
			'20199': 255,
			'20200': 159,
			'20201': 153,
			'20202': 153,
			'20203': 255,
			'20204': 135,
			'20205': 127,
			'20206': 128,
			'20207': 255,
			'20208': 116,
			'20209': 106,
			'20210': 107,
			'20211': 255,
			'20212': 90,
			'20213': 80,
			'20214': 80,
			'20215': 255,
			'20216': 70,
			'20217': 60,
			'20218': 59,
			'20219': 255,
			'20220': 80,
			'20221': 70,
			'20222': 68,
			'20223': 255,
			'20224': 117,
			'20225': 107,
			'20226': 108,
			'20227': 255,
			'20228': 149,
			'20229': 140,
			'20230': 142,
			'20231': 255,
			'20232': 142,
			'20233': 133,
			'20234': 134,
			'20235': 255,
			'20236': 146,
			'20237': 137,
			'20238': 138,
			'20239': 255,
			'20240': 154,
			'20241': 144,
			'20242': 145,
			'20243': 255,
			'20244': 155,
			'20245': 145,
			'20246': 147,
			'20247': 255,
			'20248': 157,
			'20249': 151,
			'20250': 151,
			'20251': 255,
			'20252': 66,
			'20253': 59,
			'20254': 60,
			'20255': 255,
			'20256': 68,
			'20257': 61,
			'20258': 61,
			'20259': 255,
			'20260': 160,
			'20261': 154,
			'20262': 154,
			'20263': 255,
			'20264': 188,
			'20265': 185,
			'20266': 184,
			'20267': 255,
			'20268': 212,
			'20269': 209,
			'20270': 207,
			'20271': 255,
			'20272': 196,
			'20273': 192,
			'20274': 191,
			'20275': 255,
			'20276': 183,
			'20277': 178,
			'20278': 178,
			'20279': 255,
			'20280': 179,
			'20281': 175,
			'20282': 174,
			'20283': 255,
			'20284': 182,
			'20285': 178,
			'20286': 177,
			'20287': 255,
			'20288': 182,
			'20289': 178,
			'20290': 177,
			'20291': 255,
			'20292': 183,
			'20293': 179,
			'20294': 178,
			'20295': 255,
			'20296': 182,
			'20297': 177,
			'20298': 177,
			'20299': 255,
			'20300': 180,
			'20301': 176,
			'20302': 175,
			'20303': 255,
			'20304': 179,
			'20305': 175,
			'20306': 174,
			'20307': 255,
			'20308': 176,
			'20309': 172,
			'20310': 171,
			'20311': 255,
			'20312': 167,
			'20313': 162,
			'20314': 161,
			'20315': 255,
			'20316': 170,
			'20317': 166,
			'20318': 165,
			'20319': 255,
			'20320': 179,
			'20321': 175,
			'20322': 175,
			'20323': 255,
			'20324': 177,
			'20325': 173,
			'20326': 172,
			'20327': 255,
			'20328': 175,
			'20329': 171,
			'20330': 169,
			'20331': 255,
			'20332': 174,
			'20333': 170,
			'20334': 167,
			'20335': 255,
			'20336': 172,
			'20337': 168,
			'20338': 166,
			'20339': 255,
			'20340': 165,
			'20341': 160,
			'20342': 159,
			'20343': 255,
			'20344': 165,
			'20345': 160,
			'20346': 160,
			'20347': 255,
			'20348': 167,
			'20349': 163,
			'20350': 162,
			'20351': 255,
			'20352': 162,
			'20353': 158,
			'20354': 157,
			'20355': 255,
			'20356': 160,
			'20357': 157,
			'20358': 156,
			'20359': 255,
			'20360': 158,
			'20361': 154,
			'20362': 153,
			'20363': 255,
			'20364': 159,
			'20365': 154,
			'20366': 154,
			'20367': 255,
			'20368': 157,
			'20369': 151,
			'20370': 151,
			'20371': 255,
			'20372': 154,
			'20373': 148,
			'20374': 148,
			'20375': 255,
			'20376': 155,
			'20377': 145,
			'20378': 147,
			'20379': 255,
			'20380': 150,
			'20381': 142,
			'20382': 143,
			'20383': 255,
			'20384': 149,
			'20385': 140,
			'20386': 141,
			'20387': 255,
			'20388': 147,
			'20389': 137,
			'20390': 139,
			'20391': 255,
			'20392': 140,
			'20393': 131,
			'20394': 132,
			'20395': 255,
			'20396': 145,
			'20397': 136,
			'20398': 137,
			'20399': 255,
			'20400': 202,
			'20401': 198,
			'20402': 197,
			'20403': 255,
			'20404': 199,
			'20405': 196,
			'20406': 195,
			'20407': 255,
			'20408': 202,
			'20409': 197,
			'20410': 196,
			'20411': 255,
			'20412': 201,
			'20413': 196,
			'20414': 195,
			'20415': 255,
			'20416': 201,
			'20417': 196,
			'20418': 195,
			'20419': 255,
			'20420': 202,
			'20421': 198,
			'20422': 197,
			'20423': 255,
			'20424': 202,
			'20425': 198,
			'20426': 197,
			'20427': 255,
			'20428': 200,
			'20429': 197,
			'20430': 195,
			'20431': 255,
			'20432': 202,
			'20433': 200,
			'20434': 198,
			'20435': 255,
			'20436': 204,
			'20437': 200,
			'20438': 199,
			'20439': 255,
			'20440': 203,
			'20441': 199,
			'20442': 198,
			'20443': 255,
			'20444': 206,
			'20445': 201,
			'20446': 200,
			'20447': 255,
			'20448': 203,
			'20449': 200,
			'20450': 199,
			'20451': 255,
			'20452': 205,
			'20453': 201,
			'20454': 200,
			'20455': 255,
			'20456': 191,
			'20457': 187,
			'20458': 186,
			'20459': 255,
			'20460': 164,
			'20461': 160,
			'20462': 159,
			'20463': 255,
			'20464': 195,
			'20465': 192,
			'20466': 190,
			'20467': 255,
			'20468': 212,
			'20469': 207,
			'20470': 206,
			'20471': 255,
			'20472': 205,
			'20473': 202,
			'20474': 200,
			'20475': 255,
			'20476': 209,
			'20477': 206,
			'20478': 205,
			'20479': 255,
			'20480': 209,
			'20481': 208,
			'20482': 206,
			'20483': 255,
			'20484': 208,
			'20485': 205,
			'20486': 203,
			'20487': 255,
			'20488': 208,
			'20489': 204,
			'20490': 203,
			'20491': 255,
			'20492': 208,
			'20493': 205,
			'20494': 203,
			'20495': 255,
			'20496': 207,
			'20497': 207,
			'20498': 204,
			'20499': 255,
			'20500': 209,
			'20501': 207,
			'20502': 205,
			'20503': 255,
			'20504': 208,
			'20505': 206,
			'20506': 204,
			'20507': 255,
			'20508': 207,
			'20509': 206,
			'20510': 203,
			'20511': 255,
			'20512': 213,
			'20513': 210,
			'20514': 208,
			'20515': 255,
			'20516': 234,
			'20517': 230,
			'20518': 229,
			'20519': 255,
			'20520': 241,
			'20521': 241,
			'20522': 240,
			'20523': 255,
			'20524': 206,
			'20525': 204,
			'20526': 202,
			'20527': 255,
			'20528': 153,
			'20529': 146,
			'20530': 145,
			'20531': 255,
			'20532': 80,
			'20533': 72,
			'20534': 73,
			'20535': 255,
			'20536': 19,
			'20537': 9,
			'20538': 8,
			'20539': 255,
			'20540': 14,
			'20541': 3,
			'20542': 3,
			'20543': 255,
			'20544': 49,
			'20545': 38,
			'20546': 37,
			'20547': 255,
			'20548': 40,
			'20549': 30,
			'20550': 31,
			'20551': 255,
			'20552': 180,
			'20553': 175,
			'20554': 175,
			'20555': 255,
			'20556': 238,
			'20557': 237,
			'20558': 235,
			'20559': 255,
			'20560': 216,
			'20561': 215,
			'20562': 213,
			'20563': 255,
			'20564': 219,
			'20565': 218,
			'20566': 216,
			'20567': 255,
			'20568': 217,
			'20569': 216,
			'20570': 214,
			'20571': 255,
			'20572': 215,
			'20573': 214,
			'20574': 212,
			'20575': 255,
			'20576': 213,
			'20577': 212,
			'20578': 210,
			'20579': 255,
			'20580': 212,
			'20581': 210,
			'20582': 209,
			'20583': 255,
			'20584': 215,
			'20585': 214,
			'20586': 212,
			'20587': 255,
			'20588': 214,
			'20589': 214,
			'20590': 212,
			'20591': 255,
			'20592': 216,
			'20593': 215,
			'20594': 213,
			'20595': 255,
			'20596': 214,
			'20597': 212,
			'20598': 210,
			'20599': 255,
			'20600': 208,
			'20601': 205,
			'20602': 204,
			'20603': 255,
			'20604': 187,
			'20605': 184,
			'20606': 183,
			'20607': 255,
			'20608': 151,
			'20609': 144,
			'20610': 145,
			'20611': 255,
			'20612': 113,
			'20613': 103,
			'20614': 105,
			'20615': 255,
			'20616': 92,
			'20617': 82,
			'20618': 83,
			'20619': 255,
			'20620': 118,
			'20621': 108,
			'20622': 109,
			'20623': 255,
			'20624': 151,
			'20625': 141,
			'20626': 143,
			'20627': 255,
			'20628': 151,
			'20629': 142,
			'20630': 143,
			'20631': 255,
			'20632': 155,
			'20633': 146,
			'20634': 147,
			'20635': 255,
			'20636': 154,
			'20637': 145,
			'20638': 146,
			'20639': 255,
			'20640': 151,
			'20641': 142,
			'20642': 143,
			'20643': 255,
			'20644': 145,
			'20645': 135,
			'20646': 137,
			'20647': 255,
			'20648': 175,
			'20649': 169,
			'20650': 169,
			'20651': 255,
			'20652': 158,
			'20653': 154,
			'20654': 153,
			'20655': 255,
			'20656': 3,
			'20657': 0,
			'20658': 0,
			'20659': 255,
			'20660': 5,
			'20661': 0,
			'20662': 0,
			'20663': 255,
			'20664': 35,
			'20665': 27,
			'20666': 27,
			'20667': 255,
			'20668': 120,
			'20669': 114,
			'20670': 113,
			'20671': 255,
			'20672': 206,
			'20673': 202,
			'20674': 201,
			'20675': 255,
			'20676': 218,
			'20677': 215,
			'20678': 213,
			'20679': 255,
			'20680': 194,
			'20681': 191,
			'20682': 190,
			'20683': 255,
			'20684': 183,
			'20685': 179,
			'20686': 178,
			'20687': 255,
			'20688': 183,
			'20689': 179,
			'20690': 178,
			'20691': 255,
			'20692': 182,
			'20693': 178,
			'20694': 177,
			'20695': 255,
			'20696': 180,
			'20697': 176,
			'20698': 175,
			'20699': 255,
			'20700': 177,
			'20701': 174,
			'20702': 173,
			'20703': 255,
			'20704': 176,
			'20705': 172,
			'20706': 171,
			'20707': 255,
			'20708': 171,
			'20709': 167,
			'20710': 165,
			'20711': 255,
			'20712': 176,
			'20713': 172,
			'20714': 171,
			'20715': 255,
			'20716': 169,
			'20717': 164,
			'20718': 164,
			'20719': 255,
			'20720': 170,
			'20721': 166,
			'20722': 165,
			'20723': 255,
			'20724': 177,
			'20725': 173,
			'20726': 170,
			'20727': 255,
			'20728': 174,
			'20729': 170,
			'20730': 168,
			'20731': 255,
			'20732': 173,
			'20733': 169,
			'20734': 167,
			'20735': 255,
			'20736': 170,
			'20737': 166,
			'20738': 165,
			'20739': 255,
			'20740': 167,
			'20741': 164,
			'20742': 163,
			'20743': 255,
			'20744': 166,
			'20745': 162,
			'20746': 161,
			'20747': 255,
			'20748': 162,
			'20749': 158,
			'20750': 157,
			'20751': 255,
			'20752': 160,
			'20753': 157,
			'20754': 155,
			'20755': 255,
			'20756': 159,
			'20757': 155,
			'20758': 154,
			'20759': 255,
			'20760': 158,
			'20761': 153,
			'20762': 153,
			'20763': 255,
			'20764': 157,
			'20765': 151,
			'20766': 151,
			'20767': 255,
			'20768': 154,
			'20769': 148,
			'20770': 148,
			'20771': 255,
			'20772': 155,
			'20773': 146,
			'20774': 147,
			'20775': 255,
			'20776': 151,
			'20777': 141,
			'20778': 143,
			'20779': 255,
			'20780': 146,
			'20781': 138,
			'20782': 138,
			'20783': 255,
			'20784': 146,
			'20785': 136,
			'20786': 137,
			'20787': 255,
			'20788': 143,
			'20789': 134,
			'20790': 134,
			'20791': 255,
			'20792': 140,
			'20793': 132,
			'20794': 132,
			'20795': 255,
			'20796': 144,
			'20797': 135,
			'20798': 137,
			'20799': 255,
			'20800': 201,
			'20801': 197,
			'20802': 196,
			'20803': 255,
			'20804': 197,
			'20805': 193,
			'20806': 192,
			'20807': 255,
			'20808': 198,
			'20809': 194,
			'20810': 193,
			'20811': 255,
			'20812': 199,
			'20813': 195,
			'20814': 194,
			'20815': 255,
			'20816': 199,
			'20817': 194,
			'20818': 193,
			'20819': 255,
			'20820': 202,
			'20821': 198,
			'20822': 197,
			'20823': 255,
			'20824': 198,
			'20825': 195,
			'20826': 194,
			'20827': 255,
			'20828': 198,
			'20829': 193,
			'20830': 192,
			'20831': 255,
			'20832': 195,
			'20833': 192,
			'20834': 191,
			'20835': 255,
			'20836': 198,
			'20837': 195,
			'20838': 194,
			'20839': 255,
			'20840': 203,
			'20841': 199,
			'20842': 198,
			'20843': 255,
			'20844': 200,
			'20845': 195,
			'20846': 194,
			'20847': 255,
			'20848': 199,
			'20849': 195,
			'20850': 194,
			'20851': 255,
			'20852': 198,
			'20853': 194,
			'20854': 193,
			'20855': 255,
			'20856': 196,
			'20857': 192,
			'20858': 191,
			'20859': 255,
			'20860': 183,
			'20861': 179,
			'20862': 178,
			'20863': 255,
			'20864': 178,
			'20865': 174,
			'20866': 173,
			'20867': 255,
			'20868': 204,
			'20869': 200,
			'20870': 199,
			'20871': 255,
			'20872': 206,
			'20873': 201,
			'20874': 201,
			'20875': 255,
			'20876': 207,
			'20877': 203,
			'20878': 202,
			'20879': 255,
			'20880': 207,
			'20881': 205,
			'20882': 204,
			'20883': 255,
			'20884': 207,
			'20885': 204,
			'20886': 203,
			'20887': 255,
			'20888': 206,
			'20889': 202,
			'20890': 201,
			'20891': 255,
			'20892': 205,
			'20893': 201,
			'20894': 200,
			'20895': 255,
			'20896': 205,
			'20897': 204,
			'20898': 202,
			'20899': 255,
			'20900': 207,
			'20901': 206,
			'20902': 204,
			'20903': 255,
			'20904': 206,
			'20905': 202,
			'20906': 201,
			'20907': 255,
			'20908': 227,
			'20909': 225,
			'20910': 223,
			'20911': 255,
			'20912': 243,
			'20913': 242,
			'20914': 240,
			'20915': 255,
			'20916': 180,
			'20917': 176,
			'20918': 175,
			'20919': 255,
			'20920': 105,
			'20921': 100,
			'20922': 98,
			'20923': 255,
			'20924': 53,
			'20925': 45,
			'20926': 44,
			'20927': 255,
			'20928': 9,
			'20929': 0,
			'20930': 0,
			'20931': 255,
			'20932': 13,
			'20933': 4,
			'20934': 4,
			'20935': 255,
			'20936': 38,
			'20937': 30,
			'20938': 27,
			'20939': 255,
			'20940': 26,
			'20941': 18,
			'20942': 18,
			'20943': 255,
			'20944': 42,
			'20945': 33,
			'20946': 32,
			'20947': 255,
			'20948': 21,
			'20949': 11,
			'20950': 9,
			'20951': 255,
			'20952': 130,
			'20953': 125,
			'20954': 124,
			'20955': 255,
			'20956': 249,
			'20957': 249,
			'20958': 247,
			'20959': 255,
			'20960': 213,
			'20961': 213,
			'20962': 211,
			'20963': 255,
			'20964': 216,
			'20965': 215,
			'20966': 213,
			'20967': 255,
			'20968': 216,
			'20969': 216,
			'20970': 213,
			'20971': 255,
			'20972': 213,
			'20973': 212,
			'20974': 210,
			'20975': 255,
			'20976': 214,
			'20977': 211,
			'20978': 209,
			'20979': 255,
			'20980': 211,
			'20981': 207,
			'20982': 206,
			'20983': 255,
			'20984': 211,
			'20985': 207,
			'20986': 206,
			'20987': 255,
			'20988': 216,
			'20989': 213,
			'20990': 212,
			'20991': 255,
			'20992': 211,
			'20993': 210,
			'20994': 207,
			'20995': 255,
			'20996': 204,
			'20997': 201,
			'20998': 199,
			'20999': 255,
			'21000': 194,
			'21001': 189,
			'21002': 189,
			'21003': 255,
			'21004': 179,
			'21005': 176,
			'21006': 175,
			'21007': 255,
			'21008': 154,
			'21009': 148,
			'21010': 148,
			'21011': 255,
			'21012': 135,
			'21013': 125,
			'21014': 126,
			'21015': 255,
			'21016': 133,
			'21017': 124,
			'21018': 125,
			'21019': 255,
			'21020': 146,
			'21021': 137,
			'21022': 138,
			'21023': 255,
			'21024': 154,
			'21025': 145,
			'21026': 146,
			'21027': 255,
			'21028': 157,
			'21029': 148,
			'21030': 149,
			'21031': 255,
			'21032': 153,
			'21033': 144,
			'21034': 145,
			'21035': 255,
			'21036': 149,
			'21037': 140,
			'21038': 141,
			'21039': 255,
			'21040': 151,
			'21041': 142,
			'21042': 143,
			'21043': 255,
			'21044': 143,
			'21045': 133,
			'21046': 134,
			'21047': 255,
			'21048': 178,
			'21049': 171,
			'21050': 171,
			'21051': 255,
			'21052': 136,
			'21053': 131,
			'21054': 130,
			'21055': 255,
			'21056': 11,
			'21057': 5,
			'21058': 4,
			'21059': 255,
			'21060': 14,
			'21061': 7,
			'21062': 7,
			'21063': 255,
			'21064': 7,
			'21065': 0,
			'21066': 0,
			'21067': 255,
			'21068': 2,
			'21069': 0,
			'21070': 0,
			'21071': 255,
			'21072': 59,
			'21073': 50,
			'21074': 51,
			'21075': 255,
			'21076': 119,
			'21077': 113,
			'21078': 113,
			'21079': 255,
			'21080': 174,
			'21081': 171,
			'21082': 169,
			'21083': 255,
			'21084': 210,
			'21085': 208,
			'21086': 206,
			'21087': 255,
			'21088': 187,
			'21089': 183,
			'21090': 182,
			'21091': 255,
			'21092': 174,
			'21093': 171,
			'21094': 170,
			'21095': 255,
			'21096': 176,
			'21097': 173,
			'21098': 172,
			'21099': 255,
			'21100': 178,
			'21101': 174,
			'21102': 172,
			'21103': 255,
			'21104': 177,
			'21105': 173,
			'21106': 171,
			'21107': 255,
			'21108': 175,
			'21109': 171,
			'21110': 170,
			'21111': 255,
			'21112': 179,
			'21113': 176,
			'21114': 175,
			'21115': 255,
			'21116': 154,
			'21117': 148,
			'21118': 147,
			'21119': 255,
			'21120': 166,
			'21121': 161,
			'21122': 160,
			'21123': 255,
			'21124': 177,
			'21125': 173,
			'21126': 170,
			'21127': 255,
			'21128': 172,
			'21129': 168,
			'21130': 166,
			'21131': 255,
			'21132': 169,
			'21133': 165,
			'21134': 164,
			'21135': 255,
			'21136': 168,
			'21137': 164,
			'21138': 162,
			'21139': 255,
			'21140': 165,
			'21141': 161,
			'21142': 160,
			'21143': 255,
			'21144': 161,
			'21145': 158,
			'21146': 156,
			'21147': 255,
			'21148': 160,
			'21149': 156,
			'21150': 155,
			'21151': 255,
			'21152': 159,
			'21153': 154,
			'21154': 153,
			'21155': 255,
			'21156': 158,
			'21157': 152,
			'21158': 152,
			'21159': 255,
			'21160': 157,
			'21161': 151,
			'21162': 151,
			'21163': 255,
			'21164': 155,
			'21165': 148,
			'21166': 149,
			'21167': 255,
			'21168': 154,
			'21169': 145,
			'21170': 146,
			'21171': 255,
			'21172': 153,
			'21173': 144,
			'21174': 145,
			'21175': 255,
			'21176': 148,
			'21177': 140,
			'21178': 141,
			'21179': 255,
			'21180': 149,
			'21181': 139,
			'21182': 141,
			'21183': 255,
			'21184': 146,
			'21185': 137,
			'21186': 137,
			'21187': 255,
			'21188': 142,
			'21189': 133,
			'21190': 133,
			'21191': 255,
			'21192': 140,
			'21193': 131,
			'21194': 132,
			'21195': 255,
			'21196': 142,
			'21197': 134,
			'21198': 134,
			'21199': 255,
			'21200': 197,
			'21201': 193,
			'21202': 192,
			'21203': 255,
			'21204': 195,
			'21205': 191,
			'21206': 190,
			'21207': 255,
			'21208': 197,
			'21209': 193,
			'21210': 192,
			'21211': 255,
			'21212': 191,
			'21213': 187,
			'21214': 186,
			'21215': 255,
			'21216': 187,
			'21217': 183,
			'21218': 182,
			'21219': 255,
			'21220': 199,
			'21221': 195,
			'21222': 194,
			'21223': 255,
			'21224': 198,
			'21225': 194,
			'21226': 193,
			'21227': 255,
			'21228': 201,
			'21229': 196,
			'21230': 195,
			'21231': 255,
			'21232': 188,
			'21233': 184,
			'21234': 183,
			'21235': 255,
			'21236': 184,
			'21237': 180,
			'21238': 179,
			'21239': 255,
			'21240': 197,
			'21241': 193,
			'21242': 192,
			'21243': 255,
			'21244': 194,
			'21245': 190,
			'21246': 189,
			'21247': 255,
			'21248': 190,
			'21249': 186,
			'21250': 185,
			'21251': 255,
			'21252': 194,
			'21253': 190,
			'21254': 189,
			'21255': 255,
			'21256': 201,
			'21257': 196,
			'21258': 196,
			'21259': 255,
			'21260': 194,
			'21261': 190,
			'21262': 189,
			'21263': 255,
			'21264': 188,
			'21265': 184,
			'21266': 183,
			'21267': 255,
			'21268': 196,
			'21269': 192,
			'21270': 191,
			'21271': 255,
			'21272': 201,
			'21273': 197,
			'21274': 196,
			'21275': 255,
			'21276': 204,
			'21277': 200,
			'21278': 199,
			'21279': 255,
			'21280': 204,
			'21281': 201,
			'21282': 199,
			'21283': 255,
			'21284': 206,
			'21285': 204,
			'21286': 202,
			'21287': 255,
			'21288': 205,
			'21289': 201,
			'21290': 200,
			'21291': 255,
			'21292': 203,
			'21293': 198,
			'21294': 197,
			'21295': 255,
			'21296': 205,
			'21297': 201,
			'21298': 201,
			'21299': 255,
			'21300': 222,
			'21301': 219,
			'21302': 218,
			'21303': 255,
			'21304': 239,
			'21305': 236,
			'21306': 235,
			'21307': 255,
			'21308': 204,
			'21309': 201,
			'21310': 199,
			'21311': 255,
			'21312': 108,
			'21313': 102,
			'21314': 100,
			'21315': 255,
			'21316': 21,
			'21317': 12,
			'21318': 12,
			'21319': 255,
			'21320': 0,
			'21321': 0,
			'21322': 0,
			'21323': 255,
			'21324': 19,
			'21325': 9,
			'21326': 10,
			'21327': 255,
			'21328': 30,
			'21329': 21,
			'21330': 23,
			'21331': 255,
			'21332': 29,
			'21333': 20,
			'21334': 21,
			'21335': 255,
			'21336': 39,
			'21337': 30,
			'21338': 30,
			'21339': 255,
			'21340': 26,
			'21341': 18,
			'21342': 18,
			'21343': 255,
			'21344': 28,
			'21345': 20,
			'21346': 21,
			'21347': 255,
			'21348': 32,
			'21349': 22,
			'21350': 21,
			'21351': 255,
			'21352': 56,
			'21353': 47,
			'21354': 46,
			'21355': 255,
			'21356': 217,
			'21357': 215,
			'21358': 214,
			'21359': 255,
			'21360': 230,
			'21361': 228,
			'21362': 227,
			'21363': 255,
			'21364': 212,
			'21365': 211,
			'21366': 209,
			'21367': 255,
			'21368': 215,
			'21369': 214,
			'21370': 212,
			'21371': 255,
			'21372': 215,
			'21373': 213,
			'21374': 212,
			'21375': 255,
			'21376': 212,
			'21377': 211,
			'21378': 209,
			'21379': 255,
			'21380': 207,
			'21381': 205,
			'21382': 203,
			'21383': 255,
			'21384': 204,
			'21385': 200,
			'21386': 199,
			'21387': 255,
			'21388': 209,
			'21389': 206,
			'21390': 204,
			'21391': 255,
			'21392': 212,
			'21393': 208,
			'21394': 207,
			'21395': 255,
			'21396': 203,
			'21397': 199,
			'21398': 198,
			'21399': 255,
			'21400': 190,
			'21401': 187,
			'21402': 186,
			'21403': 255,
			'21404': 175,
			'21405': 172,
			'21406': 170,
			'21407': 255,
			'21408': 159,
			'21409': 153,
			'21410': 152,
			'21411': 255,
			'21412': 148,
			'21413': 138,
			'21414': 139,
			'21415': 255,
			'21416': 144,
			'21417': 135,
			'21418': 136,
			'21419': 255,
			'21420': 151,
			'21421': 144,
			'21422': 144,
			'21423': 255,
			'21424': 159,
			'21425': 155,
			'21426': 154,
			'21427': 255,
			'21428': 160,
			'21429': 153,
			'21430': 153,
			'21431': 255,
			'21432': 149,
			'21433': 140,
			'21434': 141,
			'21435': 255,
			'21436': 142,
			'21437': 133,
			'21438': 134,
			'21439': 255,
			'21440': 141,
			'21441': 132,
			'21442': 133,
			'21443': 255,
			'21444': 147,
			'21445': 138,
			'21446': 139,
			'21447': 255,
			'21448': 185,
			'21449': 177,
			'21450': 178,
			'21451': 255,
			'21452': 72,
			'21453': 62,
			'21454': 64,
			'21455': 255,
			'21456': 0,
			'21457': 0,
			'21458': 0,
			'21459': 255,
			'21460': 22,
			'21461': 14,
			'21462': 13,
			'21463': 255,
			'21464': 23,
			'21465': 14,
			'21466': 16,
			'21467': 255,
			'21468': 23,
			'21469': 15,
			'21470': 15,
			'21471': 255,
			'21472': 2,
			'21473': 0,
			'21474': 0,
			'21475': 255,
			'21476': 0,
			'21477': 0,
			'21478': 0,
			'21479': 255,
			'21480': 25,
			'21481': 16,
			'21482': 16,
			'21483': 255,
			'21484': 107,
			'21485': 102,
			'21486': 102,
			'21487': 255,
			'21488': 193,
			'21489': 189,
			'21490': 189,
			'21491': 255,
			'21492': 196,
			'21493': 193,
			'21494': 192,
			'21495': 255,
			'21496': 174,
			'21497': 170,
			'21498': 169,
			'21499': 255,
			'21500': 168,
			'21501': 164,
			'21502': 162,
			'21503': 255,
			'21504': 168,
			'21505': 164,
			'21506': 162,
			'21507': 255,
			'21508': 164,
			'21509': 160,
			'21510': 160,
			'21511': 255,
			'21512': 160,
			'21513': 155,
			'21514': 155,
			'21515': 255,
			'21516': 163,
			'21517': 158,
			'21518': 158,
			'21519': 255,
			'21520': 174,
			'21521': 169,
			'21522': 168,
			'21523': 255,
			'21524': 172,
			'21525': 168,
			'21526': 166,
			'21527': 255,
			'21528': 166,
			'21529': 162,
			'21530': 161,
			'21531': 255,
			'21532': 164,
			'21533': 160,
			'21534': 159,
			'21535': 255,
			'21536': 163,
			'21537': 159,
			'21538': 157,
			'21539': 255,
			'21540': 162,
			'21541': 158,
			'21542': 157,
			'21543': 255,
			'21544': 160,
			'21545': 155,
			'21546': 154,
			'21547': 255,
			'21548': 155,
			'21549': 149,
			'21550': 149,
			'21551': 255,
			'21552': 157,
			'21553': 151,
			'21554': 151,
			'21555': 255,
			'21556': 155,
			'21557': 150,
			'21558': 150,
			'21559': 255,
			'21560': 154,
			'21561': 148,
			'21562': 148,
			'21563': 255,
			'21564': 155,
			'21565': 146,
			'21566': 147,
			'21567': 255,
			'21568': 152,
			'21569': 142,
			'21570': 143,
			'21571': 255,
			'21572': 149,
			'21573': 140,
			'21574': 141,
			'21575': 255,
			'21576': 146,
			'21577': 138,
			'21578': 139,
			'21579': 255,
			'21580': 137,
			'21581': 128,
			'21582': 129,
			'21583': 255,
			'21584': 139,
			'21585': 131,
			'21586': 130,
			'21587': 255,
			'21588': 143,
			'21589': 134,
			'21590': 135,
			'21591': 255,
			'21592': 137,
			'21593': 128,
			'21594': 130,
			'21595': 255,
			'21596': 140,
			'21597': 133,
			'21598': 133,
			'21599': 255,
			'21600': 197,
			'21601': 193,
			'21602': 192,
			'21603': 255,
			'21604': 193,
			'21605': 189,
			'21606': 188,
			'21607': 255,
			'21608': 198,
			'21609': 194,
			'21610': 193,
			'21611': 255,
			'21612': 198,
			'21613': 194,
			'21614': 193,
			'21615': 255,
			'21616': 187,
			'21617': 183,
			'21618': 182,
			'21619': 255,
			'21620': 189,
			'21621': 186,
			'21622': 185,
			'21623': 255,
			'21624': 204,
			'21625': 200,
			'21626': 199,
			'21627': 255,
			'21628': 207,
			'21629': 203,
			'21630': 202,
			'21631': 255,
			'21632': 200,
			'21633': 197,
			'21634': 196,
			'21635': 255,
			'21636': 196,
			'21637': 192,
			'21638': 191,
			'21639': 255,
			'21640': 198,
			'21641': 195,
			'21642': 193,
			'21643': 255,
			'21644': 205,
			'21645': 201,
			'21646': 200,
			'21647': 255,
			'21648': 200,
			'21649': 196,
			'21650': 195,
			'21651': 255,
			'21652': 197,
			'21653': 192,
			'21654': 191,
			'21655': 255,
			'21656': 201,
			'21657': 197,
			'21658': 196,
			'21659': 255,
			'21660': 205,
			'21661': 201,
			'21662': 200,
			'21663': 255,
			'21664': 205,
			'21665': 202,
			'21666': 200,
			'21667': 255,
			'21668': 202,
			'21669': 199,
			'21670': 198,
			'21671': 255,
			'21672': 204,
			'21673': 200,
			'21674': 199,
			'21675': 255,
			'21676': 206,
			'21677': 203,
			'21678': 202,
			'21679': 255,
			'21680': 206,
			'21681': 202,
			'21682': 202,
			'21683': 255,
			'21684': 210,
			'21685': 206,
			'21686': 205,
			'21687': 255,
			'21688': 209,
			'21689': 205,
			'21690': 204,
			'21691': 255,
			'21692': 225,
			'21693': 222,
			'21694': 221,
			'21695': 255,
			'21696': 230,
			'21697': 227,
			'21698': 226,
			'21699': 255,
			'21700': 195,
			'21701': 190,
			'21702': 190,
			'21703': 255,
			'21704': 123,
			'21705': 117,
			'21706': 117,
			'21707': 255,
			'21708': 37,
			'21709': 28,
			'21710': 28,
			'21711': 255,
			'21712': 0,
			'21713': 0,
			'21714': 0,
			'21715': 255,
			'21716': 21,
			'21717': 12,
			'21718': 12,
			'21719': 255,
			'21720': 30,
			'21721': 22,
			'21722': 22,
			'21723': 255,
			'21724': 24,
			'21725': 16,
			'21726': 17,
			'21727': 255,
			'21728': 24,
			'21729': 15,
			'21730': 16,
			'21731': 255,
			'21732': 27,
			'21733': 18,
			'21734': 19,
			'21735': 255,
			'21736': 32,
			'21737': 23,
			'21738': 24,
			'21739': 255,
			'21740': 31,
			'21741': 21,
			'21742': 23,
			'21743': 255,
			'21744': 21,
			'21745': 12,
			'21746': 14,
			'21747': 255,
			'21748': 41,
			'21749': 31,
			'21750': 32,
			'21751': 255,
			'21752': 13,
			'21753': 2,
			'21754': 0,
			'21755': 255,
			'21756': 122,
			'21757': 115,
			'21758': 114,
			'21759': 255,
			'21760': 253,
			'21761': 251,
			'21762': 249,
			'21763': 255,
			'21764': 213,
			'21765': 210,
			'21766': 209,
			'21767': 255,
			'21768': 214,
			'21769': 209,
			'21770': 208,
			'21771': 255,
			'21772': 213,
			'21773': 211,
			'21774': 209,
			'21775': 255,
			'21776': 209,
			'21777': 209,
			'21778': 207,
			'21779': 255,
			'21780': 209,
			'21781': 206,
			'21782': 204,
			'21783': 255,
			'21784': 203,
			'21785': 198,
			'21786': 197,
			'21787': 255,
			'21788': 199,
			'21789': 195,
			'21790': 194,
			'21791': 255,
			'21792': 204,
			'21793': 200,
			'21794': 199,
			'21795': 255,
			'21796': 201,
			'21797': 197,
			'21798': 196,
			'21799': 255,
			'21800': 189,
			'21801': 185,
			'21802': 184,
			'21803': 255,
			'21804': 178,
			'21805': 174,
			'21806': 173,
			'21807': 255,
			'21808': 167,
			'21809': 162,
			'21810': 161,
			'21811': 255,
			'21812': 153,
			'21813': 144,
			'21814': 145,
			'21815': 255,
			'21816': 151,
			'21817': 141,
			'21818': 142,
			'21819': 255,
			'21820': 157,
			'21821': 151,
			'21822': 151,
			'21823': 255,
			'21824': 159,
			'21825': 154,
			'21826': 154,
			'21827': 255,
			'21828': 154,
			'21829': 146,
			'21830': 147,
			'21831': 255,
			'21832': 144,
			'21833': 134,
			'21834': 135,
			'21835': 255,
			'21836': 136,
			'21837': 127,
			'21838': 128,
			'21839': 255,
			'21840': 135,
			'21841': 126,
			'21842': 127,
			'21843': 255,
			'21844': 169,
			'21845': 160,
			'21846': 161,
			'21847': 255,
			'21848': 123,
			'21849': 113,
			'21850': 114,
			'21851': 255,
			'21852': 4,
			'21853': 0,
			'21854': 0,
			'21855': 255,
			'21856': 16,
			'21857': 8,
			'21858': 7,
			'21859': 255,
			'21860': 21,
			'21861': 12,
			'21862': 11,
			'21863': 255,
			'21864': 22,
			'21865': 13,
			'21866': 15,
			'21867': 255,
			'21868': 21,
			'21869': 15,
			'21870': 12,
			'21871': 255,
			'21872': 20,
			'21873': 15,
			'21874': 13,
			'21875': 255,
			'21876': 23,
			'21877': 16,
			'21878': 15,
			'21879': 255,
			'21880': 9,
			'21881': 0,
			'21882': 1,
			'21883': 255,
			'21884': 0,
			'21885': 0,
			'21886': 0,
			'21887': 255,
			'21888': 55,
			'21889': 47,
			'21890': 48,
			'21891': 255,
			'21892': 157,
			'21893': 151,
			'21894': 151,
			'21895': 255,
			'21896': 200,
			'21897': 198,
			'21898': 196,
			'21899': 255,
			'21900': 175,
			'21901': 172,
			'21902': 171,
			'21903': 255,
			'21904': 163,
			'21905': 159,
			'21906': 158,
			'21907': 255,
			'21908': 165,
			'21909': 160,
			'21910': 159,
			'21911': 255,
			'21912': 164,
			'21913': 159,
			'21914': 158,
			'21915': 255,
			'21916': 172,
			'21917': 168,
			'21918': 167,
			'21919': 255,
			'21920': 169,
			'21921': 165,
			'21922': 164,
			'21923': 255,
			'21924': 160,
			'21925': 157,
			'21926': 155,
			'21927': 255,
			'21928': 160,
			'21929': 156,
			'21930': 155,
			'21931': 255,
			'21932': 161,
			'21933': 157,
			'21934': 156,
			'21935': 255,
			'21936': 161,
			'21937': 157,
			'21938': 156,
			'21939': 255,
			'21940': 158,
			'21941': 152,
			'21942': 152,
			'21943': 255,
			'21944': 159,
			'21945': 153,
			'21946': 152,
			'21947': 255,
			'21948': 156,
			'21949': 150,
			'21950': 150,
			'21951': 255,
			'21952': 158,
			'21953': 152,
			'21954': 152,
			'21955': 255,
			'21956': 159,
			'21957': 151,
			'21958': 152,
			'21959': 255,
			'21960': 144,
			'21961': 135,
			'21962': 136,
			'21963': 255,
			'21964': 138,
			'21965': 129,
			'21966': 130,
			'21967': 255,
			'21968': 139,
			'21969': 130,
			'21970': 131,
			'21971': 255,
			'21972': 141,
			'21973': 132,
			'21974': 133,
			'21975': 255,
			'21976': 142,
			'21977': 134,
			'21978': 135,
			'21979': 255,
			'21980': 132,
			'21981': 124,
			'21982': 125,
			'21983': 255,
			'21984': 126,
			'21985': 117,
			'21986': 118,
			'21987': 255,
			'21988': 125,
			'21989': 116,
			'21990': 117,
			'21991': 255,
			'21992': 126,
			'21993': 117,
			'21994': 118,
			'21995': 255,
			'21996': 128,
			'21997': 119,
			'21998': 120,
			'21999': 255,
			'22000': 190,
			'22001': 186,
			'22002': 185,
			'22003': 255,
			'22004': 191,
			'22005': 187,
			'22006': 186,
			'22007': 255,
			'22008': 192,
			'22009': 188,
			'22010': 187,
			'22011': 255,
			'22012': 196,
			'22013': 192,
			'22014': 191,
			'22015': 255,
			'22016': 191,
			'22017': 187,
			'22018': 186,
			'22019': 255,
			'22020': 172,
			'22021': 168,
			'22022': 167,
			'22023': 255,
			'22024': 171,
			'22025': 166,
			'22026': 166,
			'22027': 255,
			'22028': 180,
			'22029': 176,
			'22030': 175,
			'22031': 255,
			'22032': 181,
			'22033': 176,
			'22034': 175,
			'22035': 255,
			'22036': 180,
			'22037': 176,
			'22038': 175,
			'22039': 255,
			'22040': 178,
			'22041': 174,
			'22042': 173,
			'22043': 255,
			'22044': 180,
			'22045': 175,
			'22046': 175,
			'22047': 255,
			'22048': 186,
			'22049': 182,
			'22050': 181,
			'22051': 255,
			'22052': 183,
			'22053': 180,
			'22054': 178,
			'22055': 255,
			'22056': 177,
			'22057': 173,
			'22058': 172,
			'22059': 255,
			'22060': 181,
			'22061': 177,
			'22062': 175,
			'22063': 255,
			'22064': 183,
			'22065': 179,
			'22066': 178,
			'22067': 255,
			'22068': 184,
			'22069': 180,
			'22070': 179,
			'22071': 255,
			'22072': 186,
			'22073': 181,
			'22074': 181,
			'22075': 255,
			'22076': 184,
			'22077': 180,
			'22078': 179,
			'22079': 255,
			'22080': 194,
			'22081': 190,
			'22082': 189,
			'22083': 255,
			'22084': 200,
			'22085': 196,
			'22086': 195,
			'22087': 255,
			'22088': 199,
			'22089': 195,
			'22090': 194,
			'22091': 255,
			'22092': 180,
			'22093': 176,
			'22094': 175,
			'22095': 255,
			'22096': 108,
			'22097': 101,
			'22098': 101,
			'22099': 255,
			'22100': 35,
			'22101': 26,
			'22102': 28,
			'22103': 255,
			'22104': 0,
			'22105': 0,
			'22106': 0,
			'22107': 255,
			'22108': 14,
			'22109': 4,
			'22110': 5,
			'22111': 255,
			'22112': 27,
			'22113': 18,
			'22114': 20,
			'22115': 255,
			'22116': 24,
			'22117': 16,
			'22118': 17,
			'22119': 255,
			'22120': 23,
			'22121': 15,
			'22122': 16,
			'22123': 255,
			'22124': 23,
			'22125': 14,
			'22126': 15,
			'22127': 255,
			'22128': 24,
			'22129': 15,
			'22130': 16,
			'22131': 255,
			'22132': 24,
			'22133': 16,
			'22134': 17,
			'22135': 255,
			'22136': 25,
			'22137': 17,
			'22138': 17,
			'22139': 255,
			'22140': 31,
			'22141': 23,
			'22142': 23,
			'22143': 255,
			'22144': 24,
			'22145': 14,
			'22146': 15,
			'22147': 255,
			'22148': 25,
			'22149': 16,
			'22150': 17,
			'22151': 255,
			'22152': 36,
			'22153': 26,
			'22154': 25,
			'22155': 255,
			'22156': 20,
			'22157': 9,
			'22158': 10,
			'22159': 255,
			'22160': 171,
			'22161': 167,
			'22162': 166,
			'22163': 255,
			'22164': 248,
			'22165': 246,
			'22166': 244,
			'22167': 255,
			'22168': 208,
			'22169': 205,
			'22170': 204,
			'22171': 255,
			'22172': 207,
			'22173': 206,
			'22174': 204,
			'22175': 255,
			'22176': 208,
			'22177': 205,
			'22178': 204,
			'22179': 255,
			'22180': 208,
			'22181': 205,
			'22182': 203,
			'22183': 255,
			'22184': 202,
			'22185': 198,
			'22186': 197,
			'22187': 255,
			'22188': 194,
			'22189': 190,
			'22190': 189,
			'22191': 255,
			'22192': 194,
			'22193': 190,
			'22194': 189,
			'22195': 255,
			'22196': 195,
			'22197': 191,
			'22198': 190,
			'22199': 255,
			'22200': 187,
			'22201': 183,
			'22202': 182,
			'22203': 255,
			'22204': 179,
			'22205': 174,
			'22206': 174,
			'22207': 255,
			'22208': 166,
			'22209': 162,
			'22210': 161,
			'22211': 255,
			'22212': 157,
			'22213': 152,
			'22214': 151,
			'22215': 255,
			'22216': 159,
			'22217': 151,
			'22218': 152,
			'22219': 255,
			'22220': 160,
			'22221': 154,
			'22222': 154,
			'22223': 255,
			'22224': 155,
			'22225': 148,
			'22226': 148,
			'22227': 255,
			'22228': 145,
			'22229': 135,
			'22230': 136,
			'22231': 255,
			'22232': 136,
			'22233': 127,
			'22234': 128,
			'22235': 255,
			'22236': 134,
			'22237': 125,
			'22238': 126,
			'22239': 255,
			'22240': 167,
			'22241': 158,
			'22242': 159,
			'22243': 255,
			'22244': 151,
			'22245': 142,
			'22246': 143,
			'22247': 255,
			'22248': 23,
			'22249': 17,
			'22250': 16,
			'22251': 255,
			'22252': 2,
			'22253': 0,
			'22254': 0,
			'22255': 255,
			'22256': 21,
			'22257': 11,
			'22258': 12,
			'22259': 255,
			'22260': 21,
			'22261': 13,
			'22262': 12,
			'22263': 255,
			'22264': 23,
			'22265': 15,
			'22266': 13,
			'22267': 255,
			'22268': 21,
			'22269': 12,
			'22270': 12,
			'22271': 255,
			'22272': 20,
			'22273': 12,
			'22274': 12,
			'22275': 255,
			'22276': 21,
			'22277': 13,
			'22278': 11,
			'22279': 255,
			'22280': 22,
			'22281': 15,
			'22282': 14,
			'22283': 255,
			'22284': 22,
			'22285': 13,
			'22286': 14,
			'22287': 255,
			'22288': 0,
			'22289': 0,
			'22290': 0,
			'22291': 255,
			'22292': 16,
			'22293': 8,
			'22294': 8,
			'22295': 255,
			'22296': 100,
			'22297': 92,
			'22298': 93,
			'22299': 255,
			'22300': 165,
			'22301': 159,
			'22302': 159,
			'22303': 255,
			'22304': 190,
			'22305': 186,
			'22306': 185,
			'22307': 255,
			'22308': 173,
			'22309': 170,
			'22310': 168,
			'22311': 255,
			'22312': 162,
			'22313': 157,
			'22314': 156,
			'22315': 255,
			'22316': 160,
			'22317': 156,
			'22318': 156,
			'22319': 255,
			'22320': 159,
			'22321': 155,
			'22322': 154,
			'22323': 255,
			'22324': 157,
			'22325': 153,
			'22326': 153,
			'22327': 255,
			'22328': 158,
			'22329': 153,
			'22330': 153,
			'22331': 255,
			'22332': 158,
			'22333': 154,
			'22334': 153,
			'22335': 255,
			'22336': 156,
			'22337': 151,
			'22338': 151,
			'22339': 255,
			'22340': 154,
			'22341': 146,
			'22342': 147,
			'22343': 255,
			'22344': 153,
			'22345': 145,
			'22346': 146,
			'22347': 255,
			'22348': 154,
			'22349': 148,
			'22350': 148,
			'22351': 255,
			'22352': 154,
			'22353': 146,
			'22354': 146,
			'22355': 255,
			'22356': 152,
			'22357': 143,
			'22358': 144,
			'22359': 255,
			'22360': 140,
			'22361': 131,
			'22362': 132,
			'22363': 255,
			'22364': 136,
			'22365': 127,
			'22366': 128,
			'22367': 255,
			'22368': 136,
			'22369': 127,
			'22370': 128,
			'22371': 255,
			'22372': 133,
			'22373': 124,
			'22374': 125,
			'22375': 255,
			'22376': 134,
			'22377': 125,
			'22378': 126,
			'22379': 255,
			'22380': 133,
			'22381': 124,
			'22382': 125,
			'22383': 255,
			'22384': 130,
			'22385': 121,
			'22386': 122,
			'22387': 255,
			'22388': 123,
			'22389': 113,
			'22390': 114,
			'22391': 255,
			'22392': 122,
			'22393': 113,
			'22394': 113,
			'22395': 255,
			'22396': 124,
			'22397': 115,
			'22398': 116,
			'22399': 255,
			'22400': 176,
			'22401': 172,
			'22402': 171,
			'22403': 255,
			'22404': 185,
			'22405': 181,
			'22406': 180,
			'22407': 255,
			'22408': 186,
			'22409': 182,
			'22410': 181,
			'22411': 255,
			'22412': 187,
			'22413': 183,
			'22414': 182,
			'22415': 255,
			'22416': 180,
			'22417': 176,
			'22418': 175,
			'22419': 255,
			'22420': 175,
			'22421': 171,
			'22422': 170,
			'22423': 255,
			'22424': 166,
			'22425': 162,
			'22426': 161,
			'22427': 255,
			'22428': 169,
			'22429': 165,
			'22430': 164,
			'22431': 255,
			'22432': 173,
			'22433': 168,
			'22434': 167,
			'22435': 255,
			'22436': 167,
			'22437': 164,
			'22438': 163,
			'22439': 255,
			'22440': 160,
			'22441': 154,
			'22442': 154,
			'22443': 255,
			'22444': 153,
			'22445': 147,
			'22446': 147,
			'22447': 255,
			'22448': 159,
			'22449': 154,
			'22450': 153,
			'22451': 255,
			'22452': 179,
			'22453': 175,
			'22454': 174,
			'22455': 255,
			'22456': 161,
			'22457': 156,
			'22458': 155,
			'22459': 255,
			'22460': 157,
			'22461': 152,
			'22462': 151,
			'22463': 255,
			'22464': 177,
			'22465': 173,
			'22466': 172,
			'22467': 255,
			'22468': 164,
			'22469': 160,
			'22470': 159,
			'22471': 255,
			'22472': 175,
			'22473': 171,
			'22474': 170,
			'22475': 255,
			'22476': 201,
			'22477': 199,
			'22478': 198,
			'22479': 255,
			'22480': 184,
			'22481': 180,
			'22482': 179,
			'22483': 255,
			'22484': 128,
			'22485': 121,
			'22486': 122,
			'22487': 255,
			'22488': 83,
			'22489': 73,
			'22490': 72,
			'22491': 255,
			'22492': 36,
			'22493': 27,
			'22494': 25,
			'22495': 255,
			'22496': 3,
			'22497': 0,
			'22498': 0,
			'22499': 255,
			'22500': 15,
			'22501': 5,
			'22502': 6,
			'22503': 255,
			'22504': 24,
			'22505': 15,
			'22506': 15,
			'22507': 255,
			'22508': 23,
			'22509': 15,
			'22510': 16,
			'22511': 255,
			'22512': 23,
			'22513': 14,
			'22514': 13,
			'22515': 255,
			'22516': 21,
			'22517': 13,
			'22518': 12,
			'22519': 255,
			'22520': 23,
			'22521': 14,
			'22522': 16,
			'22523': 255,
			'22524': 23,
			'22525': 14,
			'22526': 15,
			'22527': 255,
			'22528': 20,
			'22529': 11,
			'22530': 12,
			'22531': 255,
			'22532': 22,
			'22533': 14,
			'22534': 14,
			'22535': 255,
			'22536': 21,
			'22537': 15,
			'22538': 15,
			'22539': 255,
			'22540': 25,
			'22541': 17,
			'22542': 17,
			'22543': 255,
			'22544': 28,
			'22545': 20,
			'22546': 20,
			'22547': 255,
			'22548': 20,
			'22549': 11,
			'22550': 13,
			'22551': 255,
			'22552': 34,
			'22553': 25,
			'22554': 26,
			'22555': 255,
			'22556': 20,
			'22557': 10,
			'22558': 11,
			'22559': 255,
			'22560': 33,
			'22561': 24,
			'22562': 24,
			'22563': 255,
			'22564': 194,
			'22565': 190,
			'22566': 189,
			'22567': 255,
			'22568': 245,
			'22569': 243,
			'22570': 242,
			'22571': 255,
			'22572': 212,
			'22573': 209,
			'22574': 207,
			'22575': 255,
			'22576': 204,
			'22577': 200,
			'22578': 199,
			'22579': 255,
			'22580': 205,
			'22581': 202,
			'22582': 201,
			'22583': 255,
			'22584': 203,
			'22585': 199,
			'22586': 198,
			'22587': 255,
			'22588': 193,
			'22589': 188,
			'22590': 187,
			'22591': 255,
			'22592': 184,
			'22593': 180,
			'22594': 179,
			'22595': 255,
			'22596': 182,
			'22597': 178,
			'22598': 177,
			'22599': 255,
			'22600': 181,
			'22601': 177,
			'22602': 176,
			'22603': 255,
			'22604': 177,
			'22605': 173,
			'22606': 172,
			'22607': 255,
			'22608': 170,
			'22609': 166,
			'22610': 164,
			'22611': 255,
			'22612': 163,
			'22613': 159,
			'22614': 158,
			'22615': 255,
			'22616': 162,
			'22617': 157,
			'22618': 157,
			'22619': 255,
			'22620': 158,
			'22621': 151,
			'22622': 151,
			'22623': 255,
			'22624': 148,
			'22625': 139,
			'22626': 140,
			'22627': 255,
			'22628': 136,
			'22629': 127,
			'22630': 128,
			'22631': 255,
			'22632': 137,
			'22633': 128,
			'22634': 129,
			'22635': 255,
			'22636': 166,
			'22637': 157,
			'22638': 158,
			'22639': 255,
			'22640': 146,
			'22641': 137,
			'22642': 137,
			'22643': 255,
			'22644': 34,
			'22645': 27,
			'22646': 28,
			'22647': 255,
			'22648': 0,
			'22649': 0,
			'22650': 0,
			'22651': 255,
			'22652': 21,
			'22653': 11,
			'22654': 12,
			'22655': 255,
			'22656': 19,
			'22657': 10,
			'22658': 12,
			'22659': 255,
			'22660': 21,
			'22661': 13,
			'22662': 13,
			'22663': 255,
			'22664': 22,
			'22665': 14,
			'22666': 11,
			'22667': 255,
			'22668': 20,
			'22669': 12,
			'22670': 12,
			'22671': 255,
			'22672': 19,
			'22673': 10,
			'22674': 12,
			'22675': 255,
			'22676': 20,
			'22677': 11,
			'22678': 12,
			'22679': 255,
			'22680': 21,
			'22681': 11,
			'22682': 12,
			'22683': 255,
			'22684': 21,
			'22685': 12,
			'22686': 12,
			'22687': 255,
			'22688': 23,
			'22689': 16,
			'22690': 14,
			'22691': 255,
			'22692': 12,
			'22693': 4,
			'22694': 2,
			'22695': 255,
			'22696': 0,
			'22697': 0,
			'22698': 0,
			'22699': 255,
			'22700': 27,
			'22701': 17,
			'22702': 19,
			'22703': 255,
			'22704': 103,
			'22705': 97,
			'22706': 95,
			'22707': 255,
			'22708': 186,
			'22709': 182,
			'22710': 181,
			'22711': 255,
			'22712': 193,
			'22713': 189,
			'22714': 188,
			'22715': 255,
			'22716': 167,
			'22717': 164,
			'22718': 162,
			'22719': 255,
			'22720': 163,
			'22721': 159,
			'22722': 158,
			'22723': 255,
			'22724': 164,
			'22725': 159,
			'22726': 159,
			'22727': 255,
			'22728': 163,
			'22729': 159,
			'22730': 158,
			'22731': 255,
			'22732': 162,
			'22733': 157,
			'22734': 156,
			'22735': 255,
			'22736': 160,
			'22737': 154,
			'22738': 154,
			'22739': 255,
			'22740': 158,
			'22741': 153,
			'22742': 152,
			'22743': 255,
			'22744': 155,
			'22745': 149,
			'22746': 149,
			'22747': 255,
			'22748': 156,
			'22749': 148,
			'22750': 148,
			'22751': 255,
			'22752': 153,
			'22753': 144,
			'22754': 145,
			'22755': 255,
			'22756': 147,
			'22757': 138,
			'22758': 139,
			'22759': 255,
			'22760': 143,
			'22761': 133,
			'22762': 134,
			'22763': 255,
			'22764': 143,
			'22765': 134,
			'22766': 135,
			'22767': 255,
			'22768': 141,
			'22769': 132,
			'22770': 133,
			'22771': 255,
			'22772': 134,
			'22773': 125,
			'22774': 126,
			'22775': 255,
			'22776': 128,
			'22777': 118,
			'22778': 119,
			'22779': 255,
			'22780': 126,
			'22781': 117,
			'22782': 118,
			'22783': 255,
			'22784': 130,
			'22785': 121,
			'22786': 123,
			'22787': 255,
			'22788': 129,
			'22789': 120,
			'22790': 120,
			'22791': 255,
			'22792': 125,
			'22793': 118,
			'22794': 116,
			'22795': 255,
			'22796': 130,
			'22797': 120,
			'22798': 121,
			'22799': 255,
			'22800': 180,
			'22801': 176,
			'22802': 175,
			'22803': 255,
			'22804': 188,
			'22805': 184,
			'22806': 183,
			'22807': 255,
			'22808': 194,
			'22809': 190,
			'22810': 189,
			'22811': 255,
			'22812': 192,
			'22813': 188,
			'22814': 187,
			'22815': 255,
			'22816': 194,
			'22817': 190,
			'22818': 189,
			'22819': 255,
			'22820': 196,
			'22821': 192,
			'22822': 191,
			'22823': 255,
			'22824': 189,
			'22825': 185,
			'22826': 184,
			'22827': 255,
			'22828': 192,
			'22829': 188,
			'22830': 187,
			'22831': 255,
			'22832': 195,
			'22833': 191,
			'22834': 190,
			'22835': 255,
			'22836': 191,
			'22837': 187,
			'22838': 186,
			'22839': 255,
			'22840': 180,
			'22841': 176,
			'22842': 175,
			'22843': 255,
			'22844': 181,
			'22845': 177,
			'22846': 176,
			'22847': 255,
			'22848': 178,
			'22849': 174,
			'22850': 173,
			'22851': 255,
			'22852': 191,
			'22853': 187,
			'22854': 186,
			'22855': 255,
			'22856': 186,
			'22857': 182,
			'22858': 181,
			'22859': 255,
			'22860': 163,
			'22861': 159,
			'22862': 158,
			'22863': 255,
			'22864': 204,
			'22865': 201,
			'22866': 199,
			'22867': 255,
			'22868': 226,
			'22869': 223,
			'22870': 223,
			'22871': 255,
			'22872': 167,
			'22873': 162,
			'22874': 162,
			'22875': 255,
			'22876': 127,
			'22877': 120,
			'22878': 120,
			'22879': 255,
			'22880': 80,
			'22881': 70,
			'22882': 70,
			'22883': 255,
			'22884': 38,
			'22885': 27,
			'22886': 27,
			'22887': 255,
			'22888': 19,
			'22889': 10,
			'22890': 10,
			'22891': 255,
			'22892': 19,
			'22893': 10,
			'22894': 11,
			'22895': 255,
			'22896': 23,
			'22897': 14,
			'22898': 15,
			'22899': 255,
			'22900': 22,
			'22901': 14,
			'22902': 14,
			'22903': 255,
			'22904': 22,
			'22905': 13,
			'22906': 12,
			'22907': 255,
			'22908': 20,
			'22909': 13,
			'22910': 13,
			'22911': 255,
			'22912': 21,
			'22913': 13,
			'22914': 11,
			'22915': 255,
			'22916': 21,
			'22917': 12,
			'22918': 11,
			'22919': 255,
			'22920': 22,
			'22921': 13,
			'22922': 14,
			'22923': 255,
			'22924': 21,
			'22925': 12,
			'22926': 14,
			'22927': 255,
			'22928': 21,
			'22929': 12,
			'22930': 12,
			'22931': 255,
			'22932': 22,
			'22933': 15,
			'22934': 14,
			'22935': 255,
			'22936': 21,
			'22937': 13,
			'22938': 14,
			'22939': 255,
			'22940': 21,
			'22941': 12,
			'22942': 13,
			'22943': 255,
			'22944': 26,
			'22945': 19,
			'22946': 20,
			'22947': 255,
			'22948': 25,
			'22949': 16,
			'22950': 17,
			'22951': 255,
			'22952': 19,
			'22953': 10,
			'22954': 11,
			'22955': 255,
			'22956': 37,
			'22957': 28,
			'22958': 29,
			'22959': 255,
			'22960': 17,
			'22961': 7,
			'22962': 9,
			'22963': 255,
			'22964': 33,
			'22965': 24,
			'22966': 24,
			'22967': 255,
			'22968': 155,
			'22969': 150,
			'22970': 148,
			'22971': 255,
			'22972': 221,
			'22973': 217,
			'22974': 216,
			'22975': 255,
			'22976': 226,
			'22977': 223,
			'22978': 222,
			'22979': 255,
			'22980': 210,
			'22981': 208,
			'22982': 206,
			'22983': 255,
			'22984': 200,
			'22985': 197,
			'22986': 196,
			'22987': 255,
			'22988': 191,
			'22989': 186,
			'22990': 185,
			'22991': 255,
			'22992': 174,
			'22993': 170,
			'22994': 168,
			'22995': 255,
			'22996': 173,
			'22997': 169,
			'22998': 167,
			'22999': 255,
			'23000': 175,
			'23001': 171,
			'23002': 171,
			'23003': 255,
			'23004': 174,
			'23005': 170,
			'23006': 169,
			'23007': 255,
			'23008': 173,
			'23009': 169,
			'23010': 167,
			'23011': 255,
			'23012': 170,
			'23013': 166,
			'23014': 165,
			'23015': 255,
			'23016': 165,
			'23017': 161,
			'23018': 161,
			'23019': 255,
			'23020': 154,
			'23021': 146,
			'23022': 146,
			'23023': 255,
			'23024': 142,
			'23025': 132,
			'23026': 134,
			'23027': 255,
			'23028': 152,
			'23029': 143,
			'23030': 144,
			'23031': 255,
			'23032': 158,
			'23033': 149,
			'23034': 150,
			'23035': 255,
			'23036': 109,
			'23037': 100,
			'23038': 101,
			'23039': 255,
			'23040': 19,
			'23041': 13,
			'23042': 13,
			'23043': 255,
			'23044': 0,
			'23045': 0,
			'23046': 0,
			'23047': 255,
			'23048': 19,
			'23049': 9,
			'23050': 11,
			'23051': 255,
			'23052': 19,
			'23053': 10,
			'23054': 11,
			'23055': 255,
			'23056': 21,
			'23057': 12,
			'23058': 13,
			'23059': 255,
			'23060': 20,
			'23061': 11,
			'23062': 12,
			'23063': 255,
			'23064': 21,
			'23065': 11,
			'23066': 13,
			'23067': 255,
			'23068': 20,
			'23069': 11,
			'23070': 12,
			'23071': 255,
			'23072': 19,
			'23073': 10,
			'23074': 11,
			'23075': 255,
			'23076': 19,
			'23077': 10,
			'23078': 11,
			'23079': 255,
			'23080': 19,
			'23081': 10,
			'23082': 11,
			'23083': 255,
			'23084': 20,
			'23085': 11,
			'23086': 12,
			'23087': 255,
			'23088': 20,
			'23089': 11,
			'23090': 12,
			'23091': 255,
			'23092': 20,
			'23093': 11,
			'23094': 12,
			'23095': 255,
			'23096': 20,
			'23097': 11,
			'23098': 12,
			'23099': 255,
			'23100': 8,
			'23101': 0,
			'23102': 0,
			'23103': 255,
			'23104': 0,
			'23105': 0,
			'23106': 0,
			'23107': 255,
			'23108': 50,
			'23109': 42,
			'23110': 43,
			'23111': 255,
			'23112': 142,
			'23113': 135,
			'23114': 135,
			'23115': 255,
			'23116': 195,
			'23117': 191,
			'23118': 189,
			'23119': 255,
			'23120': 184,
			'23121': 181,
			'23122': 180,
			'23123': 255,
			'23124': 170,
			'23125': 166,
			'23126': 165,
			'23127': 255,
			'23128': 163,
			'23129': 159,
			'23130': 158,
			'23131': 255,
			'23132': 159,
			'23133': 153,
			'23134': 153,
			'23135': 255,
			'23136': 158,
			'23137': 153,
			'23138': 153,
			'23139': 255,
			'23140': 156,
			'23141': 151,
			'23142': 151,
			'23143': 255,
			'23144': 156,
			'23145': 148,
			'23146': 148,
			'23147': 255,
			'23148': 155,
			'23149': 147,
			'23150': 148,
			'23151': 255,
			'23152': 153,
			'23153': 146,
			'23154': 146,
			'23155': 255,
			'23156': 154,
			'23157': 146,
			'23158': 146,
			'23159': 255,
			'23160': 153,
			'23161': 143,
			'23162': 144,
			'23163': 255,
			'23164': 148,
			'23165': 139,
			'23166': 140,
			'23167': 255,
			'23168': 147,
			'23169': 138,
			'23170': 139,
			'23171': 255,
			'23172': 142,
			'23173': 133,
			'23174': 134,
			'23175': 255,
			'23176': 128,
			'23177': 119,
			'23178': 120,
			'23179': 255,
			'23180': 128,
			'23181': 119,
			'23182': 120,
			'23183': 255,
			'23184': 125,
			'23185': 116,
			'23186': 117,
			'23187': 255,
			'23188': 132,
			'23189': 123,
			'23190': 124,
			'23191': 255,
			'23192': 139,
			'23193': 130,
			'23194': 131,
			'23195': 255,
			'23196': 137,
			'23197': 129,
			'23198': 130,
			'23199': 255,
			'23200': 175,
			'23201': 171,
			'23202': 171,
			'23203': 255,
			'23204': 190,
			'23205': 186,
			'23206': 185,
			'23207': 255,
			'23208': 187,
			'23209': 183,
			'23210': 182,
			'23211': 255,
			'23212': 186,
			'23213': 182,
			'23214': 181,
			'23215': 255,
			'23216': 194,
			'23217': 190,
			'23218': 189,
			'23219': 255,
			'23220': 189,
			'23221': 185,
			'23222': 184,
			'23223': 255,
			'23224': 183,
			'23225': 179,
			'23226': 178,
			'23227': 255,
			'23228': 187,
			'23229': 183,
			'23230': 182,
			'23231': 255,
			'23232': 187,
			'23233': 183,
			'23234': 182,
			'23235': 255,
			'23236': 187,
			'23237': 183,
			'23238': 182,
			'23239': 255,
			'23240': 184,
			'23241': 180,
			'23242': 179,
			'23243': 255,
			'23244': 188,
			'23245': 184,
			'23246': 183,
			'23247': 255,
			'23248': 190,
			'23249': 186,
			'23250': 185,
			'23251': 255,
			'23252': 183,
			'23253': 179,
			'23254': 178,
			'23255': 255,
			'23256': 182,
			'23257': 178,
			'23258': 177,
			'23259': 255,
			'23260': 192,
			'23261': 189,
			'23262': 188,
			'23263': 255,
			'23264': 198,
			'23265': 195,
			'23266': 194,
			'23267': 255,
			'23268': 125,
			'23269': 118,
			'23270': 118,
			'23271': 255,
			'23272': 46,
			'23273': 36,
			'23274': 36,
			'23275': 255,
			'23276': 18,
			'23277': 7,
			'23278': 7,
			'23279': 255,
			'23280': 21,
			'23281': 12,
			'23282': 10,
			'23283': 255,
			'23284': 25,
			'23285': 17,
			'23286': 17,
			'23287': 255,
			'23288': 24,
			'23289': 15,
			'23290': 17,
			'23291': 255,
			'23292': 23,
			'23293': 15,
			'23294': 16,
			'23295': 255,
			'23296': 21,
			'23297': 15,
			'23298': 15,
			'23299': 255,
			'23300': 22,
			'23301': 17,
			'23302': 17,
			'23303': 255,
			'23304': 22,
			'23305': 14,
			'23306': 14,
			'23307': 255,
			'23308': 22,
			'23309': 13,
			'23310': 12,
			'23311': 255,
			'23312': 21,
			'23313': 11,
			'23314': 13,
			'23315': 255,
			'23316': 20,
			'23317': 12,
			'23318': 12,
			'23319': 255,
			'23320': 20,
			'23321': 11,
			'23322': 11,
			'23323': 255,
			'23324': 19,
			'23325': 10,
			'23326': 12,
			'23327': 255,
			'23328': 22,
			'23329': 13,
			'23330': 13,
			'23331': 255,
			'23332': 23,
			'23333': 14,
			'23334': 12,
			'23335': 255,
			'23336': 21,
			'23337': 12,
			'23338': 13,
			'23339': 255,
			'23340': 19,
			'23341': 9,
			'23342': 11,
			'23343': 255,
			'23344': 22,
			'23345': 13,
			'23346': 14,
			'23347': 255,
			'23348': 26,
			'23349': 18,
			'23350': 19,
			'23351': 255,
			'23352': 20,
			'23353': 12,
			'23354': 13,
			'23355': 255,
			'23356': 21,
			'23357': 11,
			'23358': 13,
			'23359': 255,
			'23360': 36,
			'23361': 27,
			'23362': 28,
			'23363': 255,
			'23364': 16,
			'23365': 7,
			'23366': 7,
			'23367': 255,
			'23368': 12,
			'23369': 2,
			'23370': 3,
			'23371': 255,
			'23372': 77,
			'23373': 69,
			'23374': 69,
			'23375': 255,
			'23376': 154,
			'23377': 148,
			'23378': 147,
			'23379': 255,
			'23380': 218,
			'23381': 214,
			'23382': 213,
			'23383': 255,
			'23384': 230,
			'23385': 227,
			'23386': 225,
			'23387': 255,
			'23388': 199,
			'23389': 196,
			'23390': 195,
			'23391': 255,
			'23392': 171,
			'23393': 167,
			'23394': 165,
			'23395': 255,
			'23396': 169,
			'23397': 166,
			'23398': 164,
			'23399': 255,
			'23400': 174,
			'23401': 171,
			'23402': 169,
			'23403': 255,
			'23404': 175,
			'23405': 171,
			'23406': 168,
			'23407': 255,
			'23408': 176,
			'23409': 173,
			'23410': 170,
			'23411': 255,
			'23412': 175,
			'23413': 173,
			'23414': 171,
			'23415': 255,
			'23416': 174,
			'23417': 169,
			'23418': 169,
			'23419': 255,
			'23420': 168,
			'23421': 159,
			'23422': 160,
			'23423': 255,
			'23424': 154,
			'23425': 144,
			'23426': 145,
			'23427': 255,
			'23428': 120,
			'23429': 112,
			'23430': 113,
			'23431': 255,
			'23432': 58,
			'23433': 49,
			'23434': 50,
			'23435': 255,
			'23436': 0,
			'23437': 0,
			'23438': 0,
			'23439': 255,
			'23440': 3,
			'23441': 0,
			'23442': 0,
			'23443': 255,
			'23444': 20,
			'23445': 10,
			'23446': 11,
			'23447': 255,
			'23448': 18,
			'23449': 9,
			'23450': 10,
			'23451': 255,
			'23452': 19,
			'23453': 10,
			'23454': 11,
			'23455': 255,
			'23456': 21,
			'23457': 12,
			'23458': 13,
			'23459': 255,
			'23460': 20,
			'23461': 11,
			'23462': 12,
			'23463': 255,
			'23464': 20,
			'23465': 11,
			'23466': 12,
			'23467': 255,
			'23468': 20,
			'23469': 11,
			'23470': 12,
			'23471': 255,
			'23472': 19,
			'23473': 10,
			'23474': 11,
			'23475': 255,
			'23476': 19,
			'23477': 10,
			'23478': 11,
			'23479': 255,
			'23480': 19,
			'23481': 10,
			'23482': 11,
			'23483': 255,
			'23484': 19,
			'23485': 10,
			'23486': 11,
			'23487': 255,
			'23488': 19,
			'23489': 10,
			'23490': 11,
			'23491': 255,
			'23492': 19,
			'23493': 10,
			'23494': 12,
			'23495': 255,
			'23496': 19,
			'23497': 10,
			'23498': 11,
			'23499': 255,
			'23500': 20,
			'23501': 11,
			'23502': 12,
			'23503': 255,
			'23504': 18,
			'23505': 10,
			'23506': 11,
			'23507': 255,
			'23508': 0,
			'23509': 0,
			'23510': 0,
			'23511': 255,
			'23512': 8,
			'23513': 0,
			'23514': 0,
			'23515': 255,
			'23516': 76,
			'23517': 67,
			'23518': 68,
			'23519': 255,
			'23520': 146,
			'23521': 140,
			'23522': 141,
			'23523': 255,
			'23524': 184,
			'23525': 177,
			'23526': 177,
			'23527': 255,
			'23528': 171,
			'23529': 164,
			'23530': 164,
			'23531': 255,
			'23532': 153,
			'23533': 145,
			'23534': 146,
			'23535': 255,
			'23536': 152,
			'23537': 144,
			'23538': 145,
			'23539': 255,
			'23540': 153,
			'23541': 145,
			'23542': 146,
			'23543': 255,
			'23544': 153,
			'23545': 143,
			'23546': 145,
			'23547': 255,
			'23548': 152,
			'23549': 142,
			'23550': 143,
			'23551': 255,
			'23552': 149,
			'23553': 140,
			'23554': 141,
			'23555': 255,
			'23556': 151,
			'23557': 143,
			'23558': 143,
			'23559': 255,
			'23560': 148,
			'23561': 139,
			'23562': 140,
			'23563': 255,
			'23564': 140,
			'23565': 131,
			'23566': 132,
			'23567': 255,
			'23568': 137,
			'23569': 129,
			'23570': 129,
			'23571': 255,
			'23572': 142,
			'23573': 133,
			'23574': 134,
			'23575': 255,
			'23576': 133,
			'23577': 124,
			'23578': 125,
			'23579': 255,
			'23580': 130,
			'23581': 121,
			'23582': 122,
			'23583': 255,
			'23584': 125,
			'23585': 116,
			'23586': 117,
			'23587': 255,
			'23588': 119,
			'23589': 110,
			'23590': 111,
			'23591': 255,
			'23592': 128,
			'23593': 119,
			'23594': 120,
			'23595': 255,
			'23596': 133,
			'23597': 124,
			'23598': 125,
			'23599': 255,
			'23600': 177,
			'23601': 173,
			'23602': 172,
			'23603': 255,
			'23604': 183,
			'23605': 179,
			'23606': 178,
			'23607': 255,
			'23608': 186,
			'23609': 182,
			'23610': 181,
			'23611': 255,
			'23612': 188,
			'23613': 184,
			'23614': 183,
			'23615': 255,
			'23616': 185,
			'23617': 181,
			'23618': 180,
			'23619': 255,
			'23620': 182,
			'23621': 178,
			'23622': 177,
			'23623': 255,
			'23624': 184,
			'23625': 180,
			'23626': 179,
			'23627': 255,
			'23628': 184,
			'23629': 180,
			'23630': 179,
			'23631': 255,
			'23632': 186,
			'23633': 182,
			'23634': 181,
			'23635': 255,
			'23636': 184,
			'23637': 180,
			'23638': 179,
			'23639': 255,
			'23640': 184,
			'23641': 180,
			'23642': 179,
			'23643': 255,
			'23644': 185,
			'23645': 181,
			'23646': 180,
			'23647': 255,
			'23648': 188,
			'23649': 184,
			'23650': 183,
			'23651': 255,
			'23652': 185,
			'23653': 181,
			'23654': 180,
			'23655': 255,
			'23656': 183,
			'23657': 180,
			'23658': 178,
			'23659': 255,
			'23660': 209,
			'23661': 206,
			'23662': 205,
			'23663': 255,
			'23664': 121,
			'23665': 114,
			'23666': 114,
			'23667': 255,
			'23668': 9,
			'23669': 0,
			'23670': 0,
			'23671': 255,
			'23672': 25,
			'23673': 15,
			'23674': 15,
			'23675': 255,
			'23676': 31,
			'23677': 22,
			'23678': 23,
			'23679': 255,
			'23680': 27,
			'23681': 18,
			'23682': 19,
			'23683': 255,
			'23684': 25,
			'23685': 17,
			'23686': 18,
			'23687': 255,
			'23688': 25,
			'23689': 15,
			'23690': 17,
			'23691': 255,
			'23692': 23,
			'23693': 16,
			'23694': 17,
			'23695': 255,
			'23696': 22,
			'23697': 16,
			'23698': 15,
			'23699': 255,
			'23700': 22,
			'23701': 16,
			'23702': 14,
			'23703': 255,
			'23704': 23,
			'23705': 16,
			'23706': 15,
			'23707': 255,
			'23708': 25,
			'23709': 18,
			'23710': 18,
			'23711': 255,
			'23712': 23,
			'23713': 14,
			'23714': 15,
			'23715': 255,
			'23716': 19,
			'23717': 9,
			'23718': 10,
			'23719': 255,
			'23720': 18,
			'23721': 8,
			'23722': 10,
			'23723': 255,
			'23724': 19,
			'23725': 10,
			'23726': 12,
			'23727': 255,
			'23728': 20,
			'23729': 10,
			'23730': 12,
			'23731': 255,
			'23732': 21,
			'23733': 12,
			'23734': 11,
			'23735': 255,
			'23736': 23,
			'23737': 15,
			'23738': 14,
			'23739': 255,
			'23740': 20,
			'23741': 10,
			'23742': 12,
			'23743': 255,
			'23744': 19,
			'23745': 10,
			'23746': 11,
			'23747': 255,
			'23748': 25,
			'23749': 16,
			'23750': 17,
			'23751': 255,
			'23752': 27,
			'23753': 18,
			'23754': 19,
			'23755': 255,
			'23756': 20,
			'23757': 11,
			'23758': 12,
			'23759': 255,
			'23760': 22,
			'23761': 13,
			'23762': 14,
			'23763': 255,
			'23764': 30,
			'23765': 21,
			'23766': 22,
			'23767': 255,
			'23768': 30,
			'23769': 21,
			'23770': 23,
			'23771': 255,
			'23772': 11,
			'23773': 2,
			'23774': 2,
			'23775': 255,
			'23776': 15,
			'23777': 5,
			'23778': 6,
			'23779': 255,
			'23780': 75,
			'23781': 66,
			'23782': 68,
			'23783': 255,
			'23784': 153,
			'23785': 146,
			'23786': 147,
			'23787': 255,
			'23788': 197,
			'23789': 193,
			'23790': 192,
			'23791': 255,
			'23792': 189,
			'23793': 185,
			'23794': 184,
			'23795': 255,
			'23796': 178,
			'23797': 173,
			'23798': 173,
			'23799': 255,
			'23800': 180,
			'23801': 174,
			'23802': 173,
			'23803': 255,
			'23804': 177,
			'23805': 171,
			'23806': 170,
			'23807': 255,
			'23808': 174,
			'23809': 168,
			'23810': 168,
			'23811': 255,
			'23812': 170,
			'23813': 165,
			'23814': 165,
			'23815': 255,
			'23816': 146,
			'23817': 139,
			'23818': 139,
			'23819': 255,
			'23820': 104,
			'23821': 95,
			'23822': 96,
			'23823': 255,
			'23824': 57,
			'23825': 49,
			'23826': 50,
			'23827': 255,
			'23828': 11,
			'23829': 3,
			'23830': 4,
			'23831': 255,
			'23832': 0,
			'23833': 0,
			'23834': 0,
			'23835': 255,
			'23836': 14,
			'23837': 5,
			'23838': 6,
			'23839': 255,
			'23840': 19,
			'23841': 10,
			'23842': 11,
			'23843': 255,
			'23844': 20,
			'23845': 11,
			'23846': 12,
			'23847': 255,
			'23848': 20,
			'23849': 11,
			'23850': 12,
			'23851': 255,
			'23852': 19,
			'23853': 10,
			'23854': 11,
			'23855': 255,
			'23856': 20,
			'23857': 11,
			'23858': 12,
			'23859': 255,
			'23860': 20,
			'23861': 11,
			'23862': 12,
			'23863': 255,
			'23864': 19,
			'23865': 10,
			'23866': 11,
			'23867': 255,
			'23868': 18,
			'23869': 9,
			'23870': 10,
			'23871': 255,
			'23872': 18,
			'23873': 9,
			'23874': 10,
			'23875': 255,
			'23876': 19,
			'23877': 10,
			'23878': 11,
			'23879': 255,
			'23880': 19,
			'23881': 10,
			'23882': 11,
			'23883': 255,
			'23884': 19,
			'23885': 10,
			'23886': 11,
			'23887': 255,
			'23888': 20,
			'23889': 11,
			'23890': 12,
			'23891': 255,
			'23892': 20,
			'23893': 11,
			'23894': 12,
			'23895': 255,
			'23896': 18,
			'23897': 9,
			'23898': 10,
			'23899': 255,
			'23900': 19,
			'23901': 10,
			'23902': 11,
			'23903': 255,
			'23904': 19,
			'23905': 10,
			'23906': 11,
			'23907': 255,
			'23908': 21,
			'23909': 12,
			'23910': 12,
			'23911': 255,
			'23912': 13,
			'23913': 4,
			'23914': 5,
			'23915': 255,
			'23916': 0,
			'23917': 0,
			'23918': 0,
			'23919': 255,
			'23920': 17,
			'23921': 7,
			'23922': 8,
			'23923': 255,
			'23924': 78,
			'23925': 68,
			'23926': 69,
			'23927': 255,
			'23928': 149,
			'23929': 141,
			'23930': 141,
			'23931': 255,
			'23932': 178,
			'23933': 169,
			'23934': 170,
			'23935': 255,
			'23936': 161,
			'23937': 151,
			'23938': 153,
			'23939': 255,
			'23940': 152,
			'23941': 143,
			'23942': 144,
			'23943': 255,
			'23944': 151,
			'23945': 142,
			'23946': 143,
			'23947': 255,
			'23948': 148,
			'23949': 139,
			'23950': 140,
			'23951': 255,
			'23952': 146,
			'23953': 138,
			'23954': 138,
			'23955': 255,
			'23956': 144,
			'23957': 135,
			'23958': 135,
			'23959': 255,
			'23960': 142,
			'23961': 133,
			'23962': 134,
			'23963': 255,
			'23964': 138,
			'23965': 130,
			'23966': 130,
			'23967': 255,
			'23968': 135,
			'23969': 126,
			'23970': 127,
			'23971': 255,
			'23972': 136,
			'23973': 127,
			'23974': 128,
			'23975': 255,
			'23976': 131,
			'23977': 122,
			'23978': 123,
			'23979': 255,
			'23980': 130,
			'23981': 121,
			'23982': 122,
			'23983': 255,
			'23984': 126,
			'23985': 117,
			'23986': 118,
			'23987': 255,
			'23988': 119,
			'23989': 109,
			'23990': 110,
			'23991': 255,
			'23992': 118,
			'23993': 109,
			'23994': 110,
			'23995': 255,
			'23996': 125,
			'23997': 115,
			'23998': 116,
			'23999': 255,
			'24000': 184,
			'24001': 180,
			'24002': 179,
			'24003': 255,
			'24004': 181,
			'24005': 177,
			'24006': 176,
			'24007': 255,
			'24008': 184,
			'24009': 180,
			'24010': 179,
			'24011': 255,
			'24012': 192,
			'24013': 188,
			'24014': 187,
			'24015': 255,
			'24016': 180,
			'24017': 176,
			'24018': 175,
			'24019': 255,
			'24020': 179,
			'24021': 175,
			'24022': 174,
			'24023': 255,
			'24024': 182,
			'24025': 178,
			'24026': 177,
			'24027': 255,
			'24028': 180,
			'24029': 176,
			'24030': 175,
			'24031': 255,
			'24032': 183,
			'24033': 179,
			'24034': 178,
			'24035': 255,
			'24036': 185,
			'24037': 181,
			'24038': 180,
			'24039': 255,
			'24040': 182,
			'24041': 178,
			'24042': 177,
			'24043': 255,
			'24044': 176,
			'24045': 172,
			'24046': 171,
			'24047': 255,
			'24048': 177,
			'24049': 173,
			'24050': 172,
			'24051': 255,
			'24052': 186,
			'24053': 182,
			'24054': 181,
			'24055': 255,
			'24056': 205,
			'24057': 202,
			'24058': 201,
			'24059': 255,
			'24060': 130,
			'24061': 124,
			'24062': 123,
			'24063': 255,
			'24064': 41,
			'24065': 30,
			'24066': 29,
			'24067': 255,
			'24068': 30,
			'24069': 21,
			'24070': 20,
			'24071': 255,
			'24072': 26,
			'24073': 18,
			'24074': 19,
			'24075': 255,
			'24076': 25,
			'24077': 17,
			'24078': 18,
			'24079': 255,
			'24080': 25,
			'24081': 16,
			'24082': 17,
			'24083': 255,
			'24084': 23,
			'24085': 16,
			'24086': 16,
			'24087': 255,
			'24088': 24,
			'24089': 16,
			'24090': 16,
			'24091': 255,
			'24092': 25,
			'24093': 19,
			'24094': 19,
			'24095': 255,
			'24096': 26,
			'24097': 18,
			'24098': 18,
			'24099': 255,
			'24100': 22,
			'24101': 13,
			'24102': 13,
			'24103': 255,
			'24104': 22,
			'24105': 14,
			'24106': 15,
			'24107': 255,
			'24108': 24,
			'24109': 17,
			'24110': 18,
			'24111': 255,
			'24112': 22,
			'24113': 13,
			'24114': 12,
			'24115': 255,
			'24116': 18,
			'24117': 9,
			'24118': 10,
			'24119': 255,
			'24120': 18,
			'24121': 9,
			'24122': 10,
			'24123': 255,
			'24124': 20,
			'24125': 11,
			'24126': 11,
			'24127': 255,
			'24128': 20,
			'24129': 11,
			'24130': 12,
			'24131': 255,
			'24132': 20,
			'24133': 11,
			'24134': 12,
			'24135': 255,
			'24136': 22,
			'24137': 13,
			'24138': 14,
			'24139': 255,
			'24140': 20,
			'24141': 12,
			'24142': 12,
			'24143': 255,
			'24144': 19,
			'24145': 10,
			'24146': 11,
			'24147': 255,
			'24148': 22,
			'24149': 13,
			'24150': 14,
			'24151': 255,
			'24152': 25,
			'24153': 16,
			'24154': 15,
			'24155': 255,
			'24156': 23,
			'24157': 18,
			'24158': 14,
			'24159': 255,
			'24160': 22,
			'24161': 14,
			'24162': 15,
			'24163': 255,
			'24164': 21,
			'24165': 12,
			'24166': 13,
			'24167': 255,
			'24168': 27,
			'24169': 18,
			'24170': 19,
			'24171': 255,
			'24172': 33,
			'24173': 24,
			'24174': 24,
			'24175': 255,
			'24176': 24,
			'24177': 15,
			'24178': 16,
			'24179': 255,
			'24180': 5,
			'24181': 0,
			'24182': 0,
			'24183': 255,
			'24184': 12,
			'24185': 3,
			'24186': 4,
			'24187': 255,
			'24188': 54,
			'24189': 44,
			'24190': 46,
			'24191': 255,
			'24192': 73,
			'24193': 65,
			'24194': 66,
			'24195': 255,
			'24196': 72,
			'24197': 64,
			'24198': 64,
			'24199': 255,
			'24200': 70,
			'24201': 61,
			'24202': 62,
			'24203': 255,
			'24204': 67,
			'24205': 57,
			'24206': 59,
			'24207': 255,
			'24208': 62,
			'24209': 52,
			'24210': 53,
			'24211': 255,
			'24212': 50,
			'24213': 41,
			'24214': 42,
			'24215': 255,
			'24216': 25,
			'24217': 17,
			'24218': 16,
			'24219': 255,
			'24220': 3,
			'24221': 0,
			'24222': 0,
			'24223': 255,
			'24224': 0,
			'24225': 0,
			'24226': 0,
			'24227': 255,
			'24228': 14,
			'24229': 5,
			'24230': 6,
			'24231': 255,
			'24232': 19,
			'24233': 10,
			'24234': 11,
			'24235': 255,
			'24236': 18,
			'24237': 9,
			'24238': 10,
			'24239': 255,
			'24240': 19,
			'24241': 10,
			'24242': 11,
			'24243': 255,
			'24244': 20,
			'24245': 11,
			'24246': 12,
			'24247': 255,
			'24248': 19,
			'24249': 10,
			'24250': 11,
			'24251': 255,
			'24252': 19,
			'24253': 10,
			'24254': 11,
			'24255': 255,
			'24256': 20,
			'24257': 11,
			'24258': 12,
			'24259': 255,
			'24260': 19,
			'24261': 10,
			'24262': 11,
			'24263': 255,
			'24264': 19,
			'24265': 10,
			'24266': 11,
			'24267': 255,
			'24268': 18,
			'24269': 9,
			'24270': 10,
			'24271': 255,
			'24272': 18,
			'24273': 9,
			'24274': 10,
			'24275': 255,
			'24276': 19,
			'24277': 10,
			'24278': 11,
			'24279': 255,
			'24280': 19,
			'24281': 10,
			'24282': 11,
			'24283': 255,
			'24284': 19,
			'24285': 10,
			'24286': 11,
			'24287': 255,
			'24288': 19,
			'24289': 10,
			'24290': 11,
			'24291': 255,
			'24292': 19,
			'24293': 10,
			'24294': 11,
			'24295': 255,
			'24296': 18,
			'24297': 9,
			'24298': 10,
			'24299': 255,
			'24300': 18,
			'24301': 9,
			'24302': 10,
			'24303': 255,
			'24304': 18,
			'24305': 9,
			'24306': 10,
			'24307': 255,
			'24308': 19,
			'24309': 10,
			'24310': 11,
			'24311': 255,
			'24312': 19,
			'24313': 10,
			'24314': 11,
			'24315': 255,
			'24316': 20,
			'24317': 11,
			'24318': 11,
			'24319': 255,
			'24320': 12,
			'24321': 3,
			'24322': 3,
			'24323': 255,
			'24324': 0,
			'24325': 0,
			'24326': 0,
			'24327': 255,
			'24328': 22,
			'24329': 12,
			'24330': 14,
			'24331': 255,
			'24332': 94,
			'24333': 85,
			'24334': 86,
			'24335': 255,
			'24336': 159,
			'24337': 150,
			'24338': 150,
			'24339': 255,
			'24340': 155,
			'24341': 147,
			'24342': 148,
			'24343': 255,
			'24344': 140,
			'24345': 130,
			'24346': 131,
			'24347': 255,
			'24348': 144,
			'24349': 134,
			'24350': 135,
			'24351': 255,
			'24352': 141,
			'24353': 133,
			'24354': 133,
			'24355': 255,
			'24356': 140,
			'24357': 131,
			'24358': 131,
			'24359': 255,
			'24360': 138,
			'24361': 130,
			'24362': 130,
			'24363': 255,
			'24364': 137,
			'24365': 129,
			'24366': 129,
			'24367': 255,
			'24368': 137,
			'24369': 127,
			'24370': 128,
			'24371': 255,
			'24372': 134,
			'24373': 125,
			'24374': 126,
			'24375': 255,
			'24376': 131,
			'24377': 121,
			'24378': 122,
			'24379': 255,
			'24380': 130,
			'24381': 121,
			'24382': 122,
			'24383': 255,
			'24384': 123,
			'24385': 114,
			'24386': 115,
			'24387': 255,
			'24388': 124,
			'24389': 114,
			'24390': 115,
			'24391': 255,
			'24392': 127,
			'24393': 118,
			'24394': 119,
			'24395': 255,
			'24396': 130,
			'24397': 121,
			'24398': 122,
			'24399': 255,
			'24400': 174,
			'24401': 171,
			'24402': 170,
			'24403': 255,
			'24404': 185,
			'24405': 181,
			'24406': 180,
			'24407': 255,
			'24408': 184,
			'24409': 180,
			'24410': 179,
			'24411': 255,
			'24412': 183,
			'24413': 179,
			'24414': 178,
			'24415': 255,
			'24416': 181,
			'24417': 177,
			'24418': 176,
			'24419': 255,
			'24420': 179,
			'24421': 176,
			'24422': 175,
			'24423': 255,
			'24424': 181,
			'24425': 176,
			'24426': 175,
			'24427': 255,
			'24428': 179,
			'24429': 175,
			'24430': 174,
			'24431': 255,
			'24432': 179,
			'24433': 175,
			'24434': 174,
			'24435': 255,
			'24436': 180,
			'24437': 176,
			'24438': 175,
			'24439': 255,
			'24440': 174,
			'24441': 170,
			'24442': 169,
			'24443': 255,
			'24444': 169,
			'24445': 165,
			'24446': 164,
			'24447': 255,
			'24448': 172,
			'24449': 168,
			'24450': 167,
			'24451': 255,
			'24452': 198,
			'24453': 196,
			'24454': 194,
			'24455': 255,
			'24456': 148,
			'24457': 143,
			'24458': 142,
			'24459': 255,
			'24460': 52,
			'24461': 41,
			'24462': 40,
			'24463': 255,
			'24464': 50,
			'24465': 40,
			'24466': 38,
			'24467': 255,
			'24468': 36,
			'24469': 27,
			'24470': 27,
			'24471': 255,
			'24472': 21,
			'24473': 12,
			'24474': 14,
			'24475': 255,
			'24476': 23,
			'24477': 16,
			'24478': 17,
			'24479': 255,
			'24480': 25,
			'24481': 16,
			'24482': 17,
			'24483': 255,
			'24484': 25,
			'24485': 15,
			'24486': 17,
			'24487': 255,
			'24488': 22,
			'24489': 15,
			'24490': 13,
			'24491': 255,
			'24492': 23,
			'24493': 17,
			'24494': 14,
			'24495': 255,
			'24496': 27,
			'24497': 18,
			'24498': 19,
			'24499': 255,
			'24500': 23,
			'24501': 15,
			'24502': 15,
			'24503': 255,
			'24504': 22,
			'24505': 12,
			'24506': 13,
			'24507': 255,
			'24508': 24,
			'24509': 15,
			'24510': 15,
			'24511': 255,
			'24512': 21,
			'24513': 13,
			'24514': 13,
			'24515': 255,
			'24516': 18,
			'24517': 9,
			'24518': 10,
			'24519': 255,
			'24520': 18,
			'24521': 9,
			'24522': 10,
			'24523': 255,
			'24524': 20,
			'24525': 11,
			'24526': 12,
			'24527': 255,
			'24528': 20,
			'24529': 11,
			'24530': 12,
			'24531': 255,
			'24532': 20,
			'24533': 11,
			'24534': 12,
			'24535': 255,
			'24536': 21,
			'24537': 12,
			'24538': 13,
			'24539': 255,
			'24540': 21,
			'24541': 12,
			'24542': 13,
			'24543': 255,
			'24544': 21,
			'24545': 12,
			'24546': 12,
			'24547': 255,
			'24548': 20,
			'24549': 11,
			'24550': 12,
			'24551': 255,
			'24552': 20,
			'24553': 11,
			'24554': 12,
			'24555': 255,
			'24556': 22,
			'24557': 14,
			'24558': 13,
			'24559': 255,
			'24560': 24,
			'24561': 17,
			'24562': 17,
			'24563': 255,
			'24564': 24,
			'24565': 16,
			'24566': 16,
			'24567': 255,
			'24568': 21,
			'24569': 11,
			'24570': 13,
			'24571': 255,
			'24572': 21,
			'24573': 12,
			'24574': 13,
			'24575': 255,
			'24576': 26,
			'24577': 17,
			'24578': 18,
			'24579': 255,
			'24580': 30,
			'24581': 21,
			'24582': 21,
			'24583': 255,
			'24584': 25,
			'24585': 17,
			'24586': 17,
			'24587': 255,
			'24588': 10,
			'24589': 1,
			'24590': 2,
			'24591': 255,
			'24592': 4,
			'24593': 0,
			'24594': 0,
			'24595': 255,
			'24596': 1,
			'24597': 0,
			'24598': 0,
			'24599': 255,
			'24600': 1,
			'24601': 0,
			'24602': 0,
			'24603': 255,
			'24604': 3,
			'24605': 0,
			'24606': 0,
			'24607': 255,
			'24608': 3,
			'24609': 0,
			'24610': 0,
			'24611': 255,
			'24612': 5,
			'24613': 0,
			'24614': 0,
			'24615': 255,
			'24616': 14,
			'24617': 6,
			'24618': 4,
			'24619': 255,
			'24620': 19,
			'24621': 10,
			'24622': 11,
			'24623': 255,
			'24624': 19,
			'24625': 10,
			'24626': 11,
			'24627': 255,
			'24628': 19,
			'24629': 10,
			'24630': 11,
			'24631': 255,
			'24632': 18,
			'24633': 9,
			'24634': 10,
			'24635': 255,
			'24636': 19,
			'24637': 10,
			'24638': 11,
			'24639': 255,
			'24640': 19,
			'24641': 10,
			'24642': 11,
			'24643': 255,
			'24644': 20,
			'24645': 11,
			'24646': 12,
			'24647': 255,
			'24648': 19,
			'24649': 10,
			'24650': 11,
			'24651': 255,
			'24652': 20,
			'24653': 11,
			'24654': 12,
			'24655': 255,
			'24656': 19,
			'24657': 10,
			'24658': 11,
			'24659': 255,
			'24660': 19,
			'24661': 10,
			'24662': 11,
			'24663': 255,
			'24664': 19,
			'24665': 10,
			'24666': 11,
			'24667': 255,
			'24668': 18,
			'24669': 9,
			'24670': 10,
			'24671': 255,
			'24672': 18,
			'24673': 9,
			'24674': 10,
			'24675': 255,
			'24676': 18,
			'24677': 9,
			'24678': 10,
			'24679': 255,
			'24680': 19,
			'24681': 10,
			'24682': 11,
			'24683': 255,
			'24684': 20,
			'24685': 11,
			'24686': 12,
			'24687': 255,
			'24688': 20,
			'24689': 11,
			'24690': 12,
			'24691': 255,
			'24692': 18,
			'24693': 9,
			'24694': 10,
			'24695': 255,
			'24696': 18,
			'24697': 9,
			'24698': 10,
			'24699': 255,
			'24700': 18,
			'24701': 9,
			'24702': 10,
			'24703': 255,
			'24704': 18,
			'24705': 9,
			'24706': 10,
			'24707': 255,
			'24708': 18,
			'24709': 10,
			'24710': 11,
			'24711': 255,
			'24712': 19,
			'24713': 10,
			'24714': 11,
			'24715': 255,
			'24716': 19,
			'24717': 10,
			'24718': 11,
			'24719': 255,
			'24720': 18,
			'24721': 10,
			'24722': 11,
			'24723': 255,
			'24724': 20,
			'24725': 11,
			'24726': 12,
			'24727': 255,
			'24728': 8,
			'24729': 0,
			'24730': 0,
			'24731': 255,
			'24732': 0,
			'24733': 0,
			'24734': 0,
			'24735': 255,
			'24736': 54,
			'24737': 45,
			'24738': 45,
			'24739': 255,
			'24740': 156,
			'24741': 147,
			'24742': 148,
			'24743': 255,
			'24744': 147,
			'24745': 138,
			'24746': 139,
			'24747': 255,
			'24748': 136,
			'24749': 127,
			'24750': 128,
			'24751': 255,
			'24752': 136,
			'24753': 127,
			'24754': 128,
			'24755': 255,
			'24756': 134,
			'24757': 125,
			'24758': 126,
			'24759': 255,
			'24760': 135,
			'24761': 126,
			'24762': 127,
			'24763': 255,
			'24764': 132,
			'24765': 123,
			'24766': 124,
			'24767': 255,
			'24768': 131,
			'24769': 122,
			'24770': 123,
			'24771': 255,
			'24772': 130,
			'24773': 121,
			'24774': 122,
			'24775': 255,
			'24776': 125,
			'24777': 116,
			'24778': 117,
			'24779': 255,
			'24780': 125,
			'24781': 116,
			'24782': 117,
			'24783': 255,
			'24784': 122,
			'24785': 113,
			'24786': 114,
			'24787': 255,
			'24788': 119,
			'24789': 109,
			'24790': 110,
			'24791': 255,
			'24792': 122,
			'24793': 112,
			'24794': 113,
			'24795': 255,
			'24796': 131,
			'24797': 121,
			'24798': 122,
			'24799': 255,
			'24800': 161,
			'24801': 154,
			'24802': 154,
			'24803': 255,
			'24804': 182,
			'24805': 178,
			'24806': 177,
			'24807': 255,
			'24808': 188,
			'24809': 185,
			'24810': 184,
			'24811': 255,
			'24812': 175,
			'24813': 171,
			'24814': 170,
			'24815': 255,
			'24816': 179,
			'24817': 175,
			'24818': 174,
			'24819': 255,
			'24820': 179,
			'24821': 175,
			'24822': 174,
			'24823': 255,
			'24824': 178,
			'24825': 176,
			'24826': 174,
			'24827': 255,
			'24828': 178,
			'24829': 175,
			'24830': 174,
			'24831': 255,
			'24832': 179,
			'24833': 175,
			'24834': 174,
			'24835': 255,
			'24836': 174,
			'24837': 170,
			'24838': 169,
			'24839': 255,
			'24840': 174,
			'24841': 170,
			'24842': 169,
			'24843': 255,
			'24844': 173,
			'24845': 169,
			'24846': 168,
			'24847': 255,
			'24848': 194,
			'24849': 190,
			'24850': 189,
			'24851': 255,
			'24852': 169,
			'24853': 165,
			'24854': 165,
			'24855': 255,
			'24856': 68,
			'24857': 58,
			'24858': 57,
			'24859': 255,
			'24860': 50,
			'24861': 39,
			'24862': 39,
			'24863': 255,
			'24864': 49,
			'24865': 40,
			'24866': 38,
			'24867': 255,
			'24868': 39,
			'24869': 30,
			'24870': 29,
			'24871': 255,
			'24872': 25,
			'24873': 15,
			'24874': 17,
			'24875': 255,
			'24876': 23,
			'24877': 13,
			'24878': 14,
			'24879': 255,
			'24880': 23,
			'24881': 15,
			'24882': 16,
			'24883': 255,
			'24884': 22,
			'24885': 15,
			'24886': 16,
			'24887': 255,
			'24888': 22,
			'24889': 13,
			'24890': 12,
			'24891': 255,
			'24892': 20,
			'24893': 12,
			'24894': 10,
			'24895': 255,
			'24896': 28,
			'24897': 19,
			'24898': 20,
			'24899': 255,
			'24900': 26,
			'24901': 16,
			'24902': 18,
			'24903': 255,
			'24904': 20,
			'24905': 11,
			'24906': 11,
			'24907': 255,
			'24908': 22,
			'24909': 14,
			'24910': 13,
			'24911': 255,
			'24912': 19,
			'24913': 10,
			'24914': 11,
			'24915': 255,
			'24916': 18,
			'24917': 9,
			'24918': 10,
			'24919': 255,
			'24920': 19,
			'24921': 10,
			'24922': 11,
			'24923': 255,
			'24924': 20,
			'24925': 11,
			'24926': 12,
			'24927': 255,
			'24928': 19,
			'24929': 10,
			'24930': 11,
			'24931': 255,
			'24932': 19,
			'24933': 10,
			'24934': 11,
			'24935': 255,
			'24936': 19,
			'24937': 10,
			'24938': 11,
			'24939': 255,
			'24940': 20,
			'24941': 11,
			'24942': 12,
			'24943': 255,
			'24944': 20,
			'24945': 12,
			'24946': 11,
			'24947': 255,
			'24948': 21,
			'24949': 13,
			'24950': 11,
			'24951': 255,
			'24952': 20,
			'24953': 10,
			'24954': 12,
			'24955': 255,
			'24956': 21,
			'24957': 11,
			'24958': 13,
			'24959': 255,
			'24960': 22,
			'24961': 13,
			'24962': 13,
			'24963': 255,
			'24964': 24,
			'24965': 17,
			'24966': 16,
			'24967': 255,
			'24968': 23,
			'24969': 15,
			'24970': 15,
			'24971': 255,
			'24972': 21,
			'24973': 12,
			'24974': 12,
			'24975': 255,
			'24976': 21,
			'24977': 12,
			'24978': 13,
			'24979': 255,
			'24980': 22,
			'24981': 13,
			'24982': 14,
			'24983': 255,
			'24984': 24,
			'24985': 15,
			'24986': 16,
			'24987': 255,
			'24988': 25,
			'24989': 16,
			'24990': 17,
			'24991': 255,
			'24992': 25,
			'24993': 15,
			'24994': 16,
			'24995': 255,
			'24996': 23,
			'24997': 14,
			'24998': 16,
			'24999': 255,
			'25000': 22,
			'25001': 15,
			'25002': 14,
			'25003': 255,
			'25004': 20,
			'25005': 13,
			'25006': 13,
			'25007': 255,
			'25008': 21,
			'25009': 13,
			'25010': 13,
			'25011': 255,
			'25012': 21,
			'25013': 12,
			'25014': 12,
			'25015': 255,
			'25016': 20,
			'25017': 12,
			'25018': 11,
			'25019': 255,
			'25020': 21,
			'25021': 12,
			'25022': 13,
			'25023': 255,
			'25024': 19,
			'25025': 10,
			'25026': 11,
			'25027': 255,
			'25028': 18,
			'25029': 9,
			'25030': 10,
			'25031': 255,
			'25032': 18,
			'25033': 9,
			'25034': 10,
			'25035': 255,
			'25036': 19,
			'25037': 10,
			'25038': 11,
			'25039': 255,
			'25040': 19,
			'25041': 10,
			'25042': 11,
			'25043': 255,
			'25044': 19,
			'25045': 10,
			'25046': 11,
			'25047': 255,
			'25048': 19,
			'25049': 10,
			'25050': 11,
			'25051': 255,
			'25052': 20,
			'25053': 11,
			'25054': 12,
			'25055': 255,
			'25056': 18,
			'25057': 9,
			'25058': 10,
			'25059': 255,
			'25060': 18,
			'25061': 9,
			'25062': 10,
			'25063': 255,
			'25064': 18,
			'25065': 9,
			'25066': 10,
			'25067': 255,
			'25068': 18,
			'25069': 9,
			'25070': 10,
			'25071': 255,
			'25072': 18,
			'25073': 9,
			'25074': 10,
			'25075': 255,
			'25076': 18,
			'25077': 9,
			'25078': 10,
			'25079': 255,
			'25080': 18,
			'25081': 9,
			'25082': 10,
			'25083': 255,
			'25084': 18,
			'25085': 9,
			'25086': 10,
			'25087': 255,
			'25088': 19,
			'25089': 10,
			'25090': 11,
			'25091': 255,
			'25092': 19,
			'25093': 10,
			'25094': 11,
			'25095': 255,
			'25096': 18,
			'25097': 9,
			'25098': 10,
			'25099': 255,
			'25100': 18,
			'25101': 9,
			'25102': 10,
			'25103': 255,
			'25104': 18,
			'25105': 9,
			'25106': 10,
			'25107': 255,
			'25108': 19,
			'25109': 9,
			'25110': 10,
			'25111': 255,
			'25112': 18,
			'25113': 9,
			'25114': 10,
			'25115': 255,
			'25116': 18,
			'25117': 9,
			'25118': 10,
			'25119': 255,
			'25120': 18,
			'25121': 9,
			'25122': 10,
			'25123': 255,
			'25124': 18,
			'25125': 9,
			'25126': 10,
			'25127': 255,
			'25128': 19,
			'25129': 10,
			'25130': 11,
			'25131': 255,
			'25132': 16,
			'25133': 7,
			'25134': 8,
			'25135': 255,
			'25136': 0,
			'25137': 0,
			'25138': 0,
			'25139': 255,
			'25140': 81,
			'25141': 71,
			'25142': 72,
			'25143': 255,
			'25144': 162,
			'25145': 153,
			'25146': 154,
			'25147': 255,
			'25148': 135,
			'25149': 126,
			'25150': 127,
			'25151': 255,
			'25152': 131,
			'25153': 122,
			'25154': 123,
			'25155': 255,
			'25156': 132,
			'25157': 123,
			'25158': 124,
			'25159': 255,
			'25160': 129,
			'25161': 120,
			'25162': 121,
			'25163': 255,
			'25164': 129,
			'25165': 120,
			'25166': 121,
			'25167': 255,
			'25168': 131,
			'25169': 122,
			'25170': 123,
			'25171': 255,
			'25172': 126,
			'25173': 117,
			'25174': 118,
			'25175': 255,
			'25176': 121,
			'25177': 112,
			'25178': 113,
			'25179': 255,
			'25180': 121,
			'25181': 112,
			'25182': 112,
			'25183': 255,
			'25184': 116,
			'25185': 108,
			'25186': 108,
			'25187': 255,
			'25188': 119,
			'25189': 110,
			'25190': 111,
			'25191': 255,
			'25192': 121,
			'25193': 111,
			'25194': 112,
			'25195': 255,
			'25196': 125,
			'25197': 116,
			'25198': 117,
			'25199': 255,
			'25200': 157,
			'25201': 151,
			'25202': 152,
			'25203': 255,
			'25204': 168,
			'25205': 164,
			'25206': 163,
			'25207': 255,
			'25208': 177,
			'25209': 174,
			'25210': 173,
			'25211': 255,
			'25212': 178,
			'25213': 175,
			'25214': 173,
			'25215': 255,
			'25216': 180,
			'25217': 177,
			'25218': 176,
			'25219': 255,
			'25220': 179,
			'25221': 175,
			'25222': 174,
			'25223': 255,
			'25224': 177,
			'25225': 173,
			'25226': 172,
			'25227': 255,
			'25228': 166,
			'25229': 162,
			'25230': 161,
			'25231': 255,
			'25232': 161,
			'25233': 155,
			'25234': 155,
			'25235': 255,
			'25236': 174,
			'25237': 170,
			'25238': 169,
			'25239': 255,
			'25240': 176,
			'25241': 171,
			'25242': 171,
			'25243': 255,
			'25244': 184,
			'25245': 180,
			'25246': 179,
			'25247': 255,
			'25248': 198,
			'25249': 195,
			'25250': 194,
			'25251': 255,
			'25252': 103,
			'25253': 94,
			'25254': 95,
			'25255': 255,
			'25256': 46,
			'25257': 35,
			'25258': 34,
			'25259': 255,
			'25260': 55,
			'25261': 44,
			'25262': 44,
			'25263': 255,
			'25264': 43,
			'25265': 33,
			'25266': 32,
			'25267': 255,
			'25268': 41,
			'25269': 32,
			'25270': 31,
			'25271': 255,
			'25272': 34,
			'25273': 25,
			'25274': 25,
			'25275': 255,
			'25276': 18,
			'25277': 9,
			'25278': 10,
			'25279': 255,
			'25280': 19,
			'25281': 11,
			'25282': 12,
			'25283': 255,
			'25284': 22,
			'25285': 15,
			'25286': 14,
			'25287': 255,
			'25288': 22,
			'25289': 13,
			'25290': 12,
			'25291': 255,
			'25292': 19,
			'25293': 10,
			'25294': 11,
			'25295': 255,
			'25296': 28,
			'25297': 20,
			'25298': 21,
			'25299': 255,
			'25300': 30,
			'25301': 20,
			'25302': 21,
			'25303': 255,
			'25304': 23,
			'25305': 15,
			'25306': 14,
			'25307': 255,
			'25308': 20,
			'25309': 12,
			'25310': 11,
			'25311': 255,
			'25312': 17,
			'25313': 8,
			'25314': 9,
			'25315': 255,
			'25316': 18,
			'25317': 9,
			'25318': 11,
			'25319': 255,
			'25320': 22,
			'25321': 14,
			'25322': 13,
			'25323': 255,
			'25324': 20,
			'25325': 12,
			'25326': 12,
			'25327': 255,
			'25328': 18,
			'25329': 9,
			'25330': 11,
			'25331': 255,
			'25332': 18,
			'25333': 9,
			'25334': 10,
			'25335': 255,
			'25336': 19,
			'25337': 10,
			'25338': 11,
			'25339': 255,
			'25340': 20,
			'25341': 11,
			'25342': 12,
			'25343': 255,
			'25344': 20,
			'25345': 11,
			'25346': 12,
			'25347': 255,
			'25348': 20,
			'25349': 11,
			'25350': 12,
			'25351': 255,
			'25352': 21,
			'25353': 12,
			'25354': 13,
			'25355': 255,
			'25356': 21,
			'25357': 12,
			'25358': 13,
			'25359': 255,
			'25360': 21,
			'25361': 12,
			'25362': 12,
			'25363': 255,
			'25364': 21,
			'25365': 12,
			'25366': 12,
			'25367': 255,
			'25368': 22,
			'25369': 14,
			'25370': 13,
			'25371': 255,
			'25372': 24,
			'25373': 15,
			'25374': 15,
			'25375': 255,
			'25376': 25,
			'25377': 16,
			'25378': 18,
			'25379': 255,
			'25380': 24,
			'25381': 15,
			'25382': 16,
			'25383': 255,
			'25384': 23,
			'25385': 14,
			'25386': 15,
			'25387': 255,
			'25388': 22,
			'25389': 13,
			'25390': 14,
			'25391': 255,
			'25392': 22,
			'25393': 13,
			'25394': 14,
			'25395': 255,
			'25396': 22,
			'25397': 13,
			'25398': 14,
			'25399': 255,
			'25400': 20,
			'25401': 10,
			'25402': 12,
			'25403': 255,
			'25404': 21,
			'25405': 11,
			'25406': 13,
			'25407': 255,
			'25408': 21,
			'25409': 12,
			'25410': 13,
			'25411': 255,
			'25412': 18,
			'25413': 9,
			'25414': 11,
			'25415': 255,
			'25416': 18,
			'25417': 8,
			'25418': 10,
			'25419': 255,
			'25420': 21,
			'25421': 12,
			'25422': 13,
			'25423': 255,
			'25424': 21,
			'25425': 12,
			'25426': 13,
			'25427': 255,
			'25428': 18,
			'25429': 9,
			'25430': 10,
			'25431': 255,
			'25432': 18,
			'25433': 9,
			'25434': 10,
			'25435': 255,
			'25436': 18,
			'25437': 9,
			'25438': 10,
			'25439': 255,
			'25440': 19,
			'25441': 10,
			'25442': 11,
			'25443': 255,
			'25444': 18,
			'25445': 9,
			'25446': 10,
			'25447': 255,
			'25448': 19,
			'25449': 10,
			'25450': 11,
			'25451': 255,
			'25452': 19,
			'25453': 10,
			'25454': 11,
			'25455': 255,
			'25456': 18,
			'25457': 9,
			'25458': 10,
			'25459': 255,
			'25460': 18,
			'25461': 9,
			'25462': 10,
			'25463': 255,
			'25464': 19,
			'25465': 10,
			'25466': 11,
			'25467': 255,
			'25468': 19,
			'25469': 10,
			'25470': 11,
			'25471': 255,
			'25472': 19,
			'25473': 9,
			'25474': 10,
			'25475': 255,
			'25476': 18,
			'25477': 9,
			'25478': 10,
			'25479': 255,
			'25480': 18,
			'25481': 9,
			'25482': 10,
			'25483': 255,
			'25484': 18,
			'25485': 9,
			'25486': 10,
			'25487': 255,
			'25488': 19,
			'25489': 10,
			'25490': 11,
			'25491': 255,
			'25492': 18,
			'25493': 9,
			'25494': 10,
			'25495': 255,
			'25496': 18,
			'25497': 9,
			'25498': 10,
			'25499': 255,
			'25500': 17,
			'25501': 9,
			'25502': 9,
			'25503': 255,
			'25504': 17,
			'25505': 9,
			'25506': 10,
			'25507': 255,
			'25508': 20,
			'25509': 10,
			'25510': 11,
			'25511': 255,
			'25512': 18,
			'25513': 9,
			'25514': 10,
			'25515': 255,
			'25516': 18,
			'25517': 9,
			'25518': 10,
			'25519': 255,
			'25520': 19,
			'25521': 9,
			'25522': 10,
			'25523': 255,
			'25524': 18,
			'25525': 9,
			'25526': 10,
			'25527': 255,
			'25528': 18,
			'25529': 9,
			'25530': 10,
			'25531': 255,
			'25532': 19,
			'25533': 10,
			'25534': 11,
			'25535': 255,
			'25536': 12,
			'25537': 4,
			'25538': 5,
			'25539': 255,
			'25540': 0,
			'25541': 0,
			'25542': 0,
			'25543': 255,
			'25544': 107,
			'25545': 98,
			'25546': 99,
			'25547': 255,
			'25548': 158,
			'25549': 149,
			'25550': 150,
			'25551': 255,
			'25552': 133,
			'25553': 124,
			'25554': 125,
			'25555': 255,
			'25556': 130,
			'25557': 121,
			'25558': 122,
			'25559': 255,
			'25560': 128,
			'25561': 119,
			'25562': 121,
			'25563': 255,
			'25564': 129,
			'25565': 120,
			'25566': 121,
			'25567': 255,
			'25568': 125,
			'25569': 116,
			'25570': 117,
			'25571': 255,
			'25572': 120,
			'25573': 111,
			'25574': 112,
			'25575': 255,
			'25576': 120,
			'25577': 111,
			'25578': 112,
			'25579': 255,
			'25580': 116,
			'25581': 108,
			'25582': 108,
			'25583': 255,
			'25584': 114,
			'25585': 105,
			'25586': 105,
			'25587': 255,
			'25588': 120,
			'25589': 111,
			'25590': 112,
			'25591': 255,
			'25592': 118,
			'25593': 109,
			'25594': 108,
			'25595': 255,
			'25596': 121,
			'25597': 114,
			'25598': 114,
			'25599': 255,
			'25600': 153,
			'25601': 146,
			'25602': 147,
			'25603': 255,
			'25604': 158,
			'25605': 152,
			'25606': 152,
			'25607': 255,
			'25608': 172,
			'25609': 169,
			'25610': 168,
			'25611': 255,
			'25612': 164,
			'25613': 159,
			'25614': 159,
			'25615': 255,
			'25616': 168,
			'25617': 165,
			'25618': 164,
			'25619': 255,
			'25620': 177,
			'25621': 173,
			'25622': 172,
			'25623': 255,
			'25624': 168,
			'25625': 163,
			'25626': 162,
			'25627': 255,
			'25628': 158,
			'25629': 153,
			'25630': 152,
			'25631': 255,
			'25632': 148,
			'25633': 141,
			'25634': 142,
			'25635': 255,
			'25636': 164,
			'25637': 159,
			'25638': 159,
			'25639': 255,
			'25640': 166,
			'25641': 162,
			'25642': 162,
			'25643': 255,
			'25644': 196,
			'25645': 193,
			'25646': 192,
			'25647': 255,
			'25648': 146,
			'25649': 140,
			'25650': 140,
			'25651': 255,
			'25652': 52,
			'25653': 41,
			'25654': 41,
			'25655': 255,
			'25656': 55,
			'25657': 45,
			'25658': 43,
			'25659': 255,
			'25660': 53,
			'25661': 43,
			'25662': 41,
			'25663': 255,
			'25664': 45,
			'25665': 35,
			'25666': 35,
			'25667': 255,
			'25668': 28,
			'25669': 19,
			'25670': 21,
			'25671': 255,
			'25672': 41,
			'25673': 33,
			'25674': 32,
			'25675': 255,
			'25676': 22,
			'25677': 14,
			'25678': 14,
			'25679': 255,
			'25680': 16,
			'25681': 7,
			'25682': 8,
			'25683': 255,
			'25684': 21,
			'25685': 12,
			'25686': 12,
			'25687': 255,
			'25688': 20,
			'25689': 12,
			'25690': 12,
			'25691': 255,
			'25692': 20,
			'25693': 11,
			'25694': 12,
			'25695': 255,
			'25696': 27,
			'25697': 18,
			'25698': 19,
			'25699': 255,
			'25700': 26,
			'25701': 17,
			'25702': 18,
			'25703': 255,
			'25704': 29,
			'25705': 20,
			'25706': 21,
			'25707': 255,
			'25708': 19,
			'25709': 11,
			'25710': 11,
			'25711': 255,
			'25712': 17,
			'25713': 8,
			'25714': 9,
			'25715': 255,
			'25716': 20,
			'25717': 11,
			'25718': 12,
			'25719': 255,
			'25720': 24,
			'25721': 15,
			'25722': 13,
			'25723': 255,
			'25724': 21,
			'25725': 12,
			'25726': 12,
			'25727': 255,
			'25728': 19,
			'25729': 10,
			'25730': 11,
			'25731': 255,
			'25732': 18,
			'25733': 9,
			'25734': 10,
			'25735': 255,
			'25736': 18,
			'25737': 9,
			'25738': 10,
			'25739': 255,
			'25740': 21,
			'25741': 12,
			'25742': 12,
			'25743': 255,
			'25744': 21,
			'25745': 12,
			'25746': 12,
			'25747': 255,
			'25748': 19,
			'25749': 10,
			'25750': 12,
			'25751': 255,
			'25752': 20,
			'25753': 11,
			'25754': 12,
			'25755': 255,
			'25756': 20,
			'25757': 11,
			'25758': 12,
			'25759': 255,
			'25760': 19,
			'25761': 10,
			'25762': 12,
			'25763': 255,
			'25764': 20,
			'25765': 11,
			'25766': 11,
			'25767': 255,
			'25768': 23,
			'25769': 14,
			'25770': 13,
			'25771': 255,
			'25772': 24,
			'25773': 15,
			'25774': 16,
			'25775': 255,
			'25776': 22,
			'25777': 16,
			'25778': 16,
			'25779': 255,
			'25780': 24,
			'25781': 16,
			'25782': 17,
			'25783': 255,
			'25784': 26,
			'25785': 16,
			'25786': 17,
			'25787': 255,
			'25788': 25,
			'25789': 17,
			'25790': 18,
			'25791': 255,
			'25792': 24,
			'25793': 16,
			'25794': 17,
			'25795': 255,
			'25796': 22,
			'25797': 15,
			'25798': 15,
			'25799': 255,
			'25800': 21,
			'25801': 13,
			'25802': 12,
			'25803': 255,
			'25804': 22,
			'25805': 13,
			'25806': 12,
			'25807': 255,
			'25808': 20,
			'25809': 11,
			'25810': 12,
			'25811': 255,
			'25812': 19,
			'25813': 10,
			'25814': 11,
			'25815': 255,
			'25816': 19,
			'25817': 10,
			'25818': 11,
			'25819': 255,
			'25820': 19,
			'25821': 10,
			'25822': 11,
			'25823': 255,
			'25824': 18,
			'25825': 9,
			'25826': 10,
			'25827': 255,
			'25828': 18,
			'25829': 9,
			'25830': 10,
			'25831': 255,
			'25832': 18,
			'25833': 9,
			'25834': 10,
			'25835': 255,
			'25836': 19,
			'25837': 10,
			'25838': 11,
			'25839': 255,
			'25840': 18,
			'25841': 9,
			'25842': 10,
			'25843': 255,
			'25844': 18,
			'25845': 9,
			'25846': 10,
			'25847': 255,
			'25848': 18,
			'25849': 9,
			'25850': 10,
			'25851': 255,
			'25852': 18,
			'25853': 9,
			'25854': 10,
			'25855': 255,
			'25856': 19,
			'25857': 10,
			'25858': 11,
			'25859': 255,
			'25860': 18,
			'25861': 9,
			'25862': 10,
			'25863': 255,
			'25864': 18,
			'25865': 9,
			'25866': 10,
			'25867': 255,
			'25868': 18,
			'25869': 9,
			'25870': 10,
			'25871': 255,
			'25872': 18,
			'25873': 9,
			'25874': 10,
			'25875': 255,
			'25876': 18,
			'25877': 9,
			'25878': 10,
			'25879': 255,
			'25880': 18,
			'25881': 9,
			'25882': 10,
			'25883': 255,
			'25884': 18,
			'25885': 9,
			'25886': 10,
			'25887': 255,
			'25888': 19,
			'25889': 10,
			'25890': 11,
			'25891': 255,
			'25892': 18,
			'25893': 9,
			'25894': 10,
			'25895': 255,
			'25896': 18,
			'25897': 8,
			'25898': 9,
			'25899': 255,
			'25900': 16,
			'25901': 9,
			'25902': 9,
			'25903': 255,
			'25904': 14,
			'25905': 8,
			'25906': 9,
			'25907': 255,
			'25908': 18,
			'25909': 9,
			'25910': 10,
			'25911': 255,
			'25912': 17,
			'25913': 9,
			'25914': 10,
			'25915': 255,
			'25916': 16,
			'25917': 8,
			'25918': 9,
			'25919': 255,
			'25920': 17,
			'25921': 8,
			'25922': 9,
			'25923': 255,
			'25924': 19,
			'25925': 9,
			'25926': 10,
			'25927': 255,
			'25928': 16,
			'25929': 8,
			'25930': 9,
			'25931': 255,
			'25932': 18,
			'25933': 9,
			'25934': 10,
			'25935': 255,
			'25936': 20,
			'25937': 11,
			'25938': 12,
			'25939': 255,
			'25940': 2,
			'25941': 0,
			'25942': 0,
			'25943': 255,
			'25944': 29,
			'25945': 19,
			'25946': 21,
			'25947': 255,
			'25948': 126,
			'25949': 117,
			'25950': 117,
			'25951': 255,
			'25952': 132,
			'25953': 123,
			'25954': 124,
			'25955': 255,
			'25956': 130,
			'25957': 122,
			'25958': 122,
			'25959': 255,
			'25960': 128,
			'25961': 119,
			'25962': 119,
			'25963': 255,
			'25964': 123,
			'25965': 114,
			'25966': 115,
			'25967': 255,
			'25968': 121,
			'25969': 112,
			'25970': 113,
			'25971': 255,
			'25972': 122,
			'25973': 113,
			'25974': 114,
			'25975': 255,
			'25976': 108,
			'25977': 99,
			'25978': 100,
			'25979': 255,
			'25980': 108,
			'25981': 99,
			'25982': 99,
			'25983': 255,
			'25984': 120,
			'25985': 111,
			'25986': 112,
			'25987': 255,
			'25988': 117,
			'25989': 108,
			'25990': 109,
			'25991': 255,
			'25992': 113,
			'25993': 104,
			'25994': 105,
			'25995': 255,
			'25996': 119,
			'25997': 111,
			'25998': 112,
			'25999': 255,
			'26000': 158,
			'26001': 153,
			'26002': 153,
			'26003': 255,
			'26004': 162,
			'26005': 157,
			'26006': 156,
			'26007': 255,
			'26008': 173,
			'26009': 170,
			'26010': 169,
			'26011': 255,
			'26012': 164,
			'26013': 159,
			'26014': 159,
			'26015': 255,
			'26016': 158,
			'26017': 154,
			'26018': 153,
			'26019': 255,
			'26020': 165,
			'26021': 162,
			'26022': 160,
			'26023': 255,
			'26024': 167,
			'26025': 163,
			'26026': 162,
			'26027': 255,
			'26028': 163,
			'26029': 159,
			'26030': 158,
			'26031': 255,
			'26032': 165,
			'26033': 161,
			'26034': 160,
			'26035': 255,
			'26036': 170,
			'26037': 166,
			'26038': 165,
			'26039': 255,
			'26040': 180,
			'26041': 177,
			'26042': 175,
			'26043': 255,
			'26044': 189,
			'26045': 186,
			'26046': 184,
			'26047': 255,
			'26048': 90,
			'26049': 81,
			'26050': 80,
			'26051': 255,
			'26052': 47,
			'26053': 36,
			'26054': 36,
			'26055': 255,
			'26056': 56,
			'26057': 46,
			'26058': 46,
			'26059': 255,
			'26060': 49,
			'26061': 39,
			'26062': 37,
			'26063': 255,
			'26064': 50,
			'26065': 42,
			'26066': 40,
			'26067': 255,
			'26068': 20,
			'26069': 11,
			'26070': 13,
			'26071': 255,
			'26072': 33,
			'26073': 25,
			'26074': 24,
			'26075': 255,
			'26076': 33,
			'26077': 24,
			'26078': 24,
			'26079': 255,
			'26080': 13,
			'26081': 4,
			'26082': 5,
			'26083': 255,
			'26084': 18,
			'26085': 9,
			'26086': 11,
			'26087': 255,
			'26088': 19,
			'26089': 10,
			'26090': 11,
			'26091': 255,
			'26092': 23,
			'26093': 14,
			'26094': 15,
			'26095': 255,
			'26096': 27,
			'26097': 17,
			'26098': 18,
			'26099': 255,
			'26100': 20,
			'26101': 11,
			'26102': 12,
			'26103': 255,
			'26104': 28,
			'26105': 19,
			'26106': 20,
			'26107': 255,
			'26108': 20,
			'26109': 10,
			'26110': 12,
			'26111': 255,
			'26112': 17,
			'26113': 8,
			'26114': 9,
			'26115': 255,
			'26116': 20,
			'26117': 12,
			'26118': 12,
			'26119': 255,
			'26120': 21,
			'26121': 12,
			'26122': 12,
			'26123': 255,
			'26124': 20,
			'26125': 11,
			'26126': 12,
			'26127': 255,
			'26128': 19,
			'26129': 10,
			'26130': 10,
			'26131': 255,
			'26132': 17,
			'26133': 8,
			'26134': 9,
			'26135': 255,
			'26136': 19,
			'26137': 10,
			'26138': 11,
			'26139': 255,
			'26140': 22,
			'26141': 14,
			'26142': 13,
			'26143': 255,
			'26144': 20,
			'26145': 12,
			'26146': 11,
			'26147': 255,
			'26148': 20,
			'26149': 11,
			'26150': 12,
			'26151': 255,
			'26152': 20,
			'26153': 10,
			'26154': 12,
			'26155': 255,
			'26156': 20,
			'26157': 11,
			'26158': 12,
			'26159': 255,
			'26160': 21,
			'26161': 12,
			'26162': 13,
			'26163': 255,
			'26164': 21,
			'26165': 13,
			'26166': 13,
			'26167': 255,
			'26168': 23,
			'26169': 15,
			'26170': 14,
			'26171': 255,
			'26172': 23,
			'26173': 17,
			'26174': 17,
			'26175': 255,
			'26176': 22,
			'26177': 16,
			'26178': 16,
			'26179': 255,
			'26180': 23,
			'26181': 16,
			'26182': 16,
			'26183': 255,
			'26184': 23,
			'26185': 15,
			'26186': 16,
			'26187': 255,
			'26188': 24,
			'26189': 15,
			'26190': 16,
			'26191': 255,
			'26192': 23,
			'26193': 14,
			'26194': 15,
			'26195': 255,
			'26196': 21,
			'26197': 12,
			'26198': 12,
			'26199': 255,
			'26200': 21,
			'26201': 12,
			'26202': 11,
			'26203': 255,
			'26204': 20,
			'26205': 11,
			'26206': 12,
			'26207': 255,
			'26208': 19,
			'26209': 10,
			'26210': 11,
			'26211': 255,
			'26212': 20,
			'26213': 11,
			'26214': 12,
			'26215': 255,
			'26216': 19,
			'26217': 10,
			'26218': 11,
			'26219': 255,
			'26220': 18,
			'26221': 9,
			'26222': 10,
			'26223': 255,
			'26224': 18,
			'26225': 9,
			'26226': 10,
			'26227': 255,
			'26228': 18,
			'26229': 9,
			'26230': 10,
			'26231': 255,
			'26232': 19,
			'26233': 10,
			'26234': 11,
			'26235': 255,
			'26236': 19,
			'26237': 10,
			'26238': 11,
			'26239': 255,
			'26240': 18,
			'26241': 9,
			'26242': 10,
			'26243': 255,
			'26244': 18,
			'26245': 9,
			'26246': 10,
			'26247': 255,
			'26248': 18,
			'26249': 9,
			'26250': 10,
			'26251': 255,
			'26252': 18,
			'26253': 9,
			'26254': 10,
			'26255': 255,
			'26256': 18,
			'26257': 9,
			'26258': 10,
			'26259': 255,
			'26260': 18,
			'26261': 9,
			'26262': 10,
			'26263': 255,
			'26264': 18,
			'26265': 9,
			'26266': 10,
			'26267': 255,
			'26268': 18,
			'26269': 9,
			'26270': 10,
			'26271': 255,
			'26272': 18,
			'26273': 9,
			'26274': 10,
			'26275': 255,
			'26276': 18,
			'26277': 9,
			'26278': 10,
			'26279': 255,
			'26280': 18,
			'26281': 9,
			'26282': 10,
			'26283': 255,
			'26284': 19,
			'26285': 10,
			'26286': 11,
			'26287': 255,
			'26288': 20,
			'26289': 10,
			'26290': 11,
			'26291': 255,
			'26292': 18,
			'26293': 9,
			'26294': 10,
			'26295': 255,
			'26296': 17,
			'26297': 8,
			'26298': 9,
			'26299': 255,
			'26300': 17,
			'26301': 9,
			'26302': 9,
			'26303': 255,
			'26304': 13,
			'26305': 8,
			'26306': 7,
			'26307': 255,
			'26308': 16,
			'26309': 8,
			'26310': 9,
			'26311': 255,
			'26312': 18,
			'26313': 8,
			'26314': 10,
			'26315': 255,
			'26316': 13,
			'26317': 8,
			'26318': 7,
			'26319': 255,
			'26320': 15,
			'26321': 8,
			'26322': 8,
			'26323': 255,
			'26324': 16,
			'26325': 8,
			'26326': 9,
			'26327': 255,
			'26328': 14,
			'26329': 9,
			'26330': 8,
			'26331': 255,
			'26332': 17,
			'26333': 9,
			'26334': 10,
			'26335': 255,
			'26336': 15,
			'26337': 8,
			'26338': 8,
			'26339': 255,
			'26340': 18,
			'26341': 8,
			'26342': 9,
			'26343': 255,
			'26344': 0,
			'26345': 0,
			'26346': 0,
			'26347': 255,
			'26348': 64,
			'26349': 56,
			'26350': 55,
			'26351': 255,
			'26352': 129,
			'26353': 120,
			'26354': 121,
			'26355': 255,
			'26356': 125,
			'26357': 116,
			'26358': 116,
			'26359': 255,
			'26360': 123,
			'26361': 113,
			'26362': 113,
			'26363': 255,
			'26364': 121,
			'26365': 111,
			'26366': 112,
			'26367': 255,
			'26368': 119,
			'26369': 110,
			'26370': 110,
			'26371': 255,
			'26372': 116,
			'26373': 108,
			'26374': 107,
			'26375': 255,
			'26376': 105,
			'26377': 96,
			'26378': 96,
			'26379': 255,
			'26380': 106,
			'26381': 97,
			'26382': 97,
			'26383': 255,
			'26384': 116,
			'26385': 107,
			'26386': 109,
			'26387': 255,
			'26388': 112,
			'26389': 103,
			'26390': 104,
			'26391': 255,
			'26392': 111,
			'26393': 101,
			'26394': 102,
			'26395': 255,
			'26396': 114,
			'26397': 105,
			'26398': 103,
			'26399': 255,
			'26400': 171,
			'26401': 169,
			'26402': 167,
			'26403': 255,
			'26404': 170,
			'26405': 167,
			'26406': 165,
			'26407': 255,
			'26408': 164,
			'26409': 161,
			'26410': 159,
			'26411': 255,
			'26412': 163,
			'26413': 160,
			'26414': 158,
			'26415': 255,
			'26416': 161,
			'26417': 157,
			'26418': 156,
			'26419': 255,
			'26420': 164,
			'26421': 161,
			'26422': 159,
			'26423': 255,
			'26424': 167,
			'26425': 164,
			'26426': 163,
			'26427': 255,
			'26428': 166,
			'26429': 162,
			'26430': 161,
			'26431': 255,
			'26432': 167,
			'26433': 164,
			'26434': 163,
			'26435': 255,
			'26436': 173,
			'26437': 170,
			'26438': 167,
			'26439': 255,
			'26440': 194,
			'26441': 191,
			'26442': 187,
			'26443': 255,
			'26444': 148,
			'26445': 143,
			'26446': 141,
			'26447': 255,
			'26448': 51,
			'26449': 41,
			'26450': 41,
			'26451': 255,
			'26452': 53,
			'26453': 43,
			'26454': 45,
			'26455': 255,
			'26456': 53,
			'26457': 43,
			'26458': 42,
			'26459': 255,
			'26460': 46,
			'26461': 37,
			'26462': 35,
			'26463': 255,
			'26464': 53,
			'26465': 43,
			'26466': 43,
			'26467': 255,
			'26468': 24,
			'26469': 15,
			'26470': 17,
			'26471': 255,
			'26472': 23,
			'26473': 14,
			'26474': 15,
			'26475': 255,
			'26476': 33,
			'26477': 24,
			'26478': 25,
			'26479': 255,
			'26480': 15,
			'26481': 5,
			'26482': 6,
			'26483': 255,
			'26484': 18,
			'26485': 8,
			'26486': 9,
			'26487': 255,
			'26488': 19,
			'26489': 9,
			'26490': 10,
			'26491': 255,
			'26492': 25,
			'26493': 16,
			'26494': 17,
			'26495': 255,
			'26496': 23,
			'26497': 13,
			'26498': 14,
			'26499': 255,
			'26500': 20,
			'26501': 11,
			'26502': 12,
			'26503': 255,
			'26504': 28,
			'26505': 19,
			'26506': 20,
			'26507': 255,
			'26508': 17,
			'26509': 8,
			'26510': 9,
			'26511': 255,
			'26512': 18,
			'26513': 9,
			'26514': 10,
			'26515': 255,
			'26516': 21,
			'26517': 12,
			'26518': 13,
			'26519': 255,
			'26520': 19,
			'26521': 10,
			'26522': 11,
			'26523': 255,
			'26524': 18,
			'26525': 9,
			'26526': 10,
			'26527': 255,
			'26528': 19,
			'26529': 10,
			'26530': 11,
			'26531': 255,
			'26532': 18,
			'26533': 9,
			'26534': 10,
			'26535': 255,
			'26536': 22,
			'26537': 12,
			'26538': 13,
			'26539': 255,
			'26540': 24,
			'26541': 15,
			'26542': 16,
			'26543': 255,
			'26544': 21,
			'26545': 13,
			'26546': 13,
			'26547': 255,
			'26548': 21,
			'26549': 12,
			'26550': 12,
			'26551': 255,
			'26552': 22,
			'26553': 14,
			'26554': 12,
			'26555': 255,
			'26556': 22,
			'26557': 13,
			'26558': 14,
			'26559': 255,
			'26560': 25,
			'26561': 15,
			'26562': 17,
			'26563': 255,
			'26564': 24,
			'26565': 14,
			'26566': 15,
			'26567': 255,
			'26568': 22,
			'26569': 15,
			'26570': 14,
			'26571': 255,
			'26572': 22,
			'26573': 15,
			'26574': 16,
			'26575': 255,
			'26576': 23,
			'26577': 16,
			'26578': 17,
			'26579': 255,
			'26580': 24,
			'26581': 15,
			'26582': 16,
			'26583': 255,
			'26584': 23,
			'26585': 15,
			'26586': 15,
			'26587': 255,
			'26588': 23,
			'26589': 15,
			'26590': 13,
			'26591': 255,
			'26592': 22,
			'26593': 14,
			'26594': 11,
			'26595': 255,
			'26596': 21,
			'26597': 12,
			'26598': 12,
			'26599': 255,
			'26600': 20,
			'26601': 10,
			'26602': 13,
			'26603': 255,
			'26604': 20,
			'26605': 11,
			'26606': 12,
			'26607': 255,
			'26608': 19,
			'26609': 10,
			'26610': 11,
			'26611': 255,
			'26612': 20,
			'26613': 11,
			'26614': 12,
			'26615': 255,
			'26616': 19,
			'26617': 10,
			'26618': 11,
			'26619': 255,
			'26620': 18,
			'26621': 9,
			'26622': 10,
			'26623': 255,
			'26624': 18,
			'26625': 9,
			'26626': 10,
			'26627': 255,
			'26628': 18,
			'26629': 9,
			'26630': 10,
			'26631': 255,
			'26632': 18,
			'26633': 9,
			'26634': 10,
			'26635': 255,
			'26636': 18,
			'26637': 9,
			'26638': 10,
			'26639': 255,
			'26640': 18,
			'26641': 9,
			'26642': 10,
			'26643': 255,
			'26644': 18,
			'26645': 9,
			'26646': 10,
			'26647': 255,
			'26648': 18,
			'26649': 9,
			'26650': 10,
			'26651': 255,
			'26652': 18,
			'26653': 9,
			'26654': 10,
			'26655': 255,
			'26656': 18,
			'26657': 9,
			'26658': 10,
			'26659': 255,
			'26660': 18,
			'26661': 9,
			'26662': 10,
			'26663': 255,
			'26664': 18,
			'26665': 9,
			'26666': 10,
			'26667': 255,
			'26668': 18,
			'26669': 9,
			'26670': 10,
			'26671': 255,
			'26672': 18,
			'26673': 9,
			'26674': 10,
			'26675': 255,
			'26676': 18,
			'26677': 9,
			'26678': 10,
			'26679': 255,
			'26680': 18,
			'26681': 9,
			'26682': 10,
			'26683': 255,
			'26684': 18,
			'26685': 9,
			'26686': 10,
			'26687': 255,
			'26688': 18,
			'26689': 9,
			'26690': 10,
			'26691': 255,
			'26692': 18,
			'26693': 9,
			'26694': 10,
			'26695': 255,
			'26696': 14,
			'26697': 8,
			'26698': 8,
			'26699': 255,
			'26700': 14,
			'26701': 9,
			'26702': 9,
			'26703': 255,
			'26704': 13,
			'26705': 8,
			'26706': 7,
			'26707': 255,
			'26708': 14,
			'26709': 8,
			'26710': 8,
			'26711': 255,
			'26712': 15,
			'26713': 9,
			'26714': 9,
			'26715': 255,
			'26716': 12,
			'26717': 7,
			'26718': 7,
			'26719': 255,
			'26720': 17,
			'26721': 9,
			'26722': 9,
			'26723': 255,
			'26724': 17,
			'26725': 9,
			'26726': 9,
			'26727': 255,
			'26728': 13,
			'26729': 9,
			'26730': 8,
			'26731': 255,
			'26732': 14,
			'26733': 8,
			'26734': 7,
			'26735': 255,
			'26736': 12,
			'26737': 7,
			'26738': 6,
			'26739': 255,
			'26740': 17,
			'26741': 8,
			'26742': 9,
			'26743': 255,
			'26744': 6,
			'26745': 0,
			'26746': 0,
			'26747': 255,
			'26748': 28,
			'26749': 18,
			'26750': 20,
			'26751': 255,
			'26752': 126,
			'26753': 117,
			'26754': 118,
			'26755': 255,
			'26756': 127,
			'26757': 118,
			'26758': 119,
			'26759': 255,
			'26760': 120,
			'26761': 111,
			'26762': 112,
			'26763': 255,
			'26764': 118,
			'26765': 108,
			'26766': 109,
			'26767': 255,
			'26768': 114,
			'26769': 106,
			'26770': 106,
			'26771': 255,
			'26772': 114,
			'26773': 105,
			'26774': 105,
			'26775': 255,
			'26776': 118,
			'26777': 108,
			'26778': 110,
			'26779': 255,
			'26780': 115,
			'26781': 106,
			'26782': 106,
			'26783': 255,
			'26784': 112,
			'26785': 104,
			'26786': 103,
			'26787': 255,
			'26788': 113,
			'26789': 103,
			'26790': 105,
			'26791': 255,
			'26792': 108,
			'26793': 99,
			'26794': 98,
			'26795': 255,
			'26796': 114,
			'26797': 106,
			'26798': 104,
			'26799': 255,
			'26800': 153,
			'26801': 146,
			'26802': 146,
			'26803': 255,
			'26804': 152,
			'26805': 146,
			'26806': 146,
			'26807': 255,
			'26808': 161,
			'26809': 156,
			'26810': 155,
			'26811': 255,
			'26812': 154,
			'26813': 148,
			'26814': 148,
			'26815': 255,
			'26816': 148,
			'26817': 141,
			'26818': 142,
			'26819': 255,
			'26820': 146,
			'26821': 139,
			'26822': 140,
			'26823': 255,
			'26824': 143,
			'26825': 134,
			'26826': 135,
			'26827': 255,
			'26828': 141,
			'26829': 133,
			'26830': 134,
			'26831': 255,
			'26832': 137,
			'26833': 129,
			'26834': 130,
			'26835': 255,
			'26836': 152,
			'26837': 145,
			'26838': 145,
			'26839': 255,
			'26840': 163,
			'26841': 157,
			'26842': 156,
			'26843': 255,
			'26844': 95,
			'26845': 84,
			'26846': 84,
			'26847': 255,
			'26848': 48,
			'26849': 37,
			'26850': 36,
			'26851': 255,
			'26852': 49,
			'26853': 39,
			'26854': 37,
			'26855': 255,
			'26856': 51,
			'26857': 41,
			'26858': 40,
			'26859': 255,
			'26860': 41,
			'26861': 31,
			'26862': 31,
			'26863': 255,
			'26864': 50,
			'26865': 41,
			'26866': 40,
			'26867': 255,
			'26868': 30,
			'26869': 22,
			'26870': 21,
			'26871': 255,
			'26872': 15,
			'26873': 6,
			'26874': 7,
			'26875': 255,
			'26876': 31,
			'26877': 22,
			'26878': 23,
			'26879': 255,
			'26880': 19,
			'26881': 10,
			'26882': 11,
			'26883': 255,
			'26884': 16,
			'26885': 7,
			'26886': 7,
			'26887': 255,
			'26888': 20,
			'26889': 10,
			'26890': 11,
			'26891': 255,
			'26892': 26,
			'26893': 17,
			'26894': 18,
			'26895': 255,
			'26896': 15,
			'26897': 8,
			'26898': 8,
			'26899': 255,
			'26900': 20,
			'26901': 13,
			'26902': 14,
			'26903': 255,
			'26904': 26,
			'26905': 17,
			'26906': 18,
			'26907': 255,
			'26908': 15,
			'26909': 7,
			'26910': 7,
			'26911': 255,
			'26912': 20,
			'26913': 11,
			'26914': 12,
			'26915': 255,
			'26916': 19,
			'26917': 10,
			'26918': 11,
			'26919': 255,
			'26920': 18,
			'26921': 9,
			'26922': 10,
			'26923': 255,
			'26924': 18,
			'26925': 9,
			'26926': 10,
			'26927': 255,
			'26928': 19,
			'26929': 10,
			'26930': 11,
			'26931': 255,
			'26932': 20,
			'26933': 11,
			'26934': 12,
			'26935': 255,
			'26936': 24,
			'26937': 15,
			'26938': 16,
			'26939': 255,
			'26940': 25,
			'26941': 17,
			'26942': 18,
			'26943': 255,
			'26944': 22,
			'26945': 14,
			'26946': 14,
			'26947': 255,
			'26948': 20,
			'26949': 11,
			'26950': 11,
			'26951': 255,
			'26952': 21,
			'26953': 13,
			'26954': 13,
			'26955': 255,
			'26956': 24,
			'26957': 14,
			'26958': 16,
			'26959': 255,
			'26960': 24,
			'26961': 15,
			'26962': 16,
			'26963': 255,
			'26964': 22,
			'26965': 14,
			'26966': 13,
			'26967': 255,
			'26968': 22,
			'26969': 13,
			'26970': 12,
			'26971': 255,
			'26972': 22,
			'26973': 13,
			'26974': 13,
			'26975': 255,
			'26976': 24,
			'26977': 16,
			'26978': 17,
			'26979': 255,
			'26980': 24,
			'26981': 16,
			'26982': 17,
			'26983': 255,
			'26984': 21,
			'26985': 14,
			'26986': 14,
			'26987': 255,
			'26988': 21,
			'26989': 12,
			'26990': 11,
			'26991': 255,
			'26992': 20,
			'26993': 11,
			'26994': 11,
			'26995': 255,
			'26996': 20,
			'26997': 12,
			'26998': 12,
			'26999': 255,
			'27000': 20,
			'27001': 11,
			'27002': 12,
			'27003': 255,
			'27004': 20,
			'27005': 11,
			'27006': 12,
			'27007': 255,
			'27008': 20,
			'27009': 11,
			'27010': 12,
			'27011': 255,
			'27012': 18,
			'27013': 9,
			'27014': 10,
			'27015': 255,
			'27016': 18,
			'27017': 9,
			'27018': 10,
			'27019': 255,
			'27020': 18,
			'27021': 9,
			'27022': 10,
			'27023': 255,
			'27024': 18,
			'27025': 9,
			'27026': 10,
			'27027': 255,
			'27028': 18,
			'27029': 9,
			'27030': 10,
			'27031': 255,
			'27032': 18,
			'27033': 9,
			'27034': 10,
			'27035': 255,
			'27036': 18,
			'27037': 9,
			'27038': 10,
			'27039': 255,
			'27040': 18,
			'27041': 9,
			'27042': 10,
			'27043': 255,
			'27044': 18,
			'27045': 9,
			'27046': 10,
			'27047': 255,
			'27048': 18,
			'27049': 9,
			'27050': 10,
			'27051': 255,
			'27052': 18,
			'27053': 9,
			'27054': 10,
			'27055': 255,
			'27056': 18,
			'27057': 9,
			'27058': 10,
			'27059': 255,
			'27060': 18,
			'27061': 9,
			'27062': 10,
			'27063': 255,
			'27064': 18,
			'27065': 9,
			'27066': 10,
			'27067': 255,
			'27068': 18,
			'27069': 9,
			'27070': 10,
			'27071': 255,
			'27072': 19,
			'27073': 9,
			'27074': 10,
			'27075': 255,
			'27076': 18,
			'27077': 9,
			'27078': 10,
			'27079': 255,
			'27080': 18,
			'27081': 9,
			'27082': 10,
			'27083': 255,
			'27084': 18,
			'27085': 9,
			'27086': 10,
			'27087': 255,
			'27088': 18,
			'27089': 9,
			'27090': 10,
			'27091': 255,
			'27092': 19,
			'27093': 9,
			'27094': 10,
			'27095': 255,
			'27096': 15,
			'27097': 8,
			'27098': 9,
			'27099': 255,
			'27100': 13,
			'27101': 7,
			'27102': 7,
			'27103': 255,
			'27104': 13,
			'27105': 8,
			'27106': 8,
			'27107': 255,
			'27108': 13,
			'27109': 8,
			'27110': 8,
			'27111': 255,
			'27112': 15,
			'27113': 9,
			'27114': 9,
			'27115': 255,
			'27116': 12,
			'27117': 8,
			'27118': 7,
			'27119': 255,
			'27120': 16,
			'27121': 9,
			'27122': 9,
			'27123': 255,
			'27124': 17,
			'27125': 9,
			'27126': 9,
			'27127': 255,
			'27128': 13,
			'27129': 7,
			'27130': 7,
			'27131': 255,
			'27132': 11,
			'27133': 6,
			'27134': 6,
			'27135': 255,
			'27136': 12,
			'27137': 7,
			'27138': 6,
			'27139': 255,
			'27140': 14,
			'27141': 8,
			'27142': 8,
			'27143': 255,
			'27144': 16,
			'27145': 7,
			'27146': 8,
			'27147': 255,
			'27148': 0,
			'27149': 0,
			'27150': 0,
			'27151': 255,
			'27152': 83,
			'27153': 74,
			'27154': 75,
			'27155': 255,
			'27156': 132,
			'27157': 123,
			'27158': 124,
			'27159': 255,
			'27160': 111,
			'27161': 102,
			'27162': 103,
			'27163': 255,
			'27164': 111,
			'27165': 102,
			'27166': 103,
			'27167': 255,
			'27168': 111,
			'27169': 101,
			'27170': 102,
			'27171': 255,
			'27172': 112,
			'27173': 102,
			'27174': 104,
			'27175': 255,
			'27176': 109,
			'27177': 101,
			'27178': 101,
			'27179': 255,
			'27180': 107,
			'27181': 100,
			'27182': 97,
			'27183': 255,
			'27184': 106,
			'27185': 98,
			'27186': 95,
			'27187': 255,
			'27188': 104,
			'27189': 94,
			'27190': 93,
			'27191': 255,
			'27192': 105,
			'27193': 95,
			'27194': 95,
			'27195': 255,
			'27196': 103,
			'27197': 94,
			'27198': 95,
			'27199': 255,
			'27200': 162,
			'27201': 154,
			'27202': 154,
			'27203': 255,
			'27204': 135,
			'27205': 126,
			'27206': 127,
			'27207': 255,
			'27208': 152,
			'27209': 143,
			'27210': 143,
			'27211': 255,
			'27212': 165,
			'27213': 159,
			'27214': 158,
			'27215': 255,
			'27216': 153,
			'27217': 146,
			'27218': 146,
			'27219': 255,
			'27220': 153,
			'27221': 148,
			'27222': 148,
			'27223': 255,
			'27224': 152,
			'27225': 144,
			'27226': 144,
			'27227': 255,
			'27228': 153,
			'27229': 144,
			'27230': 146,
			'27231': 255,
			'27232': 145,
			'27233': 135,
			'27234': 136,
			'27235': 255,
			'27236': 161,
			'27237': 154,
			'27238': 155,
			'27239': 255,
			'27240': 151,
			'27241': 144,
			'27242': 145,
			'27243': 255,
			'27244': 72,
			'27245': 61,
			'27246': 61,
			'27247': 255,
			'27248': 65,
			'27249': 55,
			'27250': 54,
			'27251': 255,
			'27252': 54,
			'27253': 45,
			'27254': 43,
			'27255': 255,
			'27256': 59,
			'27257': 50,
			'27258': 48,
			'27259': 255,
			'27260': 49,
			'27261': 41,
			'27262': 40,
			'27263': 255,
			'27264': 53,
			'27265': 46,
			'27266': 44,
			'27267': 255,
			'27268': 44,
			'27269': 36,
			'27270': 35,
			'27271': 255,
			'27272': 22,
			'27273': 15,
			'27274': 16,
			'27275': 255,
			'27276': 41,
			'27277': 33,
			'27278': 33,
			'27279': 255,
			'27280': 34,
			'27281': 26,
			'27282': 27,
			'27283': 255,
			'27284': 23,
			'27285': 18,
			'27286': 18,
			'27287': 255,
			'27288': 33,
			'27289': 24,
			'27290': 25,
			'27291': 255,
			'27292': 37,
			'27293': 28,
			'27294': 29,
			'27295': 255,
			'27296': 23,
			'27297': 18,
			'27298': 18,
			'27299': 255,
			'27300': 33,
			'27301': 27,
			'27302': 27,
			'27303': 255,
			'27304': 36,
			'27305': 27,
			'27306': 28,
			'27307': 255,
			'27308': 29,
			'27309': 21,
			'27310': 22,
			'27311': 255,
			'27312': 31,
			'27313': 22,
			'27314': 23,
			'27315': 255,
			'27316': 29,
			'27317': 21,
			'27318': 22,
			'27319': 255,
			'27320': 30,
			'27321': 22,
			'27322': 22,
			'27323': 255,
			'27324': 31,
			'27325': 22,
			'27326': 23,
			'27327': 255,
			'27328': 32,
			'27329': 23,
			'27330': 24,
			'27331': 255,
			'27332': 34,
			'27333': 24,
			'27334': 25,
			'27335': 255,
			'27336': 35,
			'27337': 28,
			'27338': 28,
			'27339': 255,
			'27340': 37,
			'27341': 29,
			'27342': 30,
			'27343': 255,
			'27344': 34,
			'27345': 24,
			'27346': 25,
			'27347': 255,
			'27348': 30,
			'27349': 22,
			'27350': 22,
			'27351': 255,
			'27352': 33,
			'27353': 24,
			'27354': 25,
			'27355': 255,
			'27356': 34,
			'27357': 25,
			'27358': 26,
			'27359': 255,
			'27360': 33,
			'27361': 26,
			'27362': 26,
			'27363': 255,
			'27364': 33,
			'27365': 25,
			'27366': 24,
			'27367': 255,
			'27368': 33,
			'27369': 25,
			'27370': 24,
			'27371': 255,
			'27372': 33,
			'27373': 23,
			'27374': 24,
			'27375': 255,
			'27376': 35,
			'27377': 25,
			'27378': 27,
			'27379': 255,
			'27380': 35,
			'27381': 29,
			'27382': 29,
			'27383': 255,
			'27384': 34,
			'27385': 26,
			'27386': 27,
			'27387': 255,
			'27388': 32,
			'27389': 22,
			'27390': 24,
			'27391': 255,
			'27392': 31,
			'27393': 23,
			'27394': 24,
			'27395': 255,
			'27396': 32,
			'27397': 23,
			'27398': 24,
			'27399': 255,
			'27400': 31,
			'27401': 22,
			'27402': 23,
			'27403': 255,
			'27404': 30,
			'27405': 22,
			'27406': 22,
			'27407': 255,
			'27408': 31,
			'27409': 22,
			'27410': 23,
			'27411': 255,
			'27412': 30,
			'27413': 22,
			'27414': 22,
			'27415': 255,
			'27416': 30,
			'27417': 22,
			'27418': 22,
			'27419': 255,
			'27420': 30,
			'27421': 22,
			'27422': 22,
			'27423': 255,
			'27424': 30,
			'27425': 22,
			'27426': 22,
			'27427': 255,
			'27428': 30,
			'27429': 22,
			'27430': 22,
			'27431': 255,
			'27432': 30,
			'27433': 22,
			'27434': 22,
			'27435': 255,
			'27436': 30,
			'27437': 22,
			'27438': 22,
			'27439': 255,
			'27440': 30,
			'27441': 22,
			'27442': 22,
			'27443': 255,
			'27444': 30,
			'27445': 22,
			'27446': 22,
			'27447': 255,
			'27448': 30,
			'27449': 22,
			'27450': 22,
			'27451': 255,
			'27452': 30,
			'27453': 22,
			'27454': 22,
			'27455': 255,
			'27456': 30,
			'27457': 22,
			'27458': 22,
			'27459': 255,
			'27460': 31,
			'27461': 22,
			'27462': 22,
			'27463': 255,
			'27464': 30,
			'27465': 22,
			'27466': 22,
			'27467': 255,
			'27468': 30,
			'27469': 22,
			'27470': 22,
			'27471': 255,
			'27472': 30,
			'27473': 22,
			'27474': 22,
			'27475': 255,
			'27476': 29,
			'27477': 21,
			'27478': 22,
			'27479': 255,
			'27480': 29,
			'27481': 21,
			'27482': 22,
			'27483': 255,
			'27484': 30,
			'27485': 22,
			'27486': 22,
			'27487': 255,
			'27488': 30,
			'27489': 22,
			'27490': 22,
			'27491': 255,
			'27492': 31,
			'27493': 22,
			'27494': 23,
			'27495': 255,
			'27496': 28,
			'27497': 22,
			'27498': 22,
			'27499': 255,
			'27500': 24,
			'27501': 20,
			'27502': 19,
			'27503': 255,
			'27504': 25,
			'27505': 20,
			'27506': 20,
			'27507': 255,
			'27508': 24,
			'27509': 20,
			'27510': 20,
			'27511': 255,
			'27512': 27,
			'27513': 21,
			'27514': 22,
			'27515': 255,
			'27516': 23,
			'27517': 19,
			'27518': 19,
			'27519': 255,
			'27520': 25,
			'27521': 21,
			'27522': 21,
			'27523': 255,
			'27524': 27,
			'27525': 22,
			'27526': 22,
			'27527': 255,
			'27528': 23,
			'27529': 18,
			'27530': 18,
			'27531': 255,
			'27532': 24,
			'27533': 20,
			'27534': 19,
			'27535': 255,
			'27536': 24,
			'27537': 20,
			'27538': 20,
			'27539': 255,
			'27540': 25,
			'27541': 21,
			'27542': 20,
			'27543': 255,
			'27544': 27,
			'27545': 21,
			'27546': 21,
			'27547': 255,
			'27548': 14,
			'27549': 13,
			'27550': 13,
			'27551': 255,
			'27552': 55,
			'27553': 46,
			'27554': 47,
			'27555': 255,
			'27556': 134,
			'27557': 126,
			'27558': 126,
			'27559': 255,
			'27560': 124,
			'27561': 116,
			'27562': 116,
			'27563': 255,
			'27564': 121,
			'27565': 113,
			'27566': 114,
			'27567': 255,
			'27568': 121,
			'27569': 112,
			'27570': 113,
			'27571': 255,
			'27572': 119,
			'27573': 111,
			'27574': 111,
			'27575': 255,
			'27576': 118,
			'27577': 111,
			'27578': 110,
			'27579': 255,
			'27580': 115,
			'27581': 108,
			'27582': 108,
			'27583': 255,
			'27584': 114,
			'27585': 106,
			'27586': 104,
			'27587': 255,
			'27588': 112,
			'27589': 103,
			'27590': 101,
			'27591': 255,
			'27592': 111,
			'27593': 101,
			'27594': 101,
			'27595': 255,
			'27596': 116,
			'27597': 108,
			'27598': 108,
			'27599': 255
		},
		_gridData: [
			{ x: 0, y: 0 },
			{ x: 0.01, y: 0 },
			{ x: 0.02, y: 0 },
			{ x: 0.03, y: 0 },
			{ x: 0.04, y: 0 },
			{ x: 0.05, y: 0 },
			{ x: 0.06, y: 0 },
			{ x: 0.07, y: 0 },
			{ x: 0.08, y: 0 },
			{ x: 0.09, y: 0 },
			{ x: 0.1, y: 0 },
			{ x: 0.11, y: 0 },
			{ x: 0.12, y: 0 },
			{ x: 0.13, y: 0 },
			{ x: 0.14, y: 0 },
			{ x: 0.15, y: 0 },
			{ x: 0.16, y: 0 },
			{ x: 0.17, y: 0 },
			{ x: 0.18, y: 0 },
			{ x: 0.19, y: 0 },
			{ x: 0.2, y: 0 },
			{ x: 0.21, y: 0 },
			{ x: 0.22, y: 0 },
			{ x: 0.23, y: 0 },
			{ x: 0.24, y: 0 },
			{ x: 0.25, y: 0 },
			{ x: 0.26, y: 0 },
			{ x: 0.27, y: 0 },
			{ x: 0.28, y: 0 },
			{ x: 0.29, y: 0 },
			{ x: 0.3, y: 0 },
			{ x: 0.31, y: 0 },
			{ x: 0.32, y: 0 },
			{ x: 0.33, y: 0 },
			{ x: 0.34, y: 0 },
			{ x: 0.35, y: 0 },
			{ x: 0.36, y: 0 },
			{ x: 0.37, y: 0 },
			{ x: 0.38, y: 0 },
			{ x: 0.39, y: 0 },
			{ x: 0.4, y: 0 },
			{ x: 0.41, y: 0 },
			{ x: 0.42, y: 0 },
			{ x: 0.43, y: 0 },
			{ x: 0.44, y: 0 },
			{ x: 0.45, y: 0 },
			{ x: 0.46, y: 0 },
			{ x: 0.47, y: 0 },
			{ x: 0.48, y: 0 },
			{ x: 0.49, y: 0 },
			{ x: 0.5, y: 0 },
			{ x: 0.51, y: 0 },
			{ x: 0.52, y: 0 },
			{ x: 0.53, y: 0 },
			{ x: 0.54, y: 0 },
			{ x: 0.55, y: 0 },
			{ x: 0.56, y: 0 },
			{ x: 0.57, y: 0 },
			{ x: 0.58, y: 0 },
			{ x: 0.59, y: 0 },
			{ x: 0.6, y: 0 },
			{ x: 0.61, y: 0 },
			{ x: 0.62, y: 0 },
			{ x: 0.63, y: 0 },
			{ x: 0.64, y: 0 },
			{ x: 0.65, y: 0 },
			{ x: 0.66, y: 0 },
			{ x: 0.67, y: 0 },
			{ x: 0.68, y: 0 },
			{ x: 0.69, y: 0 },
			{ x: 0.7, y: 0 },
			{ x: 0.71, y: 0 },
			{ x: 0.72, y: 0 },
			{ x: 0.73, y: 0 },
			{ x: 0.74, y: 0 },
			{ x: 0.75, y: 0 },
			{ x: 0.76, y: 0 },
			{ x: 0.77, y: 0 },
			{ x: 0.78, y: 0 },
			{ x: 0.79, y: 0 },
			{ x: 0.8, y: 0 },
			{ x: 0.81, y: 0 },
			{ x: 0.82, y: 0 },
			{ x: 0.83, y: 0 },
			{ x: 0.84, y: 0 },
			{ x: 0.85, y: 0 },
			{ x: 0.86, y: 0 },
			{ x: 0.87, y: 0 },
			{ x: 0.88, y: 0 },
			{ x: 0.89, y: 0 },
			{ x: 0.9, y: 0 },
			{ x: 0.91, y: 0 },
			{ x: 0.92, y: 0 },
			{ x: 0.93, y: 0 },
			{ x: 0.94, y: 0 },
			{ x: 0.95, y: 0 },
			{ x: 0.96, y: 0 },
			{ x: 0.97, y: 0 },
			{ x: 0.98, y: 0 },
			{ x: 0.99, y: 0 },
			{ x: 0, y: 0.01449 },
			{ x: 0.01, y: 0.01449 },
			{ x: 0.02, y: 0.01449 },
			{ x: 0.03, y: 0.01449 },
			{ x: 0.04, y: 0.01449 },
			{ x: 0.05, y: 0.01449 },
			{ x: 0.06, y: 0.01449 },
			{ x: 0.07, y: 0.01449 },
			{ x: 0.08, y: 0.01449 },
			{ x: 0.09, y: 0.01449 },
			{ x: 0.1, y: 0.01449 },
			{ x: 0.11, y: 0.01449 },
			{ x: 0.12, y: 0.01449 },
			{ x: 0.13, y: 0.01449 },
			{ x: 0.14, y: 0.01449 },
			{ x: 0.15, y: 0.01449 },
			{ x: 0.16, y: 0.01449 },
			{ x: 0.17, y: 0.01449 },
			{ x: 0.18, y: 0.01449 },
			{ x: 0.19, y: 0.01449 },
			{ x: 0.2, y: 0.01449 },
			{ x: 0.21, y: 0.01449 },
			{ x: 0.22, y: 0.01449 },
			{ x: 0.23, y: 0.01449 },
			{ x: 0.24, y: 0.01449 },
			{ x: 0.25, y: 0.01449 },
			{ x: 0.26, y: 0.01449 },
			{ x: 0.27, y: 0.01449 },
			{ x: 0.28, y: 0.01449 },
			{ x: 0.29, y: 0.01449 },
			{ x: 0.3, y: 0.01449 },
			{ x: 0.31, y: 0.01449 },
			{ x: 0.32, y: 0.01449 },
			{ x: 0.33, y: 0.01449 },
			{ x: 0.34, y: 0.01449 },
			{ x: 0.35, y: 0.01449 },
			{ x: 0.36, y: 0.01449 },
			{ x: 0.37, y: 0.01449 },
			{ x: 0.38, y: 0.01449 },
			{ x: 0.39, y: 0.01449 },
			{ x: 0.4, y: 0.01449 },
			{ x: 0.41, y: 0.01449 },
			{ x: 0.42, y: 0.01449 },
			{ x: 0.43, y: 0.01449 },
			{ x: 0.44, y: 0.01449 },
			{ x: 0.45, y: 0.01449 },
			{ x: 0.46, y: 0.01449 },
			{ x: 0.47, y: 0.01449 },
			{ x: 0.48, y: 0.01449 },
			{ x: 0.49, y: 0.01449 },
			{ x: 0.5, y: 0.01449 },
			{ x: 0.51, y: 0.01449 },
			{ x: 0.52, y: 0.01449 },
			{ x: 0.53, y: 0.01449 },
			{ x: 0.54, y: 0.01449 },
			{ x: 0.55, y: 0.01449 },
			{ x: 0.56, y: 0.01449 },
			{ x: 0.57, y: 0.01449 },
			{ x: 0.58, y: 0.01449 },
			{ x: 0.59, y: 0.01449 },
			{ x: 0.6, y: 0.01449 },
			{ x: 0.61, y: 0.01449 },
			{ x: 0.62, y: 0.01449 },
			{ x: 0.63, y: 0.01449 },
			{ x: 0.64, y: 0.01449 },
			{ x: 0.65, y: 0.01449 },
			{ x: 0.66, y: 0.01449 },
			{ x: 0.67, y: 0.01449 },
			{ x: 0.68, y: 0.01449 },
			{ x: 0.69, y: 0.01449 },
			{ x: 0.7, y: 0.01449 },
			{ x: 0.71, y: 0.01449 },
			{ x: 0.72, y: 0.01449 },
			{ x: 0.73, y: 0.01449 },
			{ x: 0.74, y: 0.01449 },
			{ x: 0.75, y: 0.01449 },
			{ x: 0.76, y: 0.01449 },
			{ x: 0.77, y: 0.01449 },
			{ x: 0.78, y: 0.01449 },
			{ x: 0.79, y: 0.01449 },
			{ x: 0.8, y: 0.01449 },
			{ x: 0.81, y: 0.01449 },
			{ x: 0.82, y: 0.01449 },
			{ x: 0.83, y: 0.01449 },
			{ x: 0.84, y: 0.01449 },
			{ x: 0.85, y: 0.01449 },
			{ x: 0.86, y: 0.01449 },
			{ x: 0.87, y: 0.01449 },
			{ x: 0.88, y: 0.01449 },
			{ x: 0.89, y: 0.01449 },
			{ x: 0.9, y: 0.01449 },
			{ x: 0.91, y: 0.01449 },
			{ x: 0.92, y: 0.01449 },
			{ x: 0.93, y: 0.01449 },
			{ x: 0.94, y: 0.01449 },
			{ x: 0.95, y: 0.01449 },
			{ x: 0.96, y: 0.01449 },
			{ x: 0.97, y: 0.01449 },
			{ x: 0.98, y: 0.01449 },
			{ x: 0.99, y: 0.01449 },
			{ x: 0, y: 0.02899 },
			{ x: 0.01, y: 0.02899 },
			{ x: 0.02, y: 0.02899 },
			{ x: 0.03, y: 0.02899 },
			{ x: 0.04, y: 0.02899 },
			{ x: 0.05, y: 0.02899 },
			{ x: 0.06, y: 0.02899 },
			{ x: 0.07, y: 0.02899 },
			{ x: 0.08, y: 0.02899 },
			{ x: 0.09, y: 0.02899 },
			{ x: 0.1, y: 0.02899 },
			{ x: 0.11, y: 0.02899 },
			{ x: 0.12, y: 0.02899 },
			{ x: 0.13, y: 0.02899 },
			{ x: 0.14, y: 0.02899 },
			{ x: 0.15, y: 0.02899 },
			{ x: 0.16, y: 0.02899 },
			{ x: 0.17, y: 0.02899 },
			{ x: 0.18, y: 0.02899 },
			{ x: 0.19, y: 0.02899 },
			{ x: 0.2, y: 0.02899 },
			{ x: 0.21, y: 0.02899 },
			{ x: 0.22, y: 0.02899 },
			{ x: 0.23, y: 0.02899 },
			{ x: 0.24, y: 0.02899 },
			{ x: 0.25, y: 0.02899 },
			{ x: 0.26, y: 0.02899 },
			{ x: 0.27, y: 0.02899 },
			{ x: 0.28, y: 0.02899 },
			{ x: 0.29, y: 0.02899 },
			{ x: 0.3, y: 0.02899 },
			{ x: 0.31, y: 0.02899 },
			{ x: 0.32, y: 0.02899 },
			{ x: 0.33, y: 0.02899 },
			{ x: 0.34, y: 0.02899 },
			{ x: 0.35, y: 0.02899 },
			{ x: 0.36, y: 0.02899 },
			{ x: 0.37, y: 0.02899 },
			{ x: 0.38, y: 0.02899 },
			{ x: 0.39, y: 0.02899 },
			{ x: 0.4, y: 0.02899 },
			{ x: 0.41, y: 0.02899 },
			{ x: 0.42, y: 0.02899 },
			{ x: 0.43, y: 0.02899 },
			{ x: 0.44, y: 0.02899 },
			{ x: 0.45, y: 0.02899 },
			{ x: 0.46, y: 0.02899 },
			{ x: 0.47, y: 0.02899 },
			{ x: 0.48, y: 0.02899 },
			{ x: 0.49, y: 0.02899 },
			{ x: 0.5, y: 0.02899 },
			{ x: 0.51, y: 0.02899 },
			{ x: 0.52, y: 0.02899 },
			{ x: 0.53, y: 0.02899 },
			{ x: 0.54, y: 0.02899 },
			{ x: 0.55, y: 0.02899 },
			{ x: 0.56, y: 0.02899 },
			{ x: 0.57, y: 0.02899 },
			{ x: 0.58, y: 0.02899 },
			{ x: 0.59, y: 0.02899 },
			{ x: 0.6, y: 0.02899 },
			{ x: 0.61, y: 0.02899 },
			{ x: 0.62, y: 0.02899 },
			{ x: 0.63, y: 0.02899 },
			{ x: 0.64, y: 0.02899 },
			{ x: 0.65, y: 0.02899 },
			{ x: 0.66, y: 0.02899 },
			{ x: 0.67, y: 0.02899 },
			{ x: 0.68, y: 0.02899 },
			{ x: 0.69, y: 0.02899 },
			{ x: 0.7, y: 0.02899 },
			{ x: 0.71, y: 0.02899 },
			{ x: 0.72, y: 0.02899 },
			{ x: 0.73, y: 0.02899 },
			{ x: 0.74, y: 0.02899 },
			{ x: 0.75, y: 0.02899 },
			{ x: 0.76, y: 0.02899 },
			{ x: 0.77, y: 0.02899 },
			{ x: 0.78, y: 0.02899 },
			{ x: 0.79, y: 0.02899 },
			{ x: 0.8, y: 0.02899 },
			{ x: 0.81, y: 0.02899 },
			{ x: 0.82, y: 0.02899 },
			{ x: 0.83, y: 0.02899 },
			{ x: 0.84, y: 0.02899 },
			{ x: 0.85, y: 0.02899 },
			{ x: 0.86, y: 0.02899 },
			{ x: 0.87, y: 0.02899 },
			{ x: 0.88, y: 0.02899 },
			{ x: 0.89, y: 0.02899 },
			{ x: 0.9, y: 0.02899 },
			{ x: 0.91, y: 0.02899 },
			{ x: 0.92, y: 0.02899 },
			{ x: 0.93, y: 0.02899 },
			{ x: 0.94, y: 0.02899 },
			{ x: 0.95, y: 0.02899 },
			{ x: 0.96, y: 0.02899 },
			{ x: 0.97, y: 0.02899 },
			{ x: 0.98, y: 0.02899 },
			{ x: 0.99, y: 0.02899 },
			{ x: 0, y: 0.04348 },
			{ x: 0.01, y: 0.04348 },
			{ x: 0.02, y: 0.04348 },
			{ x: 0.03, y: 0.04348 },
			{ x: 0.04, y: 0.04348 },
			{ x: 0.05, y: 0.04348 },
			{ x: 0.06, y: 0.04348 },
			{ x: 0.07, y: 0.04348 },
			{ x: 0.08, y: 0.04348 },
			{ x: 0.09, y: 0.04348 },
			{ x: 0.1, y: 0.04348 },
			{ x: 0.11, y: 0.04348 },
			{ x: 0.12, y: 0.04348 },
			{ x: 0.13, y: 0.04348 },
			{ x: 0.14, y: 0.04348 },
			{ x: 0.15, y: 0.04348 },
			{ x: 0.16, y: 0.04348 },
			{ x: 0.17, y: 0.04348 },
			{ x: 0.18, y: 0.04348 },
			{ x: 0.19, y: 0.04348 },
			{ x: 0.2, y: 0.04348 },
			{ x: 0.21, y: 0.04348 },
			{ x: 0.22, y: 0.04348 },
			{ x: 0.23, y: 0.04348 },
			{ x: 0.24, y: 0.04348 },
			{ x: 0.25, y: 0.04348 },
			{ x: 0.26, y: 0.04348 },
			{ x: 0.27, y: 0.04348 },
			{ x: 0.28, y: 0.04348 },
			{ x: 0.29, y: 0.04348 },
			{ x: 0.3, y: 0.04348 },
			{ x: 0.31, y: 0.04348 },
			{ x: 0.32, y: 0.04348 },
			{ x: 0.33, y: 0.04348 },
			{ x: 0.34, y: 0.04348 },
			{ x: 0.35, y: 0.04348 },
			{ x: 0.36, y: 0.04348 },
			{ x: 0.37, y: 0.04348 },
			{ x: 0.38, y: 0.04348 },
			{ x: 0.39, y: 0.04348 },
			{ x: 0.4, y: 0.04348 },
			{ x: 0.41, y: 0.04348 },
			{ x: 0.42, y: 0.04348 },
			{ x: 0.43, y: 0.04348 },
			{ x: 0.44, y: 0.04348 },
			{ x: 0.45, y: 0.04348 },
			{ x: 0.46, y: 0.04348 },
			{ x: 0.47, y: 0.04348 },
			{ x: 0.48, y: 0.04348 },
			{ x: 0.49, y: 0.04348 },
			{ x: 0.5, y: 0.04348 },
			{ x: 0.51, y: 0.04348 },
			{ x: 0.52, y: 0.04348 },
			{ x: 0.53, y: 0.04348 },
			{ x: 0.54, y: 0.04348 },
			{ x: 0.55, y: 0.04348 },
			{ x: 0.56, y: 0.04348 },
			{ x: 0.57, y: 0.04348 },
			{ x: 0.58, y: 0.04348 },
			{ x: 0.59, y: 0.04348 },
			{ x: 0.6, y: 0.04348 },
			{ x: 0.61, y: 0.04348 },
			{ x: 0.62, y: 0.04348 },
			{ x: 0.63, y: 0.04348 },
			{ x: 0.64, y: 0.04348 },
			{ x: 0.65, y: 0.04348 },
			{ x: 0.66, y: 0.04348 },
			{ x: 0.67, y: 0.04348 },
			{ x: 0.68, y: 0.04348 },
			{ x: 0.69, y: 0.04348 },
			{ x: 0.7, y: 0.04348 },
			{ x: 0.71, y: 0.04348 },
			{ x: 0.72, y: 0.04348 },
			{ x: 0.73, y: 0.04348 },
			{ x: 0.74, y: 0.04348 },
			{ x: 0.75, y: 0.04348 },
			{ x: 0.76, y: 0.04348 },
			{ x: 0.77, y: 0.04348 },
			{ x: 0.78, y: 0.04348 },
			{ x: 0.79, y: 0.04348 },
			{ x: 0.8, y: 0.04348 },
			{ x: 0.81, y: 0.04348 },
			{ x: 0.82, y: 0.04348 },
			{ x: 0.83, y: 0.04348 },
			{ x: 0.84, y: 0.04348 },
			{ x: 0.85, y: 0.04348 },
			{ x: 0.86, y: 0.04348 },
			{ x: 0.87, y: 0.04348 },
			{ x: 0.88, y: 0.04348 },
			{ x: 0.89, y: 0.04348 },
			{ x: 0.9, y: 0.04348 },
			{ x: 0.91, y: 0.04348 },
			{ x: 0.92, y: 0.04348 },
			{ x: 0.93, y: 0.04348 },
			{ x: 0.94, y: 0.04348 },
			{ x: 0.95, y: 0.04348 },
			{ x: 0.96, y: 0.04348 },
			{ x: 0.97, y: 0.04348 },
			{ x: 0.98, y: 0.04348 },
			{ x: 0.99, y: 0.04348 },
			{ x: 0, y: 0.05797 },
			{ x: 0.01, y: 0.05797 },
			{ x: 0.02, y: 0.05797 },
			{ x: 0.03, y: 0.05797 },
			{ x: 0.04, y: 0.05797 },
			{ x: 0.05, y: 0.05797 },
			{ x: 0.06, y: 0.05797 },
			{ x: 0.07, y: 0.05797 },
			{ x: 0.08, y: 0.05797 },
			{ x: 0.09, y: 0.05797 },
			{ x: 0.1, y: 0.05797 },
			{ x: 0.11, y: 0.05797 },
			{ x: 0.12, y: 0.05797 },
			{ x: 0.13, y: 0.05797 },
			{ x: 0.14, y: 0.05797 },
			{ x: 0.15, y: 0.05797 },
			{ x: 0.16, y: 0.05797 },
			{ x: 0.17, y: 0.05797 },
			{ x: 0.18, y: 0.05797 },
			{ x: 0.19, y: 0.05797 },
			{ x: 0.2, y: 0.05797 },
			{ x: 0.21, y: 0.05797 },
			{ x: 0.22, y: 0.05797 },
			{ x: 0.23, y: 0.05797 },
			{ x: 0.24, y: 0.05797 },
			{ x: 0.25, y: 0.05797 },
			{ x: 0.26, y: 0.05797 },
			{ x: 0.27, y: 0.05797 },
			{ x: 0.28, y: 0.05797 },
			{ x: 0.29, y: 0.05797 },
			{ x: 0.3, y: 0.05797 },
			{ x: 0.31, y: 0.05797 },
			{ x: 0.32, y: 0.05797 },
			{ x: 0.33, y: 0.05797 },
			{ x: 0.34, y: 0.05797 },
			{ x: 0.35, y: 0.05797 },
			{ x: 0.36, y: 0.05797 },
			{ x: 0.37, y: 0.05797 },
			{ x: 0.38, y: 0.05797 },
			{ x: 0.39, y: 0.05797 },
			{ x: 0.4, y: 0.05797 },
			{ x: 0.41, y: 0.05797 },
			{ x: 0.42, y: 0.05797 },
			{ x: 0.43, y: 0.05797 },
			{ x: 0.44, y: 0.05797 },
			{ x: 0.45, y: 0.05797 },
			{ x: 0.46, y: 0.05797 },
			{ x: 0.47, y: 0.05797 },
			{ x: 0.48, y: 0.05797 },
			{ x: 0.49, y: 0.05797 },
			{ x: 0.5, y: 0.05797 },
			{ x: 0.51, y: 0.05797 },
			{ x: 0.52, y: 0.05797 },
			{ x: 0.53, y: 0.05797 },
			{ x: 0.54, y: 0.05797 },
			{ x: 0.55, y: 0.05797 },
			{ x: 0.56, y: 0.05797 },
			{ x: 0.57, y: 0.05797 },
			{ x: 0.58, y: 0.05797 },
			{ x: 0.59, y: 0.05797 },
			{ x: 0.6, y: 0.05797 },
			{ x: 0.61, y: 0.05797 },
			{ x: 0.62, y: 0.05797 },
			{ x: 0.63, y: 0.05797 },
			{ x: 0.64, y: 0.05797 },
			{ x: 0.65, y: 0.05797 },
			{ x: 0.66, y: 0.05797 },
			{ x: 0.67, y: 0.05797 },
			{ x: 0.68, y: 0.05797 },
			{ x: 0.69, y: 0.05797 },
			{ x: 0.7, y: 0.05797 },
			{ x: 0.71, y: 0.05797 },
			{ x: 0.72, y: 0.05797 },
			{ x: 0.73, y: 0.05797 },
			{ x: 0.74, y: 0.05797 },
			{ x: 0.75, y: 0.05797 },
			{ x: 0.76, y: 0.05797 },
			{ x: 0.77, y: 0.05797 },
			{ x: 0.78, y: 0.05797 },
			{ x: 0.79, y: 0.05797 },
			{ x: 0.8, y: 0.05797 },
			{ x: 0.81, y: 0.05797 },
			{ x: 0.82, y: 0.05797 },
			{ x: 0.83, y: 0.05797 },
			{ x: 0.84, y: 0.05797 },
			{ x: 0.85, y: 0.05797 },
			{ x: 0.86, y: 0.05797 },
			{ x: 0.87, y: 0.05797 },
			{ x: 0.88, y: 0.05797 },
			{ x: 0.89, y: 0.05797 },
			{ x: 0.9, y: 0.05797 },
			{ x: 0.91, y: 0.05797 },
			{ x: 0.92, y: 0.05797 },
			{ x: 0.93, y: 0.05797 },
			{ x: 0.94, y: 0.05797 },
			{ x: 0.95, y: 0.05797 },
			{ x: 0.96, y: 0.05797 },
			{ x: 0.97, y: 0.05797 },
			{ x: 0.98, y: 0.05797 },
			{ x: 0.99, y: 0.05797 },
			{ x: 0, y: 0.07246 },
			{ x: 0.01, y: 0.07246 },
			{ x: 0.02, y: 0.07246 },
			{ x: 0.03, y: 0.07246 },
			{ x: 0.04, y: 0.07246 },
			{ x: 0.05, y: 0.07246 },
			{ x: 0.06, y: 0.07246 },
			{ x: 0.07, y: 0.07246 },
			{ x: 0.08, y: 0.07246 },
			{ x: 0.09, y: 0.07246 },
			{ x: 0.1, y: 0.07246 },
			{ x: 0.11, y: 0.07246 },
			{ x: 0.12, y: 0.07246 },
			{ x: 0.13, y: 0.07246 },
			{ x: 0.14, y: 0.07246 },
			{ x: 0.15, y: 0.07246 },
			{ x: 0.16, y: 0.07246 },
			{ x: 0.17, y: 0.07246 },
			{ x: 0.18, y: 0.07246 },
			{ x: 0.19, y: 0.07246 },
			{ x: 0.2, y: 0.07246 },
			{ x: 0.21, y: 0.07246 },
			{ x: 0.22, y: 0.07246 },
			{ x: 0.23, y: 0.07246 },
			{ x: 0.24, y: 0.07246 },
			{ x: 0.25, y: 0.07246 },
			{ x: 0.26, y: 0.07246 },
			{ x: 0.27, y: 0.07246 },
			{ x: 0.28, y: 0.07246 },
			{ x: 0.29, y: 0.07246 },
			{ x: 0.3, y: 0.07246 },
			{ x: 0.31, y: 0.07246 },
			{ x: 0.32, y: 0.07246 },
			{ x: 0.33, y: 0.07246 },
			{ x: 0.34, y: 0.07246 },
			{ x: 0.35, y: 0.07246 },
			{ x: 0.36, y: 0.07246 },
			{ x: 0.37, y: 0.07246 },
			{ x: 0.38, y: 0.07246 },
			{ x: 0.39, y: 0.07246 },
			{ x: 0.4, y: 0.07246 },
			{ x: 0.41, y: 0.07246 },
			{ x: 0.42, y: 0.07246 },
			{ x: 0.43, y: 0.07246 },
			{ x: 0.44, y: 0.07246 },
			{ x: 0.45, y: 0.07246 },
			{ x: 0.46, y: 0.07246 },
			{ x: 0.47, y: 0.07246 },
			{ x: 0.48, y: 0.07246 },
			{ x: 0.49, y: 0.07246 },
			{ x: 0.5, y: 0.07246 },
			{ x: 0.51, y: 0.07246 },
			{ x: 0.52, y: 0.07246 },
			{ x: 0.53, y: 0.07246 },
			{ x: 0.54, y: 0.07246 },
			{ x: 0.55, y: 0.07246 },
			{ x: 0.56, y: 0.07246 },
			{ x: 0.57, y: 0.07246 },
			{ x: 0.58, y: 0.07246 },
			{ x: 0.59, y: 0.07246 },
			{ x: 0.6, y: 0.07246 },
			{ x: 0.61, y: 0.07246 },
			{ x: 0.62, y: 0.07246 },
			{ x: 0.63, y: 0.07246 },
			{ x: 0.64, y: 0.07246 },
			{ x: 0.65, y: 0.07246 },
			{ x: 0.66, y: 0.07246 },
			{ x: 0.67, y: 0.07246 },
			{ x: 0.68, y: 0.07246 },
			{ x: 0.69, y: 0.07246 },
			{ x: 0.7, y: 0.07246 },
			{ x: 0.71, y: 0.07246 },
			{ x: 0.72, y: 0.07246 },
			{ x: 0.73, y: 0.07246 },
			{ x: 0.74, y: 0.07246 },
			{ x: 0.75, y: 0.07246 },
			{ x: 0.76, y: 0.07246 },
			{ x: 0.77, y: 0.07246 },
			{ x: 0.78, y: 0.07246 },
			{ x: 0.79, y: 0.07246 },
			{ x: 0.8, y: 0.07246 },
			{ x: 0.81, y: 0.07246 },
			{ x: 0.82, y: 0.07246 },
			{ x: 0.83, y: 0.07246 },
			{ x: 0.84, y: 0.07246 },
			{ x: 0.85, y: 0.07246 },
			{ x: 0.86, y: 0.07246 },
			{ x: 0.87, y: 0.07246 },
			{ x: 0.88, y: 0.07246 },
			{ x: 0.89, y: 0.07246 },
			{ x: 0.9, y: 0.07246 },
			{ x: 0.91, y: 0.07246 },
			{ x: 0.92, y: 0.07246 },
			{ x: 0.93, y: 0.07246 },
			{ x: 0.94, y: 0.07246 },
			{ x: 0.95, y: 0.07246 },
			{ x: 0.96, y: 0.07246 },
			{ x: 0.97, y: 0.07246 },
			{ x: 0.98, y: 0.07246 },
			{ x: 0.99, y: 0.07246 },
			{ x: 0, y: 0.08696 },
			{ x: 0.01, y: 0.08696 },
			{ x: 0.02, y: 0.08696 },
			{ x: 0.03, y: 0.08696 },
			{ x: 0.04, y: 0.08696 },
			{ x: 0.05, y: 0.08696 },
			{ x: 0.06, y: 0.08696 },
			{ x: 0.07, y: 0.08696 },
			{ x: 0.08, y: 0.08696 },
			{ x: 0.09, y: 0.08696 },
			{ x: 0.1, y: 0.08696 },
			{ x: 0.11, y: 0.08696 },
			{ x: 0.12, y: 0.08696 },
			{ x: 0.13, y: 0.08696 },
			{ x: 0.14, y: 0.08696 },
			{ x: 0.15, y: 0.08696 },
			{ x: 0.16, y: 0.08696 },
			{ x: 0.17, y: 0.08696 },
			{ x: 0.18, y: 0.08696 },
			{ x: 0.19, y: 0.08696 },
			{ x: 0.2, y: 0.08696 },
			{ x: 0.21, y: 0.08696 },
			{ x: 0.22, y: 0.08696 },
			{ x: 0.23, y: 0.08696 },
			{ x: 0.24, y: 0.08696 },
			{ x: 0.25, y: 0.08696 },
			{ x: 0.26, y: 0.08696 },
			{ x: 0.27, y: 0.08696 },
			{ x: 0.28, y: 0.08696 },
			{ x: 0.29, y: 0.08696 },
			{ x: 0.3, y: 0.08696 },
			{ x: 0.31, y: 0.08696 },
			{ x: 0.32, y: 0.08696 },
			{ x: 0.33, y: 0.08696 },
			{ x: 0.34, y: 0.08696 },
			{ x: 0.35, y: 0.08696 },
			{ x: 0.36, y: 0.08696 },
			{ x: 0.37, y: 0.08696 },
			{ x: 0.38, y: 0.08696 },
			{ x: 0.39, y: 0.08696 },
			{ x: 0.4, y: 0.08696 },
			{ x: 0.41, y: 0.08696 },
			{ x: 0.42, y: 0.08696 },
			{ x: 0.43, y: 0.08696 },
			{ x: 0.44, y: 0.08696 },
			{ x: 0.45, y: 0.08696 },
			{ x: 0.46, y: 0.08696 },
			{ x: 0.47, y: 0.08696 },
			{ x: 0.48, y: 0.08696 },
			{ x: 0.49, y: 0.08696 },
			{ x: 0.5, y: 0.08696 },
			{ x: 0.51, y: 0.08696 },
			{ x: 0.52, y: 0.08696 },
			{ x: 0.53, y: 0.08696 },
			{ x: 0.54, y: 0.08696 },
			{ x: 0.55, y: 0.08696 },
			{ x: 0.56, y: 0.08696 },
			{ x: 0.57, y: 0.08696 },
			{ x: 0.58, y: 0.08696 },
			{ x: 0.59, y: 0.08696 },
			{ x: 0.6, y: 0.08696 },
			{ x: 0.61, y: 0.08696 },
			{ x: 0.62, y: 0.08696 },
			{ x: 0.63, y: 0.08696 },
			{ x: 0.64, y: 0.08696 },
			{ x: 0.65, y: 0.08696 },
			{ x: 0.66, y: 0.08696 },
			{ x: 0.67, y: 0.08696 },
			{ x: 0.68, y: 0.08696 },
			{ x: 0.69, y: 0.08696 },
			{ x: 0.7, y: 0.08696 },
			{ x: 0.71, y: 0.08696 },
			{ x: 0.72, y: 0.08696 },
			{ x: 0.73, y: 0.08696 },
			{ x: 0.74, y: 0.08696 },
			{ x: 0.75, y: 0.08696 },
			{ x: 0.76, y: 0.08696 },
			{ x: 0.77, y: 0.08696 },
			{ x: 0.78, y: 0.08696 },
			{ x: 0.79, y: 0.08696 },
			{ x: 0.8, y: 0.08696 },
			{ x: 0.81, y: 0.08696 },
			{ x: 0.82, y: 0.08696 },
			{ x: 0.83, y: 0.08696 },
			{ x: 0.84, y: 0.08696 },
			{ x: 0.85, y: 0.08696 },
			{ x: 0.86, y: 0.08696 },
			{ x: 0.87, y: 0.08696 },
			{ x: 0.88, y: 0.08696 },
			{ x: 0.89, y: 0.08696 },
			{ x: 0.9, y: 0.08696 },
			{ x: 0.91, y: 0.08696 },
			{ x: 0.92, y: 0.08696 },
			{ x: 0.93, y: 0.08696 },
			{ x: 0.94, y: 0.08696 },
			{ x: 0.95, y: 0.08696 },
			{ x: 0.96, y: 0.08696 },
			{ x: 0.97, y: 0.08696 },
			{ x: 0.98, y: 0.08696 },
			{ x: 0.99, y: 0.08696 },
			{ x: 0, y: 0.10145 },
			{ x: 0.01, y: 0.10145 },
			{ x: 0.02, y: 0.10145 },
			{ x: 0.03, y: 0.10145 },
			{ x: 0.04, y: 0.10145 },
			{ x: 0.05, y: 0.10145 },
			{ x: 0.06, y: 0.10145 },
			{ x: 0.07, y: 0.10145 },
			{ x: 0.08, y: 0.10145 },
			{ x: 0.09, y: 0.10145 },
			{ x: 0.1, y: 0.10145 },
			{ x: 0.11, y: 0.10145 },
			{ x: 0.12, y: 0.10145 },
			{ x: 0.13, y: 0.10145 },
			{ x: 0.14, y: 0.10145 },
			{ x: 0.15, y: 0.10145 },
			{ x: 0.16, y: 0.10145 },
			{ x: 0.17, y: 0.10145 },
			{ x: 0.18, y: 0.10145 },
			{ x: 0.19, y: 0.10145 },
			{ x: 0.2, y: 0.10145 },
			{ x: 0.21, y: 0.10145 },
			{ x: 0.22, y: 0.10145 },
			{ x: 0.23, y: 0.10145 },
			{ x: 0.24, y: 0.10145 },
			{ x: 0.25, y: 0.10145 },
			{ x: 0.26, y: 0.10145 },
			{ x: 0.27, y: 0.10145 },
			{ x: 0.28, y: 0.10145 },
			{ x: 0.29, y: 0.10145 },
			{ x: 0.3, y: 0.10145 },
			{ x: 0.31, y: 0.10145 },
			{ x: 0.32, y: 0.10145 },
			{ x: 0.33, y: 0.10145 },
			{ x: 0.34, y: 0.10145 },
			{ x: 0.35, y: 0.10145 },
			{ x: 0.36, y: 0.10145 },
			{ x: 0.37, y: 0.10145 },
			{ x: 0.38, y: 0.10145 },
			{ x: 0.39, y: 0.10145 },
			{ x: 0.4, y: 0.10145 },
			{ x: 0.41, y: 0.10145 },
			{ x: 0.42, y: 0.10145 },
			{ x: 0.43, y: 0.10145 },
			{ x: 0.44, y: 0.10145 },
			{ x: 0.45, y: 0.10145 },
			{ x: 0.46, y: 0.10145 },
			{ x: 0.47, y: 0.10145 },
			{ x: 0.48, y: 0.10145 },
			{ x: 0.49, y: 0.10145 },
			{ x: 0.5, y: 0.10145 },
			{ x: 0.51, y: 0.10145 },
			{ x: 0.52, y: 0.10145 },
			{ x: 0.53, y: 0.10145 },
			{ x: 0.54, y: 0.10145 },
			{ x: 0.55, y: 0.10145 },
			{ x: 0.56, y: 0.10145 },
			{ x: 0.57, y: 0.10145 },
			{ x: 0.58, y: 0.10145 },
			{ x: 0.59, y: 0.10145 },
			{ x: 0.6, y: 0.10145 },
			{ x: 0.61, y: 0.10145 },
			{ x: 0.62, y: 0.10145 },
			{ x: 0.63, y: 0.10145 },
			{ x: 0.64, y: 0.10145 },
			{ x: 0.65, y: 0.10145 },
			{ x: 0.66, y: 0.10145 },
			{ x: 0.67, y: 0.10145 },
			{ x: 0.68, y: 0.10145 },
			{ x: 0.69, y: 0.10145 },
			{ x: 0.7, y: 0.10145 },
			{ x: 0.71, y: 0.10145 },
			{ x: 0.72, y: 0.10145 },
			{ x: 0.73, y: 0.10145 },
			{ x: 0.74, y: 0.10145 },
			{ x: 0.75, y: 0.10145 },
			{ x: 0.76, y: 0.10145 },
			{ x: 0.77, y: 0.10145 },
			{ x: 0.78, y: 0.10145 },
			{ x: 0.79, y: 0.10145 },
			{ x: 0.8, y: 0.10145 },
			{ x: 0.81, y: 0.10145 },
			{ x: 0.82, y: 0.10145 },
			{ x: 0.83, y: 0.10145 },
			{ x: 0.84, y: 0.10145 },
			{ x: 0.85, y: 0.10145 },
			{ x: 0.86, y: 0.10145 },
			{ x: 0.87, y: 0.10145 },
			{ x: 0.88, y: 0.10145 },
			{ x: 0.89, y: 0.10145 },
			{ x: 0.9, y: 0.10145 },
			{ x: 0.91, y: 0.10145 },
			{ x: 0.92, y: 0.10145 },
			{ x: 0.93, y: 0.10145 },
			{ x: 0.94, y: 0.10145 },
			{ x: 0.95, y: 0.10145 },
			{ x: 0.96, y: 0.10145 },
			{ x: 0.97, y: 0.10145 },
			{ x: 0.98, y: 0.10145 },
			{ x: 0.99, y: 0.10145 },
			{ x: 0, y: 0.11594 },
			{ x: 0.01, y: 0.11594 },
			{ x: 0.02, y: 0.11594 },
			{ x: 0.03, y: 0.11594 },
			{ x: 0.04, y: 0.11594 },
			{ x: 0.05, y: 0.11594 },
			{ x: 0.06, y: 0.11594 },
			{ x: 0.07, y: 0.11594 },
			{ x: 0.08, y: 0.11594 },
			{ x: 0.09, y: 0.11594 },
			{ x: 0.1, y: 0.11594 },
			{ x: 0.11, y: 0.11594 },
			{ x: 0.12, y: 0.11594 },
			{ x: 0.13, y: 0.11594 },
			{ x: 0.14, y: 0.11594 },
			{ x: 0.15, y: 0.11594 },
			{ x: 0.16, y: 0.11594 },
			{ x: 0.17, y: 0.11594 },
			{ x: 0.18, y: 0.11594 },
			{ x: 0.19, y: 0.11594 },
			{ x: 0.2, y: 0.11594 },
			{ x: 0.21, y: 0.11594 },
			{ x: 0.22, y: 0.11594 },
			{ x: 0.23, y: 0.11594 },
			{ x: 0.24, y: 0.11594 },
			{ x: 0.25, y: 0.11594 },
			{ x: 0.26, y: 0.11594 },
			{ x: 0.27, y: 0.11594 },
			{ x: 0.28, y: 0.11594 },
			{ x: 0.29, y: 0.11594 },
			{ x: 0.3, y: 0.11594 },
			{ x: 0.31, y: 0.11594 },
			{ x: 0.32, y: 0.11594 },
			{ x: 0.33, y: 0.11594 },
			{ x: 0.34, y: 0.11594 },
			{ x: 0.35, y: 0.11594 },
			{ x: 0.36, y: 0.11594 },
			{ x: 0.37, y: 0.11594 },
			{ x: 0.38, y: 0.11594 },
			{ x: 0.39, y: 0.11594 },
			{ x: 0.4, y: 0.11594 },
			{ x: 0.41, y: 0.11594 },
			{ x: 0.42, y: 0.11594 },
			{ x: 0.43, y: 0.11594 },
			{ x: 0.44, y: 0.11594 },
			{ x: 0.45, y: 0.11594 },
			{ x: 0.46, y: 0.11594 },
			{ x: 0.47, y: 0.11594 },
			{ x: 0.48, y: 0.11594 },
			{ x: 0.49, y: 0.11594 },
			{ x: 0.5, y: 0.11594 },
			{ x: 0.51, y: 0.11594 },
			{ x: 0.52, y: 0.11594 },
			{ x: 0.53, y: 0.11594 },
			{ x: 0.54, y: 0.11594 },
			{ x: 0.55, y: 0.11594 },
			{ x: 0.56, y: 0.11594 },
			{ x: 0.57, y: 0.11594 },
			{ x: 0.58, y: 0.11594 },
			{ x: 0.59, y: 0.11594 },
			{ x: 0.6, y: 0.11594 },
			{ x: 0.61, y: 0.11594 },
			{ x: 0.62, y: 0.11594 },
			{ x: 0.63, y: 0.11594 },
			{ x: 0.64, y: 0.11594 },
			{ x: 0.65, y: 0.11594 },
			{ x: 0.66, y: 0.11594 },
			{ x: 0.67, y: 0.11594 },
			{ x: 0.68, y: 0.11594 },
			{ x: 0.69, y: 0.11594 },
			{ x: 0.7, y: 0.11594 },
			{ x: 0.71, y: 0.11594 },
			{ x: 0.72, y: 0.11594 },
			{ x: 0.73, y: 0.11594 },
			{ x: 0.74, y: 0.11594 },
			{ x: 0.75, y: 0.11594 },
			{ x: 0.76, y: 0.11594 },
			{ x: 0.77, y: 0.11594 },
			{ x: 0.78, y: 0.11594 },
			{ x: 0.79, y: 0.11594 },
			{ x: 0.8, y: 0.11594 },
			{ x: 0.81, y: 0.11594 },
			{ x: 0.82, y: 0.11594 },
			{ x: 0.83, y: 0.11594 },
			{ x: 0.84, y: 0.11594 },
			{ x: 0.85, y: 0.11594 },
			{ x: 0.86, y: 0.11594 },
			{ x: 0.87, y: 0.11594 },
			{ x: 0.88, y: 0.11594 },
			{ x: 0.89, y: 0.11594 },
			{ x: 0.9, y: 0.11594 },
			{ x: 0.91, y: 0.11594 },
			{ x: 0.92, y: 0.11594 },
			{ x: 0.93, y: 0.11594 },
			{ x: 0.94, y: 0.11594 },
			{ x: 0.95, y: 0.11594 },
			{ x: 0.96, y: 0.11594 },
			{ x: 0.97, y: 0.11594 },
			{ x: 0.98, y: 0.11594 },
			{ x: 0.99, y: 0.11594 },
			{ x: 0, y: 0.13043 },
			{ x: 0.01, y: 0.13043 },
			{ x: 0.02, y: 0.13043 },
			{ x: 0.03, y: 0.13043 },
			{ x: 0.04, y: 0.13043 },
			{ x: 0.05, y: 0.13043 },
			{ x: 0.06, y: 0.13043 },
			{ x: 0.07, y: 0.13043 },
			{ x: 0.08, y: 0.13043 },
			{ x: 0.09, y: 0.13043 },
			{ x: 0.1, y: 0.13043 },
			{ x: 0.11, y: 0.13043 },
			{ x: 0.12, y: 0.13043 },
			{ x: 0.13, y: 0.13043 },
			{ x: 0.14, y: 0.13043 },
			{ x: 0.15, y: 0.13043 },
			{ x: 0.16, y: 0.13043 },
			{ x: 0.17, y: 0.13043 },
			{ x: 0.18, y: 0.13043 },
			{ x: 0.19, y: 0.13043 },
			{ x: 0.2, y: 0.13043 },
			{ x: 0.21, y: 0.13043 },
			{ x: 0.22, y: 0.13043 },
			{ x: 0.23, y: 0.13043 },
			{ x: 0.24, y: 0.13043 },
			{ x: 0.25, y: 0.13043 },
			{ x: 0.26, y: 0.13043 },
			{ x: 0.27, y: 0.13043 },
			{ x: 0.28, y: 0.13043 },
			{ x: 0.29, y: 0.13043 },
			{ x: 0.3, y: 0.13043 },
			{ x: 0.31, y: 0.13043 },
			{ x: 0.32, y: 0.13043 },
			{ x: 0.33, y: 0.13043 },
			{ x: 0.34, y: 0.13043 },
			{ x: 0.35, y: 0.13043 },
			{ x: 0.36, y: 0.13043 },
			{ x: 0.37, y: 0.13043 },
			{ x: 0.38, y: 0.13043 },
			{ x: 0.39, y: 0.13043 },
			{ x: 0.4, y: 0.13043 },
			{ x: 0.41, y: 0.13043 },
			{ x: 0.42, y: 0.13043 },
			{ x: 0.43, y: 0.13043 },
			{ x: 0.44, y: 0.13043 },
			{ x: 0.45, y: 0.13043 },
			{ x: 0.46, y: 0.13043 },
			{ x: 0.47, y: 0.13043 },
			{ x: 0.48, y: 0.13043 },
			{ x: 0.49, y: 0.13043 },
			{ x: 0.5, y: 0.13043 },
			{ x: 0.51, y: 0.13043 },
			{ x: 0.52, y: 0.13043 },
			{ x: 0.53, y: 0.13043 },
			{ x: 0.54, y: 0.13043 },
			{ x: 0.55, y: 0.13043 },
			{ x: 0.56, y: 0.13043 },
			{ x: 0.57, y: 0.13043 },
			{ x: 0.58, y: 0.13043 },
			{ x: 0.59, y: 0.13043 },
			{ x: 0.6, y: 0.13043 },
			{ x: 0.61, y: 0.13043 },
			{ x: 0.62, y: 0.13043 },
			{ x: 0.63, y: 0.13043 },
			{ x: 0.64, y: 0.13043 },
			{ x: 0.65, y: 0.13043 },
			{ x: 0.66, y: 0.13043 },
			{ x: 0.67, y: 0.13043 },
			{ x: 0.68, y: 0.13043 },
			{ x: 0.69, y: 0.13043 },
			{ x: 0.7, y: 0.13043 },
			{ x: 0.71, y: 0.13043 },
			{ x: 0.72, y: 0.13043 },
			{ x: 0.73, y: 0.13043 },
			{ x: 0.74, y: 0.13043 },
			{ x: 0.75, y: 0.13043 },
			{ x: 0.76, y: 0.13043 },
			{ x: 0.77, y: 0.13043 },
			{ x: 0.78, y: 0.13043 },
			{ x: 0.79, y: 0.13043 },
			{ x: 0.8, y: 0.13043 },
			{ x: 0.81, y: 0.13043 },
			{ x: 0.82, y: 0.13043 },
			{ x: 0.83, y: 0.13043 },
			{ x: 0.84, y: 0.13043 },
			{ x: 0.85, y: 0.13043 },
			{ x: 0.86, y: 0.13043 },
			{ x: 0.87, y: 0.13043 },
			{ x: 0.88, y: 0.13043 },
			{ x: 0.89, y: 0.13043 },
			{ x: 0.9, y: 0.13043 },
			{ x: 0.91, y: 0.13043 },
			{ x: 0.92, y: 0.13043 },
			{ x: 0.93, y: 0.13043 },
			{ x: 0.94, y: 0.13043 },
			{ x: 0.95, y: 0.13043 },
			{ x: 0.96, y: 0.13043 },
			{ x: 0.97, y: 0.13043 },
			{ x: 0.98, y: 0.13043 },
			{ x: 0.99, y: 0.13043 },
			{ x: 0, y: 0.14493 },
			{ x: 0.01, y: 0.14493 },
			{ x: 0.02, y: 0.14493 },
			{ x: 0.03, y: 0.14493 },
			{ x: 0.04, y: 0.14493 },
			{ x: 0.05, y: 0.14493 },
			{ x: 0.06, y: 0.14493 },
			{ x: 0.07, y: 0.14493 },
			{ x: 0.08, y: 0.14493 },
			{ x: 0.09, y: 0.14493 },
			{ x: 0.1, y: 0.14493 },
			{ x: 0.11, y: 0.14493 },
			{ x: 0.12, y: 0.14493 },
			{ x: 0.13, y: 0.14493 },
			{ x: 0.14, y: 0.14493 },
			{ x: 0.15, y: 0.14493 },
			{ x: 0.16, y: 0.14493 },
			{ x: 0.17, y: 0.14493 },
			{ x: 0.18, y: 0.14493 },
			{ x: 0.19, y: 0.14493 },
			{ x: 0.2, y: 0.14493 },
			{ x: 0.21, y: 0.14493 },
			{ x: 0.22, y: 0.14493 },
			{ x: 0.23, y: 0.14493 },
			{ x: 0.24, y: 0.14493 },
			{ x: 0.25, y: 0.14493 },
			{ x: 0.26, y: 0.14493 },
			{ x: 0.27, y: 0.14493 },
			{ x: 0.28, y: 0.14493 },
			{ x: 0.29, y: 0.14493 },
			{ x: 0.3, y: 0.14493 },
			{ x: 0.31, y: 0.14493 },
			{ x: 0.32, y: 0.14493 },
			{ x: 0.33, y: 0.14493 },
			{ x: 0.34, y: 0.14493 },
			{ x: 0.35, y: 0.14493 },
			{ x: 0.36, y: 0.14493 },
			{ x: 0.37, y: 0.14493 },
			{ x: 0.38, y: 0.14493 },
			{ x: 0.39, y: 0.14493 },
			{ x: 0.4, y: 0.14493 },
			{ x: 0.41, y: 0.14493 },
			{ x: 0.42, y: 0.14493 },
			{ x: 0.43, y: 0.14493 },
			{ x: 0.44, y: 0.14493 },
			{ x: 0.45, y: 0.14493 },
			{ x: 0.46, y: 0.14493 },
			{ x: 0.47, y: 0.14493 },
			{ x: 0.48, y: 0.14493 },
			{ x: 0.49, y: 0.14493 },
			{ x: 0.5, y: 0.14493 },
			{ x: 0.51, y: 0.14493 },
			{ x: 0.52, y: 0.14493 },
			{ x: 0.53, y: 0.14493 },
			{ x: 0.54, y: 0.14493 },
			{ x: 0.55, y: 0.14493 },
			{ x: 0.56, y: 0.14493 },
			{ x: 0.57, y: 0.14493 },
			{ x: 0.58, y: 0.14493 },
			{ x: 0.59, y: 0.14493 },
			{ x: 0.6, y: 0.14493 },
			{ x: 0.61, y: 0.14493 },
			{ x: 0.63, y: 0.14493 },
			{ x: 0.64, y: 0.14493 },
			{ x: 0.65, y: 0.14493 },
			{ x: 0.66, y: 0.14493 },
			{ x: 0.67, y: 0.14493 },
			{ x: 0.68, y: 0.14493 },
			{ x: 0.69, y: 0.14493 },
			{ x: 0.7, y: 0.14493 },
			{ x: 0.71, y: 0.14493 },
			{ x: 0.72, y: 0.14493 },
			{ x: 0.73, y: 0.14493 },
			{ x: 0.74, y: 0.14493 },
			{ x: 0.75, y: 0.14493 },
			{ x: 0.76, y: 0.14493 },
			{ x: 0.77, y: 0.14493 },
			{ x: 0.78, y: 0.14493 },
			{ x: 0.79, y: 0.14493 },
			{ x: 0.8, y: 0.14493 },
			{ x: 0.81, y: 0.14493 },
			{ x: 0.82, y: 0.14493 },
			{ x: 0.83, y: 0.14493 },
			{ x: 0.84, y: 0.14493 },
			{ x: 0.85, y: 0.14493 },
			{ x: 0.86, y: 0.14493 },
			{ x: 0.87, y: 0.14493 },
			{ x: 0.88, y: 0.14493 },
			{ x: 0.89, y: 0.14493 },
			{ x: 0.9, y: 0.14493 },
			{ x: 0.91, y: 0.14493 },
			{ x: 0.92, y: 0.14493 },
			{ x: 0.93, y: 0.14493 },
			{ x: 0.94, y: 0.14493 },
			{ x: 0.95, y: 0.14493 },
			{ x: 0.96, y: 0.14493 },
			{ x: 0.97, y: 0.14493 },
			{ x: 0.98, y: 0.14493 },
			{ x: 0.99, y: 0.14493 },
			{ x: 0, y: 0.15942 },
			{ x: 0.01, y: 0.15942 },
			{ x: 0.02, y: 0.15942 },
			{ x: 0.03, y: 0.15942 },
			{ x: 0.04, y: 0.15942 },
			{ x: 0.05, y: 0.15942 },
			{ x: 0.06, y: 0.15942 },
			{ x: 0.07, y: 0.15942 },
			{ x: 0.08, y: 0.15942 },
			{ x: 0.09, y: 0.15942 },
			{ x: 0.1, y: 0.15942 },
			{ x: 0.11, y: 0.15942 },
			{ x: 0.12, y: 0.15942 },
			{ x: 0.13, y: 0.15942 },
			{ x: 0.14, y: 0.15942 },
			{ x: 0.15, y: 0.15942 },
			{ x: 0.16, y: 0.15942 },
			{ x: 0.17, y: 0.15942 },
			{ x: 0.18, y: 0.15942 },
			{ x: 0.19, y: 0.15942 },
			{ x: 0.2, y: 0.15942 },
			{ x: 0.21, y: 0.15942 },
			{ x: 0.22, y: 0.15942 },
			{ x: 0.23, y: 0.15942 },
			{ x: 0.24, y: 0.15942 },
			{ x: 0.25, y: 0.15942 },
			{ x: 0.26, y: 0.15942 },
			{ x: 0.27, y: 0.15942 },
			{ x: 0.28, y: 0.15942 },
			{ x: 0.29, y: 0.15942 },
			{ x: 0.3, y: 0.15942 },
			{ x: 0.31, y: 0.15942 },
			{ x: 0.32, y: 0.15942 },
			{ x: 0.33, y: 0.15942 },
			{ x: 0.34, y: 0.15942 },
			{ x: 0.35, y: 0.15942 },
			{ x: 0.36, y: 0.15942 },
			{ x: 0.37, y: 0.15942 },
			{ x: 0.38, y: 0.15942 },
			{ x: 0.39, y: 0.15942 },
			{ x: 0.4, y: 0.15942 },
			{ x: 0.41, y: 0.15942 },
			{ x: 0.42, y: 0.15942 },
			{ x: 0.43, y: 0.15942 },
			{ x: 0.44, y: 0.15942 },
			{ x: 0.45, y: 0.15942 },
			{ x: 0.46, y: 0.15942 },
			{ x: 0.47, y: 0.15942 },
			{ x: 0.48, y: 0.15942 },
			{ x: 0.49, y: 0.15942 },
			{ x: 0.5, y: 0.15942 },
			{ x: 0.51, y: 0.15942 },
			{ x: 0.52, y: 0.15942 },
			{ x: 0.53, y: 0.15942 },
			{ x: 0.54, y: 0.15942 },
			{ x: 0.55, y: 0.15942 },
			{ x: 0.56, y: 0.15942 },
			{ x: 0.57, y: 0.15942 },
			{ x: 0.58, y: 0.15942 },
			{ x: 0.59, y: 0.15942 },
			{ x: 0.6, y: 0.15942 },
			{ x: 0.61, y: 0.15942 },
			{ x: 0.62, y: 0.15942 },
			{ x: 0.63, y: 0.15942 },
			{ x: 0.64, y: 0.15942 },
			{ x: 0.65, y: 0.15942 },
			{ x: 0.66, y: 0.15942 },
			{ x: 0.67, y: 0.15942 },
			{ x: 0.68, y: 0.15942 },
			{ x: 0.69, y: 0.15942 },
			{ x: 0.7, y: 0.15942 },
			{ x: 0.71, y: 0.15942 },
			{ x: 0.72, y: 0.15942 },
			{ x: 0.73, y: 0.15942 },
			{ x: 0.74, y: 0.15942 },
			{ x: 0.75, y: 0.15942 },
			{ x: 0.76, y: 0.15942 },
			{ x: 0.77, y: 0.15942 },
			{ x: 0.78, y: 0.15942 },
			{ x: 0.79, y: 0.15942 },
			{ x: 0.8, y: 0.15942 },
			{ x: 0.81, y: 0.15942 },
			{ x: 0.82, y: 0.15942 },
			{ x: 0.83, y: 0.15942 },
			{ x: 0.84, y: 0.15942 },
			{ x: 0.85, y: 0.15942 },
			{ x: 0.86, y: 0.15942 },
			{ x: 0.87, y: 0.15942 },
			{ x: 0.88, y: 0.15942 },
			{ x: 0.89, y: 0.15942 },
			{ x: 0.9, y: 0.15942 },
			{ x: 0.91, y: 0.15942 },
			{ x: 0.92, y: 0.15942 },
			{ x: 0.93, y: 0.15942 },
			{ x: 0.94, y: 0.15942 },
			{ x: 0.95, y: 0.15942 },
			{ x: 0.96, y: 0.15942 },
			{ x: 0.97, y: 0.15942 },
			{ x: 0.98, y: 0.15942 },
			{ x: 0.99, y: 0.15942 },
			{ x: 0, y: 0.17391 },
			{ x: 0.01, y: 0.17391 },
			{ x: 0.02, y: 0.17391 },
			{ x: 0.03, y: 0.17391 },
			{ x: 0.04, y: 0.17391 },
			{ x: 0.05, y: 0.17391 },
			{ x: 0.06, y: 0.17391 },
			{ x: 0.07, y: 0.17391 },
			{ x: 0.08, y: 0.17391 },
			{ x: 0.09, y: 0.17391 },
			{ x: 0.1, y: 0.17391 },
			{ x: 0.11, y: 0.17391 },
			{ x: 0.12, y: 0.17391 },
			{ x: 0.13, y: 0.17391 },
			{ x: 0.14, y: 0.17391 },
			{ x: 0.15, y: 0.17391 },
			{ x: 0.16, y: 0.17391 },
			{ x: 0.17, y: 0.17391 },
			{ x: 0.18, y: 0.17391 },
			{ x: 0.19, y: 0.17391 },
			{ x: 0.2, y: 0.17391 },
			{ x: 0.21, y: 0.17391 },
			{ x: 0.22, y: 0.17391 },
			{ x: 0.23, y: 0.17391 },
			{ x: 0.24, y: 0.17391 },
			{ x: 0.25, y: 0.17391 },
			{ x: 0.26, y: 0.17391 },
			{ x: 0.27, y: 0.17391 },
			{ x: 0.28, y: 0.17391 },
			{ x: 0.29, y: 0.17391 },
			{ x: 0.3, y: 0.17391 },
			{ x: 0.31, y: 0.17391 },
			{ x: 0.32, y: 0.17391 },
			{ x: 0.33, y: 0.17391 },
			{ x: 0.34, y: 0.17391 },
			{ x: 0.35, y: 0.17391 },
			{ x: 0.36, y: 0.17391 },
			{ x: 0.37, y: 0.17391 },
			{ x: 0.38, y: 0.17391 },
			{ x: 0.39, y: 0.17391 },
			{ x: 0.4, y: 0.17391 },
			{ x: 0.41, y: 0.17391 },
			{ x: 0.42, y: 0.17391 },
			{ x: 0.43, y: 0.17391 },
			{ x: 0.44, y: 0.17391 },
			{ x: 0.45, y: 0.17391 },
			{ x: 0.46, y: 0.17391 },
			{ x: 0.47, y: 0.17391 },
			{ x: 0.48, y: 0.17391 },
			{ x: 0.49, y: 0.17391 },
			{ x: 0.5, y: 0.17391 },
			{ x: 0.51, y: 0.17391 },
			{ x: 0.52, y: 0.17391 },
			{ x: 0.53, y: 0.17391 },
			{ x: 0.54, y: 0.17391 },
			{ x: 0.55, y: 0.17391 },
			{ x: 0.56, y: 0.17391 },
			{ x: 0.57, y: 0.17391 },
			{ x: 0.58, y: 0.17391 },
			{ x: 0.59, y: 0.17391 },
			{ x: 0.6, y: 0.17391 },
			{ x: 0.61, y: 0.17391 },
			{ x: 0.62, y: 0.17391 },
			{ x: 0.63, y: 0.17391 },
			{ x: 0.64, y: 0.17391 },
			{ x: 0.65, y: 0.17391 },
			{ x: 0.66, y: 0.17391 },
			{ x: 0.67, y: 0.17391 },
			{ x: 0.68, y: 0.17391 },
			{ x: 0.69, y: 0.17391 },
			{ x: 0.7, y: 0.17391 },
			{ x: 0.71, y: 0.17391 },
			{ x: 0.72, y: 0.17391 },
			{ x: 0.73, y: 0.17391 },
			{ x: 0.74, y: 0.17391 },
			{ x: 0.75, y: 0.17391 },
			{ x: 0.76, y: 0.17391 },
			{ x: 0.77, y: 0.17391 },
			{ x: 0.78, y: 0.17391 },
			{ x: 0.79, y: 0.17391 },
			{ x: 0.8, y: 0.17391 },
			{ x: 0.81, y: 0.17391 },
			{ x: 0.82, y: 0.17391 },
			{ x: 0.83, y: 0.17391 },
			{ x: 0.84, y: 0.17391 },
			{ x: 0.85, y: 0.17391 },
			{ x: 0.86, y: 0.17391 },
			{ x: 0.87, y: 0.17391 },
			{ x: 0.88, y: 0.17391 },
			{ x: 0.89, y: 0.17391 },
			{ x: 0.9, y: 0.17391 },
			{ x: 0.91, y: 0.17391 },
			{ x: 0.92, y: 0.17391 },
			{ x: 0.93, y: 0.17391 },
			{ x: 0.94, y: 0.17391 },
			{ x: 0.95, y: 0.17391 },
			{ x: 0.96, y: 0.17391 },
			{ x: 0.97, y: 0.17391 },
			{ x: 0.98, y: 0.17391 },
			{ x: 0.99, y: 0.17391 },
			{ x: 0, y: 0.18841 },
			{ x: 0.01, y: 0.18841 },
			{ x: 0.02, y: 0.18841 },
			{ x: 0.03, y: 0.18841 },
			{ x: 0.04, y: 0.18841 },
			{ x: 0.05, y: 0.18841 },
			{ x: 0.06, y: 0.18841 },
			{ x: 0.07, y: 0.18841 },
			{ x: 0.08, y: 0.18841 },
			{ x: 0.09, y: 0.18841 },
			{ x: 0.1, y: 0.18841 },
			{ x: 0.11, y: 0.18841 },
			{ x: 0.12, y: 0.18841 },
			{ x: 0.13, y: 0.18841 },
			{ x: 0.14, y: 0.18841 },
			{ x: 0.15, y: 0.18841 },
			{ x: 0.16, y: 0.18841 },
			{ x: 0.17, y: 0.18841 },
			{ x: 0.18, y: 0.18841 },
			{ x: 0.19, y: 0.18841 },
			{ x: 0.2, y: 0.18841 },
			{ x: 0.21, y: 0.18841 },
			{ x: 0.22, y: 0.18841 },
			{ x: 0.23, y: 0.18841 },
			{ x: 0.24, y: 0.18841 },
			{ x: 0.25, y: 0.18841 },
			{ x: 0.26, y: 0.18841 },
			{ x: 0.27, y: 0.18841 },
			{ x: 0.28, y: 0.18841 },
			{ x: 0.29, y: 0.18841 },
			{ x: 0.3, y: 0.18841 },
			{ x: 0.31, y: 0.18841 },
			{ x: 0.32, y: 0.18841 },
			{ x: 0.33, y: 0.18841 },
			{ x: 0.34, y: 0.18841 },
			{ x: 0.35, y: 0.18841 },
			{ x: 0.36, y: 0.18841 },
			{ x: 0.37, y: 0.18841 },
			{ x: 0.38, y: 0.18841 },
			{ x: 0.39, y: 0.18841 },
			{ x: 0.4, y: 0.18841 },
			{ x: 0.41, y: 0.18841 },
			{ x: 0.42, y: 0.18841 },
			{ x: 0.43, y: 0.18841 },
			{ x: 0.44, y: 0.18841 },
			{ x: 0.45, y: 0.18841 },
			{ x: 0.46, y: 0.18841 },
			{ x: 0.47, y: 0.18841 },
			{ x: 0.48, y: 0.18841 },
			{ x: 0.49, y: 0.18841 },
			{ x: 0.5, y: 0.18841 },
			{ x: 0.51, y: 0.18841 },
			{ x: 0.52, y: 0.18841 },
			{ x: 0.53, y: 0.18841 },
			{ x: 0.54, y: 0.18841 },
			{ x: 0.55, y: 0.18841 },
			{ x: 0.56, y: 0.18841 },
			{ x: 0.57, y: 0.18841 },
			{ x: 0.58, y: 0.18841 },
			{ x: 0.59, y: 0.18841 },
			{ x: 0.6, y: 0.18841 },
			{ x: 0.61, y: 0.18841 },
			{ x: 0.62, y: 0.18841 },
			{ x: 0.63, y: 0.18841 },
			{ x: 0.64, y: 0.18841 },
			{ x: 0.65, y: 0.18841 },
			{ x: 0.66, y: 0.18841 },
			{ x: 0.67, y: 0.18841 },
			{ x: 0.68, y: 0.18841 },
			{ x: 0.69, y: 0.18841 },
			{ x: 0.7, y: 0.18841 },
			{ x: 0.71, y: 0.18841 },
			{ x: 0.72, y: 0.18841 },
			{ x: 0.73, y: 0.18841 },
			{ x: 0.74, y: 0.18841 },
			{ x: 0.75, y: 0.18841 },
			{ x: 0.76, y: 0.18841 },
			{ x: 0.77, y: 0.18841 },
			{ x: 0.78, y: 0.18841 },
			{ x: 0.79, y: 0.18841 },
			{ x: 0.8, y: 0.18841 },
			{ x: 0.81, y: 0.18841 },
			{ x: 0.82, y: 0.18841 },
			{ x: 0.83, y: 0.18841 },
			{ x: 0.84, y: 0.18841 },
			{ x: 0.85, y: 0.18841 },
			{ x: 0.86, y: 0.18841 },
			{ x: 0.87, y: 0.18841 },
			{ x: 0.88, y: 0.18841 },
			{ x: 0.89, y: 0.18841 },
			{ x: 0.9, y: 0.18841 },
			{ x: 0.91, y: 0.18841 },
			{ x: 0.92, y: 0.18841 },
			{ x: 0.93, y: 0.18841 },
			{ x: 0.94, y: 0.18841 },
			{ x: 0.95, y: 0.18841 },
			{ x: 0.96, y: 0.18841 },
			{ x: 0.97, y: 0.18841 },
			{ x: 0.98, y: 0.18841 },
			{ x: 0.99, y: 0.18841 },
			{ x: 0, y: 0.2029 },
			{ x: 0.01, y: 0.2029 },
			{ x: 0.02, y: 0.2029 },
			{ x: 0.03, y: 0.2029 },
			{ x: 0.04, y: 0.2029 },
			{ x: 0.05, y: 0.2029 },
			{ x: 0.06, y: 0.2029 },
			{ x: 0.07, y: 0.2029 },
			{ x: 0.08, y: 0.2029 },
			{ x: 0.09, y: 0.2029 },
			{ x: 0.1, y: 0.2029 },
			{ x: 0.11, y: 0.2029 },
			{ x: 0.12, y: 0.2029 },
			{ x: 0.13, y: 0.2029 },
			{ x: 0.14, y: 0.2029 },
			{ x: 0.15, y: 0.2029 },
			{ x: 0.16, y: 0.2029 },
			{ x: 0.17, y: 0.2029 },
			{ x: 0.18, y: 0.2029 },
			{ x: 0.19, y: 0.2029 },
			{ x: 0.2, y: 0.2029 },
			{ x: 0.21, y: 0.2029 },
			{ x: 0.22, y: 0.2029 },
			{ x: 0.23, y: 0.2029 },
			{ x: 0.24, y: 0.2029 },
			{ x: 0.25, y: 0.2029 },
			{ x: 0.26, y: 0.2029 },
			{ x: 0.27, y: 0.2029 },
			{ x: 0.28, y: 0.2029 },
			{ x: 0.29, y: 0.2029 },
			{ x: 0.3, y: 0.2029 },
			{ x: 0.31, y: 0.2029 },
			{ x: 0.32, y: 0.2029 },
			{ x: 0.33, y: 0.2029 },
			{ x: 0.34, y: 0.2029 },
			{ x: 0.35, y: 0.2029 },
			{ x: 0.36, y: 0.2029 },
			{ x: 0.37, y: 0.2029 },
			{ x: 0.38, y: 0.2029 },
			{ x: 0.39, y: 0.2029 },
			{ x: 0.4, y: 0.2029 },
			{ x: 0.41, y: 0.2029 },
			{ x: 0.42, y: 0.2029 },
			{ x: 0.43, y: 0.2029 },
			{ x: 0.44, y: 0.2029 },
			{ x: 0.45, y: 0.2029 },
			{ x: 0.46, y: 0.2029 },
			{ x: 0.47, y: 0.2029 },
			{ x: 0.48, y: 0.2029 },
			{ x: 0.49, y: 0.2029 },
			{ x: 0.5, y: 0.2029 },
			{ x: 0.51, y: 0.2029 },
			{ x: 0.52, y: 0.2029 },
			{ x: 0.53, y: 0.2029 },
			{ x: 0.54, y: 0.2029 },
			{ x: 0.55, y: 0.2029 },
			{ x: 0.56, y: 0.2029 },
			{ x: 0.57, y: 0.2029 },
			{ x: 0.58, y: 0.2029 },
			{ x: 0.59, y: 0.2029 },
			{ x: 0.6, y: 0.2029 },
			{ x: 0.61, y: 0.2029 },
			{ x: 0.62, y: 0.2029 },
			{ x: 0.63, y: 0.2029 },
			{ x: 0.64, y: 0.2029 },
			{ x: 0.65, y: 0.2029 },
			{ x: 0.66, y: 0.2029 },
			{ x: 0.67, y: 0.2029 },
			{ x: 0.68, y: 0.2029 },
			{ x: 0.69, y: 0.2029 },
			{ x: 0.7, y: 0.2029 },
			{ x: 0.71, y: 0.2029 },
			{ x: 0.72, y: 0.2029 },
			{ x: 0.73, y: 0.2029 },
			{ x: 0.74, y: 0.2029 },
			{ x: 0.75, y: 0.2029 },
			{ x: 0.76, y: 0.2029 },
			{ x: 0.77, y: 0.2029 },
			{ x: 0.78, y: 0.2029 },
			{ x: 0.79, y: 0.2029 },
			{ x: 0.8, y: 0.2029 },
			{ x: 0.81, y: 0.2029 },
			{ x: 0.82, y: 0.2029 },
			{ x: 0.83, y: 0.2029 },
			{ x: 0.84, y: 0.2029 },
			{ x: 0.85, y: 0.2029 },
			{ x: 0.86, y: 0.2029 },
			{ x: 0.87, y: 0.2029 },
			{ x: 0.88, y: 0.2029 },
			{ x: 0.89, y: 0.2029 },
			{ x: 0.9, y: 0.2029 },
			{ x: 0.91, y: 0.2029 },
			{ x: 0.92, y: 0.2029 },
			{ x: 0.93, y: 0.2029 },
			{ x: 0.94, y: 0.2029 },
			{ x: 0.95, y: 0.2029 },
			{ x: 0.96, y: 0.2029 },
			{ x: 0.97, y: 0.2029 },
			{ x: 0.98, y: 0.2029 },
			{ x: 0.99, y: 0.2029 },
			{ x: 0, y: 0.21739 },
			{ x: 0.01, y: 0.21739 },
			{ x: 0.02, y: 0.21739 },
			{ x: 0.03, y: 0.21739 },
			{ x: 0.04, y: 0.21739 },
			{ x: 0.05, y: 0.21739 },
			{ x: 0.06, y: 0.21739 },
			{ x: 0.07, y: 0.21739 },
			{ x: 0.08, y: 0.21739 },
			{ x: 0.09, y: 0.21739 },
			{ x: 0.1, y: 0.21739 },
			{ x: 0.11, y: 0.21739 },
			{ x: 0.12, y: 0.21739 },
			{ x: 0.13, y: 0.21739 },
			{ x: 0.14, y: 0.21739 },
			{ x: 0.15, y: 0.21739 },
			{ x: 0.16, y: 0.21739 },
			{ x: 0.17, y: 0.21739 },
			{ x: 0.18, y: 0.21739 },
			{ x: 0.19, y: 0.21739 },
			{ x: 0.2, y: 0.21739 },
			{ x: 0.21, y: 0.21739 },
			{ x: 0.22, y: 0.21739 },
			{ x: 0.23, y: 0.21739 },
			{ x: 0.24, y: 0.21739 },
			{ x: 0.25, y: 0.21739 },
			{ x: 0.26, y: 0.21739 },
			{ x: 0.27, y: 0.21739 },
			{ x: 0.28, y: 0.21739 },
			{ x: 0.29, y: 0.21739 },
			{ x: 0.3, y: 0.21739 },
			{ x: 0.31, y: 0.21739 },
			{ x: 0.32, y: 0.21739 },
			{ x: 0.33, y: 0.21739 },
			{ x: 0.34, y: 0.21739 },
			{ x: 0.35, y: 0.21739 },
			{ x: 0.36, y: 0.21739 },
			{ x: 0.37, y: 0.21739 },
			{ x: 0.38, y: 0.21739 },
			{ x: 0.39, y: 0.21739 },
			{ x: 0.4, y: 0.21739 },
			{ x: 0.41, y: 0.21739 },
			{ x: 0.42, y: 0.21739 },
			{ x: 0.43, y: 0.21739 },
			{ x: 0.44, y: 0.21739 },
			{ x: 0.45, y: 0.21739 },
			{ x: 0.46, y: 0.21739 },
			{ x: 0.47, y: 0.21739 },
			{ x: 0.48, y: 0.21739 },
			{ x: 0.49, y: 0.21739 },
			{ x: 0.5, y: 0.21739 },
			{ x: 0.51, y: 0.21739 },
			{ x: 0.52, y: 0.21739 },
			{ x: 0.53, y: 0.21739 },
			{ x: 0.54, y: 0.21739 },
			{ x: 0.55, y: 0.21739 },
			{ x: 0.56, y: 0.21739 },
			{ x: 0.57, y: 0.21739 },
			{ x: 0.58, y: 0.21739 },
			{ x: 0.59, y: 0.21739 },
			{ x: 0.6, y: 0.21739 },
			{ x: 0.61, y: 0.21739 },
			{ x: 0.62, y: 0.21739 },
			{ x: 0.63, y: 0.21739 },
			{ x: 0.64, y: 0.21739 },
			{ x: 0.66, y: 0.21739 },
			{ x: 0.67, y: 0.21739 },
			{ x: 0.68, y: 0.21739 },
			{ x: 0.69, y: 0.21739 },
			{ x: 0.7, y: 0.21739 },
			{ x: 0.71, y: 0.21739 },
			{ x: 0.72, y: 0.21739 },
			{ x: 0.73, y: 0.21739 },
			{ x: 0.74, y: 0.21739 },
			{ x: 0.75, y: 0.21739 },
			{ x: 0.76, y: 0.21739 },
			{ x: 0.77, y: 0.21739 },
			{ x: 0.78, y: 0.21739 },
			{ x: 0.79, y: 0.21739 },
			{ x: 0.8, y: 0.21739 },
			{ x: 0.81, y: 0.21739 },
			{ x: 0.82, y: 0.21739 },
			{ x: 0.83, y: 0.21739 },
			{ x: 0.84, y: 0.21739 },
			{ x: 0.85, y: 0.21739 },
			{ x: 0.86, y: 0.21739 },
			{ x: 0.87, y: 0.21739 },
			{ x: 0.88, y: 0.21739 },
			{ x: 0.89, y: 0.21739 },
			{ x: 0.9, y: 0.21739 },
			{ x: 0.91, y: 0.21739 },
			{ x: 0.92, y: 0.21739 },
			{ x: 0.93, y: 0.21739 },
			{ x: 0.94, y: 0.21739 },
			{ x: 0.95, y: 0.21739 },
			{ x: 0.96, y: 0.21739 },
			{ x: 0.97, y: 0.21739 },
			{ x: 0.98, y: 0.21739 },
			{ x: 0.99, y: 0.21739 },
			{ x: 0, y: 0.23188 },
			{ x: 0.01, y: 0.23188 },
			{ x: 0.02, y: 0.23188 },
			{ x: 0.03, y: 0.23188 },
			{ x: 0.04, y: 0.23188 },
			{ x: 0.05, y: 0.23188 },
			{ x: 0.06, y: 0.23188 },
			{ x: 0.07, y: 0.23188 },
			{ x: 0.08, y: 0.23188 },
			{ x: 0.09, y: 0.23188 },
			{ x: 0.1, y: 0.23188 },
			{ x: 0.11, y: 0.23188 },
			{ x: 0.12, y: 0.23188 },
			{ x: 0.13, y: 0.23188 },
			{ x: 0.14, y: 0.23188 },
			{ x: 0.15, y: 0.23188 },
			{ x: 0.16, y: 0.23188 },
			{ x: 0.17, y: 0.23188 },
			{ x: 0.18, y: 0.23188 },
			{ x: 0.19, y: 0.23188 },
			{ x: 0.2, y: 0.23188 },
			{ x: 0.21, y: 0.23188 },
			{ x: 0.22, y: 0.23188 },
			{ x: 0.23, y: 0.23188 },
			{ x: 0.24, y: 0.23188 },
			{ x: 0.25, y: 0.23188 },
			{ x: 0.26, y: 0.23188 },
			{ x: 0.27, y: 0.23188 },
			{ x: 0.28, y: 0.23188 },
			{ x: 0.29, y: 0.23188 },
			{ x: 0.3, y: 0.23188 },
			{ x: 0.31, y: 0.23188 },
			{ x: 0.32, y: 0.23188 },
			{ x: 0.33, y: 0.23188 },
			{ x: 0.34, y: 0.23188 },
			{ x: 0.35, y: 0.23188 },
			{ x: 0.36, y: 0.23188 },
			{ x: 0.37, y: 0.23188 },
			{ x: 0.38, y: 0.23188 },
			{ x: 0.39, y: 0.23188 },
			{ x: 0.4, y: 0.23188 },
			{ x: 0.41, y: 0.23188 },
			{ x: 0.42, y: 0.23188 },
			{ x: 0.43, y: 0.23188 },
			{ x: 0.44, y: 0.23188 },
			{ x: 0.45, y: 0.23188 },
			{ x: 0.46, y: 0.23188 },
			{ x: 0.47, y: 0.23188 },
			{ x: 0.48, y: 0.23188 },
			{ x: 0.49, y: 0.23188 },
			{ x: 0.5, y: 0.23188 },
			{ x: 0.51, y: 0.23188 },
			{ x: 0.52, y: 0.23188 },
			{ x: 0.53, y: 0.23188 },
			{ x: 0.54, y: 0.23188 },
			{ x: 0.55, y: 0.23188 },
			{ x: 0.56, y: 0.23188 },
			{ x: 0.57, y: 0.23188 },
			{ x: 0.58, y: 0.23188 },
			{ x: 0.59, y: 0.23188 },
			{ x: 0.6, y: 0.23188 },
			{ x: 0.61, y: 0.23188 },
			{ x: 0.62, y: 0.23188 },
			{ x: 0.63, y: 0.23188 },
			{ x: 0.64, y: 0.23188 },
			{ x: 0.65, y: 0.23188 },
			{ x: 0.66, y: 0.23188 },
			{ x: 0.67, y: 0.23188 },
			{ x: 0.68, y: 0.23188 },
			{ x: 0.69, y: 0.23188 },
			{ x: 0.7, y: 0.23188 },
			{ x: 0.71, y: 0.23188 },
			{ x: 0.72, y: 0.23188 },
			{ x: 0.73, y: 0.23188 },
			{ x: 0.74, y: 0.23188 },
			{ x: 0.75, y: 0.23188 },
			{ x: 0.76, y: 0.23188 },
			{ x: 0.77, y: 0.23188 },
			{ x: 0.78, y: 0.23188 },
			{ x: 0.79, y: 0.23188 },
			{ x: 0.8, y: 0.23188 },
			{ x: 0.81, y: 0.23188 },
			{ x: 0.82, y: 0.23188 },
			{ x: 0.83, y: 0.23188 },
			{ x: 0.84, y: 0.23188 },
			{ x: 0.85, y: 0.23188 },
			{ x: 0.86, y: 0.23188 },
			{ x: 0.87, y: 0.23188 },
			{ x: 0.88, y: 0.23188 },
			{ x: 0.89, y: 0.23188 },
			{ x: 0.9, y: 0.23188 },
			{ x: 0.91, y: 0.23188 },
			{ x: 0.92, y: 0.23188 },
			{ x: 0.93, y: 0.23188 },
			{ x: 0.94, y: 0.23188 },
			{ x: 0.95, y: 0.23188 },
			{ x: 0.96, y: 0.23188 },
			{ x: 0.97, y: 0.23188 },
			{ x: 0.98, y: 0.23188 },
			{ x: 0.99, y: 0.23188 },
			{ x: 0, y: 0.24638 },
			{ x: 0.01, y: 0.24638 },
			{ x: 0.02, y: 0.24638 },
			{ x: 0.03, y: 0.24638 },
			{ x: 0.04, y: 0.24638 },
			{ x: 0.05, y: 0.24638 },
			{ x: 0.06, y: 0.24638 },
			{ x: 0.07, y: 0.24638 },
			{ x: 0.08, y: 0.24638 },
			{ x: 0.09, y: 0.24638 },
			{ x: 0.1, y: 0.24638 },
			{ x: 0.11, y: 0.24638 },
			{ x: 0.12, y: 0.24638 },
			{ x: 0.13, y: 0.24638 },
			{ x: 0.14, y: 0.24638 },
			{ x: 0.15, y: 0.24638 },
			{ x: 0.16, y: 0.24638 },
			{ x: 0.17, y: 0.24638 },
			{ x: 0.18, y: 0.24638 },
			{ x: 0.19, y: 0.24638 },
			{ x: 0.2, y: 0.24638 },
			{ x: 0.21, y: 0.24638 },
			{ x: 0.22, y: 0.24638 },
			{ x: 0.23, y: 0.24638 },
			{ x: 0.24, y: 0.24638 },
			{ x: 0.25, y: 0.24638 },
			{ x: 0.26, y: 0.24638 },
			{ x: 0.27, y: 0.24638 },
			{ x: 0.28, y: 0.24638 },
			{ x: 0.29, y: 0.24638 },
			{ x: 0.3, y: 0.24638 },
			{ x: 0.31, y: 0.24638 },
			{ x: 0.32, y: 0.24638 },
			{ x: 0.33, y: 0.24638 },
			{ x: 0.34, y: 0.24638 },
			{ x: 0.35, y: 0.24638 },
			{ x: 0.36, y: 0.24638 },
			{ x: 0.37, y: 0.24638 },
			{ x: 0.38, y: 0.24638 },
			{ x: 0.39, y: 0.24638 },
			{ x: 0.4, y: 0.24638 },
			{ x: 0.41, y: 0.24638 },
			{ x: 0.42, y: 0.24638 },
			{ x: 0.43, y: 0.24638 },
			{ x: 0.44, y: 0.24638 },
			{ x: 0.45, y: 0.24638 },
			{ x: 0.46, y: 0.24638 },
			{ x: 0.47, y: 0.24638 },
			{ x: 0.48, y: 0.24638 },
			{ x: 0.49, y: 0.24638 },
			{ x: 0.5, y: 0.24638 },
			{ x: 0.51, y: 0.24638 },
			{ x: 0.52, y: 0.24638 },
			{ x: 0.53, y: 0.24638 },
			{ x: 0.54, y: 0.24638 },
			{ x: 0.55, y: 0.24638 },
			{ x: 0.56, y: 0.24638 },
			{ x: 0.57, y: 0.24638 },
			{ x: 0.58, y: 0.24638 },
			{ x: 0.59, y: 0.24638 },
			{ x: 0.6, y: 0.24638 },
			{ x: 0.61, y: 0.24638 },
			{ x: 0.62, y: 0.24638 },
			{ x: 0.63, y: 0.24638 },
			{ x: 0.64, y: 0.24638 },
			{ x: 0.65, y: 0.24638 },
			{ x: 0.67, y: 0.24638 },
			{ x: 0.68, y: 0.24638 },
			{ x: 0.69, y: 0.24638 },
			{ x: 0.7, y: 0.24638 },
			{ x: 0.71, y: 0.24638 },
			{ x: 0.72, y: 0.24638 },
			{ x: 0.73, y: 0.24638 },
			{ x: 0.74, y: 0.24638 },
			{ x: 0.75, y: 0.24638 },
			{ x: 0.76, y: 0.24638 },
			{ x: 0.77, y: 0.24638 },
			{ x: 0.78, y: 0.24638 },
			{ x: 0.79, y: 0.24638 },
			{ x: 0.8, y: 0.24638 },
			{ x: 0.81, y: 0.24638 },
			{ x: 0.82, y: 0.24638 },
			{ x: 0.83, y: 0.24638 },
			{ x: 0.84, y: 0.24638 },
			{ x: 0.85, y: 0.24638 },
			{ x: 0.86, y: 0.24638 },
			{ x: 0.87, y: 0.24638 },
			{ x: 0.88, y: 0.24638 },
			{ x: 0.89, y: 0.24638 },
			{ x: 0.9, y: 0.24638 },
			{ x: 0.91, y: 0.24638 },
			{ x: 0.92, y: 0.24638 },
			{ x: 0.93, y: 0.24638 },
			{ x: 0.94, y: 0.24638 },
			{ x: 0.95, y: 0.24638 },
			{ x: 0.96, y: 0.24638 },
			{ x: 0.97, y: 0.24638 },
			{ x: 0.98, y: 0.24638 },
			{ x: 0.99, y: 0.24638 },
			{ x: 0, y: 0.26087 },
			{ x: 0.01, y: 0.26087 },
			{ x: 0.02, y: 0.26087 },
			{ x: 0.03, y: 0.26087 },
			{ x: 0.04, y: 0.26087 },
			{ x: 0.05, y: 0.26087 },
			{ x: 0.06, y: 0.26087 },
			{ x: 0.07, y: 0.26087 },
			{ x: 0.08, y: 0.26087 },
			{ x: 0.09, y: 0.26087 },
			{ x: 0.1, y: 0.26087 },
			{ x: 0.11, y: 0.26087 },
			{ x: 0.12, y: 0.26087 },
			{ x: 0.13, y: 0.26087 },
			{ x: 0.14, y: 0.26087 },
			{ x: 0.15, y: 0.26087 },
			{ x: 0.16, y: 0.26087 },
			{ x: 0.17, y: 0.26087 },
			{ x: 0.18, y: 0.26087 },
			{ x: 0.19, y: 0.26087 },
			{ x: 0.2, y: 0.26087 },
			{ x: 0.21, y: 0.26087 },
			{ x: 0.22, y: 0.26087 },
			{ x: 0.23, y: 0.26087 },
			{ x: 0.24, y: 0.26087 },
			{ x: 0.25, y: 0.26087 },
			{ x: 0.26, y: 0.26087 },
			{ x: 0.27, y: 0.26087 },
			{ x: 0.28, y: 0.26087 },
			{ x: 0.29, y: 0.26087 },
			{ x: 0.3, y: 0.26087 },
			{ x: 0.31, y: 0.26087 },
			{ x: 0.32, y: 0.26087 },
			{ x: 0.33, y: 0.26087 },
			{ x: 0.34, y: 0.26087 },
			{ x: 0.35, y: 0.26087 },
			{ x: 0.36, y: 0.26087 },
			{ x: 0.37, y: 0.26087 },
			{ x: 0.38, y: 0.26087 },
			{ x: 0.39, y: 0.26087 },
			{ x: 0.4, y: 0.26087 },
			{ x: 0.41, y: 0.26087 },
			{ x: 0.42, y: 0.26087 },
			{ x: 0.43, y: 0.26087 },
			{ x: 0.44, y: 0.26087 },
			{ x: 0.45, y: 0.26087 },
			{ x: 0.46, y: 0.26087 },
			{ x: 0.47, y: 0.26087 },
			{ x: 0.48, y: 0.26087 },
			{ x: 0.49, y: 0.26087 },
			{ x: 0.5, y: 0.26087 },
			{ x: 0.51, y: 0.26087 },
			{ x: 0.52, y: 0.26087 },
			{ x: 0.53, y: 0.26087 },
			{ x: 0.54, y: 0.26087 },
			{ x: 0.55, y: 0.26087 },
			{ x: 0.56, y: 0.26087 },
			{ x: 0.57, y: 0.26087 },
			{ x: 0.58, y: 0.26087 },
			{ x: 0.59, y: 0.26087 },
			{ x: 0.6, y: 0.26087 },
			{ x: 0.61, y: 0.26087 },
			{ x: 0.62, y: 0.26087 },
			{ x: 0.63, y: 0.26087 },
			{ x: 0.64, y: 0.26087 },
			{ x: 0.65, y: 0.26087 },
			{ x: 0.66, y: 0.26087 },
			{ x: 0.67, y: 0.26087 },
			{ x: 0.68, y: 0.26087 },
			{ x: 0.69, y: 0.26087 },
			{ x: 0.7, y: 0.26087 },
			{ x: 0.71, y: 0.26087 },
			{ x: 0.72, y: 0.26087 },
			{ x: 0.73, y: 0.26087 },
			{ x: 0.74, y: 0.26087 },
			{ x: 0.75, y: 0.26087 },
			{ x: 0.76, y: 0.26087 },
			{ x: 0.77, y: 0.26087 },
			{ x: 0.78, y: 0.26087 },
			{ x: 0.79, y: 0.26087 },
			{ x: 0.8, y: 0.26087 },
			{ x: 0.81, y: 0.26087 },
			{ x: 0.82, y: 0.26087 },
			{ x: 0.83, y: 0.26087 },
			{ x: 0.84, y: 0.26087 },
			{ x: 0.85, y: 0.26087 },
			{ x: 0.86, y: 0.26087 },
			{ x: 0.87, y: 0.26087 },
			{ x: 0.88, y: 0.26087 },
			{ x: 0.89, y: 0.26087 },
			{ x: 0.9, y: 0.26087 },
			{ x: 0.91, y: 0.26087 },
			{ x: 0.92, y: 0.26087 },
			{ x: 0.93, y: 0.26087 },
			{ x: 0.94, y: 0.26087 },
			{ x: 0.95, y: 0.26087 },
			{ x: 0.96, y: 0.26087 },
			{ x: 0.97, y: 0.26087 },
			{ x: 0.98, y: 0.26087 },
			{ x: 0.99, y: 0.26087 },
			{ x: 0, y: 0.27536 },
			{ x: 0.01, y: 0.27536 },
			{ x: 0.02, y: 0.27536 },
			{ x: 0.03, y: 0.27536 },
			{ x: 0.04, y: 0.27536 },
			{ x: 0.05, y: 0.27536 },
			{ x: 0.06, y: 0.27536 },
			{ x: 0.07, y: 0.27536 },
			{ x: 0.08, y: 0.27536 },
			{ x: 0.09, y: 0.27536 },
			{ x: 0.1, y: 0.27536 },
			{ x: 0.11, y: 0.27536 },
			{ x: 0.12, y: 0.27536 },
			{ x: 0.13, y: 0.27536 },
			{ x: 0.14, y: 0.27536 },
			{ x: 0.15, y: 0.27536 },
			{ x: 0.16, y: 0.27536 },
			{ x: 0.17, y: 0.27536 },
			{ x: 0.18, y: 0.27536 },
			{ x: 0.19, y: 0.27536 },
			{ x: 0.2, y: 0.27536 },
			{ x: 0.21, y: 0.27536 },
			{ x: 0.22, y: 0.27536 },
			{ x: 0.23, y: 0.27536 },
			{ x: 0.24, y: 0.27536 },
			{ x: 0.25, y: 0.27536 },
			{ x: 0.26, y: 0.27536 },
			{ x: 0.27, y: 0.27536 },
			{ x: 0.28, y: 0.27536 },
			{ x: 0.29, y: 0.27536 },
			{ x: 0.3, y: 0.27536 },
			{ x: 0.31, y: 0.27536 },
			{ x: 0.32, y: 0.27536 },
			{ x: 0.33, y: 0.27536 },
			{ x: 0.34, y: 0.27536 },
			{ x: 0.35, y: 0.27536 },
			{ x: 0.36, y: 0.27536 },
			{ x: 0.37, y: 0.27536 },
			{ x: 0.38, y: 0.27536 },
			{ x: 0.39, y: 0.27536 },
			{ x: 0.4, y: 0.27536 },
			{ x: 0.41, y: 0.27536 },
			{ x: 0.42, y: 0.27536 },
			{ x: 0.43, y: 0.27536 },
			{ x: 0.44, y: 0.27536 },
			{ x: 0.45, y: 0.27536 },
			{ x: 0.46, y: 0.27536 },
			{ x: 0.47, y: 0.27536 },
			{ x: 0.48, y: 0.27536 },
			{ x: 0.49, y: 0.27536 },
			{ x: 0.5, y: 0.27536 },
			{ x: 0.51, y: 0.27536 },
			{ x: 0.52, y: 0.27536 },
			{ x: 0.53, y: 0.27536 },
			{ x: 0.54, y: 0.27536 },
			{ x: 0.55, y: 0.27536 },
			{ x: 0.56, y: 0.27536 },
			{ x: 0.57, y: 0.27536 },
			{ x: 0.58, y: 0.27536 },
			{ x: 0.59, y: 0.27536 },
			{ x: 0.6, y: 0.27536 },
			{ x: 0.61, y: 0.27536 },
			{ x: 0.62, y: 0.27536 },
			{ x: 0.63, y: 0.27536 },
			{ x: 0.64, y: 0.27536 },
			{ x: 0.65, y: 0.27536 },
			{ x: 0.66, y: 0.27536 },
			{ x: 0.67, y: 0.27536 },
			{ x: 0.68, y: 0.27536 },
			{ x: 0.69, y: 0.27536 },
			{ x: 0.7, y: 0.27536 },
			{ x: 0.71, y: 0.27536 },
			{ x: 0.72, y: 0.27536 },
			{ x: 0.73, y: 0.27536 },
			{ x: 0.74, y: 0.27536 },
			{ x: 0.75, y: 0.27536 },
			{ x: 0.76, y: 0.27536 },
			{ x: 0.77, y: 0.27536 },
			{ x: 0.78, y: 0.27536 },
			{ x: 0.79, y: 0.27536 },
			{ x: 0.8, y: 0.27536 },
			{ x: 0.81, y: 0.27536 },
			{ x: 0.82, y: 0.27536 },
			{ x: 0.83, y: 0.27536 },
			{ x: 0.84, y: 0.27536 },
			{ x: 0.85, y: 0.27536 },
			{ x: 0.86, y: 0.27536 },
			{ x: 0.87, y: 0.27536 },
			{ x: 0.88, y: 0.27536 },
			{ x: 0.89, y: 0.27536 },
			{ x: 0.9, y: 0.27536 },
			{ x: 0.91, y: 0.27536 },
			{ x: 0.92, y: 0.27536 },
			{ x: 0.93, y: 0.27536 },
			{ x: 0.94, y: 0.27536 },
			{ x: 0.95, y: 0.27536 },
			{ x: 0.96, y: 0.27536 },
			{ x: 0.97, y: 0.27536 },
			{ x: 0.98, y: 0.27536 },
			{ x: 0.99, y: 0.27536 },
			{ x: 0, y: 0.28986 },
			{ x: 0.01, y: 0.28986 },
			{ x: 0.02, y: 0.28986 },
			{ x: 0.03, y: 0.28986 },
			{ x: 0.04, y: 0.28986 },
			{ x: 0.05, y: 0.28986 },
			{ x: 0.06, y: 0.28986 },
			{ x: 0.07, y: 0.28986 },
			{ x: 0.08, y: 0.28986 },
			{ x: 0.09, y: 0.28986 },
			{ x: 0.1, y: 0.28986 },
			{ x: 0.11, y: 0.28986 },
			{ x: 0.12, y: 0.28986 },
			{ x: 0.13, y: 0.28986 },
			{ x: 0.14, y: 0.28986 },
			{ x: 0.15, y: 0.28986 },
			{ x: 0.16, y: 0.28986 },
			{ x: 0.17, y: 0.28986 },
			{ x: 0.18, y: 0.28986 },
			{ x: 0.19, y: 0.28986 },
			{ x: 0.2, y: 0.28986 },
			{ x: 0.21, y: 0.28986 },
			{ x: 0.22, y: 0.28986 },
			{ x: 0.23, y: 0.28986 },
			{ x: 0.24, y: 0.28986 },
			{ x: 0.25, y: 0.28986 },
			{ x: 0.26, y: 0.28986 },
			{ x: 0.27, y: 0.28986 },
			{ x: 0.28, y: 0.28986 },
			{ x: 0.29, y: 0.28986 },
			{ x: 0.3, y: 0.28986 },
			{ x: 0.31, y: 0.28986 },
			{ x: 0.32, y: 0.28986 },
			{ x: 0.33, y: 0.28986 },
			{ x: 0.34, y: 0.28986 },
			{ x: 0.35, y: 0.28986 },
			{ x: 0.36, y: 0.28986 },
			{ x: 0.37, y: 0.28986 },
			{ x: 0.38, y: 0.28986 },
			{ x: 0.39, y: 0.28986 },
			{ x: 0.4, y: 0.28986 },
			{ x: 0.41, y: 0.28986 },
			{ x: 0.42, y: 0.28986 },
			{ x: 0.43, y: 0.28986 },
			{ x: 0.44, y: 0.28986 },
			{ x: 0.45, y: 0.28986 },
			{ x: 0.46, y: 0.28986 },
			{ x: 0.47, y: 0.28986 },
			{ x: 0.48, y: 0.28986 },
			{ x: 0.49, y: 0.28986 },
			{ x: 0.5, y: 0.28986 },
			{ x: 0.51, y: 0.28986 },
			{ x: 0.52, y: 0.28986 },
			{ x: 0.53, y: 0.28986 },
			{ x: 0.54, y: 0.28986 },
			{ x: 0.55, y: 0.28986 },
			{ x: 0.56, y: 0.28986 },
			{ x: 0.57, y: 0.28986 },
			{ x: 0.58, y: 0.28986 },
			{ x: 0.59, y: 0.28986 },
			{ x: 0.6, y: 0.28986 },
			{ x: 0.61, y: 0.28986 },
			{ x: 0.62, y: 0.28986 },
			{ x: 0.63, y: 0.28986 },
			{ x: 0.64, y: 0.28986 },
			{ x: 0.65, y: 0.28986 },
			{ x: 0.66, y: 0.28986 },
			{ x: 0.67, y: 0.28986 },
			{ x: 0.68, y: 0.28986 },
			{ x: 0.69, y: 0.28986 },
			{ x: 0.7, y: 0.28986 },
			{ x: 0.71, y: 0.28986 },
			{ x: 0.72, y: 0.28986 },
			{ x: 0.73, y: 0.28986 },
			{ x: 0.74, y: 0.28986 },
			{ x: 0.75, y: 0.28986 },
			{ x: 0.76, y: 0.28986 },
			{ x: 0.77, y: 0.28986 },
			{ x: 0.78, y: 0.28986 },
			{ x: 0.79, y: 0.28986 },
			{ x: 0.8, y: 0.28986 },
			{ x: 0.81, y: 0.28986 },
			{ x: 0.82, y: 0.28986 },
			{ x: 0.83, y: 0.28986 },
			{ x: 0.84, y: 0.28986 },
			{ x: 0.85, y: 0.28986 },
			{ x: 0.86, y: 0.28986 },
			{ x: 0.87, y: 0.28986 },
			{ x: 0.88, y: 0.28986 },
			{ x: 0.89, y: 0.28986 },
			{ x: 0.9, y: 0.28986 },
			{ x: 0.91, y: 0.28986 },
			{ x: 0.92, y: 0.28986 },
			{ x: 0.93, y: 0.28986 },
			{ x: 0.94, y: 0.28986 },
			{ x: 0.95, y: 0.28986 },
			{ x: 0.96, y: 0.28986 },
			{ x: 0.97, y: 0.28986 },
			{ x: 0.98, y: 0.28986 },
			{ x: 0.99, y: 0.28986 },
			{ x: 0, y: 0.30435 },
			{ x: 0.01, y: 0.30435 },
			{ x: 0.02, y: 0.30435 },
			{ x: 0.03, y: 0.30435 },
			{ x: 0.04, y: 0.30435 },
			{ x: 0.05, y: 0.30435 },
			{ x: 0.06, y: 0.30435 },
			{ x: 0.07, y: 0.30435 },
			{ x: 0.08, y: 0.30435 },
			{ x: 0.09, y: 0.30435 },
			{ x: 0.1, y: 0.30435 },
			{ x: 0.11, y: 0.30435 },
			{ x: 0.12, y: 0.30435 },
			{ x: 0.13, y: 0.30435 },
			{ x: 0.14, y: 0.30435 },
			{ x: 0.15, y: 0.30435 },
			{ x: 0.16, y: 0.30435 },
			{ x: 0.17, y: 0.30435 },
			{ x: 0.18, y: 0.30435 },
			{ x: 0.19, y: 0.30435 },
			{ x: 0.2, y: 0.30435 },
			{ x: 0.21, y: 0.30435 },
			{ x: 0.22, y: 0.30435 },
			{ x: 0.23, y: 0.30435 },
			{ x: 0.24, y: 0.30435 },
			{ x: 0.25, y: 0.30435 },
			{ x: 0.26, y: 0.30435 },
			{ x: 0.27, y: 0.30435 },
			{ x: 0.28, y: 0.30435 },
			{ x: 0.29, y: 0.30435 },
			{ x: 0.3, y: 0.30435 },
			{ x: 0.31, y: 0.30435 },
			{ x: 0.32, y: 0.30435 },
			{ x: 0.33, y: 0.30435 },
			{ x: 0.34, y: 0.30435 },
			{ x: 0.35, y: 0.30435 },
			{ x: 0.36, y: 0.30435 },
			{ x: 0.37, y: 0.30435 },
			{ x: 0.38, y: 0.30435 },
			{ x: 0.39, y: 0.30435 },
			{ x: 0.4, y: 0.30435 },
			{ x: 0.41, y: 0.30435 },
			{ x: 0.42, y: 0.30435 },
			{ x: 0.43, y: 0.30435 },
			{ x: 0.44, y: 0.30435 },
			{ x: 0.45, y: 0.30435 },
			{ x: 0.46, y: 0.30435 },
			{ x: 0.47, y: 0.30435 },
			{ x: 0.48, y: 0.30435 },
			{ x: 0.49, y: 0.30435 },
			{ x: 0.5, y: 0.30435 },
			{ x: 0.51, y: 0.30435 },
			{ x: 0.52, y: 0.30435 },
			{ x: 0.53, y: 0.30435 },
			{ x: 0.54, y: 0.30435 },
			{ x: 0.55, y: 0.30435 },
			{ x: 0.56, y: 0.30435 },
			{ x: 0.57, y: 0.30435 },
			{ x: 0.58, y: 0.30435 },
			{ x: 0.59, y: 0.30435 },
			{ x: 0.6, y: 0.30435 },
			{ x: 0.61, y: 0.30435 },
			{ x: 0.62, y: 0.30435 },
			{ x: 0.63, y: 0.30435 },
			{ x: 0.64, y: 0.30435 },
			{ x: 0.65, y: 0.30435 },
			{ x: 0.66, y: 0.30435 },
			{ x: 0.67, y: 0.30435 },
			{ x: 0.68, y: 0.30435 },
			{ x: 0.69, y: 0.30435 },
			{ x: 0.7, y: 0.30435 },
			{ x: 0.71, y: 0.30435 },
			{ x: 0.72, y: 0.30435 },
			{ x: 0.73, y: 0.30435 },
			{ x: 0.74, y: 0.30435 },
			{ x: 0.75, y: 0.30435 },
			{ x: 0.76, y: 0.30435 },
			{ x: 0.77, y: 0.30435 },
			{ x: 0.78, y: 0.30435 },
			{ x: 0.79, y: 0.30435 },
			{ x: 0.8, y: 0.30435 },
			{ x: 0.81, y: 0.30435 },
			{ x: 0.82, y: 0.30435 },
			{ x: 0.83, y: 0.30435 },
			{ x: 0.84, y: 0.30435 },
			{ x: 0.85, y: 0.30435 },
			{ x: 0.86, y: 0.30435 },
			{ x: 0.87, y: 0.30435 },
			{ x: 0.88, y: 0.30435 },
			{ x: 0.89, y: 0.30435 },
			{ x: 0.9, y: 0.30435 },
			{ x: 0.91, y: 0.30435 },
			{ x: 0.92, y: 0.30435 },
			{ x: 0.93, y: 0.30435 },
			{ x: 0.94, y: 0.30435 },
			{ x: 0.95, y: 0.30435 },
			{ x: 0.96, y: 0.30435 },
			{ x: 0.97, y: 0.30435 },
			{ x: 0.98, y: 0.30435 },
			{ x: 0.99, y: 0.30435 },
			{ x: 0, y: 0.31884 },
			{ x: 0.01, y: 0.31884 },
			{ x: 0.02, y: 0.31884 },
			{ x: 0.03, y: 0.31884 },
			{ x: 0.04, y: 0.31884 },
			{ x: 0.05, y: 0.31884 },
			{ x: 0.06, y: 0.31884 },
			{ x: 0.07, y: 0.31884 },
			{ x: 0.08, y: 0.31884 },
			{ x: 0.09, y: 0.31884 },
			{ x: 0.1, y: 0.31884 },
			{ x: 0.11, y: 0.31884 },
			{ x: 0.12, y: 0.31884 },
			{ x: 0.13, y: 0.31884 },
			{ x: 0.14, y: 0.31884 },
			{ x: 0.15, y: 0.31884 },
			{ x: 0.16, y: 0.31884 },
			{ x: 0.17, y: 0.31884 },
			{ x: 0.18, y: 0.31884 },
			{ x: 0.19, y: 0.31884 },
			{ x: 0.2, y: 0.31884 },
			{ x: 0.21, y: 0.31884 },
			{ x: 0.22, y: 0.31884 },
			{ x: 0.23, y: 0.31884 },
			{ x: 0.24, y: 0.31884 },
			{ x: 0.25, y: 0.31884 },
			{ x: 0.26, y: 0.31884 },
			{ x: 0.27, y: 0.31884 },
			{ x: 0.28, y: 0.31884 },
			{ x: 0.29, y: 0.31884 },
			{ x: 0.3, y: 0.31884 },
			{ x: 0.31, y: 0.31884 },
			{ x: 0.32, y: 0.31884 },
			{ x: 0.33, y: 0.31884 },
			{ x: 0.34, y: 0.31884 },
			{ x: 0.35, y: 0.31884 },
			{ x: 0.36, y: 0.31884 },
			{ x: 0.37, y: 0.31884 },
			{ x: 0.38, y: 0.31884 },
			{ x: 0.39, y: 0.31884 },
			{ x: 0.4, y: 0.31884 },
			{ x: 0.41, y: 0.31884 },
			{ x: 0.42, y: 0.31884 },
			{ x: 0.43, y: 0.31884 },
			{ x: 0.44, y: 0.31884 },
			{ x: 0.45, y: 0.31884 },
			{ x: 0.46, y: 0.31884 },
			{ x: 0.47, y: 0.31884 },
			{ x: 0.48, y: 0.31884 },
			{ x: 0.49, y: 0.31884 },
			{ x: 0.5, y: 0.31884 },
			{ x: 0.51, y: 0.31884 },
			{ x: 0.52, y: 0.31884 },
			{ x: 0.53, y: 0.31884 },
			{ x: 0.54, y: 0.31884 },
			{ x: 0.55, y: 0.31884 },
			{ x: 0.56, y: 0.31884 },
			{ x: 0.57, y: 0.31884 },
			{ x: 0.58, y: 0.31884 },
			{ x: 0.59, y: 0.31884 },
			{ x: 0.6, y: 0.31884 },
			{ x: 0.61, y: 0.31884 },
			{ x: 0.62, y: 0.31884 },
			{ x: 0.63, y: 0.31884 },
			{ x: 0.64, y: 0.31884 },
			{ x: 0.65, y: 0.31884 },
			{ x: 0.66, y: 0.31884 },
			{ x: 0.67, y: 0.31884 },
			{ x: 0.68, y: 0.31884 },
			{ x: 0.69, y: 0.31884 },
			{ x: 0.7, y: 0.31884 },
			{ x: 0.71, y: 0.31884 },
			{ x: 0.72, y: 0.31884 },
			{ x: 0.73, y: 0.31884 },
			{ x: 0.74, y: 0.31884 },
			{ x: 0.75, y: 0.31884 },
			{ x: 0.76, y: 0.31884 },
			{ x: 0.77, y: 0.31884 },
			{ x: 0.78, y: 0.31884 },
			{ x: 0.79, y: 0.31884 },
			{ x: 0.8, y: 0.31884 },
			{ x: 0.81, y: 0.31884 },
			{ x: 0.82, y: 0.31884 },
			{ x: 0.83, y: 0.31884 },
			{ x: 0.84, y: 0.31884 },
			{ x: 0.85, y: 0.31884 },
			{ x: 0.86, y: 0.31884 },
			{ x: 0.87, y: 0.31884 },
			{ x: 0.88, y: 0.31884 },
			{ x: 0.89, y: 0.31884 },
			{ x: 0.9, y: 0.31884 },
			{ x: 0.91, y: 0.31884 },
			{ x: 0.92, y: 0.31884 },
			{ x: 0.93, y: 0.31884 },
			{ x: 0.94, y: 0.31884 },
			{ x: 0.95, y: 0.31884 },
			{ x: 0.96, y: 0.31884 },
			{ x: 0.97, y: 0.31884 },
			{ x: 0.98, y: 0.31884 },
			{ x: 0.99, y: 0.31884 },
			{ x: 0, y: 0.33333 },
			{ x: 0.01, y: 0.33333 },
			{ x: 0.02, y: 0.33333 },
			{ x: 0.03, y: 0.33333 },
			{ x: 0.04, y: 0.33333 },
			{ x: 0.05, y: 0.33333 },
			{ x: 0.06, y: 0.33333 },
			{ x: 0.07, y: 0.33333 },
			{ x: 0.08, y: 0.33333 },
			{ x: 0.09, y: 0.33333 },
			{ x: 0.1, y: 0.33333 },
			{ x: 0.11, y: 0.33333 },
			{ x: 0.12, y: 0.33333 },
			{ x: 0.13, y: 0.33333 },
			{ x: 0.14, y: 0.33333 },
			{ x: 0.15, y: 0.33333 },
			{ x: 0.16, y: 0.33333 },
			{ x: 0.17, y: 0.33333 },
			{ x: 0.18, y: 0.33333 },
			{ x: 0.19, y: 0.33333 },
			{ x: 0.2, y: 0.33333 },
			{ x: 0.21, y: 0.33333 },
			{ x: 0.22, y: 0.33333 },
			{ x: 0.23, y: 0.33333 },
			{ x: 0.24, y: 0.33333 },
			{ x: 0.25, y: 0.33333 },
			{ x: 0.26, y: 0.33333 },
			{ x: 0.27, y: 0.33333 },
			{ x: 0.28, y: 0.33333 },
			{ x: 0.29, y: 0.33333 },
			{ x: 0.3, y: 0.33333 },
			{ x: 0.31, y: 0.33333 },
			{ x: 0.32, y: 0.33333 },
			{ x: 0.33, y: 0.33333 },
			{ x: 0.34, y: 0.33333 },
			{ x: 0.35, y: 0.33333 },
			{ x: 0.36, y: 0.33333 },
			{ x: 0.37, y: 0.33333 },
			{ x: 0.38, y: 0.33333 },
			{ x: 0.39, y: 0.33333 },
			{ x: 0.4, y: 0.33333 },
			{ x: 0.41, y: 0.33333 },
			{ x: 0.42, y: 0.33333 },
			{ x: 0.43, y: 0.33333 },
			{ x: 0.44, y: 0.33333 },
			{ x: 0.45, y: 0.33333 },
			{ x: 0.46, y: 0.33333 },
			{ x: 0.47, y: 0.33333 },
			{ x: 0.48, y: 0.33333 },
			{ x: 0.49, y: 0.33333 },
			{ x: 0.5, y: 0.33333 },
			{ x: 0.51, y: 0.33333 },
			{ x: 0.52, y: 0.33333 },
			{ x: 0.53, y: 0.33333 },
			{ x: 0.54, y: 0.33333 },
			{ x: 0.55, y: 0.33333 },
			{ x: 0.56, y: 0.33333 },
			{ x: 0.57, y: 0.33333 },
			{ x: 0.58, y: 0.33333 },
			{ x: 0.59, y: 0.33333 },
			{ x: 0.6, y: 0.33333 },
			{ x: 0.61, y: 0.33333 },
			{ x: 0.62, y: 0.33333 },
			{ x: 0.63, y: 0.33333 },
			{ x: 0.64, y: 0.33333 },
			{ x: 0.65, y: 0.33333 },
			{ x: 0.66, y: 0.33333 },
			{ x: 0.67, y: 0.33333 },
			{ x: 0.68, y: 0.33333 },
			{ x: 0.69, y: 0.33333 },
			{ x: 0.7, y: 0.33333 },
			{ x: 0.71, y: 0.33333 },
			{ x: 0.72, y: 0.33333 },
			{ x: 0.73, y: 0.33333 },
			{ x: 0.74, y: 0.33333 },
			{ x: 0.75, y: 0.33333 },
			{ x: 0.76, y: 0.33333 },
			{ x: 0.77, y: 0.33333 },
			{ x: 0.78, y: 0.33333 },
			{ x: 0.79, y: 0.33333 },
			{ x: 0.8, y: 0.33333 },
			{ x: 0.81, y: 0.33333 },
			{ x: 0.82, y: 0.33333 },
			{ x: 0.83, y: 0.33333 },
			{ x: 0.84, y: 0.33333 },
			{ x: 0.85, y: 0.33333 },
			{ x: 0.86, y: 0.33333 },
			{ x: 0.87, y: 0.33333 },
			{ x: 0.88, y: 0.33333 },
			{ x: 0.89, y: 0.33333 },
			{ x: 0.9, y: 0.33333 },
			{ x: 0.91, y: 0.33333 },
			{ x: 0.92, y: 0.33333 },
			{ x: 0.93, y: 0.33333 },
			{ x: 0.94, y: 0.33333 },
			{ x: 0.95, y: 0.33333 },
			{ x: 0.96, y: 0.33333 },
			{ x: 0.97, y: 0.33333 },
			{ x: 0.98, y: 0.33333 },
			{ x: 0.99, y: 0.33333 },
			{ x: 0, y: 0.34783 },
			{ x: 0.01, y: 0.34783 },
			{ x: 0.02, y: 0.34783 },
			{ x: 0.03, y: 0.34783 },
			{ x: 0.04, y: 0.34783 },
			{ x: 0.05, y: 0.34783 },
			{ x: 0.06, y: 0.34783 },
			{ x: 0.07, y: 0.34783 },
			{ x: 0.08, y: 0.34783 },
			{ x: 0.09, y: 0.34783 },
			{ x: 0.1, y: 0.34783 },
			{ x: 0.11, y: 0.34783 },
			{ x: 0.12, y: 0.34783 },
			{ x: 0.13, y: 0.34783 },
			{ x: 0.14, y: 0.34783 },
			{ x: 0.15, y: 0.34783 },
			{ x: 0.16, y: 0.34783 },
			{ x: 0.17, y: 0.34783 },
			{ x: 0.18, y: 0.34783 },
			{ x: 0.19, y: 0.34783 },
			{ x: 0.2, y: 0.34783 },
			{ x: 0.21, y: 0.34783 },
			{ x: 0.22, y: 0.34783 },
			{ x: 0.23, y: 0.34783 },
			{ x: 0.24, y: 0.34783 },
			{ x: 0.25, y: 0.34783 },
			{ x: 0.26, y: 0.34783 },
			{ x: 0.27, y: 0.34783 },
			{ x: 0.28, y: 0.34783 },
			{ x: 0.29, y: 0.34783 },
			{ x: 0.3, y: 0.34783 },
			{ x: 0.31, y: 0.34783 },
			{ x: 0.32, y: 0.34783 },
			{ x: 0.33, y: 0.34783 },
			{ x: 0.34, y: 0.34783 },
			{ x: 0.35, y: 0.34783 },
			{ x: 0.36, y: 0.34783 },
			{ x: 0.37, y: 0.34783 },
			{ x: 0.38, y: 0.34783 },
			{ x: 0.39, y: 0.34783 },
			{ x: 0.4, y: 0.34783 },
			{ x: 0.41, y: 0.34783 },
			{ x: 0.42, y: 0.34783 },
			{ x: 0.43, y: 0.34783 },
			{ x: 0.44, y: 0.34783 },
			{ x: 0.45, y: 0.34783 },
			{ x: 0.46, y: 0.34783 },
			{ x: 0.47, y: 0.34783 },
			{ x: 0.48, y: 0.34783 },
			{ x: 0.49, y: 0.34783 },
			{ x: 0.5, y: 0.34783 },
			{ x: 0.51, y: 0.34783 },
			{ x: 0.52, y: 0.34783 },
			{ x: 0.53, y: 0.34783 },
			{ x: 0.54, y: 0.34783 },
			{ x: 0.55, y: 0.34783 },
			{ x: 0.56, y: 0.34783 },
			{ x: 0.57, y: 0.34783 },
			{ x: 0.58, y: 0.34783 },
			{ x: 0.59, y: 0.34783 },
			{ x: 0.6, y: 0.34783 },
			{ x: 0.61, y: 0.34783 },
			{ x: 0.62, y: 0.34783 },
			{ x: 0.63, y: 0.34783 },
			{ x: 0.64, y: 0.34783 },
			{ x: 0.65, y: 0.34783 },
			{ x: 0.66, y: 0.34783 },
			{ x: 0.67, y: 0.34783 },
			{ x: 0.68, y: 0.34783 },
			{ x: 0.69, y: 0.34783 },
			{ x: 0.7, y: 0.34783 },
			{ x: 0.71, y: 0.34783 },
			{ x: 0.72, y: 0.34783 },
			{ x: 0.73, y: 0.34783 },
			{ x: 0.74, y: 0.34783 },
			{ x: 0.75, y: 0.34783 },
			{ x: 0.76, y: 0.34783 },
			{ x: 0.77, y: 0.34783 },
			{ x: 0.78, y: 0.34783 },
			{ x: 0.79, y: 0.34783 },
			{ x: 0.8, y: 0.34783 },
			{ x: 0.81, y: 0.34783 },
			{ x: 0.82, y: 0.34783 },
			{ x: 0.83, y: 0.34783 },
			{ x: 0.84, y: 0.34783 },
			{ x: 0.85, y: 0.34783 },
			{ x: 0.86, y: 0.34783 },
			{ x: 0.87, y: 0.34783 },
			{ x: 0.88, y: 0.34783 },
			{ x: 0.89, y: 0.34783 },
			{ x: 0.9, y: 0.34783 },
			{ x: 0.91, y: 0.34783 },
			{ x: 0.92, y: 0.34783 },
			{ x: 0.93, y: 0.34783 },
			{ x: 0.94, y: 0.34783 },
			{ x: 0.95, y: 0.34783 },
			{ x: 0.96, y: 0.34783 },
			{ x: 0.97, y: 0.34783 },
			{ x: 0.98, y: 0.34783 },
			{ x: 0.99, y: 0.34783 },
			{ x: 0, y: 0.36232 },
			{ x: 0.01, y: 0.36232 },
			{ x: 0.02, y: 0.36232 },
			{ x: 0.03, y: 0.36232 },
			{ x: 0.04, y: 0.36232 },
			{ x: 0.05, y: 0.36232 },
			{ x: 0.06, y: 0.36232 },
			{ x: 0.07, y: 0.36232 },
			{ x: 0.08, y: 0.36232 },
			{ x: 0.09, y: 0.36232 },
			{ x: 0.1, y: 0.36232 },
			{ x: 0.11, y: 0.36232 },
			{ x: 0.12, y: 0.36232 },
			{ x: 0.13, y: 0.36232 },
			{ x: 0.14, y: 0.36232 },
			{ x: 0.15, y: 0.36232 },
			{ x: 0.16, y: 0.36232 },
			{ x: 0.17, y: 0.36232 },
			{ x: 0.18, y: 0.36232 },
			{ x: 0.19, y: 0.36232 },
			{ x: 0.2, y: 0.36232 },
			{ x: 0.21, y: 0.36232 },
			{ x: 0.22, y: 0.36232 },
			{ x: 0.23, y: 0.36232 },
			{ x: 0.24, y: 0.36232 },
			{ x: 0.25, y: 0.36232 },
			{ x: 0.26, y: 0.36232 },
			{ x: 0.27, y: 0.36232 },
			{ x: 0.28, y: 0.36232 },
			{ x: 0.29, y: 0.36232 },
			{ x: 0.3, y: 0.36232 },
			{ x: 0.31, y: 0.36232 },
			{ x: 0.32, y: 0.36232 },
			{ x: 0.33, y: 0.36232 },
			{ x: 0.34, y: 0.36232 },
			{ x: 0.35, y: 0.36232 },
			{ x: 0.36, y: 0.36232 },
			{ x: 0.37, y: 0.36232 },
			{ x: 0.38, y: 0.36232 },
			{ x: 0.39, y: 0.36232 },
			{ x: 0.4, y: 0.36232 },
			{ x: 0.41, y: 0.36232 },
			{ x: 0.42, y: 0.36232 },
			{ x: 0.43, y: 0.36232 },
			{ x: 0.44, y: 0.36232 },
			{ x: 0.45, y: 0.36232 },
			{ x: 0.46, y: 0.36232 },
			{ x: 0.47, y: 0.36232 },
			{ x: 0.48, y: 0.36232 },
			{ x: 0.49, y: 0.36232 },
			{ x: 0.5, y: 0.36232 },
			{ x: 0.51, y: 0.36232 },
			{ x: 0.52, y: 0.36232 },
			{ x: 0.53, y: 0.36232 },
			{ x: 0.54, y: 0.36232 },
			{ x: 0.55, y: 0.36232 },
			{ x: 0.56, y: 0.36232 },
			{ x: 0.57, y: 0.36232 },
			{ x: 0.58, y: 0.36232 },
			{ x: 0.59, y: 0.36232 },
			{ x: 0.6, y: 0.36232 },
			{ x: 0.61, y: 0.36232 },
			{ x: 0.62, y: 0.36232 },
			{ x: 0.63, y: 0.36232 },
			{ x: 0.64, y: 0.36232 },
			{ x: 0.65, y: 0.36232 },
			{ x: 0.66, y: 0.36232 },
			{ x: 0.67, y: 0.36232 },
			{ x: 0.68, y: 0.36232 },
			{ x: 0.69, y: 0.36232 },
			{ x: 0.7, y: 0.36232 },
			{ x: 0.71, y: 0.36232 },
			{ x: 0.72, y: 0.36232 },
			{ x: 0.73, y: 0.36232 },
			{ x: 0.74, y: 0.36232 },
			{ x: 0.75, y: 0.36232 },
			{ x: 0.76, y: 0.36232 },
			{ x: 0.77, y: 0.36232 },
			{ x: 0.78, y: 0.36232 },
			{ x: 0.79, y: 0.36232 },
			{ x: 0.8, y: 0.36232 },
			{ x: 0.81, y: 0.36232 },
			{ x: 0.82, y: 0.36232 },
			{ x: 0.83, y: 0.36232 },
			{ x: 0.84, y: 0.36232 },
			{ x: 0.85, y: 0.36232 },
			{ x: 0.86, y: 0.36232 },
			{ x: 0.87, y: 0.36232 },
			{ x: 0.88, y: 0.36232 },
			{ x: 0.89, y: 0.36232 },
			{ x: 0.9, y: 0.36232 },
			{ x: 0.91, y: 0.36232 },
			{ x: 0.92, y: 0.36232 },
			{ x: 0.93, y: 0.36232 },
			{ x: 0.94, y: 0.36232 },
			{ x: 0.95, y: 0.36232 },
			{ x: 0.96, y: 0.36232 },
			{ x: 0.97, y: 0.36232 },
			{ x: 0.98, y: 0.36232 },
			{ x: 0.99, y: 0.36232 },
			{ x: 0, y: 0.37681 },
			{ x: 0.01, y: 0.37681 },
			{ x: 0.02, y: 0.37681 },
			{ x: 0.03, y: 0.37681 },
			{ x: 0.04, y: 0.37681 },
			{ x: 0.05, y: 0.37681 },
			{ x: 0.06, y: 0.37681 },
			{ x: 0.07, y: 0.37681 },
			{ x: 0.08, y: 0.37681 },
			{ x: 0.09, y: 0.37681 },
			{ x: 0.1, y: 0.37681 },
			{ x: 0.11, y: 0.37681 },
			{ x: 0.12, y: 0.37681 },
			{ x: 0.13, y: 0.37681 },
			{ x: 0.14, y: 0.37681 },
			{ x: 0.15, y: 0.37681 },
			{ x: 0.16, y: 0.37681 },
			{ x: 0.17, y: 0.37681 },
			{ x: 0.18, y: 0.37681 },
			{ x: 0.19, y: 0.37681 },
			{ x: 0.2, y: 0.37681 },
			{ x: 0.21, y: 0.37681 },
			{ x: 0.22, y: 0.37681 },
			{ x: 0.23, y: 0.37681 },
			{ x: 0.24, y: 0.37681 },
			{ x: 0.25, y: 0.37681 },
			{ x: 0.26, y: 0.37681 },
			{ x: 0.27, y: 0.37681 },
			{ x: 0.28, y: 0.37681 },
			{ x: 0.29, y: 0.37681 },
			{ x: 0.3, y: 0.37681 },
			{ x: 0.31, y: 0.37681 },
			{ x: 0.32, y: 0.37681 },
			{ x: 0.33, y: 0.37681 },
			{ x: 0.34, y: 0.37681 },
			{ x: 0.35, y: 0.37681 },
			{ x: 0.36, y: 0.37681 },
			{ x: 0.37, y: 0.37681 },
			{ x: 0.38, y: 0.37681 },
			{ x: 0.39, y: 0.37681 },
			{ x: 0.4, y: 0.37681 },
			{ x: 0.41, y: 0.37681 },
			{ x: 0.42, y: 0.37681 },
			{ x: 0.43, y: 0.37681 },
			{ x: 0.44, y: 0.37681 },
			{ x: 0.45, y: 0.37681 },
			{ x: 0.46, y: 0.37681 },
			{ x: 0.47, y: 0.37681 },
			{ x: 0.48, y: 0.37681 },
			{ x: 0.49, y: 0.37681 },
			{ x: 0.5, y: 0.37681 },
			{ x: 0.51, y: 0.37681 },
			{ x: 0.52, y: 0.37681 },
			{ x: 0.53, y: 0.37681 },
			{ x: 0.54, y: 0.37681 },
			{ x: 0.55, y: 0.37681 },
			{ x: 0.56, y: 0.37681 },
			{ x: 0.57, y: 0.37681 },
			{ x: 0.58, y: 0.37681 },
			{ x: 0.59, y: 0.37681 },
			{ x: 0.6, y: 0.37681 },
			{ x: 0.61, y: 0.37681 },
			{ x: 0.62, y: 0.37681 },
			{ x: 0.63, y: 0.37681 },
			{ x: 0.64, y: 0.37681 },
			{ x: 0.65, y: 0.37681 },
			{ x: 0.66, y: 0.37681 },
			{ x: 0.67, y: 0.37681 },
			{ x: 0.68, y: 0.37681 },
			{ x: 0.69, y: 0.37681 },
			{ x: 0.7, y: 0.37681 },
			{ x: 0.71, y: 0.37681 },
			{ x: 0.72, y: 0.37681 },
			{ x: 0.73, y: 0.37681 },
			{ x: 0.74, y: 0.37681 },
			{ x: 0.75, y: 0.37681 },
			{ x: 0.76, y: 0.37681 },
			{ x: 0.77, y: 0.37681 },
			{ x: 0.78, y: 0.37681 },
			{ x: 0.79, y: 0.37681 },
			{ x: 0.8, y: 0.37681 },
			{ x: 0.81, y: 0.37681 },
			{ x: 0.82, y: 0.37681 },
			{ x: 0.83, y: 0.37681 },
			{ x: 0.84, y: 0.37681 },
			{ x: 0.85, y: 0.37681 },
			{ x: 0.86, y: 0.37681 },
			{ x: 0.87, y: 0.37681 },
			{ x: 0.88, y: 0.37681 },
			{ x: 0.89, y: 0.37681 },
			{ x: 0.9, y: 0.37681 },
			{ x: 0.91, y: 0.37681 },
			{ x: 0.92, y: 0.37681 },
			{ x: 0.93, y: 0.37681 },
			{ x: 0.94, y: 0.37681 },
			{ x: 0.95, y: 0.37681 },
			{ x: 0.96, y: 0.37681 },
			{ x: 0.97, y: 0.37681 },
			{ x: 0.98, y: 0.37681 },
			{ x: 0.99, y: 0.37681 },
			{ x: 0, y: 0.3913 },
			{ x: 0.01, y: 0.3913 },
			{ x: 0.02, y: 0.3913 },
			{ x: 0.03, y: 0.3913 },
			{ x: 0.04, y: 0.3913 },
			{ x: 0.05, y: 0.3913 },
			{ x: 0.06, y: 0.3913 },
			{ x: 0.07, y: 0.3913 },
			{ x: 0.08, y: 0.3913 },
			{ x: 0.09, y: 0.3913 },
			{ x: 0.1, y: 0.3913 },
			{ x: 0.11, y: 0.3913 },
			{ x: 0.12, y: 0.3913 },
			{ x: 0.13, y: 0.3913 },
			{ x: 0.14, y: 0.3913 },
			{ x: 0.15, y: 0.3913 },
			{ x: 0.16, y: 0.3913 },
			{ x: 0.17, y: 0.3913 },
			{ x: 0.18, y: 0.3913 },
			{ x: 0.19, y: 0.3913 },
			{ x: 0.2, y: 0.3913 },
			{ x: 0.21, y: 0.3913 },
			{ x: 0.22, y: 0.3913 },
			{ x: 0.23, y: 0.3913 },
			{ x: 0.24, y: 0.3913 },
			{ x: 0.25, y: 0.3913 },
			{ x: 0.26, y: 0.3913 },
			{ x: 0.27, y: 0.3913 },
			{ x: 0.28, y: 0.3913 },
			{ x: 0.29, y: 0.3913 },
			{ x: 0.3, y: 0.3913 },
			{ x: 0.31, y: 0.3913 },
			{ x: 0.32, y: 0.3913 },
			{ x: 0.33, y: 0.3913 },
			{ x: 0.34, y: 0.3913 },
			{ x: 0.35, y: 0.3913 },
			{ x: 0.36, y: 0.3913 },
			{ x: 0.37, y: 0.3913 },
			{ x: 0.38, y: 0.3913 },
			{ x: 0.39, y: 0.3913 },
			{ x: 0.4, y: 0.3913 },
			{ x: 0.41, y: 0.3913 },
			{ x: 0.42, y: 0.3913 },
			{ x: 0.43, y: 0.3913 },
			{ x: 0.44, y: 0.3913 },
			{ x: 0.45, y: 0.3913 },
			{ x: 0.46, y: 0.3913 },
			{ x: 0.47, y: 0.3913 },
			{ x: 0.48, y: 0.3913 },
			{ x: 0.49, y: 0.3913 },
			{ x: 0.5, y: 0.3913 },
			{ x: 0.51, y: 0.3913 },
			{ x: 0.52, y: 0.3913 },
			{ x: 0.53, y: 0.3913 },
			{ x: 0.54, y: 0.3913 },
			{ x: 0.55, y: 0.3913 },
			{ x: 0.56, y: 0.3913 },
			{ x: 0.57, y: 0.3913 },
			{ x: 0.58, y: 0.3913 },
			{ x: 0.59, y: 0.3913 },
			{ x: 0.6, y: 0.3913 },
			{ x: 0.61, y: 0.3913 },
			{ x: 0.62, y: 0.3913 },
			{ x: 0.63, y: 0.3913 },
			{ x: 0.64, y: 0.3913 },
			{ x: 0.65, y: 0.3913 },
			{ x: 0.66, y: 0.3913 },
			{ x: 0.67, y: 0.3913 },
			{ x: 0.68, y: 0.3913 },
			{ x: 0.69, y: 0.3913 },
			{ x: 0.7, y: 0.3913 },
			{ x: 0.71, y: 0.3913 },
			{ x: 0.72, y: 0.3913 },
			{ x: 0.73, y: 0.3913 },
			{ x: 0.74, y: 0.3913 },
			{ x: 0.75, y: 0.3913 },
			{ x: 0.76, y: 0.3913 },
			{ x: 0.77, y: 0.3913 },
			{ x: 0.78, y: 0.3913 },
			{ x: 0.79, y: 0.3913 },
			{ x: 0.8, y: 0.3913 },
			{ x: 0.81, y: 0.3913 },
			{ x: 0.82, y: 0.3913 },
			{ x: 0.83, y: 0.3913 },
			{ x: 0.84, y: 0.3913 },
			{ x: 0.85, y: 0.3913 },
			{ x: 0.86, y: 0.3913 },
			{ x: 0.87, y: 0.3913 },
			{ x: 0.88, y: 0.3913 },
			{ x: 0.89, y: 0.3913 },
			{ x: 0.9, y: 0.3913 },
			{ x: 0.91, y: 0.3913 },
			{ x: 0.92, y: 0.3913 },
			{ x: 0.93, y: 0.3913 },
			{ x: 0.94, y: 0.3913 },
			{ x: 0.95, y: 0.3913 },
			{ x: 0.96, y: 0.3913 },
			{ x: 0.97, y: 0.3913 },
			{ x: 0.98, y: 0.3913 },
			{ x: 0.99, y: 0.3913 },
			{ x: 0, y: 0.4058 },
			{ x: 0.01, y: 0.4058 },
			{ x: 0.02, y: 0.4058 },
			{ x: 0.03, y: 0.4058 },
			{ x: 0.04, y: 0.4058 },
			{ x: 0.05, y: 0.4058 },
			{ x: 0.06, y: 0.4058 },
			{ x: 0.07, y: 0.4058 },
			{ x: 0.08, y: 0.4058 },
			{ x: 0.09, y: 0.4058 },
			{ x: 0.1, y: 0.4058 },
			{ x: 0.11, y: 0.4058 },
			{ x: 0.12, y: 0.4058 },
			{ x: 0.13, y: 0.4058 },
			{ x: 0.14, y: 0.4058 },
			{ x: 0.15, y: 0.4058 },
			{ x: 0.16, y: 0.4058 },
			{ x: 0.17, y: 0.4058 },
			{ x: 0.18, y: 0.4058 },
			{ x: 0.19, y: 0.4058 },
			{ x: 0.2, y: 0.4058 },
			{ x: 0.21, y: 0.4058 },
			{ x: 0.22, y: 0.4058 },
			{ x: 0.23, y: 0.4058 },
			{ x: 0.24, y: 0.4058 },
			{ x: 0.25, y: 0.4058 },
			{ x: 0.26, y: 0.4058 },
			{ x: 0.27, y: 0.4058 },
			{ x: 0.28, y: 0.4058 },
			{ x: 0.29, y: 0.4058 },
			{ x: 0.3, y: 0.4058 },
			{ x: 0.31, y: 0.4058 },
			{ x: 0.32, y: 0.4058 },
			{ x: 0.33, y: 0.4058 },
			{ x: 0.34, y: 0.4058 },
			{ x: 0.35, y: 0.4058 },
			{ x: 0.36, y: 0.4058 },
			{ x: 0.37, y: 0.4058 },
			{ x: 0.38, y: 0.4058 },
			{ x: 0.39, y: 0.4058 },
			{ x: 0.4, y: 0.4058 },
			{ x: 0.41, y: 0.4058 },
			{ x: 0.42, y: 0.4058 },
			{ x: 0.43, y: 0.4058 },
			{ x: 0.44, y: 0.4058 },
			{ x: 0.45, y: 0.4058 },
			{ x: 0.46, y: 0.4058 },
			{ x: 0.47, y: 0.4058 },
			{ x: 0.48, y: 0.4058 },
			{ x: 0.49, y: 0.4058 },
			{ x: 0.5, y: 0.4058 },
			{ x: 0.51, y: 0.4058 },
			{ x: 0.52, y: 0.4058 },
			{ x: 0.53, y: 0.4058 },
			{ x: 0.54, y: 0.4058 },
			{ x: 0.55, y: 0.4058 },
			{ x: 0.56, y: 0.4058 },
			{ x: 0.57, y: 0.4058 },
			{ x: 0.58, y: 0.4058 },
			{ x: 0.59, y: 0.4058 },
			{ x: 0.6, y: 0.4058 },
			{ x: 0.61, y: 0.4058 },
			{ x: 0.62, y: 0.4058 },
			{ x: 0.63, y: 0.4058 },
			{ x: 0.64, y: 0.4058 },
			{ x: 0.65, y: 0.4058 },
			{ x: 0.66, y: 0.4058 },
			{ x: 0.67, y: 0.4058 },
			{ x: 0.68, y: 0.4058 },
			{ x: 0.69, y: 0.4058 },
			{ x: 0.7, y: 0.4058 },
			{ x: 0.71, y: 0.4058 },
			{ x: 0.72, y: 0.4058 },
			{ x: 0.73, y: 0.4058 },
			{ x: 0.74, y: 0.4058 },
			{ x: 0.75, y: 0.4058 },
			{ x: 0.76, y: 0.4058 },
			{ x: 0.77, y: 0.4058 },
			{ x: 0.78, y: 0.4058 },
			{ x: 0.79, y: 0.4058 },
			{ x: 0.8, y: 0.4058 },
			{ x: 0.81, y: 0.4058 },
			{ x: 0.82, y: 0.4058 },
			{ x: 0.83, y: 0.4058 },
			{ x: 0.84, y: 0.4058 },
			{ x: 0.85, y: 0.4058 },
			{ x: 0.86, y: 0.4058 },
			{ x: 0.87, y: 0.4058 },
			{ x: 0.88, y: 0.4058 },
			{ x: 0.89, y: 0.4058 },
			{ x: 0.9, y: 0.4058 },
			{ x: 0.91, y: 0.4058 },
			{ x: 0.92, y: 0.4058 },
			{ x: 0.93, y: 0.4058 },
			{ x: 0.94, y: 0.4058 },
			{ x: 0.95, y: 0.4058 },
			{ x: 0.96, y: 0.4058 },
			{ x: 0.97, y: 0.4058 },
			{ x: 0.98, y: 0.4058 },
			{ x: 0.99, y: 0.4058 },
			{ x: 0, y: 0.42029 },
			{ x: 0.01, y: 0.42029 },
			{ x: 0.02, y: 0.42029 },
			{ x: 0.03, y: 0.42029 },
			{ x: 0.04, y: 0.42029 },
			{ x: 0.05, y: 0.42029 },
			{ x: 0.06, y: 0.42029 },
			{ x: 0.07, y: 0.42029 },
			{ x: 0.08, y: 0.42029 },
			{ x: 0.09, y: 0.42029 },
			{ x: 0.1, y: 0.42029 },
			{ x: 0.11, y: 0.42029 },
			{ x: 0.12, y: 0.42029 },
			{ x: 0.13, y: 0.42029 },
			{ x: 0.14, y: 0.42029 },
			{ x: 0.15, y: 0.42029 },
			{ x: 0.16, y: 0.42029 },
			{ x: 0.17, y: 0.42029 },
			{ x: 0.18, y: 0.42029 },
			{ x: 0.19, y: 0.42029 },
			{ x: 0.2, y: 0.42029 },
			{ x: 0.21, y: 0.42029 },
			{ x: 0.22, y: 0.42029 },
			{ x: 0.23, y: 0.42029 },
			{ x: 0.24, y: 0.42029 },
			{ x: 0.25, y: 0.42029 },
			{ x: 0.26, y: 0.42029 },
			{ x: 0.27, y: 0.42029 },
			{ x: 0.28, y: 0.42029 },
			{ x: 0.29, y: 0.42029 },
			{ x: 0.3, y: 0.42029 },
			{ x: 0.31, y: 0.42029 },
			{ x: 0.32, y: 0.42029 },
			{ x: 0.33, y: 0.42029 },
			{ x: 0.34, y: 0.42029 },
			{ x: 0.35, y: 0.42029 },
			{ x: 0.36, y: 0.42029 },
			{ x: 0.37, y: 0.42029 },
			{ x: 0.38, y: 0.42029 },
			{ x: 0.39, y: 0.42029 },
			{ x: 0.4, y: 0.42029 },
			{ x: 0.41, y: 0.42029 },
			{ x: 0.42, y: 0.42029 },
			{ x: 0.43, y: 0.42029 },
			{ x: 0.44, y: 0.42029 },
			{ x: 0.45, y: 0.42029 },
			{ x: 0.46, y: 0.42029 },
			{ x: 0.47, y: 0.42029 },
			{ x: 0.48, y: 0.42029 },
			{ x: 0.49, y: 0.42029 },
			{ x: 0.5, y: 0.42029 },
			{ x: 0.51, y: 0.42029 },
			{ x: 0.52, y: 0.42029 },
			{ x: 0.53, y: 0.42029 },
			{ x: 0.54, y: 0.42029 },
			{ x: 0.55, y: 0.42029 },
			{ x: 0.56, y: 0.42029 },
			{ x: 0.57, y: 0.42029 },
			{ x: 0.58, y: 0.42029 },
			{ x: 0.59, y: 0.42029 },
			{ x: 0.6, y: 0.42029 },
			{ x: 0.61, y: 0.42029 },
			{ x: 0.62, y: 0.42029 },
			{ x: 0.63, y: 0.42029 },
			{ x: 0.64, y: 0.42029 },
			{ x: 0.65, y: 0.42029 },
			{ x: 0.66, y: 0.42029 },
			{ x: 0.67, y: 0.42029 },
			{ x: 0.68, y: 0.42029 },
			{ x: 0.69, y: 0.42029 },
			{ x: 0.7, y: 0.42029 },
			{ x: 0.71, y: 0.42029 },
			{ x: 0.72, y: 0.42029 },
			{ x: 0.73, y: 0.42029 },
			{ x: 0.74, y: 0.42029 },
			{ x: 0.75, y: 0.42029 },
			{ x: 0.76, y: 0.42029 },
			{ x: 0.77, y: 0.42029 },
			{ x: 0.78, y: 0.42029 },
			{ x: 0.79, y: 0.42029 },
			{ x: 0.8, y: 0.42029 },
			{ x: 0.81, y: 0.42029 },
			{ x: 0.82, y: 0.42029 },
			{ x: 0.83, y: 0.42029 },
			{ x: 0.84, y: 0.42029 },
			{ x: 0.85, y: 0.42029 },
			{ x: 0.86, y: 0.42029 },
			{ x: 0.87, y: 0.42029 },
			{ x: 0.88, y: 0.42029 },
			{ x: 0.89, y: 0.42029 },
			{ x: 0.9, y: 0.42029 },
			{ x: 0.91, y: 0.42029 },
			{ x: 0.92, y: 0.42029 },
			{ x: 0.93, y: 0.42029 },
			{ x: 0.94, y: 0.42029 },
			{ x: 0.95, y: 0.42029 },
			{ x: 0.96, y: 0.42029 },
			{ x: 0.97, y: 0.42029 },
			{ x: 0.98, y: 0.42029 },
			{ x: 0.99, y: 0.42029 },
			{ x: 0, y: 0.43478 },
			{ x: 0.01, y: 0.43478 },
			{ x: 0.02, y: 0.43478 },
			{ x: 0.03, y: 0.43478 },
			{ x: 0.04, y: 0.43478 },
			{ x: 0.05, y: 0.43478 },
			{ x: 0.06, y: 0.43478 },
			{ x: 0.07, y: 0.43478 },
			{ x: 0.08, y: 0.43478 },
			{ x: 0.09, y: 0.43478 },
			{ x: 0.1, y: 0.43478 },
			{ x: 0.11, y: 0.43478 },
			{ x: 0.12, y: 0.43478 },
			{ x: 0.13, y: 0.43478 },
			{ x: 0.14, y: 0.43478 },
			{ x: 0.15, y: 0.43478 },
			{ x: 0.16, y: 0.43478 },
			{ x: 0.17, y: 0.43478 },
			{ x: 0.18, y: 0.43478 },
			{ x: 0.19, y: 0.43478 },
			{ x: 0.2, y: 0.43478 },
			{ x: 0.21, y: 0.43478 },
			{ x: 0.22, y: 0.43478 },
			{ x: 0.23, y: 0.43478 },
			{ x: 0.24, y: 0.43478 },
			{ x: 0.25, y: 0.43478 },
			{ x: 0.26, y: 0.43478 },
			{ x: 0.27, y: 0.43478 },
			{ x: 0.28, y: 0.43478 },
			{ x: 0.29, y: 0.43478 },
			{ x: 0.3, y: 0.43478 },
			{ x: 0.31, y: 0.43478 },
			{ x: 0.32, y: 0.43478 },
			{ x: 0.33, y: 0.43478 },
			{ x: 0.34, y: 0.43478 },
			{ x: 0.35, y: 0.43478 },
			{ x: 0.36, y: 0.43478 },
			{ x: 0.37, y: 0.43478 },
			{ x: 0.38, y: 0.43478 },
			{ x: 0.39, y: 0.43478 },
			{ x: 0.4, y: 0.43478 },
			{ x: 0.41, y: 0.43478 },
			{ x: 0.42, y: 0.43478 },
			{ x: 0.43, y: 0.43478 },
			{ x: 0.44, y: 0.43478 },
			{ x: 0.45, y: 0.43478 },
			{ x: 0.46, y: 0.43478 },
			{ x: 0.47, y: 0.43478 },
			{ x: 0.48, y: 0.43478 },
			{ x: 0.49, y: 0.43478 },
			{ x: 0.5, y: 0.43478 },
			{ x: 0.51, y: 0.43478 },
			{ x: 0.52, y: 0.43478 },
			{ x: 0.53, y: 0.43478 },
			{ x: 0.54, y: 0.43478 },
			{ x: 0.55, y: 0.43478 },
			{ x: 0.56, y: 0.43478 },
			{ x: 0.57, y: 0.43478 },
			{ x: 0.58, y: 0.43478 },
			{ x: 0.59, y: 0.43478 },
			{ x: 0.6, y: 0.43478 },
			{ x: 0.61, y: 0.43478 },
			{ x: 0.62, y: 0.43478 },
			{ x: 0.63, y: 0.43478 },
			{ x: 0.64, y: 0.43478 },
			{ x: 0.65, y: 0.43478 },
			{ x: 0.66, y: 0.43478 },
			{ x: 0.67, y: 0.43478 },
			{ x: 0.68, y: 0.43478 },
			{ x: 0.69, y: 0.43478 },
			{ x: 0.7, y: 0.43478 },
			{ x: 0.71, y: 0.43478 },
			{ x: 0.72, y: 0.43478 },
			{ x: 0.73, y: 0.43478 },
			{ x: 0.74, y: 0.43478 },
			{ x: 0.75, y: 0.43478 },
			{ x: 0.76, y: 0.43478 },
			{ x: 0.77, y: 0.43478 },
			{ x: 0.78, y: 0.43478 },
			{ x: 0.79, y: 0.43478 },
			{ x: 0.8, y: 0.43478 },
			{ x: 0.81, y: 0.43478 },
			{ x: 0.82, y: 0.43478 },
			{ x: 0.83, y: 0.43478 },
			{ x: 0.84, y: 0.43478 },
			{ x: 0.85, y: 0.43478 },
			{ x: 0.86, y: 0.43478 },
			{ x: 0.87, y: 0.43478 },
			{ x: 0.88, y: 0.43478 },
			{ x: 0.89, y: 0.43478 },
			{ x: 0.9, y: 0.43478 },
			{ x: 0.91, y: 0.43478 },
			{ x: 0.92, y: 0.43478 },
			{ x: 0.93, y: 0.43478 },
			{ x: 0.94, y: 0.43478 },
			{ x: 0.95, y: 0.43478 },
			{ x: 0.96, y: 0.43478 },
			{ x: 0.97, y: 0.43478 },
			{ x: 0.98, y: 0.43478 },
			{ x: 0.99, y: 0.43478 },
			{ x: 0, y: 0.44928 },
			{ x: 0.01, y: 0.44928 },
			{ x: 0.02, y: 0.44928 },
			{ x: 0.03, y: 0.44928 },
			{ x: 0.04, y: 0.44928 },
			{ x: 0.05, y: 0.44928 },
			{ x: 0.06, y: 0.44928 },
			{ x: 0.07, y: 0.44928 },
			{ x: 0.08, y: 0.44928 },
			{ x: 0.09, y: 0.44928 },
			{ x: 0.1, y: 0.44928 },
			{ x: 0.11, y: 0.44928 },
			{ x: 0.12, y: 0.44928 },
			{ x: 0.13, y: 0.44928 },
			{ x: 0.14, y: 0.44928 },
			{ x: 0.15, y: 0.44928 },
			{ x: 0.16, y: 0.44928 },
			{ x: 0.17, y: 0.44928 },
			{ x: 0.18, y: 0.44928 },
			{ x: 0.19, y: 0.44928 },
			{ x: 0.2, y: 0.44928 },
			{ x: 0.21, y: 0.44928 },
			{ x: 0.22, y: 0.44928 },
			{ x: 0.23, y: 0.44928 },
			{ x: 0.24, y: 0.44928 },
			{ x: 0.25, y: 0.44928 },
			{ x: 0.26, y: 0.44928 },
			{ x: 0.27, y: 0.44928 },
			{ x: 0.28, y: 0.44928 },
			{ x: 0.29, y: 0.44928 },
			{ x: 0.3, y: 0.44928 },
			{ x: 0.31, y: 0.44928 },
			{ x: 0.32, y: 0.44928 },
			{ x: 0.33, y: 0.44928 },
			{ x: 0.34, y: 0.44928 },
			{ x: 0.35, y: 0.44928 },
			{ x: 0.36, y: 0.44928 },
			{ x: 0.37, y: 0.44928 },
			{ x: 0.38, y: 0.44928 },
			{ x: 0.39, y: 0.44928 },
			{ x: 0.4, y: 0.44928 },
			{ x: 0.41, y: 0.44928 },
			{ x: 0.42, y: 0.44928 },
			{ x: 0.43, y: 0.44928 },
			{ x: 0.44, y: 0.44928 },
			{ x: 0.45, y: 0.44928 },
			{ x: 0.46, y: 0.44928 },
			{ x: 0.47, y: 0.44928 },
			{ x: 0.48, y: 0.44928 },
			{ x: 0.49, y: 0.44928 },
			{ x: 0.5, y: 0.44928 },
			{ x: 0.51, y: 0.44928 },
			{ x: 0.52, y: 0.44928 },
			{ x: 0.53, y: 0.44928 },
			{ x: 0.54, y: 0.44928 },
			{ x: 0.55, y: 0.44928 },
			{ x: 0.56, y: 0.44928 },
			{ x: 0.57, y: 0.44928 },
			{ x: 0.58, y: 0.44928 },
			{ x: 0.59, y: 0.44928 },
			{ x: 0.6, y: 0.44928 },
			{ x: 0.61, y: 0.44928 },
			{ x: 0.62, y: 0.44928 },
			{ x: 0.63, y: 0.44928 },
			{ x: 0.64, y: 0.44928 },
			{ x: 0.65, y: 0.44928 },
			{ x: 0.66, y: 0.44928 },
			{ x: 0.67, y: 0.44928 },
			{ x: 0.68, y: 0.44928 },
			{ x: 0.69, y: 0.44928 },
			{ x: 0.7, y: 0.44928 },
			{ x: 0.71, y: 0.44928 },
			{ x: 0.72, y: 0.44928 },
			{ x: 0.73, y: 0.44928 },
			{ x: 0.74, y: 0.44928 },
			{ x: 0.75, y: 0.44928 },
			{ x: 0.76, y: 0.44928 },
			{ x: 0.77, y: 0.44928 },
			{ x: 0.78, y: 0.44928 },
			{ x: 0.79, y: 0.44928 },
			{ x: 0.8, y: 0.44928 },
			{ x: 0.81, y: 0.44928 },
			{ x: 0.82, y: 0.44928 },
			{ x: 0.83, y: 0.44928 },
			{ x: 0.84, y: 0.44928 },
			{ x: 0.85, y: 0.44928 },
			{ x: 0.86, y: 0.44928 },
			{ x: 0.87, y: 0.44928 },
			{ x: 0.88, y: 0.44928 },
			{ x: 0.89, y: 0.44928 },
			{ x: 0.9, y: 0.44928 },
			{ x: 0.91, y: 0.44928 },
			{ x: 0.92, y: 0.44928 },
			{ x: 0.93, y: 0.44928 },
			{ x: 0.94, y: 0.44928 },
			{ x: 0.95, y: 0.44928 },
			{ x: 0.96, y: 0.44928 },
			{ x: 0.97, y: 0.44928 },
			{ x: 0.98, y: 0.44928 },
			{ x: 0.99, y: 0.44928 },
			{ x: 0, y: 0.46377 },
			{ x: 0.01, y: 0.46377 },
			{ x: 0.02, y: 0.46377 },
			{ x: 0.03, y: 0.46377 },
			{ x: 0.04, y: 0.46377 },
			{ x: 0.05, y: 0.46377 },
			{ x: 0.06, y: 0.46377 },
			{ x: 0.07, y: 0.46377 },
			{ x: 0.08, y: 0.46377 },
			{ x: 0.09, y: 0.46377 },
			{ x: 0.1, y: 0.46377 },
			{ x: 0.11, y: 0.46377 },
			{ x: 0.12, y: 0.46377 },
			{ x: 0.13, y: 0.46377 },
			{ x: 0.14, y: 0.46377 },
			{ x: 0.15, y: 0.46377 },
			{ x: 0.16, y: 0.46377 },
			{ x: 0.17, y: 0.46377 },
			{ x: 0.18, y: 0.46377 },
			{ x: 0.19, y: 0.46377 },
			{ x: 0.2, y: 0.46377 },
			{ x: 0.21, y: 0.46377 },
			{ x: 0.22, y: 0.46377 },
			{ x: 0.23, y: 0.46377 },
			{ x: 0.24, y: 0.46377 },
			{ x: 0.25, y: 0.46377 },
			{ x: 0.26, y: 0.46377 },
			{ x: 0.27, y: 0.46377 },
			{ x: 0.28, y: 0.46377 },
			{ x: 0.29, y: 0.46377 },
			{ x: 0.3, y: 0.46377 },
			{ x: 0.31, y: 0.46377 },
			{ x: 0.32, y: 0.46377 },
			{ x: 0.33, y: 0.46377 },
			{ x: 0.34, y: 0.46377 },
			{ x: 0.35, y: 0.46377 },
			{ x: 0.36, y: 0.46377 },
			{ x: 0.37, y: 0.46377 },
			{ x: 0.38, y: 0.46377 },
			{ x: 0.39, y: 0.46377 },
			{ x: 0.4, y: 0.46377 },
			{ x: 0.41, y: 0.46377 },
			{ x: 0.42, y: 0.46377 },
			{ x: 0.43, y: 0.46377 },
			{ x: 0.44, y: 0.46377 },
			{ x: 0.45, y: 0.46377 },
			{ x: 0.46, y: 0.46377 },
			{ x: 0.47, y: 0.46377 },
			{ x: 0.48, y: 0.46377 },
			{ x: 0.49, y: 0.46377 },
			{ x: 0.5, y: 0.46377 },
			{ x: 0.51, y: 0.46377 },
			{ x: 0.52, y: 0.46377 },
			{ x: 0.53, y: 0.46377 },
			{ x: 0.54, y: 0.46377 },
			{ x: 0.55, y: 0.46377 },
			{ x: 0.56, y: 0.46377 },
			{ x: 0.57, y: 0.46377 },
			{ x: 0.58, y: 0.46377 },
			{ x: 0.59, y: 0.46377 },
			{ x: 0.6, y: 0.46377 },
			{ x: 0.61, y: 0.46377 },
			{ x: 0.62, y: 0.46377 },
			{ x: 0.63, y: 0.46377 },
			{ x: 0.64, y: 0.46377 },
			{ x: 0.65, y: 0.46377 },
			{ x: 0.66, y: 0.46377 },
			{ x: 0.67, y: 0.46377 },
			{ x: 0.68, y: 0.46377 },
			{ x: 0.69, y: 0.46377 },
			{ x: 0.7, y: 0.46377 },
			{ x: 0.71, y: 0.46377 },
			{ x: 0.72, y: 0.46377 },
			{ x: 0.73, y: 0.46377 },
			{ x: 0.74, y: 0.46377 },
			{ x: 0.75, y: 0.46377 },
			{ x: 0.76, y: 0.46377 },
			{ x: 0.77, y: 0.46377 },
			{ x: 0.78, y: 0.46377 },
			{ x: 0.79, y: 0.46377 },
			{ x: 0.8, y: 0.46377 },
			{ x: 0.81, y: 0.46377 },
			{ x: 0.82, y: 0.46377 },
			{ x: 0.83, y: 0.46377 },
			{ x: 0.84, y: 0.46377 },
			{ x: 0.85, y: 0.46377 },
			{ x: 0.86, y: 0.46377 },
			{ x: 0.87, y: 0.46377 },
			{ x: 0.88, y: 0.46377 },
			{ x: 0.89, y: 0.46377 },
			{ x: 0.9, y: 0.46377 },
			{ x: 0.91, y: 0.46377 },
			{ x: 0.92, y: 0.46377 },
			{ x: 0.93, y: 0.46377 },
			{ x: 0.94, y: 0.46377 },
			{ x: 0.95, y: 0.46377 },
			{ x: 0.96, y: 0.46377 },
			{ x: 0.97, y: 0.46377 },
			{ x: 0.98, y: 0.46377 },
			{ x: 0.99, y: 0.46377 },
			{ x: 0, y: 0.47826 },
			{ x: 0.01, y: 0.47826 },
			{ x: 0.02, y: 0.47826 },
			{ x: 0.03, y: 0.47826 },
			{ x: 0.04, y: 0.47826 },
			{ x: 0.05, y: 0.47826 },
			{ x: 0.06, y: 0.47826 },
			{ x: 0.07, y: 0.47826 },
			{ x: 0.08, y: 0.47826 },
			{ x: 0.09, y: 0.47826 },
			{ x: 0.1, y: 0.47826 },
			{ x: 0.11, y: 0.47826 },
			{ x: 0.12, y: 0.47826 },
			{ x: 0.13, y: 0.47826 },
			{ x: 0.14, y: 0.47826 },
			{ x: 0.15, y: 0.47826 },
			{ x: 0.16, y: 0.47826 },
			{ x: 0.17, y: 0.47826 },
			{ x: 0.18, y: 0.47826 },
			{ x: 0.19, y: 0.47826 },
			{ x: 0.2, y: 0.47826 },
			{ x: 0.21, y: 0.47826 },
			{ x: 0.22, y: 0.47826 },
			{ x: 0.23, y: 0.47826 },
			{ x: 0.24, y: 0.47826 },
			{ x: 0.25, y: 0.47826 },
			{ x: 0.26, y: 0.47826 },
			{ x: 0.27, y: 0.47826 },
			{ x: 0.28, y: 0.47826 },
			{ x: 0.29, y: 0.47826 },
			{ x: 0.3, y: 0.47826 },
			{ x: 0.31, y: 0.47826 },
			{ x: 0.32, y: 0.47826 },
			{ x: 0.33, y: 0.47826 },
			{ x: 0.34, y: 0.47826 },
			{ x: 0.35, y: 0.47826 },
			{ x: 0.36, y: 0.47826 },
			{ x: 0.37, y: 0.47826 },
			{ x: 0.38, y: 0.47826 },
			{ x: 0.39, y: 0.47826 },
			{ x: 0.4, y: 0.47826 },
			{ x: 0.41, y: 0.47826 },
			{ x: 0.42, y: 0.47826 },
			{ x: 0.43, y: 0.47826 },
			{ x: 0.44, y: 0.47826 },
			{ x: 0.45, y: 0.47826 },
			{ x: 0.46, y: 0.47826 },
			{ x: 0.47, y: 0.47826 },
			{ x: 0.48, y: 0.47826 },
			{ x: 0.49, y: 0.47826 },
			{ x: 0.5, y: 0.47826 },
			{ x: 0.51, y: 0.47826 },
			{ x: 0.52, y: 0.47826 },
			{ x: 0.53, y: 0.47826 },
			{ x: 0.54, y: 0.47826 },
			{ x: 0.55, y: 0.47826 },
			{ x: 0.56, y: 0.47826 },
			{ x: 0.57, y: 0.47826 },
			{ x: 0.58, y: 0.47826 },
			{ x: 0.59, y: 0.47826 },
			{ x: 0.6, y: 0.47826 },
			{ x: 0.61, y: 0.47826 },
			{ x: 0.62, y: 0.47826 },
			{ x: 0.63, y: 0.47826 },
			{ x: 0.64, y: 0.47826 },
			{ x: 0.65, y: 0.47826 },
			{ x: 0.66, y: 0.47826 },
			{ x: 0.67, y: 0.47826 },
			{ x: 0.68, y: 0.47826 },
			{ x: 0.69, y: 0.47826 },
			{ x: 0.7, y: 0.47826 },
			{ x: 0.71, y: 0.47826 },
			{ x: 0.72, y: 0.47826 },
			{ x: 0.73, y: 0.47826 },
			{ x: 0.74, y: 0.47826 },
			{ x: 0.75, y: 0.47826 },
			{ x: 0.76, y: 0.47826 },
			{ x: 0.77, y: 0.47826 },
			{ x: 0.78, y: 0.47826 },
			{ x: 0.79, y: 0.47826 },
			{ x: 0.8, y: 0.47826 },
			{ x: 0.81, y: 0.47826 },
			{ x: 0.82, y: 0.47826 },
			{ x: 0.83, y: 0.47826 },
			{ x: 0.84, y: 0.47826 },
			{ x: 0.85, y: 0.47826 },
			{ x: 0.86, y: 0.47826 },
			{ x: 0.87, y: 0.47826 },
			{ x: 0.88, y: 0.47826 },
			{ x: 0.89, y: 0.47826 },
			{ x: 0.9, y: 0.47826 },
			{ x: 0.91, y: 0.47826 },
			{ x: 0.92, y: 0.47826 },
			{ x: 0.93, y: 0.47826 },
			{ x: 0.94, y: 0.47826 },
			{ x: 0.95, y: 0.47826 },
			{ x: 0.96, y: 0.47826 },
			{ x: 0.97, y: 0.47826 },
			{ x: 0.98, y: 0.47826 },
			{ x: 0.99, y: 0.47826 },
			{ x: 0, y: 0.49275 },
			{ x: 0.01, y: 0.49275 },
			{ x: 0.02, y: 0.49275 },
			{ x: 0.03, y: 0.49275 },
			{ x: 0.04, y: 0.49275 },
			{ x: 0.05, y: 0.49275 },
			{ x: 0.06, y: 0.49275 },
			{ x: 0.07, y: 0.49275 },
			{ x: 0.08, y: 0.49275 },
			{ x: 0.09, y: 0.49275 },
			{ x: 0.1, y: 0.49275 },
			{ x: 0.11, y: 0.49275 },
			{ x: 0.12, y: 0.49275 },
			{ x: 0.13, y: 0.49275 },
			{ x: 0.14, y: 0.49275 },
			{ x: 0.15, y: 0.49275 },
			{ x: 0.16, y: 0.49275 },
			{ x: 0.17, y: 0.49275 },
			{ x: 0.18, y: 0.49275 },
			{ x: 0.19, y: 0.49275 },
			{ x: 0.2, y: 0.49275 },
			{ x: 0.21, y: 0.49275 },
			{ x: 0.22, y: 0.49275 },
			{ x: 0.23, y: 0.49275 },
			{ x: 0.24, y: 0.49275 },
			{ x: 0.25, y: 0.49275 },
			{ x: 0.26, y: 0.49275 },
			{ x: 0.27, y: 0.49275 },
			{ x: 0.28, y: 0.49275 },
			{ x: 0.29, y: 0.49275 },
			{ x: 0.3, y: 0.49275 },
			{ x: 0.31, y: 0.49275 },
			{ x: 0.32, y: 0.49275 },
			{ x: 0.33, y: 0.49275 },
			{ x: 0.34, y: 0.49275 },
			{ x: 0.35, y: 0.49275 },
			{ x: 0.36, y: 0.49275 },
			{ x: 0.37, y: 0.49275 },
			{ x: 0.38, y: 0.49275 },
			{ x: 0.39, y: 0.49275 },
			{ x: 0.4, y: 0.49275 },
			{ x: 0.41, y: 0.49275 },
			{ x: 0.42, y: 0.49275 },
			{ x: 0.43, y: 0.49275 },
			{ x: 0.44, y: 0.49275 },
			{ x: 0.45, y: 0.49275 },
			{ x: 0.46, y: 0.49275 },
			{ x: 0.47, y: 0.49275 },
			{ x: 0.48, y: 0.49275 },
			{ x: 0.49, y: 0.49275 },
			{ x: 0.5, y: 0.49275 },
			{ x: 0.51, y: 0.49275 },
			{ x: 0.52, y: 0.49275 },
			{ x: 0.53, y: 0.49275 },
			{ x: 0.54, y: 0.49275 },
			{ x: 0.55, y: 0.49275 },
			{ x: 0.56, y: 0.49275 },
			{ x: 0.57, y: 0.49275 },
			{ x: 0.58, y: 0.49275 },
			{ x: 0.59, y: 0.49275 },
			{ x: 0.6, y: 0.49275 },
			{ x: 0.61, y: 0.49275 },
			{ x: 0.62, y: 0.49275 },
			{ x: 0.63, y: 0.49275 },
			{ x: 0.64, y: 0.49275 },
			{ x: 0.65, y: 0.49275 },
			{ x: 0.66, y: 0.49275 },
			{ x: 0.67, y: 0.49275 },
			{ x: 0.68, y: 0.49275 },
			{ x: 0.69, y: 0.49275 },
			{ x: 0.7, y: 0.49275 },
			{ x: 0.71, y: 0.49275 },
			{ x: 0.72, y: 0.49275 },
			{ x: 0.73, y: 0.49275 },
			{ x: 0.74, y: 0.49275 },
			{ x: 0.75, y: 0.49275 },
			{ x: 0.76, y: 0.49275 },
			{ x: 0.77, y: 0.49275 },
			{ x: 0.78, y: 0.49275 },
			{ x: 0.79, y: 0.49275 },
			{ x: 0.8, y: 0.49275 },
			{ x: 0.81, y: 0.49275 },
			{ x: 0.82, y: 0.49275 },
			{ x: 0.83, y: 0.49275 },
			{ x: 0.84, y: 0.49275 },
			{ x: 0.85, y: 0.49275 },
			{ x: 0.86, y: 0.49275 },
			{ x: 0.87, y: 0.49275 },
			{ x: 0.88, y: 0.49275 },
			{ x: 0.89, y: 0.49275 },
			{ x: 0.9, y: 0.49275 },
			{ x: 0.91, y: 0.49275 },
			{ x: 0.92, y: 0.49275 },
			{ x: 0.93, y: 0.49275 },
			{ x: 0.94, y: 0.49275 },
			{ x: 0.95, y: 0.49275 },
			{ x: 0.96, y: 0.49275 },
			{ x: 0.97, y: 0.49275 },
			{ x: 0.98, y: 0.49275 },
			{ x: 0.99, y: 0.49275 },
			{ x: 0, y: 0.50725 },
			{ x: 0.01, y: 0.50725 },
			{ x: 0.02, y: 0.50725 },
			{ x: 0.03, y: 0.50725 },
			{ x: 0.04, y: 0.50725 },
			{ x: 0.05, y: 0.50725 },
			{ x: 0.06, y: 0.50725 },
			{ x: 0.07, y: 0.50725 },
			{ x: 0.08, y: 0.50725 },
			{ x: 0.09, y: 0.50725 },
			{ x: 0.1, y: 0.50725 },
			{ x: 0.11, y: 0.50725 },
			{ x: 0.12, y: 0.50725 },
			{ x: 0.13, y: 0.50725 },
			{ x: 0.14, y: 0.50725 },
			{ x: 0.15, y: 0.50725 },
			{ x: 0.16, y: 0.50725 },
			{ x: 0.17, y: 0.50725 },
			{ x: 0.18, y: 0.50725 },
			{ x: 0.19, y: 0.50725 },
			{ x: 0.2, y: 0.50725 },
			{ x: 0.21, y: 0.50725 },
			{ x: 0.22, y: 0.50725 },
			{ x: 0.23, y: 0.50725 },
			{ x: 0.24, y: 0.50725 },
			{ x: 0.25, y: 0.50725 },
			{ x: 0.26, y: 0.50725 },
			{ x: 0.27, y: 0.50725 },
			{ x: 0.28, y: 0.50725 },
			{ x: 0.29, y: 0.50725 },
			{ x: 0.3, y: 0.50725 },
			{ x: 0.31, y: 0.50725 },
			{ x: 0.32, y: 0.50725 },
			{ x: 0.33, y: 0.50725 },
			{ x: 0.34, y: 0.50725 },
			{ x: 0.35, y: 0.50725 },
			{ x: 0.36, y: 0.50725 },
			{ x: 0.37, y: 0.50725 },
			{ x: 0.38, y: 0.50725 },
			{ x: 0.39, y: 0.50725 },
			{ x: 0.4, y: 0.50725 },
			{ x: 0.41, y: 0.50725 },
			{ x: 0.42, y: 0.50725 },
			{ x: 0.43, y: 0.50725 },
			{ x: 0.44, y: 0.50725 },
			{ x: 0.45, y: 0.50725 },
			{ x: 0.46, y: 0.50725 },
			{ x: 0.47, y: 0.50725 },
			{ x: 0.48, y: 0.50725 },
			{ x: 0.49, y: 0.50725 },
			{ x: 0.5, y: 0.50725 },
			{ x: 0.51, y: 0.50725 },
			{ x: 0.52, y: 0.50725 },
			{ x: 0.53, y: 0.50725 },
			{ x: 0.54, y: 0.50725 },
			{ x: 0.55, y: 0.50725 },
			{ x: 0.56, y: 0.50725 },
			{ x: 0.57, y: 0.50725 },
			{ x: 0.58, y: 0.50725 },
			{ x: 0.59, y: 0.50725 },
			{ x: 0.6, y: 0.50725 },
			{ x: 0.61, y: 0.50725 },
			{ x: 0.62, y: 0.50725 },
			{ x: 0.63, y: 0.50725 },
			{ x: 0.64, y: 0.50725 },
			{ x: 0.65, y: 0.50725 },
			{ x: 0.66, y: 0.50725 },
			{ x: 0.67, y: 0.50725 },
			{ x: 0.68, y: 0.50725 },
			{ x: 0.69, y: 0.50725 },
			{ x: 0.7, y: 0.50725 },
			{ x: 0.71, y: 0.50725 },
			{ x: 0.72, y: 0.50725 },
			{ x: 0.73, y: 0.50725 },
			{ x: 0.74, y: 0.50725 },
			{ x: 0.75, y: 0.50725 },
			{ x: 0.76, y: 0.50725 },
			{ x: 0.77, y: 0.50725 },
			{ x: 0.78, y: 0.50725 },
			{ x: 0.79, y: 0.50725 },
			{ x: 0.8, y: 0.50725 },
			{ x: 0.81, y: 0.50725 },
			{ x: 0.82, y: 0.50725 },
			{ x: 0.83, y: 0.50725 },
			{ x: 0.84, y: 0.50725 },
			{ x: 0.85, y: 0.50725 },
			{ x: 0.86, y: 0.50725 },
			{ x: 0.87, y: 0.50725 },
			{ x: 0.88, y: 0.50725 },
			{ x: 0.89, y: 0.50725 },
			{ x: 0.9, y: 0.50725 },
			{ x: 0.91, y: 0.50725 },
			{ x: 0.92, y: 0.50725 },
			{ x: 0.93, y: 0.50725 },
			{ x: 0.94, y: 0.50725 },
			{ x: 0.95, y: 0.50725 },
			{ x: 0.96, y: 0.50725 },
			{ x: 0.97, y: 0.50725 },
			{ x: 0.98, y: 0.50725 },
			{ x: 0.99, y: 0.50725 },
			{ x: 0, y: 0.52174 },
			{ x: 0.01, y: 0.52174 },
			{ x: 0.02, y: 0.52174 },
			{ x: 0.03, y: 0.52174 },
			{ x: 0.04, y: 0.52174 },
			{ x: 0.05, y: 0.52174 },
			{ x: 0.06, y: 0.52174 },
			{ x: 0.07, y: 0.52174 },
			{ x: 0.08, y: 0.52174 },
			{ x: 0.09, y: 0.52174 },
			{ x: 0.1, y: 0.52174 },
			{ x: 0.11, y: 0.52174 },
			{ x: 0.12, y: 0.52174 },
			{ x: 0.13, y: 0.52174 },
			{ x: 0.14, y: 0.52174 },
			{ x: 0.15, y: 0.52174 },
			{ x: 0.16, y: 0.52174 },
			{ x: 0.17, y: 0.52174 },
			{ x: 0.18, y: 0.52174 },
			{ x: 0.19, y: 0.52174 },
			{ x: 0.2, y: 0.52174 },
			{ x: 0.21, y: 0.52174 },
			{ x: 0.22, y: 0.52174 },
			{ x: 0.23, y: 0.52174 },
			{ x: 0.24, y: 0.52174 },
			{ x: 0.25, y: 0.52174 },
			{ x: 0.26, y: 0.52174 },
			{ x: 0.27, y: 0.52174 },
			{ x: 0.28, y: 0.52174 },
			{ x: 0.29, y: 0.52174 },
			{ x: 0.3, y: 0.52174 },
			{ x: 0.31, y: 0.52174 },
			{ x: 0.32, y: 0.52174 },
			{ x: 0.33, y: 0.52174 },
			{ x: 0.34, y: 0.52174 },
			{ x: 0.35, y: 0.52174 },
			{ x: 0.36, y: 0.52174 },
			{ x: 0.37, y: 0.52174 },
			{ x: 0.38, y: 0.52174 },
			{ x: 0.39, y: 0.52174 },
			{ x: 0.4, y: 0.52174 },
			{ x: 0.41, y: 0.52174 },
			{ x: 0.42, y: 0.52174 },
			{ x: 0.43, y: 0.52174 },
			{ x: 0.44, y: 0.52174 },
			{ x: 0.45, y: 0.52174 },
			{ x: 0.46, y: 0.52174 },
			{ x: 0.47, y: 0.52174 },
			{ x: 0.48, y: 0.52174 },
			{ x: 0.49, y: 0.52174 },
			{ x: 0.5, y: 0.52174 },
			{ x: 0.51, y: 0.52174 },
			{ x: 0.52, y: 0.52174 },
			{ x: 0.53, y: 0.52174 },
			{ x: 0.54, y: 0.52174 },
			{ x: 0.55, y: 0.52174 },
			{ x: 0.56, y: 0.52174 },
			{ x: 0.57, y: 0.52174 },
			{ x: 0.58, y: 0.52174 },
			{ x: 0.59, y: 0.52174 },
			{ x: 0.6, y: 0.52174 },
			{ x: 0.61, y: 0.52174 },
			{ x: 0.62, y: 0.52174 },
			{ x: 0.63, y: 0.52174 },
			{ x: 0.64, y: 0.52174 },
			{ x: 0.65, y: 0.52174 },
			{ x: 0.66, y: 0.52174 },
			{ x: 0.67, y: 0.52174 },
			{ x: 0.68, y: 0.52174 },
			{ x: 0.69, y: 0.52174 },
			{ x: 0.7, y: 0.52174 },
			{ x: 0.71, y: 0.52174 },
			{ x: 0.72, y: 0.52174 },
			{ x: 0.73, y: 0.52174 },
			{ x: 0.74, y: 0.52174 },
			{ x: 0.75, y: 0.52174 },
			{ x: 0.76, y: 0.52174 },
			{ x: 0.77, y: 0.52174 },
			{ x: 0.78, y: 0.52174 },
			{ x: 0.79, y: 0.52174 },
			{ x: 0.8, y: 0.52174 },
			{ x: 0.81, y: 0.52174 },
			{ x: 0.82, y: 0.52174 },
			{ x: 0.83, y: 0.52174 },
			{ x: 0.84, y: 0.52174 },
			{ x: 0.85, y: 0.52174 },
			{ x: 0.86, y: 0.52174 },
			{ x: 0.87, y: 0.52174 },
			{ x: 0.88, y: 0.52174 },
			{ x: 0.89, y: 0.52174 },
			{ x: 0.9, y: 0.52174 },
			{ x: 0.91, y: 0.52174 },
			{ x: 0.92, y: 0.52174 },
			{ x: 0.93, y: 0.52174 },
			{ x: 0.94, y: 0.52174 },
			{ x: 0.95, y: 0.52174 },
			{ x: 0.96, y: 0.52174 },
			{ x: 0.97, y: 0.52174 },
			{ x: 0.98, y: 0.52174 },
			{ x: 0.99, y: 0.52174 },
			{ x: 0, y: 0.53623 },
			{ x: 0.01, y: 0.53623 },
			{ x: 0.02, y: 0.53623 },
			{ x: 0.03, y: 0.53623 },
			{ x: 0.04, y: 0.53623 },
			{ x: 0.05, y: 0.53623 },
			{ x: 0.06, y: 0.53623 },
			{ x: 0.07, y: 0.53623 },
			{ x: 0.08, y: 0.53623 },
			{ x: 0.09, y: 0.53623 },
			{ x: 0.1, y: 0.53623 },
			{ x: 0.11, y: 0.53623 },
			{ x: 0.12, y: 0.53623 },
			{ x: 0.13, y: 0.53623 },
			{ x: 0.14, y: 0.53623 },
			{ x: 0.15, y: 0.53623 },
			{ x: 0.16, y: 0.53623 },
			{ x: 0.17, y: 0.53623 },
			{ x: 0.18, y: 0.53623 },
			{ x: 0.19, y: 0.53623 },
			{ x: 0.2, y: 0.53623 },
			{ x: 0.21, y: 0.53623 },
			{ x: 0.22, y: 0.53623 },
			{ x: 0.23, y: 0.53623 },
			{ x: 0.24, y: 0.53623 },
			{ x: 0.25, y: 0.53623 },
			{ x: 0.26, y: 0.53623 },
			{ x: 0.27, y: 0.53623 },
			{ x: 0.28, y: 0.53623 },
			{ x: 0.29, y: 0.53623 },
			{ x: 0.3, y: 0.53623 },
			{ x: 0.31, y: 0.53623 },
			{ x: 0.32, y: 0.53623 },
			{ x: 0.33, y: 0.53623 },
			{ x: 0.34, y: 0.53623 },
			{ x: 0.35, y: 0.53623 },
			{ x: 0.36, y: 0.53623 },
			{ x: 0.37, y: 0.53623 },
			{ x: 0.38, y: 0.53623 },
			{ x: 0.39, y: 0.53623 },
			{ x: 0.4, y: 0.53623 },
			{ x: 0.41, y: 0.53623 },
			{ x: 0.42, y: 0.53623 },
			{ x: 0.43, y: 0.53623 },
			{ x: 0.44, y: 0.53623 },
			{ x: 0.45, y: 0.53623 },
			{ x: 0.46, y: 0.53623 },
			{ x: 0.47, y: 0.53623 },
			{ x: 0.48, y: 0.53623 },
			{ x: 0.49, y: 0.53623 },
			{ x: 0.5, y: 0.53623 },
			{ x: 0.51, y: 0.53623 },
			{ x: 0.52, y: 0.53623 },
			{ x: 0.53, y: 0.53623 },
			{ x: 0.54, y: 0.53623 },
			{ x: 0.55, y: 0.53623 },
			{ x: 0.56, y: 0.53623 },
			{ x: 0.57, y: 0.53623 },
			{ x: 0.58, y: 0.53623 },
			{ x: 0.59, y: 0.53623 },
			{ x: 0.6, y: 0.53623 },
			{ x: 0.61, y: 0.53623 },
			{ x: 0.62, y: 0.53623 },
			{ x: 0.63, y: 0.53623 },
			{ x: 0.64, y: 0.53623 },
			{ x: 0.65, y: 0.53623 },
			{ x: 0.66, y: 0.53623 },
			{ x: 0.67, y: 0.53623 },
			{ x: 0.68, y: 0.53623 },
			{ x: 0.69, y: 0.53623 },
			{ x: 0.7, y: 0.53623 },
			{ x: 0.71, y: 0.53623 },
			{ x: 0.72, y: 0.53623 },
			{ x: 0.73, y: 0.53623 },
			{ x: 0.74, y: 0.53623 },
			{ x: 0.75, y: 0.53623 },
			{ x: 0.76, y: 0.53623 },
			{ x: 0.77, y: 0.53623 },
			{ x: 0.78, y: 0.53623 },
			{ x: 0.79, y: 0.53623 },
			{ x: 0.8, y: 0.53623 },
			{ x: 0.81, y: 0.53623 },
			{ x: 0.82, y: 0.53623 },
			{ x: 0.83, y: 0.53623 },
			{ x: 0.84, y: 0.53623 },
			{ x: 0.85, y: 0.53623 },
			{ x: 0.86, y: 0.53623 },
			{ x: 0.87, y: 0.53623 },
			{ x: 0.88, y: 0.53623 },
			{ x: 0.89, y: 0.53623 },
			{ x: 0.9, y: 0.53623 },
			{ x: 0.91, y: 0.53623 },
			{ x: 0.92, y: 0.53623 },
			{ x: 0.93, y: 0.53623 },
			{ x: 0.94, y: 0.53623 },
			{ x: 0.95, y: 0.53623 },
			{ x: 0.96, y: 0.53623 },
			{ x: 0.97, y: 0.53623 },
			{ x: 0.98, y: 0.53623 },
			{ x: 0.99, y: 0.53623 },
			{ x: 0, y: 0.55072 },
			{ x: 0.01, y: 0.55072 },
			{ x: 0.02, y: 0.55072 },
			{ x: 0.03, y: 0.55072 },
			{ x: 0.04, y: 0.55072 },
			{ x: 0.05, y: 0.55072 },
			{ x: 0.06, y: 0.55072 },
			{ x: 0.07, y: 0.55072 },
			{ x: 0.08, y: 0.55072 },
			{ x: 0.09, y: 0.55072 },
			{ x: 0.1, y: 0.55072 },
			{ x: 0.11, y: 0.55072 },
			{ x: 0.12, y: 0.55072 },
			{ x: 0.13, y: 0.55072 },
			{ x: 0.14, y: 0.55072 },
			{ x: 0.15, y: 0.55072 },
			{ x: 0.16, y: 0.55072 },
			{ x: 0.17, y: 0.55072 },
			{ x: 0.18, y: 0.55072 },
			{ x: 0.19, y: 0.55072 },
			{ x: 0.2, y: 0.55072 },
			{ x: 0.21, y: 0.55072 },
			{ x: 0.22, y: 0.55072 },
			{ x: 0.23, y: 0.55072 },
			{ x: 0.24, y: 0.55072 },
			{ x: 0.25, y: 0.55072 },
			{ x: 0.26, y: 0.55072 },
			{ x: 0.27, y: 0.55072 },
			{ x: 0.28, y: 0.55072 },
			{ x: 0.29, y: 0.55072 },
			{ x: 0.3, y: 0.55072 },
			{ x: 0.31, y: 0.55072 },
			{ x: 0.32, y: 0.55072 },
			{ x: 0.33, y: 0.55072 },
			{ x: 0.34, y: 0.55072 },
			{ x: 0.35, y: 0.55072 },
			{ x: 0.36, y: 0.55072 },
			{ x: 0.37, y: 0.55072 },
			{ x: 0.38, y: 0.55072 },
			{ x: 0.39, y: 0.55072 },
			{ x: 0.4, y: 0.55072 },
			{ x: 0.41, y: 0.55072 },
			{ x: 0.42, y: 0.55072 },
			{ x: 0.43, y: 0.55072 },
			{ x: 0.44, y: 0.55072 },
			{ x: 0.45, y: 0.55072 },
			{ x: 0.46, y: 0.55072 },
			{ x: 0.47, y: 0.55072 },
			{ x: 0.48, y: 0.55072 },
			{ x: 0.49, y: 0.55072 },
			{ x: 0.5, y: 0.55072 },
			{ x: 0.51, y: 0.55072 },
			{ x: 0.52, y: 0.55072 },
			{ x: 0.53, y: 0.55072 },
			{ x: 0.54, y: 0.55072 },
			{ x: 0.55, y: 0.55072 },
			{ x: 0.56, y: 0.55072 },
			{ x: 0.57, y: 0.55072 },
			{ x: 0.58, y: 0.55072 },
			{ x: 0.59, y: 0.55072 },
			{ x: 0.6, y: 0.55072 },
			{ x: 0.61, y: 0.55072 },
			{ x: 0.62, y: 0.55072 },
			{ x: 0.63, y: 0.55072 },
			{ x: 0.64, y: 0.55072 },
			{ x: 0.65, y: 0.55072 },
			{ x: 0.66, y: 0.55072 },
			{ x: 0.67, y: 0.55072 },
			{ x: 0.68, y: 0.55072 },
			{ x: 0.69, y: 0.55072 },
			{ x: 0.7, y: 0.55072 },
			{ x: 0.71, y: 0.55072 },
			{ x: 0.72, y: 0.55072 },
			{ x: 0.73, y: 0.55072 },
			{ x: 0.74, y: 0.55072 },
			{ x: 0.75, y: 0.55072 },
			{ x: 0.76, y: 0.55072 },
			{ x: 0.77, y: 0.55072 },
			{ x: 0.78, y: 0.55072 },
			{ x: 0.79, y: 0.55072 },
			{ x: 0.8, y: 0.55072 },
			{ x: 0.81, y: 0.55072 },
			{ x: 0.82, y: 0.55072 },
			{ x: 0.83, y: 0.55072 },
			{ x: 0.84, y: 0.55072 },
			{ x: 0.85, y: 0.55072 },
			{ x: 0.86, y: 0.55072 },
			{ x: 0.87, y: 0.55072 },
			{ x: 0.88, y: 0.55072 },
			{ x: 0.89, y: 0.55072 },
			{ x: 0.9, y: 0.55072 },
			{ x: 0.91, y: 0.55072 },
			{ x: 0.92, y: 0.55072 },
			{ x: 0.93, y: 0.55072 },
			{ x: 0.94, y: 0.55072 },
			{ x: 0.95, y: 0.55072 },
			{ x: 0.96, y: 0.55072 },
			{ x: 0.97, y: 0.55072 },
			{ x: 0.98, y: 0.55072 },
			{ x: 0.99, y: 0.55072 },
			{ x: 0, y: 0.56522 },
			{ x: 0.01, y: 0.56522 },
			{ x: 0.02, y: 0.56522 },
			{ x: 0.03, y: 0.56522 },
			{ x: 0.04, y: 0.56522 },
			{ x: 0.05, y: 0.56522 },
			{ x: 0.06, y: 0.56522 },
			{ x: 0.07, y: 0.56522 },
			{ x: 0.08, y: 0.56522 },
			{ x: 0.09, y: 0.56522 },
			{ x: 0.1, y: 0.56522 },
			{ x: 0.11, y: 0.56522 },
			{ x: 0.12, y: 0.56522 },
			{ x: 0.13, y: 0.56522 },
			{ x: 0.14, y: 0.56522 },
			{ x: 0.15, y: 0.56522 },
			{ x: 0.16, y: 0.56522 },
			{ x: 0.17, y: 0.56522 },
			{ x: 0.18, y: 0.56522 },
			{ x: 0.19, y: 0.56522 },
			{ x: 0.2, y: 0.56522 },
			{ x: 0.21, y: 0.56522 },
			{ x: 0.22, y: 0.56522 },
			{ x: 0.23, y: 0.56522 },
			{ x: 0.24, y: 0.56522 },
			{ x: 0.25, y: 0.56522 },
			{ x: 0.26, y: 0.56522 },
			{ x: 0.27, y: 0.56522 },
			{ x: 0.28, y: 0.56522 },
			{ x: 0.29, y: 0.56522 },
			{ x: 0.3, y: 0.56522 },
			{ x: 0.31, y: 0.56522 },
			{ x: 0.32, y: 0.56522 },
			{ x: 0.33, y: 0.56522 },
			{ x: 0.34, y: 0.56522 },
			{ x: 0.35, y: 0.56522 },
			{ x: 0.36, y: 0.56522 },
			{ x: 0.37, y: 0.56522 },
			{ x: 0.38, y: 0.56522 },
			{ x: 0.39, y: 0.56522 },
			{ x: 0.4, y: 0.56522 },
			{ x: 0.41, y: 0.56522 },
			{ x: 0.42, y: 0.56522 },
			{ x: 0.43, y: 0.56522 },
			{ x: 0.44, y: 0.56522 },
			{ x: 0.45, y: 0.56522 },
			{ x: 0.46, y: 0.56522 },
			{ x: 0.47, y: 0.56522 },
			{ x: 0.48, y: 0.56522 },
			{ x: 0.49, y: 0.56522 },
			{ x: 0.5, y: 0.56522 },
			{ x: 0.51, y: 0.56522 },
			{ x: 0.52, y: 0.56522 },
			{ x: 0.53, y: 0.56522 },
			{ x: 0.54, y: 0.56522 },
			{ x: 0.55, y: 0.56522 },
			{ x: 0.56, y: 0.56522 },
			{ x: 0.57, y: 0.56522 },
			{ x: 0.58, y: 0.56522 },
			{ x: 0.59, y: 0.56522 },
			{ x: 0.6, y: 0.56522 },
			{ x: 0.61, y: 0.56522 },
			{ x: 0.62, y: 0.56522 },
			{ x: 0.63, y: 0.56522 },
			{ x: 0.64, y: 0.56522 },
			{ x: 0.65, y: 0.56522 },
			{ x: 0.66, y: 0.56522 },
			{ x: 0.67, y: 0.56522 },
			{ x: 0.68, y: 0.56522 },
			{ x: 0.69, y: 0.56522 },
			{ x: 0.7, y: 0.56522 },
			{ x: 0.71, y: 0.56522 },
			{ x: 0.72, y: 0.56522 },
			{ x: 0.73, y: 0.56522 },
			{ x: 0.74, y: 0.56522 },
			{ x: 0.75, y: 0.56522 },
			{ x: 0.76, y: 0.56522 },
			{ x: 0.77, y: 0.56522 },
			{ x: 0.78, y: 0.56522 },
			{ x: 0.79, y: 0.56522 },
			{ x: 0.8, y: 0.56522 },
			{ x: 0.81, y: 0.56522 },
			{ x: 0.82, y: 0.56522 },
			{ x: 0.83, y: 0.56522 },
			{ x: 0.84, y: 0.56522 },
			{ x: 0.85, y: 0.56522 },
			{ x: 0.86, y: 0.56522 },
			{ x: 0.87, y: 0.56522 },
			{ x: 0.88, y: 0.56522 },
			{ x: 0.89, y: 0.56522 },
			{ x: 0.9, y: 0.56522 },
			{ x: 0.91, y: 0.56522 },
			{ x: 0.92, y: 0.56522 },
			{ x: 0.93, y: 0.56522 },
			{ x: 0.94, y: 0.56522 },
			{ x: 0.95, y: 0.56522 },
			{ x: 0.96, y: 0.56522 },
			{ x: 0.97, y: 0.56522 },
			{ x: 0.98, y: 0.56522 },
			{ x: 0.99, y: 0.56522 },
			{ x: 0, y: 0.57971 },
			{ x: 0.01, y: 0.57971 },
			{ x: 0.02, y: 0.57971 },
			{ x: 0.03, y: 0.57971 },
			{ x: 0.04, y: 0.57971 },
			{ x: 0.05, y: 0.57971 },
			{ x: 0.06, y: 0.57971 },
			{ x: 0.07, y: 0.57971 },
			{ x: 0.08, y: 0.57971 },
			{ x: 0.09, y: 0.57971 },
			{ x: 0.1, y: 0.57971 },
			{ x: 0.11, y: 0.57971 },
			{ x: 0.12, y: 0.57971 },
			{ x: 0.13, y: 0.57971 },
			{ x: 0.14, y: 0.57971 },
			{ x: 0.15, y: 0.57971 },
			{ x: 0.16, y: 0.57971 },
			{ x: 0.17, y: 0.57971 },
			{ x: 0.18, y: 0.57971 },
			{ x: 0.19, y: 0.57971 },
			{ x: 0.2, y: 0.57971 },
			{ x: 0.21, y: 0.57971 },
			{ x: 0.22, y: 0.57971 },
			{ x: 0.23, y: 0.57971 },
			{ x: 0.24, y: 0.57971 },
			{ x: 0.25, y: 0.57971 },
			{ x: 0.26, y: 0.57971 },
			{ x: 0.27, y: 0.57971 },
			{ x: 0.28, y: 0.57971 },
			{ x: 0.29, y: 0.57971 },
			{ x: 0.3, y: 0.57971 },
			{ x: 0.31, y: 0.57971 },
			{ x: 0.32, y: 0.57971 },
			{ x: 0.33, y: 0.57971 },
			{ x: 0.34, y: 0.57971 },
			{ x: 0.35, y: 0.57971 },
			{ x: 0.36, y: 0.57971 },
			{ x: 0.37, y: 0.57971 },
			{ x: 0.38, y: 0.57971 },
			{ x: 0.39, y: 0.57971 },
			{ x: 0.4, y: 0.57971 },
			{ x: 0.41, y: 0.57971 },
			{ x: 0.42, y: 0.57971 },
			{ x: 0.43, y: 0.57971 },
			{ x: 0.44, y: 0.57971 },
			{ x: 0.45, y: 0.57971 },
			{ x: 0.46, y: 0.57971 },
			{ x: 0.47, y: 0.57971 },
			{ x: 0.48, y: 0.57971 },
			{ x: 0.49, y: 0.57971 },
			{ x: 0.5, y: 0.57971 },
			{ x: 0.51, y: 0.57971 },
			{ x: 0.52, y: 0.57971 },
			{ x: 0.53, y: 0.57971 },
			{ x: 0.54, y: 0.57971 },
			{ x: 0.55, y: 0.57971 },
			{ x: 0.56, y: 0.57971 },
			{ x: 0.57, y: 0.57971 },
			{ x: 0.58, y: 0.57971 },
			{ x: 0.59, y: 0.57971 },
			{ x: 0.6, y: 0.57971 },
			{ x: 0.61, y: 0.57971 },
			{ x: 0.62, y: 0.57971 },
			{ x: 0.63, y: 0.57971 },
			{ x: 0.64, y: 0.57971 },
			{ x: 0.65, y: 0.57971 },
			{ x: 0.66, y: 0.57971 },
			{ x: 0.67, y: 0.57971 },
			{ x: 0.68, y: 0.57971 },
			{ x: 0.69, y: 0.57971 },
			{ x: 0.7, y: 0.57971 },
			{ x: 0.71, y: 0.57971 },
			{ x: 0.72, y: 0.57971 },
			{ x: 0.73, y: 0.57971 },
			{ x: 0.74, y: 0.57971 },
			{ x: 0.75, y: 0.57971 },
			{ x: 0.76, y: 0.57971 },
			{ x: 0.77, y: 0.57971 },
			{ x: 0.78, y: 0.57971 },
			{ x: 0.79, y: 0.57971 },
			{ x: 0.8, y: 0.57971 },
			{ x: 0.81, y: 0.57971 },
			{ x: 0.82, y: 0.57971 },
			{ x: 0.83, y: 0.57971 },
			{ x: 0.84, y: 0.57971 },
			{ x: 0.85, y: 0.57971 },
			{ x: 0.86, y: 0.57971 },
			{ x: 0.87, y: 0.57971 },
			{ x: 0.88, y: 0.57971 },
			{ x: 0.89, y: 0.57971 },
			{ x: 0.9, y: 0.57971 },
			{ x: 0.91, y: 0.57971 },
			{ x: 0.92, y: 0.57971 },
			{ x: 0.93, y: 0.57971 },
			{ x: 0.94, y: 0.57971 },
			{ x: 0.95, y: 0.57971 },
			{ x: 0.96, y: 0.57971 },
			{ x: 0.97, y: 0.57971 },
			{ x: 0.98, y: 0.57971 },
			{ x: 0.99, y: 0.57971 },
			{ x: 0, y: 0.5942 },
			{ x: 0.01, y: 0.5942 },
			{ x: 0.02, y: 0.5942 },
			{ x: 0.03, y: 0.5942 },
			{ x: 0.04, y: 0.5942 },
			{ x: 0.05, y: 0.5942 },
			{ x: 0.06, y: 0.5942 },
			{ x: 0.07, y: 0.5942 },
			{ x: 0.08, y: 0.5942 },
			{ x: 0.09, y: 0.5942 },
			{ x: 0.1, y: 0.5942 },
			{ x: 0.11, y: 0.5942 },
			{ x: 0.12, y: 0.5942 },
			{ x: 0.13, y: 0.5942 },
			{ x: 0.14, y: 0.5942 },
			{ x: 0.15, y: 0.5942 },
			{ x: 0.16, y: 0.5942 },
			{ x: 0.17, y: 0.5942 },
			{ x: 0.18, y: 0.5942 },
			{ x: 0.19, y: 0.5942 },
			{ x: 0.2, y: 0.5942 },
			{ x: 0.21, y: 0.5942 },
			{ x: 0.22, y: 0.5942 },
			{ x: 0.23, y: 0.5942 },
			{ x: 0.24, y: 0.5942 },
			{ x: 0.25, y: 0.5942 },
			{ x: 0.26, y: 0.5942 },
			{ x: 0.27, y: 0.5942 },
			{ x: 0.28, y: 0.5942 },
			{ x: 0.29, y: 0.5942 },
			{ x: 0.3, y: 0.5942 },
			{ x: 0.31, y: 0.5942 },
			{ x: 0.32, y: 0.5942 },
			{ x: 0.33, y: 0.5942 },
			{ x: 0.34, y: 0.5942 },
			{ x: 0.35, y: 0.5942 },
			{ x: 0.36, y: 0.5942 },
			{ x: 0.37, y: 0.5942 },
			{ x: 0.38, y: 0.5942 },
			{ x: 0.39, y: 0.5942 },
			{ x: 0.4, y: 0.5942 },
			{ x: 0.41, y: 0.5942 },
			{ x: 0.42, y: 0.5942 },
			{ x: 0.43, y: 0.5942 },
			{ x: 0.44, y: 0.5942 },
			{ x: 0.45, y: 0.5942 },
			{ x: 0.46, y: 0.5942 },
			{ x: 0.47, y: 0.5942 },
			{ x: 0.48, y: 0.5942 },
			{ x: 0.49, y: 0.5942 },
			{ x: 0.5, y: 0.5942 },
			{ x: 0.51, y: 0.5942 },
			{ x: 0.52, y: 0.5942 },
			{ x: 0.53, y: 0.5942 },
			{ x: 0.54, y: 0.5942 },
			{ x: 0.55, y: 0.5942 },
			{ x: 0.56, y: 0.5942 },
			{ x: 0.57, y: 0.5942 },
			{ x: 0.58, y: 0.5942 },
			{ x: 0.59, y: 0.5942 },
			{ x: 0.6, y: 0.5942 },
			{ x: 0.61, y: 0.5942 },
			{ x: 0.62, y: 0.5942 },
			{ x: 0.63, y: 0.5942 },
			{ x: 0.64, y: 0.5942 },
			{ x: 0.65, y: 0.5942 },
			{ x: 0.66, y: 0.5942 },
			{ x: 0.67, y: 0.5942 },
			{ x: 0.68, y: 0.5942 },
			{ x: 0.69, y: 0.5942 },
			{ x: 0.7, y: 0.5942 },
			{ x: 0.71, y: 0.5942 },
			{ x: 0.72, y: 0.5942 },
			{ x: 0.73, y: 0.5942 },
			{ x: 0.74, y: 0.5942 },
			{ x: 0.75, y: 0.5942 },
			{ x: 0.76, y: 0.5942 },
			{ x: 0.77, y: 0.5942 },
			{ x: 0.78, y: 0.5942 },
			{ x: 0.79, y: 0.5942 },
			{ x: 0.8, y: 0.5942 },
			{ x: 0.81, y: 0.5942 },
			{ x: 0.82, y: 0.5942 },
			{ x: 0.83, y: 0.5942 },
			{ x: 0.84, y: 0.5942 },
			{ x: 0.85, y: 0.5942 },
			{ x: 0.86, y: 0.5942 },
			{ x: 0.87, y: 0.5942 },
			{ x: 0.88, y: 0.5942 },
			{ x: 0.89, y: 0.5942 },
			{ x: 0.9, y: 0.5942 },
			{ x: 0.91, y: 0.5942 },
			{ x: 0.92, y: 0.5942 },
			{ x: 0.93, y: 0.5942 },
			{ x: 0.94, y: 0.5942 },
			{ x: 0.95, y: 0.5942 },
			{ x: 0.96, y: 0.5942 },
			{ x: 0.97, y: 0.5942 },
			{ x: 0.98, y: 0.5942 },
			{ x: 0.99, y: 0.5942 },
			{ x: 0, y: 0.6087 },
			{ x: 0.01, y: 0.6087 },
			{ x: 0.02, y: 0.6087 },
			{ x: 0.03, y: 0.6087 },
			{ x: 0.04, y: 0.6087 },
			{ x: 0.05, y: 0.6087 },
			{ x: 0.06, y: 0.6087 },
			{ x: 0.07, y: 0.6087 },
			{ x: 0.08, y: 0.6087 },
			{ x: 0.09, y: 0.6087 },
			{ x: 0.1, y: 0.6087 },
			{ x: 0.11, y: 0.6087 },
			{ x: 0.12, y: 0.6087 },
			{ x: 0.13, y: 0.6087 },
			{ x: 0.14, y: 0.6087 },
			{ x: 0.15, y: 0.6087 },
			{ x: 0.16, y: 0.6087 },
			{ x: 0.17, y: 0.6087 },
			{ x: 0.18, y: 0.6087 },
			{ x: 0.19, y: 0.6087 },
			{ x: 0.2, y: 0.6087 },
			{ x: 0.21, y: 0.6087 },
			{ x: 0.22, y: 0.6087 },
			{ x: 0.23, y: 0.6087 },
			{ x: 0.24, y: 0.6087 },
			{ x: 0.25, y: 0.6087 },
			{ x: 0.26, y: 0.6087 },
			{ x: 0.27, y: 0.6087 },
			{ x: 0.28, y: 0.6087 },
			{ x: 0.29, y: 0.6087 },
			{ x: 0.3, y: 0.6087 },
			{ x: 0.31, y: 0.6087 },
			{ x: 0.32, y: 0.6087 },
			{ x: 0.33, y: 0.6087 },
			{ x: 0.34, y: 0.6087 },
			{ x: 0.35, y: 0.6087 },
			{ x: 0.36, y: 0.6087 },
			{ x: 0.37, y: 0.6087 },
			{ x: 0.38, y: 0.6087 },
			{ x: 0.39, y: 0.6087 },
			{ x: 0.4, y: 0.6087 },
			{ x: 0.41, y: 0.6087 },
			{ x: 0.42, y: 0.6087 },
			{ x: 0.43, y: 0.6087 },
			{ x: 0.44, y: 0.6087 },
			{ x: 0.45, y: 0.6087 },
			{ x: 0.46, y: 0.6087 },
			{ x: 0.47, y: 0.6087 },
			{ x: 0.48, y: 0.6087 },
			{ x: 0.49, y: 0.6087 },
			{ x: 0.5, y: 0.6087 },
			{ x: 0.51, y: 0.6087 },
			{ x: 0.52, y: 0.6087 },
			{ x: 0.53, y: 0.6087 },
			{ x: 0.54, y: 0.6087 },
			{ x: 0.55, y: 0.6087 },
			{ x: 0.56, y: 0.6087 },
			{ x: 0.57, y: 0.6087 },
			{ x: 0.58, y: 0.6087 },
			{ x: 0.59, y: 0.6087 },
			{ x: 0.6, y: 0.6087 },
			{ x: 0.61, y: 0.6087 },
			{ x: 0.62, y: 0.6087 },
			{ x: 0.63, y: 0.6087 },
			{ x: 0.64, y: 0.6087 },
			{ x: 0.65, y: 0.6087 },
			{ x: 0.66, y: 0.6087 },
			{ x: 0.67, y: 0.6087 },
			{ x: 0.68, y: 0.6087 },
			{ x: 0.69, y: 0.6087 },
			{ x: 0.7, y: 0.6087 },
			{ x: 0.71, y: 0.6087 },
			{ x: 0.72, y: 0.6087 },
			{ x: 0.73, y: 0.6087 },
			{ x: 0.74, y: 0.6087 },
			{ x: 0.75, y: 0.6087 },
			{ x: 0.76, y: 0.6087 },
			{ x: 0.77, y: 0.6087 },
			{ x: 0.78, y: 0.6087 },
			{ x: 0.79, y: 0.6087 },
			{ x: 0.8, y: 0.6087 },
			{ x: 0.81, y: 0.6087 },
			{ x: 0.82, y: 0.6087 },
			{ x: 0.83, y: 0.6087 },
			{ x: 0.84, y: 0.6087 },
			{ x: 0.85, y: 0.6087 },
			{ x: 0.86, y: 0.6087 },
			{ x: 0.87, y: 0.6087 },
			{ x: 0.88, y: 0.6087 },
			{ x: 0.89, y: 0.6087 },
			{ x: 0.9, y: 0.6087 },
			{ x: 0.91, y: 0.6087 },
			{ x: 0.92, y: 0.6087 },
			{ x: 0.93, y: 0.6087 },
			{ x: 0.94, y: 0.6087 },
			{ x: 0.95, y: 0.6087 },
			{ x: 0.96, y: 0.6087 },
			{ x: 0.97, y: 0.6087 },
			{ x: 0.98, y: 0.6087 },
			{ x: 0.99, y: 0.6087 },
			{ x: 0, y: 0.62319 },
			{ x: 0.01, y: 0.62319 },
			{ x: 0.02, y: 0.62319 },
			{ x: 0.03, y: 0.62319 },
			{ x: 0.04, y: 0.62319 },
			{ x: 0.05, y: 0.62319 },
			{ x: 0.06, y: 0.62319 },
			{ x: 0.07, y: 0.62319 },
			{ x: 0.08, y: 0.62319 },
			{ x: 0.09, y: 0.62319 },
			{ x: 0.1, y: 0.62319 },
			{ x: 0.11, y: 0.62319 },
			{ x: 0.12, y: 0.62319 },
			{ x: 0.13, y: 0.62319 },
			{ x: 0.14, y: 0.62319 },
			{ x: 0.15, y: 0.62319 },
			{ x: 0.16, y: 0.62319 },
			{ x: 0.17, y: 0.62319 },
			{ x: 0.18, y: 0.62319 },
			{ x: 0.19, y: 0.62319 },
			{ x: 0.2, y: 0.62319 },
			{ x: 0.21, y: 0.62319 },
			{ x: 0.22, y: 0.62319 },
			{ x: 0.23, y: 0.62319 },
			{ x: 0.24, y: 0.62319 },
			{ x: 0.25, y: 0.62319 },
			{ x: 0.26, y: 0.62319 },
			{ x: 0.27, y: 0.62319 },
			{ x: 0.28, y: 0.62319 },
			{ x: 0.29, y: 0.62319 },
			{ x: 0.3, y: 0.62319 },
			{ x: 0.31, y: 0.62319 },
			{ x: 0.32, y: 0.62319 },
			{ x: 0.33, y: 0.62319 },
			{ x: 0.34, y: 0.62319 },
			{ x: 0.35, y: 0.62319 },
			{ x: 0.36, y: 0.62319 },
			{ x: 0.37, y: 0.62319 },
			{ x: 0.38, y: 0.62319 },
			{ x: 0.39, y: 0.62319 },
			{ x: 0.4, y: 0.62319 },
			{ x: 0.41, y: 0.62319 },
			{ x: 0.42, y: 0.62319 },
			{ x: 0.43, y: 0.62319 },
			{ x: 0.44, y: 0.62319 },
			{ x: 0.45, y: 0.62319 },
			{ x: 0.46, y: 0.62319 },
			{ x: 0.47, y: 0.62319 },
			{ x: 0.48, y: 0.62319 },
			{ x: 0.49, y: 0.62319 },
			{ x: 0.5, y: 0.62319 },
			{ x: 0.51, y: 0.62319 },
			{ x: 0.52, y: 0.62319 },
			{ x: 0.53, y: 0.62319 },
			{ x: 0.54, y: 0.62319 },
			{ x: 0.55, y: 0.62319 },
			{ x: 0.56, y: 0.62319 },
			{ x: 0.57, y: 0.62319 },
			{ x: 0.58, y: 0.62319 },
			{ x: 0.59, y: 0.62319 },
			{ x: 0.6, y: 0.62319 },
			{ x: 0.61, y: 0.62319 },
			{ x: 0.62, y: 0.62319 },
			{ x: 0.63, y: 0.62319 },
			{ x: 0.64, y: 0.62319 },
			{ x: 0.65, y: 0.62319 },
			{ x: 0.66, y: 0.62319 },
			{ x: 0.67, y: 0.62319 },
			{ x: 0.68, y: 0.62319 },
			{ x: 0.69, y: 0.62319 },
			{ x: 0.7, y: 0.62319 },
			{ x: 0.71, y: 0.62319 },
			{ x: 0.72, y: 0.62319 },
			{ x: 0.73, y: 0.62319 },
			{ x: 0.74, y: 0.62319 },
			{ x: 0.75, y: 0.62319 },
			{ x: 0.76, y: 0.62319 },
			{ x: 0.77, y: 0.62319 },
			{ x: 0.78, y: 0.62319 },
			{ x: 0.79, y: 0.62319 },
			{ x: 0.8, y: 0.62319 },
			{ x: 0.81, y: 0.62319 },
			{ x: 0.82, y: 0.62319 },
			{ x: 0.83, y: 0.62319 },
			{ x: 0.84, y: 0.62319 },
			{ x: 0.85, y: 0.62319 },
			{ x: 0.86, y: 0.62319 },
			{ x: 0.87, y: 0.62319 },
			{ x: 0.88, y: 0.62319 },
			{ x: 0.89, y: 0.62319 },
			{ x: 0.9, y: 0.62319 },
			{ x: 0.91, y: 0.62319 },
			{ x: 0.92, y: 0.62319 },
			{ x: 0.93, y: 0.62319 },
			{ x: 0.94, y: 0.62319 },
			{ x: 0.95, y: 0.62319 },
			{ x: 0.96, y: 0.62319 },
			{ x: 0.97, y: 0.62319 },
			{ x: 0.98, y: 0.62319 },
			{ x: 0.99, y: 0.62319 },
			{ x: 0, y: 0.63768 },
			{ x: 0.01, y: 0.63768 },
			{ x: 0.02, y: 0.63768 },
			{ x: 0.03, y: 0.63768 },
			{ x: 0.04, y: 0.63768 },
			{ x: 0.05, y: 0.63768 },
			{ x: 0.06, y: 0.63768 },
			{ x: 0.07, y: 0.63768 },
			{ x: 0.08, y: 0.63768 },
			{ x: 0.09, y: 0.63768 },
			{ x: 0.1, y: 0.63768 },
			{ x: 0.11, y: 0.63768 },
			{ x: 0.12, y: 0.63768 },
			{ x: 0.13, y: 0.63768 },
			{ x: 0.14, y: 0.63768 },
			{ x: 0.15, y: 0.63768 },
			{ x: 0.16, y: 0.63768 },
			{ x: 0.17, y: 0.63768 },
			{ x: 0.18, y: 0.63768 },
			{ x: 0.19, y: 0.63768 },
			{ x: 0.2, y: 0.63768 },
			{ x: 0.21, y: 0.63768 },
			{ x: 0.22, y: 0.63768 },
			{ x: 0.23, y: 0.63768 },
			{ x: 0.24, y: 0.63768 },
			{ x: 0.25, y: 0.63768 },
			{ x: 0.26, y: 0.63768 },
			{ x: 0.27, y: 0.63768 },
			{ x: 0.28, y: 0.63768 },
			{ x: 0.29, y: 0.63768 },
			{ x: 0.3, y: 0.63768 },
			{ x: 0.31, y: 0.63768 },
			{ x: 0.32, y: 0.63768 },
			{ x: 0.33, y: 0.63768 },
			{ x: 0.34, y: 0.63768 },
			{ x: 0.35, y: 0.63768 },
			{ x: 0.36, y: 0.63768 },
			{ x: 0.37, y: 0.63768 },
			{ x: 0.38, y: 0.63768 },
			{ x: 0.39, y: 0.63768 },
			{ x: 0.4, y: 0.63768 },
			{ x: 0.41, y: 0.63768 },
			{ x: 0.42, y: 0.63768 },
			{ x: 0.43, y: 0.63768 },
			{ x: 0.44, y: 0.63768 },
			{ x: 0.45, y: 0.63768 },
			{ x: 0.46, y: 0.63768 },
			{ x: 0.47, y: 0.63768 },
			{ x: 0.48, y: 0.63768 },
			{ x: 0.49, y: 0.63768 },
			{ x: 0.5, y: 0.63768 },
			{ x: 0.51, y: 0.63768 },
			{ x: 0.52, y: 0.63768 },
			{ x: 0.53, y: 0.63768 },
			{ x: 0.54, y: 0.63768 },
			{ x: 0.55, y: 0.63768 },
			{ x: 0.56, y: 0.63768 },
			{ x: 0.57, y: 0.63768 },
			{ x: 0.58, y: 0.63768 },
			{ x: 0.59, y: 0.63768 },
			{ x: 0.6, y: 0.63768 },
			{ x: 0.61, y: 0.63768 },
			{ x: 0.62, y: 0.63768 },
			{ x: 0.63, y: 0.63768 },
			{ x: 0.64, y: 0.63768 },
			{ x: 0.65, y: 0.63768 },
			{ x: 0.66, y: 0.63768 },
			{ x: 0.67, y: 0.63768 },
			{ x: 0.68, y: 0.63768 },
			{ x: 0.69, y: 0.63768 },
			{ x: 0.7, y: 0.63768 },
			{ x: 0.71, y: 0.63768 },
			{ x: 0.72, y: 0.63768 },
			{ x: 0.73, y: 0.63768 },
			{ x: 0.74, y: 0.63768 },
			{ x: 0.75, y: 0.63768 },
			{ x: 0.76, y: 0.63768 },
			{ x: 0.77, y: 0.63768 },
			{ x: 0.78, y: 0.63768 },
			{ x: 0.79, y: 0.63768 },
			{ x: 0.8, y: 0.63768 },
			{ x: 0.81, y: 0.63768 },
			{ x: 0.82, y: 0.63768 },
			{ x: 0.83, y: 0.63768 },
			{ x: 0.84, y: 0.63768 },
			{ x: 0.85, y: 0.63768 },
			{ x: 0.86, y: 0.63768 },
			{ x: 0.87, y: 0.63768 },
			{ x: 0.88, y: 0.63768 },
			{ x: 0.89, y: 0.63768 },
			{ x: 0.9, y: 0.63768 },
			{ x: 0.91, y: 0.63768 },
			{ x: 0.92, y: 0.63768 },
			{ x: 0.93, y: 0.63768 },
			{ x: 0.94, y: 0.63768 },
			{ x: 0.95, y: 0.63768 },
			{ x: 0.96, y: 0.63768 },
			{ x: 0.97, y: 0.63768 },
			{ x: 0.98, y: 0.63768 },
			{ x: 0.99, y: 0.63768 },
			{ x: 0, y: 0.65217 },
			{ x: 0.01, y: 0.65217 },
			{ x: 0.02, y: 0.65217 },
			{ x: 0.03, y: 0.65217 },
			{ x: 0.04, y: 0.65217 },
			{ x: 0.05, y: 0.65217 },
			{ x: 0.06, y: 0.65217 },
			{ x: 0.07, y: 0.65217 },
			{ x: 0.08, y: 0.65217 },
			{ x: 0.09, y: 0.65217 },
			{ x: 0.1, y: 0.65217 },
			{ x: 0.11, y: 0.65217 },
			{ x: 0.12, y: 0.65217 },
			{ x: 0.13, y: 0.65217 },
			{ x: 0.14, y: 0.65217 },
			{ x: 0.15, y: 0.65217 },
			{ x: 0.16, y: 0.65217 },
			{ x: 0.17, y: 0.65217 },
			{ x: 0.18, y: 0.65217 },
			{ x: 0.19, y: 0.65217 },
			{ x: 0.2, y: 0.65217 },
			{ x: 0.21, y: 0.65217 },
			{ x: 0.22, y: 0.65217 },
			{ x: 0.23, y: 0.65217 },
			{ x: 0.24, y: 0.65217 },
			{ x: 0.25, y: 0.65217 },
			{ x: 0.26, y: 0.65217 },
			{ x: 0.27, y: 0.65217 },
			{ x: 0.28, y: 0.65217 },
			{ x: 0.29, y: 0.65217 },
			{ x: 0.3, y: 0.65217 },
			{ x: 0.31, y: 0.65217 },
			{ x: 0.32, y: 0.65217 },
			{ x: 0.33, y: 0.65217 },
			{ x: 0.34, y: 0.65217 },
			{ x: 0.35, y: 0.65217 },
			{ x: 0.36, y: 0.65217 },
			{ x: 0.37, y: 0.65217 },
			{ x: 0.38, y: 0.65217 },
			{ x: 0.39, y: 0.65217 },
			{ x: 0.4, y: 0.65217 },
			{ x: 0.41, y: 0.65217 },
			{ x: 0.42, y: 0.65217 },
			{ x: 0.43, y: 0.65217 },
			{ x: 0.44, y: 0.65217 },
			{ x: 0.45, y: 0.65217 },
			{ x: 0.46, y: 0.65217 },
			{ x: 0.47, y: 0.65217 },
			{ x: 0.48, y: 0.65217 },
			{ x: 0.49, y: 0.65217 },
			{ x: 0.5, y: 0.65217 },
			{ x: 0.51, y: 0.65217 },
			{ x: 0.52, y: 0.65217 },
			{ x: 0.53, y: 0.65217 },
			{ x: 0.54, y: 0.65217 },
			{ x: 0.55, y: 0.65217 },
			{ x: 0.56, y: 0.65217 },
			{ x: 0.57, y: 0.65217 },
			{ x: 0.58, y: 0.65217 },
			{ x: 0.59, y: 0.65217 },
			{ x: 0.6, y: 0.65217 },
			{ x: 0.61, y: 0.65217 },
			{ x: 0.62, y: 0.65217 },
			{ x: 0.63, y: 0.65217 },
			{ x: 0.64, y: 0.65217 },
			{ x: 0.65, y: 0.65217 },
			{ x: 0.66, y: 0.65217 },
			{ x: 0.67, y: 0.65217 },
			{ x: 0.68, y: 0.65217 },
			{ x: 0.69, y: 0.65217 },
			{ x: 0.7, y: 0.65217 },
			{ x: 0.71, y: 0.65217 },
			{ x: 0.72, y: 0.65217 },
			{ x: 0.73, y: 0.65217 },
			{ x: 0.74, y: 0.65217 },
			{ x: 0.75, y: 0.65217 },
			{ x: 0.76, y: 0.65217 },
			{ x: 0.77, y: 0.65217 },
			{ x: 0.78, y: 0.65217 },
			{ x: 0.79, y: 0.65217 },
			{ x: 0.8, y: 0.65217 },
			{ x: 0.81, y: 0.65217 },
			{ x: 0.82, y: 0.65217 },
			{ x: 0.83, y: 0.65217 },
			{ x: 0.84, y: 0.65217 },
			{ x: 0.85, y: 0.65217 },
			{ x: 0.86, y: 0.65217 },
			{ x: 0.87, y: 0.65217 },
			{ x: 0.88, y: 0.65217 },
			{ x: 0.89, y: 0.65217 },
			{ x: 0.9, y: 0.65217 },
			{ x: 0.91, y: 0.65217 },
			{ x: 0.92, y: 0.65217 },
			{ x: 0.93, y: 0.65217 },
			{ x: 0.94, y: 0.65217 },
			{ x: 0.95, y: 0.65217 },
			{ x: 0.96, y: 0.65217 },
			{ x: 0.97, y: 0.65217 },
			{ x: 0.98, y: 0.65217 },
			{ x: 0.99, y: 0.65217 },
			{ x: 0, y: 0.66667 },
			{ x: 0.01, y: 0.66667 },
			{ x: 0.02, y: 0.66667 },
			{ x: 0.03, y: 0.66667 },
			{ x: 0.04, y: 0.66667 },
			{ x: 0.05, y: 0.66667 },
			{ x: 0.06, y: 0.66667 },
			{ x: 0.07, y: 0.66667 },
			{ x: 0.08, y: 0.66667 },
			{ x: 0.09, y: 0.66667 },
			{ x: 0.1, y: 0.66667 },
			{ x: 0.11, y: 0.66667 },
			{ x: 0.12, y: 0.66667 },
			{ x: 0.13, y: 0.66667 },
			{ x: 0.14, y: 0.66667 },
			{ x: 0.15, y: 0.66667 },
			{ x: 0.16, y: 0.66667 },
			{ x: 0.17, y: 0.66667 },
			{ x: 0.18, y: 0.66667 },
			{ x: 0.19, y: 0.66667 },
			{ x: 0.2, y: 0.66667 },
			{ x: 0.21, y: 0.66667 },
			{ x: 0.22, y: 0.66667 },
			{ x: 0.23, y: 0.66667 },
			{ x: 0.24, y: 0.66667 },
			{ x: 0.25, y: 0.66667 },
			{ x: 0.26, y: 0.66667 },
			{ x: 0.27, y: 0.66667 },
			{ x: 0.28, y: 0.66667 },
			{ x: 0.29, y: 0.66667 },
			{ x: 0.3, y: 0.66667 },
			{ x: 0.31, y: 0.66667 },
			{ x: 0.32, y: 0.66667 },
			{ x: 0.33, y: 0.66667 },
			{ x: 0.34, y: 0.66667 },
			{ x: 0.35, y: 0.66667 },
			{ x: 0.36, y: 0.66667 },
			{ x: 0.37, y: 0.66667 },
			{ x: 0.38, y: 0.66667 },
			{ x: 0.39, y: 0.66667 },
			{ x: 0.4, y: 0.66667 },
			{ x: 0.41, y: 0.66667 },
			{ x: 0.42, y: 0.66667 },
			{ x: 0.43, y: 0.66667 },
			{ x: 0.44, y: 0.66667 },
			{ x: 0.45, y: 0.66667 },
			{ x: 0.46, y: 0.66667 },
			{ x: 0.47, y: 0.66667 },
			{ x: 0.48, y: 0.66667 },
			{ x: 0.49, y: 0.66667 },
			{ x: 0.5, y: 0.66667 },
			{ x: 0.51, y: 0.66667 },
			{ x: 0.52, y: 0.66667 },
			{ x: 0.53, y: 0.66667 },
			{ x: 0.54, y: 0.66667 },
			{ x: 0.55, y: 0.66667 },
			{ x: 0.56, y: 0.66667 },
			{ x: 0.57, y: 0.66667 },
			{ x: 0.58, y: 0.66667 },
			{ x: 0.59, y: 0.66667 },
			{ x: 0.6, y: 0.66667 },
			{ x: 0.61, y: 0.66667 },
			{ x: 0.62, y: 0.66667 },
			{ x: 0.63, y: 0.66667 },
			{ x: 0.64, y: 0.66667 },
			{ x: 0.65, y: 0.66667 },
			{ x: 0.66, y: 0.66667 },
			{ x: 0.67, y: 0.66667 },
			{ x: 0.68, y: 0.66667 },
			{ x: 0.69, y: 0.66667 },
			{ x: 0.7, y: 0.66667 },
			{ x: 0.71, y: 0.66667 },
			{ x: 0.72, y: 0.66667 },
			{ x: 0.73, y: 0.66667 },
			{ x: 0.74, y: 0.66667 },
			{ x: 0.75, y: 0.66667 },
			{ x: 0.76, y: 0.66667 },
			{ x: 0.77, y: 0.66667 },
			{ x: 0.78, y: 0.66667 },
			{ x: 0.79, y: 0.66667 },
			{ x: 0.8, y: 0.66667 },
			{ x: 0.81, y: 0.66667 },
			{ x: 0.82, y: 0.66667 },
			{ x: 0.83, y: 0.66667 },
			{ x: 0.84, y: 0.66667 },
			{ x: 0.85, y: 0.66667 },
			{ x: 0.86, y: 0.66667 },
			{ x: 0.87, y: 0.66667 },
			{ x: 0.88, y: 0.66667 },
			{ x: 0.89, y: 0.66667 },
			{ x: 0.9, y: 0.66667 },
			{ x: 0.91, y: 0.66667 },
			{ x: 0.92, y: 0.66667 },
			{ x: 0.93, y: 0.66667 },
			{ x: 0.94, y: 0.66667 },
			{ x: 0.95, y: 0.66667 },
			{ x: 0.96, y: 0.66667 },
			{ x: 0.97, y: 0.66667 },
			{ x: 0.98, y: 0.66667 },
			{ x: 0.99, y: 0.66667 },
			{ x: 0, y: 0.68116 },
			{ x: 0.01, y: 0.68116 },
			{ x: 0.02, y: 0.68116 },
			{ x: 0.03, y: 0.68116 },
			{ x: 0.04, y: 0.68116 },
			{ x: 0.05, y: 0.68116 },
			{ x: 0.06, y: 0.68116 },
			{ x: 0.07, y: 0.68116 },
			{ x: 0.08, y: 0.68116 },
			{ x: 0.09, y: 0.68116 },
			{ x: 0.1, y: 0.68116 },
			{ x: 0.11, y: 0.68116 },
			{ x: 0.12, y: 0.68116 },
			{ x: 0.13, y: 0.68116 },
			{ x: 0.14, y: 0.68116 },
			{ x: 0.15, y: 0.68116 },
			{ x: 0.16, y: 0.68116 },
			{ x: 0.17, y: 0.68116 },
			{ x: 0.18, y: 0.68116 },
			{ x: 0.19, y: 0.68116 },
			{ x: 0.2, y: 0.68116 },
			{ x: 0.21, y: 0.68116 },
			{ x: 0.22, y: 0.68116 },
			{ x: 0.23, y: 0.68116 },
			{ x: 0.24, y: 0.68116 },
			{ x: 0.25, y: 0.68116 },
			{ x: 0.26, y: 0.68116 },
			{ x: 0.27, y: 0.68116 },
			{ x: 0.28, y: 0.68116 },
			{ x: 0.29, y: 0.68116 },
			{ x: 0.3, y: 0.68116 },
			{ x: 0.31, y: 0.68116 },
			{ x: 0.32, y: 0.68116 },
			{ x: 0.33, y: 0.68116 },
			{ x: 0.34, y: 0.68116 },
			{ x: 0.35, y: 0.68116 },
			{ x: 0.36, y: 0.68116 },
			{ x: 0.37, y: 0.68116 },
			{ x: 0.38, y: 0.68116 },
			{ x: 0.39, y: 0.68116 },
			{ x: 0.4, y: 0.68116 },
			{ x: 0.41, y: 0.68116 },
			{ x: 0.42, y: 0.68116 },
			{ x: 0.43, y: 0.68116 },
			{ x: 0.44, y: 0.68116 },
			{ x: 0.45, y: 0.68116 },
			{ x: 0.46, y: 0.68116 },
			{ x: 0.47, y: 0.68116 },
			{ x: 0.48, y: 0.68116 },
			{ x: 0.49, y: 0.68116 },
			{ x: 0.5, y: 0.68116 },
			{ x: 0.51, y: 0.68116 },
			{ x: 0.52, y: 0.68116 },
			{ x: 0.53, y: 0.68116 },
			{ x: 0.54, y: 0.68116 },
			{ x: 0.55, y: 0.68116 },
			{ x: 0.56, y: 0.68116 },
			{ x: 0.57, y: 0.68116 },
			{ x: 0.58, y: 0.68116 },
			{ x: 0.59, y: 0.68116 },
			{ x: 0.6, y: 0.68116 },
			{ x: 0.61, y: 0.68116 },
			{ x: 0.62, y: 0.68116 },
			{ x: 0.63, y: 0.68116 },
			{ x: 0.64, y: 0.68116 },
			{ x: 0.65, y: 0.68116 },
			{ x: 0.66, y: 0.68116 },
			{ x: 0.67, y: 0.68116 },
			{ x: 0.68, y: 0.68116 },
			{ x: 0.69, y: 0.68116 },
			{ x: 0.7, y: 0.68116 },
			{ x: 0.71, y: 0.68116 },
			{ x: 0.72, y: 0.68116 },
			{ x: 0.73, y: 0.68116 },
			{ x: 0.74, y: 0.68116 },
			{ x: 0.75, y: 0.68116 },
			{ x: 0.76, y: 0.68116 },
			{ x: 0.77, y: 0.68116 },
			{ x: 0.78, y: 0.68116 },
			{ x: 0.79, y: 0.68116 },
			{ x: 0.8, y: 0.68116 },
			{ x: 0.81, y: 0.68116 },
			{ x: 0.82, y: 0.68116 },
			{ x: 0.83, y: 0.68116 },
			{ x: 0.84, y: 0.68116 },
			{ x: 0.85, y: 0.68116 },
			{ x: 0.86, y: 0.68116 },
			{ x: 0.87, y: 0.68116 },
			{ x: 0.88, y: 0.68116 },
			{ x: 0.89, y: 0.68116 },
			{ x: 0.9, y: 0.68116 },
			{ x: 0.91, y: 0.68116 },
			{ x: 0.92, y: 0.68116 },
			{ x: 0.93, y: 0.68116 },
			{ x: 0.94, y: 0.68116 },
			{ x: 0.95, y: 0.68116 },
			{ x: 0.96, y: 0.68116 },
			{ x: 0.97, y: 0.68116 },
			{ x: 0.98, y: 0.68116 },
			{ x: 0.99, y: 0.68116 },
			{ x: 0, y: 0.69565 },
			{ x: 0.01, y: 0.69565 },
			{ x: 0.02, y: 0.69565 },
			{ x: 0.03, y: 0.69565 },
			{ x: 0.04, y: 0.69565 },
			{ x: 0.05, y: 0.69565 },
			{ x: 0.06, y: 0.69565 },
			{ x: 0.07, y: 0.69565 },
			{ x: 0.08, y: 0.69565 },
			{ x: 0.09, y: 0.69565 },
			{ x: 0.1, y: 0.69565 },
			{ x: 0.11, y: 0.69565 },
			{ x: 0.12, y: 0.69565 },
			{ x: 0.13, y: 0.69565 },
			{ x: 0.14, y: 0.69565 },
			{ x: 0.15, y: 0.69565 },
			{ x: 0.16, y: 0.69565 },
			{ x: 0.17, y: 0.69565 },
			{ x: 0.18, y: 0.69565 },
			{ x: 0.19, y: 0.69565 },
			{ x: 0.2, y: 0.69565 },
			{ x: 0.21, y: 0.69565 },
			{ x: 0.22, y: 0.69565 },
			{ x: 0.23, y: 0.69565 },
			{ x: 0.24, y: 0.69565 },
			{ x: 0.25, y: 0.69565 },
			{ x: 0.26, y: 0.69565 },
			{ x: 0.27, y: 0.69565 },
			{ x: 0.28, y: 0.69565 },
			{ x: 0.29, y: 0.69565 },
			{ x: 0.3, y: 0.69565 },
			{ x: 0.31, y: 0.69565 },
			{ x: 0.32, y: 0.69565 },
			{ x: 0.33, y: 0.69565 },
			{ x: 0.34, y: 0.69565 },
			{ x: 0.35, y: 0.69565 },
			{ x: 0.36, y: 0.69565 },
			{ x: 0.37, y: 0.69565 },
			{ x: 0.38, y: 0.69565 },
			{ x: 0.39, y: 0.69565 },
			{ x: 0.4, y: 0.69565 },
			{ x: 0.41, y: 0.69565 },
			{ x: 0.42, y: 0.69565 },
			{ x: 0.43, y: 0.69565 },
			{ x: 0.44, y: 0.69565 },
			{ x: 0.45, y: 0.69565 },
			{ x: 0.46, y: 0.69565 },
			{ x: 0.47, y: 0.69565 },
			{ x: 0.48, y: 0.69565 },
			{ x: 0.49, y: 0.69565 },
			{ x: 0.5, y: 0.69565 },
			{ x: 0.51, y: 0.69565 },
			{ x: 0.52, y: 0.69565 },
			{ x: 0.53, y: 0.69565 },
			{ x: 0.54, y: 0.69565 },
			{ x: 0.55, y: 0.69565 },
			{ x: 0.56, y: 0.69565 },
			{ x: 0.57, y: 0.69565 },
			{ x: 0.58, y: 0.69565 },
			{ x: 0.59, y: 0.69565 },
			{ x: 0.6, y: 0.69565 },
			{ x: 0.61, y: 0.69565 },
			{ x: 0.62, y: 0.69565 },
			{ x: 0.63, y: 0.69565 },
			{ x: 0.64, y: 0.69565 },
			{ x: 0.65, y: 0.69565 },
			{ x: 0.66, y: 0.69565 },
			{ x: 0.67, y: 0.69565 },
			{ x: 0.68, y: 0.69565 },
			{ x: 0.69, y: 0.69565 },
			{ x: 0.7, y: 0.69565 },
			{ x: 0.71, y: 0.69565 },
			{ x: 0.72, y: 0.69565 },
			{ x: 0.73, y: 0.69565 },
			{ x: 0.74, y: 0.69565 },
			{ x: 0.75, y: 0.69565 },
			{ x: 0.76, y: 0.69565 },
			{ x: 0.77, y: 0.69565 },
			{ x: 0.78, y: 0.69565 },
			{ x: 0.79, y: 0.69565 },
			{ x: 0.8, y: 0.69565 },
			{ x: 0.81, y: 0.69565 },
			{ x: 0.82, y: 0.69565 },
			{ x: 0.83, y: 0.69565 },
			{ x: 0.84, y: 0.69565 },
			{ x: 0.85, y: 0.69565 },
			{ x: 0.86, y: 0.69565 },
			{ x: 0.87, y: 0.69565 },
			{ x: 0.88, y: 0.69565 },
			{ x: 0.89, y: 0.69565 },
			{ x: 0.9, y: 0.69565 },
			{ x: 0.91, y: 0.69565 },
			{ x: 0.92, y: 0.69565 },
			{ x: 0.93, y: 0.69565 },
			{ x: 0.94, y: 0.69565 },
			{ x: 0.95, y: 0.69565 },
			{ x: 0.96, y: 0.69565 },
			{ x: 0.97, y: 0.69565 },
			{ x: 0.98, y: 0.69565 },
			{ x: 0.99, y: 0.69565 },
			{ x: 0, y: 0.71014 },
			{ x: 0.01, y: 0.71014 },
			{ x: 0.02, y: 0.71014 },
			{ x: 0.03, y: 0.71014 },
			{ x: 0.04, y: 0.71014 },
			{ x: 0.05, y: 0.71014 },
			{ x: 0.06, y: 0.71014 },
			{ x: 0.07, y: 0.71014 },
			{ x: 0.08, y: 0.71014 },
			{ x: 0.09, y: 0.71014 },
			{ x: 0.1, y: 0.71014 },
			{ x: 0.11, y: 0.71014 },
			{ x: 0.12, y: 0.71014 },
			{ x: 0.13, y: 0.71014 },
			{ x: 0.14, y: 0.71014 },
			{ x: 0.15, y: 0.71014 },
			{ x: 0.16, y: 0.71014 },
			{ x: 0.17, y: 0.71014 },
			{ x: 0.18, y: 0.71014 },
			{ x: 0.19, y: 0.71014 },
			{ x: 0.2, y: 0.71014 },
			{ x: 0.21, y: 0.71014 },
			{ x: 0.22, y: 0.71014 },
			{ x: 0.23, y: 0.71014 },
			{ x: 0.24, y: 0.71014 },
			{ x: 0.25, y: 0.71014 },
			{ x: 0.26, y: 0.71014 },
			{ x: 0.27, y: 0.71014 },
			{ x: 0.28, y: 0.71014 },
			{ x: 0.29, y: 0.71014 },
			{ x: 0.3, y: 0.71014 },
			{ x: 0.31, y: 0.71014 },
			{ x: 0.32, y: 0.71014 },
			{ x: 0.33, y: 0.71014 },
			{ x: 0.34, y: 0.71014 },
			{ x: 0.35, y: 0.71014 },
			{ x: 0.36, y: 0.71014 },
			{ x: 0.37, y: 0.71014 },
			{ x: 0.38, y: 0.71014 },
			{ x: 0.39, y: 0.71014 },
			{ x: 0.4, y: 0.71014 },
			{ x: 0.41, y: 0.71014 },
			{ x: 0.42, y: 0.71014 },
			{ x: 0.43, y: 0.71014 },
			{ x: 0.44, y: 0.71014 },
			{ x: 0.45, y: 0.71014 },
			{ x: 0.46, y: 0.71014 },
			{ x: 0.47, y: 0.71014 },
			{ x: 0.48, y: 0.71014 },
			{ x: 0.49, y: 0.71014 },
			{ x: 0.5, y: 0.71014 },
			{ x: 0.51, y: 0.71014 },
			{ x: 0.52, y: 0.71014 },
			{ x: 0.53, y: 0.71014 },
			{ x: 0.54, y: 0.71014 },
			{ x: 0.55, y: 0.71014 },
			{ x: 0.56, y: 0.71014 },
			{ x: 0.57, y: 0.71014 },
			{ x: 0.58, y: 0.71014 },
			{ x: 0.59, y: 0.71014 },
			{ x: 0.6, y: 0.71014 },
			{ x: 0.61, y: 0.71014 },
			{ x: 0.62, y: 0.71014 },
			{ x: 0.63, y: 0.71014 },
			{ x: 0.64, y: 0.71014 },
			{ x: 0.65, y: 0.71014 },
			{ x: 0.66, y: 0.71014 },
			{ x: 0.67, y: 0.71014 },
			{ x: 0.68, y: 0.71014 },
			{ x: 0.69, y: 0.71014 },
			{ x: 0.7, y: 0.71014 },
			{ x: 0.71, y: 0.71014 },
			{ x: 0.72, y: 0.71014 },
			{ x: 0.73, y: 0.71014 },
			{ x: 0.74, y: 0.71014 },
			{ x: 0.75, y: 0.71014 },
			{ x: 0.76, y: 0.71014 },
			{ x: 0.77, y: 0.71014 },
			{ x: 0.78, y: 0.71014 },
			{ x: 0.79, y: 0.71014 },
			{ x: 0.8, y: 0.71014 },
			{ x: 0.81, y: 0.71014 },
			{ x: 0.82, y: 0.71014 },
			{ x: 0.83, y: 0.71014 },
			{ x: 0.84, y: 0.71014 },
			{ x: 0.85, y: 0.71014 },
			{ x: 0.86, y: 0.71014 },
			{ x: 0.87, y: 0.71014 },
			{ x: 0.88, y: 0.71014 },
			{ x: 0.89, y: 0.71014 },
			{ x: 0.9, y: 0.71014 },
			{ x: 0.91, y: 0.71014 },
			{ x: 0.92, y: 0.71014 },
			{ x: 0.93, y: 0.71014 },
			{ x: 0.94, y: 0.71014 },
			{ x: 0.95, y: 0.71014 },
			{ x: 0.96, y: 0.71014 },
			{ x: 0.97, y: 0.71014 },
			{ x: 0.98, y: 0.71014 },
			{ x: 0.99, y: 0.71014 },
			{ x: 0, y: 0.72464 },
			{ x: 0.01, y: 0.72464 },
			{ x: 0.02, y: 0.72464 },
			{ x: 0.03, y: 0.72464 },
			{ x: 0.04, y: 0.72464 },
			{ x: 0.05, y: 0.72464 },
			{ x: 0.06, y: 0.72464 },
			{ x: 0.07, y: 0.72464 },
			{ x: 0.08, y: 0.72464 },
			{ x: 0.09, y: 0.72464 },
			{ x: 0.1, y: 0.72464 },
			{ x: 0.11, y: 0.72464 },
			{ x: 0.12, y: 0.72464 },
			{ x: 0.13, y: 0.72464 },
			{ x: 0.14, y: 0.72464 },
			{ x: 0.15, y: 0.72464 },
			{ x: 0.16, y: 0.72464 },
			{ x: 0.17, y: 0.72464 },
			{ x: 0.18, y: 0.72464 },
			{ x: 0.19, y: 0.72464 },
			{ x: 0.2, y: 0.72464 },
			{ x: 0.21, y: 0.72464 },
			{ x: 0.22, y: 0.72464 },
			{ x: 0.23, y: 0.72464 },
			{ x: 0.24, y: 0.72464 },
			{ x: 0.25, y: 0.72464 },
			{ x: 0.26, y: 0.72464 },
			{ x: 0.27, y: 0.72464 },
			{ x: 0.28, y: 0.72464 },
			{ x: 0.29, y: 0.72464 },
			{ x: 0.3, y: 0.72464 },
			{ x: 0.31, y: 0.72464 },
			{ x: 0.32, y: 0.72464 },
			{ x: 0.33, y: 0.72464 },
			{ x: 0.34, y: 0.72464 },
			{ x: 0.35, y: 0.72464 },
			{ x: 0.36, y: 0.72464 },
			{ x: 0.37, y: 0.72464 },
			{ x: 0.38, y: 0.72464 },
			{ x: 0.39, y: 0.72464 },
			{ x: 0.4, y: 0.72464 },
			{ x: 0.41, y: 0.72464 },
			{ x: 0.42, y: 0.72464 },
			{ x: 0.43, y: 0.72464 },
			{ x: 0.44, y: 0.72464 },
			{ x: 0.45, y: 0.72464 },
			{ x: 0.46, y: 0.72464 },
			{ x: 0.47, y: 0.72464 },
			{ x: 0.48, y: 0.72464 },
			{ x: 0.49, y: 0.72464 },
			{ x: 0.5, y: 0.72464 },
			{ x: 0.51, y: 0.72464 },
			{ x: 0.52, y: 0.72464 },
			{ x: 0.53, y: 0.72464 },
			{ x: 0.54, y: 0.72464 },
			{ x: 0.55, y: 0.72464 },
			{ x: 0.56, y: 0.72464 },
			{ x: 0.57, y: 0.72464 },
			{ x: 0.58, y: 0.72464 },
			{ x: 0.59, y: 0.72464 },
			{ x: 0.6, y: 0.72464 },
			{ x: 0.61, y: 0.72464 },
			{ x: 0.62, y: 0.72464 },
			{ x: 0.63, y: 0.72464 },
			{ x: 0.64, y: 0.72464 },
			{ x: 0.65, y: 0.72464 },
			{ x: 0.66, y: 0.72464 },
			{ x: 0.67, y: 0.72464 },
			{ x: 0.68, y: 0.72464 },
			{ x: 0.69, y: 0.72464 },
			{ x: 0.7, y: 0.72464 },
			{ x: 0.71, y: 0.72464 },
			{ x: 0.72, y: 0.72464 },
			{ x: 0.73, y: 0.72464 },
			{ x: 0.74, y: 0.72464 },
			{ x: 0.75, y: 0.72464 },
			{ x: 0.76, y: 0.72464 },
			{ x: 0.77, y: 0.72464 },
			{ x: 0.78, y: 0.72464 },
			{ x: 0.79, y: 0.72464 },
			{ x: 0.8, y: 0.72464 },
			{ x: 0.81, y: 0.72464 },
			{ x: 0.82, y: 0.72464 },
			{ x: 0.83, y: 0.72464 },
			{ x: 0.84, y: 0.72464 },
			{ x: 0.85, y: 0.72464 },
			{ x: 0.86, y: 0.72464 },
			{ x: 0.87, y: 0.72464 },
			{ x: 0.88, y: 0.72464 },
			{ x: 0.89, y: 0.72464 },
			{ x: 0.9, y: 0.72464 },
			{ x: 0.91, y: 0.72464 },
			{ x: 0.92, y: 0.72464 },
			{ x: 0.93, y: 0.72464 },
			{ x: 0.94, y: 0.72464 },
			{ x: 0.95, y: 0.72464 },
			{ x: 0.96, y: 0.72464 },
			{ x: 0.97, y: 0.72464 },
			{ x: 0.98, y: 0.72464 },
			{ x: 0.99, y: 0.72464 },
			{ x: 0, y: 0.73913 },
			{ x: 0.01, y: 0.73913 },
			{ x: 0.02, y: 0.73913 },
			{ x: 0.03, y: 0.73913 },
			{ x: 0.04, y: 0.73913 },
			{ x: 0.05, y: 0.73913 },
			{ x: 0.06, y: 0.73913 },
			{ x: 0.07, y: 0.73913 },
			{ x: 0.08, y: 0.73913 },
			{ x: 0.09, y: 0.73913 },
			{ x: 0.1, y: 0.73913 },
			{ x: 0.11, y: 0.73913 },
			{ x: 0.12, y: 0.73913 },
			{ x: 0.13, y: 0.73913 },
			{ x: 0.14, y: 0.73913 },
			{ x: 0.15, y: 0.73913 },
			{ x: 0.16, y: 0.73913 },
			{ x: 0.17, y: 0.73913 },
			{ x: 0.18, y: 0.73913 },
			{ x: 0.19, y: 0.73913 },
			{ x: 0.2, y: 0.73913 },
			{ x: 0.21, y: 0.73913 },
			{ x: 0.22, y: 0.73913 },
			{ x: 0.23, y: 0.73913 },
			{ x: 0.24, y: 0.73913 },
			{ x: 0.25, y: 0.73913 },
			{ x: 0.26, y: 0.73913 },
			{ x: 0.27, y: 0.73913 },
			{ x: 0.28, y: 0.73913 },
			{ x: 0.29, y: 0.73913 },
			{ x: 0.3, y: 0.73913 },
			{ x: 0.31, y: 0.73913 },
			{ x: 0.32, y: 0.73913 },
			{ x: 0.33, y: 0.73913 },
			{ x: 0.34, y: 0.73913 },
			{ x: 0.35, y: 0.73913 },
			{ x: 0.36, y: 0.73913 },
			{ x: 0.37, y: 0.73913 },
			{ x: 0.38, y: 0.73913 },
			{ x: 0.39, y: 0.73913 },
			{ x: 0.4, y: 0.73913 },
			{ x: 0.41, y: 0.73913 },
			{ x: 0.42, y: 0.73913 },
			{ x: 0.43, y: 0.73913 },
			{ x: 0.44, y: 0.73913 },
			{ x: 0.45, y: 0.73913 },
			{ x: 0.46, y: 0.73913 },
			{ x: 0.47, y: 0.73913 },
			{ x: 0.48, y: 0.73913 },
			{ x: 0.49, y: 0.73913 },
			{ x: 0.5, y: 0.73913 },
			{ x: 0.51, y: 0.73913 },
			{ x: 0.52, y: 0.73913 },
			{ x: 0.53, y: 0.73913 },
			{ x: 0.54, y: 0.73913 },
			{ x: 0.55, y: 0.73913 },
			{ x: 0.56, y: 0.73913 },
			{ x: 0.57, y: 0.73913 },
			{ x: 0.58, y: 0.73913 },
			{ x: 0.59, y: 0.73913 },
			{ x: 0.6, y: 0.73913 },
			{ x: 0.61, y: 0.73913 },
			{ x: 0.62, y: 0.73913 },
			{ x: 0.63, y: 0.73913 },
			{ x: 0.66, y: 0.73913 },
			{ x: 0.67, y: 0.73913 },
			{ x: 0.68, y: 0.73913 },
			{ x: 0.69, y: 0.73913 },
			{ x: 0.7, y: 0.73913 },
			{ x: 0.71, y: 0.73913 },
			{ x: 0.72, y: 0.73913 },
			{ x: 0.73, y: 0.73913 },
			{ x: 0.74, y: 0.73913 },
			{ x: 0.75, y: 0.73913 },
			{ x: 0.76, y: 0.73913 },
			{ x: 0.77, y: 0.73913 },
			{ x: 0.78, y: 0.73913 },
			{ x: 0.79, y: 0.73913 },
			{ x: 0.8, y: 0.73913 },
			{ x: 0.81, y: 0.73913 },
			{ x: 0.82, y: 0.73913 },
			{ x: 0.83, y: 0.73913 },
			{ x: 0.84, y: 0.73913 },
			{ x: 0.85, y: 0.73913 },
			{ x: 0.86, y: 0.73913 },
			{ x: 0.87, y: 0.73913 },
			{ x: 0.88, y: 0.73913 },
			{ x: 0.89, y: 0.73913 },
			{ x: 0.9, y: 0.73913 },
			{ x: 0.91, y: 0.73913 },
			{ x: 0.92, y: 0.73913 },
			{ x: 0.93, y: 0.73913 },
			{ x: 0.94, y: 0.73913 },
			{ x: 0.95, y: 0.73913 },
			{ x: 0.96, y: 0.73913 },
			{ x: 0.97, y: 0.73913 },
			{ x: 0.98, y: 0.73913 },
			{ x: 0.99, y: 0.73913 },
			{ x: 0, y: 0.75362 },
			{ x: 0.01, y: 0.75362 },
			{ x: 0.02, y: 0.75362 },
			{ x: 0.03, y: 0.75362 },
			{ x: 0.04, y: 0.75362 },
			{ x: 0.05, y: 0.75362 },
			{ x: 0.06, y: 0.75362 },
			{ x: 0.07, y: 0.75362 },
			{ x: 0.08, y: 0.75362 },
			{ x: 0.09, y: 0.75362 },
			{ x: 0.1, y: 0.75362 },
			{ x: 0.11, y: 0.75362 },
			{ x: 0.12, y: 0.75362 },
			{ x: 0.13, y: 0.75362 },
			{ x: 0.14, y: 0.75362 },
			{ x: 0.15, y: 0.75362 },
			{ x: 0.16, y: 0.75362 },
			{ x: 0.17, y: 0.75362 },
			{ x: 0.18, y: 0.75362 },
			{ x: 0.19, y: 0.75362 },
			{ x: 0.2, y: 0.75362 },
			{ x: 0.21, y: 0.75362 },
			{ x: 0.22, y: 0.75362 },
			{ x: 0.23, y: 0.75362 },
			{ x: 0.24, y: 0.75362 },
			{ x: 0.25, y: 0.75362 },
			{ x: 0.26, y: 0.75362 },
			{ x: 0.27, y: 0.75362 },
			{ x: 0.28, y: 0.75362 },
			{ x: 0.29, y: 0.75362 },
			{ x: 0.3, y: 0.75362 },
			{ x: 0.31, y: 0.75362 },
			{ x: 0.33, y: 0.75362 },
			{ x: 0.34, y: 0.75362 },
			{ x: 0.35, y: 0.75362 },
			{ x: 0.36, y: 0.75362 },
			{ x: 0.37, y: 0.75362 },
			{ x: 0.38, y: 0.75362 },
			{ x: 0.39, y: 0.75362 },
			{ x: 0.4, y: 0.75362 },
			{ x: 0.41, y: 0.75362 },
			{ x: 0.42, y: 0.75362 },
			{ x: 0.43, y: 0.75362 },
			{ x: 0.44, y: 0.75362 },
			{ x: 0.45, y: 0.75362 },
			{ x: 0.46, y: 0.75362 },
			{ x: 0.47, y: 0.75362 },
			{ x: 0.48, y: 0.75362 },
			{ x: 0.49, y: 0.75362 },
			{ x: 0.5, y: 0.75362 },
			{ x: 0.51, y: 0.75362 },
			{ x: 0.52, y: 0.75362 },
			{ x: 0.53, y: 0.75362 },
			{ x: 0.54, y: 0.75362 },
			{ x: 0.55, y: 0.75362 },
			{ x: 0.56, y: 0.75362 },
			{ x: 0.57, y: 0.75362 },
			{ x: 0.58, y: 0.75362 },
			{ x: 0.59, y: 0.75362 },
			{ x: 0.6, y: 0.75362 },
			{ x: 0.61, y: 0.75362 },
			{ x: 0.62, y: 0.75362 },
			{ x: 0.63, y: 0.75362 },
			{ x: 0.65, y: 0.75362 },
			{ x: 0.68, y: 0.75362 },
			{ x: 0.69, y: 0.75362 },
			{ x: 0.7, y: 0.75362 },
			{ x: 0.71, y: 0.75362 },
			{ x: 0.72, y: 0.75362 },
			{ x: 0.73, y: 0.75362 },
			{ x: 0.74, y: 0.75362 },
			{ x: 0.75, y: 0.75362 },
			{ x: 0.76, y: 0.75362 },
			{ x: 0.77, y: 0.75362 },
			{ x: 0.78, y: 0.75362 },
			{ x: 0.79, y: 0.75362 },
			{ x: 0.8, y: 0.75362 },
			{ x: 0.81, y: 0.75362 },
			{ x: 0.82, y: 0.75362 },
			{ x: 0.83, y: 0.75362 },
			{ x: 0.84, y: 0.75362 },
			{ x: 0.85, y: 0.75362 },
			{ x: 0.86, y: 0.75362 },
			{ x: 0.87, y: 0.75362 },
			{ x: 0.88, y: 0.75362 },
			{ x: 0.89, y: 0.75362 },
			{ x: 0.9, y: 0.75362 },
			{ x: 0.91, y: 0.75362 },
			{ x: 0.92, y: 0.75362 },
			{ x: 0.93, y: 0.75362 },
			{ x: 0.94, y: 0.75362 },
			{ x: 0.95, y: 0.75362 },
			{ x: 0.96, y: 0.75362 },
			{ x: 0.97, y: 0.75362 },
			{ x: 0.98, y: 0.75362 },
			{ x: 0.99, y: 0.75362 },
			{ x: 0, y: 0.76812 },
			{ x: 0.01, y: 0.76812 },
			{ x: 0.02, y: 0.76812 },
			{ x: 0.03, y: 0.76812 },
			{ x: 0.04, y: 0.76812 },
			{ x: 0.05, y: 0.76812 },
			{ x: 0.06, y: 0.76812 },
			{ x: 0.07, y: 0.76812 },
			{ x: 0.08, y: 0.76812 },
			{ x: 0.09, y: 0.76812 },
			{ x: 0.1, y: 0.76812 },
			{ x: 0.11, y: 0.76812 },
			{ x: 0.12, y: 0.76812 },
			{ x: 0.13, y: 0.76812 },
			{ x: 0.14, y: 0.76812 },
			{ x: 0.15, y: 0.76812 },
			{ x: 0.16, y: 0.76812 },
			{ x: 0.17, y: 0.76812 },
			{ x: 0.18, y: 0.76812 },
			{ x: 0.19, y: 0.76812 },
			{ x: 0.2, y: 0.76812 },
			{ x: 0.21, y: 0.76812 },
			{ x: 0.22, y: 0.76812 },
			{ x: 0.23, y: 0.76812 },
			{ x: 0.24, y: 0.76812 },
			{ x: 0.25, y: 0.76812 },
			{ x: 0.26, y: 0.76812 },
			{ x: 0.27, y: 0.76812 },
			{ x: 0.28, y: 0.76812 },
			{ x: 0.29, y: 0.76812 },
			{ x: 0.31, y: 0.76812 },
			{ x: 0.32, y: 0.76812 },
			{ x: 0.33, y: 0.76812 },
			{ x: 0.34, y: 0.76812 },
			{ x: 0.35, y: 0.76812 },
			{ x: 0.36, y: 0.76812 },
			{ x: 0.37, y: 0.76812 },
			{ x: 0.38, y: 0.76812 },
			{ x: 0.39, y: 0.76812 },
			{ x: 0.4, y: 0.76812 },
			{ x: 0.41, y: 0.76812 },
			{ x: 0.42, y: 0.76812 },
			{ x: 0.43, y: 0.76812 },
			{ x: 0.44, y: 0.76812 },
			{ x: 0.45, y: 0.76812 },
			{ x: 0.46, y: 0.76812 },
			{ x: 0.47, y: 0.76812 },
			{ x: 0.48, y: 0.76812 },
			{ x: 0.49, y: 0.76812 },
			{ x: 0.5, y: 0.76812 },
			{ x: 0.51, y: 0.76812 },
			{ x: 0.52, y: 0.76812 },
			{ x: 0.53, y: 0.76812 },
			{ x: 0.54, y: 0.76812 },
			{ x: 0.55, y: 0.76812 },
			{ x: 0.56, y: 0.76812 },
			{ x: 0.57, y: 0.76812 },
			{ x: 0.58, y: 0.76812 },
			{ x: 0.59, y: 0.76812 },
			{ x: 0.6, y: 0.76812 },
			{ x: 0.61, y: 0.76812 },
			{ x: 0.62, y: 0.76812 },
			{ x: 0.63, y: 0.76812 },
			{ x: 0.65, y: 0.76812 },
			{ x: 0.66, y: 0.76812 },
			{ x: 0.67, y: 0.76812 },
			{ x: 0.7, y: 0.76812 },
			{ x: 0.71, y: 0.76812 },
			{ x: 0.72, y: 0.76812 },
			{ x: 0.73, y: 0.76812 },
			{ x: 0.74, y: 0.76812 },
			{ x: 0.75, y: 0.76812 },
			{ x: 0.76, y: 0.76812 },
			{ x: 0.77, y: 0.76812 },
			{ x: 0.78, y: 0.76812 },
			{ x: 0.79, y: 0.76812 },
			{ x: 0.8, y: 0.76812 },
			{ x: 0.81, y: 0.76812 },
			{ x: 0.82, y: 0.76812 },
			{ x: 0.83, y: 0.76812 },
			{ x: 0.84, y: 0.76812 },
			{ x: 0.85, y: 0.76812 },
			{ x: 0.86, y: 0.76812 },
			{ x: 0.87, y: 0.76812 },
			{ x: 0.88, y: 0.76812 },
			{ x: 0.89, y: 0.76812 },
			{ x: 0.9, y: 0.76812 },
			{ x: 0.91, y: 0.76812 },
			{ x: 0.92, y: 0.76812 },
			{ x: 0.93, y: 0.76812 },
			{ x: 0.94, y: 0.76812 },
			{ x: 0.95, y: 0.76812 },
			{ x: 0.96, y: 0.76812 },
			{ x: 0.97, y: 0.76812 },
			{ x: 0.98, y: 0.76812 },
			{ x: 0.99, y: 0.76812 },
			{ x: 0, y: 0.78261 },
			{ x: 0.01, y: 0.78261 },
			{ x: 0.02, y: 0.78261 },
			{ x: 0.03, y: 0.78261 },
			{ x: 0.04, y: 0.78261 },
			{ x: 0.05, y: 0.78261 },
			{ x: 0.06, y: 0.78261 },
			{ x: 0.07, y: 0.78261 },
			{ x: 0.08, y: 0.78261 },
			{ x: 0.09, y: 0.78261 },
			{ x: 0.1, y: 0.78261 },
			{ x: 0.11, y: 0.78261 },
			{ x: 0.12, y: 0.78261 },
			{ x: 0.13, y: 0.78261 },
			{ x: 0.14, y: 0.78261 },
			{ x: 0.15, y: 0.78261 },
			{ x: 0.16, y: 0.78261 },
			{ x: 0.17, y: 0.78261 },
			{ x: 0.18, y: 0.78261 },
			{ x: 0.19, y: 0.78261 },
			{ x: 0.2, y: 0.78261 },
			{ x: 0.21, y: 0.78261 },
			{ x: 0.22, y: 0.78261 },
			{ x: 0.23, y: 0.78261 },
			{ x: 0.24, y: 0.78261 },
			{ x: 0.25, y: 0.78261 },
			{ x: 0.26, y: 0.78261 },
			{ x: 0.27, y: 0.78261 },
			{ x: 0.29, y: 0.78261 },
			{ x: 0.3, y: 0.78261 },
			{ x: 0.31, y: 0.78261 },
			{ x: 0.32, y: 0.78261 },
			{ x: 0.33, y: 0.78261 },
			{ x: 0.34, y: 0.78261 },
			{ x: 0.35, y: 0.78261 },
			{ x: 0.36, y: 0.78261 },
			{ x: 0.37, y: 0.78261 },
			{ x: 0.38, y: 0.78261 },
			{ x: 0.39, y: 0.78261 },
			{ x: 0.4, y: 0.78261 },
			{ x: 0.41, y: 0.78261 },
			{ x: 0.42, y: 0.78261 },
			{ x: 0.43, y: 0.78261 },
			{ x: 0.44, y: 0.78261 },
			{ x: 0.45, y: 0.78261 },
			{ x: 0.46, y: 0.78261 },
			{ x: 0.47, y: 0.78261 },
			{ x: 0.48, y: 0.78261 },
			{ x: 0.49, y: 0.78261 },
			{ x: 0.5, y: 0.78261 },
			{ x: 0.51, y: 0.78261 },
			{ x: 0.52, y: 0.78261 },
			{ x: 0.53, y: 0.78261 },
			{ x: 0.54, y: 0.78261 },
			{ x: 0.55, y: 0.78261 },
			{ x: 0.56, y: 0.78261 },
			{ x: 0.57, y: 0.78261 },
			{ x: 0.58, y: 0.78261 },
			{ x: 0.59, y: 0.78261 },
			{ x: 0.6, y: 0.78261 },
			{ x: 0.61, y: 0.78261 },
			{ x: 0.62, y: 0.78261 },
			{ x: 0.64, y: 0.78261 },
			{ x: 0.65, y: 0.78261 },
			{ x: 0.66, y: 0.78261 },
			{ x: 0.67, y: 0.78261 },
			{ x: 0.68, y: 0.78261 },
			{ x: 0.69, y: 0.78261 },
			{ x: 0.72, y: 0.78261 },
			{ x: 0.73, y: 0.78261 },
			{ x: 0.74, y: 0.78261 },
			{ x: 0.75, y: 0.78261 },
			{ x: 0.76, y: 0.78261 },
			{ x: 0.77, y: 0.78261 },
			{ x: 0.78, y: 0.78261 },
			{ x: 0.79, y: 0.78261 },
			{ x: 0.8, y: 0.78261 },
			{ x: 0.81, y: 0.78261 },
			{ x: 0.82, y: 0.78261 },
			{ x: 0.83, y: 0.78261 },
			{ x: 0.84, y: 0.78261 },
			{ x: 0.85, y: 0.78261 },
			{ x: 0.86, y: 0.78261 },
			{ x: 0.87, y: 0.78261 },
			{ x: 0.88, y: 0.78261 },
			{ x: 0.89, y: 0.78261 },
			{ x: 0.9, y: 0.78261 },
			{ x: 0.91, y: 0.78261 },
			{ x: 0.92, y: 0.78261 },
			{ x: 0.93, y: 0.78261 },
			{ x: 0.94, y: 0.78261 },
			{ x: 0.95, y: 0.78261 },
			{ x: 0.96, y: 0.78261 },
			{ x: 0.97, y: 0.78261 },
			{ x: 0.98, y: 0.78261 },
			{ x: 0.99, y: 0.78261 },
			{ x: 0, y: 0.7971 },
			{ x: 0.01, y: 0.7971 },
			{ x: 0.02, y: 0.7971 },
			{ x: 0.03, y: 0.7971 },
			{ x: 0.04, y: 0.7971 },
			{ x: 0.05, y: 0.7971 },
			{ x: 0.06, y: 0.7971 },
			{ x: 0.07, y: 0.7971 },
			{ x: 0.08, y: 0.7971 },
			{ x: 0.09, y: 0.7971 },
			{ x: 0.1, y: 0.7971 },
			{ x: 0.11, y: 0.7971 },
			{ x: 0.12, y: 0.7971 },
			{ x: 0.13, y: 0.7971 },
			{ x: 0.14, y: 0.7971 },
			{ x: 0.15, y: 0.7971 },
			{ x: 0.16, y: 0.7971 },
			{ x: 0.17, y: 0.7971 },
			{ x: 0.18, y: 0.7971 },
			{ x: 0.19, y: 0.7971 },
			{ x: 0.2, y: 0.7971 },
			{ x: 0.21, y: 0.7971 },
			{ x: 0.22, y: 0.7971 },
			{ x: 0.23, y: 0.7971 },
			{ x: 0.24, y: 0.7971 },
			{ x: 0.25, y: 0.7971 },
			{ x: 0.27, y: 0.7971 },
			{ x: 0.28, y: 0.7971 },
			{ x: 0.29, y: 0.7971 },
			{ x: 0.3, y: 0.7971 },
			{ x: 0.31, y: 0.7971 },
			{ x: 0.32, y: 0.7971 },
			{ x: 0.33, y: 0.7971 },
			{ x: 0.34, y: 0.7971 },
			{ x: 0.35, y: 0.7971 },
			{ x: 0.36, y: 0.7971 },
			{ x: 0.37, y: 0.7971 },
			{ x: 0.38, y: 0.7971 },
			{ x: 0.39, y: 0.7971 },
			{ x: 0.4, y: 0.7971 },
			{ x: 0.41, y: 0.7971 },
			{ x: 0.42, y: 0.7971 },
			{ x: 0.43, y: 0.7971 },
			{ x: 0.44, y: 0.7971 },
			{ x: 0.45, y: 0.7971 },
			{ x: 0.46, y: 0.7971 },
			{ x: 0.47, y: 0.7971 },
			{ x: 0.48, y: 0.7971 },
			{ x: 0.49, y: 0.7971 },
			{ x: 0.5, y: 0.7971 },
			{ x: 0.51, y: 0.7971 },
			{ x: 0.52, y: 0.7971 },
			{ x: 0.53, y: 0.7971 },
			{ x: 0.54, y: 0.7971 },
			{ x: 0.55, y: 0.7971 },
			{ x: 0.56, y: 0.7971 },
			{ x: 0.57, y: 0.7971 },
			{ x: 0.58, y: 0.7971 },
			{ x: 0.59, y: 0.7971 },
			{ x: 0.6, y: 0.7971 },
			{ x: 0.61, y: 0.7971 },
			{ x: 0.62, y: 0.7971 },
			{ x: 0.64, y: 0.7971 },
			{ x: 0.65, y: 0.7971 },
			{ x: 0.66, y: 0.7971 },
			{ x: 0.67, y: 0.7971 },
			{ x: 0.68, y: 0.7971 },
			{ x: 0.69, y: 0.7971 },
			{ x: 0.7, y: 0.7971 },
			{ x: 0.71, y: 0.7971 },
			{ x: 0.73, y: 0.7971 },
			{ x: 0.74, y: 0.7971 },
			{ x: 0.75, y: 0.7971 },
			{ x: 0.76, y: 0.7971 },
			{ x: 0.77, y: 0.7971 },
			{ x: 0.78, y: 0.7971 },
			{ x: 0.79, y: 0.7971 },
			{ x: 0.8, y: 0.7971 },
			{ x: 0.81, y: 0.7971 },
			{ x: 0.82, y: 0.7971 },
			{ x: 0.83, y: 0.7971 },
			{ x: 0.84, y: 0.7971 },
			{ x: 0.85, y: 0.7971 },
			{ x: 0.86, y: 0.7971 },
			{ x: 0.87, y: 0.7971 },
			{ x: 0.88, y: 0.7971 },
			{ x: 0.89, y: 0.7971 },
			{ x: 0.9, y: 0.7971 },
			{ x: 0.91, y: 0.7971 },
			{ x: 0.92, y: 0.7971 },
			{ x: 0.93, y: 0.7971 },
			{ x: 0.94, y: 0.7971 },
			{ x: 0.95, y: 0.7971 },
			{ x: 0.96, y: 0.7971 },
			{ x: 0.97, y: 0.7971 },
			{ x: 0.98, y: 0.7971 },
			{ x: 0.99, y: 0.7971 },
			{ x: 0, y: 0.81159 },
			{ x: 0.01, y: 0.81159 },
			{ x: 0.02, y: 0.81159 },
			{ x: 0.03, y: 0.81159 },
			{ x: 0.04, y: 0.81159 },
			{ x: 0.05, y: 0.81159 },
			{ x: 0.06, y: 0.81159 },
			{ x: 0.07, y: 0.81159 },
			{ x: 0.08, y: 0.81159 },
			{ x: 0.09, y: 0.81159 },
			{ x: 0.1, y: 0.81159 },
			{ x: 0.11, y: 0.81159 },
			{ x: 0.12, y: 0.81159 },
			{ x: 0.13, y: 0.81159 },
			{ x: 0.14, y: 0.81159 },
			{ x: 0.15, y: 0.81159 },
			{ x: 0.16, y: 0.81159 },
			{ x: 0.17, y: 0.81159 },
			{ x: 0.18, y: 0.81159 },
			{ x: 0.19, y: 0.81159 },
			{ x: 0.2, y: 0.81159 },
			{ x: 0.21, y: 0.81159 },
			{ x: 0.22, y: 0.81159 },
			{ x: 0.23, y: 0.81159 },
			{ x: 0.25, y: 0.81159 },
			{ x: 0.26, y: 0.81159 },
			{ x: 0.27, y: 0.81159 },
			{ x: 0.28, y: 0.81159 },
			{ x: 0.29, y: 0.81159 },
			{ x: 0.3, y: 0.81159 },
			{ x: 0.31, y: 0.81159 },
			{ x: 0.32, y: 0.81159 },
			{ x: 0.33, y: 0.81159 },
			{ x: 0.34, y: 0.81159 },
			{ x: 0.35, y: 0.81159 },
			{ x: 0.36, y: 0.81159 },
			{ x: 0.37, y: 0.81159 },
			{ x: 0.38, y: 0.81159 },
			{ x: 0.39, y: 0.81159 },
			{ x: 0.4, y: 0.81159 },
			{ x: 0.41, y: 0.81159 },
			{ x: 0.42, y: 0.81159 },
			{ x: 0.43, y: 0.81159 },
			{ x: 0.44, y: 0.81159 },
			{ x: 0.45, y: 0.81159 },
			{ x: 0.46, y: 0.81159 },
			{ x: 0.47, y: 0.81159 },
			{ x: 0.48, y: 0.81159 },
			{ x: 0.49, y: 0.81159 },
			{ x: 0.5, y: 0.81159 },
			{ x: 0.51, y: 0.81159 },
			{ x: 0.52, y: 0.81159 },
			{ x: 0.53, y: 0.81159 },
			{ x: 0.54, y: 0.81159 },
			{ x: 0.55, y: 0.81159 },
			{ x: 0.56, y: 0.81159 },
			{ x: 0.57, y: 0.81159 },
			{ x: 0.58, y: 0.81159 },
			{ x: 0.59, y: 0.81159 },
			{ x: 0.6, y: 0.81159 },
			{ x: 0.61, y: 0.81159 },
			{ x: 0.63, y: 0.81159 },
			{ x: 0.64, y: 0.81159 },
			{ x: 0.65, y: 0.81159 },
			{ x: 0.66, y: 0.81159 },
			{ x: 0.67, y: 0.81159 },
			{ x: 0.68, y: 0.81159 },
			{ x: 0.69, y: 0.81159 },
			{ x: 0.7, y: 0.81159 },
			{ x: 0.71, y: 0.81159 },
			{ x: 0.72, y: 0.81159 },
			{ x: 0.75, y: 0.81159 },
			{ x: 0.76, y: 0.81159 },
			{ x: 0.77, y: 0.81159 },
			{ x: 0.78, y: 0.81159 },
			{ x: 0.79, y: 0.81159 },
			{ x: 0.8, y: 0.81159 },
			{ x: 0.81, y: 0.81159 },
			{ x: 0.82, y: 0.81159 },
			{ x: 0.83, y: 0.81159 },
			{ x: 0.84, y: 0.81159 },
			{ x: 0.85, y: 0.81159 },
			{ x: 0.86, y: 0.81159 },
			{ x: 0.87, y: 0.81159 },
			{ x: 0.88, y: 0.81159 },
			{ x: 0.89, y: 0.81159 },
			{ x: 0.9, y: 0.81159 },
			{ x: 0.91, y: 0.81159 },
			{ x: 0.92, y: 0.81159 },
			{ x: 0.93, y: 0.81159 },
			{ x: 0.94, y: 0.81159 },
			{ x: 0.95, y: 0.81159 },
			{ x: 0.96, y: 0.81159 },
			{ x: 0.97, y: 0.81159 },
			{ x: 0.98, y: 0.81159 },
			{ x: 0.99, y: 0.81159 },
			{ x: 0, y: 0.82609 },
			{ x: 0.01, y: 0.82609 },
			{ x: 0.02, y: 0.82609 },
			{ x: 0.03, y: 0.82609 },
			{ x: 0.04, y: 0.82609 },
			{ x: 0.05, y: 0.82609 },
			{ x: 0.06, y: 0.82609 },
			{ x: 0.07, y: 0.82609 },
			{ x: 0.08, y: 0.82609 },
			{ x: 0.09, y: 0.82609 },
			{ x: 0.1, y: 0.82609 },
			{ x: 0.11, y: 0.82609 },
			{ x: 0.12, y: 0.82609 },
			{ x: 0.13, y: 0.82609 },
			{ x: 0.14, y: 0.82609 },
			{ x: 0.15, y: 0.82609 },
			{ x: 0.16, y: 0.82609 },
			{ x: 0.17, y: 0.82609 },
			{ x: 0.18, y: 0.82609 },
			{ x: 0.19, y: 0.82609 },
			{ x: 0.2, y: 0.82609 },
			{ x: 0.21, y: 0.82609 },
			{ x: 0.22, y: 0.82609 },
			{ x: 0.23, y: 0.82609 },
			{ x: 0.24, y: 0.82609 },
			{ x: 0.25, y: 0.82609 },
			{ x: 0.26, y: 0.82609 },
			{ x: 0.27, y: 0.82609 },
			{ x: 0.28, y: 0.82609 },
			{ x: 0.29, y: 0.82609 },
			{ x: 0.3, y: 0.82609 },
			{ x: 0.31, y: 0.82609 },
			{ x: 0.32, y: 0.82609 },
			{ x: 0.33, y: 0.82609 },
			{ x: 0.34, y: 0.82609 },
			{ x: 0.35, y: 0.82609 },
			{ x: 0.36, y: 0.82609 },
			{ x: 0.37, y: 0.82609 },
			{ x: 0.38, y: 0.82609 },
			{ x: 0.39, y: 0.82609 },
			{ x: 0.4, y: 0.82609 },
			{ x: 0.41, y: 0.82609 },
			{ x: 0.42, y: 0.82609 },
			{ x: 0.43, y: 0.82609 },
			{ x: 0.44, y: 0.82609 },
			{ x: 0.45, y: 0.82609 },
			{ x: 0.46, y: 0.82609 },
			{ x: 0.47, y: 0.82609 },
			{ x: 0.48, y: 0.82609 },
			{ x: 0.49, y: 0.82609 },
			{ x: 0.5, y: 0.82609 },
			{ x: 0.51, y: 0.82609 },
			{ x: 0.52, y: 0.82609 },
			{ x: 0.53, y: 0.82609 },
			{ x: 0.54, y: 0.82609 },
			{ x: 0.55, y: 0.82609 },
			{ x: 0.56, y: 0.82609 },
			{ x: 0.57, y: 0.82609 },
			{ x: 0.58, y: 0.82609 },
			{ x: 0.59, y: 0.82609 },
			{ x: 0.6, y: 0.82609 },
			{ x: 0.62, y: 0.82609 },
			{ x: 0.63, y: 0.82609 },
			{ x: 0.64, y: 0.82609 },
			{ x: 0.65, y: 0.82609 },
			{ x: 0.66, y: 0.82609 },
			{ x: 0.67, y: 0.82609 },
			{ x: 0.68, y: 0.82609 },
			{ x: 0.69, y: 0.82609 },
			{ x: 0.7, y: 0.82609 },
			{ x: 0.71, y: 0.82609 },
			{ x: 0.72, y: 0.82609 },
			{ x: 0.73, y: 0.82609 },
			{ x: 0.74, y: 0.82609 },
			{ x: 0.77, y: 0.82609 },
			{ x: 0.78, y: 0.82609 },
			{ x: 0.79, y: 0.82609 },
			{ x: 0.8, y: 0.82609 },
			{ x: 0.81, y: 0.82609 },
			{ x: 0.82, y: 0.82609 },
			{ x: 0.83, y: 0.82609 },
			{ x: 0.84, y: 0.82609 },
			{ x: 0.85, y: 0.82609 },
			{ x: 0.86, y: 0.82609 },
			{ x: 0.87, y: 0.82609 },
			{ x: 0.88, y: 0.82609 },
			{ x: 0.89, y: 0.82609 },
			{ x: 0.9, y: 0.82609 },
			{ x: 0.91, y: 0.82609 },
			{ x: 0.92, y: 0.82609 },
			{ x: 0.93, y: 0.82609 },
			{ x: 0.94, y: 0.82609 },
			{ x: 0.95, y: 0.82609 },
			{ x: 0.96, y: 0.82609 },
			{ x: 0.97, y: 0.82609 },
			{ x: 0.98, y: 0.82609 },
			{ x: 0.99, y: 0.82609 },
			{ x: 0, y: 0.84058 },
			{ x: 0.01, y: 0.84058 },
			{ x: 0.02, y: 0.84058 },
			{ x: 0.03, y: 0.84058 },
			{ x: 0.04, y: 0.84058 },
			{ x: 0.05, y: 0.84058 },
			{ x: 0.06, y: 0.84058 },
			{ x: 0.07, y: 0.84058 },
			{ x: 0.08, y: 0.84058 },
			{ x: 0.09, y: 0.84058 },
			{ x: 0.1, y: 0.84058 },
			{ x: 0.11, y: 0.84058 },
			{ x: 0.12, y: 0.84058 },
			{ x: 0.13, y: 0.84058 },
			{ x: 0.14, y: 0.84058 },
			{ x: 0.15, y: 0.84058 },
			{ x: 0.16, y: 0.84058 },
			{ x: 0.17, y: 0.84058 },
			{ x: 0.18, y: 0.84058 },
			{ x: 0.19, y: 0.84058 },
			{ x: 0.2, y: 0.84058 },
			{ x: 0.21, y: 0.84058 },
			{ x: 0.22, y: 0.84058 },
			{ x: 0.23, y: 0.84058 },
			{ x: 0.24, y: 0.84058 },
			{ x: 0.25, y: 0.84058 },
			{ x: 0.26, y: 0.84058 },
			{ x: 0.27, y: 0.84058 },
			{ x: 0.28, y: 0.84058 },
			{ x: 0.29, y: 0.84058 },
			{ x: 0.3, y: 0.84058 },
			{ x: 0.31, y: 0.84058 },
			{ x: 0.32, y: 0.84058 },
			{ x: 0.33, y: 0.84058 },
			{ x: 0.34, y: 0.84058 },
			{ x: 0.35, y: 0.84058 },
			{ x: 0.36, y: 0.84058 },
			{ x: 0.37, y: 0.84058 },
			{ x: 0.38, y: 0.84058 },
			{ x: 0.39, y: 0.84058 },
			{ x: 0.4, y: 0.84058 },
			{ x: 0.41, y: 0.84058 },
			{ x: 0.43, y: 0.84058 },
			{ x: 0.44, y: 0.84058 },
			{ x: 0.45, y: 0.84058 },
			{ x: 0.46, y: 0.84058 },
			{ x: 0.47, y: 0.84058 },
			{ x: 0.48, y: 0.84058 },
			{ x: 0.49, y: 0.84058 },
			{ x: 0.5, y: 0.84058 },
			{ x: 0.51, y: 0.84058 },
			{ x: 0.52, y: 0.84058 },
			{ x: 0.53, y: 0.84058 },
			{ x: 0.54, y: 0.84058 },
			{ x: 0.55, y: 0.84058 },
			{ x: 0.56, y: 0.84058 },
			{ x: 0.57, y: 0.84058 },
			{ x: 0.58, y: 0.84058 },
			{ x: 0.61, y: 0.84058 },
			{ x: 0.62, y: 0.84058 },
			{ x: 0.63, y: 0.84058 },
			{ x: 0.64, y: 0.84058 },
			{ x: 0.65, y: 0.84058 },
			{ x: 0.66, y: 0.84058 },
			{ x: 0.67, y: 0.84058 },
			{ x: 0.68, y: 0.84058 },
			{ x: 0.69, y: 0.84058 },
			{ x: 0.7, y: 0.84058 },
			{ x: 0.71, y: 0.84058 },
			{ x: 0.72, y: 0.84058 },
			{ x: 0.73, y: 0.84058 },
			{ x: 0.74, y: 0.84058 },
			{ x: 0.75, y: 0.84058 },
			{ x: 0.76, y: 0.84058 },
			{ x: 0.79, y: 0.84058 },
			{ x: 0.8, y: 0.84058 },
			{ x: 0.81, y: 0.84058 },
			{ x: 0.82, y: 0.84058 },
			{ x: 0.83, y: 0.84058 },
			{ x: 0.84, y: 0.84058 },
			{ x: 0.85, y: 0.84058 },
			{ x: 0.86, y: 0.84058 },
			{ x: 0.87, y: 0.84058 },
			{ x: 0.88, y: 0.84058 },
			{ x: 0.89, y: 0.84058 },
			{ x: 0.9, y: 0.84058 },
			{ x: 0.91, y: 0.84058 },
			{ x: 0.92, y: 0.84058 },
			{ x: 0.93, y: 0.84058 },
			{ x: 0.94, y: 0.84058 },
			{ x: 0.95, y: 0.84058 },
			{ x: 0.96, y: 0.84058 },
			{ x: 0.97, y: 0.84058 },
			{ x: 0.98, y: 0.84058 },
			{ x: 0.99, y: 0.84058 },
			{ x: 0, y: 0.85507 },
			{ x: 0.01, y: 0.85507 },
			{ x: 0.02, y: 0.85507 },
			{ x: 0.03, y: 0.85507 },
			{ x: 0.04, y: 0.85507 },
			{ x: 0.05, y: 0.85507 },
			{ x: 0.06, y: 0.85507 },
			{ x: 0.07, y: 0.85507 },
			{ x: 0.08, y: 0.85507 },
			{ x: 0.09, y: 0.85507 },
			{ x: 0.1, y: 0.85507 },
			{ x: 0.11, y: 0.85507 },
			{ x: 0.12, y: 0.85507 },
			{ x: 0.13, y: 0.85507 },
			{ x: 0.14, y: 0.85507 },
			{ x: 0.15, y: 0.85507 },
			{ x: 0.16, y: 0.85507 },
			{ x: 0.18, y: 0.85507 },
			{ x: 0.19, y: 0.85507 },
			{ x: 0.2, y: 0.85507 },
			{ x: 0.21, y: 0.85507 },
			{ x: 0.22, y: 0.85507 },
			{ x: 0.23, y: 0.85507 },
			{ x: 0.24, y: 0.85507 },
			{ x: 0.25, y: 0.85507 },
			{ x: 0.26, y: 0.85507 },
			{ x: 0.27, y: 0.85507 },
			{ x: 0.28, y: 0.85507 },
			{ x: 0.29, y: 0.85507 },
			{ x: 0.3, y: 0.85507 },
			{ x: 0.31, y: 0.85507 },
			{ x: 0.32, y: 0.85507 },
			{ x: 0.33, y: 0.85507 },
			{ x: 0.34, y: 0.85507 },
			{ x: 0.35, y: 0.85507 },
			{ x: 0.36, y: 0.85507 },
			{ x: 0.37, y: 0.85507 },
			{ x: 0.38, y: 0.85507 },
			{ x: 0.39, y: 0.85507 },
			{ x: 0.4, y: 0.85507 },
			{ x: 0.41, y: 0.85507 },
			{ x: 0.42, y: 0.85507 },
			{ x: 0.44, y: 0.85507 },
			{ x: 0.45, y: 0.85507 },
			{ x: 0.46, y: 0.85507 },
			{ x: 0.47, y: 0.85507 },
			{ x: 0.48, y: 0.85507 },
			{ x: 0.49, y: 0.85507 },
			{ x: 0.5, y: 0.85507 },
			{ x: 0.51, y: 0.85507 },
			{ x: 0.52, y: 0.85507 },
			{ x: 0.53, y: 0.85507 },
			{ x: 0.54, y: 0.85507 },
			{ x: 0.55, y: 0.85507 },
			{ x: 0.56, y: 0.85507 },
			{ x: 0.59, y: 0.85507 },
			{ x: 0.6, y: 0.85507 },
			{ x: 0.61, y: 0.85507 },
			{ x: 0.62, y: 0.85507 },
			{ x: 0.63, y: 0.85507 },
			{ x: 0.64, y: 0.85507 },
			{ x: 0.65, y: 0.85507 },
			{ x: 0.66, y: 0.85507 },
			{ x: 0.67, y: 0.85507 },
			{ x: 0.68, y: 0.85507 },
			{ x: 0.69, y: 0.85507 },
			{ x: 0.7, y: 0.85507 },
			{ x: 0.71, y: 0.85507 },
			{ x: 0.72, y: 0.85507 },
			{ x: 0.73, y: 0.85507 },
			{ x: 0.74, y: 0.85507 },
			{ x: 0.75, y: 0.85507 },
			{ x: 0.76, y: 0.85507 },
			{ x: 0.77, y: 0.85507 },
			{ x: 0.78, y: 0.85507 },
			{ x: 0.8, y: 0.85507 },
			{ x: 0.81, y: 0.85507 },
			{ x: 0.82, y: 0.85507 },
			{ x: 0.83, y: 0.85507 },
			{ x: 0.84, y: 0.85507 },
			{ x: 0.85, y: 0.85507 },
			{ x: 0.86, y: 0.85507 },
			{ x: 0.87, y: 0.85507 },
			{ x: 0.88, y: 0.85507 },
			{ x: 0.89, y: 0.85507 },
			{ x: 0.9, y: 0.85507 },
			{ x: 0.91, y: 0.85507 },
			{ x: 0.92, y: 0.85507 },
			{ x: 0.93, y: 0.85507 },
			{ x: 0.94, y: 0.85507 },
			{ x: 0.95, y: 0.85507 },
			{ x: 0.96, y: 0.85507 },
			{ x: 0.97, y: 0.85507 },
			{ x: 0.98, y: 0.85507 },
			{ x: 0.99, y: 0.85507 },
			{ x: 0, y: 0.86957 },
			{ x: 0.01, y: 0.86957 },
			{ x: 0.02, y: 0.86957 },
			{ x: 0.03, y: 0.86957 },
			{ x: 0.04, y: 0.86957 },
			{ x: 0.05, y: 0.86957 },
			{ x: 0.06, y: 0.86957 },
			{ x: 0.07, y: 0.86957 },
			{ x: 0.08, y: 0.86957 },
			{ x: 0.09, y: 0.86957 },
			{ x: 0.1, y: 0.86957 },
			{ x: 0.11, y: 0.86957 },
			{ x: 0.12, y: 0.86957 },
			{ x: 0.13, y: 0.86957 },
			{ x: 0.14, y: 0.86957 },
			{ x: 0.15, y: 0.86957 },
			{ x: 0.16, y: 0.86957 },
			{ x: 0.17, y: 0.86957 },
			{ x: 0.18, y: 0.86957 },
			{ x: 0.19, y: 0.86957 },
			{ x: 0.2, y: 0.86957 },
			{ x: 0.21, y: 0.86957 },
			{ x: 0.22, y: 0.86957 },
			{ x: 0.23, y: 0.86957 },
			{ x: 0.24, y: 0.86957 },
			{ x: 0.25, y: 0.86957 },
			{ x: 0.26, y: 0.86957 },
			{ x: 0.27, y: 0.86957 },
			{ x: 0.28, y: 0.86957 },
			{ x: 0.29, y: 0.86957 },
			{ x: 0.3, y: 0.86957 },
			{ x: 0.31, y: 0.86957 },
			{ x: 0.32, y: 0.86957 },
			{ x: 0.33, y: 0.86957 },
			{ x: 0.34, y: 0.86957 },
			{ x: 0.35, y: 0.86957 },
			{ x: 0.36, y: 0.86957 },
			{ x: 0.37, y: 0.86957 },
			{ x: 0.38, y: 0.86957 },
			{ x: 0.39, y: 0.86957 },
			{ x: 0.4, y: 0.86957 },
			{ x: 0.41, y: 0.86957 },
			{ x: 0.42, y: 0.86957 },
			{ x: 0.43, y: 0.86957 },
			{ x: 0.44, y: 0.86957 },
			{ x: 0.47, y: 0.86957 },
			{ x: 0.48, y: 0.86957 },
			{ x: 0.49, y: 0.86957 },
			{ x: 0.5, y: 0.86957 },
			{ x: 0.51, y: 0.86957 },
			{ x: 0.52, y: 0.86957 },
			{ x: 0.53, y: 0.86957 },
			{ x: 0.54, y: 0.86957 },
			{ x: 0.57, y: 0.86957 },
			{ x: 0.58, y: 0.86957 },
			{ x: 0.59, y: 0.86957 },
			{ x: 0.6, y: 0.86957 },
			{ x: 0.61, y: 0.86957 },
			{ x: 0.62, y: 0.86957 },
			{ x: 0.63, y: 0.86957 },
			{ x: 0.64, y: 0.86957 },
			{ x: 0.65, y: 0.86957 },
			{ x: 0.66, y: 0.86957 },
			{ x: 0.67, y: 0.86957 },
			{ x: 0.68, y: 0.86957 },
			{ x: 0.69, y: 0.86957 },
			{ x: 0.7, y: 0.86957 },
			{ x: 0.71, y: 0.86957 },
			{ x: 0.72, y: 0.86957 },
			{ x: 0.73, y: 0.86957 },
			{ x: 0.74, y: 0.86957 },
			{ x: 0.75, y: 0.86957 },
			{ x: 0.76, y: 0.86957 },
			{ x: 0.77, y: 0.86957 },
			{ x: 0.78, y: 0.86957 },
			{ x: 0.79, y: 0.86957 },
			{ x: 0.82, y: 0.86957 },
			{ x: 0.83, y: 0.86957 },
			{ x: 0.84, y: 0.86957 },
			{ x: 0.85, y: 0.86957 },
			{ x: 0.86, y: 0.86957 },
			{ x: 0.87, y: 0.86957 },
			{ x: 0.88, y: 0.86957 },
			{ x: 0.89, y: 0.86957 },
			{ x: 0.9, y: 0.86957 },
			{ x: 0.91, y: 0.86957 },
			{ x: 0.92, y: 0.86957 },
			{ x: 0.93, y: 0.86957 },
			{ x: 0.94, y: 0.86957 },
			{ x: 0.95, y: 0.86957 },
			{ x: 0.96, y: 0.86957 },
			{ x: 0.97, y: 0.86957 },
			{ x: 0.98, y: 0.86957 },
			{ x: 0.99, y: 0.86957 },
			{ x: 0, y: 0.88406 },
			{ x: 0.01, y: 0.88406 },
			{ x: 0.02, y: 0.88406 },
			{ x: 0.03, y: 0.88406 },
			{ x: 0.04, y: 0.88406 },
			{ x: 0.05, y: 0.88406 },
			{ x: 0.06, y: 0.88406 },
			{ x: 0.07, y: 0.88406 },
			{ x: 0.08, y: 0.88406 },
			{ x: 0.09, y: 0.88406 },
			{ x: 0.1, y: 0.88406 },
			{ x: 0.11, y: 0.88406 },
			{ x: 0.12, y: 0.88406 },
			{ x: 0.13, y: 0.88406 },
			{ x: 0.14, y: 0.88406 },
			{ x: 0.15, y: 0.88406 },
			{ x: 0.16, y: 0.88406 },
			{ x: 0.17, y: 0.88406 },
			{ x: 0.18, y: 0.88406 },
			{ x: 0.19, y: 0.88406 },
			{ x: 0.2, y: 0.88406 },
			{ x: 0.21, y: 0.88406 },
			{ x: 0.22, y: 0.88406 },
			{ x: 0.23, y: 0.88406 },
			{ x: 0.24, y: 0.88406 },
			{ x: 0.25, y: 0.88406 },
			{ x: 0.26, y: 0.88406 },
			{ x: 0.27, y: 0.88406 },
			{ x: 0.28, y: 0.88406 },
			{ x: 0.29, y: 0.88406 },
			{ x: 0.3, y: 0.88406 },
			{ x: 0.31, y: 0.88406 },
			{ x: 0.32, y: 0.88406 },
			{ x: 0.33, y: 0.88406 },
			{ x: 0.34, y: 0.88406 },
			{ x: 0.35, y: 0.88406 },
			{ x: 0.36, y: 0.88406 },
			{ x: 0.37, y: 0.88406 },
			{ x: 0.38, y: 0.88406 },
			{ x: 0.39, y: 0.88406 },
			{ x: 0.4, y: 0.88406 },
			{ x: 0.41, y: 0.88406 },
			{ x: 0.42, y: 0.88406 },
			{ x: 0.43, y: 0.88406 },
			{ x: 0.44, y: 0.88406 },
			{ x: 0.45, y: 0.88406 },
			{ x: 0.46, y: 0.88406 },
			{ x: 0.54, y: 0.88406 },
			{ x: 0.55, y: 0.88406 },
			{ x: 0.56, y: 0.88406 },
			{ x: 0.57, y: 0.88406 },
			{ x: 0.58, y: 0.88406 },
			{ x: 0.59, y: 0.88406 },
			{ x: 0.6, y: 0.88406 },
			{ x: 0.61, y: 0.88406 },
			{ x: 0.62, y: 0.88406 },
			{ x: 0.63, y: 0.88406 },
			{ x: 0.64, y: 0.88406 },
			{ x: 0.65, y: 0.88406 },
			{ x: 0.66, y: 0.88406 },
			{ x: 0.67, y: 0.88406 },
			{ x: 0.68, y: 0.88406 },
			{ x: 0.69, y: 0.88406 },
			{ x: 0.7, y: 0.88406 },
			{ x: 0.71, y: 0.88406 },
			{ x: 0.72, y: 0.88406 },
			{ x: 0.73, y: 0.88406 },
			{ x: 0.74, y: 0.88406 },
			{ x: 0.75, y: 0.88406 },
			{ x: 0.76, y: 0.88406 },
			{ x: 0.77, y: 0.88406 },
			{ x: 0.78, y: 0.88406 },
			{ x: 0.79, y: 0.88406 },
			{ x: 0.8, y: 0.88406 },
			{ x: 0.81, y: 0.88406 },
			{ x: 0.84, y: 0.88406 },
			{ x: 0.85, y: 0.88406 },
			{ x: 0.86, y: 0.88406 },
			{ x: 0.87, y: 0.88406 },
			{ x: 0.88, y: 0.88406 },
			{ x: 0.89, y: 0.88406 },
			{ x: 0.9, y: 0.88406 },
			{ x: 0.91, y: 0.88406 },
			{ x: 0.92, y: 0.88406 },
			{ x: 0.93, y: 0.88406 },
			{ x: 0.94, y: 0.88406 },
			{ x: 0.95, y: 0.88406 },
			{ x: 0.96, y: 0.88406 },
			{ x: 0.97, y: 0.88406 },
			{ x: 0.98, y: 0.88406 },
			{ x: 0.99, y: 0.88406 },
			{ x: 0, y: 0.89855 },
			{ x: 0.01, y: 0.89855 },
			{ x: 0.02, y: 0.89855 },
			{ x: 0.03, y: 0.89855 },
			{ x: 0.04, y: 0.89855 },
			{ x: 0.05, y: 0.89855 },
			{ x: 0.06, y: 0.89855 },
			{ x: 0.07, y: 0.89855 },
			{ x: 0.08, y: 0.89855 },
			{ x: 0.09, y: 0.89855 },
			{ x: 0.1, y: 0.89855 },
			{ x: 0.11, y: 0.89855 },
			{ x: 0.12, y: 0.89855 },
			{ x: 0.13, y: 0.89855 },
			{ x: 0.14, y: 0.89855 },
			{ x: 0.15, y: 0.89855 },
			{ x: 0.16, y: 0.89855 },
			{ x: 0.17, y: 0.89855 },
			{ x: 0.18, y: 0.89855 },
			{ x: 0.19, y: 0.89855 },
			{ x: 0.2, y: 0.89855 },
			{ x: 0.21, y: 0.89855 },
			{ x: 0.22, y: 0.89855 },
			{ x: 0.23, y: 0.89855 },
			{ x: 0.24, y: 0.89855 },
			{ x: 0.25, y: 0.89855 },
			{ x: 0.26, y: 0.89855 },
			{ x: 0.27, y: 0.89855 },
			{ x: 0.28, y: 0.89855 },
			{ x: 0.29, y: 0.89855 },
			{ x: 0.3, y: 0.89855 },
			{ x: 0.31, y: 0.89855 },
			{ x: 0.32, y: 0.89855 },
			{ x: 0.33, y: 0.89855 },
			{ x: 0.34, y: 0.89855 },
			{ x: 0.35, y: 0.89855 },
			{ x: 0.36, y: 0.89855 },
			{ x: 0.37, y: 0.89855 },
			{ x: 0.38, y: 0.89855 },
			{ x: 0.39, y: 0.89855 },
			{ x: 0.4, y: 0.89855 },
			{ x: 0.41, y: 0.89855 },
			{ x: 0.42, y: 0.89855 },
			{ x: 0.43, y: 0.89855 },
			{ x: 0.44, y: 0.89855 },
			{ x: 0.45, y: 0.89855 },
			{ x: 0.46, y: 0.89855 },
			{ x: 0.47, y: 0.89855 },
			{ x: 0.48, y: 0.89855 },
			{ x: 0.49, y: 0.89855 },
			{ x: 0.5, y: 0.89855 },
			{ x: 0.51, y: 0.89855 },
			{ x: 0.52, y: 0.89855 },
			{ x: 0.53, y: 0.89855 },
			{ x: 0.54, y: 0.89855 },
			{ x: 0.55, y: 0.89855 },
			{ x: 0.56, y: 0.89855 },
			{ x: 0.57, y: 0.89855 },
			{ x: 0.58, y: 0.89855 },
			{ x: 0.59, y: 0.89855 },
			{ x: 0.6, y: 0.89855 },
			{ x: 0.61, y: 0.89855 },
			{ x: 0.62, y: 0.89855 },
			{ x: 0.63, y: 0.89855 },
			{ x: 0.64, y: 0.89855 },
			{ x: 0.65, y: 0.89855 },
			{ x: 0.66, y: 0.89855 },
			{ x: 0.67, y: 0.89855 },
			{ x: 0.68, y: 0.89855 },
			{ x: 0.69, y: 0.89855 },
			{ x: 0.7, y: 0.89855 },
			{ x: 0.71, y: 0.89855 },
			{ x: 0.72, y: 0.89855 },
			{ x: 0.73, y: 0.89855 },
			{ x: 0.74, y: 0.89855 },
			{ x: 0.75, y: 0.89855 },
			{ x: 0.76, y: 0.89855 },
			{ x: 0.77, y: 0.89855 },
			{ x: 0.78, y: 0.89855 },
			{ x: 0.79, y: 0.89855 },
			{ x: 0.8, y: 0.89855 },
			{ x: 0.81, y: 0.89855 },
			{ x: 0.82, y: 0.89855 },
			{ x: 0.83, y: 0.89855 },
			{ x: 0.85, y: 0.89855 },
			{ x: 0.86, y: 0.89855 },
			{ x: 0.87, y: 0.89855 },
			{ x: 0.88, y: 0.89855 },
			{ x: 0.89, y: 0.89855 },
			{ x: 0.9, y: 0.89855 },
			{ x: 0.91, y: 0.89855 },
			{ x: 0.92, y: 0.89855 },
			{ x: 0.93, y: 0.89855 },
			{ x: 0.94, y: 0.89855 },
			{ x: 0.95, y: 0.89855 },
			{ x: 0.96, y: 0.89855 },
			{ x: 0.97, y: 0.89855 },
			{ x: 0.98, y: 0.89855 },
			{ x: 0.99, y: 0.89855 },
			{ x: 0, y: 0.91304 },
			{ x: 0.01, y: 0.91304 },
			{ x: 0.02, y: 0.91304 },
			{ x: 0.03, y: 0.91304 },
			{ x: 0.04, y: 0.91304 },
			{ x: 0.05, y: 0.91304 },
			{ x: 0.06, y: 0.91304 },
			{ x: 0.07, y: 0.91304 },
			{ x: 0.08, y: 0.91304 },
			{ x: 0.09, y: 0.91304 },
			{ x: 0.1, y: 0.91304 },
			{ x: 0.11, y: 0.91304 },
			{ x: 0.12, y: 0.91304 },
			{ x: 0.13, y: 0.91304 },
			{ x: 0.14, y: 0.91304 },
			{ x: 0.15, y: 0.91304 },
			{ x: 0.16, y: 0.91304 },
			{ x: 0.17, y: 0.91304 },
			{ x: 0.18, y: 0.91304 },
			{ x: 0.19, y: 0.91304 },
			{ x: 0.2, y: 0.91304 },
			{ x: 0.21, y: 0.91304 },
			{ x: 0.22, y: 0.91304 },
			{ x: 0.23, y: 0.91304 },
			{ x: 0.24, y: 0.91304 },
			{ x: 0.25, y: 0.91304 },
			{ x: 0.26, y: 0.91304 },
			{ x: 0.27, y: 0.91304 },
			{ x: 0.28, y: 0.91304 },
			{ x: 0.29, y: 0.91304 },
			{ x: 0.3, y: 0.91304 },
			{ x: 0.31, y: 0.91304 },
			{ x: 0.32, y: 0.91304 },
			{ x: 0.33, y: 0.91304 },
			{ x: 0.34, y: 0.91304 },
			{ x: 0.35, y: 0.91304 },
			{ x: 0.36, y: 0.91304 },
			{ x: 0.37, y: 0.91304 },
			{ x: 0.38, y: 0.91304 },
			{ x: 0.39, y: 0.91304 },
			{ x: 0.4, y: 0.91304 },
			{ x: 0.41, y: 0.91304 },
			{ x: 0.42, y: 0.91304 },
			{ x: 0.43, y: 0.91304 },
			{ x: 0.44, y: 0.91304 },
			{ x: 0.45, y: 0.91304 },
			{ x: 0.46, y: 0.91304 },
			{ x: 0.47, y: 0.91304 },
			{ x: 0.48, y: 0.91304 },
			{ x: 0.49, y: 0.91304 },
			{ x: 0.5, y: 0.91304 },
			{ x: 0.51, y: 0.91304 },
			{ x: 0.52, y: 0.91304 },
			{ x: 0.53, y: 0.91304 },
			{ x: 0.54, y: 0.91304 },
			{ x: 0.55, y: 0.91304 },
			{ x: 0.56, y: 0.91304 },
			{ x: 0.57, y: 0.91304 },
			{ x: 0.58, y: 0.91304 },
			{ x: 0.59, y: 0.91304 },
			{ x: 0.6, y: 0.91304 },
			{ x: 0.61, y: 0.91304 },
			{ x: 0.62, y: 0.91304 },
			{ x: 0.63, y: 0.91304 },
			{ x: 0.64, y: 0.91304 },
			{ x: 0.65, y: 0.91304 },
			{ x: 0.66, y: 0.91304 },
			{ x: 0.67, y: 0.91304 },
			{ x: 0.68, y: 0.91304 },
			{ x: 0.69, y: 0.91304 },
			{ x: 0.7, y: 0.91304 },
			{ x: 0.71, y: 0.91304 },
			{ x: 0.72, y: 0.91304 },
			{ x: 0.73, y: 0.91304 },
			{ x: 0.74, y: 0.91304 },
			{ x: 0.75, y: 0.91304 },
			{ x: 0.76, y: 0.91304 },
			{ x: 0.77, y: 0.91304 },
			{ x: 0.78, y: 0.91304 },
			{ x: 0.79, y: 0.91304 },
			{ x: 0.8, y: 0.91304 },
			{ x: 0.81, y: 0.91304 },
			{ x: 0.82, y: 0.91304 },
			{ x: 0.83, y: 0.91304 },
			{ x: 0.86, y: 0.91304 },
			{ x: 0.87, y: 0.91304 },
			{ x: 0.88, y: 0.91304 },
			{ x: 0.89, y: 0.91304 },
			{ x: 0.9, y: 0.91304 },
			{ x: 0.91, y: 0.91304 },
			{ x: 0.92, y: 0.91304 },
			{ x: 0.93, y: 0.91304 },
			{ x: 0.94, y: 0.91304 },
			{ x: 0.95, y: 0.91304 },
			{ x: 0.96, y: 0.91304 },
			{ x: 0.97, y: 0.91304 },
			{ x: 0.98, y: 0.91304 },
			{ x: 0.99, y: 0.91304 },
			{ x: 0, y: 0.92754 },
			{ x: 0.01, y: 0.92754 },
			{ x: 0.02, y: 0.92754 },
			{ x: 0.03, y: 0.92754 },
			{ x: 0.04, y: 0.92754 },
			{ x: 0.05, y: 0.92754 },
			{ x: 0.06, y: 0.92754 },
			{ x: 0.07, y: 0.92754 },
			{ x: 0.08, y: 0.92754 },
			{ x: 0.09, y: 0.92754 },
			{ x: 0.1, y: 0.92754 },
			{ x: 0.11, y: 0.92754 },
			{ x: 0.12, y: 0.92754 },
			{ x: 0.13, y: 0.92754 },
			{ x: 0.14, y: 0.92754 },
			{ x: 0.15, y: 0.92754 },
			{ x: 0.16, y: 0.92754 },
			{ x: 0.17, y: 0.92754 },
			{ x: 0.18, y: 0.92754 },
			{ x: 0.19, y: 0.92754 },
			{ x: 0.2, y: 0.92754 },
			{ x: 0.21, y: 0.92754 },
			{ x: 0.22, y: 0.92754 },
			{ x: 0.23, y: 0.92754 },
			{ x: 0.24, y: 0.92754 },
			{ x: 0.25, y: 0.92754 },
			{ x: 0.26, y: 0.92754 },
			{ x: 0.27, y: 0.92754 },
			{ x: 0.28, y: 0.92754 },
			{ x: 0.29, y: 0.92754 },
			{ x: 0.3, y: 0.92754 },
			{ x: 0.31, y: 0.92754 },
			{ x: 0.32, y: 0.92754 },
			{ x: 0.33, y: 0.92754 },
			{ x: 0.34, y: 0.92754 },
			{ x: 0.35, y: 0.92754 },
			{ x: 0.36, y: 0.92754 },
			{ x: 0.37, y: 0.92754 },
			{ x: 0.38, y: 0.92754 },
			{ x: 0.39, y: 0.92754 },
			{ x: 0.4, y: 0.92754 },
			{ x: 0.41, y: 0.92754 },
			{ x: 0.42, y: 0.92754 },
			{ x: 0.43, y: 0.92754 },
			{ x: 0.44, y: 0.92754 },
			{ x: 0.45, y: 0.92754 },
			{ x: 0.46, y: 0.92754 },
			{ x: 0.47, y: 0.92754 },
			{ x: 0.48, y: 0.92754 },
			{ x: 0.49, y: 0.92754 },
			{ x: 0.5, y: 0.92754 },
			{ x: 0.51, y: 0.92754 },
			{ x: 0.52, y: 0.92754 },
			{ x: 0.53, y: 0.92754 },
			{ x: 0.54, y: 0.92754 },
			{ x: 0.55, y: 0.92754 },
			{ x: 0.56, y: 0.92754 },
			{ x: 0.57, y: 0.92754 },
			{ x: 0.58, y: 0.92754 },
			{ x: 0.59, y: 0.92754 },
			{ x: 0.6, y: 0.92754 },
			{ x: 0.61, y: 0.92754 },
			{ x: 0.62, y: 0.92754 },
			{ x: 0.63, y: 0.92754 },
			{ x: 0.64, y: 0.92754 },
			{ x: 0.65, y: 0.92754 },
			{ x: 0.66, y: 0.92754 },
			{ x: 0.67, y: 0.92754 },
			{ x: 0.68, y: 0.92754 },
			{ x: 0.69, y: 0.92754 },
			{ x: 0.7, y: 0.92754 },
			{ x: 0.71, y: 0.92754 },
			{ x: 0.72, y: 0.92754 },
			{ x: 0.73, y: 0.92754 },
			{ x: 0.74, y: 0.92754 },
			{ x: 0.75, y: 0.92754 },
			{ x: 0.76, y: 0.92754 },
			{ x: 0.77, y: 0.92754 },
			{ x: 0.78, y: 0.92754 },
			{ x: 0.79, y: 0.92754 },
			{ x: 0.8, y: 0.92754 },
			{ x: 0.81, y: 0.92754 },
			{ x: 0.82, y: 0.92754 },
			{ x: 0.83, y: 0.92754 },
			{ x: 0.84, y: 0.92754 },
			{ x: 0.86, y: 0.92754 },
			{ x: 0.87, y: 0.92754 },
			{ x: 0.88, y: 0.92754 },
			{ x: 0.89, y: 0.92754 },
			{ x: 0.9, y: 0.92754 },
			{ x: 0.91, y: 0.92754 },
			{ x: 0.92, y: 0.92754 },
			{ x: 0.93, y: 0.92754 },
			{ x: 0.94, y: 0.92754 },
			{ x: 0.95, y: 0.92754 },
			{ x: 0.96, y: 0.92754 },
			{ x: 0.97, y: 0.92754 },
			{ x: 0.98, y: 0.92754 },
			{ x: 0.99, y: 0.92754 },
			{ x: 0, y: 0.94203 },
			{ x: 0.01, y: 0.94203 },
			{ x: 0.02, y: 0.94203 },
			{ x: 0.03, y: 0.94203 },
			{ x: 0.04, y: 0.94203 },
			{ x: 0.05, y: 0.94203 },
			{ x: 0.06, y: 0.94203 },
			{ x: 0.07, y: 0.94203 },
			{ x: 0.08, y: 0.94203 },
			{ x: 0.09, y: 0.94203 },
			{ x: 0.1, y: 0.94203 },
			{ x: 0.11, y: 0.94203 },
			{ x: 0.12, y: 0.94203 },
			{ x: 0.13, y: 0.94203 },
			{ x: 0.14, y: 0.94203 },
			{ x: 0.15, y: 0.94203 },
			{ x: 0.16, y: 0.94203 },
			{ x: 0.17, y: 0.94203 },
			{ x: 0.18, y: 0.94203 },
			{ x: 0.19, y: 0.94203 },
			{ x: 0.2, y: 0.94203 },
			{ x: 0.21, y: 0.94203 },
			{ x: 0.22, y: 0.94203 },
			{ x: 0.23, y: 0.94203 },
			{ x: 0.24, y: 0.94203 },
			{ x: 0.25, y: 0.94203 },
			{ x: 0.26, y: 0.94203 },
			{ x: 0.27, y: 0.94203 },
			{ x: 0.28, y: 0.94203 },
			{ x: 0.29, y: 0.94203 },
			{ x: 0.3, y: 0.94203 },
			{ x: 0.31, y: 0.94203 },
			{ x: 0.32, y: 0.94203 },
			{ x: 0.33, y: 0.94203 },
			{ x: 0.34, y: 0.94203 },
			{ x: 0.35, y: 0.94203 },
			{ x: 0.36, y: 0.94203 },
			{ x: 0.37, y: 0.94203 },
			{ x: 0.38, y: 0.94203 },
			{ x: 0.39, y: 0.94203 },
			{ x: 0.4, y: 0.94203 },
			{ x: 0.41, y: 0.94203 },
			{ x: 0.42, y: 0.94203 },
			{ x: 0.43, y: 0.94203 },
			{ x: 0.44, y: 0.94203 },
			{ x: 0.45, y: 0.94203 },
			{ x: 0.46, y: 0.94203 },
			{ x: 0.47, y: 0.94203 },
			{ x: 0.48, y: 0.94203 },
			{ x: 0.49, y: 0.94203 },
			{ x: 0.5, y: 0.94203 },
			{ x: 0.51, y: 0.94203 },
			{ x: 0.52, y: 0.94203 },
			{ x: 0.53, y: 0.94203 },
			{ x: 0.54, y: 0.94203 },
			{ x: 0.55, y: 0.94203 },
			{ x: 0.56, y: 0.94203 },
			{ x: 0.57, y: 0.94203 },
			{ x: 0.58, y: 0.94203 },
			{ x: 0.59, y: 0.94203 },
			{ x: 0.6, y: 0.94203 },
			{ x: 0.61, y: 0.94203 },
			{ x: 0.62, y: 0.94203 },
			{ x: 0.63, y: 0.94203 },
			{ x: 0.64, y: 0.94203 },
			{ x: 0.65, y: 0.94203 },
			{ x: 0.66, y: 0.94203 },
			{ x: 0.67, y: 0.94203 },
			{ x: 0.68, y: 0.94203 },
			{ x: 0.69, y: 0.94203 },
			{ x: 0.7, y: 0.94203 },
			{ x: 0.71, y: 0.94203 },
			{ x: 0.72, y: 0.94203 },
			{ x: 0.73, y: 0.94203 },
			{ x: 0.74, y: 0.94203 },
			{ x: 0.75, y: 0.94203 },
			{ x: 0.76, y: 0.94203 },
			{ x: 0.77, y: 0.94203 },
			{ x: 0.78, y: 0.94203 },
			{ x: 0.79, y: 0.94203 },
			{ x: 0.8, y: 0.94203 },
			{ x: 0.81, y: 0.94203 },
			{ x: 0.82, y: 0.94203 },
			{ x: 0.83, y: 0.94203 },
			{ x: 0.84, y: 0.94203 },
			{ x: 0.85, y: 0.94203 },
			{ x: 0.87, y: 0.94203 },
			{ x: 0.88, y: 0.94203 },
			{ x: 0.89, y: 0.94203 },
			{ x: 0.9, y: 0.94203 },
			{ x: 0.91, y: 0.94203 },
			{ x: 0.92, y: 0.94203 },
			{ x: 0.93, y: 0.94203 },
			{ x: 0.94, y: 0.94203 },
			{ x: 0.95, y: 0.94203 },
			{ x: 0.96, y: 0.94203 },
			{ x: 0.97, y: 0.94203 },
			{ x: 0.98, y: 0.94203 },
			{ x: 0.99, y: 0.94203 },
			{ x: 0, y: 0.95652 },
			{ x: 0.01, y: 0.95652 },
			{ x: 0.02, y: 0.95652 },
			{ x: 0.03, y: 0.95652 },
			{ x: 0.04, y: 0.95652 },
			{ x: 0.05, y: 0.95652 },
			{ x: 0.06, y: 0.95652 },
			{ x: 0.07, y: 0.95652 },
			{ x: 0.08, y: 0.95652 },
			{ x: 0.09, y: 0.95652 },
			{ x: 0.1, y: 0.95652 },
			{ x: 0.11, y: 0.95652 },
			{ x: 0.12, y: 0.95652 },
			{ x: 0.13, y: 0.95652 },
			{ x: 0.14, y: 0.95652 },
			{ x: 0.15, y: 0.95652 },
			{ x: 0.16, y: 0.95652 },
			{ x: 0.17, y: 0.95652 },
			{ x: 0.18, y: 0.95652 },
			{ x: 0.19, y: 0.95652 },
			{ x: 0.2, y: 0.95652 },
			{ x: 0.21, y: 0.95652 },
			{ x: 0.22, y: 0.95652 },
			{ x: 0.23, y: 0.95652 },
			{ x: 0.24, y: 0.95652 },
			{ x: 0.25, y: 0.95652 },
			{ x: 0.26, y: 0.95652 },
			{ x: 0.27, y: 0.95652 },
			{ x: 0.28, y: 0.95652 },
			{ x: 0.29, y: 0.95652 },
			{ x: 0.3, y: 0.95652 },
			{ x: 0.31, y: 0.95652 },
			{ x: 0.32, y: 0.95652 },
			{ x: 0.33, y: 0.95652 },
			{ x: 0.34, y: 0.95652 },
			{ x: 0.35, y: 0.95652 },
			{ x: 0.36, y: 0.95652 },
			{ x: 0.37, y: 0.95652 },
			{ x: 0.38, y: 0.95652 },
			{ x: 0.39, y: 0.95652 },
			{ x: 0.4, y: 0.95652 },
			{ x: 0.41, y: 0.95652 },
			{ x: 0.42, y: 0.95652 },
			{ x: 0.43, y: 0.95652 },
			{ x: 0.44, y: 0.95652 },
			{ x: 0.45, y: 0.95652 },
			{ x: 0.46, y: 0.95652 },
			{ x: 0.47, y: 0.95652 },
			{ x: 0.48, y: 0.95652 },
			{ x: 0.49, y: 0.95652 },
			{ x: 0.5, y: 0.95652 },
			{ x: 0.51, y: 0.95652 },
			{ x: 0.52, y: 0.95652 },
			{ x: 0.53, y: 0.95652 },
			{ x: 0.54, y: 0.95652 },
			{ x: 0.55, y: 0.95652 },
			{ x: 0.56, y: 0.95652 },
			{ x: 0.57, y: 0.95652 },
			{ x: 0.58, y: 0.95652 },
			{ x: 0.59, y: 0.95652 },
			{ x: 0.6, y: 0.95652 },
			{ x: 0.61, y: 0.95652 },
			{ x: 0.62, y: 0.95652 },
			{ x: 0.63, y: 0.95652 },
			{ x: 0.64, y: 0.95652 },
			{ x: 0.65, y: 0.95652 },
			{ x: 0.66, y: 0.95652 },
			{ x: 0.67, y: 0.95652 },
			{ x: 0.68, y: 0.95652 },
			{ x: 0.69, y: 0.95652 },
			{ x: 0.7, y: 0.95652 },
			{ x: 0.71, y: 0.95652 },
			{ x: 0.72, y: 0.95652 },
			{ x: 0.73, y: 0.95652 },
			{ x: 0.74, y: 0.95652 },
			{ x: 0.75, y: 0.95652 },
			{ x: 0.76, y: 0.95652 },
			{ x: 0.77, y: 0.95652 },
			{ x: 0.78, y: 0.95652 },
			{ x: 0.8, y: 0.95652 },
			{ x: 0.81, y: 0.95652 },
			{ x: 0.82, y: 0.95652 },
			{ x: 0.83, y: 0.95652 },
			{ x: 0.85, y: 0.95652 },
			{ x: 0.87, y: 0.95652 },
			{ x: 0.88, y: 0.95652 },
			{ x: 0.89, y: 0.95652 },
			{ x: 0.9, y: 0.95652 },
			{ x: 0.91, y: 0.95652 },
			{ x: 0.92, y: 0.95652 },
			{ x: 0.93, y: 0.95652 },
			{ x: 0.94, y: 0.95652 },
			{ x: 0.95, y: 0.95652 },
			{ x: 0.96, y: 0.95652 },
			{ x: 0.97, y: 0.95652 },
			{ x: 0.98, y: 0.95652 },
			{ x: 0.99, y: 0.95652 },
			{ x: 0, y: 0.97101 },
			{ x: 0.01, y: 0.97101 },
			{ x: 0.02, y: 0.97101 },
			{ x: 0.03, y: 0.97101 },
			{ x: 0.04, y: 0.97101 },
			{ x: 0.05, y: 0.97101 },
			{ x: 0.06, y: 0.97101 },
			{ x: 0.07, y: 0.97101 },
			{ x: 0.08, y: 0.97101 },
			{ x: 0.09, y: 0.97101 },
			{ x: 0.1, y: 0.97101 },
			{ x: 0.11, y: 0.97101 },
			{ x: 0.12, y: 0.97101 },
			{ x: 0.13, y: 0.97101 },
			{ x: 0.14, y: 0.97101 },
			{ x: 0.15, y: 0.97101 },
			{ x: 0.16, y: 0.97101 },
			{ x: 0.17, y: 0.97101 },
			{ x: 0.18, y: 0.97101 },
			{ x: 0.19, y: 0.97101 },
			{ x: 0.2, y: 0.97101 },
			{ x: 0.21, y: 0.97101 },
			{ x: 0.22, y: 0.97101 },
			{ x: 0.23, y: 0.97101 },
			{ x: 0.24, y: 0.97101 },
			{ x: 0.25, y: 0.97101 },
			{ x: 0.26, y: 0.97101 },
			{ x: 0.27, y: 0.97101 },
			{ x: 0.28, y: 0.97101 },
			{ x: 0.29, y: 0.97101 },
			{ x: 0.3, y: 0.97101 },
			{ x: 0.31, y: 0.97101 },
			{ x: 0.32, y: 0.97101 },
			{ x: 0.33, y: 0.97101 },
			{ x: 0.34, y: 0.97101 },
			{ x: 0.35, y: 0.97101 },
			{ x: 0.36, y: 0.97101 },
			{ x: 0.37, y: 0.97101 },
			{ x: 0.38, y: 0.97101 },
			{ x: 0.39, y: 0.97101 },
			{ x: 0.4, y: 0.97101 },
			{ x: 0.41, y: 0.97101 },
			{ x: 0.42, y: 0.97101 },
			{ x: 0.43, y: 0.97101 },
			{ x: 0.44, y: 0.97101 },
			{ x: 0.45, y: 0.97101 },
			{ x: 0.46, y: 0.97101 },
			{ x: 0.47, y: 0.97101 },
			{ x: 0.48, y: 0.97101 },
			{ x: 0.49, y: 0.97101 },
			{ x: 0.5, y: 0.97101 },
			{ x: 0.51, y: 0.97101 },
			{ x: 0.52, y: 0.97101 },
			{ x: 0.53, y: 0.97101 },
			{ x: 0.54, y: 0.97101 },
			{ x: 0.55, y: 0.97101 },
			{ x: 0.56, y: 0.97101 },
			{ x: 0.57, y: 0.97101 },
			{ x: 0.58, y: 0.97101 },
			{ x: 0.59, y: 0.97101 },
			{ x: 0.6, y: 0.97101 },
			{ x: 0.61, y: 0.97101 },
			{ x: 0.62, y: 0.97101 },
			{ x: 0.63, y: 0.97101 },
			{ x: 0.64, y: 0.97101 },
			{ x: 0.65, y: 0.97101 },
			{ x: 0.66, y: 0.97101 },
			{ x: 0.67, y: 0.97101 },
			{ x: 0.68, y: 0.97101 },
			{ x: 0.69, y: 0.97101 },
			{ x: 0.7, y: 0.97101 },
			{ x: 0.71, y: 0.97101 },
			{ x: 0.72, y: 0.97101 },
			{ x: 0.73, y: 0.97101 },
			{ x: 0.74, y: 0.97101 },
			{ x: 0.75, y: 0.97101 },
			{ x: 0.76, y: 0.97101 },
			{ x: 0.77, y: 0.97101 },
			{ x: 0.78, y: 0.97101 },
			{ x: 0.8, y: 0.97101 },
			{ x: 0.81, y: 0.97101 },
			{ x: 0.82, y: 0.97101 },
			{ x: 0.85, y: 0.97101 },
			{ x: 0.86, y: 0.97101 },
			{ x: 0.88, y: 0.97101 },
			{ x: 0.89, y: 0.97101 },
			{ x: 0.9, y: 0.97101 },
			{ x: 0.91, y: 0.97101 },
			{ x: 0.92, y: 0.97101 },
			{ x: 0.93, y: 0.97101 },
			{ x: 0.94, y: 0.97101 },
			{ x: 0.95, y: 0.97101 },
			{ x: 0.96, y: 0.97101 },
			{ x: 0.97, y: 0.97101 },
			{ x: 0.98, y: 0.97101 },
			{ x: 0.99, y: 0.97101 },
			{ x: 0, y: 0.98551 },
			{ x: 0.01, y: 0.98551 },
			{ x: 0.02, y: 0.98551 },
			{ x: 0.03, y: 0.98551 },
			{ x: 0.04, y: 0.98551 },
			{ x: 0.05, y: 0.98551 },
			{ x: 0.06, y: 0.98551 },
			{ x: 0.07, y: 0.98551 },
			{ x: 0.08, y: 0.98551 },
			{ x: 0.09, y: 0.98551 },
			{ x: 0.1, y: 0.98551 },
			{ x: 0.11, y: 0.98551 },
			{ x: 0.12, y: 0.98551 },
			{ x: 0.13, y: 0.98551 },
			{ x: 0.14, y: 0.98551 },
			{ x: 0.15, y: 0.98551 },
			{ x: 0.16, y: 0.98551 },
			{ x: 0.17, y: 0.98551 },
			{ x: 0.18, y: 0.98551 },
			{ x: 0.19, y: 0.98551 },
			{ x: 0.2, y: 0.98551 },
			{ x: 0.21, y: 0.98551 },
			{ x: 0.22, y: 0.98551 },
			{ x: 0.23, y: 0.98551 },
			{ x: 0.24, y: 0.98551 },
			{ x: 0.25, y: 0.98551 },
			{ x: 0.26, y: 0.98551 },
			{ x: 0.27, y: 0.98551 },
			{ x: 0.28, y: 0.98551 },
			{ x: 0.29, y: 0.98551 },
			{ x: 0.3, y: 0.98551 },
			{ x: 0.31, y: 0.98551 },
			{ x: 0.32, y: 0.98551 },
			{ x: 0.33, y: 0.98551 },
			{ x: 0.34, y: 0.98551 },
			{ x: 0.35, y: 0.98551 },
			{ x: 0.36, y: 0.98551 },
			{ x: 0.37, y: 0.98551 },
			{ x: 0.38, y: 0.98551 },
			{ x: 0.39, y: 0.98551 },
			{ x: 0.4, y: 0.98551 },
			{ x: 0.41, y: 0.98551 },
			{ x: 0.42, y: 0.98551 },
			{ x: 0.43, y: 0.98551 },
			{ x: 0.44, y: 0.98551 },
			{ x: 0.45, y: 0.98551 },
			{ x: 0.46, y: 0.98551 },
			{ x: 0.47, y: 0.98551 },
			{ x: 0.48, y: 0.98551 },
			{ x: 0.49, y: 0.98551 },
			{ x: 0.5, y: 0.98551 },
			{ x: 0.51, y: 0.98551 },
			{ x: 0.52, y: 0.98551 },
			{ x: 0.53, y: 0.98551 },
			{ x: 0.54, y: 0.98551 },
			{ x: 0.55, y: 0.98551 },
			{ x: 0.56, y: 0.98551 },
			{ x: 0.57, y: 0.98551 },
			{ x: 0.58, y: 0.98551 },
			{ x: 0.59, y: 0.98551 },
			{ x: 0.6, y: 0.98551 },
			{ x: 0.61, y: 0.98551 },
			{ x: 0.62, y: 0.98551 },
			{ x: 0.63, y: 0.98551 },
			{ x: 0.64, y: 0.98551 },
			{ x: 0.65, y: 0.98551 },
			{ x: 0.66, y: 0.98551 },
			{ x: 0.67, y: 0.98551 },
			{ x: 0.68, y: 0.98551 },
			{ x: 0.69, y: 0.98551 },
			{ x: 0.7, y: 0.98551 },
			{ x: 0.71, y: 0.98551 },
			{ x: 0.72, y: 0.98551 },
			{ x: 0.73, y: 0.98551 },
			{ x: 0.74, y: 0.98551 },
			{ x: 0.75, y: 0.98551 },
			{ x: 0.76, y: 0.98551 },
			{ x: 0.77, y: 0.98551 },
			{ x: 0.78, y: 0.98551 },
			{ x: 0.79, y: 0.98551 },
			{ x: 0.8, y: 0.98551 },
			{ x: 0.81, y: 0.98551 },
			{ x: 0.82, y: 0.98551 },
			{ x: 0.83, y: 0.98551 },
			{ x: 0.84, y: 0.98551 },
			{ x: 0.85, y: 0.98551 },
			{ x: 0.86, y: 0.98551 },
			{ x: 0.87, y: 0.98551 },
			{ x: 0.88, y: 0.98551 },
			{ x: 0.89, y: 0.98551 },
			{ x: 0.9, y: 0.98551 },
			{ x: 0.91, y: 0.98551 },
			{ x: 0.92, y: 0.98551 },
			{ x: 0.93, y: 0.98551 },
			{ x: 0.94, y: 0.98551 },
			{ x: 0.95, y: 0.98551 },
			{ x: 0.96, y: 0.98551 },
			{ x: 0.97, y: 0.98551 },
			{ x: 0.98, y: 0.98551 },
			{ x: 0.99, y: 0.98551 }
		]
	}
};
